webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var DisplayIf = function DisplayIf(_ref) {
  var className = _ref.className,
      style = _ref.style,
      condition = _ref.condition,
      children = _ref.children;
  return condition ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: className,
      style: style },
    children
  ) : null;
};

DisplayIf.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  style: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  condition: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node
};

DisplayIf.defaultProps = {
  className: '',
  style: {},
  condition: false,
  children: null
};

/* harmony default export */ __webpack_exports__["a"] = DisplayIf;

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_ga__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_ga__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__variables__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_spinner__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_auth_actions_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__error_actionTypes__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__error_errorManager__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_variables__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_topBanner_actionTypes__ = __webpack_require__(86);
/* unused harmony export capitalizeEachLetter */
/* unused harmony export setDocumentTitle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return navigateTo; });
/* unused harmony export replaceTo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleRouterUpdate; });
/* unused harmony export sendAsync */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return putJsonAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return postJsonAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getJsonNonCacheAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getJsonAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return deleteJsonAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return beginProcessAsync; });
/* unused harmony export endProcessAsync */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handlePrint; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var capitalizeEachLetter = function capitalizeEachLetter(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

var setDocumentTitle = function setDocumentTitle() {
  return function () {
    var title = window.location.pathname.toLowerCase().split(/\//).filter(function (x) {
      return !!x && !x.match(/^[{]?[0-9a-fA-F]{8}[-]?([0-9a-fA-F]{4}[-]?){3}[0-9a-fA-F]{12}[}]?$/);
    }).join(' ');

    title = title && capitalizeEachLetter(title);
    document.title = title || 'USBC';
  };
};

var navigateTo = function navigateTo() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__["push"])('/' + (__WEBPACK_IMPORTED_MODULE_8_shared_variables__["c" /* BASE_PATH */] ? __WEBPACK_IMPORTED_MODULE_8_shared_variables__["c" /* BASE_PATH */] + '/' : '') + path));
  };
};
var replaceTo = function replaceTo() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__["replace"])('/' + (__WEBPACK_IMPORTED_MODULE_8_shared_variables__["c" /* BASE_PATH */] ? __WEBPACK_IMPORTED_MODULE_8_shared_variables__["c" /* BASE_PATH */] + '/' : '') + path));
  };
};

var handleRouterUpdate = function handleRouterUpdate() {
  return function (dispatch, getState) {
    if (!window.location.pathname.toLowerCase().includes('/maintenance')) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_auth_actions_js__["a" /* retrieveMaintenanceMessage */])()).then(function () {
        if (getState().shared.auth.maintenanceMessage) {
          dispatch(navigateTo('maintenance'));
          return;
        }
      });
    }

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_topBanner_actionTypes__["a" /* setTopBannerImagePath */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__error_actionTypes__["a" /* setErrorList */])([]));
    dispatch(setDocumentTitle());

    // trigger GA page views
    __WEBPACK_IMPORTED_MODULE_0_react_ga___default.a.pageview(window.location.pathname);

    // trigger HubSpot page view
    triggerHubSpotPageView(window.location.pathname);
  };
};

var triggerHubSpotPageView = function triggerHubSpotPageView(path) {
  var _hsq = window._hsq = window._hsq || [];

  _hsq.push(['setPath', path]);
  _hsq.push(['trackPageView']);
};

var handleResponse = function handleResponse(response) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__error_actionTypes__["a" /* setErrorList */])([]));
    dispatch(endProcessAsync());

    if (!response.ok) {

      if (response.status == 401) {
        // REG-2538: JSON Error and Permission Denied
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_auth_actions_js__["b" /* login */])();
        return;
      }

      var responseParsed = null;

      return response.text().then(function (text) {
        // verify if 'text' is a valid JSON response to be parsed
        try {
          responseParsed = JSON.parse(text);
        } catch (e) {
          // use 'text' as message but first try to get detail from HTML title if text is html
          if (text.search('<title>') != -1) {
            text = text.substring(text.search('<title>') + 7, text.search('</title>'));
          }
          throw Error(text);
        }

        if (typeof responseParsed === 'string') {
          // use 'responseParsed' in parsed 'text'
          throw Error(responseParsed);
        } else if (responseParsed && responseParsed.message) {
          // use 'message' in parsed 'text'
          throw Error(responseParsed.message);
        } else if (responseParsed && responseParsed.length) {
          // Server-side valdation can return an array of error messages, so just throw that array
          throw responseParsed;
        } else {
          throw Error('An unknown error occurred.');
        }
      });
    }
    return response;
  };
};

var sendAsync = function sendAsync(url, data) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'POST';
  var defaultError = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      setTimeout(function () {
        return dispatch(beginProcessAsync());
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_auth_actions_js__["c" /* authorizationHeader */])().then(function (header) {
        fetch(__WEBPACK_IMPORTED_MODULE_2__variables__["d" /* API_URL */] + '/' + url, {
          method: method,
          headers: _extends({
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }, header),
          body: JSON.stringify(data)
        }).then(function (response) {
          return dispatch(handleResponse(response));
        }).then(function (response) {
          return response.text().then(function (text) {
            resolve(text ? JSON.parse(text) : {});
          });
        }).catch(function (error) {

          if (defaultError) {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__error_errorManager__["a" /* defaultErrorAction */])(error));
          }

          reject(error);
        });
      });
    });
  };
};

var putJsonAsync = function putJsonAsync(url, data) {
  var defaultError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return sendAsync(url, data, 'PUT', defaultError);
};

var postJsonAsync = function postJsonAsync(url, data) {
  var defaultError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return sendAsync(url, data, 'POST', defaultError);
};

var getJsonNonCacheAsync = function getJsonNonCacheAsync(url) {
  var defaultError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  return getJsonAsyncCore(url, 0, defaultError);
};

var getJsonAsync = function getJsonAsync(url) {
  var defaultError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  return getJsonAsyncCore(url, 1, defaultError);
};

var getJsonAsyncCore = function getJsonAsyncCore(url, useCache) {
  var defaultError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      setTimeout(function () {
        return dispatch(beginProcessAsync());
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_auth_actions_js__["c" /* authorizationHeader */])().then(function (header) {
        var headers = header;

        if (!useCache) {
          headers.pragma = 'no-cache';
          headers['cache-control'] = 'no-cache';
        }

        fetch(__WEBPACK_IMPORTED_MODULE_2__variables__["d" /* API_URL */] + '/' + url, { headers: headers }).then(function (response) {
          return dispatch(handleResponse(response));
        }).then(function (response) {
          // REG-2538: JSON Error and Permission Denied
          if (response) {
            resolve(response.json());
          } else {
            resolve();
          }
        }).catch(function (error) {

          if (defaultError) {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__error_errorManager__["a" /* defaultErrorAction */])(error));
          }

          reject(error);
        });
      });
    });
  };
};

var deleteJsonAsync = function deleteJsonAsync(url, data) {
  var defaultError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return sendAsync(url, data, 'DELETE', defaultError);
};

var beginProcessAsync = function beginProcessAsync() {
  return _defineProperty({
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* PROCESSING_ASYNC_DATA */]
  }, __WEBPACK_IMPORTED_MODULE_4_react_redux_spinner__["pendingTask"], __WEBPACK_IMPORTED_MODULE_4_react_redux_spinner__["begin"]);
};

var endProcessAsync = function endProcessAsync() {
  return _defineProperty({
    type: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* PROCESSING_ASYNC_DATA */]
  }, __WEBPACK_IMPORTED_MODULE_4_react_redux_spinner__["pendingTask"], __WEBPACK_IMPORTED_MODULE_4_react_redux_spinner__["end"]);
};

var handlePrint = function handlePrint(content) {
  var printFrame = document.getElementById("ifmContentsToPrint").contentWindow;

  // write the content to print
  printFrame.document.open();
  printFrame.document.write(content.innerHtml);
  printFrame.document.close();

  // this works for IE 11, Chrome and FF
  var printed = printFrame.document.execCommand('print', false, null);

  if (!printed) {
    // this doesn't work in IE but *should* work on browsers that don't support the execCommand() command above
    printFrame.focus();
    printFrame.print();
  }
};

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldValidationError_jsx__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_DatePicker_DatePicker_jsx__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(109);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var StandardField = function StandardField(_ref) {
  var autoFocus = _ref.autoFocus,
      disabled = _ref.disabled,
      input = _ref.input,
      label = _ref.label,
      type = _ref.type,
      placeholder = _ref.placeholder,
      step = _ref.step,
      min = _ref.min,
      max = _ref.max,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      name = _ref.name,
      style = _ref.style,
      required = _ref.required,
      todayHighlight = _ref.todayHighlight,
      tooltip = _ref.tooltip,
      tooltipPosition = _ref.tooltipPosition,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      onCustomChange = _ref.onCustomChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()({ 'form-group': placeholder || label }, { 'has-error': touched && error }) },
    label || placeholder ? tooltip ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["OverlayTrigger"],
      {
        trigger: ["click", "hover"],
        rootClose: true,
        placement: tooltipPosition,
        overlay: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Popover"],
          { id: 'popover-positioned-' + tooltipPosition },
          tooltip
        ) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'label',
        { htmlFor: name },
        label || placeholder,
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-question-circle-o' })
      )
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'label',
      { htmlFor: name },
      label || placeholder
    ) : null,
    type === 'date' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_DatePicker_DatePicker_jsx__["a" /* default */], _extends({}, input, {
      minDate: minDate,
      maxDate: maxDate,
      autoFocus: autoFocus,
      disabled: disabled,
      placeholder: placeholder,
      style: style,
      required: required,
      todayHighlight: todayHighlight,
      name: name,
      onChange: function onChange(event) {
        // redux-form overrides change event if provided to Field
        // use custom handler for other specific handling
        onCustomChange(event);
        if (input && typeof input.onChange === "function") {
          input.onChange(event);
        }
      }
    })) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, input, {
      autoFocus: autoFocus,
      className: 'form-control',
      disabled: disabled,
      min: min,
      max: max,
      placeholder: placeholder,
      step: step,
      style: style,
      type: type,
      required: required,
      onChange: function onChange(event) {
        // redux-form overrides change event if provided to Field
        // use custom handler for other specific handling
        onCustomChange(event);
        if (input) input.onChange(event);
      }
    })),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FieldValidationError_jsx__["a" /* default */], {
      touched: touched,
      error: error
    })
  );
};

StandardField.propTypes = {
  autoFocus: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  input: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  disabled: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  label: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,
  meta: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  name: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  placeholder: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  type: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  step: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  min: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  max: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  minDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  maxDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  style: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  required: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  todayHighlight: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  tooltip: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  tooltipPosition: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onCustomChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

StandardField.defaultProps = {
  type: 'text',
  onCustomChange: function onCustomChange() {},
  tooltipPosition: 'top'
};

/* harmony default export */ __webpack_exports__["a"] = StandardField;

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ErrorList_jsx__ = __webpack_require__(991);



var mapStateToProps = function mapStateToProps(state) {
  return state.shared.error;
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__ErrorList_jsx__["a" /* default */]);

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);



var StandardModal = function StandardModal(_ref) {
  var bodyOverflow = _ref.bodyOverflow,
      visible = _ref.visible,
      title = _ref.title,
      wideModal = _ref.wideModal,
      children = _ref.children,
      onCloseClick = _ref.onCloseClick,
      disableClose = _ref.disableClose;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("modal", { "display block animated fadeIn": visible }),
      style: { overflow: 'auto', paddingRight: "0px" }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("modal-dialog", { "wide-modal": wideModal }) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'modal-content' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'modal-header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'close',
              'aria-hidden': 'true',
              onClick: onCloseClick,
              disabled: disableClose == true
            },
            '\xD7'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'modal-title' },
            title
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("modal-body", { "overflow-y": bodyOverflow }) },
          children
        )
      )
    )
  );
};

StandardModal.propTypes = {
  bodyOverflow: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  wideModal: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  children: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,
  onCloseClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  disableClose: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool
};

StandardModal.defaultProps = {
  wideModal: false
};

/* harmony default export */ __webpack_exports__["a"] = StandardModal;

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatCurrency; });
/* Solution adapted from http://stackoverflow.com/questions/149055/how-can-i-format-numbers-as-money-in-javascript */

/* Parameters:
  decimalPlaces   <int>: the number of places to pad after the decimal place (default 2)
  decimalChar  <string>: the character string to use for the decimal place (default '.')
  groupingChar <string>: the character string to use for grouping numbers over 1000 (default ',')
*/

/* Usage: 
  import {formatCurrency} from './formatCurrency';
  
  Number.prototype.formatCurrency = formatCurrency;

  (1234).formatCurrency();
  myNumber.formatCurrency();
*/

var formatCurrency = function formatCurrency(decimalPlaces, decimalChar, groupingChar) {
  var value = this;

  decimalPlaces = isNaN(decimalPlaces = Math.abs(decimalPlaces)) ? 2 : decimalPlaces;
  decimalChar = decimalChar == undefined ? '.' : decimalChar;
  groupingChar = groupingChar == undefined ? ',' : groupingChar;

  var sign = value < 0 ? '-' : '';
  var decimalValue = String(parseInt(value = Math.abs(Number(value) || 0).toFixed(decimalPlaces)));
  var group = (group = decimalValue.length) > 3 ? group % 3 : 0;

  return sign + (group ? decimalValue.substr(0, group) + groupingChar : '') + decimalValue.substr(group).replace(/(\d{3})(?=\d)/g, '$1' + groupingChar) + (decimalPlaces ? decimalChar + Math.abs(value - decimalValue).toFixed(decimalPlaces).slice(2) : '');
};

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var Submitting = function Submitting() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-cog fa-spin" });
};

/* harmony default export */ __webpack_exports__["a"] = Submitting;

/***/ }),
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldValidationError_jsx__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(109);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var StandardSelectField = function StandardSelectField(_ref) {
  var autoFocus = _ref.autoFocus,
      disabled = _ref.disabled,
      input = _ref.input,
      label = _ref.label,
      matchPos = _ref.matchPos,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      options = _ref.options,
      placeholder = _ref.placeholder,
      required = _ref.required,
      searchable = _ref.searchable,
      simpleValue = _ref.simpleValue,
      style = _ref.style,
      onCustomChange = _ref.onCustomChange,
      multi = _ref.multi,
      tooltip = _ref.tooltip,
      tooltipPosition = _ref.tooltipPosition;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('form-group', { 'has-error': touched && error }) },
    label || placeholder ? tooltip ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["OverlayTrigger"],
      {
        trigger: ["click", "hover"],
        rootClose: true,
        placement: tooltipPosition,
        overlay: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["Popover"],
          { id: 'popover-positioned-' + tooltipPosition },
          tooltip
        ) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'label',
        { htmlFor: name },
        label || placeholder,
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-question-circle-o' })
      )
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'label',
      { htmlFor: name },
      label || placeholder
    ) : null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select___default.a, _extends({}, input, {
      autoFocus: autoFocus,
      disabled: disabled,
      options: options,
      placeholder: placeholder,
      searchable: searchable,
      matchPos: matchPos,
      required: required,
      simpleValue: simpleValue,
      style: style,
      multi: multi,
      onBlur: function onBlur() {
        return input.onBlur(input.value);
      },
      onChange: function onChange(event) {
        // redux-form overrides change event if provided to Field
        // use custom handler for other specific handling
        onCustomChange(event);
        input.onChange(event);
      }
    })),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FieldValidationError_jsx__["a" /* default */], {
      touched: touched,
      error: error
    })
  );
};

StandardSelectField.propTypes = {
  autoFocus: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  disabled: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  input: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  label: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,
  matchPos: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  meta: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  options: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  placeholder: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  required: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  searchable: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  simpleValue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  style: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  onCustomChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  multi: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  tooltip: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  tooltipPosition: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

StandardSelectField.defaultProps = {
  autoFocus: false,
  disabled: false,
  input: {},
  label: '',
  matchPos: '',
  meta: {},
  options: [],
  placeholder: '',
  required: false,
  searchable: true,
  simpleValue: true,
  style: {},
  onCustomChange: function onCustomChange() {},
  multi: false,
  tooltipPosition: 'top'
};

/* harmony default export */ __webpack_exports__["a"] = StandardSelectField;

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BASE_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BASE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return API_URL; });
/* unused harmony export IMAGE_BASE_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DEFAULT_TOURNAMENT_IMG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DEFAULT_TOURNAMENT_IMG_LARGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ENVIRONMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GOOGLE_ANALYTICS_TRACKING_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ALLOW_CAPTAIN_CHANGE_SQUAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return APP_VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SSO_CLOCK_SKEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FACEBOOK_PIXEL_ID; });
var BASE_PATH = window.REGISTRATION_APPEND_URI ? window.REGISTRATION_APPEND_URI.replace(/\//, '') : '';
var BASE_URL = document.location.protocol + '//' + document.location.host + (BASE_PATH ? '/' + BASE_PATH : '');
var API_URL = BASE_URL + '/api';
var IMAGE_BASE_URL =  true ? BASE_URL + '/assets' : 'http://localhost:8081';
var DEFAULT_TOURNAMENT_IMG = IMAGE_BASE_URL + '/350x200_Pinstar_Thmnl.jpg';
var DEFAULT_TOURNAMENT_IMG_LARGE = IMAGE_BASE_URL + '/usbc-banner.png';
var ENVIRONMENT = window.ENVIRONMENT || 'UNKNOWN';
var GOOGLE_ANALYTICS_TRACKING_ID = window.GOOGLE_ANALYTICS_TRACKING_ID || 'UA-90923542-1';
var ALLOW_CAPTAIN_CHANGE_SQUAD = window.ALLOW_CAPTAIN_CHANGE_SQUAD || false;
var APP_VERSION = window.APP_VERSION || '1.0.0.0';
var SSO_CLOCK_SKEW = window.SSO_CLOCK_SKEW || 300;
var FACEBOOK_PIXEL_ID = window.FACEBOOK_PIXEL_ID || '1101352990766581';

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_constants__ = __webpack_require__(97);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return displayEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return displayVirtualEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return displayTeamOwnedVirtualEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return displayClearCartConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return clearSchedulerItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return calculateBalanceDue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return displayCountriesInDropDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return displayStatesInDropDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return cancelEntryDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cancelEntryPaymentLogHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return cancelPurchasedEntryForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return closeVirtualEntryEditing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return cancelVirtualEventPaymentLogHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return displayEntryDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return displayPurchasedEntryForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return displayRosterPositions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return displayVirtualEntryBowlerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return handleRemoveUnassignedChildVirtualEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return handleRemoveUnassignedParentVirtualEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return setAvailableBowlersInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return setAvailableBowlersInStateForVirtualEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return setEntryDetailsInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return setEntryStateDisabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return setRemoveVirtualEntryConfirmationVisibility; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return setRosterConfirmationVisibility; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return setVirtualEntryBowlerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return setCartVirtualEntryBowlerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return setVirtualEventSelectedEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return virtualEntrySubmittingFinished; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return virtualEntrySubmittingStarts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return setBowlerForVirtualEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return setBowlerForCartVirtualEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return setBowlerForCartVirtualEntryAlreadyAssigned; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return removeVirtualEntryBowlerFromCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return updateVirtualAvailableEntryFromCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return moveRosterDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return moveRosterUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reinsertManagedRosterIdsToCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return setIsProfessional; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return updateRosterInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return searchingStarts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return searchingFinished; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return setMemberSearchField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return setMemberAvgField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return clearRosterPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return assignChildTeamOwnedVirtualEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return assignTeamOwnedVirtualEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return storeTeamOwnedVirtualEntryMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return displayPaymentLogHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return displayVirtualEventPaymentLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return setEntrySelectedEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return createCartRosterPositions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return convertEntriesFromCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return convertVirtualEntriesFromCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return setCurrentCartRosterId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return setCurrentCartRosterComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return setCartRostersComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return setVirtualEntryRosterComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setCartRoster; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return setCartBowlersForCartRosterId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return clearCartItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return removeCartEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return updateCartEntryForParentTeamOwnedVirtualEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return updateCartEntryForChildTeamOwnedVirtualEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return resetTeamOwnedVirtualEntryEventAssignment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return setCartRosterOnEditingEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return setCartRosterIdForVirtualEventInCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return setCartRosterOnCartVirtualEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return clearCartBowlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearShared; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return clearPurchasedTeamOwnedVirtualEntries; });




var displayEntries = function displayEntries(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_PURCHASED_ENTRIES */],
    payload: data
  };
};

var displayVirtualEntries = function displayVirtualEntries(virtualEntries) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DISPLAY_VIRTUAL_ENTRIES_FOR_REG_MANAGE */],
    payload: virtualEntries
  };
};

var displayTeamOwnedVirtualEntries = function displayTeamOwnedVirtualEntries(data, entryId, bowlerCount) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* DISPLAY_TEAM_OWNED_VIRTUAL_ENTRIES */],
    payload: {
      data: data,
      entryId: entryId,
      bowlerCount: bowlerCount
    }
  };
};

var displayClearCartConfirmation = function displayClearCartConfirmation(showModal) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* DISPLAY_CLEAR_CART_CONFIRMATION_FOR_CAPTAIN */],
    payload: showModal
  };
};

var clearSchedulerItems = function clearSchedulerItems() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1_shared_constants__["c" /* CLEAR_SCHEDULER_ITEMS */]
  };
};

var calculateBalanceDue = function calculateBalanceDue() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* CALCULATE_BALANCE_DUE_FOR_REG_MANAGE */]
  };
};

var displayCountriesInDropDown = function displayCountriesInDropDown(countries) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* DISPLAY_COUNTRIES_IN_DD_FOR_ENTRY_FORM */],
    payload: countries
  };
};

var displayStatesInDropDown = function displayStatesInDropDown(states) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* DISPLAY_STATES_IN_DD_FOR_ENTRY_FORM */],
    payload: states
  };
};

var cancelEntryDetails = function cancelEntryDetails() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* CANCEL_ENTRY_DETAILS_FOR_REG_MANAGE */]
  };
};

var cancelEntryPaymentLogHistory = function cancelEntryPaymentLogHistory() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* CANCEL_ENTRY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE */]
  };
};

var cancelPurchasedEntryForm = function cancelPurchasedEntryForm() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* CANCEL_PURCHASED_ENTRY_FORM */]
  };
};

var closeVirtualEntryEditing = function closeVirtualEntryEditing() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* CLOSE_VIRTUAL_BOWLER_EDITING_FOR_REG_MANAGE */]
  };
};

var cancelVirtualEventPaymentLogHistory = function cancelVirtualEventPaymentLogHistory() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* CANCEL_VIRTUAL_EVENT_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE */]
  };
};

var displayEntryDetails = function displayEntryDetails(entryId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* DISPLAY_ENTRY_DETAILS_FOR_REG_MANAGE */],
    payload: entryId
  };
};

var displayPurchasedEntryForm = function displayPurchasedEntryForm(entryId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* DISPLAY_PURCHASED_ENTRY_FORM */],
    payload: entryId
  };
};

var displayRosterPositions = function displayRosterPositions(rosterPositions) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["o" /* DISPLAY_ROSTER_POSITIONS_FOR_REG_MANAGE_PURCHASES */],
    payload: rosterPositions
  };
};

var displayVirtualEntryBowlerList = function displayVirtualEntryBowlerList(virtualEventId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["p" /* DISPLAY_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE */],
    payload: virtualEventId
  };
};

var handleRemoveUnassignedChildVirtualEntries = function handleRemoveUnassignedChildVirtualEntries(virtualEventName) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["q" /* REMOVE_UNASSIGNED_CHILD_VIRTUAL_ENTRIES_ROSTER_CHECKOUT */],
    payload: { virtualEventName: virtualEventName }
  };
};

var handleRemoveUnassignedParentVirtualEntries = function handleRemoveUnassignedParentVirtualEntries(virtualEventName) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["r" /* REMOVE_UNASSIGNED_PARENT_VIRTUAL_ENTRIES_ROSTER_CHECKOUT */],
    payload: { virtualEventName: virtualEventName }
  };
};

var setAvailableBowlersInState = function setAvailableBowlersInState(bowlers) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["s" /* SET_AVAILABLE_BOWLERS_IN_STATE_FOR_REG_MANAGE */],
    payload: bowlers
  };
};

var setAvailableBowlersInStateForVirtualEntries = function setAvailableBowlersInStateForVirtualEntries(bowlers) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["t" /* SET_AVAILABLE_BOWLERS_IN_STATE_FOR_REG_MANAGE_FOR_VIRTUAL_ENTRIES */],
    payload: bowlers
  };
};

var setEntryDetailsInState = function setEntryDetailsInState(entryDetails) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["u" /* SET_ENTRY_DETAILS_IN_STATE_FOR_REG_MANAGE */],
    payload: entryDetails
  };
};

var setEntryStateDisabled = function setEntryStateDisabled(entryId, disabled) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["v" /* SET_ENTRY_STATE_DISABLED_FOR_REG_MANAGE */],
    payload: { entryId: entryId, disabled: disabled }
  };
};

var setRemoveVirtualEntryConfirmationVisibility = function setRemoveVirtualEntryConfirmationVisibility(visible, virtualEventName, childOrParent, quantity) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["w" /* SET_REMOVE_VIRTUAL_ENTRY_CONFIRMATION_FOR_ROSTER_CHECKOUT */],
    payload: { visible: visible, virtualEventName: virtualEventName, childOrParent: childOrParent, quantity: quantity }
  };
};

var setRosterConfirmationVisibility = function setRosterConfirmationVisibility(visible, nextAction, args) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["x" /* SET_ROSTER_CONFIRMATION_VISIBILITY_FOR_MANAGE_ENTRIES */],
    payload: { visible: visible, nextAction: nextAction, args: args }
  };
};

var setVirtualEntryBowlerList = function setVirtualEntryBowlerList(bowlerList) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* SET_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE */],
    payload: bowlerList
  };
};

var setCartVirtualEntryBowlerList = function setCartVirtualEntryBowlerList(bowlerList) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["z" /* SET_CART_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE */],
    payload: bowlerList
  };
};

var setVirtualEventSelectedEntry = function setVirtualEventSelectedEntry(virtualEventId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["A" /* SET_SELECTED_VIRTUAL_EVENT_FOR_REG_MANAGE_ENTRIES */],
    payload: virtualEventId
  };
};

var virtualEntrySubmittingFinished = function virtualEntrySubmittingFinished() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["B" /* VIRTUAL_ENTRY_SUBMITTING_FINISHED_FOR_REG_MANAGE */]
  };
};

var virtualEntrySubmittingStarts = function virtualEntrySubmittingStarts() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["C" /* VIRTUAL_ENTRY_SUBMITTING_STARTS_FOR_REG_MANAGE */]
  };
};

var setBowlerForVirtualEntry = function setBowlerForVirtualEntry(virtualEntryId, bowlerId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["D" /* SET_BOWLER_FOR_VIRTUAL_ENTRY_FOR_REG_MANAGE */],
    payload: { virtualEntryId: virtualEntryId, bowlerId: bowlerId }
  };
};

var setBowlerForCartVirtualEntry = function setBowlerForCartVirtualEntry(virtualEntryId, bowlerId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["E" /* SET_BOWLER_FOR_CART_VIRTUAL_ENTRY_FOR_REG_MANAGE */],
    payload: { virtualEntryId: virtualEntryId, bowlerId: bowlerId }
  };
};

var setBowlerForCartVirtualEntryAlreadyAssigned = function setBowlerForCartVirtualEntryAlreadyAssigned(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["F" /* SET_BOWLER_FOR_CART_VIRTUAL_ENTRY_ALREADY_ASSIGNED_FOR_REG_MANAGE */],
    payload: payload
  };
};

var removeVirtualEntryBowlerFromCart = function removeVirtualEntryBowlerFromCart(bowlerId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["G" /* REMOVE_VIRTUAL_ENTRY_BOWLER_FROM_CART */],
    payload: { bowlerId: bowlerId }
  };
};

var updateVirtualAvailableEntryFromCart = function updateVirtualAvailableEntryFromCart(cartRosterId, virtualEventId, virtualEntryQuantity) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["H" /* UPDATE_VIRTUAL_AVAILABLE_ENTRY_FROM_CART */],
    payload: { cartRosterId: cartRosterId, virtualEventId: virtualEventId, virtualEntryQuantity: virtualEntryQuantity }
  };
};

var moveRosterDown = function moveRosterDown(index) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["I" /* MOVE_POSITION_DOWN_FOR_REG_ROSTERS */],
    payload: index
  };
};

var moveRosterUp = function moveRosterUp(index) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["J" /* MOVE_POSITION_UP_FOR_REG_ROSTER */],
    payload: index
  };
};

var reinsertManagedRosterIdsToCart = function reinsertManagedRosterIdsToCart(tempCartEntries) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["K" /* REINSERT_MANAGED_ROSTER_IDS_INTO_CART */],
    payload: tempCartEntries
  };
};

var setIsProfessional = function setIsProfessional(position, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["L" /* SET_IS_PROFESSIONAL_FOR_REG_ROSTER */],
    payload: {
      position: position,
      value: value
    }
  };
};

var updateRosterInfo = function updateRosterInfo(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["M" /* UPDATE_ROSTER_INFO */],
    payload: data
  };
};

var searchingStarts = function searchingStarts(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["N" /* SEARCHING_MEMBER_STARTS */],
    payload: data
  };
};

var searchingFinished = function searchingFinished() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["O" /* SEARCHING_MEMBER_FINISHED */]
  };
};

var setMemberSearchField = function setMemberSearchField(roster) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["P" /* SET_MEMBER_SEARCH_FIELD */],
    payload: roster
  };
};

var setMemberAvgField = function setMemberAvgField(position, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["Q" /* SET_MEMBER_AVG_FIELD */],
    payload: {
      position: position,
      value: value
    }
  };
};

var clearRosterPosition = function clearRosterPosition(index) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["R" /* CLEAR_POSITION_FOR_REG_ROSTERS */],
    payload: index
  };
};

var assignChildTeamOwnedVirtualEntry = function assignChildTeamOwnedVirtualEntry(virtualEventName, parentTeamEntryId, rosterPosition, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["S" /* ASSIGN_CHILD_TEAM_OWNED_VIRTUAL_ENTRY */],
    payload: {
      virtualEventName: virtualEventName,
      parentTeamEntryId: parentTeamEntryId,
      rosterPosition: rosterPosition,
      value: value
    }
  };
};

var assignTeamOwnedVirtualEntry = function assignTeamOwnedVirtualEntry(virtualEventName, teamEntryId, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["T" /* ASSIGN_TEAM_OWNED_VIRTUAL_ENTRY */],
    payload: {
      virtualEventName: virtualEventName,
      teamEntryId: teamEntryId,
      value: value
    }
  };
};

var storeTeamOwnedVirtualEntryMap = function storeTeamOwnedVirtualEntryMap(virtualEventName, teamEntryId, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["U" /* STORE_TEAM_OWNED_VIRTUAL_ENTRY_MAP */],
    payload: {
      virtualEventName: virtualEventName,
      teamEntryId: teamEntryId,
      value: value
    }
  };
};

var displayPaymentLogHistory = function displayPaymentLogHistory(entryId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["V" /* DISPLAY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE_TEAMS */],
    payload: entryId
  };
};

var displayVirtualEventPaymentLog = function displayVirtualEventPaymentLog(virtualEventId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["W" /* DISPLAY_VIRTUAL_EVENT_PAYMENT_LOG_FOR_REG_MANAGE */],
    payload: virtualEventId
  };
};

var setEntrySelectedEntry = function setEntrySelectedEntry(entryId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["X" /* SET_SELECTED_ENTRY_FOR_REG_MANAGE_ENTRIES */],
    payload: entryId
  };
};

var createCartRosterPositions = function createCartRosterPositions(eventNumberOfBowlers, averageBased) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["Y" /* CREATE_CART_ROSTER_POSITIONS */],
    payload: { eventNumberOfBowlers: eventNumberOfBowlers, averageBased: averageBased }
  };
};

var convertEntriesFromCart = function convertEntriesFromCart(squads, events) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["Z" /* CONVERT_ENTRIES_FROM_CART */],
    payload: { squads: squads, events: events }
  };
};

var convertVirtualEntriesFromCart = function convertVirtualEntriesFromCart(squads) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["_0" /* CONVERT_VIRTUAL_ENTRIES_FROM_CART */],
    payload: squads
  };
};

var setCurrentCartRosterId = function setCurrentCartRosterId(oldId, newId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["_1" /* SET_CURRENT_ROSTER_CART_ID */],
    payload: { oldId: oldId, newId: newId }
  };
};

var setCurrentCartRosterComplete = function setCurrentCartRosterComplete(name) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["_2" /* SET_CURRENT_ROSTER_CART_COMPLETE */],
    payload: name
  };
};

var setCartRostersComplete = function setCartRostersComplete(cartRosterId, cartRoster) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["_3" /* SET_CART_ROSTERS_COMPLETE */],
    payload: { cartRosterId: cartRosterId, cartRoster: cartRoster }
  };
};

var setVirtualEntryRosterComplete = function setVirtualEntryRosterComplete(cartRosterId, cartRoster) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["_4" /* SET_VIRTUAL_ENTRY_ROSTER_COMPLETE */],
    payload: { cartRosterId: cartRosterId, cartRoster: cartRoster }
  };
};

var setCartRoster = function setCartRoster(cartRoster) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["_5" /* SET_CART_ROSTER */],
    payload: cartRoster
  };
};

var setCartBowlersForCartRosterId = function setCartBowlersForCartRosterId(cartBowlers, cartRosterId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["_6" /* SET_CART_BOWLERS_FOR_CART_ROSTER_ID */],
    payload: { cartBowlers: cartBowlers, cartRosterId: cartRosterId }
  };
};

var clearCartItems = function clearCartItems() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["_7" /* CLEAR_CART_ITEMS */]
  };
};

var removeCartEntry = function removeCartEntry(cartRosterId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["_8" /* REMOVE_CART_ENTRY */],
    payload: cartRosterId
  };
};

var updateCartEntryForParentTeamOwnedVirtualEntry = function updateCartEntryForParentTeamOwnedVirtualEntry(virtualEventName, teamEntryId, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["_9" /* UPDATE_CART_ENTRY_FOR_PARENT_TEAM_OWNED_VIRTUAL_ENTRY */],
    payload: {
      virtualEventName: virtualEventName,
      teamEntryId: teamEntryId,
      value: value
    }
  };
};

var updateCartEntryForChildTeamOwnedVirtualEntry = function updateCartEntryForChildTeamOwnedVirtualEntry(virtualEventName, teamEntryId, value, rosterPosition) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["_10" /* UPDATE_CART_ENTRY_FOR_CHILD_TEAM_OWNED_VIRTUAL_ENTRY */],
    payload: {
      virtualEventName: virtualEventName,
      teamEntryId: teamEntryId,
      value: value,
      rosterPosition: rosterPosition
    }
  };
};

var resetTeamOwnedVirtualEntryEventAssignment = function resetTeamOwnedVirtualEntryEventAssignment() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["_11" /* RESET_TEAM_OWNED_VIRTUAL_ENTRY_EVENT_ASSIGNMENT */]
  };
};

var setCartRosterOnEditingEntry = function setCartRosterOnEditingEntry(cartRosterId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["_12" /* SET_CART_ROSTER_ON_EDITING_ENTRY */],
    payload: {
      cartRosterId: cartRosterId
    }
  };
};

var setCartRosterIdForVirtualEventInCart = function setCartRosterIdForVirtualEventInCart(virtualEvents, virtualEventId, cartRosterId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["_13" /* SET_CART_ROSTER_ID_FOR_VIRTUAL_EVENT_IN_CART */],
    payload: {
      virtualEvents: virtualEvents,
      virtualEventId: virtualEventId,
      cartRosterId: cartRosterId
    }
  };
};

var setCartRosterOnCartVirtualEntries = function setCartRosterOnCartVirtualEntries(assignedVirtualEntries, cartRosterId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["_14" /* SET_CART_ROSTER_ON_CART_VIRTUAL_ENTRIES */],
    payload: {
      assignedVirtualEntries: assignedVirtualEntries,
      cartRosterId: cartRosterId
    }
  };
};

var clearCartBowlers = function clearCartBowlers() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["_15" /* CLEAR_CART_BOWLERS */]
  };
};

var clearShared = function clearShared() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["_16" /* CLEAR_SHARED */]
  };
};

var clearPurchasedTeamOwnedVirtualEntries = function clearPurchasedTeamOwnedVirtualEntries() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["_17" /* CLEAR_PURCHASED_TEAM_OWNED_VIRTUAL_ENTRIES */]
  };
};

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_validators__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_error_actionTypes__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_error_errorManager__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_actionRosterPosition__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actionTypes__ = __webpack_require__(269);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return handleCountryChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return handleSaveEntryRosterForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return handleRosterPositionCleared; });
/* unused harmony export retrieveCancelEntryWarnings */
/* unused harmony export retrieveRosterWarnings */
/* unused harmony export retrieveStates */
/* unused harmony export retrieveCountries */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return validateEntryRosterForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return handleSearchChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return handleSearch; });
/* unused harmony export setRosterPositionAverage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return handleSearchEnterKeyPress; });
/* unused harmony export autoSetTeamNameForRosterFromState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return handleMoveDownClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return handleMoveUpClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return handleCancelClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return handleViewRosterClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return handleAdminManageRosterClick; });
/* unused harmony export retrieveAvailableBowlers */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return retrieveEntryDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return retrieveEntryCaptainDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return retrieveEntryCoordinatorDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return handlePaymentLogClick; });
/* unused harmony export retrievePaymentLog */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return validateEntryDetailSquadChangeForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return validateEntryCaptainChangeForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return validateEntryCoordinatorDetailForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return handleEntryCaptainChangeFormSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeEntryCaptain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return handleEntryDetailPaymentClick; });
/* unused harmony export validate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return handleEntryDetailCreditCardPaymentClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return handleEntryDetailPaymentCancelClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return handlePaymentSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return handleSquadChangeClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return handleSquadChangeCancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return handleSquadChangeSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return handleChangeSquadDateChanged; });
/* unused harmony export updateAvailableSquadsForDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return handleEntryDetailCoordinatorUpdateClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return handleEntryDetailChangeCaptainClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handleEntryDetailCoordinatorUpdateCancelClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return handleEntryChangeCaptainCancelClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return handleEntryChangeCaptainSearchClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handleCoordinatorSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return handleRemoveSquadClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return handleEntryDetailCancelEntryClick; });
/* unused harmony export displayEntryDetailRefundModal */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return handleEntryDetailRefundCancelClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return handleEntryDetailRefundSubmitClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return handleEntryDetailReactivateEntryClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return handleReactivationCancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return handleReactivationChangeSquadDateChanged; });
/* unused harmony export updateAvailableSquadsForReactivationDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return handleReactivationSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return handleEntryDetailRefundClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return handleEventChangeClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return handleEventChangeCancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return handleEventChangeSave; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













var handleCountryChange = function handleCountryChange(value) {
  return function (dispatch, getState) {
    var countries = getState().admin.entryDetail.countries,
        selectedCountry = countries.find(function (x) {
      return x.value === value;
    }),
        disableEntryState = !selectedCountry || !selectedCountry.label || selectedCountry.label !== 'United States';

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["b" /* setEntryStateDisabled */])(disableEntryState));
    if (disableEntryState) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('adminEntryRosterForm', 'state', null));
    }
  };
};

var handleSaveEntryRosterForm = function handleSaveEntryRosterForm(data) {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var _getState$admin$entry = getState().admin.entryDetail,
          entryId = _getState$admin$entry.entryId,
          rosterPositions = _getState$admin$entry.rosterPositions;

      // Make sure we don't save if there are modifications in the user ID 

      var hasRosterPositionChanged = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_actionRosterPosition__["a" /* rostersHasUserIdModifications */])(rosterPositions);

      // For some reason, we need to do this to refresh the layout 
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["c" /* setRosterPositions */])(rosterPositions.map(function (r) {
        return r;
      })));
      if (hasRosterPositionChanged) {
        resolve();
        return;
      }

      // create payload using form data and roster positions from state
      var payload = {
        rosterPositions: rosterPositions,
        name: data.name,
        state: data.state,
        countryId: data.countryId,
        pairCode: data.pairCode,
        groupCode: data.groupCode
      };

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["g" /* putJsonAsync */])('admin/entry/' + entryId + '/roster', payload, false)).then(function () {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["reset"])('adminEntryRosterForm'));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["d" /* displayEntryModal */])(false));
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Roster Updated!', 'Entry roster successfully saved!');
        dispatch(retrieveEntryDetails(entryId));
        resolve();
      }).catch(function (error) {

        if (!Array.isArray(error)) {
          error = [error.message];
        }

        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_error_errorManager__["b" /* displayErrorList */])(error));

        resolve();
      });
    });
  };
};

var handleRosterPositionCleared = function handleRosterPositionCleared(index) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["e" /* clearRosterPosition */])(index));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('adminEntryRosterForm', 'average-' + (index + 1), ""));
    dispatch(autoSetTeamNameForRosterFromState());

    dispatch(retrieveRosterWarnings());
  };
};

var retrieveCancelEntryWarnings = function retrieveCancelEntryWarnings() {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var entryId = getState().admin.entryDetail.entryId;


      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["e" /* postJsonAsync */])('admin/entry/' + entryId + '/cancelWarnings')).then(function (response) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["f" /* setVirtualEntriesToModify */])(response.virtualEntriesToModify));
        resolve();
      }).catch(function () {
        return resolve();
      });
    });
  };
};

var retrieveRosterWarnings = function retrieveRosterWarnings() {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var _getState$admin$entry2 = getState().admin.entryDetail,
          entryId = _getState$admin$entry2.entryId,
          rosterPositions = _getState$admin$entry2.rosterPositions;

      // create payload using form data and roster positions from state

      var payload = {
        rosterPositions: rosterPositions
      };

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["f" /* setVirtualEntriesToModify */])(undefined));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["e" /* postJsonAsync */])('admin/entry/' + entryId + '/rosterWarnings', payload)).then(function (response) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["f" /* setVirtualEntriesToModify */])(response.virtualEntriesToModify));
        resolve();
      }).catch(function () {
        return resolve();
      });
    });
  };
};

var retrieveStates = function retrieveStates() {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      var states = getState().admin.entryDetail.states;

      // prevent going to server if countries already in state
      if (states && states.length) {
        resolve(states);
      }

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["d" /* getJsonAsync */])('states')).then(function (states) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["g" /* setStates */])(states));
        resolve(states);
      }).catch(function () {
        return reject();
      });
    });
  };
};

var retrieveCountries = function retrieveCountries() {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      var countries = getState().admin.entryDetail.countries;

      // prevent going to server if countries already in state
      if (countries && countries.length) {
        resolve(countries);
      }

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["d" /* getJsonAsync */])('countries')).then(function (countries) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["h" /* setCountries */])(countries.map(function (_ref) {
          var id = _ref.id,
              name = _ref.name;
          return {
            value: id,
            label: name
          };
        })));
        resolve(countries);
      }).catch(function () {
        return reject();
      });
    });
  };
};

var validateEntryRosterForm = function validateEntryRosterForm(data) {
  var errors = {};

  if (!data.name) {
    errors.name = 'We need to be able to identify your team.';
  }
  return errors;
};

var handleSearchChange = function handleSearchChange(roster, event) {
  return function (dispatch) {
    roster._searchValue = event.target.value.trim();
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["i" /* setMemberSearchField */])(roster));
  };
};

var handleSearch = function handleSearch(rosterPosition) {
  return function (dispatch, getState) {
    var tournamentId = getState().admin.entryDetail.tournament.id;
    var eventId = getState().admin.entryDetail.eventId;
    var entryId = getState().admin.entryDetail.entryId;

    // do nothing if usbc search field is empty
    if (!rosterPosition._searchValue) {
      return false;
    }

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["j" /* searchingStarts */])(rosterPosition));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["d" /* getJsonAsync */])('admin/tournament/' + tournamentId + '/member/' + rosterPosition._searchValue + '/event/' + eventId + '/entry/' + entryId)).then(function (bowler) {
      var updatedRosterPosition = _extends({}, rosterPosition, {
        bowler: bowler.error ? {} : bowler,
        usbcId: rosterPosition._searchValue,
        usbcIdError: false,
        _errorMessage: bowler.error ? bowler.error.Message : null
      });

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["k" /* updateRosterInfo */])(updatedRosterPosition));
      dispatch(setRosterPositionAverage(updatedRosterPosition));
      dispatch(autoSetTeamNameForRosterFromState());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["l" /* searchingFinished */])());

      dispatch(retrieveRosterWarnings());
    }).catch(function () {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["l" /* searchingFinished */])());
    });
  };
};

var setRosterPositionAverage = function setRosterPositionAverage(rosterPosition) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('adminEntryRosterForm', 'average-' + rosterPosition.position, rosterPosition.bowler.average));
  };
};

var handleSearchEnterKeyPress = function handleSearchEnterKeyPress(roster, event) {
  return function (dispatch) {
    if (event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation();
      dispatch(handleSearch(roster));
    }
  };
};

var autoSetTeamNameForRosterFromState = function autoSetTeamNameForRosterFromState() {
  return function (dispatch, getState) {
    var state = getState(),
        rosterPositions = state.admin.entryDetail.rosterPositions,
        rosterPositionsQty = rosterPositions.length;

    // singles
    if (rosterPositionsQty === 1) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('adminEntryRosterForm', 'name', rosterPositions[0].bowler.firstName + ' ' + rosterPositions[0].bowler.lastName));

      // doubles
    } else if (rosterPositionsQty === 2) {
      var teamNameA = rosterPositions[0].bowler && rosterPositions[0].bowler.lastName ? rosterPositions[0].bowler.lastName : '';
      var teamNameB = rosterPositions[1].bowler && rosterPositions[1].bowler.lastName ? rosterPositions[1].bowler.lastName : '';

      if (teamNameA || teamNameB) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('adminEntryRosterForm', 'name', '' + teamNameA + (teamNameA && teamNameB ? '/' : '') + teamNameB));
      }
    }
  };
};

var handleMoveDownClick = function handleMoveDownClick(index) {
  return function (dispatch, getState) {
    var formValues = getState().form.adminEntryRosterForm.values;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["m" /* moveRosterDown */])(index));

    // swap averages in form data because of redux-form is handling those fields
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('adminEntryRosterForm', 'average-' + (index + 1), formValues['average-' + (index + 2)]));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('adminEntryRosterForm', 'average-' + (index + 2), formValues['average-' + (index + 1)]));
    dispatch(autoSetTeamNameForRosterFromState());
  };
};

var handleMoveUpClick = function handleMoveUpClick(index) {
  return function (dispatch, getState) {
    var formValues = getState().form.adminEntryRosterForm.values;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["n" /* moveRosterUp */])(index));

    // swap averages in form data because of redux-form is handling those fields
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('adminEntryRosterForm', 'average-' + (index + 1), formValues['average-' + index]));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('adminEntryRosterForm', 'average-' + index, formValues['average-' + (index + 1)]));
    dispatch(autoSetTeamNameForRosterFromState());
  };
};

var handleCancelClick = function handleCancelClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["d" /* displayEntryModal */])(false));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["reset"])('adminEntryRosterForm'));
  };
};

var handleViewRosterClick = function handleViewRosterClick() {
  return function (dispatch, getState) {
    var entryId = getState().admin.entryDetail.entryId;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["d" /* getJsonAsync */])('admin/entry/' + entryId + '/readonly')).then(function (readOnlyInfo) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["d" /* displayEntryModal */])(true));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["o" /* setEntryReadOnlyInfo */])(readOnlyInfo));
    });
  };
};

var handleAdminManageRosterClick = function handleAdminManageRosterClick() {
  return function (dispatch, getState) {
    dispatch(retrieveStates()).then(function () {
      dispatch(retrieveCountries()).then(function () {
        var _getState$admin$entry3 = getState().admin.entryDetail,
            entryId = _getState$admin$entry3.entryId,
            countries = _getState$admin$entry3.countries;


        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["f" /* setVirtualEntriesToModify */])(undefined));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["d" /* getJsonAsync */])('admin/entry/' + entryId + '/roster')).then(function (entry) {
          var selectedCountry = countries.find(function (x) {
            return x.value === entry.countryId;
          }),
              disableEntryState = !selectedCountry || !selectedCountry.label || selectedCountry.label !== 'United States';
          var rosterPositionsAverage = {};
          var rosterPositions = entry.rosterPositions.map(function (roster) {
            return _extends({}, roster, {
              _searchValue: roster.bowler.usbcId || '',
              _processing: false,
              _retrieved: !!roster.bowler.usbcId && !roster.bowler.error,
              _errorMessage: roster.bowler.error ? roster.bowler.error.Message : null,
              bowler: roster.bowler.error ? {} : _extends({}, roster.bowler, {
                average: roster.bowler.average || ''
              })
            });
          });

          var errorUsbcIds = rosterPositions.filter(function (rosterPosition) {
            return rosterPosition._errorMessage;
          }).map(function (rosterPosition) {
            return rosterPosition._searchValue;
          });

          if (errorUsbcIds && errorUsbcIds.length > 0) {
            __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].error('USBC ID' + (errorUsbcIds.length === 1 ? '' : 's') + ' ' + errorUsbcIds.join() + ' ' + (errorUsbcIds.length === 1 ? 'is' : 'are') + ' not found in membership', '', { allowHtml: true });
          }

          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["d" /* displayEntryModal */])(true));
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["c" /* setRosterPositions */])(rosterPositions));

          // generates redux-form model for roster positions averages
          rosterPositions.forEach(function (roster) {
            return rosterPositionsAverage['average-' + roster.position] = roster.bowler.average;
          });

          // re-initialize redux-form with entry data
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["initialize"])('adminEntryRosterForm', _extends({}, rosterPositionsAverage, entry, {
            rosterPositionsQty: rosterPositions.length
          })));
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["b" /* setEntryStateDisabled */])(disableEntryState));

          // initialize available bowler list for doubles/singles dropwdown
          dispatch(retrieveAvailableBowlers(entryId));
        });
      });
    });
  };
};

var retrieveAvailableBowlers = function retrieveAvailableBowlers(entryId) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["d" /* getJsonAsync */])('admin/entry/' + entryId + '/bowlers')).then(function (bowlers) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["p" /* setAvailableBowlersInState */])(bowlers));
        resolve(bowlers);
      }).catch(function () {
        return reject();
      });
    });
  };
};

var retrieveEntryDetails = function retrieveEntryDetails(entryId, paymentId) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["d" /* getJsonAsync */])('admin/entry/' + entryId)).then(function (response) {
        if (response.parentEntryId) {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["b" /* navigateTo */])('admin/entry/' + response.parentEntryId));
          __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].warning('Showing the linked entry', 'The entry ' + response.entryNumber + ' is linked to this entry. You can only modify this entry.');
          resolve(response);
          return;
        }
        dispatch(initializeDetailForms(entryId, response));
        dispatch(setEntryDetails(entryId, response));

        if (paymentId) {
          dispatch(entryPayment(entryId, paymentId));
        }
        resolve(response);
      });
    });
  };
};

var entryPayment = function entryPayment(entryId, paymentId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["e" /* postJsonAsync */])('admin/entry/' + entryId + '/payment/balance', {
      BypassWebHooks: localStorage.bypassWebHooks,
      paymentId: paymentId
    })).then(function (response) {
      if (response) __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Payment Processed!', 'Selected entries were paid successfully.');
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["q" /* setEntryDetailBalance */])(response.balance));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["reset"])('adminEntryPaymentForm'));
    });

    if (localStorage.bypassWebHooks) delete localStorage.bypassWebHooks;
  };
};

var initializeDetailForms = function initializeDetailForms(entryId, response) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["initialize"])('adminEntryPaymentForm', {
      entryId: entryId
    }));

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["initialize"])('adminEntryDetailSquadChangeForm', {
      entryId: entryId,
      currentSquadDate: response.squadDateTime ? __WEBPACK_IMPORTED_MODULE_0_moment___default.a.parseZone(response.squadDateTime).format('YYYY-MM-DD') : null,
      currentSquadId: response.squadId,
      availableSquads: response.availableSquads.map(function (x) {
        return {
          value: x.id,
          label: x.description
        };
      })
    }));

    if (response.availableEvents) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["initialize"])('adminEntryDetailEventChangeForm', {
        entryId: entryId,
        availableEvents: response.availableEvents.map(function (x) {
          return {
            value: x.id,
            label: x.description
          };
        })
      }));
    }
  };
};

var setEntryDetails = function setEntryDetails(entryId, response) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["r" /* setEntrySummary */])({
      entryNumber: response.entryNumber,
      groupCode: response.groupCode,
      pairCode: response.pairCode,
      readOnly: response.readOnly,
      isCancelled: response.isCancelled,
      teamName: response.teamName,
      divisionName: response.divisionName,
      timeZoneDisplayName: response.timeZoneDisplayName,
      squadDateTime: response.squadDateTime,
      eventId: response.eventId
    }));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["q" /* setEntryDetailBalance */])(response.balance));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["s" /* setEntryDetailCaptainId */])(response.captainId));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["t" /* setEntryDetailId */])(entryId));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["u" /* setEntryDetailTournament */])({
      id: response.tournamentId,
      name: response.tournamentName,
      stripeKey: response.tournamentStripeKey,
      startDate: response.tournamentStartDate,
      endDate: response.tournamentEndDate,
      allowChangeBetweenFreeEvents: response.allowChangeBetweenFreeEvents
    }));
  };
};

var retrieveEntryCaptainDetails = function retrieveEntryCaptainDetails(captainId) {
  return function (dispatch, getState) {
    var readOnly = getState().admin.entryDetail.readOnly;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["e" /* postJsonAsync */])('admin/captain/' + captainId)).then(function (response) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["v" /* setEntryDetailCaptain */])({
        captainId: captainId,
        captainFirstName: response.captainFirstName,
        captainLastName: response.captainLastName,
        captainEmail: response.captainEmail,
        readOnly: readOnly
      }));
    });
  };
};

var retrieveEntryCoordinatorDetails = function retrieveEntryCoordinatorDetails(coordinatorId) {
  return function (dispatch) {
    if (coordinatorId === undefined || coordinatorId === null) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["w" /* setEntryDetailCoordinator */])({
        firstName: '',
        lastName: '',
        email: ''
      }));
      return;
    }
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["d" /* getJsonAsync */])('admin/coordinator/' + coordinatorId)).then(function (response) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["w" /* setEntryDetailCoordinator */])({
        firstName: response.firstName,
        lastName: response.lastName,
        email: response.email
      }));
    });
  };
};

var handlePaymentLogClick = function handlePaymentLogClick() {
  return function (dispatch, getState) {
    var _getState$admin$entry4 = getState().admin.entryDetail,
        entryId = _getState$admin$entry4.entryId,
        showPaymentLog = _getState$admin$entry4.showPaymentLog;


    if (showPaymentLog) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["a" /* displayPaymentLogHistory */])(false));
      return;
    }

    dispatch(retrievePaymentLog(entryId)).then(function () {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["a" /* displayPaymentLogHistory */])());
    });
  };
};

var retrievePaymentLog = function retrievePaymentLog(entryId) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["d" /* getJsonAsync */])('admin/entry/' + entryId + '/payment/log')).then(function (paymentLog) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["x" /* setPaymentLogHistory */])(paymentLog));
        resolve(paymentLog);
      }).catch(function () {
        return resolve();
      });
    });
  };
};

var validateEntryDetailSquadChangeForm = function validateEntryDetailSquadChangeForm(data) {
  var errors = {};

  if (!data.currentSquadId) {
    errors.currentSquadId = 'There are no squads available on this date';
  }

  return errors;
};

var validateEntryCaptainChangeForm = function validateEntryCaptainChangeForm(data) {
  var errors = {};

  if (!data.captainEmail || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_validators__["a" /* validateEmail */])(data.captainEmail)) {
    errors.captainEmail = 'Please provide a valid email.';
  }

  if (!data.captainFirstName) {
    errors.captainFirstName = 'Please search for the captain before updating.';
  }

  return errors;
};

var validateEntryCoordinatorDetailForm = function validateEntryCoordinatorDetailForm(data) {
  var errors = {};

  if (!data.email || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_validators__["a" /* validateEmail */])(data.email)) {
    errors.email = 'Please provide a valid email.';
  }

  return errors;
};

var handleEntryCaptainChangeFormSave = function handleEntryCaptainChangeFormSave(data) {
  return function (dispatch, getState) {
    return new Promise(function () {
      var entryId = getState().admin.entryDetail.entryId;
      var virtualEntries = getState().admin.captainDetail.affectedVirtualEntries.filter(function (entry) {
        return entry.selected;
      }).map(function (entry) {
        return entry.virtualEntryId;
      });

      var request = {
        entryId: entryId,
        firstName: data.captainFirstName,
        lastName: data.captainLastName,
        email: data.captainEmail,
        virtualEntryIds: virtualEntries
      };

      dispatch(changeEntryCaptain(request));
    });
  };
};

var changeEntryCaptain = function changeEntryCaptain(request) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["e" /* postJsonAsync */])('admin/captain/change/entry', request)).then(function (response) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["y" /* hideEntryDetailChangeCaptainModal */])());
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Captain Changed!', 'Captain was changed.');
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["s" /* setEntryDetailCaptainId */])(response.captainId));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["v" /* setEntryDetailCaptain */])({
          captainId: response.captainId,
          captainFirstName: response.firstName,
          captainLastName: response.lastName,
          captainEmail: response.email
        }));
        resolve();
      }).catch(function () {
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].error('Captain Not Changed!', 'There was an error changing the captain.');
        resolve();
      });
    });
  };
};

var handleEntryDetailPaymentClick = function handleEntryDetailPaymentClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["z" /* displayEntryDetailPaymentModal */])());
  };
};

var validate = function validate(data) {
  var errors = {};

  if (!data.name) {
    errors.name = 'Please provide a name for this account.';
  }
  return errors;
};

var handleEntryDetailCreditCardPaymentClick = function handleEntryDetailCreditCardPaymentClick() {
  return function (dispatch, getState) {
    var state = getState();
    var entryId = state.admin.entryDetail.entryId;
    var tournament = state.admin.entryDetail.tournament;
    var body = {
      entryId: entryId
    };

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["e" /* postJsonAsync */])('admin/entry/createSession', body)).then(function (response) {
      var publishableKey = tournament.stripeKey;
      var stripe = window.Stripe(publishableKey);
      var sessionId = response.paymentId;

      stripe.redirectToCheckout({
        sessionId: sessionId
      });
    });
  };
};

var handleEntryDetailPaymentCancelClick = function handleEntryDetailPaymentCancelClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["A" /* cancelEntryDetailPaymentModal */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["reset"])('adminEntryPaymentForm'));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_error_actionTypes__["a" /* setErrorList */])([]));
  };
};

var handlePaymentSave = function handlePaymentSave(data) {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var showPaymentLog = getState().admin.entryDetail.showPaymentLog;

      if (data.stripeTransactionId) data.stripeTransactionId = data.stripeTransactionId.trim();

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["e" /* postJsonAsync */])('admin/entry/' + data.entryId + '/payment/other', data)).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Saved!', 'Payment was successfully saved.');
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["q" /* setEntryDetailBalance */])(response.balance));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["B" /* hideEntryDetailPaymentModal */])());
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["reset"])('adminEntryPaymentForm'));

        // update payment log info if container is visible
        if (showPaymentLog) {
          dispatch(retrievePaymentLog(data.entryId)).then(function () {
            return resolve();
          });
        } else {
          resolve();
        }
      }).catch(function () {
        return resolve();
      });
    });
  };
};

var handleSquadChangeClick = function handleSquadChangeClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["C" /* displaySquadChangeModal */])(true));
  };
};

var handleSquadChangeCancel = function handleSquadChangeCancel() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["C" /* displaySquadChangeModal */])(false));
  };
};

var handleSquadChangeSave = function handleSquadChangeSave(data) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      var request = {
        entryId: data.entryId,
        squadId: data.currentSquadId
      };

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["g" /* putJsonAsync */])('admin/entry/' + request.entryId + '/squad/change', request)).then(function () {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["C" /* displaySquadChangeModal */])(false));
        dispatch(retrieveEntryDetails(request.entryId));
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Squad Changed!', 'The squad was changed successfully.');
        resolve();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].error('Squad Not Updated!', 'There was an error changing squad for the entry.');
        reject(error);
      });
    });
  };
};

var handleChangeSquadDateChanged = function handleChangeSquadDateChanged(date) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('adminEntryDetailSquadChangeForm', 'currentSquadDate', date));
    dispatch(updateAvailableSquadsForDate(date));
  };
};

var updateAvailableSquadsForDate = function updateAvailableSquadsForDate(date) {
  return function (dispatch, getState) {
    var entryId = getState().admin.entryDetail.entryId,
        formattedDate = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.parseZone(date).format('YYYY-MM-DD');

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["d" /* getJsonAsync */])('admin/entry/' + entryId + '/squads/' + formattedDate)).then(function (response) {
      var availableSquads = response.map(function (x) {
        return {
          value: x.id,
          label: x.description
        };
      });

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('adminEntryDetailSquadChangeForm', 'availableSquads', availableSquads));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('adminEntryDetailSquadChangeForm', 'currentSquadId', availableSquads.length ? availableSquads[0].value : ''));
    }).catch(function () {
      __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].error('Error getting squads!', 'There was an error getting available squad times.');
    });
  };
};

var handleEntryDetailCoordinatorUpdateClick = function handleEntryDetailCoordinatorUpdateClick() {
  return function (dispatch, getState) {
    var state = getState(),
        coordinator = state.admin.entryDetail.coordinator;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["D" /* displayEntryDetailCoordinatorModal */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["initialize"])('adminEntryCoordinatorDetailForm', coordinator));
  };
};

var handleEntryDetailChangeCaptainClick = function handleEntryDetailChangeCaptainClick() {
  return function (dispatch, getState) {
    var state = getState(),
        captain = state.admin.entryDetail.captain;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["E" /* displayEntryDetailChangeCaptainModal */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["initialize"])('adminEntryCaptainChangeForm', captain));
  };
};

var handleEntryDetailCoordinatorUpdateCancelClick = function handleEntryDetailCoordinatorUpdateCancelClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["F" /* cancelEntryDetailCoordinatorModal */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["reset"])('adminEntryCoordinatorDetailForm'));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_error_actionTypes__["a" /* setErrorList */])([]));
  };
};

var handleEntryChangeCaptainCancelClick = function handleEntryChangeCaptainCancelClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["G" /* cancelEntryDetailChangeCaptainModal */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["reset"])('adminEntryCaptainChangeForm'));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_error_actionTypes__["a" /* setErrorList */])([]));
  };
};

var handleEntryChangeCaptainSearchClick = function handleEntryChangeCaptainSearchClick() {
  return function (dispatch, getState) {
    var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])('adminEntryCaptainChangeForm');
    var captainEmail = selector(getState(), 'captainEmail');

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["d" /* getJsonAsync */])('admin/captain/' + captainEmail + '/email')).then(function (response) {
      if (response) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('adminEntryCaptainChangeForm', 'captainFirstName', response.captainFirstName));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('adminEntryCaptainChangeForm', 'captainLastName', response.captainLastName));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["H" /* setIsNewCaptainOnSearch */])(false));
      } else {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('adminEntryCaptainChangeForm', 'captainFirstName', ''));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('adminEntryCaptainChangeForm', 'captainLastName', ''));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["H" /* setIsNewCaptainOnSearch */])(true));
      }
    }).catch(function () {
      __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].error('Error getting captain detail!', 'There was an error getting captain detail.');
    });
  };
};

var handleCoordinatorSave = function handleCoordinatorSave(data) {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var entryId = getState().admin.entryDetail.entryId;
      var request = {
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email
      };

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["e" /* postJsonAsync */])('admin/entry/' + entryId + '/coordinator', request)).then(function (response) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["I" /* hideEntryDetailCoordinatorModal */])());
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Coordinator Updated!', 'Coordinator was updated.');
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["w" /* setEntryDetailCoordinator */])({
          firstName: response.firstName,
          lastName: response.lastName,
          email: response.email
        }));
        resolve();
      }).catch(function () {
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].error('Coordinator Not Updated!', 'There was an error updating the coordinator.');
        resolve();
      });
    });
  };
};

var handleRemoveSquadClick = function handleRemoveSquadClick() {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      var request = {
        entryId: getState().admin.entryDetail.entryId,
        squadId: null
      };

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["g" /* putJsonAsync */])('admin/entry/' + request.entryId + '/squad/change', request)).then(function () {
        dispatch(retrieveEntryDetails(request.entryId));
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Squad Removed!', 'The entry was removed from the squad successfully.');
        resolve();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].error('Squad Not Removed!', 'There was an error removing the squad from the entry.');
        reject(error);
      });
    });
  };
};

var handleEntryDetailCancelEntryClick = function handleEntryDetailCancelEntryClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["J" /* setAdminEntryDetailRefundType */])('refundWithCancellation'));
    dispatch(retrieveCancelEntryWarnings());
    dispatch(displayEntryDetailRefundModal());
  };
};

var displayEntryDetailRefundModal = function displayEntryDetailRefundModal() {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      var entryId = getState().admin.entryDetail.entryId;


      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["K" /* setVisibleEntryDetailRefundModal */])(true));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["d" /* getJsonAsync */])('admin/entry/' + entryId + '/payment/creditLog')).then(function (response) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["L" /* setCreditPurchaseTransactions */])(response.payments));
        resolve();
      }).catch(function (error) {
        return reject(error);
      });
    });
  };
};

var handleEntryDetailRefundCancelClick = function handleEntryDetailRefundCancelClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["K" /* setVisibleEntryDetailRefundModal */])(false));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["reset"])('adminEntryRefundForm'));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_error_actionTypes__["a" /* setErrorList */])([]));
  };
};

var handleEntryDetailRefundSubmitClick = function handleEntryDetailRefundSubmitClick(data) {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var state = getState().admin.entryDetail;
      var showPaymentLog = state.showPaymentLog;
      var entryId = state.entryId;
      var refundType = state.refundType;

      if (data.stripeTransactionId) data.stripeTransactionId = data.stripeTransactionId.trim();

      data = _extends({}, data, {
        refundOnly: refundType === 'refundOnly'
      });

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["e" /* postJsonAsync */])('admin/entry/' + entryId + '/cancel', data)).then(function () {
        if (refundType === 'refundOnly') {
          __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Saved!', 'The refund was successful.');
        } else {
          __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Saved!', 'The cancellation was successful.');
        }
        dispatch(retrieveEntryDetails(entryId));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["K" /* setVisibleEntryDetailRefundModal */])(false));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["reset"])('adminEntryRefundForm'));

        if (showPaymentLog) {
          dispatch(retrievePaymentLog(entryId)).then(function () {
            return resolve();
          });
        } else {
          resolve();
        }
      }).catch(function () {
        return resolve();
      });
    });
  };
};

var handleEntryDetailReactivateEntryClick = function handleEntryDetailReactivateEntryClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["M" /* displayReactivationModal */])(true));
  };
};

var handleReactivationCancel = function handleReactivationCancel() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["M" /* displayReactivationModal */])(false));
  };
};

var handleReactivationChangeSquadDateChanged = function handleReactivationChangeSquadDateChanged(date) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('adminEntryDetailReactivationForm', 'currentSquadDate', date));
    dispatch(updateAvailableSquadsForReactivationDate(date));
  };
};

var updateAvailableSquadsForReactivationDate = function updateAvailableSquadsForReactivationDate(date) {
  return function (dispatch, getState) {
    var entryId = getState().admin.entryDetail.entryId,
        formattedDate = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.parseZone(date).format('YYYY-MM-DD');

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["d" /* getJsonAsync */])('admin/entry/' + entryId + '/squads/' + formattedDate)).then(function (response) {
      var availableSquads = response.map(function (x) {
        return {
          value: x.id,
          label: x.description
        };
      });

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('adminEntryDetailReactivationForm', 'availableSquads', availableSquads));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('adminEntryDetailReactivationForm', 'currentSquadId', availableSquads.length ? availableSquads[0].value : ''));
    }).catch(function () {
      __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].error('Error getting squads!', 'There was an error getting available squad times.');
    });
  };
};

var handleReactivationSave = function handleReactivationSave(data) {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      var entryId = getState().admin.entryDetail.entryId;
      var request = {
        entryId: entryId,
        squadId: data.currentSquadId
      };

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["e" /* postJsonAsync */])('admin/entry/' + request.entryId + '/reactivate', request)).then(function () {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["M" /* displayReactivationModal */])(false));
        dispatch(retrieveEntryDetails(request.entryId));
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Reactivation Saved!', 'The entry was successfully reactivated and added to the squad.');
        resolve();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].error('Reactivation not successful!', 'There was an error reactivating and updating the squad for the entry.');
        reject(error);
      });
    });
  };
};

var handleEntryDetailRefundClick = function handleEntryDetailRefundClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["J" /* setAdminEntryDetailRefundType */])('refundOnly'));
    dispatch(displayEntryDetailRefundModal());
  };
};

var handleEventChangeClick = function handleEventChangeClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["N" /* displayEventChangeModal */])(true));
  };
};

var handleEventChangeCancel = function handleEventChangeCancel() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["N" /* displayEventChangeModal */])(false));
  };
};

var handleEventChangeSave = function handleEventChangeSave(data) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      var request = {
        entryId: data.entryId,
        squadId: data.currentSquadId
      };

      // Note this is the same URL used by handleSquadChangeSave
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["g" /* putJsonAsync */])('admin/entry/' + request.entryId + '/squad/change', request)).then(function () {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actionTypes__["N" /* displayEventChangeModal */])(false));
        dispatch(retrieveEntryDetails(request.entryId));
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Event Changed!', 'The event was changed successfully.');
        resolve();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].error('Event Not Updated!', 'There was an error changing event for the entry.');
        reject(error);
      });
    });
  };
};

/***/ }),
/* 43 */,
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);



var Panel = function Panel(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      title = _ref.title;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('panel', className),
      style: style },
    title ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-heading' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h3',
        { className: 'panel-title' },
        title
      )
    ) : null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-body' },
      children
    )
  );
};

Panel.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,
  className: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  style: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node
};

Panel.defaultProps = {
  className: 'panel-default',
  title: null,
  style: {}
};

/* harmony default export */ __webpack_exports__["a"] = Panel;

/***/ }),
/* 45 */,
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var ResultsNotFound = function ResultsNotFound() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "alert alert-warning text-center" },
    "Sorry, no results were found."
  );
};

/* harmony default export */ __webpack_exports__["a"] = ResultsNotFound;

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_validators__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__entryDetail_actions__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actionTypes__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_error_actionTypes__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_topBanner_actionTypes__ = __webpack_require__(86);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return handleUpdateClicked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return onHideCancelledEntriesChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return onHideArchivedEntriesChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return handleCaptainDetailUpdateCancelClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return handleCaptainDetailUpdateFormSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return handleEntryLinkClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return handleViewEntriesClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return handleChangeEntriesCaptainFormSave; });
/* unused harmony export handleChangeEntryCaptainFormSave */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return handleChangeEntriesCaptainClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return handleEntryChangeCaptainSearchClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return validateEntryCaptainChangeForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return handleEntryChangeCaptainCancelClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return handlePaymentLogClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return handleVirtualEventLinkClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return handleNotesEditClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return handleNotesModalCancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return handleNotesModalSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearPaymentLogs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadCaptainDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadCaptainTournamentEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return handleEntryClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return handleVirtualEventSelectChecked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return handleEntrySelectChecked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return handlePayBalanceClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return handlePayBalanceOtherClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return handlePayBalanceOtherCancelClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return handlePayBalanceOtherAcceptClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return handlePrintConfirmationClick; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










var handleUpdateClicked = function handleUpdateClicked() {
  return function (dispatch, getState) {
    var _getState$admin$capta = getState().admin.captainDetail,
        captainId = _getState$admin$capta.captainId,
        captainFirstName = _getState$admin$capta.captainFirstName,
        captainLastName = _getState$admin$capta.captainLastName;


    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["initialize"])('adminCaptainDetailUpdateForm', {
      captainId: captainId,
      captainFirstName: captainFirstName,
      captainLastName: captainLastName
    }));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["c" /* displayUpdateModal */])(true));
  };
};

var onHideCancelledEntriesChange = function onHideCancelledEntriesChange(hideCancelled) {
  return function (dispatch, getState) {
    var captainId = getState().admin.captainDetail.captainId;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["d" /* changeHideCancelledEntries */])(hideCancelled));
    dispatch(loadCaptainTournamentEntries(captainId));
  };
};
var onHideArchivedEntriesChange = function onHideArchivedEntriesChange(hideArchived) {
  return function (dispatch, getState) {
    var captainId = getState().admin.captainDetail.captainId;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["e" /* changeHideArchivedEntries */])(hideArchived));
    dispatch(loadCaptainTournamentEntries(captainId));
  };
};

var handleCaptainDetailUpdateCancelClick = function handleCaptainDetailUpdateCancelClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["c" /* displayUpdateModal */])(false));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reset"])('adminCaptainDetailUpdateForm'));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_error_actionTypes__["a" /* setErrorList */])([]));
  };
};

var handleCaptainDetailUpdateFormSave = function handleCaptainDetailUpdateFormSave(data) {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var captainId = getState().admin.captainDetail.captainId;
      var request = {
        captainId: captainId,
        firstName: data.captainFirstName,
        lastName: data.captainLastName
      };

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])('admin/captain/update', request)).then(function () {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["c" /* displayUpdateModal */])(false));
        __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Captain Updated!', 'Captain was updated.');
        dispatch(loadCaptainDetails(captainId));
        resolve();
      }).catch(function () {
        __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].error('Captain Not Updated!', 'There was an error updating the captain.');
        resolve();
      });
    });
  };
};

var handleEntryLinkClick = function handleEntryLinkClick(entryId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["b" /* navigateTo */])('admin/entry/' + entryId));
  };
};

var handleViewEntriesClick = function handleViewEntriesClick(paymentId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('admin/payments/' + paymentId + '/entries')).then(function (response) {
      if (response && !response.entries.length && !response.virtualEvents.length) {
        __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].warning('Nothing Found', 'No payment\'s entries found');
        return;
      }
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["f" /* setPaymentEntries */])(response.entries));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["g" /* setPaymentVirtualEvents */])(response.virtualEvents));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["h" /* displayPaymentEntries */])(paymentId));
    }).catch(function () {
      return __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].error('Error', 'An unexpected error was found while getting payment entries');
    });
  };
};

var handleChangeEntriesCaptainFormSave = function handleChangeEntriesCaptainFormSave(data) {
  return function (dispatch, getState) {
    return new Promise(function () {
      var captainDetail = getState().admin.captainDetail;
      var tournament = captainDetail.tournaments.find(function (t) {
        return t.selected;
      });
      var entries = tournament.entries.filter(function (entry) {
        return entry.selected;
      }).map(function (entry) {
        return entry.id;
      });
      var virtualEntries = captainDetail.affectedVirtualEntries.filter(function (entry) {
        return entry.selected;
      }).map(function (entry) {
        return entry.virtualEntryId;
      });

      var entryData = _extends({
        entries: entries
      }, data, {
        captainId: captainDetail.captainId,
        virtualEntries: virtualEntries
      });

      dispatch(handleChangeEntryCaptainFormSave(entryData));
    });
  };
};

var handleChangeEntryCaptainFormSave = function handleChangeEntryCaptainFormSave(data) {
  return function (dispatch) {
    return new Promise(function () {
      var entryId = data.entries.shift();

      var entryData = _extends({}, data, {
        entries: data.entries
      });

      var request = {
        entryId: entryId,
        firstName: data.captainFirstName,
        lastName: data.captainLastName,
        email: data.captainEmail,
        virtualEntryIds: data.virtualEntries
      };

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__entryDetail_actions__["d" /* changeEntryCaptain */])(request)).then(function () {
        if (data.entries.length === 0) {
          dispatch(loadCaptainTournamentEntries(data.captainId));
          dispatch(handleEntryChangeCaptainCancelClick());
        } else {
          // Next Entry 
          dispatch(handleChangeEntryCaptainFormSave(entryData));
        }
      });
    });
  };
};

var handleChangeEntriesCaptainClick = function handleChangeEntriesCaptainClick() {
  return function (dispatch, getState) {
    var captainDetail = getState().admin.captainDetail;
    var tournament = captainDetail.tournaments.find(function (t) {
      return t.selected;
    });
    var entries = tournament.entries.filter(function (entry) {
      return entry.selected;
    }).map(function (entry) {
      return entry.id;
    });

    var virtualEntries = tournament.virtualEvents.filter(function (entry) {
      return entry.selected;
    }).map(function (entry) {
      return entry.id;
    });

    if (virtualEntries.length > 0) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["i" /* setchangeMultipleEntriesErrors */])('Cannot change the captain of virtual entries. ' + 'Click on the virtual entries and change the captain from the virtual entries page. '));
      return;
    }
    if (entries.length == 0) {
      return;
    }
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["i" /* setchangeMultipleEntriesErrors */])(''));
    var request = {
      fromCaptainId: captainDetail.captainId,
      entryIds: entries
    };

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])('admin/captain/affectedvirtualentries', request)).then(function (response) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["b" /* setAffectedVirtualEntries */])(response.virtualEntries));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["j" /* displayEntryDetailChangeCaptainModal */])());
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].error('Error changing the captain!', error.toString());
    });
  };
};

var handleEntryChangeCaptainSearchClick = function handleEntryChangeCaptainSearchClick() {
  return function (dispatch, getState) {
    var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["formValueSelector"])('CaptainEntryChangeCaptainForm');
    var captainEmail = selector(getState(), 'captainEmail');

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('admin/captain/' + captainEmail + '/email')).then(function (response) {
      if (response) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["change"])('CaptainEntryChangeCaptainForm', 'captainFirstName', response.captainFirstName));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["change"])('CaptainEntryChangeCaptainForm', 'captainLastName', response.captainLastName));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["k" /* setIsNewCaptainOnSearch */])(false));
      } else {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["change"])('CaptainEntryChangeCaptainForm', 'captainFirstName', ''));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["change"])('CaptainEntryChangeCaptainForm', 'captainLastName', ''));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["k" /* setIsNewCaptainOnSearch */])(true));
      }
    }).catch(function () {
      __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].error('Error getting captain detail!', 'There was an error getting captain detail.');
    });
  };
};

var validateEntryCaptainChangeForm = function validateEntryCaptainChangeForm(data) {
  var errors = {};

  if (!data.captainEmail || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_validators__["a" /* validateEmail */])(data.captainEmail)) {
    errors.captainEmail = 'Please provide a valid email.';
  }

  if (!data.captainFirstName) {
    errors.captainFirstName = 'Please search for the captain before updating.';
  }

  return errors;
};

var handleEntryChangeCaptainCancelClick = function handleEntryChangeCaptainCancelClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["l" /* hideEntryDetailChangeCaptainModal */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reset"])('CaptainEntryChangeCaptainForm'));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_error_actionTypes__["a" /* setErrorList */])([]));
  };
};

var handlePaymentLogClick = function handlePaymentLogClick() {
  return function (dispatch, getState) {
    var _getState$admin$capta2 = getState().admin.captainDetail,
        captainId = _getState$admin$capta2.captainId,
        payments = _getState$admin$capta2.payments;

    // hide everything by removing data from state

    if (payments.length) {
      dispatch(clearPaymentLogs());
      return;
    }

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('admin/captain/' + captainId + '/payments')).then(function (payments) {
      if (!payments || !payments.length) {
        __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].warning('Nothing Found', 'No captain\'s payments found');
        return;
      }
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["m" /* setPayments */])(payments));
    }).catch(function () {
      return __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].error('Error', 'An unexpected error was found while getting captain payments');
    });
  };
};

var handleVirtualEventLinkClick = function handleVirtualEventLinkClick(virtualEventId) {
  return function (dispatch, getState) {
    var captainId = getState().admin.captainDetail.captainId;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["b" /* navigateTo */])('admin/captain/' + captainId + '/virtualevent/' + virtualEventId));
  };
};

var handleNotesEditClick = function handleNotesEditClick() {
  return function (dispatch, getState) {
    var notes = getState().admin.captainDetail.notes;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["n" /* displayNotesModalVisibility */])(true));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["initialize"])('adminCaptainDetailNotesForm', { notes: notes }));
    setTimeout(function () {
      // focus field after animatation finished (~800ms) by directly accessing the dom
      document.querySelectorAll('.modal-dialog #captainDetailNotesForm [name=notes]')[0].focus();
    }, 800);
  };
};

var handleNotesModalCancel = function handleNotesModalCancel() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["n" /* displayNotesModalVisibility */])(false));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reset"])('adminCaptainDetailNotesForm'));
  };
};

var handleNotesModalSave = function handleNotesModalSave(data) {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      var captainDetailState = getState().admin.captainDetail;
      var captainId = captainDetailState.captainId;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])('admin/captain/' + captainId + '/notes', data)).then(function () {
        __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Saved!', 'Notes were successfully saved.');
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["n" /* displayNotesModalVisibility */])(false));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reset"])('adminCaptainDetailNotesForm'));
        dispatch(loadCaptainDetails(captainId));
        resolve();
      }).catch(function (error) {
        return reject(error);
      });
    });
  };
};

var clearPaymentLogs = function clearPaymentLogs() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["m" /* setPayments */])([]));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["f" /* setPaymentEntries */])([]));
  };
};

var loadCaptainDetails = function loadCaptainDetails(captainId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])('admin/captain/' + captainId)).then(function (captainDetails) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["o" /* setCaptainDetails */])(captainDetails));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_topBanner_actionTypes__["b" /* setTitle */])(captainDetails.captainName + ' (Captain)'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_topBanner_actionTypes__["c" /* setSubTitle */])('' + captainDetails.captainEmail));
    });
  };
};

var loadCaptainTournamentEntries = function loadCaptainTournamentEntries(captainId, paymentId) {
  return function (dispatch, getState) {
    var hideCancelledEntries = getState().admin.captainDetail.hideCancelledEntries;
    var hideArchivedEntries = getState().admin.captainDetail.hideArchivedEntries;

    var url = 'admin/captain/' + captainId + '/entries/filterEntries/' + hideCancelledEntries + '/' + hideArchivedEntries;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])(url)).then(function (response) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["p" /* setCaptainTournamentEntries */])(response.tournaments));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["q" /* setCaptainBalanceDue */])(response.balance));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["r" /* calculateSelectedBalance */])());
      response.tournaments.forEach(function (element) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["s" /* setTournamentCollapsed */])(element.id));
      });
    });

    if (paymentId) {
      dispatch(captainPayment(captainId, paymentId));
    }
  };
};

var captainPayment = function captainPayment(captainId, paymentId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])('admin/captain/payment/credit', {
      BypassWebHooks: localStorage.bypassWebHooks,
      captainId: captainId,
      paymentId: paymentId
    })).then(function (response) {
      if (response) __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Payment Processed!', 'Selected entries were paid successfully.');
      dispatch(loadCaptainTournamentEntries(captainId));
    });

    if (localStorage.bypassWebHooks) delete localStorage.bypassWebHooks;
  };
};

var handleEntryClick = function handleEntryClick(entryId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["b" /* navigateTo */])('admin/entry/' + entryId));
  };
};

var handleVirtualEventSelectChecked = function handleVirtualEventSelectChecked(tournamentId, virtualEventId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["t" /* setVirtualEventSelected */])(tournamentId, virtualEventId));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["u" /* disableOtherTournamentSelection */])(tournamentId));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["r" /* calculateSelectedBalance */])());
  };
};

var handleEntrySelectChecked = function handleEntrySelectChecked(tournamentId, entryId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["v" /* setEntrySelected */])(tournamentId, entryId));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["u" /* disableOtherTournamentSelection */])(tournamentId));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["r" /* calculateSelectedBalance */])());
  };
};

var handlePayBalanceClick = function handlePayBalanceClick() {
  return function (dispatch, getState) {
    var state = getState();
    var captainId = state.admin.captainDetail.captainId;
    var tournament = state.admin.captainDetail.tournaments.find(function (x) {
      return x.selected;
    });
    var entries = tournament.entries.filter(function (entry) {
      return entry.selected;
    }).map(function (entry) {
      return entry.id;
    });
    var virtualEvents = tournament.virtualEvents.filter(function (virtualEvent) {
      return virtualEvent.selected;
    }).map(function (virtualEvent) {
      return virtualEvent.virtualEventId;
    });
    var body = {
      captainId: captainId,
      entries: entries,
      source: 'captainDetail',
      tournamentId: tournament.id,
      virtualEvents: virtualEvents
    };

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])('admin/captain/createSession', body)).then(function (response) {
      var publishableKey = tournament.stripePublishableKey;
      var stripe = window.Stripe(publishableKey);
      var sessionId = response.paymentId;
      var errorMessages = response.messages;

      if (errorMessages && errorMessages.length > 0) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["w" /* setValidationMessages */])(errorMessages));
      } else {
        stripe.redirectToCheckout({
          sessionId: sessionId
        });
      }
    });
  };
};

var handlePayBalanceOtherClick = function handlePayBalanceOtherClick() {
  return function (dispatch, getState) {
    var amount = getState().admin.captainDetail.selectedBalance;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["initialize"])('adminCaptainPaymentForm', {
      amount: amount
    }));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["x" /* displayCaptainDetailPaymentModal */])(true));
  };
};

var handlePayBalanceOtherCancelClick = function handlePayBalanceOtherCancelClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_error_actionTypes__["a" /* setErrorList */])([]));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["x" /* displayCaptainDetailPaymentModal */])(false));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reset"])('adminEntryPaymentForm'));
  };
};

var handlePayBalanceOtherAcceptClick = function handlePayBalanceOtherAcceptClick(data) {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var state = getState().admin.captainDetail;
      var captainId = state.captainId;
      var tournament = state.tournaments.find(function (t) {
        return t.selected;
      });
      var entries = tournament.entries.filter(function (entry) {
        return entry.selected;
      }).map(function (entry) {
        return entry.id;
      });
      var virtualEvents = tournament.virtualEvents.filter(function (virtualEvent) {
        return virtualEvent.selected;
      }).map(function (virtualEvent) {
        return virtualEvent.virtualEventId;
      });

      var body = _extends({}, data, {
        tournamentId: tournament.id,
        captainId: captainId,
        entries: entries,
        virtualEvents: virtualEvents
      });

      if (body.stripeTransactionId) body.stripeTransactionId = body.stripeTransactionId.trim();

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])('admin/captain/payment/other', body)).then(function () {
        __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Saved!', 'Payment was successfully saved.');
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_error_actionTypes__["a" /* setErrorList */])([]));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["x" /* displayCaptainDetailPaymentModal */])(false));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reset"])('adminCaptainPaymentForm'));
        dispatch(loadCaptainTournamentEntries(captainId));
        resolve();
      }).catch(function () {
        return resolve();
      });
    });
  };
};

var handlePrintConfirmationClick = function handlePrintConfirmationClick(paymentId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('admin/payments/' + paymentId + '/printable')).then(function (payload) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["f" /* handlePrint */])(payload));
    });
  };
};

/***/ }),
/* 52 */,
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_error_errorManager__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_actionRosterPosition__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actionTypes__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_actions__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rostercheckout_actionTypes__ = __webpack_require__(441);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleRosterConfirmationCancel", function() { return handleRosterConfirmationCancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleIsProfessionalChange", function() { return handleIsProfessionalChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handlePayBalanceClick", function() { return handlePayBalanceClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleCompletePayBalance", function() { return handleCompletePayBalance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleVirtualEntryPaymentLogClick", function() { return handleVirtualEntryPaymentLogClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handlePaymentLogSelection", function() { return handlePaymentLogSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changePurchasedEntryFormField", function() { return changePurchasedEntryFormField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleCountryChange", function() { return handleCountryChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validate", function() { return validate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleSave", function() { return handleSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleMoveDownClick", function() { return handleMoveDownClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleMoveUpClick", function() { return handleMoveUpClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleSearchEnterKeyPress", function() { return handleSearchEnterKeyPress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleSearchChange", function() { return handleSearchChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleSearch", function() { return handleSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setRosterPositionAverage", function() { return setRosterPositionAverage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "autoSetTeamNameForRosterFromState", function() { return autoSetTeamNameForRosterFromState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleRosterPositionCleared", function() { return handleRosterPositionCleared; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleEntrySelectChecked", function() { return handleEntrySelectChecked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handlePurchaseClick", function() { return handlePurchaseClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateCaptainManageSquadChangeForm", function() { return validateCaptainManageSquadChangeForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleSquadChangeCancel", function() { return handleSquadChangeCancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleSquadChangeSave", function() { return handleSquadChangeSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleSquadDateChanged", function() { return handleSquadDateChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleSquadTimeChanged", function() { return handleSquadTimeChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "retrieveRosterWarnings", function() { return retrieveRosterWarnings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleSquadChangeClick", function() { return handleSquadChangeClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handlePrintEntryClick", function() { return handlePrintEntryClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handlePrintPaymentLogClick", function() { return handlePrintPaymentLogClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleAssignTeamOwnedVirtualEventClick", function() { return handleAssignTeamOwnedVirtualEventClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleAssignChildTeamOwnedVirtualEventClick", function() { return handleAssignChildTeamOwnedVirtualEventClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkForCompleteRosters", function() { return checkForCompleteRosters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleEventChangeClick", function() { return handleEventChangeClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleEventChangeCancel", function() { return handleEventChangeCancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleEventChangeSave", function() { return handleEventChangeSave; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };














var scrollToFirstHighlightedEntry = function scrollToFirstHighlightedEntry() {
  var elementToScroll = document.querySelectorAll('.list-group-item-labeled.highlight');

  if (elementToScroll && elementToScroll.length) {
    setTimeout(function () {
      elementToScroll[0].scrollIntoView();
    }, 900); // execute scrolling after a period of time to allow rendering to execute other prior animations
  }
};

var handleRosterConfirmationCancel = function handleRosterConfirmationCancel() {
  return function (dispatch, getState) {
    var state = getState();
    var _state$registration$m = state.registration.manage,
        rosterConfirmationNextAction = _state$registration$m.rosterConfirmationNextAction,
        rosterConfirmationNextActionArgs = _state$registration$m.rosterConfirmationNextActionArgs;


    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["reset"])('entryForm'));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["u" /* cancelPurchasedEntryForm */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["r" /* setRosterConfirmationVisibility */])(false));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["E" /* resetTeamOwnedVirtualEntryEventAssignment */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_actions__["b" /* retrieveUserVirtualEntries */])(state.registration.base.tournamentId));
    if (rosterConfirmationNextAction && rosterConfirmationNextActionArgs) dispatch(__WEBPACK_IMPORTED_MODULE_9__actions__[rosterConfirmationNextAction](rosterConfirmationNextActionArgs)); // eslint-disable-line import/namespace
    scrollToFirstHighlightedEntry();
  };
};

var handleIsProfessionalChange = function handleIsProfessionalChange(position, value) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["_3" /* setIsProfessional */])(position, value));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('entryForm', 'isProfessional-' + position, value));
  };
};

var handlePayBalanceClick = function handlePayBalanceClick() {
  return function (dispatch, getState) {
    // prevent user to loose changes while editing an entry
    if (dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_actions__["e" /* hasPendingRosterChanges */])(handlePayBalanceClick.name))) {
      return;
    }

    var state = getState(),
        tournamentId = state.registration.base.tournamentId,
        tournamentStripeKey = state.registration.base.tournamentStripeKey,
        entries = state.registration.shared.entries.filter(function (entry) {
      return entry.selected;
    }).map(function (entry) {
      return entry.id;
    }),
        virtualEvents = state.registration.shared.virtualEntries.filter(function (virtualEvent) {
      return virtualEvent.selected;
    }).map(function (virtualEvent) {
      return virtualEvent.virtualEventId;
    }),
        teamOwnedVirtualEvents = state.registration.shared.teamOwnedVirtualEntriesAvailable.filter(function (teamOwnedVirtualEntries) {
      return teamOwnedVirtualEntries.selected;
    }).map(function (teamOwnedVirtualEvent) {
      return teamOwnedVirtualEvent.virtualEventId;
    });

    var body = {
      tournamentId: tournamentId,
      entries: entries,
      virtualEvents: virtualEvents,
      teamOwnedVirtualEvents: teamOwnedVirtualEvents,
      source: 'captainBalance'
    };

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_actions__["e" /* postJsonAsync */])('registration/payment/createSession', body)).then(function (response) {
      var publishableKey = tournamentStripeKey;
      var stripe = window.Stripe(publishableKey);
      var sessionId = response.paymentId;

      stripe.redirectToCheckout({
        sessionId: sessionId
      });
    });
  };
};

var handleCompletePayBalance = function handleCompletePayBalance(tournamentId, paymentData) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_actions__["e" /* postJsonAsync */])('registration/payment/balance', {
      BypassWebHooks: paymentData.BypassWebHooks,
      PaymentId: paymentData.PaymentId
    })).then(function (response) {
      if (response) __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Payment Processed!', 'Selected entries were paid successfully.');
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_actions__["a" /* retrieveEntries */])(tournamentId));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_actions__["b" /* retrieveUserVirtualEntries */])(tournamentId));
    });

    if (localStorage.bypassWebHooks) delete localStorage.bypassWebHooks;
  };
};

var handleVirtualEntryPaymentLogClick = function handleVirtualEntryPaymentLogClick(virtualEventId) {
  return function (dispatch) {
    // prevent user to loose changes while editing an entry
    if (dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_actions__["e" /* hasPendingRosterChanges */])(handleVirtualEntryPaymentLogClick.name, virtualEventId))) {
      return;
    }

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_actions__["d" /* getJsonAsync */])('registration/virtualevent/' + virtualEventId + '/payment/log')).then(function (paymentLog) {
      // close other panels
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["t" /* cancelEntryDetails */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["u" /* cancelPurchasedEntryForm */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["g" /* closeVirtualEntryEditing */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["e" /* cancelEntryPaymentLogHistory */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["b" /* setPaymentLogHistory */])(paymentLog));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["_4" /* displayVirtualEventPaymentLog */])(virtualEventId));
    });
  };
};

var handlePaymentLogSelection = function handlePaymentLogSelection(entryId) {
  return function (dispatch) {
    // prevent user to loose changes while editing an entry
    if (dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_actions__["e" /* hasPendingRosterChanges */])(handlePaymentLogSelection.name, entryId))) {
      return;
    }

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_actions__["d" /* getJsonAsync */])('registration/entry/' + entryId + '/payment/log')).then(function (paymentLog) {
      // close other panels
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["t" /* cancelEntryDetails */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["u" /* cancelPurchasedEntryForm */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["g" /* closeVirtualEntryEditing */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["f" /* cancelVirtualEventPaymentLogHistory */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["b" /* setPaymentLogHistory */])(paymentLog));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["_5" /* displayPaymentLogHistory */])(entryId));
    });
  };
};

var changePurchasedEntryFormField = function changePurchasedEntryFormField(field, value) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('entryForm', field, value);
};

var handleCountryChange = function handleCountryChange(value) {
  return function (dispatch, getState) {
    var countries = getState().registration.shared.countries,
        selectedCountry = countries.find(function (x) {
      return x.value === value;
    }),
        entryId = getState().form.entryForm.values.id,
        disableEntryState = !selectedCountry || !selectedCountry.label || selectedCountry.label !== 'United States';

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["q" /* setEntryStateDisabled */])(entryId, disableEntryState));
    if (disableEntryState) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('entryForm', 'state', null));
    }
  };
};

var validate = function validate(data) {
  var errors = {};

  if (!data.name) {
    errors.name = 'We need to be able to identify your team.';
  }
  return errors;
};

var handleSave = function handleSave(data) {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var _getState$registratio = getState().registration,
          base = _getState$registratio.base,
          shared = _getState$registratio.shared;
      // Make sure we don't save if there are modifications in the user ID 

      var rosterPositions = shared.rosterPositions;
      var hasRosterPositionChanged = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_actionRosterPosition__["a" /* rostersHasUserIdModifications */])(rosterPositions);

      if (hasRosterPositionChanged) {
        resolve();
        return;
      }

      var editingEntry = shared.entries.find(function (x) {
        return x.editing;
      });
      var persistedParents = shared.parentTeamOwnedVirtualEntries.filter(function (x) {
        return x.id.length === 36;
      });
      var persistedChildren = shared.childTeamOwnedVirtualEntries.filter(function (x) {
        return x.id.length === 36;
      });
      var virtualEntries = persistedParents.concat(persistedChildren);
      var assignedCartParents = shared.parentTeamOwnedVirtualEntries.filter(function (x) {
        return x.id.length !== 36 && x.teamEntryId === editingEntry.id;
      });
      var assignedCartChildren = shared.childTeamOwnedVirtualEntries.filter(function (x) {
        return x.id.length !== 36 && x.teamEntryId === editingEntry.id;
      });
      var cartRosterIds = shared.parentTeamOwnedVirtualEntries.filter(function (x) {
        return x.id.length !== 36 && x.teamEntryId == null && x.cartRosterId !== undefined;
      }).map(function (x) {
        return x.cartRosterId;
      }).concat(shared.childTeamOwnedVirtualEntries.filter(function (x) {
        return x.id.length !== 36 && x.teamEntryId == null && x.cartRosterId !== undefined;
      }).map(function (x) {
        return x.cartRosterId;
      }));

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_actions__["g" /* putJsonAsync */])('registration/entry/' + data.id, {
        rosterPositions: rosterPositions,
        name: data.name,
        state: data.state,
        countryId: data.countryId,
        pairCode: data.pairCode,
        groupCode: data.groupCode
      }, false)).then(function () {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_actions__["g" /* putJsonAsync */])('virtualevent/teams', {
          virtualEntries: virtualEntries
        })).then(function () {
          cartRosterIds.forEach(function (cartRoster) {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_actions__["i" /* deleteJsonAsync */])('registration/cartroster', {
              id: cartRoster
            }));
          });
          if (assignedCartParents.length > 0 || assignedCartChildren.length > 0) {
            var assignedVirtualEntries = assignedCartParents.map(function (item) {
              return { virtualEventId: item.virtualEventId, teamEntryId: item.teamEntryId, id: item.id };
            }).concat(assignedCartChildren.map(function (item) {
              return {
                virtualEventId: item.virtualEventId,
                teamEntryId: item.teamEntryId,
                id: item.id
              };
            }));
            var rosterData = {
              virtualEntries: assignedVirtualEntries
            };

            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_actions__["e" /* postJsonAsync */])('registration/cartroster', {
              id: null,
              tournamentId: base.tournamentId,
              rosterType: "Virtual Entry",
              rosterData: JSON.stringify(rosterData)
            })).then(function (response) {
              var cartRosterId = response.id;

              dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["_6" /* setCartRosterOnEditingEntry */])(cartRosterId));
              dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["_7" /* setCartRosterOnCartVirtualEntries */])(assignedVirtualEntries, cartRosterId));
            });
          }

          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["r" /* setRosterConfirmationVisibility */])(false));
          __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Saved!', 'Entry information successfully saved.');
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_actions__["a" /* retrieveEntries */])(base.tournamentId)).then(function () {
            if (shared.rosterConfirmationNextAction && shared.rosterConfirmationNextActionArgs) {
              dispatch(__WEBPACK_IMPORTED_MODULE_9__actions__[shared.rosterConfirmationNextAction](shared.rosterConfirmationNextActionArgs)); // eslint-disable-line import/namespace
              scrollToFirstHighlightedEntry();
            }
            dispatch(checkForCompleteRosters());
          });
          resolve();
        });
      }).catch(function (error) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["r" /* setRosterConfirmationVisibility */])(false));

        if (!Array.isArray(error)) {
          error = [error.message];
        }

        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_error_errorManager__["b" /* displayErrorList */])(error));

        resolve();
      });
    });
  };
};

var handleMoveDownClick = function handleMoveDownClick(index) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["_8" /* moveRosterDown */])(index));
    dispatch(moveUp(index));
  };
};

var handleMoveUpClick = function handleMoveUpClick(index) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["_9" /* moveRosterUp */])(index));
    dispatch(moveUp(index - 1));
  };
};

var moveUp = function moveUp(index) {
  return function (dispatch, getState) {
    var formValues = getState().form.entryForm.values;

    var average1 = formValues['average-' + (index + 1)];
    var average2 = formValues['average-' + (index + 2)];

    if (!average1) average1 = '';
    if (!average2) average2 = '';

    // swap averages in form data because of redux-form is handling those fields
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('entryForm', 'average-' + (index + 1), average2));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('entryForm', 'average-' + (index + 2), average1));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('entryForm', 'usbcId-' + (index + 1), formValues['usbcId-' + (index + 2)]));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('entryForm', 'usbcId-' + (index + 2), formValues['usbcId-' + (index + 1)]));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('entryForm', 'isProfessional-' + (index + 1), formValues['isProfessional-' + (index + 2)]));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('entryForm', 'isProfessional-' + (index + 2), formValues['isProfessional-' + (index + 1)]));
    dispatch(autoSetTeamNameForRosterFromState());
  };
};

var handleSearchEnterKeyPress = function handleSearchEnterKeyPress(roster, event) {
  return function (dispatch) {
    if (event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation();
      dispatch(handleSearch(roster));
    }
  };
};

var handleSearchChange = function handleSearchChange(roster, event) {
  return function (dispatch) {
    roster._searchValue = event.target.value.trim();
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["_10" /* setMemberSearchField */])(roster));
  };
};

var handleSearch = function handleSearch(rosterPosition) {
  return function (dispatch, getState) {
    var state = getState();
    var tournamentId = state.registration.base.tournamentId;
    var entry = state.registration.shared.entries.find(function (x) {
      return x.editing;
    });

    // do nothing if usbc search field is empty
    if (!rosterPosition._searchValue) {
      return false;
    }

    if (!entry) {
      entry = state.registration.shared.cartEntries.find(function (x) {
        return x.editing;
      });
    }
    var eventId = entry && entry.eventId ? entry.eventId : null;
    var squadId = entry.squadId;

    // UC33 Add Item to Cart
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["_11" /* searchingStarts */])(rosterPosition));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_actions__["d" /* getJsonAsync */])('registration/entry/' + tournamentId + '/member/' + rosterPosition._searchValue + '/event/' + eventId + '/squad/' + squadId)).then(function (bowler) {
      var updatedRosterPosition = _extends({}, rosterPosition, {
        bowler: bowler.error ? {} : bowler,
        usbcId: rosterPosition._searchValue,
        _errorMessage: bowler.error ? bowler.error.Message : null
      });

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["_12" /* updateRosterInfo */])(updatedRosterPosition));
      dispatch(setRosterPositionAverage(updatedRosterPosition));
      dispatch(autoSetTeamNameForRosterFromState());
      dispatch(retrieveRosterWarnings());

      // set information in redux-form state to track changes
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('entryForm', 'average-' + rosterPosition.position, bowler.average));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('entryForm', 'usbcId-' + rosterPosition.position, bowler.usbcId));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('entryForm', 'isProfessional-' + rosterPosition.position, bowler.isProfessional));
    }).finally(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["_13" /* searchingFinished */])());
    });
  };
};

var setRosterPositionAverage = function setRosterPositionAverage(rosterPosition) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('entryForm', 'average-' + rosterPosition.position, rosterPosition.bowler.average));
  };
};

var autoSetTeamNameForRosterFromState = function autoSetTeamNameForRosterFromState() {
  return function (dispatch, getState) {
    var state = getState(),
        rosterPositions = state.registration.shared.rosterPositions,
        rosterPositionsQty = rosterPositions.length;

    // singles
    if (rosterPositionsQty === 1) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('entryForm', 'name', rosterPositions[0].bowler.firstName + ' ' + rosterPositions[0].bowler.lastName));

      // doubles
    } else if (rosterPositionsQty === 2) {
      var teamNameA = rosterPositions[0].bowler && rosterPositions[0].bowler.lastName ? rosterPositions[0].bowler.lastName : '';
      var teamNameB = rosterPositions[1].bowler && rosterPositions[1].bowler.lastName ? rosterPositions[1].bowler.lastName : '';

      if (teamNameA || teamNameB) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('entryForm', 'name', '' + teamNameA + (teamNameA && teamNameB ? '/' : '') + teamNameB));
      } else {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('entryForm', 'name', 'No Team Name'));
      }
    }
  };
};

var handleRosterPositionCleared = function handleRosterPositionCleared(index) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["_14" /* clearRosterPosition */])(index));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('entryForm', 'average-' + (index + 1), ""));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('entryForm', 'usbcId-' + (index + 1), null));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('entryForm', 'isProfessional-' + (index + 1), false));
    dispatch(autoSetTeamNameForRosterFromState());
    dispatch(retrieveRosterWarnings());
  };
};

var handleEntrySelectChecked = function handleEntrySelectChecked(entryId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["_15" /* setEntrySelectedEntry */])(entryId));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["S" /* calculateBalanceDue */])());
  };
};

var handlePurchaseClick = function handlePurchaseClick() {
  return function (dispatch, getState) {
    // prevent user from losing changes while editing an entry
    if (dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_actions__["e" /* hasPendingRosterChanges */])(handlePurchaseClick.name))) {
      return;
    }

    var tournamentId = getState().registration.base.tournamentId;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_actions__["b" /* navigateTo */])('registration/schedule/' + tournamentId));
  };
};

var validateCaptainManageSquadChangeForm = function validateCaptainManageSquadChangeForm(data) {
  var errors = {};
  var childSquadsAvailable = [];
  var childSquads = [];

  if (!data.parentSquadId) {
    errors.parentSquadId = 'Squad time is required';
  }

  if (data.childrenEntries && data.childrenEntries.length) {
    errors.childrenEntries = [];
    childSquadsAvailable = data.childAvailableSquads.slice();
    childSquads = data.childrenEntries.map(function (x) {
      return x.squadId;
    }).slice();
    data.childrenEntries.forEach(function (value, index) {
      if (!value.squadId) {
        errors.childrenEntries[index] = {};
        errors.childrenEntries[index].squadId = 'Squad time is required';
        return;
      }

      var currentSquad = childSquadsAvailable.find(function (x) {
        return x.value == value.squadId;
      });
      var existingSquads = childSquads.filter(function (x) {
        return x == value.squadId;
      });

      if (currentSquad && (currentSquad.quantity == 0 || currentSquad.quantity < existingSquads.length)) {
        errors.childrenEntries[index] = {};
        errors.childrenEntries[index].squadId = 'There are not enough available slots to move all the Doubles/Singles to the squad requested. Please select another squad for your Doubles/Singles';
      }
    });
  }

  return errors;
};

var handleSquadChangeCancel = function handleSquadChangeCancel() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["c" /* displaySquadChangeModal */])(false));
  };
};

var handleSquadChangeSave = function handleSquadChangeSave(formData) {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var payload = {
        entryId: formData.entryId,
        squadId: formData.parentSquadId,
        childrenEntries: formData.childrenEntries
      };

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_actions__["g" /* putJsonAsync */])('registration/entry/' + formData.entryId + '/squad/change', payload)).then(function () {
        var tournamentId = getState().registration.base.tournamentId;

        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_actions__["a" /* retrieveEntries */])(tournamentId));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["c" /* displaySquadChangeModal */])(false));
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Squad Changed!', 'The squad was changed successfully.');
        resolve();
      }).catch(function () {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["c" /* displaySquadChangeModal */])(false));
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].error('Squad Not Updated!', 'There was an error changing squad for the entry.');
        resolve();
      });
    });
  };
};

var handleSquadDateChanged = function handleSquadDateChanged(entryId, date) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('captainManageSquadChangeForm', 'currentSquadDate', date));
      dispatch(getAvailableSquadsForDate(entryId, date, null, true)).then(function (response) {
        return resolve(response);
      });
    });
  };
};

var handleSquadTimeChanged = function handleSquadTimeChanged(entryId, parentSquadId) {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])('captainManageSquadChangeForm');
      var date = selector(getState(), 'parentSquadDateTime');
      dispatch(getAvailableSquadsForDate(entryId, date, parentSquadId, true)).then(function (response) {
        return resolve(response);
      });
    });
  };
};

var getAvailableSquadsForDate = function getAvailableSquadsForDate(entryId, squadDate, parentSquadId) {
  var resetChildren = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return function (dispatch) {
    return new Promise(function (resolve) {
      if (!squadDate) {
        return;
      } // don't do anything if the date is empty

      var formattedDate = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.parseZone(squadDate).format('YYYY-MM-DD');
      var now = Date();

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_actions__["d" /* getJsonAsync */])('registration/entry/' + entryId + '/squads/' + formattedDate + '/id/' + parentSquadId)).then(function (response) {
        var parentAvailableSquads = response.parentAvailableSquads.map(function (x) {
          return { value: x.id, label: x.description };
        }),
            childAvailableSquads = response.childAvailableSquads.map(function (x) {
          return { value: x.id, label: x.description, quantity: x.quantity };
        });

        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('captainManageSquadChangeForm', 'childSquadDateTime', response.childSquadDateTime));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('captainManageSquadChangeForm', 'childEventName', response.childEventName));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('captainManageSquadChangeForm', 'childAvailableSquads', childAvailableSquads));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('captainManageSquadChangeForm', 'entryId', response.entryId));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('captainManageSquadChangeForm', 'isBundledChild', response.isBundledChild));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('captainManageSquadChangeForm', 'parentAvailableSquads', parentAvailableSquads));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('captainManageSquadChangeForm', 'parentEventName', response.parentEventName));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('captainManageSquadChangeForm', 'parentSquadDateTime', formattedDate));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('captainManageSquadChangeForm', 'startDate', now > response.tournamentStartDate ? now : response.tournamentStartDate));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('captainManageSquadChangeForm', 'endDate', response.tournamentEndDate));

        if (parentSquadId) {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('captainManageSquadChangeForm', 'parentSquadId', parentAvailableSquads.length ? parentAvailableSquads.find(function (x) {
            return x.value === parentSquadId;
          }).value : null));
        } else {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('captainManageSquadChangeForm', 'parentSquadId', parentAvailableSquads.length ? parentAvailableSquads[0].value : null));
        }

        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["arrayRemoveAll"])('captainManageSquadChangeForm', 'childrenEntries'));
        response.childrenEntries.forEach(function (value, index) {
          if (resetChildren) {
            // reset each child's squad ID to a new one - this is a MUST since the children must travel with the parent
            value.squadId = childAvailableSquads.length ? childAvailableSquads[0].value : null;
          }
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["arrayInsert"])('captainManageSquadChangeForm', 'childrenEntries', index, value));
        });

        resolve(response);
      }).catch(function () {
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].error('Error getting squads!', 'There was an error getting available squad times.');
        resolve();
      });
    });
  };
};

var retrieveRosterWarnings = function retrieveRosterWarnings() {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var state = getState().registration.shared;
      var rosterPositions = state.rosterPositions;
      var entry = state.entries.find(function (x) {
        return x.editing;
      });

      // We don't verify during checkout of new entries. 
      // if (!entry) entry = state.cartEntries.find(x => x.editing);
      if (!entry) return;

      // create payload using form data and roster positions from state
      var payload = {
        rosterPositions: rosterPositions
      };

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_actions__["e" /* postJsonAsync */])('registration/entry/' + entry.id + '/verify', payload)).then(function (response) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["a" /* setCaptRosterWarnings */])(response.virtualEntriesToModify));
        resolve();
      }).catch(function () {
        return resolve();
      });
    });
  };
};

var handleSquadChangeClick = function handleSquadChangeClick(entryId, squadDateTime) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["initialize"])('captainManageSquadChangeForm'));
      dispatch(getAvailableSquadsForDate(entryId, squadDateTime, null, true)).then(function (response) {
        return resolve(response);
      }).then(function () {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["c" /* displaySquadChangeModal */])(true));
      });
    });
  };
};

var handlePrintEntryClick = function handlePrintEntryClick(entryId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_actions__["d" /* getJsonAsync */])('registration/entry/' + entryId + '/printable')).then(function (payload) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_actions__["f" /* handlePrint */])(payload));
    });
  };
};

var handlePrintPaymentLogClick = function handlePrintPaymentLogClick(entryId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_actions__["d" /* getJsonAsync */])('registration/entry/' + entryId + '/paymentLogPrintable')).then(function (payload) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_actions__["f" /* handlePrint */])(payload));
    });
  };
};

var handleAssignTeamOwnedVirtualEventClick = function handleAssignTeamOwnedVirtualEventClick(virtualEventName, teamEntryId, value) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["n" /* assignTeamOwnedVirtualEntry */])(virtualEventName, teamEntryId, value));
  };
};

var handleAssignChildTeamOwnedVirtualEventClick = function handleAssignChildTeamOwnedVirtualEventClick(virtualEventName, parentTeamEntryId, rosterPosition, value) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_actionTypes__["p" /* assignChildTeamOwnedVirtualEntry */])(virtualEventName, parentTeamEntryId, rosterPosition, value));
  };
};

var checkForCompleteRosters = function checkForCompleteRosters() {
  return function (dispatch, getState) {
    var shared = getState().registration.shared;
    var entriesComplete = shared.cartEntries.every(function (x) {
      return x.rosterComplete;
    });
    var virtualEntriesComplete = shared.cartVirtualEntries.every(function (x) {
      return x.rosterComplete;
    });
    var teamOwnedVirtualEntriesComplete = shared.parentVirtualEntryEvents.every(function (x) {
      return x.remaining === 0;
    }) && shared.childVirtualEntryEvents.every(function (x) {
      return x.remaining === 0;
    });

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__rostercheckout_actionTypes__["b" /* setRostersComplete */])(entriesComplete && virtualEntriesComplete && teamOwnedVirtualEntriesComplete));
  };
};

var handleEventChangeClick = function handleEventChangeClick(entryId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["initialize"])('captainManageEventChangeForm'));
    dispatch(retrieveAvailableEvents(entryId)).then(function () {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["d" /* displayEventChangeModal */])(true));
    });
  };
};

var retrieveAvailableEvents = function retrieveAvailableEvents(entryId) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_actions__["d" /* getJsonAsync */])('registration/entry/' + entryId + '/availableEvents')).then(function (response) {
        var availableEvents = response.availableEvents.map(function (x) {
          return { value: x.id, label: x.description };
        });

        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('captainManageEventChangeForm', 'availableEvents', availableEvents));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('captainManageEventChangeForm', 'currentEventName', response.currentEventName));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('captainManageEventChangeForm', 'entryId', entryId));
        resolve(response);
      }).catch(function () {
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].error('Error getting events!', 'There was an error getting available events.');
        resolve();
      });
    });
  };
};

var handleEventChangeCancel = function handleEventChangeCancel() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["d" /* displayEventChangeModal */])(false));
  };
};

var handleEventChangeSave = function handleEventChangeSave(formData) {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var payload = {
        entryId: formData.entryId,
        squadId: formData.parentSquadId,
        childrenEntries: formData.childrenEntries
      };

      // Note this is the same URL used by handleSquadChangeSave
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_actions__["g" /* putJsonAsync */])('registration/entry/' + formData.entryId + '/squad/change', payload)).then(function () {
        var tournamentId = getState().registration.base.tournamentId;

        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_actions__["a" /* retrieveEntries */])(tournamentId));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["d" /* displayEventChangeModal */])(false));
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Event Changed!', 'The event was changed successfully.');
        resolve();
      }).catch(function () {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["d" /* displayEventChangeModal */])(false));
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].error('Event Not Updated!', 'There was an error changing event for the entry.');
        resolve();
      });
    });
  };
};

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_auth_actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_navigationBar_actionTypes__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actionTypes__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tournamentList_actions__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__general_actions__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__communications_actions__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__permissions_actions__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__events_actions__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__squads_actions__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__divisions_actions__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__capacity_actions__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fees_actions__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__restrictions_bundles_actions__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__status_actions__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__status_actionTypes__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__restrictions_actions__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_scroll__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_scroll__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return handleRouteLeave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleSetupHomeRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleSetupCreateRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleSetupUpdateRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handleUpdateCommunicationRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handleSetupPermissionsRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return handleSetupEventsRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return handleSetupSquadsRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return handleSetupDivisionsRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return handleSetupCapacityRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return handleSetupFeesRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return handleSetupRestrictionsRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return handleSetupStatusRouteEnter; });
/* unused harmony export setNavigationActions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return loadTournament; });
/* harmony export (immutable) */ __webpack_exports__["o"] = scrollToFirstError;





















var handleRouteLeave = function handleRouteLeave() {
  return function (dispatch) {
    if (!window.location.pathname.startsWith('/tournament/update')) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_navigationBar_actionTypes__["a" /* hideNavigation */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["b" /* setTitle */])(''));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["c" /* setSubTitle */])(''));
    }
  };
};

var handleSetupHomeRouteEnter = function handleSetupHomeRouteEnter(nextState, replace, callback) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tournamentList_actions__["a" /* retrieveTournaments */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tournamentList_actions__["b" /* retrieveCreateTournamentPermission */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["b" /* setTitle */])('All Tournaments'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tournamentList_actions__["c" /* retrieveGroupName */])());
    }).catch(function () {});
  };
};

var handleSetupCreateRouteEnter = function handleSetupCreateRouteEnter(nextState, replace, callback) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["b" /* setTitle */])('Create New Tournament'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__general_actions__["a" /* retrieveCards */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__general_actions__["b" /* retrieveDataExportOptions */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__general_actions__["c" /* retrieveStripeAccounts */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__general_actions__["d" /* retrieveTags */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__general_actions__["e" /* retrieveThemes */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__general_actions__["f" /* retrieveTimeZones */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__general_actions__["g" /* clearPreviousSessionVariables */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tournamentList_actions__["c" /* retrieveGroupName */])());
    }).catch(function () {});
  };
};

var handleSetupUpdateRouteEnter = function handleSetupUpdateRouteEnter(nextState, replace, callback) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      var tournamentId = nextState.params.tournamentId;

      dispatch(setNavigationActions('general', tournamentId));
      dispatch(loadTournament(tournamentId)).then(function (data) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__general_actions__["h" /* setupTournamentForm */])());
        dispatch(setTournamentSubtitle());
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__general_actions__["i" /* retrieveSelectedCard */])(data.cardId));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__general_actions__["j" /* retrieveSelectedExportOption */])(data.exportId));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__general_actions__["k" /* retrieveSelectedStripeAccount */])(data.stripeAccountId));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tournamentList_actions__["c" /* retrieveGroupName */])());
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__general_actions__["a" /* retrieveCards */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__general_actions__["b" /* retrieveDataExportOptions */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__general_actions__["l" /* retrieveLocations */])(tournamentId));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__general_actions__["c" /* retrieveStripeAccounts */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__general_actions__["d" /* retrieveTags */])(tournamentId));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__general_actions__["e" /* retrieveThemes */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__general_actions__["f" /* retrieveTimeZones */])());
    }).catch(function () {});
  };
};

var handleUpdateCommunicationRouteEnter = function handleUpdateCommunicationRouteEnter(nextState, replace, callback) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      var tournamentId = nextState.params.tournamentId;

      dispatch(setNavigationActions('communication', tournamentId));
      dispatch(loadTournament(tournamentId)).then(function () {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__communications_actions__["a" /* setupTournamentComForm */])());
        dispatch(setTournamentSubtitle());
      });
    }).catch(function () {});
  };
};

var handleSetupPermissionsRouteEnter = function handleSetupPermissionsRouteEnter(nextState, replace, callback) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      var tournamentId = nextState.params.tournamentId;

      dispatch(setNavigationActions('permissions', tournamentId));
      dispatch(loadTournament(tournamentId)).then(function () {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__permissions_actions__["a" /* setupTournamentPermissionsForm */])());
        dispatch(setTournamentSubtitle());
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__permissions_actions__["b" /* retrieveManagers */])(tournamentId));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__permissions_actions__["c" /* retrieveAdministrators */])(tournamentId));
    }).catch(function () {});
  };
};

var handleSetupEventsRouteEnter = function handleSetupEventsRouteEnter(nextState, replace, callback) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      var tournamentId = nextState.params.tournamentId;

      dispatch(setNavigationActions('events', tournamentId));
      dispatch(loadTournament(tournamentId)).then(function () {
        dispatch(setTournamentSubtitle());
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__events_actions__["a" /* retrieveEvents */])(tournamentId));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__events_actions__["b" /* retrieveVirtualEvents */])(tournamentId));
    }).catch(function () {});
  };
};

var handleSetupSquadsRouteEnter = function handleSetupSquadsRouteEnter(nextState, replace, callback) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      var tournamentId = nextState.params.tournamentId;

      dispatch(setNavigationActions('squads', tournamentId));
      dispatch(loadTournament(tournamentId)).then(function () {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__squads_actions__["a" /* loadSquadCalendar */])(tournamentId));
        dispatch(setTournamentSubtitle());
      });
    }).catch(function () {});
  };
};

var handleSetupDivisionsRouteEnter = function handleSetupDivisionsRouteEnter(nextState, replace, callback) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      var tournamentId = nextState.params.tournamentId;

      dispatch(setNavigationActions('divisions', tournamentId));
      dispatch(loadTournament(tournamentId)).then(function () {
        dispatch(setTournamentSubtitle());
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__divisions_actions__["a" /* retrieveDivisionsEvents */])(tournamentId));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__divisions_actions__["b" /* retrieveDivisionVirtualEvents */])(tournamentId));
    }).catch(function () {});
  };
};

var handleSetupCapacityRouteEnter = function handleSetupCapacityRouteEnter(nextState, replace, callback) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      var tournamentId = nextState.params.tournamentId;

      dispatch(setNavigationActions('capacity', tournamentId));
      dispatch(loadTournament(tournamentId)).then(function () {
        dispatch(setTournamentSubtitle());
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__capacity_actions__["a" /* retrieveSquadsByTournament */])(tournamentId));
    }).catch(function () {});
  };
};

var handleSetupFeesRouteEnter = function handleSetupFeesRouteEnter(nextState, replace, callback) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      var tournamentId = nextState.params.tournamentId;

      dispatch(setNavigationActions('fees', tournamentId));
      dispatch(loadTournament(tournamentId)).then(function () {
        dispatch(setTournamentSubtitle());
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__fees_actions__["a" /* retrieveActiveFees */])(tournamentId));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__fees_actions__["b" /* retrieveInactiveFees */])(tournamentId));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__fees_actions__["c" /* retrieveEventTypes */])(tournamentId));
    }).catch(function () {});
  };
};

var handleSetupRestrictionsRouteEnter = function handleSetupRestrictionsRouteEnter(nextState, replace, callback) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      var tournamentId = nextState.params.tournamentId;

      dispatch(setNavigationActions('restrictions', tournamentId));
      dispatch(loadTournament(tournamentId)).then(function () {
        dispatch(setTournamentSubtitle());
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__restrictions_actions__["a" /* retrieveRestriction */])(tournamentId));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__restrictions_bundles_actions__["a" /* retrieveActiveBundles */])(tournamentId));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__restrictions_bundles_actions__["b" /* retrieveBundlingRuleEvents */])(tournamentId));
    }).catch(function () {});
  };
};

var handleSetupStatusRouteEnter = function handleSetupStatusRouteEnter(nextState, replace, callback) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      var tournamentId = nextState.params.tournamentId;

      dispatch(setNavigationActions('status', tournamentId));
      dispatch(loadTournament(tournamentId)).then(function (data) {
        dispatch(setTournamentSubtitle());
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__status_actions__["a" /* retrieveExportSystemName */])());
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__status_actions__["b" /* setExportStatusData */])(data));
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__status_actions__["c" /* retrieveAvailableStatuses */])());
    }).catch(function () {});
  };
};

var setNavigationActions = function setNavigationActions(active, tournamentId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_navigationBar_actionTypes__["b" /* displayNavigation */])([{
      key: 'tournamentList',
      to: 'tournament',
      navOrigin: true
    }, {
      key: 'general',
      label: 'General',
      active: true,
      to: 'tournament/update/' + tournamentId
    }, {
      key: 'communication',
      label: 'Communication',
      to: 'tournament/update/' + tournamentId + '/communication'
    }, {
      key: 'permissions',
      label: 'Permissions',
      to: 'tournament/update/' + tournamentId + '/permissions'
    }, {
      key: 'events',
      label: 'Events',
      to: 'tournament/update/' + tournamentId + '/events'
    }, {
      key: 'squads',
      label: 'Squads',
      to: 'tournament/update/' + tournamentId + '/squads'
    }, {
      key: 'divisions',
      label: 'Divisions',
      to: 'tournament/update/' + tournamentId + '/divisions'
    }, {
      key: 'capacity',
      label: 'Capacity',
      to: 'tournament/update/' + tournamentId + '/capacity'
    }, {
      key: 'fees',
      label: 'Fees',
      to: 'tournament/update/' + tournamentId + '/fees'
    }, {
      key: 'restrictions',
      label: 'Restrictions',
      to: 'tournament/update/' + tournamentId + '/restrictions'
    }, {
      key: 'status',
      label: 'Status',
      to: 'tournament/update/' + tournamentId + '/status'
    }]));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_navigationBar_actionTypes__["c" /* setNavigationActive */])(active));
  };
};

var loadTournament = function loadTournament(id) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["d" /* getJsonAsync */])('setup/tournament/' + id)).then(function (data) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["b" /* setTitle */])(data.name));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__status_actionTypes__["a" /* setTournamentStatus */])(data.statusDisplayName));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__status_actionTypes__["b" /* setTournamentHasPendingChanges */])(data.hasPendingChanges));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["a" /* setTournament */])(data));
        if (data.hasPendingChanges) {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_navigationBar_actionTypes__["d" /* displayNavigationIcon */])('status', 'fa-exclamation', 'text-danger'));
        } else {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_navigationBar_actionTypes__["e" /* hideNavigationIcon */])('status'));
        }
        resolve(data);
      });
    });
  };
};

function scrollToFirstError(errors) {
  var errorFields = getErrorFieldNames(errors);

  for (var i = 0; i < errorFields.length; i++) {
    var fieldName = '' + errorFields[i];

    var elements = document.querySelectorAll('[name="' + fieldName + '"]');

    if (elements.length) {
      if (elements[0].type === "hidden") {
        __WEBPACK_IMPORTED_MODULE_18_react_scroll__["animateScroll"].scrollTo(elements[0].parentNode.offsetTop); // scroll to field in error, using offset from parent.
      } else if (elements[0].offsetParent.offsetParent.tagName === 'BODY') {
        __WEBPACK_IMPORTED_MODULE_18_react_scroll__["animateScroll"].scrollTo(elements[0].offsetTop + elements[0].parentNode.offsetHeight); // scroll to field in error, relative to body.
      } else {
        // for dynamic displayed fields: scroll to field in error, relative to offset of parent.
        __WEBPACK_IMPORTED_MODULE_18_react_scroll__["animateScroll"].scrollTo(elements[0].offsetParent.offsetTop + elements[0].parentNode.offsetHeight);
      }
      break;
    }
  }
}

function getErrorFieldNames(obj) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var errorArr = [];

  errorArr.push(Object.keys(obj).map(function (key) {
    var next = obj[key];

    if (next) {
      if (typeof next === 'string') {
        return name + key;
      }
      // Keep looking
      if (next.map) {
        errorArr.push(next.map(function (item, index) {
          return getErrorFieldNames(item, '' + name + key + '[' + index + '].');
        }).filter(function (o) {
          return o;
        }));
      }
    }
    return null;
  }).filter(function (o) {
    return o;
  }));
  return flatten(errorArr);
}

function flatten(arr) {
  return arr.reduce(function (flat, toFlatten) {
    return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
  }, []);
}

var setTournamentSubtitle = function setTournamentSubtitle() {
  return function (dispatch, getState) {
    var groupName = getState().shared.auth.groupName;
    var tournamentInfo = getState().tournament.base.tournamentInfo;

    if (tournamentInfo.readOnly) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["c" /* setSubTitle */])('Tournament has ended. Settings cannot be edited.'));
    } else if (groupName) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["c" /* setSubTitle */])('Update Tournament for ' + groupName));
    } else {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["c" /* setSubTitle */])('Update Tournament'));
    }
  };
};

var setManageTournamentSubtitle = function setManageTournamentSubtitle() {
  return function (dispatch, getState) {
    var groupName = getState().shared.auth.groupName;

    if (groupName) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["c" /* setSubTitle */])('for ' + groupName));
    } else {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["c" /* setSubTitle */])(''));
    }
  };
};

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__checkout_actions__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rostercheckout_actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__manage_actionTypes__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actionTypes__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_error_errorManager__ = __webpack_require__(137);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return cancelCheckout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return handleContinueShoppingClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return retrieveEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return retrieveUserVirtualEntries; });
/* unused harmony export retrieveTeamOwnedVirtualEntries */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return retrieveStates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return retrieveCountries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return handleVirtualEntryManageRosterClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return handleVirtualEventSelectChecked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return handleViewRosterClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return handleManageRosterClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return handleUpdateVirtualEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return handleVirtualEntryBowlerChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hasPendingRosterChanges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return retrieveAvailableBowlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return retrieveAvailableBowlersForVirtualEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return handleRemoveUnassignedVirtualEntries; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











var cancelCheckout = function cancelCheckout() {
  return function (dispatch, getState) {
    var tournamentId = getState().registration.base.tournamentId;


    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_actions__["d" /* getJsonAsync */])('registration/cartroster/clear/' + tournamentId));
    delete localStorage.cart;
    if (localStorage.tempCartEntries) delete localStorage.tempCartEntries;
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["O" /* clearSchedulerItems */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["P" /* clearCartItems */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["Q" /* displayClearCartConfirmation */])(false));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_actions__["b" /* navigateTo */])('registration/schedule/' + tournamentId));
  };
};

var handleContinueShoppingClick = function handleContinueShoppingClick() {
  return function (dispatch, getState) {
    var tournamentId = getState().registration.base.tournamentId;


    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actionTypes__["b" /* setReturningToCalendarFlag */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_actions__["b" /* navigateTo */])('registration/schedule/' + tournamentId));
  };
};

var retrieveEntries = function retrieveEntries(tournamentId) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_actions__["d" /* getJsonAsync */])('tournament/' + tournamentId + '/entries')).then(function (data) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["R" /* displayEntries */])(data.map(function (entry) {
          return _extends({}, entry, {
            selected: !!entry.balanceDue && !entry.isCancelled
          });
        })));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["S" /* calculateBalanceDue */])());
        resolve();
      });
    });
  };
};

var retrieveUserVirtualEntries = function retrieveUserVirtualEntries(tournamentId) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_actions__["d" /* getJsonAsync */])('tournament/' + tournamentId + '/virtualentries')).then(function (data) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["T" /* displayVirtualEntries */])(data.map(function (virtualEvent) {
          return _extends({}, virtualEvent, {
            selected: !!virtualEvent.balanceDue
          });
        })));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["S" /* calculateBalanceDue */])());
      }).then(function () {
        return resolve();
      });
    });
  };
};

var retrieveTeamOwnedVirtualEntries = function retrieveTeamOwnedVirtualEntries(eventId, entryId, bowlerCount) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_actions__["d" /* getJsonAsync */])('registration/virtualevent/' + eventId + '/virtualentries')).then(function (data) {
      data.forEach(function (item) {
        item.eventId = eventId;
        item.isPurchased = true;
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["N" /* displayTeamOwnedVirtualEntries */])(data, entryId, bowlerCount));
    });
  };
};

var retrieveStates = function retrieveStates() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_actions__["d" /* getJsonAsync */])('states')).then(function (states) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["U" /* displayStatesInDropDown */])(states));
    });
  };
};

var retrieveCountries = function retrieveCountries() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_actions__["d" /* getJsonAsync */])('countries')).then(function (countries) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["V" /* displayCountriesInDropDown */])(countries.map(function (_ref) {
        var id = _ref.id,
            name = _ref.name;
        return {
          value: id,
          label: name
        };
      })));
    });
  };
};

var handleVirtualEntryManageRosterClick = function handleVirtualEntryManageRosterClick(virtualEventId) {
  return function (dispatch, getState) {
    // prevent user to loose changes while editing an entry
    if (dispatch(hasPendingRosterChanges(handleVirtualEntryManageRosterClick.name, virtualEventId))) {
      return;
    }

    var tournamentId = getState().registration.base.tournamentId;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_actions__["d" /* getJsonAsync */])('virtualevent/' + virtualEventId + '/bowlers')).then(function (bowlers) {
      // close other panels
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["t" /* cancelEntryDetails */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["u" /* cancelPurchasedEntryForm */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["e" /* cancelEntryPaymentLogHistory */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["f" /* cancelVirtualEventPaymentLogHistory */])());
      // display new panel
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["x" /* setVirtualEntryBowlerList */])(bowlers.map(function (x) {
        return _extends({}, x, {
          bowlerId: x.bowlerId || ''
        });
      })));
      dispatch(retrieveAvailableBowlersForVirtualEntries(tournamentId, virtualEventId)).then(function () {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["v" /* displayVirtualEntryBowlerList */])(virtualEventId));
      });
    });
  };
};

var handleVirtualEventSelectChecked = function handleVirtualEventSelectChecked(virtualEntryId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["W" /* setVirtualEventSelectedEntry */])(virtualEntryId));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["S" /* calculateBalanceDue */])());
  };
};

var handleViewRosterClick = function handleViewRosterClick(entryId) {
  return function (dispatch) {
    // prevent user to loose changes while editing an entry
    if (dispatch(hasPendingRosterChanges(handleViewRosterClick.name, entryId))) {
      return;
    }

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_actions__["d" /* getJsonAsync */])('registration/entry/' + entryId + '/readonly')).then(function (entry) {
      // close other panels
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["u" /* cancelPurchasedEntryForm */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["e" /* cancelEntryPaymentLogHistory */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["f" /* cancelVirtualEventPaymentLogHistory */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["g" /* closeVirtualEntryEditing */])());
      // display new panel
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["A" /* setEntryDetailsInState */])(entry));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["B" /* displayEntryDetails */])(entryId));
    });
  };
};

var handleManageRosterClick = function handleManageRosterClick(entryId) {
  return function (dispatch, getState) {
    // prevent user to loose changes while editing an entry
    if (dispatch(hasPendingRosterChanges(handleManageRosterClick.name, entryId))) {
      return;
    }

    var _getState$registratio = getState().registration.shared,
        initialCountry = _getState$registratio.initialCountry,
        countries = _getState$registratio.countries;


    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_actions__["d" /* getJsonAsync */])('registration/entry/' + entryId)).then(function (entry) {
      var selectedCountry = countries.find(function (x) {
        return x.value === (entry.countryId || initialCountry);
      }),
          disableEntryState = !selectedCountry || !selectedCountry.label || selectedCountry.label !== 'United States';
      var rosterPositionsAverage = {};
      var rosterPositions = entry.rosterPositions.map(function (roster) {
        return _extends({}, roster, {
          _searchValue: roster.bowler.usbcId || '',
          _processing: false,
          _retrieved: !!roster.bowler.usbcId && !roster.bowler.error,
          _errorMessage: roster.bowler.error ? roster.bowler.error.Message : null,
          bowler: roster.bowler.error ? {} : _extends({}, roster.bowler, {
            average: roster.bowler.average || ''
          })
        });
      });

      var errorUsbcIds = rosterPositions.filter(function (rosterPosition) {
        return rosterPosition._errorMessage;
      }).map(function (rosterPosition) {
        return rosterPosition._searchValue;
      });

      if (errorUsbcIds && errorUsbcIds.length > 0) {
        __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].error('USBC ID' + (errorUsbcIds.length === 1 ? '' : 's') + ' ' + errorUsbcIds.join() + ' ' + (errorUsbcIds.length === 1 ? 'is' : 'are') + ' not found in membership', '', { allowHtml: true });
      }
      // close other panels
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["t" /* cancelEntryDetails */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["e" /* cancelEntryPaymentLogHistory */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["f" /* cancelVirtualEventPaymentLogHistory */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["g" /* closeVirtualEntryEditing */])());
      // display new panel
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["l" /* displayRosterPositions */])(rosterPositions));
      // generates redux-form model for roster positions averages
      rosterPositions.forEach(function (roster) {
        rosterPositionsAverage['average-' + roster.position] = roster.bowler.average;
        rosterPositionsAverage['usbcId-' + roster.position] = roster.bowler.usbcId;
        rosterPositionsAverage['isProfessional-' + roster.position] = roster.bowler.isProfessional;
      });
      // display form
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["j" /* displayPurchasedEntryForm */])(entryId));

      // display team-owned virtual entries
      dispatch(retrieveTeamOwnedVirtualEntries(entry.eventId, entry.id, entry.rosterPositions.length));

      // re-initialize redux-form with entry data
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["initialize"])('entryForm', _extends({}, rosterPositionsAverage, {
        id: entry.id,
        name: entry.name,
        countryId: !entry.countryId ? initialCountry : entry.countryId,
        state: entry.state,
        rosterPositionsQty: rosterPositions.length,
        pairCode: entry.pairCode,
        groupCode: entry.groupCode
      })));

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__manage_actionTypes__["a" /* setCaptRosterWarnings */])(undefined));

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["q" /* setEntryStateDisabled */])(entryId, disableEntryState));

      var tournamentId = getState().registration.base.tournamentId;

      // initialize available bowler list for doubles/singles dropwdown
      dispatch(retrieveAvailableBowlers(tournamentId, entry.eventId));
    });
  };
};

var handleUpdateVirtualEntry = function handleUpdateVirtualEntry(virtualEventId) {
  return function (dispatch, getState) {
    var _getState = getState(),
        regState = _getState.registration;

    var virtualEntryBowlers = regState.shared.virtualBowlers;
    var tournamentId = regState.base.tournamentId;


    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["F" /* virtualEntrySubmittingStarts */])(virtualEventId));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_actions__["g" /* putJsonAsync */])('virtualevent/bowlers', {
      virtualEventId: virtualEventId,
      virtualEntryBowlers: virtualEntryBowlers
    }, false)).then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["G" /* virtualEntrySubmittingFinished */])(virtualEventId));
      dispatch(retrieveUserVirtualEntries(tournamentId)).then(function () {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__rostercheckout_actions__["d" /* checkForCompleteRosters */])());
      });
      __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Saved!', 'Virtual entries successfully saved.');
    }).catch(function (error) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["G" /* virtualEntrySubmittingFinished */])(virtualEventId));

      if (!Array.isArray(error)) {
        error = [error.message];
      }

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_error_errorManager__["b" /* displayErrorList */])(error));
    });
  };
};

var handleVirtualEntryBowlerChange = function handleVirtualEntryBowlerChange(virtualEntryId, bowlerId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["X" /* setBowlerForVirtualEntry */])(virtualEntryId, bowlerId));
  };
};

var hasPendingRosterChanges = function hasPendingRosterChanges(nextAction, args) {
  return function (dispatch, getState) {
    var entries = getState().registration.shared.entries,
        pendingChanges = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["isDirty"])('entryForm')(getState());

    // prevent user to loose changes while editing an entry
    if (entries.some(function (x) {
      return x.editing;
    }) && pendingChanges) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["r" /* setRosterConfirmationVisibility */])(true, nextAction, args));
      return true;
    }
    return false;
  };
};

var retrieveAvailableBowlers = function retrieveAvailableBowlers(tournamentId, eventId) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_actions__["d" /* getJsonAsync */])('tournament/' + tournamentId + '/bowlers/' + eventId)).then(function (bowlers) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["Y" /* setAvailableBowlersInState */])(bowlers));
        resolve(bowlers);
      }).catch(function (error) {
        return reject(error);
      });
    });
  };
};

var retrieveAvailableBowlersForVirtualEntries = function retrieveAvailableBowlersForVirtualEntries(tournamentId, virtualEventId) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_actions__["d" /* getJsonAsync */])('tournament/' + tournamentId + '/virtualbowlers/' + virtualEventId)).then(function (bowlers) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["Z" /* setAvailableBowlersInStateForVirtualEntries */])(bowlers));
        resolve(bowlers);
      }).catch(function (error) {
        return reject(error);
      });
    });
  };
};

var handleRemoveUnassignedVirtualEntries = function handleRemoveUnassignedVirtualEntries() {
  return function (dispatch, getState) {
    var _getState$registratio2 = getState().registration,
        shared = _getState$registratio2.shared,
        payment = _getState$registratio2.payment;

    var virtualEntryToRemove = shared.virtualEntryToRemove;
    var childTeamOwnedVirtualEntries = shared.childTeamOwnedVirtualEntries;
    var parentTeamOwnedVirtualEntries = shared.parentTeamOwnedVirtualEntries;
    var cartVirtualEventToRemove = payment.cart.virtualEvents.find(function (x) {
      return x.name === virtualEntryToRemove.name;
    });

    if (virtualEntryToRemove.childOrParent === 'child') {
      var childrenToRemove = childTeamOwnedVirtualEntries.filter(function (x) {
        return x.virtualEventName === virtualEntryToRemove.name && x.parentTeamEntryId === null;
      });
      var virtualEventId = childrenToRemove[0].virtualEventId;
      var newQuantity = cartVirtualEventToRemove.quantity - childrenToRemove.length;

      if (newQuantity == 0) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__checkout_actions__["g" /* removeVirtualEventFromCart */])(virtualEventId));
      } else {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__checkout_actions__["h" /* handleOnVirtualEventQuantityChange */])({ virtualEventId: virtualEventId, inputValue: newQuantity }));
      }
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["_0" /* handleRemoveUnassignedChildVirtualEntries */])(virtualEntryToRemove.name));
    } else {
      var parentsToRemove = parentTeamOwnedVirtualEntries.filter(function (x) {
        return x.virtualEventName === virtualEntryToRemove.name && x.teamEntryId === null;
      });
      var _virtualEventId = parentsToRemove[0].virtualEventId;
      var _newQuantity = cartVirtualEventToRemove.quantity - parentsToRemove.length;

      if (_newQuantity == 0) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__checkout_actions__["g" /* removeVirtualEventFromCart */])(_virtualEventId));
      } else {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__checkout_actions__["h" /* handleOnVirtualEventQuantityChange */])({ virtualEventId: _virtualEventId, inputValue: _newQuantity }));
      }
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["_1" /* handleRemoveUnassignedParentVirtualEntries */])(virtualEntryToRemove.name));
    }
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["_2" /* setRemoveVirtualEntryConfirmationVisibility */])(false));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__rostercheckout_actions__["d" /* checkForCompleteRosters */])());
  };
};

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_variables__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Link = function Link(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Link"], _extends({}, props, {
    to: '/' + (__WEBPACK_IMPORTED_MODULE_1_shared_variables__["c" /* BASE_PATH */] ? __WEBPACK_IMPORTED_MODULE_1_shared_variables__["c" /* BASE_PATH */] + '/' : '') + props.to
  }));
};

Link.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

/* harmony default export */ __webpack_exports__["a"] = Link;

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_variables__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_oidc_client__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_oidc_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_oidc_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actionTypes__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__variables__ = __webpack_require__(990);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return refresh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return signinRedirectCallback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return signinSilentCallback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getLoggedInUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return signinSilent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return silentCheckAuth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return checkAuth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return authorizationHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return retrieveMaintenanceMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return handleMaintenanceComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return goToProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return goToProfileVerifyAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return partnerLogin; });







var defaultRoute = 'registration';

var config = {
  authority: window.IDENTITY_SERVER_BASE_URI,
  client_id: __WEBPACK_IMPORTED_MODULE_5__variables__["a" /* CLIENT_ID */],
  redirect_uri: __WEBPACK_IMPORTED_MODULE_5__variables__["b" /* SIGNIN_CALLBACK_URI */],
  response_type: __WEBPACK_IMPORTED_MODULE_5__variables__["c" /* SIGNIN_RESPONSE_TYPE */],
  scope: __WEBPACK_IMPORTED_MODULE_5__variables__["d" /* SIGNIN_SCOPES */],
  post_logout_redirect_uri: __WEBPACK_IMPORTED_MODULE_5__variables__["e" /* POST_LOGOUT_REDIRECT_URI */],

  //Renew access_token values shortly before they expire:
  silent_redirect_uri: __WEBPACK_IMPORTED_MODULE_5__variables__["f" /* SIGNIN_SILENT_RENEW_URI */],
  accessTokenExpiringNotificationTime: __WEBPACK_IMPORTED_MODULE_5__variables__["g" /* SILENT_RENEWAL_SECONDS_BEFORE_EXPIRES */],
  automaticSilentRenew: true,
  clockSkew: __WEBPACK_IMPORTED_MODULE_0_shared_variables__["e" /* SSO_CLOCK_SKEW */]
};

var manager = new __WEBPACK_IMPORTED_MODULE_1_oidc_client__["UserManager"](config);

manager.events.addUserSignedOut(function () {
  manager.removeUser();
});

manager.events.addUserUnloaded(function () {
  //Obsolete?
  localStorage.removeItem('cart');
  localStorage.removeItem('adminCart');
});

manager.events.addSilentRenewError(function () {
  manager.signinSilent();
});

var login = function login(postLoginRoute) {
  sessionStorage.setItem('postLoginRoute', postLoginRoute || defaultRoute);

  manager.signinRedirect().catch(function () {
    __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__["toastr"].warning('Not authenticated!', 'Sorry. There was a problem trying to\n      log you in. Please try again or contact our support team.');
  });
};

var refresh = function refresh() {
  manager.signinRedirect({ extraQueryParams: { auth_nocache: "true" } });
};

var logout = function logout() {
  manager.signoutRedirect();
};

var signinRedirectCallback = function signinRedirectCallback() {
  return function (dispatch) {
    manager.signinRedirectCallback().then(function (user) {
      var postLoginRoute = sessionStorage.getItem('postLoginRoute') || defaultRoute;

      // clean up url for react-router
      // remove any unexpected sub-directory coming from url pathname
      var redirectUrl = postLoginRoute.replace(/^\/|\/$/g, '').replace(__WEBPACK_IMPORTED_MODULE_0_shared_variables__["c" /* BASE_PATH */], '').replace(/^\/|\/$/g, '');

      if (postLoginRoute) {
        sessionStorage.removeItem('postLoginRoute');
      }

      setupUser(dispatch, user);

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["b" /* navigateTo */])(redirectUrl));
    });
  };
};

var signinSilentCallback = function signinSilentCallback() {
  manager.signinSilentCallback();
};

var setupUser = function setupUser(dispatch, user) {
  return new Promise(function (resolve, reject) {
    if (user) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["a" /* setEmailInState */])(user.profile.email));

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["c" /* getJsonNonCacheAsync */])('authorization/getProfile')).then(function (profile) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["b" /* setDisplayNameInState */])(profile));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["c" /* setDobInState */])(profile.birthDate));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["d" /* setProfileValidationsInState */])(profile));

        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["c" /* getJsonNonCacheAsync */])('authorization/getPartner')).then(function (partnerObj) {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["e" /* setIsAllowedInState */])(partnerObj.isAllowed));
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["f" /* setIsValidTypeInState */])(partnerObj.isValidType));
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["g" /* setGroupNameInState */])(partnerObj.partner !== '' && user.profile.groupname !== '' && user.profile.group !== '' ? user.profile.groupname : null));

          // Fetch roles first
          return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('authorization/roles'));
        }).then(function (roles) {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["h" /* setRoleForUserInState */])(roles));

          // Fetch permissions only after roles are done
          return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('authorization/permissions'));
        }).then(function (permissions) {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["i" /* setPermissionForUserInState */])(permissions));

          resolve();
        }).catch(function (error) {
          console.error('Error setting up user:', error);
          reject();
        });
      });
    }
  });
};

var getLoggedInUser = function getLoggedInUser() {
  return manager.getUser();
};

var signinSilent = function signinSilent(dispatch, getState) {
  manager.signinSilent().then(function (user) {
    setupUser(dispatch, user).then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["j" /* setLoginAttempted */])());

      var state = getState();

      if (!!state.shared.auth.email && !state.shared.auth.profileIsConfirmed && state.shared.auth.profileIsWorking) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["b" /* navigateTo */])('registration/accountCreated'));
      }
    });
  }).catch(function () {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["j" /* setLoginAttempted */])());
  });
};

var silentCheckAuth = function silentCheckAuth(nextState, replace, callback) {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      if (!nextState || !nextState.routes) {
        throw new Error('nextState object not provided');
      }
      if (!replace || typeof replace !== 'function') {
        throw new Error('replace method not provided');
      }
      if (!callback || typeof callback !== 'function') {
        throw new Error('callback method not provided');
      }

      var currentState = getState();
      var currentEmail = '';

      if (currentState.shared != null && currentState.shared.auth != null) {
        currentEmail = currentState.shared.auth.email;
      }

      manager.getUser().then(function (user) {
        var shouldSetup = false;

        if (!user && !currentEmail) {
          manager.signinSilent().then(function (user) {
            if (user) {
              shouldSetup = true;
            }
          }).catch(function () {});
        } else {
          if (!currentEmail) {
            shouldSetup = true;
          } else {
            if (currentEmail != user.profile.email) {
              shouldSetup = true;
            }
          }
        }

        if (shouldSetup) {
          setupUser(dispatch, user).then(function () {
            callback();
            resolve();
          });
        } else {
          callback();
          resolve();
        }
      });
    });
  };
};

var checkAuth = function checkAuth(nextState, replace, callback) {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      if (!nextState || !nextState.routes) {
        throw new Error('nextState object not provided');
      }
      if (!replace || typeof replace !== 'function') {
        throw new Error('replace method not provided');
      }
      if (!callback || typeof callback !== 'function') {
        throw new Error('callback method not provided');
      }

      var currentState = getState();
      var currentEmail = '';

      if (currentState.shared != null && currentState.shared.auth != null) {
        currentEmail = currentState.shared.auth.email;
      }

      manager.getUser().then(function (user) {
        var shouldSetup = false;

        if (!user) {
          login(nextState.location.pathname);
        } else {
          // user authenticated
          if (!currentEmail) {
            shouldSetup = true;
          } else {
            if (currentEmail != user.profile.email) {
              shouldSetup = true;
            }
          }

          if (shouldSetup) {
            setupUser(dispatch, user).then(function () {
              var roleRoute = nextState.routes.find(function (item) {
                return item.role;
              });
              var roles = getState().shared.auth.roles;

              // verify route against roles in state
              if (roleRoute && roleRoute.role) {
                var rolesToAuthorize = roleRoute.role.split(",");

                if (!roles.some(function (r) {
                  return rolesToAuthorize.includes(r);
                })) {
                  callback();
                  reject();
                  return;
                }
              }

              callback();
              resolve();
            });
          } else {
            // allow user to continue because route doesn't require a specific role
            callback();
            resolve();
          }
        }
      });
    });
  };
};

var authorizationHeader = function authorizationHeader() {
  return manager.getUser().then(function (user) {
    if (user) {
      return user.access_token ? { 'Authorization': 'Bearer ' + user.access_token } : {};
    }
  });
};

var retrieveMaintenanceMessage = function retrieveMaintenanceMessage() {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('registration/tournament/maintenanceMessage')).then(function (data) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["k" /* setMaintenanceMessage */])(data.maintenanceMessage));
        resolve();
      }).catch(function (error) {
        return reject(error);
      });
    });
  };
};

var handleMaintenanceComplete = function handleMaintenanceComplete(data) {
  return function (dispatch) {
    if (!data) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["b" /* navigateTo */])(defaultRoute));
    }
  };
};

var goToProfile = function goToProfile() {
  var identityUri = window.IDENTITY_SERVER_BASE_URI;

  window.location = identityUri + '/Manage?clientId=' + __WEBPACK_IMPORTED_MODULE_5__variables__["a" /* CLIENT_ID */];
};

var goToProfileVerifyAccount = function goToProfileVerifyAccount() {
  var identityUri = window.IDENTITY_SERVER_BASE_URI;

  window.location = identityUri + '/Manage?clientId=' + __WEBPACK_IMPORTED_MODULE_5__variables__["a" /* CLIENT_ID */] + '&sendVerification=true';
};

var partnerLogin = function partnerLogin() {
  var hubSelectorBaseUri = window.HUB_SELECTOR_BASE_URI;
  window.location = '' + hubSelectorBaseUri;
};

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(458);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setErrorList; });


var setErrorList = function setErrorList(errors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_ERROR_LIST_FOR_SHARED */],
    payload: errors
  };
};

/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(461);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setTopBannerImagePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setSubTitle; });


var setTopBannerImagePath = function setTopBannerImagePath(url) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_TOP_BANNER_IMAGE_PATH */],
    payload: url
  };
};

var setTitle = function setTitle(title) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_TITLE */],
    payload: title
  };
};

var setSubTitle = function setSubTitle(subTitle) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_SUBTITLE */],
    payload: subTitle
  };
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable import/default, no-console */
if (true) {
  module.exports = __webpack_require__(1124);
} else {
  console.log('Running in ' + process.env.NODE_ENV + ' mode');
  module.exports = require('./store.dev');
}

/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports._curry = exports.bsSizes = exports.bsStyles = exports.bsClass = undefined;

var _entries = __webpack_require__(292);

var _entries2 = _interopRequireDefault(_entries);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.prefix = prefix;
exports.getClassSet = getClassSet;
exports.splitBsProps = splitBsProps;
exports.splitBsPropsAndOmit = splitBsPropsAndOmit;
exports.addStyle = addStyle;

var _invariant = __webpack_require__(29);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _StyleConfig = __webpack_require__(244);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function curry(fn) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var last = args[args.length - 1];
    if (typeof last === 'function') {
      return fn.apply(undefined, args);
    }
    return function (Component) {
      return fn.apply(undefined, args.concat([Component]));
    };
  };
} // TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.

function prefix(props, variant) {
  !(props.bsClass != null) ?  false ? (0, _invariant2['default'])(false, 'A `bsClass` prop is required for this component') : (0, _invariant2['default'])(false) : void 0;
  return props.bsClass + (variant ? '-' + variant : '');
}

var bsClass = exports.bsClass = curry(function (defaultClass, Component) {
  var propTypes = Component.propTypes || (Component.propTypes = {});
  var defaultProps = Component.defaultProps || (Component.defaultProps = {});

  propTypes.bsClass = _react.PropTypes.string;
  defaultProps.bsClass = defaultClass;

  return Component;
});

var bsStyles = exports.bsStyles = curry(function (styles, defaultStyle, Component) {
  if (typeof defaultStyle !== 'string') {
    Component = defaultStyle;
    defaultStyle = undefined;
  }

  var existing = Component.STYLES || [];
  var propTypes = Component.propTypes || {};

  styles.forEach(function (style) {
    if (existing.indexOf(style) === -1) {
      existing.push(style);
    }
  });

  var propType = _react.PropTypes.oneOf(existing);

  // expose the values on the propType function for documentation
  Component.STYLES = propType._values = existing;

  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
    bsStyle: propType
  });

  if (defaultStyle !== undefined) {
    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
    defaultProps.bsStyle = defaultStyle;
  }

  return Component;
});

var bsSizes = exports.bsSizes = curry(function (sizes, defaultSize, Component) {
  if (typeof defaultSize !== 'string') {
    Component = defaultSize;
    defaultSize = undefined;
  }

  var existing = Component.SIZES || [];
  var propTypes = Component.propTypes || {};

  sizes.forEach(function (size) {
    if (existing.indexOf(size) === -1) {
      existing.push(size);
    }
  });

  var values = [];
  existing.forEach(function (size) {
    var mappedSize = _StyleConfig.SIZE_MAP[size];
    if (mappedSize && mappedSize !== size) {
      values.push(mappedSize);
    }

    values.push(size);
  });

  var propType = _react.PropTypes.oneOf(values);
  propType._values = values;

  // expose the values on the propType function for documentation
  Component.SIZES = existing;

  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
    bsSize: propType
  });

  if (defaultSize !== undefined) {
    if (!Component.defaultProps) {
      Component.defaultProps = {};
    }
    Component.defaultProps.bsSize = defaultSize;
  }

  return Component;
});

function getClassSet(props) {
  var _classes;

  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);

  if (props.bsSize) {
    var bsSize = _StyleConfig.SIZE_MAP[props.bsSize] || props.bsSize;
    classes[prefix(props, bsSize)] = true;
  }

  if (props.bsStyle) {
    classes[prefix(props, props.bsStyle)] = true;
  }

  return classes;
}

function getBsProps(props) {
  return {
    bsClass: props.bsClass,
    bsSize: props.bsSize,
    bsStyle: props.bsStyle,
    bsRole: props.bsRole
  };
}

function isBsProp(propName) {
  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
}

function splitBsProps(props) {
  var elementProps = {};
  (0, _entries2['default'])(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (!isBsProp(propName)) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}

function splitBsPropsAndOmit(props, omittedPropNames) {
  var isOmittedProp = {};
  omittedPropNames.forEach(function (propName) {
    isOmittedProp[propName] = true;
  });

  var elementProps = {};
  (0, _entries2['default'])(props).forEach(function (_ref2) {
    var propName = _ref2[0],
        propValue = _ref2[1];

    if (!isBsProp(propName) && !isOmittedProp[propName]) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}

/**
 * Add a style variant to a Component. Mutates the propTypes of the component
 * in order to validate the new variant.
 */
function addStyle(Component) {
  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    styleVariant[_key2 - 1] = arguments[_key2];
  }

  bsStyles(styleVariant, Component);
}

var _curry = exports._curry = curry;

/***/ }),
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_error_errorManager__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_actions__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_actionRosterPosition__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actionTypes__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_constants__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__checkout_actionTypes__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__checkout_actions__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__(200);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return retrieveEntriesFromCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handleReviewCartClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return handleCheckOutManageRosterClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return handleRemoveRosterItemClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return handleVirtualEntryManageRosterClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return handleRemoveVirtualEntryFromCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return handleVirtualEventSelectChecked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return handleViewRosterClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handleContinueShoppingSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return handleSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return handleUpdateVirtualEntry; });
/* unused harmony export addCartBowlersForVirtualEntries */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return handleCountryChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return validate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return handleAssignTeamOwnedVirtualEventClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return handleAssignChildTeamOwnedVirtualEventClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return checkForCompleteRosters; });
/* unused harmony export getRostersForExistingCartEntries */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return retrieveVirtualEntriesFromCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return retrieveEvents; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };























var retrieveEntriesFromCart = function retrieveEntriesFromCart() {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var cart = getState().registration.payment.cart;
      var events = getState().registration.rostercheckout.events;
      var tournamentId = getState().registration.base.tournamentId;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["b" /* convertEntriesFromCart */])(cart.squads, events));

      var tempCartEntries = JSON.parse(localStorage.tempCartEntries || null) || [];

      // If user returned to schedule calendar view and added more squads before checkout,
      // there might be managed rosters already in cart; if so, refresh those IDs from
      // local storage.
      if (tempCartEntries && tempCartEntries.length > 0 && tempCartEntries.some(function (entry) {
        return entry.cartRosterId.length == 36;
      })) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["c" /* reinsertManagedRosterIdsToCart */])(tempCartEntries.slice()));
      }

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_actions__["a" /* retrieveEntries */])(tournamentId));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["d" /* convertVirtualEntriesFromCart */])(cart.virtualEvents));
      var _getState$registratio = getState().registration.shared,
          cartEntries = _getState$registratio.cartEntries,
          cartVirtualEntries = _getState$registratio.cartVirtualEntries;


      dispatch(getRostersForExistingCartEntries(cartEntries, cartVirtualEntries)).then(function () {
        dispatch(checkForCompleteRosters());
      });
      resolve();
    });
  };
};

var handleReviewCartClick = function handleReviewCartClick() {
  return function (dispatch, getState) {
    var tournamentId = getState().registration.base.tournamentId;
    var cartVirtualEntries = getState().registration.shared.cartVirtualEntries;
    var tempCartEntries = JSON.parse(localStorage.tempCartEntries || null) || [];

    if (tempCartEntries && tempCartEntries.length > 0 && tempCartEntries.some(function (entry) {
      return entry.cartRosterId.length == 36;
    }) || cartVirtualEntries.length > 0 && tempCartEntries.length == 0) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["b" /* navigateTo */])('registration/checkout/' + tournamentId));
    } else {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["b" /* navigateTo */])('registration/schedule/' + tournamentId));
    }
  };
};

var handleCheckOutManageRosterClick = function handleCheckOutManageRosterClick(cartRosterId) {
  return function (dispatch, getState) {
    // prevent user from losing changes while editing an entry
    if (dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_actions__["e" /* hasPendingRosterChanges */])(handleCheckOutManageRosterClick.name, cartRosterId))) {
      return;
    }

    var _getState$registratio2 = getState().registration.shared,
        initialCountry = _getState$registratio2.initialCountry,
        countries = _getState$registratio2.countries;


    var cartRosters = getState().registration.shared.cartEntries;
    var entry = cartRosters.find(function (entry) {
      return entry.cartRosterId == cartRosterId;
    });

    var selectedCountry = countries.find(function (x) {
      return x.value === (entry.countryId || initialCountry);
    }),
        disableEntryState = !selectedCountry || !selectedCountry.label || selectedCountry.label !== 'United States';

    // close other panels
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actionTypes__["a" /* cancelCartRosterEntryForm */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["e" /* cancelEntryPaymentLogHistory */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["f" /* cancelVirtualEventPaymentLogHistory */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["g" /* closeVirtualEntryEditing */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["h" /* clearPurchasedTeamOwnedVirtualEntries */])());

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["i" /* createCartRosterPositions */])(entry.eventNumberOfBowlers, entry.averageBased));

    // display form
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["j" /* displayPurchasedEntryForm */])(cartRosterId));

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["initialize"])('entryForm', {
      rosterPositionsQty: entry.eventNumberOfBowlers,
      id: entry.id,
      maxEntries: false
    }));

    if (entry.cartRosterId && entry.cartRosterId.length == 36) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["d" /* getJsonAsync */])('registration/cartroster/' + cartRosterId)).then(function (cartRoster) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["k" /* setCartRoster */])(cartRoster));

        if (cartRoster) {
          var rosterData = JSON.parse(cartRoster.rosterData);

          var rosterPositions = rosterData.rosterPositions.map(function (roster) {
            return _extends({}, roster, {
              _searchValue: roster.bowler.usbcId || '',
              _processing: false,
              _retrieved: !!roster.bowler.usbcId && !roster.bowler.error,
              _errorMessage: roster.bowler.error ? roster.bowler.error.Message : null,
              averageRequired: entry.averageBased,
              bowler: roster.bowler.error ? {} : _extends({}, roster.bowler, {
                average: roster.bowler.average || ''
              })
            });
          });

          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["l" /* displayRosterPositions */])(rosterPositions));

          if (rosterData.parentTeamOwnedVirtualEntryAssignments) {
            var parentVirtualEntryAssignments = rosterData.parentTeamOwnedVirtualEntryAssignments;

            for (var i = 0; i < parentVirtualEntryAssignments.length; i++) {
              if (entry.parentVirtualEntryAssignments == null || entry.parentVirtualEntryAssignments.length == 0) {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["m" /* updateCartEntryForParentTeamOwnedVirtualEntry */])(parentVirtualEntryAssignments[i].virtualEventName, null, true));
              }
              dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["n" /* assignTeamOwnedVirtualEntry */])(parentVirtualEntryAssignments[i].virtualEventName, entry.id, true));
            }
          }

          if (rosterData.childTeamOwnedVirtualEntryAssignments) {
            var childVirtualEntryAssignments = rosterData.childTeamOwnedVirtualEntryAssignments;

            for (var _i = 0; _i < childVirtualEntryAssignments.length; _i++) {
              if (entry.childVirtualEntryAssignments == null || entry.childVirtualEntryAssignments.length == 0) {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["o" /* updateCartEntryForChildTeamOwnedVirtualEntry */])(childVirtualEntryAssignments[_i].virtualEventName, null, true, childVirtualEntryAssignments[_i].rosterPosition));
              }
              dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["p" /* assignChildTeamOwnedVirtualEntry */])(childVirtualEntryAssignments[_i].virtualEventName, entry.id, childVirtualEntryAssignments[_i].rosterPosition, true));
            }
          }

          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["initialize"])('entryForm', {
            rosterPositionsQty: entry.eventNumberOfBowlers,
            name: rosterData.name,
            countryId: !rosterData.countryId ? initialCountry : rosterData.countryId,
            state: rosterData.state,
            id: entry.id,
            maxEntries: false
          }));

          for (var _i2 = 0; _i2 < rosterData.rosterPositions.length; _i2++) {
            var rosterPosition = rosterData.rosterPositions[_i2];
            var average = rosterPosition.bowler.average;

            if (!rosterPosition.bowler.id) average = '';

            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('entryForm', 'average-' + rosterPosition.position, average));
          }
        }
      });
    }
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["q" /* setEntryStateDisabled */])(cartRosterId, disableEntryState));

    var tournamentId = getState().registration.base.tournamentId;

    // initialize available bowler list for doubles/singles dropwdown
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_actions__["f" /* retrieveAvailableBowlers */])(tournamentId, entry.eventId));
  };
};

var handleRemoveRosterItemClick = function handleRemoveRosterItemClick(cartRosterId) {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var _getState$registratio3 = getState().registration,
          base = _getState$registratio3.base,
          shared = _getState$registratio3.shared;


      var entryInCart = shared.cartEntries.find(function (entry) {
        return entry.cartRosterId == cartRosterId;
      });

      if (entryInCart && entryInCart.cartRosterId && entryInCart.cartRosterId.length == 36) {
        // call API to delete roster record from DB.
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["i" /* deleteJsonAsync */])('registration/cartroster', {
          id: cartRosterId,
          tournamentId: base.tournamentId,
          rosterType: "Entry"
        })).then(function () {
          dispatch(checkForCompleteRosters());
          __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Complete!', 'Entry information successfully removed.');
          resolve();
        }).catch(function () {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["r" /* setRosterConfirmationVisibility */])(false));
          resolve();
        });
      }

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["s" /* removeCartEntry */])(entryInCart.cartRosterId));
      var cartEntries = getState().registration.shared.cartEntries;

      if (cartEntries && cartEntries.length != 0) {
        localStorage.tempCartEntries = JSON.stringify(cartEntries);
      }

      // find cart entry item by squad IDs and decrement count.
      var cart = getState().registration.payment.cart;
      var squadsInCart = cart.squads || [];
      var squadInCart = squadsInCart.find(function (item) {
        return item.eventID == entryInCart.eventID && item.id == entryInCart.squadId;
      });

      if (squadInCart) {
        squadInCart.quantity--;
        if (squadInCart.quantity == 0) {
          var index = squadsInCart.indexOf(squadInCart);

          if (index !== -1) {
            squadsInCart.splice(index, 1);
          }
        }
      }

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions__["g" /* setShoppingCart */])(cart, base.tournamentId));
      dispatch(retrieveEntriesFromCart());
    });
  };
};

var handleVirtualEntryManageRosterClick = function handleVirtualEntryManageRosterClick(cartRosterId, virtualEventId, virtualEntryQuantity) {
  return function (dispatch, getState) {
    // prevent user from losing changes while editing an entry
    if (dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_actions__["e" /* hasPendingRosterChanges */])(handleVirtualEntryManageRosterClick.name, cartRosterId))) {
      return;
    }

    var registration = getState().registration;
    var tournamentId = registration.base.tournamentId;
    var bowlers = [];
    var timeInMs = new Date().getTime();

    for (var i = 0; i < virtualEntryQuantity; i++) {
      bowlers.push({ id: '' + timeInMs + i, bowlerId: '' });
    }

    // close other panels
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["t" /* cancelEntryDetails */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["u" /* cancelPurchasedEntryForm */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["e" /* cancelEntryPaymentLogHistory */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["f" /* cancelVirtualEventPaymentLogHistory */])());

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["v" /* displayVirtualEntryBowlerList */])(cartRosterId));

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_actions__["g" /* retrieveAvailableBowlersForVirtualEntries */])(tournamentId, virtualEventId));

    if (cartRosterId.length === 36) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["d" /* getJsonAsync */])('registration/cartroster/' + cartRosterId)).then(function (cartRoster) {
        var rosterData = JSON.parse(cartRoster.rosterData);

        for (var _i3 = rosterData.virtualEntries.length; _i3 < virtualEntryQuantity; _i3++) {
          rosterData.virtualEntries.push({ id: '' + timeInMs + _i3, bowlerId: '' });
        }

        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["w" /* setCartVirtualEntryBowlerList */])(rosterData.virtualEntries));
      });
    } else {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["d" /* getJsonAsync */])('virtualevent/' + virtualEventId + '/bowlers')).then(function (virtualEventBowlers) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["x" /* setVirtualEntryBowlerList */])(virtualEventBowlers.map(function (x) {
          return _extends({}, x, {
            bowlerId: x.bowlerId || ''
          });
        })));
      });

      // display new panel
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["w" /* setCartVirtualEntryBowlerList */])(bowlers.map(function (x) {
        return _extends({}, x, {
          bowlerId: x.bowlerId || ''
        });
      })));
    }

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["y" /* updateVirtualAvailableEntryFromCart */])(cartRosterId, virtualEventId, virtualEntryQuantity));
  };
};

var handleRemoveVirtualEntryFromCart = function handleRemoveVirtualEntryFromCart(virtualEventId, bowlerId) {
  return function (dispatch, getState) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["z" /* removeVirtualEntryBowlerFromCart */])(bowlerId));

    var tournamentId = getState().registration.base.tournamentId;
    var shoppingCart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions__["h" /* getShoppingCart */])(),
        virtualEvent = shoppingCart.virtualEvents.find(function (x) {
      return x.id == virtualEventId;
    });

    if (virtualEvent.quantity > 0) virtualEvent.quantity--;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__checkout_actionTypes__["a" /* updateSchedulerVirtualEventCount */])(virtualEvent, virtualEvent.quantity));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions__["g" /* setShoppingCart */])(shoppingCart, tournamentId));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__checkout_actionTypes__["b" /* loadCheckout */])(shoppingCart));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__checkout_actions__["b" /* validateCart */])());
  };
};

var handleVirtualEventSelectChecked = function handleVirtualEventSelectChecked() {
  return function () {
    // for later implementation
  };
};

var handleViewRosterClick = function handleViewRosterClick(entryId) {
  return function (dispatch) {
    //  prevent user from losing changes while editing an entry
    if (dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_actions__["e" /* hasPendingRosterChanges */])(handleViewRosterClick.name, entryId))) {
      return;
    }

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["d" /* getJsonAsync */])('registration/entry/' + entryId + '/readonly')).then(function (entry) {
      // close other panels
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["u" /* cancelPurchasedEntryForm */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["e" /* cancelEntryPaymentLogHistory */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["f" /* cancelVirtualEventPaymentLogHistory */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["g" /* closeVirtualEntryEditing */])());
      // display new panel
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["A" /* setEntryDetailsInState */])(entry));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["B" /* displayEntryDetails */])(entryId));
    });
  };
};

var handleContinueShoppingSelection = function handleContinueShoppingSelection() {
  return function (dispatch, getState) {
    var cartEntries = getState().registration.shared.cartEntries;

    if (cartEntries && cartEntries.length != 0) {
      localStorage.tempCartEntries = JSON.stringify(cartEntries);
    }

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_actions__["h" /* handleContinueShoppingClick */])());
  };
};

var handleSave = function handleSave(data) {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var _getState$registratio4 = getState().registration,
          base = _getState$registratio4.base,
          shared = _getState$registratio4.shared;

      var editingCartEntry = shared.cartEntries.find(function (cartEntry) {
        return cartEntry.editing;
      });
      var cartRosterId = editingCartEntry.cartRosterId.length === 36 ? editingCartEntry.cartRosterId : null;
      var rosterData = {
        name: data.name,
        squadId: editingCartEntry.squadId,
        state: data.state,
        countryId: data.countryId,
        rosterPositions: shared.rosterPositions,
        parentTeamOwnedVirtualEntryAssignments: editingCartEntry.parentVirtualEntryAssignments,
        childTeamOwnedVirtualEntryAssignments: editingCartEntry.childVirtualEntryAssignments
      };

      // Make sure we don't save if there are modifications in the user ID 
      var hasRosterPositionChanged = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_actionRosterPosition__["a" /* rostersHasUserIdModifications */])(shared.rosterPositions);

      if (hasRosterPositionChanged) {
        resolve();
        return;
      }

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["e" /* postJsonAsync */])('registration/cartroster', {
        id: cartRosterId,
        tournamentId: base.tournamentId,
        rosterType: "Entry",
        rosterData: JSON.stringify(rosterData)
      }, false)).then(function (response) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["C" /* setCurrentCartRosterId */])(editingCartEntry.cartRosterId, response.id));
        dispatch(addCartBowlersForVirtualEntries(shared.rosterPositions, editingCartEntry.cartRosterId, editingCartEntry.eventId));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["D" /* setCurrentCartRosterComplete */])({ name: data.name, divisionName: response.divisionName }));
        dispatch(checkForCompleteRosters());
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["E" /* resetTeamOwnedVirtualEntryEventAssignment */])());
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Saved!', 'Entry information successfully saved.');

        var cartEntries = shared.cartEntries;

        if (cartEntries && cartEntries.length != 0) {
          localStorage.tempCartEntries = JSON.stringify(cartEntries);
        }

        resolve();
      }).catch(function (error) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["r" /* setRosterConfirmationVisibility */])(false));

        if (!Array.isArray(error)) {
          error = [error.message];
        }

        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_error_errorManager__["b" /* displayErrorList */])(error));

        resolve();
      });
    });
  };
};

var handleUpdateVirtualEntry = function handleUpdateVirtualEntry(virtualEventId) {
  return function (dispatch, getState) {
    var _getState$registratio5 = getState().registration,
        base = _getState$registratio5.base,
        shared = _getState$registratio5.shared,
        payment = _getState$registratio5.payment;

    var editingCartVirtualEntry = shared.cartVirtualEntries.find(function (cartEntry) {
      return cartEntry.editing;
    });
    var cartRosterId = editingCartVirtualEntry.cartRosterId.length == 36 ? editingCartVirtualEntry.cartRosterId : null;
    var rosterData = {
      virtualEventId: editingCartVirtualEntry.virtualEventId,
      virtualEntries: shared.cartVirtualBowlers
    };

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["F" /* virtualEntrySubmittingStarts */])(virtualEventId));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["g" /* putJsonAsync */])('virtualevent/bowlers', {
      virtualEventId: virtualEventId,
      virtualEntryBowlers: shared.virtualBowlers
    })).then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["G" /* virtualEntrySubmittingFinished */])(virtualEventId));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_actions__["b" /* retrieveUserVirtualEntries */])(base.tournamentId)).then(function () {
        return dispatch(checkForCompleteRosters());
      });

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["F" /* virtualEntrySubmittingStarts */])(virtualEventId));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["e" /* postJsonAsync */])('registration/cartroster', {
        id: cartRosterId,
        tournamentId: base.tournamentId,
        rosterType: "Virtual Entry",
        rosterData: JSON.stringify(rosterData)
      }, false)).then(function (response) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["C" /* setCurrentCartRosterId */])(editingCartVirtualEntry.cartRosterId, response.id));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["H" /* setCartRosterIdForVirtualEventInCart */])(payment.cart.virtualEvents, virtualEventId, response.id));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["G" /* virtualEntrySubmittingFinished */])(virtualEventId));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["I" /* setVirtualEntryRosterComplete */])(response.id, { rosterData: JSON.stringify(rosterData) }));
        dispatch(checkForCompleteRosters());
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Saved!', 'Virtual entries successfully saved.');
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions__["g" /* setShoppingCart */])(payment.cart, base.tournamentId));

        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["g" /* closeVirtualEntryEditing */])());
      }).catch(function (error) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["G" /* virtualEntrySubmittingFinished */])(virtualEventId));

        if (!Array.isArray(error)) {
          error = [error.message];
        }

        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_error_errorManager__["b" /* displayErrorList */])(error));
      });
    }).catch(function () {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["G" /* virtualEntrySubmittingFinished */])(virtualEventId));
    });
  };
};

var addCartBowlersForVirtualEntries = function addCartBowlersForVirtualEntries(rosterPositions, cartRosterId, eventId) {
  return function (dispatch) {
    var bowlers = rosterPositions.filter(function (position) {
      return position.bowler.usbcId;
    }).map(function (rp) {
      return {
        id: rp.bowler.id,
        name: rp.bowler.firstName + ' ' + rp.bowler.lastName,
        memberId: rp.bowler.usbcId,
        assignedByOtherCaptain: rp.bowler.assignedByOtherCaptain,
        cartRosterId: cartRosterId,
        eventId: eventId
      };
    });

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["J" /* setCartBowlersForCartRosterId */])(bowlers, cartRosterId));
  };
};

var handleCountryChange = function handleCountryChange() {
  return function () {
    // for later implementation
  };
};

var validate = function validate(data) {
  var errors = {};

  if (!data.name) {
    errors.name = 'We need to be able to identify your team.';
  }
  return errors;
};

var handleAssignTeamOwnedVirtualEventClick = function handleAssignTeamOwnedVirtualEventClick(virtualEventName, teamEntryId, value) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["m" /* updateCartEntryForParentTeamOwnedVirtualEntry */])(virtualEventName, teamEntryId, value));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["n" /* assignTeamOwnedVirtualEntry */])(virtualEventName, teamEntryId, value));
  };
};

var handleAssignChildTeamOwnedVirtualEventClick = function handleAssignChildTeamOwnedVirtualEventClick(virtualEventName, parentTeamEntryId, rosterPosition, value) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["o" /* updateCartEntryForChildTeamOwnedVirtualEntry */])(virtualEventName, parentTeamEntryId, value, rosterPosition));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["p" /* assignChildTeamOwnedVirtualEntry */])(virtualEventName, parentTeamEntryId, rosterPosition, value));
  };
};

var checkForCompleteRosters = function checkForCompleteRosters() {
  return function (dispatch, getState) {
    var shared = getState().registration.shared;
    var entriesComplete = shared.cartEntries.every(function (x) {
      return x.rosterComplete;
    });
    var virtualEntriesComplete = shared.cartVirtualEntries.every(function (x) {
      return x.rosterComplete;
    });
    var teamOwnedVirtualEntriesComplete = shared.parentVirtualEntryEvents.every(function (x) {
      return x.remaining === 0;
    }) && shared.childVirtualEntryEvents.every(function (x) {
      return x.remaining === 0;
    });

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actionTypes__["b" /* setRostersComplete */])(entriesComplete && virtualEntriesComplete && teamOwnedVirtualEntriesComplete));
  };
};

var getRostersForExistingCartEntries = function getRostersForExistingCartEntries(cartEntries, cartVirtualEntries) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      var promises = [];

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["K" /* clearCartBowlers */])());

      var timeInMs = new Date().getTime();

      cartEntries.forEach(function (entry, index) {
        if (entry && entry.cartRosterId && entry.cartRosterId.length === 36) {
          promises.push(dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["d" /* getJsonAsync */])('registration/cartroster/' + entry.cartRosterId)).then(function (cartRoster) {
            var rosterPositions = [];

            if (cartRoster) {
              var rosterData = JSON.parse(cartRoster.rosterData);

              if (rosterData.parentTeamOwnedVirtualEntryAssignments) {
                var parentVirtualEntryAssignments = rosterData.parentTeamOwnedVirtualEntryAssignments;

                for (var i = 0; i < parentVirtualEntryAssignments.length; i++) {
                  dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["L" /* storeTeamOwnedVirtualEntryMap */])(parentVirtualEntryAssignments[i].virtualEventName, entry.id, true));
                }
              }
              rosterPositions = rosterData.rosterPositions;
            } else {
              entry.cartRosterId = '' + timeInMs + index;
            }
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["M" /* setCartRostersComplete */])(entry.cartRosterId, cartRoster));
            dispatch(addCartBowlersForVirtualEntries(rosterPositions, entry.cartRosterId, entry.eventId));
          }));
        }
      });

      cartVirtualEntries.forEach(function (virtualEntry) {
        if (virtualEntry && virtualEntry.cartRosterId && virtualEntry.cartRosterId.length === 36) {
          promises.push(dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["d" /* getJsonAsync */])('registration/cartroster/' + virtualEntry.cartRosterId)).then(function (cartRoster) {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["I" /* setVirtualEntryRosterComplete */])(virtualEntry.cartRosterId, cartRoster));
          }));
        }
      });

      Promise.all(promises).then(function () {
        return resolve();
      });
    });
  };
};

var retrieveVirtualEntriesFromCart = function retrieveVirtualEntriesFromCart() {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var state = getState().registration;
      var cartVirtualEvents = state.payment.cart.virtualEvents;
      var tournamentId = state.base.tournamentId;

      var tempCartEntries = JSON.parse(localStorage.tempCartEntries || null) || [];

      tempCartEntries.forEach(function (entry) {
        if (entry.cartRosterId && entry.cartRosterId.length == 36) {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["d" /* getJsonAsync */])('registration/cartroster/' + entry.cartRosterId)).then(function (cartRoster) {
            if (cartRoster) {
              var rosterData = JSON.parse(cartRoster.rosterData);

              if (rosterData.parentTeamOwnedVirtualEntryAssignments) {
                var parent = rosterData.parentTeamOwnedVirtualEntryAssignments;

                for (var i = 0; i < parent.length; i++) {
                  dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["n" /* assignTeamOwnedVirtualEntry */])(parent[i].virtualEventName, entry.id, true));
                }
              }

              if (rosterData.childTeamOwnedVirtualEntryAssignments) {
                var child = rosterData.childTeamOwnedVirtualEntryAssignments;

                for (var _i4 = 0; _i4 < child.length; _i4++) {
                  dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["p" /* assignChildTeamOwnedVirtualEntry */])(child[_i4].virtualEventName, entry.id, child[_i4].rosterPosition, true));
                }
              }
            }
          });
        }
      });

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["d" /* getJsonAsync */])('tournament/' + tournamentId + '/virtualEvents')).then(function (virtualEvents) {
        var tempParentTeamOwnedVirtualEvents = cartVirtualEvents.filter(function (ve) {
          var virtEvent = virtualEvents.find(function (x) {
            return x.id === ve.id;
          });

          return virtEvent.owner === __WEBPACK_IMPORTED_MODULE_8__shared_constants__["b" /* TEAM_ENTRY */] && virtEvent.virtualEventMaps[0].eventParentEventId === null;
        });

        var parentTeamOwnedVirtualEvents = tempParentTeamOwnedVirtualEvents.length == 0 ? [] : tempParentTeamOwnedVirtualEvents.map(function (cartItem) {
          return Array.apply(null, { length: cartItem.quantity - state.shared.parentTeamOwnedVirtualEntries.length }).map(function (item, index) {
            return { virtualEventName: cartItem.name, id: new Date().getTime() + '-' + index, childEvent: false, parentTeamEntryId: null, teamEntryId: null, rosterPosition: 0, virtualEventId: cartItem.id, eventId: cartItem.eventId, isPurchased: false };
          });
        }).reduce(function (a, b) {
          return a.concat(b);
        });

        var tempChildOwnedVirtualEvents = cartVirtualEvents.filter(function (ve) {
          var virtEvent = virtualEvents.find(function (x) {
            return x.id === ve.id;
          });

          return virtEvent.owner === __WEBPACK_IMPORTED_MODULE_8__shared_constants__["b" /* TEAM_ENTRY */] && virtEvent.virtualEventMaps[0].eventParentEventId !== null;
        });

        var data = parentTeamOwnedVirtualEvents;

        if (tempChildOwnedVirtualEvents.length > 0) {
          var childTeamOwnedVirtualEvents = tempChildOwnedVirtualEvents.map(function (cartItem) {
            return Array.apply(null, { length: cartItem.quantity - state.shared.childTeamOwnedVirtualEntries.length }).map(function (item, index) {
              return { virtualEventName: cartItem.name, id: new Date().getTime() + '-' + index, childEvent: true, parentTeamEntryId: null, teamEntryId: null, rosterPosition: 0, virtualEventId: cartItem.id, bowlerCount: cartItem.eventNumberOfBowlers, eventId: cartItem.eventId, isPurchased: false };
            });
          }).reduce(function (a, b) {
            return a.concat(b);
          });

          data = data.concat(childTeamOwnedVirtualEvents);
        }

        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["N" /* displayTeamOwnedVirtualEntries */])(data, null, null));

        var storedTeamOwnedVirtualEntryMap = getState().registration.shared.teamOwnedVirtualEntryMap;

        if (storedTeamOwnedVirtualEntryMap != null && storedTeamOwnedVirtualEntryMap.length > 0) {
          storedTeamOwnedVirtualEntryMap.forEach(function (e) {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_actionTypes__["n" /* assignTeamOwnedVirtualEntry */])(e.virtualEventName, e.teamEntryId, e.value));
          });
        }

        dispatch(checkForCompleteRosters());

        resolve();
      });
    });
  };
};

var retrieveEvents = function retrieveEvents(tournamentId) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["d" /* getJsonAsync */])('tournament/' + tournamentId + '/events')).then(function (data) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actionTypes__["c" /* setEventsForRosterCheckout */])(data));
        resolve();
      }).catch(function () {});
    });
  };
};

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldValidationError_jsx__ = __webpack_require__(111);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var StandardCheckboxField = function StandardCheckboxField(_ref) {
  var autoFocus = _ref.autoFocus,
      input = _ref.input,
      disabled = _ref.disabled,
      label = _ref.label,
      name = _ref.name,
      checked = _ref.checked,
      title = _ref.title,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      onCustomChange = _ref.onCustomChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('form-group', { 'has-error': touched && error }) },
    label ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'label',
      { title: title },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, input, {
        autoFocus: autoFocus,
        disabled: disabled,
        name: name,
        type: 'checkbox',
        onChange: function onChange(event) {
          // redux-form overrides change event if provided to Field
          // use custom handler for other specific handling
          onCustomChange(event);
          input.onChange(event);
        },
        checked: checked || !!input.value })),
      ' ',
      label
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, input, {
      autoFocus: autoFocus,
      disabled: disabled,
      name: name,
      type: 'checkbox',
      onChange: function onChange(event) {
        // redux-form overrides change event if provided to Field
        // use custom handler for other specific handling
        onCustomChange(event);
        input.onChange(event);
      },
      checked: !!input.value
    })),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FieldValidationError_jsx__["a" /* default */], {
      touched: touched,
      error: error
    })
  );
};

StandardCheckboxField.propTypes = {
  autoFocus: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  disabled: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  input: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  label: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  meta: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  name: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  checked: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onCustomChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

StandardCheckboxField.defaultProps = {
  title: '',
  onCustomChange: function onCustomChange() {}
};

/* harmony default export */ __webpack_exports__["a"] = StandardCheckboxField;

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROCESSING_ASYNC_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_SCHEDULER_SQUAD_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATE_SCHEDULER_VIRTUAL_EVENT_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAR_SCHEDULER_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TEAM_ENTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BOWLER; });
var PROCESSING_ASYNC_DATA = 'PROCESSING_ASYNC_DATA';
var UPDATE_SCHEDULER_SQUAD_COUNT = 'UPDATE_SCHEDULER_SQUAD_COUNT';
var UPDATE_SCHEDULER_VIRTUAL_EVENT_COUNT = 'UPDATE_SCHEDULER_VIRTUAL_EVENT_COUNT';
var CLEAR_SCHEDULER_ITEMS = 'CLEAR_SCHEDULER_ITEMS';

// constants for enumerating virtual event owner
var TEAM_ENTRY = "Team Entry";
var BOWLER = "Bowler";

/***/ }),
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_error_actionTypes__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home_actionTypes__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_eventPriceDetailsModal_actionTypes__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(200);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return handleSquadFeesButtonClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return restoreLocalDataForCheckout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return processPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return validateCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return openPaymentDialog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return closePaymentDialogEmbeddedForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return createPaymentClientSecret; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return removeSquadItemFromCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return removeVirtualEventFromCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return handleOnSquadQuantityChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return handleOnVirtualEventQuantityChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return retrieveTermsUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return handleAgreeToTermsClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return resetAgreeToTerms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return resetValidationMesssages; });







var handleSquadFeesButtonClick = function handleSquadFeesButtonClick(eventPrice, eventAddOnFees) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_eventPriceDetailsModal_actionTypes__["a" /* displayEventPriceDetailModal */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_eventPriceDetailsModal_actionTypes__["b" /* setEventPriceDetailData */])(eventPrice, eventAddOnFees));
  };
};

var restoreLocalDataForCheckout = function restoreLocalDataForCheckout() {
  return function (dispatch) {
    return new Promise(function (resolve) {
      var cart = JSON.parse(localStorage.cart || null) || [];

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["b" /* loadCheckout */])(cart));
      resolve();
    });
  };
};

var processPayment = function processPayment(paymentDetail) {
  return function (dispatch, getState) {
    var regState = getState().registration;
    var tournamentPhoneNumber = regState.base.tournamentPhoneNumber;

    var entries = regState.shared.cartEntries;
    var cartVirtualEntries = regState.shared.cartVirtualEntries;

    var paymentDetailModel = {
      PaymentId: paymentDetail.PaymentId,
      AlreadyValidated: regState.payment.alreadyValidated,
      TournamentId: paymentDetail.TournamentId,
      Entries: entries,
      virtualEntries: cartVirtualEntries,
      BypassWebHooks: localStorage.bypassWebHooks
    };

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["c" /* setProcessingStarted */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["d" /* setPayInFullDisabled */])(true));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["e" /* postJsonAsync */])('registration/tournament/' + paymentDetailModel.TournamentId + '/entry', paymentDetailModel)).then(function () {
      delete localStorage.cart;
      if (localStorage.tempCartEntries) delete localStorage.tempCartEntries;
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["e" /* clearPayment */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["f" /* setProcessingFinished */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["b" /* navigateTo */])(''));

      var paymentMessage = regState.base.paymentSuccessMessage;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__home_actionTypes__["a" /* setPaymentMessage */])(paymentMessage.replace('#{phoneNum}', tournamentPhoneNumber)));
    }).catch(function () {
      // Ignoring error.
      delete localStorage.cart;
      if (localStorage.tempCartEntries) delete localStorage.tempCartEntries;
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["e" /* clearPayment */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["f" /* setProcessingFinished */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["b" /* navigateTo */])(''));

      var paymentMessage = regState.base.paymentSuccessMessage;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__home_actionTypes__["a" /* setPaymentMessage */])(paymentMessage.replace('#{phoneNum}', tournamentPhoneNumber)));
    });

    if (localStorage.bypassWebHooks) delete localStorage.bypassWebHooks;
  };
};

var validateCart = function validateCart() {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var tournamentId = getState().registration.base.tournamentId,
          cart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["h" /* getShoppingCart */])();

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["g" /* setAlreadyValidated */])(false));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["d" /* setPayInFullDisabled */])(true));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["e" /* postJsonAsync */])('registration/tournament/' + tournamentId + '/entry/validate', {
        entries: cart.squads,
        virtualEntries: cart.virtualEvents
      })).then(function () {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["d" /* setPayInFullDisabled */])(false));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["g" /* setAlreadyValidated */])(true));
        resolve();
      }).catch(function () {
        return resolve();
      }); // resolve promise on fail because erros are manage inside postJsonAsync
    });
  };
};

var openPaymentDialog = function openPaymentDialog(_ref) {
  var amount = _ref.amount,
      cart = _ref.cart;
  return function (dispatch, getState) {
    var _getState = getState(),
        registration = _getState.registration;

    var tournamentId = registration.base.tournamentId;
    var tournamentStripeKey = registration.base.tournamentStripeKey;
    var squadIds = cart.squads;
    var squadvirtualEntries = cart.virtualEvents;

    var body = {
      TournamentId: tournamentId,
      SquadEntries: squadIds,
      SquadVirtualEntries: squadvirtualEntries
    };

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["e" /* postJsonAsync */])('registration/tournament/createSession', body)).then(function (response) {
      var publishableKey = tournamentStripeKey;
      var stripe = window.Stripe(publishableKey);
      var sessionId = response.paymentId;
      var errorMessages = response.messages;
      var useEmbeddedPaymentForm = response.useEmbeddedPaymentForm;

      if (errorMessages && errorMessages.length > 0) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["h" /* setValidationMessages */])(errorMessages));
      } else if (amount == 0) {
        dispatch(processPayment({ PaymentId: sessionId, TournamentId: cart.tournamentId }));
      } else {
        if (useEmbeddedPaymentForm === true) {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["i" /* showPaymentDialogEmbeddedForm */])());
        } else {
          stripe.redirectToCheckout({
            sessionId: sessionId
          });
        }
      }
    });
  };
};

var closePaymentDialogEmbeddedForm = function closePaymentDialogEmbeddedForm() {
  return function (dispatch, getState) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["j" /* hidePaymentDialogEmbeddedForm */])());
  };
};

var createPaymentClientSecret = function createPaymentClientSecret(cart) {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      var _getState2 = getState(),
          registration = _getState2.registration;

      var tournamentId = registration.base.tournamentId;
      var squadIds = cart.squads;
      var squadVirtualEntries = cart.virtualEvents;

      var body = {
        TournamentId: tournamentId,
        SquadEntries: squadIds,
        SquadVirtualEntries: squadVirtualEntries
      };

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["e" /* postJsonAsync */])('registration/tournament/createSession', body)).then(function (response) {
        var errorMessages = response.messages;

        if (errorMessages && errorMessages.length > 0) {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["h" /* setValidationMessages */])(errorMessages));
          reject(errorMessages); // Reject the promise with error messages
        } else {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["k" /* createCheckoutPayment */])(response));
          resolve(response); // Resolve the promise with the session ID
        }
      }).catch(function (error) {
        reject(error); // Ensure the promise is rejected on network or other errors
      });
    });
  };
};

var removeSquadItemFromCart = function removeSquadItemFromCart(id) {
  return function (dispatch) {
    var cart = JSON.parse(localStorage.cart || null) || [];
    var squadsInCart = cart.squads || [];
    var squadInCart = squadsInCart.find(function (item) {
      return item.id == id;
    });

    if (squadInCart) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["l" /* updateSchedulerSquadCount */])(squadInCart, 0));
    }

    cart.squads = squadsInCart.filter(function (item) {
      return item.id != id;
    });
    localStorage.cart = JSON.stringify(cart);
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_error_actionTypes__["a" /* setErrorList */])([]));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["b" /* loadCheckout */])(cart));
    dispatch(validateCart());
  };
};

var removeVirtualEventFromCart = function removeVirtualEventFromCart(id) {
  return function (dispatch) {
    var cart = JSON.parse(localStorage.cart || null) || [];
    var virtualEventsInCart = cart.virtualEvents || [];
    var virtualEventInCart = virtualEventsInCart.find(function (item) {
      return item.id == id;
    });

    if (virtualEventInCart) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["a" /* updateSchedulerVirtualEventCount */])(virtualEventInCart, 0));
    }

    cart.virtualEvents = virtualEventsInCart.filter(function (item) {
      return item.id != id;
    });
    localStorage.cart = JSON.stringify(cart);
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_error_actionTypes__["a" /* setErrorList */])([]));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["b" /* loadCheckout */])(cart));
    dispatch(validateCart());
  };
};

var handleOnSquadQuantityChange = function handleOnSquadQuantityChange(data) {
  return function (dispatch, getState) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["h" /* setValidationMessages */])(null));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["m" /* updateSquadQuantity */])(data));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["n" /* updateCartTotal */])());

    var tournamentId = getState().registration.base.tournamentId;
    var shoppingCart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["h" /* getShoppingCart */])(),
        item = shoppingCart.squads.find(function (x) {
      return x.id === data.squadId;
    }) || null;

    if (item === null) return;
    item.quantity = Number(data.inputValue);
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["l" /* updateSchedulerSquadCount */])(item, data.inputValue));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["g" /* setShoppingCart */])(shoppingCart, tournamentId));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["b" /* loadCheckout */])(shoppingCart));
    dispatch(validateCart());
  };
};

var handleOnVirtualEventQuantityChange = function handleOnVirtualEventQuantityChange(data) {
  return function (dispatch, getState) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["o" /* updateVirtualEventQuantity */])(data));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["n" /* updateCartTotal */])());

    var tournamentId = getState().registration.base.tournamentId;
    var shoppingCart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["h" /* getShoppingCart */])(),
        item = shoppingCart.virtualEvents.find(function (x) {
      return x.id === data.virtualEventId;
    }) || null;

    if (item === null) return;
    item.quantity = Number(data.inputValue);
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["a" /* updateSchedulerVirtualEventCount */])(item, data.inputValue));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["g" /* setShoppingCart */])(shoppingCart, tournamentId));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["b" /* loadCheckout */])(shoppingCart));
    dispatch(validateCart());
  };
};

var retrieveTermsUrl = function retrieveTermsUrl(tournamentId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["d" /* getJsonAsync */])('tournament/' + tournamentId + '/restriction')).then(function (data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["p" /* setTermsUrl */])(data == null ? null : data.termsUrl));
    });
  };
};

var handleAgreeToTermsClick = function handleAgreeToTermsClick(checked) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["q" /* setAgreeToTerms */])(checked));
  };
};

var resetAgreeToTerms = function resetAgreeToTerms() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["q" /* setAgreeToTerms */])(false));
  };
};

var resetValidationMesssages = function resetValidationMesssages() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["h" /* setValidationMessages */])(null));
  };
};

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var FieldValidationError = function FieldValidationError(_ref) {
  var touched = _ref.touched,
      error = _ref.error;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    null,
    touched && error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "small",
      { className: "text-danger" },
      error
    )
  );
};

FieldValidationError.propTypes = {
  touched: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  error: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

/* harmony default export */ __webpack_exports__["a"] = FieldValidationError;

/***/ }),
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(263);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleBowlerSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadBowlerAudit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleBowlerSearchEnterKeyPress; });



var handleBowlerSearch = function handleBowlerSearch() {
  return function (dispatch, getState) {
    var searchValue = getState().admin.bowlerAudit.searchBowlerAuditValue;

    if (searchValue && searchValue.length > 0) searchValue = searchValue.toLowerCase();

    if (searchValue && searchValue.trim().length > 2) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["e" /* postJsonAsync */])('audit/bowlerAudit', { searchFilter: searchValue })).then(function (data) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["a" /* displayBowlerAudit */])(data));
      }).catch(function () {});
    }
  };
};

var loadBowlerAudit = function loadBowlerAudit(bowlerId) {
  return function (dispatch) {

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["b" /* displayBowlerAuditHeader */])(null));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["c" /* displayBowlerAuditDetails */])(null));

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["d" /* getJsonAsync */])('audit/bowlerAudit/' + bowlerId)).then(function (data) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["b" /* displayBowlerAuditHeader */])(data));
    }).catch(function () {});

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["d" /* getJsonAsync */])('audit/bowlerAuditDetails/' + bowlerId)).then(function (data) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["c" /* displayBowlerAuditDetails */])(data));
    }).catch(function () {});
  };
};

var handleBowlerSearchEnterKeyPress = function handleBowlerSearchEnterKeyPress(event) {
  return function (dispatch) {
    if (event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation();
      dispatch(handleBowlerSearch());
    }
  };
};

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(264);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleCaptainSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadCaptainAudit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleCaptainSearchEnterKeyPress; });



var handleCaptainSearch = function handleCaptainSearch() {
  return function (dispatch, getState) {
    var searchValue = getState().admin.captainAudit.searchCaptainAuditValue;

    if (searchValue && searchValue.length > 0) searchValue = searchValue.toLowerCase();

    if (searchValue && searchValue.trim().length > 2) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["e" /* postJsonAsync */])('audit/captainAudit', { searchFilter: searchValue })).then(function (data) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["a" /* displayCaptainAudit */])(data));
      }).catch(function () {});
    }
  };
};

var loadCaptainAudit = function loadCaptainAudit(captainId, tournamentId) {
  return function (dispatch) {

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["b" /* displayCaptainAuditHeader */])(null));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["c" /* displayCaptainAuditDetails */])(null));

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["d" /* getJsonAsync */])('audit/captainAudit/' + captainId + '/' + tournamentId)).then(function (data) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["b" /* displayCaptainAuditHeader */])(data));
    }).catch(function () {});

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["d" /* getJsonAsync */])('audit/captainAuditDetails/' + captainId + '/' + tournamentId)).then(function (data) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["c" /* displayCaptainAuditDetails */])(data));
    }).catch(function () {});
  };
};

var handleCaptainSearchEnterKeyPress = function handleCaptainSearchEnterKeyPress(event) {
  return function (dispatch) {
    if (event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation();
      dispatch(handleCaptainSearch());
    }
  };
};

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(267);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleTournamentSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadTournamentAudit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleTournamentSearchEnterKeyPress; });



var handleTournamentSearch = function handleTournamentSearch() {
  return function (dispatch, getState) {
    var searchValue = getState().admin.tournamentAudit.searchTournamentAuditValue;

    if (searchValue && searchValue.length > 0) searchValue = searchValue.toLowerCase();

    if (searchValue && searchValue.trim().length > 2) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["e" /* postJsonAsync */])('audit/tournamentAudit', { searchFilter: searchValue })).then(function (data) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["a" /* displayTournamentAudit */])(data));
      }).catch(function () {});
    }
  };
};

var loadTournamentAudit = function loadTournamentAudit(tournamentId) {
  return function (dispatch) {

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["b" /* displayTournamentAuditHeader */])(null));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["c" /* displayTournamentAuditDetails */])(null));

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["d" /* getJsonAsync */])('audit/tournamentAudit/' + tournamentId)).then(function (data) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["b" /* displayTournamentAuditHeader */])(data));
    }).catch(function () {});

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["d" /* getJsonAsync */])('audit/tournamentAuditDetails/' + tournamentId)).then(function (data) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["c" /* displayTournamentAuditDetails */])(data));
    }).catch(function () {});
  };
};

var handleTournamentSearchEnterKeyPress = function handleTournamentSearchEnterKeyPress(event) {
  return function (dispatch) {
    if (event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation();
      dispatch(handleTournamentSearch());
    }
  };
};

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(268);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleVirtualEntrySearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadVirtualEntryAudit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleVirtualEntrySearchEnterKeyPress; });



var handleVirtualEntrySearch = function handleVirtualEntrySearch() {
  return function (dispatch, getState) {
    var searchValue = getState().admin.virtualEntryAudit.searchVirtualEntryAuditValue;

    if (searchValue && searchValue.length > 0) searchValue = searchValue.toLowerCase();

    if (searchValue && searchValue.trim().length > 2) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["e" /* postJsonAsync */])('audit/virtualEntryAudit', { searchFilter: searchValue })).then(function (data) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["a" /* displayVirtualEntryAudit */])(data));
      }).catch(function () {});
    }
  };
};

var loadVirtualEntryAudit = function loadVirtualEntryAudit(virtualEntryId) {
  return function (dispatch) {

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["b" /* displayVirtualEntryAuditHeader */])(null));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["c" /* displayVirtualEntryAuditDetails */])(null));

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["d" /* getJsonAsync */])('audit/virtualEntryAudit/' + virtualEntryId)).then(function (data) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["b" /* displayVirtualEntryAuditHeader */])(data));
    }).catch(function () {});

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["d" /* getJsonAsync */])('audit/virtualEntryAuditDetails/' + virtualEntryId)).then(function (data) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["c" /* displayVirtualEntryAuditDetails */])(data));
    }).catch(function () {});
  };
};

var handleVirtualEntrySearchEnterKeyPress = function handleVirtualEntrySearchEnterKeyPress(event) {
  return function (dispatch) {
    if (event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation();
      dispatch(handleVirtualEntrySearch());
    }
  };
};

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(417);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return setValidationMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return displayUpdateModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setPaymentVirtualEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setchangeMultipleEntriesErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeHideCancelledEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return changeHideArchivedEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return displayPaymentEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setPaymentEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setPayments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return displayNotesModalVisibility; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return setCaptainDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return setCaptainTournamentEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return setCaptainBalanceDue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return setVirtualEventSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return setEntrySelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return setTournamentCollapsed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return calculateSelectedBalance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return disableOtherTournamentSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return displayCaptainDetailPaymentModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resetCaptainDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return displayEntryDetailChangeCaptainModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return hideEntryDetailChangeCaptainModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setIsNewCaptainOnSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setAffectedVirtualEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return setSelectedAffectedVirtualEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return setAllAffectedVirtualEntriesSelected; });


var setValidationMessages = function setValidationMessages(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_VALIDATION_MESSAGES_FOR_CAPTAIN_DETAIL */],
    payload: payload
  };
};

var displayUpdateModal = function displayUpdateModal(showModal) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DISPLAY_UPDATE_MODAL_FOR_ADMIN_CAPTAIN_DETAIL */],
    payload: showModal
  };
};

var setPaymentVirtualEvents = function setPaymentVirtualEvents(paymentVirtualEvents) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_PAYMENT_VIRTUAL_EVENTS_FOR_ADMIN_CAPTAIN_DETAIL */],
    payload: paymentVirtualEvents
  };
};

var setchangeMultipleEntriesErrors = function setchangeMultipleEntriesErrors(error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_CHANGE_MULTIPLE_ENTRIES_ERRORS */],
    payload: error
  };
};

var changeHideCancelledEntries = function changeHideCancelledEntries(newValue) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* CHANGE_HIDE_CANCELLED_ENTRIES */],
    payload: newValue
  };
};

var changeHideArchivedEntries = function changeHideArchivedEntries(newValue) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* CHANGE_HIDE_ARCHIVED_ENTRIES */],
    payload: newValue
  };
};

var displayPaymentEntries = function displayPaymentEntries(paymentId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* DISPLAY_PAYMENT_ENTRIES_FOR_ADMIN_CAPTAIN_DETAIL */],
    payload: paymentId
  };
};

var setPaymentEntries = function setPaymentEntries(paymentEntries) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* SET_PAYMENT_ENTRIES_FOR_ADMIN_CAPTAIN_DETAIL */],
    payload: paymentEntries
  };
};

var setPayments = function setPayments(payments) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* SET_PAYMENTS_FOR_ADMIN_CAPTAIN_DETAIL */],
    payload: payments
  };
};

var displayNotesModalVisibility = function displayNotesModalVisibility(visible) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* DISPLAY_NOTES_MODAL_FOR_ADMIN_CAPTAIN_DETAIL */],
    payload: visible
  };
};

var setCaptainDetails = function setCaptainDetails(captainDetails) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* SET_CAPTAIN_DETAILS_FOR_ADMIN */],
    payload: captainDetails
  };
};

var setCaptainTournamentEntries = function setCaptainTournamentEntries(tournaments) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* SET_CAPTAIN_ENTRIES_BY_TOURNAMENT_FOR_ADMIN */],
    payload: tournaments
  };
};

var setCaptainBalanceDue = function setCaptainBalanceDue(balance) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* SET_CAPTAIN_BALANCE_DUE_FOR_ADMIN */],
    payload: balance
  };
};

var setVirtualEventSelected = function setVirtualEventSelected(tournamentId, virtualEventId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* SET_CAPTAIN_SELECTED_TOURNAMENT_VIRTUAL_EVENT_FOR_ADMIN */],
    payload: { tournamentId: tournamentId, virtualEventId: virtualEventId }
  };
};

var setEntrySelected = function setEntrySelected(tournamentId, entryId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["o" /* SET_CAPTAIN_SELECTED_TOURNAMENT_ENTRY_FOR_ADMIN */],
    payload: { tournamentId: tournamentId, entryId: entryId }
  };
};

var setTournamentCollapsed = function setTournamentCollapsed(tournamentId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["p" /* SET_CAPTAIN_COLLAPSED_TOURNAMENT_FOR_ADMIN */],
    payload: { tournamentId: tournamentId }
  };
};

var calculateSelectedBalance = function calculateSelectedBalance() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["q" /* CALCULATE_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_DETAIL */]
  };
};

var disableOtherTournamentSelection = function disableOtherTournamentSelection(tournamentId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["r" /* DISABLE_OTHER_TOURNAMENT_SELECTION_FOR_ADMIN_CAPTAIN_DETAIL */],
    payload: tournamentId
  };
};

var displayCaptainDetailPaymentModal = function displayCaptainDetailPaymentModal(showModal) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["s" /* DISPLAY_PAYMENT_MODAL_FOR_ADMIN_CAPTAIN_DETAIL */],
    payload: showModal
  };
};

var resetCaptainDetails = function resetCaptainDetails() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["t" /* RESET_CAPTAIN_DETAILS_FOR_ADMIN */]
  };
};

var displayEntryDetailChangeCaptainModal = function displayEntryDetailChangeCaptainModal() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["u" /* SHOW_CAPTAIN_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN */],
    payload: true
  };
};

var hideEntryDetailChangeCaptainModal = function hideEntryDetailChangeCaptainModal() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["v" /* HIDE_CAPTAIN_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN */],
    payload: false
  };
};

var setIsNewCaptainOnSearch = function setIsNewCaptainOnSearch(isNew) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["w" /* SET_IS_NEW_CAPTAIN_ENTRIES_MODAL_FOR_ADMIN */],
    payload: isNew
  };
};

var setAffectedVirtualEntries = function setAffectedVirtualEntries(virtualEntries) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["x" /* SET_AFFECTED_VIRTUAL_ENTRIES_FOR_ADMIN */],
    payload: virtualEntries
  };
};

var setSelectedAffectedVirtualEntry = function setSelectedAffectedVirtualEntry(virtualEntryId, selected) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* SET_SELECTED_AFFECTED_VIRTUAL_ENTRY */],
    payload: { virtualEntryId: virtualEntryId, selected: selected }
  };
};

var setAllAffectedVirtualEntriesSelected = function setAllAffectedVirtualEntriesSelected() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["z" /* SET_ALL_AFFECTED_VIRTUAL_ENTRIES_SELECTED */]
  };
};

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actionTypes__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handleReviewReservationsClick; });
/* unused harmony export updateSquadInLocalStorage */
/* unused harmony export clearSquadQuantity */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handleEventSquadAddClick; });
/* unused harmony export retrieveAvailableEvents */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleDateSelection; });
/* unused harmony export retrieveAvailableDates */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return resetScreenToInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return handleTournamentChange; });
/* unused harmony export retrieveVirtualEvents */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return retrieveActiveTournaments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return handleBowlerOwnedVirtualEventAddClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return handleTeamOwnedVirtualEventAddClick; });
/* unused harmony export updateSquadCartCount */
/* unused harmony export updateBowlerOwnedVirtualEventCountCart */
/* unused harmony export updateTeamOwnedVirtualEventCountCart */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };












var handleReviewReservationsClick = function handleReviewReservationsClick() {
  return function (dispatch, getState) {
    var tournamentId = getState().admin.base.tournament.id;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["b" /* navigateTo */])('admin/review/' + tournamentId));
  };
};

var updateSquadInLocalStorage = function updateSquadInLocalStorage(squadId, quantity) {
  return function (dispatch, getState) {
    var events = getState().admin.schedule.availableEvents;

    var shoppingCart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["n" /* getAdminShoppingCart */])(),
        items = shoppingCart.squads.filter(function (x) {
      return x.id === squadId;
    }),
        item = items.length ? items[0] : null;

    if (item) {
      item.quantity += quantity;
    } else {
      var squad = null;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var event = _step.value;

          squad = event.squads.find(function (_ref) {
            var id = _ref.id;
            return id === squadId;
          });
          if (squad) {
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (!squad) {
        throw new Error('Squad ' + squadId + ' not found in state');
      }
      shoppingCart.squads.push(_extends({}, squad, {
        quantity: quantity
      }));
    }

    localStorage.adminCart = JSON.stringify(shoppingCart);
  };
};

var clearSquadQuantity = function clearSquadQuantity(squadId) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["b" /* setSquadQuantity */])({
      squadId: squadId,
      addedToCart: true,
      inputValue: 0,
      max: 0
    }));
  };
};

var handleEventSquadAddClick = function handleEventSquadAddClick(squadId, quantity) {
  return function (dispatch) {
    dispatch(updateSquadCartCount(squadId, quantity));
    dispatch(updateSquadInLocalStorage(squadId, quantity));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["a" /* updateTotal */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["n" /* getAdminShoppingCart */])()));
    dispatch(clearSquadQuantity(squadId));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["c" /* displayGuideIfBundled */])(squadId));
    __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].success('Added to Cart!', 'Your selection was added to the cart.');
  };
};

var retrieveAvailableEvents = function retrieveAvailableEvents(selectedDateString) {
  return function (dispatch, getState) {
    var tournamentId = getState().admin.base.tournament.id;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["d" /* getJsonAsync */])('admin/tournament/' + tournamentId + '/reservation/event/squad/available/' + selectedDateString)).then(function (data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["d" /* setAvailableEvents */])({
        events: data,
        cart: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["n" /* getAdminShoppingCart */])()
      }));
    });
  };
};

var handleDateSelection = function handleDateSelection(selectedDate) {
  return function (dispatch) {
    // infinite-calendar uses moment for selected date
    var formattedDate = selectedDate;

    if (typeof selectedDate !== 'string') formattedDate = selectedDate.format('YYYY-MM-DD');

    dispatch(retrieveAvailableEvents(formattedDate));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["e" /* setSelectedDateInState */])(formattedDate));
  };
};

var retrieveAvailableDates = function retrieveAvailableDates(tournamentId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["d" /* getJsonAsync */])('admin/tournament/' + tournamentId + '/reservation/dates')).then(function (data) {
      if (data) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["f" /* displayAvailableSquadDates */])({
          disabledDates: data.disabledDates.map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.parseZone(item).format('YYYY-MM-DD');
          }),
          min: __WEBPACK_IMPORTED_MODULE_0_moment___default.a.parseZone(data.firstAvailableSquadDate).startOf('month').format('YYYY-MM-DD'),
          minDate: __WEBPACK_IMPORTED_MODULE_0_moment___default.a.parseZone(data.firstAvailableSquadDate).format('YYYY-MM-DD'),
          max: __WEBPACK_IMPORTED_MODULE_0_moment___default.a.parseZone(data.lastAvailableSquadDate).endOf('month').format('YYYY-MM-DD'),
          maxDate: __WEBPACK_IMPORTED_MODULE_0_moment___default.a.parseZone(data.lastAvailableSquadDate).format('YYYY-MM-DD'),
          selectedDate: null,
          visible: true
        }));
      } else {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["g" /* setNoDatesAvailable */])(true));
      }
    });
  };
};

var resetScreenToInitialState = function resetScreenToInitialState() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["h" /* displayVirtualEvents */])({
      virtualEvents: {},
      cart: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["n" /* getAdminShoppingCart */])()
    }));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["f" /* displayAvailableSquadDates */])({ visible: false }));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["g" /* setNoDatesAvailable */])(false));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["e" /* setSelectedDateInState */])(null));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["d" /* setAvailableEvents */])({
      events: [],
      cart: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["n" /* getAdminShoppingCart */])()
    }));
  };
};

var handleTournamentChange = function handleTournamentChange(tournamentId) {
  return function (dispatch, getState) {
    var tournament = getState().admin.base.tournament;

    dispatch(resetScreenToInitialState());
    if (tournamentId) {
      // clear admin cart when navigating to another tournament
      if (tournament && tournament.id !== tournamentId) {
        delete localStorage.adminCart;
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["a" /* updateTotal */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["n" /* getAdminShoppingCart */])()));
      }
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["o" /* retrieveTournamentInfo */])(tournamentId));
      dispatch(retrieveAvailableDates(tournamentId));
      dispatch(retrieveVirtualEvents(tournamentId));
    } else {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["a" /* setTournamentInformation */])(null));
    }
  };
};

var retrieveVirtualEvents = function retrieveVirtualEvents(tournamentId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["d" /* getJsonAsync */])('tournament/' + tournamentId + '/virtualevents')).then(function (virtualEvents) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["h" /* displayVirtualEvents */])({
        virtualEvents: virtualEvents,
        cart: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["n" /* getAdminShoppingCart */])()
      }));
    });
  };
};

var retrieveActiveTournaments = function retrieveActiveTournaments() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["d" /* getJsonAsync */])('admin/tournament/active')).then(function (tournaments) {
      var dropDownItems = tournaments ? tournaments.map(function (x) {
        return { value: x.id, label: x.name };
      }) : [];

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["i" /* setActiveTournamentsInState */])(dropDownItems));
    });
  };
};

var handleBowlerOwnedVirtualEventAddClick = function handleBowlerOwnedVirtualEventAddClick(virtualEvent) {
  return function (dispatch, getState) {
    var shoppingCart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["n" /* getAdminShoppingCart */])();
    var items = shoppingCart.virtualEvents.filter(function (x) {
      return x.id === virtualEvent.id;
    }),
        item = items.length ? items[0] : null,
        tournamentId = getState().registration.base.tournamentId;

    if (item) {
      item.quantity += virtualEvent.quantity;
    } else {
      shoppingCart.virtualEvents.push(virtualEvent);
    }

    dispatch(updateBowlerOwnedVirtualEventCountCart(virtualEvent.id, virtualEvent.quantity));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["p" /* setAdminShoppingCart */])(shoppingCart, tournamentId));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["a" /* updateTotal */])(shoppingCart));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["j" /* updateBowlerOwnedVirtualEventQuantity */])(virtualEvent.id, 0)); // clear quantity field after adding to cart
    __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].success('Added to Cart!', 'Your selection was added to the cart.');
  };
};

var handleTeamOwnedVirtualEventAddClick = function handleTeamOwnedVirtualEventAddClick(virtualEvent) {
  return function (dispatch, getState) {
    var shoppingCart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["n" /* getAdminShoppingCart */])();
    var items = shoppingCart.virtualEvents.filter(function (x) {
      return x.id === virtualEvent.id;
    }),
        item = items.length ? items[0] : null,
        tournamentId = getState().registration.base.tournamentId;

    if (item) {
      item.quantity += virtualEvent.quantity;
    } else {
      shoppingCart.virtualEvents.push(virtualEvent);
    }

    dispatch(updateTeamOwnedVirtualEventCountCart(virtualEvent.eventId, virtualEvent.id, virtualEvent.quantity));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["p" /* setAdminShoppingCart */])(shoppingCart, tournamentId));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["a" /* updateTotal */])(shoppingCart));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["k" /* updateTeamOwnedVirtualEventQuantity */])(virtualEvent.eventId, virtualEvent.id, 0)); // clear quantity field after adding to cart
    __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].success('Added to Cart!', 'Your selection was added to the cart.');
  };
};

var updateSquadCartCount = function updateSquadCartCount(squadId, quantity) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["l" /* updateSquadCountInCart */])(squadId, quantity));
  };
};

var updateBowlerOwnedVirtualEventCountCart = function updateBowlerOwnedVirtualEventCountCart(virtualEventId, quantity) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["m" /* updateBowlerOwnedVirtualEventCountInCart */])(virtualEventId, quantity));
  };
};

var updateTeamOwnedVirtualEventCountCart = function updateTeamOwnedVirtualEventCountCart(eventId, virtualEventId, quantity) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["n" /* updateTeamOwnedVirtualEventCountInCart */])(eventId, virtualEventId, quantity));
  };
};

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldValidationError_jsx__ = __webpack_require__(111);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var StandardTextArea = function StandardTextArea(_ref) {
  var autoFocus = _ref.autoFocus,
      disabled = _ref.disabled,
      input = _ref.input,
      label = _ref.label,
      maxLength = _ref.maxLength,
      placeholder = _ref.placeholder,
      style = _ref.style,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()({ 'form-group': placeholder || label }, { 'has-error': touched && error }) },
    label || placeholder ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'label',
      { htmlFor: name },
      label || placeholder
    ) : null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', _extends({}, input, {
      autoFocus: autoFocus,
      className: 'form-control',
      disabled: disabled,
      maxLength: maxLength,
      placeholder: placeholder,
      style: style
    })),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FieldValidationError_jsx__["a" /* default */], {
      touched: touched,
      error: error
    })
  );
};

StandardTextArea.propTypes = {
  autoFocus: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  input: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  disabled: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  label: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,
  meta: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  name: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  placeholder: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  style: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  maxLength: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

/* harmony default export */ __webpack_exports__["a"] = StandardTextArea;

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(74);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultErrorAction; });
/* unused harmony export toastError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return displayErrorList; });
/* unused harmony export scrollToErrorList */



var defaultErrorAction = function defaultErrorAction(error) {
    return function (dispatch) {
        return dispatch(toastError(error));
    };
};

var toastError = function toastError(error) {
    return function (dispatch) {
        if (typeof error === 'string') {
            __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].error(error);
        } else if (error.message) {
            __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].error(error.message);
        } else if (error && error.length) {
            dispatch(displayErrorList(error));
        }

        return null;
    };
};

var displayErrorList = function displayErrorList(errorStringArray) {
    return function (dispatch) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["a" /* setErrorList */])(errorStringArray));
        scrollToErrorList();
    };
};

var scrollToErrorList = function scrollToErrorList() {
    var elementToScroll = document.querySelectorAll('#sharedErrorList');

    if (elementToScroll && elementToScroll.length) {
        setTimeout(function () {
            elementToScroll[0].scrollIntoView();
        }, 600); // execute scrolling after a period of time to allow rendering to execute other prior animations
    }
};

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_variables__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_auth_actions__ = __webpack_require__(62);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handleLogoutClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return handleLoginClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleExitPartnerClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handleUserClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleLogoClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handlePartnerLoginClick; });




var handleLogoutClick = function handleLogoutClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["h" /* beginProcessAsync */])());
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_auth_actions__["g" /* logout */])();
  };
};

var handleLoginClick = function handleLoginClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["h" /* beginProcessAsync */])());
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_auth_actions__["b" /* login */])();
  };
};

var handleExitPartnerClick = function handleExitPartnerClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["c" /* getJsonNonCacheAsync */])('authorization/exitPartner')).then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["h" /* beginProcessAsync */])());
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_auth_actions__["h" /* refresh */])();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_auth_actions__["g" /* logout */])();
    });
  };
};

var handleUserClick = function handleUserClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_auth_actions__["i" /* goToProfile */])());
  };
};

var handleLogoClick = function handleLogoClick() {
  return function (dispatch) {
    var pathExceptions = ['signin', __WEBPACK_IMPORTED_MODULE_1_shared_variables__["c" /* BASE_PATH */]];
    var featurePath = window.location.pathname.split(/\//).filter(function (x) {
      return x && !pathExceptions.includes(x);
    });

    if (featurePath.length) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["b" /* navigateTo */])('' + featurePath[0])); // navigate to the root of current feature
    } else {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["b" /* navigateTo */])()); // navigate to root
    }
  };
};

var handlePartnerLoginClick = function handlePartnerLoginClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["h" /* beginProcessAsync */])());
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_auth_actions__["j" /* partnerLogin */])();
  };
};

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return validateDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validateEmail; });


var validateDate = function validateDate(date) {
  // Matches the format YYYY-MM-DD
  var dateRegex = /^\d{4}([./-])\d{2}\1\d{2}/;

  return dateRegex.test(date) && __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).isValid();
};

var validateEmail = function validateEmail(email) {
  var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return emailRegex.test(email);
};

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_error_actionTypes__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actionTypes__ = __webpack_require__(1047);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handleLinkedEventsToggleClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return handleVirtualEventItemClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return validateVirtualEventForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return handleSaveVirtualEventForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return handleCancelVirtualEventForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return handleNewVirtualEventClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return retrieveVirtualEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return retrieveEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleNewBowlEventClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return retrieveEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return validateBowlEventForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return handleSaveBowlEventForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return handleDeleteBowlEventForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handleAgeVerificationDateChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return handleCancelBowlEventForm; });
/* unused harmony export retrieveAgeOptions */
/* unused harmony export displayScoringMethodOptions */
/* unused harmony export displayOwnedByOptions */
/* unused harmony export displayAgeOptions */
/* unused harmony export retrieveScoringMethods */
/* unused harmony export retrieveOwnedByOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return handleMappedEventsUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return handleAgeBasedClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return handleIsHideFromCaptainClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return handleIsHandicappedClick; });
/* unused harmony export retrieveHandicapAppliedToOptions */
/* unused harmony export retrieveAvailableLocationOptions */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var defaultAgeAppliesTo = function defaultAgeAppliesTo(payload) {
  if (payload.ageBased && !payload.ageAppliesTo) {
    payload.ageAppliesTo = "Oldest Member";
  }
};

var defaultScoringMethod = function defaultScoringMethod(payload) {
  if (!payload.scoringMethod) {
    payload.scoringMethod = "First";
  }
};

var handleLinkedEventsToggleClick = function handleLinkedEventsToggleClick() {
  return function (dispatch, getState) {
    var tournamentId = getState().tournament.base.tournamentInfo.id;
    var linkEvents = !getState().tournament.base.tournamentInfo.linkEvents;
    var request = {
      tournamentId: tournamentId,
      linkEvents: linkEvents
    };

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])('setup/tournament/' + tournamentId + '/linkEvents', request)).then(function () {
      __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Saved!', 'Doubles/Singles ' + (linkEvents ? 'linked' : 'unlinked') + ' successfully');
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["n" /* loadTournament */])(tournamentId));
    }).catch(function () {});
  };
};

var handleVirtualEventItemClick = function handleVirtualEventItemClick(virtualEventId) {
  return function (dispatch, getState) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('virtualevent/' + virtualEventId)).then(function (data) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["a" /* displayVirtualEventForm */])(virtualEventId));
      data.maps = data.virtualEventMaps.map(function (virtualEventMap) {
        return virtualEventMap.eventId;
      }).join(',');
      dispatch(displayScoringMethodOptions(false));
      dispatch(displayOwnedByOptions(false));

      if (data.virtualEventMaps.length > 1) {
        var validBowledEvent = getState().tournament.events.bowlEvents.find(function (x) {
          return x.maxEntriesPerBowler > 1;
        });

        if (validBowledEvent != undefined && validBowledEvent != null) {
          data.scoringMethods = dispatch(retrieveScoringMethods());
          dispatch(handleMappedEventsUpdate(data.maps));
          dispatch(displayScoringMethodOptions(true));
        }
      }

      if (data.virtualEventMaps.length === 1) {
        var applicableEvents = getState().tournament.events.bowlEvents.filter(function (x) {
          return data.maps.includes(x.id);
        });

        if (applicableEvents !== undefined && applicableEvents.length === 1) {
          data.ownedByOptions = dispatch(retrieveOwnedByOptions());
          dispatch(handleMappedEventsUpdate(data.maps));
          dispatch(displayOwnedByOptions(true));
        }
      }

      // check for events with more than 1 bowler
      if (data.ageBased) {
        var applicableEvents1 = getState().tournament.events.bowlEvents.filter(function (x) {
          return x.numberOfBowlers > 1;
        }).filter(function (x) {
          return data.maps.includes(x.id);
        });

        if (applicableEvents1 !== undefined && applicableEvents1.length !== 0) {
          dispatch(displayAgeOptions(true));
        } else {
          dispatch(displayAgeOptions(false));
        }
      }

      if (data.isHandicapped) dispatch(retrieveHandicapAppliedToOptions());

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["initialize"])('virtualEventForm', data));
    }).catch(function () {});
  };
};

var validateVirtualEventForm = function validateVirtualEventForm(values) {
  var errors = {};
  var fields = ['name', 'expenseFee', 'lineageFee', 'prizeFee', 'handicapPercentage', 'handicapAverage', 'handicapApplied'];

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var field = _step.value;

      var error = {};

      // general validation (required, positive number)
      if (typeof values[field] === 'number' && values[field] < 0) {
        error[field] = 'Must be zero or a greater number';
      } else if (typeof values[field] !== 'number' && !values[field]) {
        error[field] = 'Required';
      }

      // specific validation
      if (field === 'expenseFee' && values[field] < 0) {
        error[field] = 'Cannot be negative amount';
      }

      if (field === 'lineageFee' && values[field] < 0) {
        error[field] = 'Cannot be negative amount';
      }

      if (field === 'prizeFee' && values[field] < 0) {
        error[field] = 'Cannot be negative amount';
      }

      if (field === 'handicapPercentage' && values[field] > 100) {
        error[field] = 'Cannot be greater than 100';
      }

      if (field === 'handicapPercentage' && values[field] < 0) {
        error[field] = 'Cannot be negative';
      }

      if (field === 'handicapAverage' && values[field] > 300) {
        error[field] = 'Cannot be greater than 300';
      }

      errors = _extends({}, errors, error);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return errors;
};

var handleSaveVirtualEventForm = function handleSaveVirtualEventForm(formData) {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var tournamentId = getState().tournament.base.tournamentInfo.id;
      var payload = _extends({
        tournamentId: tournamentId
      }, formData, {
        virtualEventMaps: formData.maps ? formData.maps.split(',') : []
      });

      var promise = formData.id ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["g" /* putJsonAsync */])('virtualevent', payload) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])('virtualevent', payload);

      defaultAgeAppliesTo(payload);
      defaultScoringMethod(payload);
      dispatch(promise).then(function () {
        __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Saved!', 'Virtual event successfully saved.');
        dispatch(retrieveVirtualEvents(tournamentId));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["n" /* loadTournament */])(tournamentId));
        resolve();
      }).catch(function () {
        return resolve();
      });
    });
  };
};

var handleCancelVirtualEventForm = function handleCancelVirtualEventForm() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_error_actionTypes__["a" /* setErrorList */])([]));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["b" /* cancelVirtualEventForm */])());
  };
};

var handleNewVirtualEventClick = function handleNewVirtualEventClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["b" /* cancelVirtualEventForm */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["c" /* displayNewVirtualEvent */])());
    dispatch(retrieveScoringMethods());
    dispatch(retrieveOwnedByOptions());
    dispatch(displayScoringMethodOptions(false));
    dispatch(displayOwnedByOptions(false));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["d" /* displayVirtualEventAgeOptions */])(false));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["initialize"])('virtualEventForm', {}));
  };
};

var retrieveVirtualEvents = function retrieveVirtualEvents(tournamentId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('tournament/' + tournamentId + '/virtualevents')).then(function (virtualEvents) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["e" /* displayVirtualEvents */])(virtualEvents));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('virtualevent/' + tournamentId + '/viewEvents'));
      dispatch(retrieveAgeOptions());
    }).catch(function () {});
  };
};

var retrieveEvent = function retrieveEvent(eventId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('event/' + eventId)).then(function (data) {
      setTimeout(function () {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["initialize"])('eventItemForm', data));
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["f" /* displayEventForm */])(data.id));
      dispatch(retrieveAvailableLocationOptions());

      if (data.isHandicapped) dispatch(retrieveHandicapAppliedToOptions());
    }).catch(function () {});
  };
};

var handleNewBowlEventClick = function handleNewBowlEventClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["g" /* cancelEventItemForm */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["h" /* displayNewEvent */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["initialize"])('eventItemForm', {}));
  };
};

var retrieveEvents = function retrieveEvents(tournamentId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('tournament/' + tournamentId + '/events')).then(function (data) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["i" /* displayEvents */])(data));
      dispatch(retrieveAgeOptions());
      dispatch(retrieveAvailableLocationOptions(tournamentId));
    }).catch(function () {});
  };
};

var validateBowlEventForm = function validateBowlEventForm(values) {
  var errors = {};
  var fields = ['name', 'numberOfBowlers', 'gamesPerSeries', 'entriesPerLanePair', 'maxEntriesPerBowler', 'handicapPercentage', 'handicapAverage', 'handicapApplied', 'expenseFee', 'lineageFee', 'prizeFee', 'numberOfBowlersThatMustBeDifferentPerTeam', 'location'];

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = fields[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var field = _step2.value;

      var error = {};

      // general validation (required, positive number)
      if (typeof values[field] === 'number' && values[field] < 0) {
        error[field] = 'Must be zero or a greater number';
      } else if (typeof values[field] !== 'number' && !values[field]) {
        error[field] = 'Required';
      }

      // specific validation
      if (field === 'maxEntriesPerBowler' && values[field] <= 0) {
        error[field] = 'Must be greater than zero';
      }

      if (field === 'handicapPercentage' && values[field] > 100) {
        error[field] = 'Cannot be greater than 100';
      }

      if (field === 'handicapPercentage' && values[field] < 0) {
        error[field] = 'Cannot be negative';
      }

      if (field === 'handicapAverage' && values[field] > 300) {
        error[field] = 'Cannot be greater than 300';
      }

      if (field === 'numberOfBowlersThatMustBeDifferentPerTeam' && values[field] > values['numberOfBowlers']) {
        error[field] = 'Cannot be greater than number of bowlers per team';
      }

      errors = _extends({}, errors, error);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return errors;
};

var handleSaveBowlEventForm = function handleSaveBowlEventForm(data) {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var tournamentId = getState().tournament.base.tournamentInfo.id;
      var payload = _extends({}, data, {
        tournamentId: tournamentId
      });

      defaultAgeAppliesTo(payload);
      var promise = data.id ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["g" /* putJsonAsync */])('event', payload) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])('event', payload);

      dispatch(promise).then(function () {
        __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Saved!', 'Tournament Event saved Successfully.');
        dispatch(retrieveEvents(tournamentId));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["n" /* loadTournament */])(tournamentId));
        resolve();
      }).catch(function () {
        return resolve();
      });
    });
  };
};

var handleDeleteBowlEventForm = function handleDeleteBowlEventForm() {
  return function (dispatch, getState) {
    var eventId = getState().form.eventItemForm ? getState().form.eventItemForm.values.id : getState().form.virtualEventForm.values.id;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])('event/' + eventId + '/remove')).then(function (response) {
      var errorMessage = response;

      if (errorMessage && errorMessage.length > 0) {
        __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].error('Event Not Removed', errorMessage);
      } else {
        __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Saved!', 'Event Removed Successfully.');
      }
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].error('Error removing the event!', error.toString());
    });
  };
};

var handleAgeVerificationDateChanged = function handleAgeVerificationDateChanged(date) {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var ageVerificationDate = getState().tournament.base.tournamentInfo.ageVerificationDate;
      var ageVerificationDateFormatted = ageVerificationDate !== null ? __WEBPACK_IMPORTED_MODULE_2_moment___default.a.parseZone(ageVerificationDate).format('YYYY-MM-DD') : ageVerificationDate;
      var formattedDate = date !== null ? __WEBPACK_IMPORTED_MODULE_2_moment___default.a.parseZone(date).format('YYYY-MM-DD') : null;

      if (ageVerificationDateFormatted !== formattedDate) {
        var tournamentId = getState().tournament.base.tournamentInfo.id;
        var payload = {
          ageVerificationDate: formattedDate,
          tournamentId: tournamentId
        };

        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])('setup/tournament/' + tournamentId + '/ageVerificationDate', payload)).then(function () {
          __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Saved!', 'Age Verification Date saved successfully.');
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["n" /* loadTournament */])(tournamentId));
        }).catch(function () {
          return resolve();
        });
      }
    });
  };
};

var handleCancelBowlEventForm = function handleCancelBowlEventForm() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_error_actionTypes__["a" /* setErrorList */])([]));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["g" /* cancelEventItemForm */])());
  };
};

var retrieveAgeOptions = function retrieveAgeOptions() {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      var ageOptions = getState().tournament.events.ageOptions;

      // prevent going to server if ageOptions already in state
      if (ageOptions && ageOptions.length) {
        resolve(ageOptions);
      }

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('division/ageOptions')).then(function (ageOptions) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["j" /* setAgeOptions */])(ageOptions.map(function (_ref) {
          var id = _ref.id,
              name = _ref.name;
          return {
            value: id,
            label: name
          };
        })));
        resolve(ageOptions);
      }).catch(function () {
        return reject();
      });
    });
  };
};

var displayScoringMethodOptions = function displayScoringMethodOptions(showScoringMethods) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["k" /* displayVirtualEventScoringMethodOptions */])(showScoringMethods));
  };
};

var displayOwnedByOptions = function displayOwnedByOptions(showOwnedBy) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["l" /* displayVirtualEventOwnedByOptions */])(showOwnedBy));
  };
};

var displayAgeOptions = function displayAgeOptions(showAgeOptions) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["d" /* displayVirtualEventAgeOptions */])(showAgeOptions));
  };
};

var retrieveScoringMethods = function retrieveScoringMethods() {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      var scoringMethods = getState().tournament.events.scoringMethods;

      // prevent going to server if scoringMethods already in state
      if (scoringMethods && scoringMethods.length) {
        resolve(scoringMethods);
      }

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('setup/tournament/scoringMethods')).then(function (scoringMethods) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["m" /* getVirtualEventScoringMethods */])(scoringMethods.map(function (_ref2) {
          var id = _ref2.id,
              name = _ref2.name;
          return {
            value: id,
            label: name
          };
        })));
        resolve(scoringMethods);
      }).catch(function () {
        return reject();
      });
    });
  };
};

var retrieveOwnedByOptions = function retrieveOwnedByOptions() {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      var ownedByOptions = getState().tournament.events.ownedByOptions;

      // prevent going to server if ownedByOptions already in state
      if (ownedByOptions && ownedByOptions.length) {
        resolve(ownedByOptions);
      }

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('setup/tournament/ownedByOptions')).then(function (ownedByOptions) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["n" /* getVirtualEventOwnedByOptions */])(ownedByOptions.map(function (_ref3) {
          var id = _ref3.id,
              name = _ref3.name;
          return {
            value: id,
            label: name
          };
        })));
        resolve(ownedByOptions);
      }).catch(function () {
        return reject();
      });
    });
  };
};

var handleMappedEventsUpdate = function handleMappedEventsUpdate(fieldData) {
  return function (dispatch, getState) {
    var virtualEventMaps = fieldData ? fieldData.split(',') : [];
    var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["formValueSelector"])('virtualEventForm');
    var ageBased = selector(getState(), 'ageBased');

    dispatch(displayScoringMethodOptions(false));
    dispatch(displayOwnedByOptions(false));

    if (virtualEventMaps.length > 1) {
      var applicableEvents2 = getState().tournament.events.bowlEvents.filter(function (x) {
        return x.maxEntriesPerBowler > 1;
      }).filter(function (x) {
        return virtualEventMaps.includes(x.id);
      });

      if (applicableEvents2 !== undefined && applicableEvents2.length !== 0) {
        dispatch(displayScoringMethodOptions(true));
      }
    }
    if (virtualEventMaps.length === 1) {
      var applicableEvents3 = getState().tournament.events.bowlEvents.filter(function (x) {
        return virtualEventMaps.includes(x.id);
      });

      if (applicableEvents3 !== undefined && applicableEvents3.length === 1) {
        dispatch(displayOwnedByOptions(true));
      }
    }
    // check for events with more than 1 bowler
    if (ageBased) {
      var eventsWithMultipleBowlers = getState().tournament.events.bowlEvents.filter(function (x) {
        return x.numberOfBowlers > 1;
      }).filter(function (x) {
        return virtualEventMaps.includes(x.id);
      });

      if (eventsWithMultipleBowlers !== undefined && eventsWithMultipleBowlers.length !== 0) {
        dispatch(displayAgeOptions(true));
      } else {
        dispatch(displayAgeOptions(false));
      }
    }
  };
};

var handleAgeBasedClick = function handleAgeBasedClick(checked) {
  return function (dispatch, getState) {
    dispatch(displayAgeOptions(false));
    var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["formValueSelector"])('virtualEventForm');
    var linkedEventMaps = selector(getState(), 'maps');

    if (checked) {
      if (linkedEventMaps !== undefined) {
        var virtualEventMaps = linkedEventMaps ? linkedEventMaps.split(',') : [];

        // check number of bowlers from linked event.  If > 1, then show AgeOptions
        if (virtualEventMaps.length > 0) {
          var applicableEvents3 = getState().tournament.events.bowlEvents.filter(function (x) {
            return x.numberOfBowlers > 1;
          }).filter(function (x) {
            return virtualEventMaps.includes(x.id);
          });

          if (applicableEvents3 !== undefined && applicableEvents3.length !== 0) {
            dispatch(displayAgeOptions(true));
          }
        }
      }
    }
  };
};

var handleIsHideFromCaptainClick = function handleIsHideFromCaptainClick(tournamentId, eventId, checked) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["g" /* putJsonAsync */])('virtualevent/' + eventId + '/hideFromCaptains', { TournamentId: tournamentId, VirtualEventId: eventId, HideFromCaptains: checked })).then(function () {
      return __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Saved!', 'Virtual event successfully saved.');
    });
    dispatch(retrieveVirtualEvents(tournamentId));
  };
};

var handleIsHandicappedClick = function handleIsHandicappedClick(checked) {
  return function (dispatch) {
    if (checked) {
      dispatch(retrieveHandicapAppliedToOptions());
    }
  };
};

var retrieveHandicapAppliedToOptions = function retrieveHandicapAppliedToOptions() {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      var handicapAppliedOptions = getState().tournament.events.handicapAppliedOptions;

      // prevent going to server if options already in state
      if (handicapAppliedOptions && handicapAppliedOptions.length) {
        resolve(handicapAppliedOptions);
      }

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('setup/tournament/handicapAppliedTo')).then(function (handicapAppliedOptions) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["o" /* getHandicapAppliedToOptions */])(handicapAppliedOptions.map(function (_ref4) {
          var id = _ref4.id,
              name = _ref4.name;
          return {
            value: id,
            label: name
          };
        })));
        resolve(handicapAppliedOptions);
      }).catch(function () {
        return reject();
      });
    });
  };
};

var retrieveAvailableLocationOptions = function retrieveAvailableLocationOptions(tournamentId) {
  return function (dispatch, getState) {
    if (!tournamentId) tournamentId = getState().tournament.base.tournamentInfo.id;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('setupEvents/' + tournamentId + '/eventLocations')).then(function (availableLocationOptions) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["p" /* getAvailableLocationOptions */])(availableLocationOptions.map(function (_ref5) {
        var id = _ref5.id,
            name = _ref5.name,
            certificationNumber = _ref5.certificationNumber;
        return {
          value: id,
          label: name + ' (#' + certificationNumber + ')'
        };
      })));
    });
  };
};

/***/ }),
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_auth_actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_eventPriceDetailsModal_actionTypes__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__review_actionTypes__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__schedule_actions__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__schedule_actionTypes__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actionTypes__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__home_actionTypes__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__captainDetail_actions__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__captainDetail_actionTypes__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__entryDetail_actions__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__entryDetail_actionTypes__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__virtualEventDetail_actions__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__virtualEventDetail_actionTypes__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__home_actions__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__audit_actionTypes__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__audit_entryAudit_actions__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__audit_virtualEntryAudit_actions__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__audit_bowlerAudit_actions__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__audit_tournamentAudit_actions__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__audit_captainAudit_actions__ = __webpack_require__(131);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return handleAdminVirtualEventDetailRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return handleAdminReviewRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return handleAdminSquadsRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleAdminHomeRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleAdminBackToSearchRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleAuditHomeRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return handleAuditEntryRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handleAuditVirtualEntryRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handleAuditBowlerRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return handleAuditTournamentRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return handleAuditCaptainRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return handleAdminEntryDetailRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return handleAdminCaptainDetailRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return handleSquadFeesButtonClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getAdminShoppingCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return setAdminShoppingCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return retrieveTournamentInfo; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
























var handleAdminVirtualEventDetailRouteEnter = function handleAdminVirtualEventDetailRouteEnter(nextState, replace, callback) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      var _nextState$params = nextState.params,
          captainId = _nextState$params.captainId,
          virtualEventId = _nextState$params.virtualEventId,
          paymentId = _nextState$params.paymentId;

      // Clear the header and details 

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["b" /* setTitle */])('Virtual Event'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["c" /* setSubTitle */])('Captain'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__virtualEventDetail_actionTypes__["a" /* setVirtualEntriesInState */])(undefined));

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__virtualEventDetail_actions__["a" /* getVirtualEventDetailInfo */])(captainId, virtualEventId, paymentId)).then(function (response) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["b" /* setTitle */])('Virtual Event: ' + response.virtualEventName));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["c" /* setSubTitle */])('Captain: ' + response.captainName));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__virtualEventDetail_actions__["b" /* retrieveVirtualEntries */])(captainId, virtualEventId));
      });
    });
  };
};

var handleAdminReviewRouteEnter = function handleAdminReviewRouteEnter(nextState, replace, callback) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      var tournamentId = nextState.params.tournamentId;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["b" /* setTitle */])('Tournament Administration'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["c" /* setSubTitle */])('Reservation Review'));
      dispatch(retrieveTournamentInfo(tournamentId));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__review_actionTypes__["a" /* loadReservationReview */])(getAdminShoppingCart()));
    }).catch(function () {});
  };
};

var handleAdminSquadsRouteEnter = function handleAdminSquadsRouteEnter() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return function (dispatch, getState) {
    return dispatch(__WEBPACK_IMPORTED_MODULE_0_shared_auth_actions__["f" /* checkAuth */].apply(undefined, args)).then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["b" /* setTitle */])('Tournament Administration'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["c" /* setSubTitle */])('Reserve Squads'));

      var isReturning = getState().admin.base.returningToCalendar;
      var selectedDate = getState().admin.schedule.calendar.selectedDate;

      if (isReturning && selectedDate) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__schedule_actions__["a" /* handleDateSelection */])(selectedDate));
      } else if (!isReturning) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__schedule_actions__["b" /* retrieveActiveTournaments */])());
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actionTypes__["a" /* setTournamentInformation */])(null));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__schedule_actions__["c" /* resetScreenToInitialState */])());
      }

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__schedule_actionTypes__["a" /* updateTotal */])(getAdminShoppingCart()));
    }).catch(function () {});
  };
};

var handleAdminHomeRouteEnter = function handleAdminHomeRouteEnter() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return function (dispatch) {
    return dispatch(__WEBPACK_IMPORTED_MODULE_0_shared_auth_actions__["f" /* checkAuth */].apply(undefined, args)).then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["b" /* setTitle */])('Tournament Administration'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["c" /* setSubTitle */])(''));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__home_actionTypes__["a" /* setSearchResultInState */])(null));
    }).catch(function () {});
  };
};

var handleAdminBackToSearchRouteEnter = function handleAdminBackToSearchRouteEnter() {
  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  return function (dispatch, getState) {
    return dispatch(__WEBPACK_IMPORTED_MODULE_0_shared_auth_actions__["f" /* checkAuth */].apply(undefined, args)).then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["b" /* setTitle */])('Tournament Administration'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["c" /* setSubTitle */])(''));
      if (getState().admin.home.searchValue) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__home_actions__["a" /* handleSearch */])());
      }
    }).catch(function () {});
  };
};

var handleAuditHomeRouteEnter = function handleAuditHomeRouteEnter() {
  for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  return function (dispatch) {
    return dispatch(__WEBPACK_IMPORTED_MODULE_0_shared_auth_actions__["f" /* checkAuth */].apply(undefined, args)).then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["b" /* setTitle */])('Audit'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["c" /* setSubTitle */])(''));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__audit_actionTypes__["a" /* clearAdminAuditSearch */])());
    }).catch(function () {});
  };
};

var handleAuditEntryRouteEnter = function handleAuditEntryRouteEnter(nextState, replace, callback) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      var entryId = nextState.params.entryId;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["b" /* setTitle */])('Audit'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["c" /* setSubTitle */])('Entry'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__audit_entryAudit_actions__["a" /* loadEntryAudit */])(entryId));
    }).catch(function () {});
  };
};

var handleAuditVirtualEntryRouteEnter = function handleAuditVirtualEntryRouteEnter(nextState, replace, callback) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      var virtualEntryId = nextState.params.virtualEntryId;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["b" /* setTitle */])('Audit'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["c" /* setSubTitle */])('Virtual Entry'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__audit_virtualEntryAudit_actions__["a" /* loadVirtualEntryAudit */])(virtualEntryId));
    }).catch(function () {});
  };
};

var handleAuditBowlerRouteEnter = function handleAuditBowlerRouteEnter(nextState, replace, callback) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      var bowlerId = nextState.params.bowlerId;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["b" /* setTitle */])('Audit'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["c" /* setSubTitle */])('Bowler'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__audit_bowlerAudit_actions__["a" /* loadBowlerAudit */])(bowlerId));
    });
  };
};

var handleAuditTournamentRouteEnter = function handleAuditTournamentRouteEnter(nextState, replace, callback) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      var tournamentId = nextState.params.tournamentId;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["b" /* setTitle */])('Audit'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["c" /* setSubTitle */])('Tournament'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__audit_tournamentAudit_actions__["a" /* loadTournamentAudit */])(tournamentId));
    });
  };
};

var handleAuditCaptainRouteEnter = function handleAuditCaptainRouteEnter(nextState, replace, callback) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      var captainId = nextState.params.captainId;
      var tournamentId = nextState.params.tournamentId;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["b" /* setTitle */])('Audit'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["c" /* setSubTitle */])('Tournament'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__audit_captainAudit_actions__["a" /* loadCaptainAudit */])(captainId, tournamentId));
    });
  };
};

var handleAdminEntryDetailRouteEnter = function handleAdminEntryDetailRouteEnter(nextState, replace, callback) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      var entryId = nextState.params.entryId;
      var paymentId = nextState.params.paymentId;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__entryDetail_actions__["a" /* retrieveEntryDetails */])(entryId, paymentId)).then(function (entryDetails) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__entryDetail_actions__["b" /* retrieveEntryCaptainDetails */])(entryDetails.captainId));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__entryDetail_actions__["c" /* retrieveEntryCoordinatorDetails */])(entryDetails.coordinatorId));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["b" /* setTitle */])('Entry # ' + entryDetails.entryNumber + ' (' + entryDetails.eventDisplayName + ' event)'));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["c" /* setSubTitle */])('' + entryDetails.teamName));
      });

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__entryDetail_actionTypes__["a" /* displayPaymentLogHistory */])(false));
    }).catch(function () {});
  };
};

var handleAdminCaptainDetailRouteEnter = function handleAdminCaptainDetailRouteEnter(nextState, replace, callback) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      var captainId = nextState.params.captainId;
      var paymentId = nextState.params.paymentId;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__captainDetail_actionTypes__["a" /* resetCaptainDetails */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__captainDetail_actionTypes__["b" /* setAffectedVirtualEntries */])([]));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__captainDetail_actions__["a" /* loadCaptainDetails */])(captainId));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__captainDetail_actions__["b" /* clearPaymentLogs */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__captainDetail_actions__["c" /* loadCaptainTournamentEntries */])(captainId, paymentId));
    }).catch(function () {});
  };
};

var handleSquadFeesButtonClick = function handleSquadFeesButtonClick(eventPrice, eventAddOnFees) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_eventPriceDetailsModal_actionTypes__["a" /* displayEventPriceDetailModal */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_eventPriceDetailsModal_actionTypes__["b" /* setEventPriceDetailData */])(eventPrice, eventAddOnFees));
  };
};

var getAdminShoppingCart = function getAdminShoppingCart() {
  var cart = JSON.parse(localStorage.adminCart || null) || {};

  return _extends({}, cart, {
    squads: cart.squads || [],
    virtualEvents: cart.virtualEvents || []
  });
};

var setAdminShoppingCart = function setAdminShoppingCart(updatedCart, tournamentId) {
  return function () {
    updatedCart.tournamentId = tournamentId;
    localStorage.adminCart = JSON.stringify(updatedCart);
  };
};

var retrieveTournamentInfo = function retrieveTournamentInfo(tournamentId) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["d" /* getJsonAsync */])('admin/tournament/' + tournamentId)).then(function (tournament) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actionTypes__["a" /* setTournamentInformation */])(tournament));
        resolve(tournament);
      }).catch(function (error) {
        return reject(error);
      });
    });
  };
};

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var ResultsLimited = function ResultsLimited() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "alert alert-warning text-center" },
    "Too many records found. Results are limited. Try again using more specific search terms."
  );
};

/* harmony default export */ __webpack_exports__["a"] = ResultsLimited;

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(413);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleTeamSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadEntryAudit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleTeamSearchEnterKeyPress; });



var handleTeamSearch = function handleTeamSearch() {
  return function (dispatch, getState) {
    var searchValue = getState().admin.entryAudit.searchEntryAuditValue;

    if (searchValue && searchValue.length > 0) searchValue = searchValue.toLowerCase();

    if (searchValue && searchValue.trim().length > 2) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["e" /* postJsonAsync */])('audit/teamAudit', { searchFilter: searchValue })).then(function (data) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["a" /* displayTeamAudit */])(data));
      }).catch(function () {});
    }
  };
};

var loadEntryAudit = function loadEntryAudit(entryId) {
  return function (dispatch) {

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["d" /* getJsonAsync */])('audit/teamAudit/' + entryId)).then(function (data) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["b" /* displayTeamAuditHeader */])(data));
    }).catch(function () {});

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["d" /* getJsonAsync */])('audit/teamAuditDetails/' + entryId)).then(function (data) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["c" /* displayTeamAuditDetails */])(data));
    }).catch(function () {});
  };
};

var handleTeamSearchEnterKeyPress = function handleTeamSearchEnterKeyPress(event) {
  return function (dispatch) {
    if (event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation();
      dispatch(handleTeamSearch());
    }
  };
};

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_validators__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_error_actionTypes__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actionTypes__ = __webpack_require__(199);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return handleCaptainDetailsLinkClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleSaveVirtualEventEntriesBowlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVirtualEventDetailInfo; });
/* unused harmony export retrieveAvailableBowlers */
/* unused harmony export retrieveAvailableTeams */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return retrieveVirtualEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return handleVirtualEntrySelectChecked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handlePayBalanceClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handlePayBalanceOtherClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return handlePayBalanceOtherCancelClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return handlePaymentModalSubmitClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return handleVirtualEntryCancelClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return handleVirtualEntryReactivateClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return handleVirtualEntryRefundClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return handleVirtualEntryChangeCaptainSearchClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return handleVirtualEntryChangeCaptainCancelClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return validateVirtualEntryCaptainChangeForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return handleChangeVirtualEntriesCaptainFormSave; });
/* unused harmony export handleChangeVirtualEntryCaptainFormSave */
/* unused harmony export loadCaptainVirtualEntries */
/* unused harmony export changeVirtualEntryCaptain */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var handleCaptainDetailsLinkClick = function handleCaptainDetailsLinkClick() {
  return function (dispatch, getState) {
    var captainId = getState().admin.virtualEventDetail.captainId;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["b" /* navigateTo */])('admin/captain/' + captainId));
  };
};

var handleSaveVirtualEventEntriesBowlers = function handleSaveVirtualEventEntriesBowlers(virtualEventId) {
  return function (dispatch, getState) {
    var state = getState();
    var captainId = state.admin.virtualEventDetail.captainId;
    var virtualEntries = state.admin.virtualEventDetail.virtualEntries.filter(function (virtualEntry) {
      return !virtualEntry.isCancelled;
    });

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["b" /* displayVirtualEventSubmitting */])(true));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["g" /* putJsonAsync */])('admin/virtualevent/' + virtualEventId + '/captain/' + captainId + '/virtualentry', { virtualEntries: virtualEntries })).then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["b" /* displayVirtualEventSubmitting */])(false));
      __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Saved!', 'Virtual entries saved successfully.');
    }).catch(function () {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["b" /* displayVirtualEventSubmitting */])(false));
    });
  };
};

var getVirtualEventDetailInfo = function getVirtualEventDetailInfo(captainId, virtualEventId, paymentId) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('admin/virtualevent/' + virtualEventId + '/captain/' + captainId)).then(function (response) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["c" /* setVirtualEventDetailsInState */])(response));
        resolve(response);
      }).catch(function () {
        return reject();
      });

      if (paymentId) {
        dispatch(virtualEventPayment(captainId, virtualEventId, paymentId));
      }
    });
  };
};

var virtualEventPayment = function virtualEventPayment(captainId, virtualEventId, paymentId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])('admin/virtualevent/payment/credit', {
      BypassWebHooks: localStorage.bypassWebHooks,
      captainId: captainId,
      paymentId: paymentId,
      virtualEventId: virtualEventId
    })).then(function (response) {
      if (response) __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Payment Processed!', 'Selected entries were paid successfully.');
      dispatch(getVirtualEventDetailInfo(captainId, virtualEventId));
      dispatch(retrieveVirtualEntries(captainId, virtualEventId));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["d" /* setSelectedBalance */])(0));
    });

    if (localStorage.bypassWebHooks) delete localStorage.bypassWebHooks;
  };
};

var retrieveAvailableBowlers = function retrieveAvailableBowlers(captainId, virtualEventId) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('admin/virtualevent/' + virtualEventId + '/captain/' + captainId + '/bowler')).then(function (bowlers) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["e" /* setAvailableTeamsInState */])(null));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["f" /* setAvailableBowlersInState */])(bowlers));
        resolve(bowlers);
      }).catch(function () {
        return reject();
      });
    });
  };
};

var retrieveAvailableTeams = function retrieveAvailableTeams(captainId, virtualEventId) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('admin/virtualevent/' + virtualEventId + '/captain/' + captainId + '/teams')).then(function (teams) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["f" /* setAvailableBowlersInState */])(null));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["e" /* setAvailableTeamsInState */])(teams));
        resolve(teams);
      }).catch(function () {
        return reject();
      });
    });
  };
};

var retrieveVirtualEntries = function retrieveVirtualEntries(captainId, virtualEventId) {
  return function (dispatch, getState) {
    var eventOwner = getState().admin.virtualEventDetail.eventOwner;

    var promise = eventOwner._value === 'Team Entry' ? retrieveAvailableTeams(captainId, virtualEventId) : retrieveAvailableBowlers(captainId, virtualEventId);

    dispatch(promise).then(function () {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('admin/virtualevent/' + virtualEventId + '/captain/' + captainId + '/virtualentry')).then(function (virtualEntries) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["a" /* setVirtualEntriesInState */])(virtualEntries));
      });
    });
  };
};

var handleVirtualEntrySelectChecked = function handleVirtualEntrySelectChecked(virtualEntryId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["g" /* setVirtualEntrySelected */])(virtualEntryId));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["h" /* calculateSelectedBalance */])());
  };
};

var handlePayBalanceClick = function handlePayBalanceClick() {
  return function (dispatch, getState) {
    var state = getState();
    var captainId = state.admin.virtualEventDetail.captainId;
    var tournament = state.admin.virtualEventDetail.tournament;
    var virtualEventId = state.admin.virtualEventDetail.virtualEventId;

    var virtualEntries = state.admin.virtualEventDetail.virtualEntries.filter(function (virtualEntry) {
      return virtualEntry.selected;
    }).map(function (virtualEntry) {
      return virtualEntry.id;
    });

    var body = {
      captainId: captainId,
      source: 'virtualEventDetail',
      tournamentId: tournament.id,
      virtualEntries: virtualEntries,
      virtualEventId: virtualEventId
    };

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])('admin/virtualEvent/createSession', body)).then(function (response) {
      var publishableKey = tournament.stripePublishableKey;
      var stripe = window.Stripe(publishableKey);
      var sessionId = response.paymentId;

      stripe.redirectToCheckout({
        sessionId: sessionId
      });
    });
  };
};

var handlePayBalanceOtherClick = function handlePayBalanceOtherClick() {
  return function (dispatch, getState) {
    var amount = getState().admin.virtualEventDetail.selectedBalance;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["initialize"])('adminVirtualEntryPaymentForm', {
      amount: amount
    }));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["i" /* displayVirtualEntryDetailPaymentModal */])(true, 'Payment'));
  };
};

var handlePayBalanceOtherCancelClick = function handlePayBalanceOtherCancelClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_error_actionTypes__["a" /* setErrorList */])([]));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["i" /* displayVirtualEntryDetailPaymentModal */])(false));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reset"])('adminVirtualEntryPaymentForm'));
  };
};

var handlePaymentModalSubmitClick = function handlePaymentModalSubmitClick(data) {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      var state = getState().admin.virtualEventDetail;
      var captainId = state.captainId;
      var virtualEventId = state.virtualEventId;
      var tournament = state.tournament;
      var refundType = state.refundType;
      var virtualEntries = state.virtualEntries.filter(function (virtualEntry) {
        return virtualEntry.selected;
      }).map(function (virtualEntry) {
        return virtualEntry.id;
      });

      if (data.stripeTransactionId) data.stripeTransactionId = data.stripeTransactionId.trim();
      var body = _extends({}, data, {
        tournamentId: tournament.id,
        captainId: captainId,
        virtualEntries: virtualEntries
      });

      data = _extends({}, data, {
        refundOnly: refundType === 'refundOnly'
      });

      if (state.paymentModalType === 'Payment') {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])('admin/virtualEvent/payment/other', body)).then(function () {
          __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Saved!', 'Payment was successfully saved.');
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_error_actionTypes__["a" /* setErrorList */])([]));
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["i" /* displayVirtualEntryDetailPaymentModal */])(false));
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reset"])('adminVirtualEntryPaymentForm'));
          dispatch(getVirtualEventDetailInfo(captainId, virtualEventId));
          dispatch(retrieveVirtualEntries(captainId, virtualEventId));
          resolve();
        }).catch(function () {
          return reject();
        });
      } else if (state.paymentModalType === 'Refund') {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])('admin/virtualevent/virtualEntry/cancel', data)).then(function () {
          __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Canceled!', 'Selected Virtual Entry was successfully canceled');
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_error_actionTypes__["a" /* setErrorList */])([]));
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["i" /* displayVirtualEntryDetailPaymentModal */])(false));
          dispatch(getVirtualEventDetailInfo(captainId, virtualEventId));
          dispatch(retrieveVirtualEntries(captainId, virtualEventId));
          resolve();
        }).catch(function () {
          return reject();
        });
      }
    });
  };
};

var handleVirtualEntryCancelClick = function handleVirtualEntryCancelClick(virtualEntryId) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('admin/entry/' + virtualEntryId + '/payment/creditLog')).then(function (response) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["j" /* setCreditPurchaseTransactions */])(response.payments));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["initialize"])('adminVirtualEntryPaymentForm', { virtualEntryId: virtualEntryId }));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["i" /* displayVirtualEntryDetailPaymentModal */])(true, 'Refund'));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["k" /* setRefundTypeForAdminVirtualEntryDetail */])('refundWithCancellation'));
        resolve();
      }).catch(function (error) {
        return reject(error);
      });
    });
  };
};

var handleVirtualEntryReactivateClick = function handleVirtualEntryReactivateClick(virtualEntryId) {
  return function (dispatch, getState) {
    var state = getState().admin.virtualEventDetail;
    var captainId = state.captainId;
    var virtualEventId = state.virtualEventId;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])('admin/virtualEvent/virtualEntry/reactivate', { virtualEntryId: virtualEntryId })).then(function () {
      __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Reactivated!', 'Selected Virtual Entry has been reactivated');
      dispatch(getVirtualEventDetailInfo(captainId, virtualEventId));
      dispatch(retrieveVirtualEntries(captainId, virtualEventId));
    }).catch(function () {
      __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].error('Error', 'There was an error reactivating the selected virtual entry.');
    });
  };
};

var handleVirtualEntryRefundClick = function handleVirtualEntryRefundClick(virtualEntryId) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('admin/entry/' + virtualEntryId + '/payment/creditLog')).then(function (response) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["j" /* setCreditPurchaseTransactions */])(response.payments));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["initialize"])('adminVirtualEntryPaymentForm', { virtualEntryId: virtualEntryId }));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["i" /* displayVirtualEntryDetailPaymentModal */])(true, 'Refund'));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["k" /* setRefundTypeForAdminVirtualEntryDetail */])('refundOnly'));
        resolve();
      }).catch(function (error) {
        return reject(error);
      });
    });
  };
};

var handleVirtualEntryChangeCaptainSearchClick = function handleVirtualEntryChangeCaptainSearchClick() {
  return function (dispatch, getState) {
    var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["formValueSelector"])('CaptainVirtualEntryChangeForm');
    var captainEmail = selector(getState(), 'captainEmail');
    var virtualEventDetail = getState().admin.virtualEventDetail;
    var virtualEventId = virtualEventDetail.virtualEventId;
    var selectedVirtualEntries = virtualEventDetail.selectedVirtualEntries;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('admin/captain/' + captainEmail + '/email/' + virtualEventId)).then(function (response) {
      if (response) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["change"])('CaptainVirtualEntryChangeForm', 'captainFirstName', response.captainFirstName));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["change"])('CaptainVirtualEntryChangeForm', 'captainLastName', response.captainLastName));
        if (response.purchasableVirtualEntryCount < selectedVirtualEntries.length) {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_error_actionTypes__["a" /* setErrorList */])(['The selected captain can support at most ' + response.purchasableVirtualEntryCount + ' virtual \n        entr' + (response.purchasableVirtualEntryCount !== 1 ? 'ies' : 'y') + ' and you have selected ' + selectedVirtualEntries.length + ' \n        virtual entr' + (selectedVirtualEntries.length !== 1 ? 'ies' : 'y') + '. Please either select a different captain or fewer \n        virtual entries.']));
        } else {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_error_actionTypes__["a" /* setErrorList */])([]));
        }
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["l" /* setIsNewCaptainOnSearch */])(false));
      } else {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["change"])('CaptainVirtualEntryChangeForm', 'captainFirstName', ''));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["change"])('CaptainVirtualEntryChangeForm', 'captainLastName', ''));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["l" /* setIsNewCaptainOnSearch */])(true));
      }
    }).catch(function () {
      __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].error('Error getting captain detail!', 'There was an error getting captain detail.');
    });
  };
};

var handleVirtualEntryChangeCaptainCancelClick = function handleVirtualEntryChangeCaptainCancelClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["m" /* hideVirtualEntryDetailChangeCaptainModal */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reset"])('CaptainVirtualEntryChangeForm'));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_error_actionTypes__["a" /* setErrorList */])([]));
  };
};

var validateVirtualEntryCaptainChangeForm = function validateVirtualEntryCaptainChangeForm(data) {
  var errors = {};

  if (!data.captainEmail || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_validators__["a" /* validateEmail */])(data.captainEmail)) {
    errors.captainEmail = 'Please provide a valid email.';
  }

  if (!data.captainFirstName) {
    errors.captainFirstName = 'Please search for the captain before updating.';
  }

  return errors;
};

var handleChangeVirtualEntriesCaptainFormSave = function handleChangeVirtualEntriesCaptainFormSave(data) {
  return function (dispatch, getState) {
    return new Promise(function () {
      var virtualEventDetail = getState().admin.virtualEventDetail;
      var virtualEntries = virtualEventDetail.selectedVirtualEntries.map(function (entry) {
        return entry.id;
      });

      var entryData = _extends({}, data, {
        captainId: virtualEventDetail.captainId,
        virtualEventId: virtualEventDetail.virtualEventId,
        virtualEntries: virtualEntries
      });

      dispatch(handleChangeVirtualEntryCaptainFormSave(entryData));
    });
  };
};

var handleChangeVirtualEntryCaptainFormSave = function handleChangeVirtualEntryCaptainFormSave(data) {
  return function (dispatch) {
    return new Promise(function () {
      var entryId = data.virtualEntries.shift();

      var entryData = _extends({}, data, {
        entries: data.virtualEntries
      });

      var request = {
        virtualEntryId: entryId,
        firstName: data.captainFirstName,
        lastName: data.captainLastName,
        email: data.captainEmail
      };

      dispatch(changeVirtualEntryCaptain(request)).then(function () {
        if (data.virtualEntries.length === 0) {
          dispatch(loadCaptainVirtualEntries(data.captainId, data.virtualEventId));
          dispatch(handleVirtualEntryChangeCaptainCancelClick());
        } else {
          // Next Entry 
          dispatch(handleChangeVirtualEntryCaptainFormSave(entryData));
        }
      });
    });
  };
};

var loadCaptainVirtualEntries = function loadCaptainVirtualEntries(captainId, virtualEventId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('admin/virtualevent/' + virtualEventId + '/captain/' + captainId + '/virtualentry')).then(function (response) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["a" /* setVirtualEntriesInState */])(response));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["h" /* calculateSelectedBalance */])());
    });
  };
};

var changeVirtualEntryCaptain = function changeVirtualEntryCaptain(request) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])('admin/captain/change/virtualentry', request)).then(function () {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["m" /* hideVirtualEntryDetailChangeCaptainModal */])());
        __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Captain Changed!', 'Captain was changed.');
        resolve();
      }).catch(function () {
        __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].error('Captain Not Changed!', 'There was an error changing the captain.');
        resolve();
      });
    });
  };
};

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(877);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadFinancialAccountFees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleDefaultTechFeeEditClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handleDefaultTechFeeModalCancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return handleDefaultTechFeeModalSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleTournamentTechFeeEditClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return handleTournamentTechFeeModalCancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handleTournamentTechFeeModalSave; });





var loadFinancialAccountFees = function loadFinancialAccountFees() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["d" /* getJsonAsync */])('finance/gettechfees')).then(function (data) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["a" /* displayFinancialFeesList */])(data));
    }).catch(function () {});
  };
};

var handleDefaultTechFeeEditClick = function handleDefaultTechFeeEditClick() {
  return function (dispatch, getState) {

    var fee = getState().finance.fees.feesList.defaultTechnologyFee;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["b" /* displayDefaultTechFeeModalVisibility */])(true));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["initialize"])('groupTechFeeForm', { fee: fee }));
    setTimeout(function () {
      // focus field after animatation finished (~800ms) by directly accessing the dom
      document.querySelectorAll('.modal-dialog #groupTechFeeForm [name=fee]')[0].focus();
    }, 800);
  };
};

var handleDefaultTechFeeModalCancel = function handleDefaultTechFeeModalCancel() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["b" /* displayDefaultTechFeeModalVisibility */])(false));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["reset"])('groupTechFeeForm'));
  };
};

var handleDefaultTechFeeModalSave = function handleDefaultTechFeeModalSave(data) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["e" /* postJsonAsync */])('finance/updatedefaulttechfee', data)).then(function () {
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Saved!', 'Default technology fee successfully saved.');
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["b" /* displayDefaultTechFeeModalVisibility */])(false));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["reset"])('groupTechFeeForm'));
        dispatch(loadFinancialAccountFees());
        resolve();
      }).catch(function (error) {
        return reject(error);
      });
    });
  };
};

var handleTournamentTechFeeEditClick = function handleTournamentTechFeeEditClick(tournamentId) {
  return function (dispatch, getState) {
    var fee = getState().finance.fees.defaultTechFee;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["c" /* displayTournamentTechFeeModalVisibility */])(true));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["initialize"])('tournamentTechFeeForm', { fee: fee, tournamentId: tournamentId }));

    setTimeout(function () {
      // focus field after animatation finished (~800ms) by directly accessing the dom
      document.querySelectorAll('.modal-dialog #tournamentTechFeeForm [name=fee]')[0].focus();
    }, 800);
  };
};

var handleTournamentTechFeeModalCancel = function handleTournamentTechFeeModalCancel() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["c" /* displayTournamentTechFeeModalVisibility */])(false));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["reset"])('tournamentTechFeeForm'));
  };
};

var handleTournamentTechFeeModalSave = function handleTournamentTechFeeModalSave(data) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["e" /* postJsonAsync */])('finance/updateTournamentTechFee', data)).then(function () {
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Saved!', 'Tournament technology fee successfully saved.');
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["c" /* displayTournamentTechFeeModalVisibility */])(false));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["reset"])('tournamentTechFeeForm'));
        dispatch(loadFinancialAccountFees());
        resolve();
      }).catch(function (error) {
        return reject(error);
      });
    });
  };
};

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_eventPriceDetailsModal_actionTypes__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home_actionTypes__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actionTypes__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return handleSquadFeesButtonClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateTotalFromLocalStorage; });
/* unused harmony export updateSquadInLocalStorage */
/* unused harmony export clearSquadQuantity */
/* unused harmony export updateSquadCartCount */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return handleEventSquadAddClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleDateSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return resetInformation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkRestrictions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return retrieveAvailableDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return handleBowlerOwnedVirtualEventAddClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return handleTeamOwnedVirtualEventAddClick; });
/* unused harmony export retrieveSquads */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return retrieveVirtualEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return checkout; });
/* unused harmony export updateBowlerOwnedVirtualEventCountCart */
/* unused harmony export updateTeamOwnedVirtualEventCountCart */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var handleSquadFeesButtonClick = function handleSquadFeesButtonClick(eventPrice, eventAddOnFees) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_eventPriceDetailsModal_actionTypes__["a" /* displayEventPriceDetailModal */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_eventPriceDetailsModal_actionTypes__["b" /* setEventPriceDetailData */])(eventPrice, eventAddOnFees));
  };
};

var updateTotalFromLocalStorage = function updateTotalFromLocalStorage() {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["a" /* updateTotal */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["h" /* getShoppingCart */])()));
  };
};

var updateSquadInLocalStorage = function updateSquadInLocalStorage(squadId, quantity) {
  return function (dispatch, getState) {
    var registrationState = getState().registration,
        events = registrationState.scheduler.events,
        tournamentId = registrationState.base.tournamentId;

    var shoppingCart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["h" /* getShoppingCart */])(),
        items = shoppingCart.squads.filter(function (x) {
      return x.id === squadId;
    }),
        item = items.length ? items[0] : null;

    if (item) {
      item.quantity += Number(quantity);
    } else {
      var squad = null;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var event = _step.value;

          squad = event.squads.find(function (_ref) {
            var id = _ref.id;
            return id === squadId;
          });
          if (squad) {
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (!squad) {
        throw new Error('Squad ' + squadId + ' not found in state');
      }
      shoppingCart.squads.push(_extends({}, squad, {
        quantity: quantity
      }));
    }

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["g" /* setShoppingCart */])(shoppingCart, tournamentId));
  };
};

var clearSquadQuantity = function clearSquadQuantity(squadId) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["b" /* updateSquadQuantity */])({
      squadId: squadId,
      addedToCart: true,
      inputValue: 0,
      max: 0
    }));
  };
};

var updateSquadCartCount = function updateSquadCartCount(squadId, quantity) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["c" /* updateSquadCountInCart */])(squadId, quantity));
  };
};

var handleEventSquadAddClick = function handleEventSquadAddClick(squadId, quantity) {
  return function (dispatch, getState) {
    var regState = getState().registration,
        tournamentId = regState.base.tournamentId,
        events = regState.scheduler.events,
        selectedDate = regState.scheduler.calendar.selectedDate;

    var bundledParentNumberOfBowlers = false; // hack: want to use isLinked but not set properly
    var squadsInCart = 0;

    events.forEach(function (event) {
      if (event.bundledParentNumberOfBowlers) {
        bundledParentNumberOfBowlers = true;
      }
      event.squads.forEach(function (squad) {
        if (squad.quantity > 0 || squad.countInCart && squad.countInCart > 0) {
          squadsInCart += 1;
        }
      });
    });

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["d" /* getJsonAsync */])('tournament/' + tournamentId + '/bundling')).then(function (squadBundling) {
      if (squadBundling === true && squadsInCart > 1 && !bundledParentNumberOfBowlers) {
        __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__["toastr"].warning('2nd Team Purchase', 'Teams can only be purchased for one squad time per day per order. To register for multiple team squad times on the same day, please process separate orders.');
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["b" /* updateSquadQuantity */])({
          squadId: squadId,
          addedToCart: false,
          inputValue: 0,
          max: 0
        }));
      } else {
        dispatch(updateSquadCartCount(squadId, quantity));
        dispatch(updateSquadInLocalStorage(squadId, quantity));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["a" /* updateTotal */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["h" /* getShoppingCart */])()));
        dispatch(clearSquadQuantity(squadId));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["d" /* displayGuideIfBundled */])(squadId));
        __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__["toastr"].success('Added to Cart!', 'Your selection was added to the cart.');
        dispatch(retrieveAvailableDates(tournamentId)).then(function () {
          return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["e" /* setSeletedDate */])(selectedDate));
        });
      }
    });
  };
};

var handleDateSelection = function handleDateSelection(selectedDate) {
  return function (dispatch) {
    // infinite-calendar uses moment for selected date
    var formattedDate = selectedDate;

    if (typeof selectedDate !== 'string') formattedDate = selectedDate.format('YYYY-MM-DD');

    dispatch(retrieveSquads(formattedDate));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["f" /* setSelectedDate */])(formattedDate));
  };
};

var resetInformation = function resetInformation() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["g" /* setNoDatesAvailable */])(false));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["h" /* displayAvailableDates */])({ visible: false }));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["i" /* displaySquads */])({
      events: [],
      cart: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["h" /* getShoppingCart */])()
    }));
  };
};

var checkRestrictions = function checkRestrictions(tournamentId) {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["d" /* getJsonAsync */])('tournament/' + tournamentId + '/restriction')).then(function (restrictions) {
        var authState = getState().shared.auth;
        var enforceMinimumCaptainAge = restrictions ? restrictions.enforceMinimumCaptainAge : false;
        var dobRaw = authState.dob;

        if (!authState.profileIsConfirmed) {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["b" /* navigateTo */])('registration'));
          reject('NeedToConfirmProfile');
          return;
        } else if (!authState.profileIsValid) {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["b" /* navigateTo */])('registration'));
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__home_actionTypes__["b" /* displayRequiredProfileFieldsModal */])(true));
          reject('MissingRequiredProfileFields');
          return;
        }

        if (enforceMinimumCaptainAge) {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__home_actionTypes__["f" /* setAgeInState */])(restrictions.minimumCaptainAge));

          var dob = new Date(dobRaw);
          var verificationDate = Date.now();
          var age = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration(verificationDate - dob).years();

          if (age < restrictions.minimumCaptainAge) {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["b" /* navigateTo */])('registration'));
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__home_actionTypes__["e" /* displayBirthDateModal */])(true));
            reject('MinimumCaptainAgeFailed');
          } else {
            resolve();
          }
        } else {
          resolve();
        }
      });
    });
  };
};

var retrieveAvailableDates = function retrieveAvailableDates(tournamentId) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["e" /* postJsonAsync */])('registration/tournament/' + tournamentId + '/dates', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["h" /* getShoppingCart */])())).then(function (data) {
        if (data) {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["h" /* displayAvailableDates */])({
            disabledDates: data.disabledDates.map(function (item) {
              return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.parseZone(item).format('YYYY-MM-DD');
            }),
            min: __WEBPACK_IMPORTED_MODULE_0_moment___default.a.parseZone(data.firstAvailableSquadDate).startOf('month').format('YYYY-MM-DD'),
            minDate: __WEBPACK_IMPORTED_MODULE_0_moment___default.a.parseZone(data.firstAvailableSquadDate).format('YYYY-MM-DD'),
            max: __WEBPACK_IMPORTED_MODULE_0_moment___default.a.parseZone(data.lastAvailableSquadDate).endOf('month').format('YYYY-MM-DD'),
            maxDate: __WEBPACK_IMPORTED_MODULE_0_moment___default.a.parseZone(data.lastAvailableSquadDate).format('YYYY-MM-DD'),
            selectedDate: null,
            visible: true
          }));
        } else {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["g" /* setNoDatesAvailable */])(true));
        }
        resolve(data);
      }).catch(function (error) {
        return reject(error);
      });
    });
  };
};

var handleBowlerOwnedVirtualEventAddClick = function handleBowlerOwnedVirtualEventAddClick(virtualEvent) {
  return function (dispatch, getState) {
    var shoppingCart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["h" /* getShoppingCart */])(),
        items = shoppingCart.virtualEvents.filter(function (x) {
      return x.id === virtualEvent.id;
    }),
        item = items.length ? items[0] : null,
        tournamentId = getState().registration.base.tournamentId;

    if (item) {
      item.quantity += virtualEvent.quantity;
    } else {
      shoppingCart.virtualEvents.push(virtualEvent);
    }

    dispatch(updateBowlerOwnedVirtualEventCountCart(virtualEvent.id, virtualEvent.quantity));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["g" /* setShoppingCart */])(shoppingCart, tournamentId));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["a" /* updateTotal */])(shoppingCart));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["j" /* updateBowlerOwnedVirtualEventQuantity */])(virtualEvent.id, 0)); // clear quantity field after adding to cart
    __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__["toastr"].success('Added to Cart!', 'Your selection was added to the cart.');
  };
};

var handleTeamOwnedVirtualEventAddClick = function handleTeamOwnedVirtualEventAddClick(virtualEvent) {
  return function (dispatch, getState) {
    var shoppingCart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["h" /* getShoppingCart */])(),
        items = shoppingCart.virtualEvents.filter(function (x) {
      return x.id === virtualEvent.id;
    }),
        item = items.length ? items[0] : null,
        tournamentId = getState().registration.base.tournamentId;

    if (item) {
      item.quantity += virtualEvent.quantity;
    } else {
      shoppingCart.virtualEvents.push(virtualEvent);
    }

    dispatch(updateTeamOwnedVirtualEventCountCart(virtualEvent.eventId, virtualEvent.id, virtualEvent.quantity));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["g" /* setShoppingCart */])(shoppingCart, tournamentId));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["a" /* updateTotal */])(shoppingCart));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["k" /* updateTeamOwnedVirtualEventQuantity */])(virtualEvent.eventId, virtualEvent.id, 0)); // clear quantity field after adding to cart
    __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__["toastr"].success('Added to Cart!', 'Your selection was added to the cart.');
  };
};

var retrieveSquads = function retrieveSquads(selectedDateString) {
  return function (dispatch, getState) {
    var tournamentId = getState().registration.base.tournamentId;

    var shoppingCart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["h" /* getShoppingCart */])();

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["e" /* postJsonAsync */])('registration/tournament/' + tournamentId + '/event/squad/' + selectedDateString, shoppingCart)).then(function (data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["i" /* displaySquads */])({
        events: data,
        cart: shoppingCart
      }));
    });
  };
};

var retrieveVirtualEvents = function retrieveVirtualEvents(tournamentId) {
  var captainView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["d" /* getJsonAsync */])('tournament/' + tournamentId + '/virtualevents?captainView=' + captainView)).then(function (virtualEvents) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["l" /* displayVirtualEvents */])({
        virtualEvents: virtualEvents,
        cart: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["h" /* getShoppingCart */])()
      }));
    });
  };
};

var checkout = function checkout() {
  return function (dispatch, getState) {
    var _getState$registratio = getState().registration.base,
        tournamentId = _getState$registratio.tournamentId,
        requireRosterBeforeCheckout = _getState$registratio.requireRosterBeforeCheckout;


    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["b" /* navigateTo */])(requireRosterBeforeCheckout ? 'registration/rostercheckout/' + tournamentId : 'registration/checkout/' + tournamentId));
  };
};

var updateBowlerOwnedVirtualEventCountCart = function updateBowlerOwnedVirtualEventCountCart(virtualEventId, quantity) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["m" /* updateBowlerOwnedVirtualEventCountInCart */])(virtualEventId, quantity));
  };
};

var updateTeamOwnedVirtualEventCountCart = function updateTeamOwnedVirtualEventCountCart(eventId, virtualEventId, quantity) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["n" /* updateTeamOwnedVirtualEventCountInCart */])(eventId, virtualEventId, quantity));
  };
};

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(1012);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleWebHooksClick; });


var handleWebHooksClick = function handleWebHooksClick(checked) {
    return function (dispatch) {
        localStorage.bypassWebHooks = checked;
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__actionTypes__["a" /* setWebHooks */])(checked));
    };
};

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tournamentList_actions__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actionTypes__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_validators__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_error_actionTypes__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_scroll__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_scroll__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return clearPreviousSessionVariables; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return handleCancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return handleCenterChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return handleLocationAddClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return handleLocationCancelClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return handleLocationRemoveClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return handleLocationSaveClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return handleLocationSearchClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return handleSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return handleTagAddClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return handleTagCancelClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return handleTagChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return handleTagNameChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return handleTagRemoveClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return handleTagSaveClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return retrieveCards; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return retrieveDataExportOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return retrieveLocations; });
/* unused harmony export retrieveLocationsByStateData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return retrieveSelectedCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return retrieveSelectedExportOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return retrieveSelectedStripeAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return retrieveStripeAccounts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return retrieveTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return retrieveThemes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return retrieveTimeZones; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setupTournamentForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return validate; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();












var endOfDayDateTimeFormat = 'YYYY-MM-DD 23:59:59.000000';

var clearPreviousSessionVariables = function clearPreviousSessionVariables() {
  return function (dispatch, getState) {
    var stateInformation = getState();

    stateInformation.tournament.general.locations = [];
    stateInformation.tournament.base.tournamentInfo.id = null;
  };
};

// -- Handlers --

var handleCancel = function handleCancel() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["b" /* navigateTo */])('tournament'));
  };
};

var handleCenterChange = function handleCenterChange(certificationNumber) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["a" /* displayCenterSaveButton */])(certificationNumber ? true : false));

    if (certificationNumber) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["b" /* setLocationCertificationNumber */])(certificationNumber));
    }
  };
};

var handleLocationAddClick = function handleLocationAddClick() {
  return function (dispatch, getState) {
    var locations = getState().tournament.general.locations;
    var emptyLocation = {
      id: null,
      name: '',
      address: '',
      city: '',
      state: '',
      zipCode: '',
      certificationNumber: '',
      phone: ''
    };

    if (!locations.some(function (m) {
      return m.editing;
    })) {
      locations.push(emptyLocation);
    }

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["c" /* setTournamentLocations */])(locations));
    dispatch(registerLocationFields());
    dispatch(populateLocationFields(emptyLocation));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["d" /* toggleTournamentLocationEditing */])(null));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["a" /* displayCenterSaveButton */])(false));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["e" /* displayCentersDropdownList */])(false));
  };
};

var handleLocationCancelClick = function handleLocationCancelClick() {
  return function (dispatch, getState) {
    var tournamentId = getState().tournament.base.tournamentInfo.id;

    getState().tournament.general.locationName = '';
    getState().tournament.general.locationSearchResults.length = 0;
    if (tournamentId) {
      dispatch(retrieveLocations(tournamentId));
    } else {
      var locations = getState().tournament.general.locations;

      locations = locations.filter(function (x) {
        return x.certificationNumber !== '';
      });
      dispatch(retrieveLocationsByStateData(locations));
    }
  };
};

var handleLocationRemoveClick = function handleLocationRemoveClick(certificationNumber) {
  return function (dispatch, getState) {
    var tournamentId = getState().tournament.base.tournamentInfo.id;

    if (tournamentId) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])('setup/tournament/' + tournamentId + '/location/' + certificationNumber + '/remove')).then(function () {
        dispatch(retrieveLocations(tournamentId));
      });
    } else {
      var locations = getState().tournament.general.locations;

      locations = locations.filter(function (x) {
        return x.certificationNumber !== certificationNumber;
      });
      dispatch(retrieveLocationsByStateData(locations));
    }
    __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Removed!', 'Tournament Location Removed Successfully.');
  };
};

var handleLocationSaveClick = function handleLocationSaveClick() {
  return function (dispatch, getState) {
    var tournamentId = getState().tournament.base.tournamentInfo.id;
    var certificationNumber = getState().tournament.general.certificationNumber;
    var zLocationSearchResults = getState().tournament.general.locationSearchResults;
    var name = zLocationSearchResults.filter(function (item) {
      return item.zCertificationNumber === certificationNumber;
    }).map(function (item) {
      return item.zName;
    })[0];
    var zipCode = zLocationSearchResults.filter(function (item) {
      return item.zCertificationNumber === certificationNumber;
    }).map(function (item) {
      return item.zZipCode;
    })[0];
    var city = zLocationSearchResults.filter(function (item) {
      return item.zCertificationNumber === certificationNumber;
    }).map(function (item) {
      return item.zCity;
    })[0];
    var state = zLocationSearchResults.filter(function (item) {
      return item.zCertificationNumber === certificationNumber;
    }).map(function (item) {
      return item.zState;
    })[0];
    var phone = zLocationSearchResults.filter(function (item) {
      return item.zCertificationNumber === certificationNumber;
    }).map(function (item) {
      return item.zPhone;
    })[0];
    var id = "";

    if (tournamentId) {
      id = tournamentId;
    } else if (certificationNumber) {
      id = certificationNumber;
    }
    var data = {
      certificationNumber: certificationNumber,
      tournamentId: tournamentId
    };
    var data2 = {
      certificationNumber: certificationNumber,
      tournamentId: tournamentId,
      city: city,
      state: state,
      name: name,
      zipCode: zipCode,
      phone: phone,
      id: id
    };

    var data3 = [];

    data3.push(data2);
    if (!tournamentId) {

      var locations = getState().tournament.general.locations;

      locations = locations.filter(function (x) {
        return x.certificationNumber !== '';
      });
      locations.push(data2);
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["c" /* setTournamentLocations */])(locations));
      __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Saved!', 'Tournament Location Saved Successfully.');
      return;
    }

    var promise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])('setup/tournament/' + tournamentId + '/location', data);

    dispatch(promise).then(function () {
      __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Saved!', 'Tournament Location Saved Successfully.');
      dispatch(retrieveLocations(tournamentId));
    });
  };
};

var handleLocationSearchClick = function handleLocationSearchClick() {
  return function (dispatch, getState) {
    var tournamentId = getState().tournament.base.tournamentInfo.id;
    var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["formValueSelector"])('tournamentSetup');
    var name = selector(getState(), 'tournamentLocationName');
    var zipCode = selector(getState(), 'tournamentLocationZipCode');
    var certificationNumber = selector(getState(), 'tournamentLocationCertificationNumber');
    var data = {
      name: name,
      zipCode: zipCode,
      certificationNumber: certificationNumber,
      tournamentId: tournamentId
    };
    var promise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])('setup/tournament/locationSearch', data);

    dispatch(promise).then(function (results) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["f" /* setTournamentLocationSearchResults */])(results.centers.map(function (_ref) {
        var certificationNumber = _ref.certificationNumber,
            name = _ref.name,
            city = _ref.city,
            state = _ref.state,
            zipCode = _ref.zipCode,
            phone = _ref.phone,
            lanesAvailable = _ref.lanesAvailable;
        return {
          value: certificationNumber,
          label: name + ' (#' + certificationNumber + '), ' + city + ', ' + state + ' ' + zipCode,
          zZipCode: zipCode,
          zName: name,
          zCity: city,
          zState: state,
          zCertificationNumber: certificationNumber,
          zPhone: phone,
          zlanesAvailable: lanesAvailable
        };
      })));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["e" /* displayCentersDropdownList */])(results.centers.length > 0 ? true : false));
    });
  };
};

var handleSave = function handleSave(data) {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var locations = getState().tournament.general.locations;
      var tagIndex = getState().tournament.general.tagIndex;
      var tournamentTags = getState().tournament.general.tournamentTags;
      var groupName = getState().shared.auth.groupName;
      var isAllowed = getState().shared.auth.isAllowed;

      var certificationNumberList = [];

      Object.entries(locations).forEach(function (entry) {
        var _entry = _slicedToArray(entry, 2),
            value = _entry[1];

        if (value.certificationNumber) {
          certificationNumberList.push(value.certificationNumber);
        }
      });

      if ((!locations || locations.length == 0 || certificationNumberList.length == 0) && tagIndex === null && (!tournamentTags || tournamentTags.length == 0) && isAllowed && groupName) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_error_actionTypes__["a" /* setErrorList */])(['Please provide location(s) for this tournament.', 'Please provide a tag for this tournament.']));
        setTimeout(function () {
          var elements = document.querySelectorAll('#sharedErrorList');
          __WEBPACK_IMPORTED_MODULE_9_react_scroll__["animateScroll"].scrollTo(elements[0].parentNode.offsetTop);
        }, 800);
        resolve();
        return;
      }

      if (!locations || locations.length == 0 || certificationNumberList.length == 0) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_error_actionTypes__["a" /* setErrorList */])(['Please provide location(s) for this tournament.']));
        setTimeout(function () {
          var elements = document.querySelectorAll('#sharedErrorList');
          __WEBPACK_IMPORTED_MODULE_9_react_scroll__["animateScroll"].scrollTo(elements[0].parentNode.offsetTop);
        }, 800);
        resolve();
        return;
      }

      if (tagIndex === null && (!tournamentTags || tournamentTags.length == 0) && isAllowed && groupName) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_error_actionTypes__["a" /* setErrorList */])(['Please provide a tag for this tournament.']));
        setTimeout(function () {
          var elements = document.querySelectorAll('#sharedErrorList');
          __WEBPACK_IMPORTED_MODULE_9_react_scroll__["animateScroll"].scrollTo(elements[0].parentNode.offsetTop);
        }, 800);
        resolve();
        return;
      }

      // scrub times from datepicker values
      data.startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.startDate).format('YYYY-MM-DD');
      data.endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.endDate).format(endOfDayDateTimeFormat);
      data.registrationCloseDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.registrationCloseDate).format(endOfDayDateTimeFormat);
      data.LocationCertificationNumberList = certificationNumberList;

      // default tournament phone (dirty solution, but having React/Redux challenges with refresh)
      if (!data.tournamentPhone || data.tournamentPhone && data.tournamentPhone.trim().length == 0) {
        data.tournamentPhone = "1-800-514-BOWL";
      }

      var promise = data.id ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["g" /* putJsonAsync */])('setup/tournament/' + data.id, data) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])('setup/tournament', data);

      dispatch(promise).then(function () {
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Saved!', 'Tournament saved Successfully.');
        resolve();
        if (!data.id) {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["b" /* navigateTo */])('tournament'));
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tournamentList_actions__["a" /* retrieveTournaments */])());
        } else {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["initialize"])('tournamentSetup', data));
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["n" /* loadTournament */])(data.id));
        }
      }).catch(function () {
        return resolve();
      });
    });
  };
};

var handleTagAddClick = function handleTagAddClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["registerField"])('tournamentSetup', 'tournamentTagName', 'Field'));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])('tournamentSetup', 'tournamentTagName', ''));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["g" /* setIsAddingTag */])(true));
  };
};

var handleTagCancelClick = function handleTagCancelClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["g" /* setIsAddingTag */])(false));
  };
};

var handleTagChange = function handleTagChange(value) {
  return function (dispatch, getState) {
    var tags = getState().tournament.general.tags;
    var tagIndex = tags.findIndex(function (x) {
      return x.value === value;
    }).toString();
    var isNewTournament = getState().tournament.general.isNewTournament;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])('tournamentSetup', 'tournamentTagName', tags[tagIndex].label));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["h" /* setCanAssignTag */])(value != null));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["i" /* setCanDeleteTag */])(value != null && !isNewTournament));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["j" /* setTagIndex */])(tagIndex));
  };
};

var handleTagNameChange = function handleTagNameChange(value) {
  return function (dispatch) {
    var filteredValue = value.replace(/[^a-zA-Z0-9\s]/g, '');
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])('tournamentSetup', 'tournamentTagName', filteredValue));
  };
};

var handleTagRemoveClick = function handleTagRemoveClick(tagId) {
  return function (dispatch, getState) {
    var tournamentId = getState().tournament.base.tournamentInfo.id;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])('setup/tournament/' + tournamentId + '/tournamentTag/' + tagId + '/remove')).then(function () {
      dispatch(retrieveTags(tournamentId));
    });
  };
};

var handleTagSaveClick = function handleTagSaveClick() {
  return function (dispatch, getState) {
    var tournamentId = getState().tournament.base.tournamentInfo.id;

    if (tournamentId) {
      var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["formValueSelector"])('tournamentSetup');
      var tournamentTagName = selector(getState(), 'tournamentTagName');
      var data = {
        tournamentId: tournamentId,
        value: tournamentTagName ? tournamentTagName : ''
      };

      if (data && data.value.length > 0) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])('setup/tournament/' + tournamentId + '/tournamentTag', data)).then(function () {
          __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Saved!', 'Tournament tag saved successfully.');
          dispatch(retrieveTags(tournamentId));
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["g" /* setIsAddingTag */])(false));
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["h" /* setCanAssignTag */])(false));
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["i" /* setCanDeleteTag */])(false));
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["registerField"])('tournamentSetup', 'tournamentTagName', 'Field'));
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])('tournamentSetup', 'tournamentTagName', ''));
        });
      }
    } else {
      var _selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["formValueSelector"])('tournamentSetup');
      var _tournamentTagName = _selector(getState(), 'tournamentTagName');

      var newTag = {
        label: _tournamentTagName,
        value: _tournamentTagName,
        editing: false
      };

      var tags = getState().tournament.general.tags;
      tags.push(newTag);
      var tagIndex = tags.findIndex(function (x) {
        return x.value === newTag.value;
      }).toString();
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["j" /* setTagIndex */])(tagIndex));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["g" /* setIsAddingTag */])(false));
    }
  };
};

// -- Retrievers --

var retrieveCards = function retrieveCards() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('setup/tournament/campaigns/cards')).then(function (data) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["k" /* setCards */])(data.map(function (_ref2) {
        var value = _ref2.value,
            id = _ref2.id;
        return {
          label: value,
          value: id
        };
      })));
    });
  };
};

var retrieveDataExportOptions = function retrieveDataExportOptions() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('export/tournament')).then(function (data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["l" /* setDataExportOptions */])(data.map(function (_ref3) {
        var id = _ref3.id,
            description = _ref3.description;
        return {
          value: id,
          label: description
        };
      })));
    });
  };
};

var retrieveLocations = function retrieveLocations(tournamentId) {
  return function (dispatch) {
    if (tournamentId) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('setup/tournament/' + tournamentId + '/locations')).then(function (data) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["c" /* setTournamentLocations */])(data));
      });
    } else {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["c" /* setTournamentLocations */])());
    }
  };
};

var retrieveLocationsByStateData = function retrieveLocationsByStateData(locationsData) {
  return function (dispatch) {
    if (locationsData) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["c" /* setTournamentLocations */])(locationsData));
    } else {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["c" /* setTournamentLocations */])());
    }
  };
};

var retrieveSelectedCard = function retrieveSelectedCard(cardId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["m" /* setCardSelection */])({ value: cardId }));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])('tournamentSetup', 'cardSelection', cardId));
  };
};

var retrieveSelectedExportOption = function retrieveSelectedExportOption(exportId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["n" /* setExportSelection */])({ value: exportId }));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])('tournamentSetup', 'exportSelection', exportId));
  };
};

var retrieveSelectedStripeAccount = function retrieveSelectedStripeAccount(stripeAccountId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["o" /* setStripeAccountSelection */])({ value: stripeAccountId }));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])('tournamentSetup', 'stripeAccountSelection', stripeAccountId));
  };
};

var retrieveStripeAccounts = function retrieveStripeAccounts() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('setup/tournament/stripeAccounts')).then(function (data) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["p" /* setStripeAccounts */])(data.map(function (_ref4) {
        var stripeAccountName = _ref4.stripeAccountName,
            stripeAccountId = _ref4.stripeAccountId;
        return {
          value: stripeAccountId,
          label: stripeAccountName
        };
      })));
    });
  };
};

var retrieveTags = function retrieveTags(tournamentId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["q" /* setIsNewTournament */])(true));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["h" /* setCanAssignTag */])(false));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["i" /* setCanDeleteTag */])(false));

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('setup/tournament/campaigns/tags')).then(function (data) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["r" /* setAvailableTags */])(data.map(function (_ref5) {
        var value = _ref5.value,
            id = _ref5.id;
        return {
          label: value,
          value: id
        };
      })));

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])('tournamentSetup', 'tagId', null));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["j" /* setTagIndex */])(null));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["s" /* setTournamentTags */])(null));
    }).catch(function (error) {
      console.error('Error fetching setup/tournament/campaigns/tags:', error);
    });

    if (tournamentId !== undefined) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["q" /* setIsNewTournament */])(false));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["h" /* setCanAssignTag */])(true));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["i" /* setCanDeleteTag */])(true));

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('setup/tournament/' + tournamentId + '/tournamentCampaigns/tags')).then(function (tags) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["s" /* setTournamentTags */])(tags.map(function (_ref6) {
          var value = _ref6.value,
              id = _ref6.id;
          return {
            label: value,
            value: id
          };
        })));

        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])('tournamentSetup', 'tagId', null));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["j" /* setTagIndex */])(null));
      });
    }
  };
};

var retrieveThemes = function retrieveThemes() {
  return function (dispatch) {
    // just listing the themes here for now, eventually this should be an API call
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["t" /* displayThemes */])([{ label: 'Blue', value: 'blue' }, { label: 'Red', value: 'red' }, { label: 'Orange', value: 'orange' }]));
  };
};

var retrieveTimeZones = function retrieveTimeZones() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('timezones')).then(function (data) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actionTypes__["u" /* displayTimeZones */])(data.map(function (_ref7) {
        var id = _ref7.id,
            value = _ref7.value;
        return {
          value: id,
          label: value
        };
      })));
    });
  };
};

// -- Initialization --

var setupTournamentForm = function setupTournamentForm() {
  return function (dispatch, getState) {
    var data = getState().tournament.base.tournamentInfo;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["initialize"])('tournamentSetup', _extends({}, data, {
      endDate: __WEBPACK_IMPORTED_MODULE_0_moment___default.a.parseZone(data.endDate).format(endOfDayDateTimeFormat),
      startDate: __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc(data.startDate).format('YYYY-MM-DD'),
      registrationCloseDate: data.registrationCloseDate ? __WEBPACK_IMPORTED_MODULE_0_moment___default.a.parseZone(data.registrationCloseDate).format(endOfDayDateTimeFormat) : null
    })));
  };
};

// -- Validation --

var validate = function validate(data) {
  var errors = {};
  var currentDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD');

  data.startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.startDate).format('YYYY-MM-DD');
  data.endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.endDate).format(endOfDayDateTimeFormat);
  data.registrationCloseDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.registrationCloseDate).format(endOfDayDateTimeFormat);

  if (!data.name) {
    errors.name = 'Please provide a name for this tournament.';
  }

  if (!data.startDate || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_validators__["b" /* validateDate */])(data.startDate)) {
    errors.startDate = 'Please set the tournament Start Date';
  }

  if (!data.endDate || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_validators__["b" /* validateDate */])(data.endDate)) {
    errors.endDate = 'Please set the tournament End Date.';
  } else if (data.endDate && data.endDate < currentDate) {
    errors.endDate = 'End Date cannot be in the past';
  }

  if (data.startDate && data.endDate && data.startDate > data.endDate) {
    errors.startDate = 'Start Date must be older than or equal to End Date';
    errors.endDate = 'End Date must be equal to or later than Start Date!';
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_validators__["b" /* validateDate */])(data.registrationCloseDate)) {
    errors.registrationCloseDate = 'Please set the tournament registration Close Date.';
  } else if (data.endDate && data.registrationCloseDate && data.registrationCloseDate > data.endDate) {
    errors.registrationCloseDate = 'Registration Date cannot be after the End Date';
  } else if (data.registrationCloseDate && data.registrationCloseDate < currentDate) {
    errors.registrationCloseDate = 'Registration Date cannot be in the past';
  }

  if (typeof data.defaultAverage !== 'number' && !data.defaultAverage || data.defaultAverage < 0 || data.defaultAverage > 300) {
    errors.defaultAverage = 'A bowling average is required and must be between 0 and 300';
  }

  if (!data.timeZone) {
    errors.timeZone = 'Please set the tournament Time Zone.';
  }

  if (!data.bccEmail || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_validators__["a" /* validateEmail */])(data.bccEmail)) {
    errors.bccEmail = 'Please provide a valid email.';
  }

  if (!data.exportId) {
    errors.exportId = 'Please select a tournament management system for this tournament.';
  }

  return errors;
};

// -- Local Methods --

var populateLocationFields = function populateLocationFields(location) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])('tournamentSetup', 'tournamentLocationName', location.name));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])('tournamentSetup', 'tournamentLocationAddress', location.address));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])('tournamentSetup', 'tournamentLocationCity', location.city));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])('tournamentSetup', 'tournamentLocationState', location.state));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])('tournamentSetup', 'tournamentLocationZipCode', location.zipCode));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])('tournamentSetup', 'tournamentLocationCertificationNumber', location.certificationNumber));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])('tournamentSetup', 'tournamentLocationPhone', location.phone));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])('tournamentSetup', 'tournamentLocationSearchResults', null));
  };
};

var registerLocationFields = function registerLocationFields() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["registerField"])('tournamentSetup', 'tournamentLocationName', 'Field'));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["registerField"])('tournamentSetup', 'tournamentLocationAddress', 'Field'));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["registerField"])('tournamentSetup', 'tournamentLocationCity', 'Field'));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["registerField"])('tournamentSetup', 'tournamentLocationState', 'Field'));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["registerField"])('tournamentSetup', 'tournamentLocationZipCode', 'Field'));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["registerField"])('tournamentSetup', 'tournamentLocationCertificationNumber', 'Field'));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["registerField"])('tournamentSetup', 'tournamentLocationPhone', 'Field'));
    setTimeout(function () {
      // focus field after animatation finished (~400ms) by directly accessing the dom
      document.querySelectorAll('[name=tournamentLocationName]')[0].focus();
    }, 400);
  };
};

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actionTypes__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(1110);
/* unused harmony export setCalendarToTournamentStart */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleEventClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return validate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return handleSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleDayClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return moveToNextMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return moveToPreviousMonth; });
/* unused harmony export retrieveSquads */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadSquadCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return confirmSquadDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return handleCloseDeleteModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return handleConfirmSquadDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return handleSquadDelete; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var setCalendarToTournamentStart = function setCalendarToTournamentStart() {
  return function (dispatch, getState) {
    var tournamentStartDate = getState().tournament.base.tournamentInfo.startDate;
    var startDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(tournamentStartDate));

    var month = Number(startDate.format('M'));
    var year = Number(startDate.format('YYYY'));

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["a" /* displaySpecificMonth */])(month, year));
  };
};

var handleEventClick = function handleEventClick(target, eventData, day) {
  return function (dispatch, getState) {
    var readOnly = getState().tournament.base.tournamentInfo.readOnly;

    if (readOnly) {
      return;
    }

    var tournamentId = getState().tournament.base.tournamentInfo.id,
        tmsEndpoint = getState().tournament.base.tournamentInfo.tmsEndPoint,

    // Whew creating a new Date in JS like this, make sure to use forward slashes
    // and not hyphens. E.g. 01/01/2016 and not 01-01-2016
    // See this StackOverflow for more info: https://goo.gl/ZADGJV
    selectedDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(day.year + '/' + (day.month + 1) + '/' + day.day)),
        // day.month starts from zero
    monthName = selectedDate.format('MMMM'),
        status = getState().tournament.status.currentStatus,
        squadInfo = target.props.eventData.data;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('tournament/' + tournamentId + '/events/')).then(function (data) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["b" /* displayEventsInDropDown */])(data.map(function (_ref) {
        var id = _ref.id,
            name = _ref.name;
        return {
          value: id,
          label: name
        };
      })));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["c" /* displaySquadDialog */])('Update Squad (' + monthName + ' ' + day.day + ', ' + day.year + ')'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["initialize"])('tournamentSquadForm', _extends({}, squadInfo, {
        startDateTime: __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(squadInfo.startDateTime),
        time: __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(squadInfo.startDateTime).format('HH:mm'),
        origStartLane: squadInfo.startLane,
        origEndLane: squadInfo.endLane,
        canDelete: true,
        status: status,
        tmsEndpoint: tmsEndpoint
      })));
      setTimeout(function () {
        // focus field after animatation finished (~800ms) by directly accessing the dom
        document.querySelectorAll('.modal-dialog [role=combobox]')[0].focus();
      }, 800);
    });
  };
};

var validate = function validate(data) {

  if (data.until) {
    // scrub times from datepicker values
    data.until = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.until).format('YYYY-MM-DD');
  }

  var errors = {};

  errors = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* validateSquad */])(data);

  errors.until = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["b" /* validateRepeatUntil */])(data);

  return errors;
};

var handleSave = function handleSave(data) {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var time = data.time.split(/\:/);
      var startDateTime = data.startDateTime.set({ hour: time[0], minute: time[1] }).format();
      var body = _extends({}, data, {
        startDateTime: startDateTime,
        repeatingDays: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* getRepeatingDays */])(startDateTime, data.repeatOn, data.until),
        repeatOn: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["d" /* getAllDaysOfWeek */])(startDateTime, data.repeatOn),
        until: data.until
      });

      var promise = data.id ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["g" /* putJsonAsync */])('squad', body) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["e" /* postJsonAsync */])('squad', body);

      dispatch(promise).then(function () {
        var tournamentId = getState().tournament.base.tournamentInfo.id;

        __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Saved!', 'Squad was successfully saved.');
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["d" /* hideSquadDialog */])());
        dispatch(retrieveSquads(tournamentId));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["n" /* loadTournament */])(tournamentId));
        resolve();
      }).catch(function () {
        return resolve();
      });
    });
  };
};

var handleDayClick = function handleDayClick(target, day) {
  return function (dispatch, getState) {
    var readOnly = getState().tournament.base.tournamentInfo.readOnly;

    if (readOnly) {
      return;
    }

    var tournamentInfo = getState().tournament.base.tournamentInfo;
    var tournamentId = tournamentInfo.id,
        timeZoneDisplayName = tournamentInfo.timeZoneDisplayName,
        selectedDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()([day.year, day.month, day.day]),
        monthName = selectedDate.format('MMMM');

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('tournament/' + tournamentId + '/events/')).then(function (data) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["b" /* displayEventsInDropDown */])(data.map(function (_ref2) {
        var id = _ref2.id,
            name = _ref2.name;
        return {
          value: id,
          label: name
        };
      })));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["c" /* displaySquadDialog */])('Create a Squad (' + monthName + ' ' + day.day + ', ' + day.year + ')'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["initialize"])('tournamentSquadForm', {
        startDateTime: selectedDate,
        tournamentEndDate: tournamentInfo.endDate,
        canRepeat: true,
        canDelete: false,
        timeZoneDisplayName: timeZoneDisplayName,
        minDateUntil: selectedDate.format("MM/DD/YYYY")
      }));
      setTimeout(function () {
        // focus field after animatation finished (~800ms) by directly accessing the dom
        document.querySelectorAll('.modal-dialog [role=combobox]')[0].focus();
      }, 800);
    });
  };
};

var moveToNextMonth = function moveToNextMonth() {
  return function (dispatch, getState) {
    var tournamentId = getState().tournament.base.tournamentInfo.id;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["e" /* displayNextMonth */])());
    dispatch(retrieveSquads(tournamentId));
  };
};

var moveToPreviousMonth = function moveToPreviousMonth() {
  return function (dispatch, getState) {
    var tournamentId = getState().tournament.base.tournamentInfo.id;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["f" /* displayPreviousMonth */])());
    dispatch(retrieveSquads(tournamentId));
  };
};

var retrieveSquads = function retrieveSquads(tournamentId) {
  return function (dispatch, getState) {
    var _getState$tournament$ = getState().tournament.squads,
        year = _getState$tournament$.year,
        month = _getState$tournament$.month;


    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["d" /* getJsonAsync */])('tournament/' + tournamentId + '/squads/' + year + '/' + month)).then(function (data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["g" /* displaySquads */])(data.map(function (squad) {
        return {
          start: __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(squad.startDateTime).format('YYYY-MM-DD'),
          end: __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(squad.startDateTime).format('YYYY-MM-DD'),
          title: squad.description,
          description: squad.description,
          data: squad
        };
      })));
    });
  };
};

var loadSquadCalendar = function loadSquadCalendar(tournamentId) {
  return function (dispatch) {
    dispatch(setCalendarToTournamentStart());
    dispatch(retrieveSquads(tournamentId));
  };
};

var confirmSquadDelete = function confirmSquadDelete() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["h" /* displaySquadDeleteModal */])());
  };
};

var handleCloseDeleteModal = function handleCloseDeleteModal() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["i" /* hideSquadDeleteDialog */])());
  };
};

var handleConfirmSquadDelete = function handleConfirmSquadDelete(option, confirmation) {
  return function (dispatch, getState) {
    var tournamentId = getState().tournament.base.tournamentInfo.id,
        squad = getState().form.tournamentSquadForm.values,
        eventIds = [squad.eventId];

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["g" /* putJsonAsync */])('squad/' + squad.id + '/delete', _extends({ TournamentId: tournamentId, EventIds: eventIds,
      Choice: option, Confirmation: confirmation }, squad), false)).then(function (response) {
      if (response.message == null) {
        __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Deleted!', 'Squad was successfully deleted.');
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["d" /* hideSquadDialog */])());
        dispatch(retrieveSquads(tournamentId));
      } else dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["j" /* displaySquadDeleteConfirmModal */])(null, response.message));
    });
  };
};

var handleSquadDelete = function handleSquadDelete() {
  return function (dispatch, getState) {
    var tournamentId = getState().tournament.base.tournamentInfo.id,
        squad = getState().form.tournamentSquadForm.values,
        eventIds = [squad.eventId];

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["g" /* putJsonAsync */])('squad/' + squad.id + '/delete', _extends({ TournamentId: tournamentId, EventIds: eventIds }, squad), false)).then(function (response) {
      if (response.choice) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["j" /* displaySquadDeleteConfirmModal */])(response.message, null, response.choice, response.confirmation));
        return;
      }
      if (response.choice == null && response.message == null) {
        __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Deleted!', 'Squad was successfully deleted.');
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["d" /* hideSquadDialog */])());
        dispatch(retrieveSquads(tournamentId));
      } else dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["h" /* displaySquadDeleteModal */])(response.message));
    });
  };
};

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_actionTypes__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_actions__ = __webpack_require__(13);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return handleManageClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handleCopyClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return retrieveGroupName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return retrieveTournaments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return handleTournamentSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handleTournamentSearchEnterKeyPress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return handleShowAllTournamentsChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return retrieveCreateTournamentPermission; });




var getTournamentsUrl = function getTournamentsUrl(getState) {
  var showAllTournaments = getState().tournament.tournamentList.showAllTournaments;
  var tournamentsUrl = 'setup/tournament/active';

  if (showAllTournaments) {
    tournamentsUrl = 'setup/tournament/all';
  }

  return tournamentsUrl;
};

var handleManageClick = function handleManageClick(tournamentId) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["b" /* navigateTo */])('tournament/update/' + tournamentId));
  };
};

var handleCopyClick = function handleCopyClick(tournamentId) {
  return function (dispatch) {
    var copyTournamentUri = window.COPY_TOURNAMENT_BASE_URI;
    window.location = copyTournamentUri + '/' + tournamentId;
  };
};

var retrieveGroupName = function retrieveGroupName() {
  return function (dispatch, getState) {
    var groupName = getState().shared.auth.groupName;
    var roles = getState().shared.auth.roles;

    if (groupName && roles.find(function (role) {
      return role === 'superuser';
    })) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["a" /* displayGroupName */])(groupName));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__general_actionTypes__["v" /* setIsSuperUser */])(true));
    } else {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["a" /* displayGroupName */])(''));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__general_actionTypes__["v" /* setIsSuperUser */])(false));
    }
  };
};

var retrieveTournaments = function retrieveTournaments() {
  return function (dispatch, getState) {
    var tournamentsUrl = getTournamentsUrl(getState);

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["d" /* getJsonAsync */])(tournamentsUrl)).then(function (data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["b" /* displayTournaments */])(data));
    }).catch(function () {});
  };
};

var handleTournamentSearch = function handleTournamentSearch() {
  return function (dispatch, getState) {
    var tournamentList = getState().tournament.tournamentList;
    var tournamentsUrl = getTournamentsUrl(getState);
    var searchValue = tournamentList.searchValue;

    if (searchValue && searchValue.length > 0) searchValue = searchValue.toLowerCase();

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["c" /* startLoadingTournaments */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["d" /* getJsonAsync */])(tournamentsUrl)).then(function (data) {
      if (searchValue && searchValue.length > 0) {
        data = data.filter(function (d) {
          return d.name.toLowerCase().indexOf(searchValue) > -1;
        });
      }
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["b" /* displayTournaments */])(data));
    }).catch(function () {});
  };
};

var handleTournamentSearchEnterKeyPress = function handleTournamentSearchEnterKeyPress(event) {
  return function (dispatch) {
    if (event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation();
      dispatch(handleTournamentSearch());
    }
  };
};

var handleShowAllTournamentsChange = function handleShowAllTournamentsChange(checked) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["d" /* updateShowAllTournaments */])(checked));
    dispatch(retrieveTournaments());
  };
};

var retrieveCreateTournamentPermission = function retrieveCreateTournamentPermission() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["d" /* getJsonAsync */])('setup/tournament/checkCreatePermission')).then(function (data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["e" /* setCanCreateTournaments */])(data));
    }).catch(function () {});
  };
};

/***/ }),
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(270);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return handleIncludePastTournamentsChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handleSearchEnterKeyPress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleEntryClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleCaptainClick; });




var handleIncludePastTournamentsChange = function handleIncludePastTournamentsChange(checked) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["b" /* setIncludePastTournamentsInState */])(checked));
    dispatch(handleSearch());
  };
};

var handleSearchEnterKeyPress = function handleSearchEnterKeyPress(event) {
  return function (dispatch) {
    if (event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation();
      dispatch(handleSearch());
    }
  };
};

var handleSearch = function handleSearch() {
  return function (dispatch, getState) {
    var adminHomeState = getState().admin.home,
        searchByOption = adminHomeState.searchByOptions.find(function (x) {
      return x.selected;
    }).id,
        searchValue = adminHomeState.searchValue.trim(),
        includePastTournaments = adminHomeState.includePastTournaments;

    if (!searchByOption) return;

    if (!searchValue || searchValue.trim().length < 3) return;

    var url = '';
    var body = {
      SearchTerms: searchValue,
      includePastTournaments: includePastTournaments
    };

    if (searchByOption === 1) {
      url = 'admin/entry/searchByBowler';
    } else if (searchByOption === 2) {
      url = 'admin/entry/searchByCaptOrCoordinator';
    } else if (searchByOption === 3) {
      url = 'admin/entry/searchByEntry';
    }

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["e" /* postJsonAsync */])(url, body)).then(function (result) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["a" /* setSearchResultInState */])(result.items));
      if (result.showingLinkedEntryInstead) {
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].warning('Showing the linked entry', 'The entry ' + searchValue + ' is linked to the entry ' + result.items[0].entryNumber + '. You can only modify entry ' + result.items[0].entryNumber);
      }
    });
  };
};

var handleEntryClick = function handleEntryClick(entryId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["b" /* navigateTo */])('admin/entry/' + entryId));
  };
};

var handleCaptainClick = function handleCaptainClick(captainId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["b" /* navigateTo */])('admin/captain/' + captainId));
  };
};

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(422);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadReservationReview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateSquadQuantity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return updateVirtualEventQuantity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateCartTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return displayClearCartConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return processingStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return processingFinished; });


var loadReservationReview = function loadReservationReview(cart) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* LOAD_RESERVATION_REVIEW_FOR_ADMIN */],
    payload: cart
  };
};

var updateSquadQuantity = function updateSquadQuantity(squad) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* UPDATE_SQUAD_QTY_FOR_ADMIN */],
    payload: squad
  };
};

var updateVirtualEventQuantity = function updateVirtualEventQuantity(virtualEvent) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* UPDATE_VIRTUAL_EVENT_QTY_FOR_ADMIN */],
    payload: virtualEvent
  };
};

var updateCartTotal = function updateCartTotal() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* UPDATE_CART_TOTAL_FOR_ADMIN */]
  };
};

var displayClearCartConfirmation = function displayClearCartConfirmation(showModal) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* DISPLAY_CLEAR_CART_CONFIRMATION_FOR_ADMIN */],
    payload: showModal
  };
};

var processingStarted = function processingStarted() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* PROCESSING_STARTED */]
  };
};

var processingFinished = function processingFinished() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* PROCESSING_FINISHED */]
  };
};

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_error_actionTypes__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actionTypes__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actionTypes__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_error_errorManager__ = __webpack_require__(137);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleReserveClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleContinueReservingClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cancelReservation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return removeSquadItemFromAdminCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removeVirtualEventFromAdminCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return handleOnSquadQuantityChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handleOnVirtualEventQuantityChange; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var handleReserveClick = function handleReserveClick() {
  return function (dispatch, getState) {
    var state = getState();
    var captain = _extends({}, state.form.captainInformationForm.values);
    var coordinator = _extends({}, state.form.coordintorInformationForm.values);
    var entries = state.admin.review.cart.squads;
    var virtualEntries = state.admin.review.cart.virtualEvents;
    var tournamentId = state.admin.base.tournament.id;
    var payload = { tournamentId: tournamentId, entries: entries, virtualEntries: virtualEntries, captain: captain, coordinator: coordinator };

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["c" /* processingStarted */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["e" /* postJsonAsync */])('admin/tournament/' + tournamentId + '/reservation', payload)).then(function (response) {
      var errorMessages = response.messages;
      if (errorMessages && errorMessages.length > 0) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_error_errorManager__["b" /* displayErrorList */])(errorMessages));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["d" /* processingFinished */])());
      } else {
        __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Saved!', 'Registration saved successfully.');
        delete localStorage.adminCart;
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["d" /* processingFinished */])());
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["b" /* navigateTo */])('admin/captain/' + response.captainId));
      }
    }).catch(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["d" /* processingFinished */])());
    });
  };
};

var handleContinueReservingClick = function handleContinueReservingClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["b" /* setReturningToCalendar */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["b" /* navigateTo */])('admin/squads'));
  };
};

var cancelReservation = function cancelReservation() {
  return function (dispatch) {
    delete localStorage.adminCart;
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["b" /* displayClearCartConfirmation */])(false));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["b" /* navigateTo */])('admin/squads'));
  };
};

var removeSquadItemFromAdminCart = function removeSquadItemFromAdminCart(id) {
  return function (dispatch) {
    var adminCart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actions__["n" /* getAdminShoppingCart */])();

    adminCart.squads = adminCart.squads.filter(function (item) {
      return item.id != id;
    });
    localStorage.adminCart = JSON.stringify(adminCart);
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_error_actionTypes__["a" /* setErrorList */])([]));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["a" /* loadReservationReview */])(adminCart));
  };
};

var removeVirtualEventFromAdminCart = function removeVirtualEventFromAdminCart(id) {
  return function (dispatch) {
    var adminCart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actions__["n" /* getAdminShoppingCart */])();

    adminCart.virtualEvents = adminCart.virtualEvents.filter(function (item) {
      return item.id != id;
    });
    localStorage.adminCart = JSON.stringify(adminCart);
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_error_actionTypes__["a" /* setErrorList */])([]));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["a" /* loadReservationReview */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actions__["n" /* getAdminShoppingCart */])()));
  };
};

var handleOnSquadQuantityChange = function handleOnSquadQuantityChange(data) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_error_actionTypes__["a" /* setErrorList */])([]));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["e" /* updateSquadQuantity */])(data));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["f" /* updateCartTotal */])());

    var shoppingCart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actions__["n" /* getAdminShoppingCart */])(),
        item = shoppingCart.squads.find(function (x) {
      return x.id === data.squadId;
    }) || null;

    if (item === null) return;
    item.quantity = Number(data.inputValue);
    sessionStorage.adminCart = JSON.stringify(shoppingCart);
  };
};

var handleOnVirtualEventQuantityChange = function handleOnVirtualEventQuantityChange(data) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["g" /* updateVirtualEventQuantity */])(data));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["f" /* updateCartTotal */])());

    var shoppingCart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actions__["n" /* getAdminShoppingCart */])(),
        item = shoppingCart.virtualEvents.find(function (x) {
      return x.id === data.virtualEventId;
    }) || null;

    if (item === null) return;
    item.quantity = Number(data.inputValue);
    sessionStorage.adminCart = JSON.stringify(shoppingCart);
  };
};

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(423);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return displayGuideIfBundled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return displayVirtualEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setSelectedDateInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setSquadQuantity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setAvailableEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setNoDatesAvailable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return displayAvailableSquadDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setActiveTournamentsInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return updateSquadCountInCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return updateBowlerOwnedVirtualEventQuantity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return updateBowlerOwnedVirtualEventCountInCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return updateTeamOwnedVirtualEventQuantity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return updateTeamOwnedVirtualEventCountInCart; });


var displayGuideIfBundled = function displayGuideIfBundled(squadId) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_GUIDE_IF_SQUAD_IS_BUNDLED_FOR_ADMIN */],
        payload: squadId
    };
};

var updateTotal = function updateTotal(items) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* UPDATE_TOTAL_FOR_ADMIN_RESERVATION */],
        payload: items
    };
};

var displayVirtualEvents = function displayVirtualEvents(data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* DISPLAY_BOWLER_OWNED_VIRTUAL_EVENTS_FOR_ADMIN */],
        payload: data
    };
};

var setSelectedDateInState = function setSelectedDateInState(selectedDate) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_SELECTED_DATE_FOR_ADMIN */],
        payload: selectedDate
    };
};

var setSquadQuantity = function setSquadQuantity(data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* SET_SQUAD_QTY_FOR_ADMIN */],
        payload: data
    };
};

var setAvailableEvents = function setAvailableEvents(availableEvents) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SET_AVAILABLE_EVENTS_FOR_ADMIN */],
        payload: availableEvents
    };
};

var setNoDatesAvailable = function setNoDatesAvailable(value) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* SET_NO_DATES_AVAILABLE_FOR_ADMIN */],
        payload: value
    };
};

var displayAvailableSquadDates = function displayAvailableSquadDates(data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* DISPLAY_AVAILABLE_SQUAD_DATES_FOR_ADMIN */],
        payload: data
    };
};

var setActiveTournamentsInState = function setActiveTournamentsInState(tournaments) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* SET_ACTIVE_TOURNAMENTS_FOR_ADMIN */],
        payload: tournaments
    };
};

var updateSquadCountInCart = function updateSquadCountInCart(squadId, quantity) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* UPDATE_SQUAD_COUNT_IN_CART_FOR_ADMIN_SCHEDULER */],
        payload: { squadId: squadId, quantity: quantity }
    };
};

var updateBowlerOwnedVirtualEventQuantity = function updateBowlerOwnedVirtualEventQuantity(virtualEventId, quantity) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_QTY_FOR_ADMIN_SCHEDULER */],
        payload: { virtualEventId: virtualEventId, quantity: quantity }
    };
};

var updateBowlerOwnedVirtualEventCountInCart = function updateBowlerOwnedVirtualEventCountInCart(virtualEventId, count) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_ADMIN_SCHEDULER */],
        payload: { virtualEventId: virtualEventId, count: count }
    };
};

var updateTeamOwnedVirtualEventQuantity = function updateTeamOwnedVirtualEventQuantity(eventId, virtualEventId, quantity) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* UPDATE_TEAM_OWNED_VIRTUAL_EVENT_QTY_FOR_ADMIN_SCHEDULER */],
        payload: { eventId: eventId, virtualEventId: virtualEventId, quantity: quantity }
    };
};

var updateTeamOwnedVirtualEventCountInCart = function updateTeamOwnedVirtualEventCountInCart(eventId, virtualEventId, count) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* UPDATE_TEAM_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_ADMIN_SCHEDULER */],
        payload: { eventId: eventId, virtualEventId: virtualEventId, count: count }
    };
};

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(424);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return displayVirtualEventSubmitting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setBowlerForVirtualEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return setTeamForVirtualEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setVirtualEventDetailsInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setAvailableBowlersInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setAvailableTeamsInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setVirtualEntriesInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return calculateSelectedBalance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setVirtualEntrySelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return displayVirtualEntryDetailPaymentModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setSelectedBalance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setRefundTypeForAdminVirtualEntryDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return displayCaptainVirtualEntryChangeModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setIsNewCaptainOnSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return hideVirtualEntryDetailChangeCaptainModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setCreditPurchaseTransactions; });


var displayVirtualEventSubmitting = function displayVirtualEventSubmitting(visible) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_SUBMITTING_FOR_ADMIN_VIRTUAL_EVENT_DETAIL */],
    payload: visible
  };
};

var setBowlerForVirtualEntry = function setBowlerForVirtualEntry(virtualEntryId, bowlerId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_VIRTUAL_ENTRY_BOWLER_FOR_ADMIN_VIRTUAL_EVENT_DETAIL */],
    payload: { virtualEntryId: virtualEntryId, bowlerId: bowlerId }
  };
};

var setTeamForVirtualEntry = function setTeamForVirtualEntry(virtualEntryId, entryId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_VIRTUAL_ENTRY_TEAM_FOR_ADMIN_VIRTUAL_EVENT_DETAIL */],
    payload: { virtualEntryId: virtualEntryId, entryId: entryId }
  };
};

var setVirtualEventDetailsInState = function setVirtualEventDetailsInState(virtualEventDetails) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_DETAILS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL */],
    payload: virtualEventDetails
  };
};

var setAvailableBowlersInState = function setAvailableBowlersInState(bowlers) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* SET_AVAILABLE_BOWLERS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL */],
    payload: bowlers
  };
};

var setAvailableTeamsInState = function setAvailableTeamsInState(teams) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SET_AVAILABLE_TEAMS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL */],
    payload: teams
  };
};

var setVirtualEntriesInState = function setVirtualEntriesInState(virtualEntries) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* SET_VIRTUAL_ENTRIES_FOR_ADMIN_VIRTUAL_EVENT_DETAIL */],
    payload: virtualEntries
  };
};

var calculateSelectedBalance = function calculateSelectedBalance() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* CALCULATE_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL */]
  };
};

var setVirtualEntrySelected = function setVirtualEntrySelected(virtualEntryId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* SET_VIRTUAL_ENTRY_SELECTED_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL */],
    payload: virtualEntryId
  };
};

var displayVirtualEntryDetailPaymentModal = function displayVirtualEntryDetailPaymentModal(showModal, paymentModalType) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* DISPLAY_PAYMENT_MODAL_FOR_ADMIN_VIRTUAL_ENTRY_DETAIL */],
    payload: { showModal: showModal, paymentModalType: paymentModalType }
  };
};

var setSelectedBalance = function setSelectedBalance(balance) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* SET_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL */],
    payload: balance
  };
};

var setRefundTypeForAdminVirtualEntryDetail = function setRefundTypeForAdminVirtualEntryDetail(refundType) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* SET_REFUND_TYPE_FOR_ADMIN_VIRTUAL_ENTRY_DETAIL */],
    payload: refundType
  };
};

var displayCaptainVirtualEntryChangeModal = function displayCaptainVirtualEntryChangeModal() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* DISPLAY_CAPTAIN_VIRTUAL_ENTRY_CHANGE_MODAL_FOR_ADMIN */],
    payload: true
  };
};

var setIsNewCaptainOnSearch = function setIsNewCaptainOnSearch(isNew) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* SET_IS_NEW_CAPTAIN_VIRTUAL_ENTRIES_MODAL_FOR_ADMIN */],
    payload: isNew
  };
};

var hideVirtualEntryDetailChangeCaptainModal = function hideVirtualEntryDetailChangeCaptainModal() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* DISPLAY_CAPTAIN_VIRTUAL_ENTRY_CHANGE_MODAL_FOR_ADMIN */],
    payload: false
  };
};

var setCreditPurchaseTransactions = function setCreditPurchaseTransactions(creditPurchaseTransactions) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["o" /* SET_VIRTUAL_EVENT_DETAIL_CREDIT_PURCHASE_TRANSACTIONS */],
    payload: creditPurchaseTransactions
  };
};

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_util_detectIE__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_topBanner_actionTypes__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__accountCreated_actionTypes__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scheduler_actions__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_actions__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rostercheckout_actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__checkout_actions__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__home_actions__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_auth_actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__manage_actions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actionTypes__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_actionTypes__ = __webpack_require__(39);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handleRegistrationManageRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return handleRegistrationCheckoutRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleRegistrationScheduleRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleAccountCreatedRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleRegistrationHomeRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handleRegistrationCheckoutRosterRouteEnter; });
/* unused harmony export loadTournament */
/* unused harmony export verifyCartState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getShoppingCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setShoppingCart; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };















var handleRegistrationManageRouteEnter = function handleRegistrationManageRouteEnter(nextState, replace, callback) {
  return function (dispatch, getState) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__shared_actionTypes__["a" /* clearShared */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      dispatch(loadTournament(nextState.params.tournamentId)).then(function () {
        var state = getState();

        if (!state.registration.base.captainPassesAgeRestrictions) {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["b" /* navigateTo */])('registration'));
        }
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_topBanner_actionTypes__["c" /* setSubTitle */])('Manage Registration'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_actions__["a" /* retrieveEntries */])(nextState.params.tournamentId));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_actions__["b" /* retrieveUserVirtualEntries */])(nextState.params.tournamentId));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_actions__["c" /* retrieveCountries */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_actions__["d" /* retrieveStates */])());

      var paymentId = nextState.params.paymentId;

      var paymentData = {
        BypassWebHooks: localStorage.bypassWebHooks,
        PaymentId: paymentId
      };

      if (paymentId) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__manage_actions__["handleCompletePayBalance"])(nextState.params.tournamentId, paymentData));
      }
    }).catch(function () {});
  };
};

var handleRegistrationCheckoutRouteEnter = function handleRegistrationCheckoutRouteEnter(nextState, replace, callback) {
  return function (dispatch) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_util_detectIE__["a" /* detectIE */])() && JSON.parse(localStorage.forceRefresh || false)) {
      localStorage.forceRefresh = false;
      window.location.reload();
    }

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      dispatch(loadTournament(nextState.params.tournamentId)).then(function () {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__checkout_actions__["a" /* restoreLocalDataForCheckout */])()).then(function () {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__checkout_actions__["b" /* validateCart */])());
        });

        var paymentDetail = {
          PaymentId: nextState.params.paymentId,
          TournamentId: nextState.params.tournamentId
        };

        if (paymentDetail.PaymentId) {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__checkout_actions__["c" /* processPayment */])(paymentDetail));
        }
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_topBanner_actionTypes__["c" /* setSubTitle */])('Checkout'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__checkout_actions__["d" /* retrieveTermsUrl */])(nextState.params.tournamentId));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__checkout_actions__["e" /* resetAgreeToTerms */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__checkout_actions__["f" /* resetValidationMesssages */])());
    }).catch(function () {});
  };
};

var handleRegistrationScheduleRouteEnter = function handleRegistrationScheduleRouteEnter(nextState, replace, callback) {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__scheduler_actions__["a" /* checkRestrictions */])(nextState.params.tournamentId)).then(function () {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_topBanner_actionTypes__["c" /* setSubTitle */])('Schedule'));

          var reg = getState().registration;
          var isReturning = reg.base.returningToCalendar;

          // TODO: simple tournamentId validation fix (but returningToCalendar is likely not getting reset when it should)
          if (isReturning && reg.scheduler.calendar.selectedDate && reg.base.tournamentId === nextState.params.tournamentId) {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__scheduler_actions__["b" /* updateTotalFromLocalStorage */])());
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__scheduler_actions__["c" /* handleDateSelection */])(reg.scheduler.calendar.selectedDate));
          } else {
            dispatch(loadTournament(nextState.params.tournamentId)).then(function () {
              dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__scheduler_actions__["b" /* updateTotalFromLocalStorage */])());
            });
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__scheduler_actions__["d" /* retrieveAvailableDates */])(nextState.params.tournamentId)).then(function () {});
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__scheduler_actions__["e" /* retrieveVirtualEvents */])(nextState.params.tournamentId));
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__scheduler_actions__["f" /* resetInformation */])());
          }
        }).catch(function (error) {
          if (error != 'MinimumCaptainAgeFailed' && error != 'MissingRequiredProfileFields' && error != 'NeedToConfirmProfile') {
            reject(error);
          }
        });
      });
    });
  };
};

var handleAccountCreatedRouteEnter = function handleAccountCreatedRouteEnter(nextState, replace, callback) {
  return function (dispatch, getState) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_auth_actions__["k" /* silentCheckAuth */])(nextState, replace, callback)).then(function () {
      var state = getState();

      if (!state.shared.auth.email || state.shared.auth.profileIsConfirmed) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["b" /* navigateTo */])('registration'));
        return;
      }

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__accountCreated_actionTypes__["a" /* displayGoHome */])(false));
      setTimeout(function () {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__accountCreated_actionTypes__["a" /* displayGoHome */])(true));
      }, 10000);

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_topBanner_actionTypes__["b" /* setTitle */])('Event Registration'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_topBanner_actionTypes__["c" /* setSubTitle */])(''));
    });
  };
};

var handleRegistrationHomeRouteEnter = function handleRegistrationHomeRouteEnter(nextState, replace, callback) {
  return function (dispatch, getState) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_auth_actions__["k" /* silentCheckAuth */])(nextState, replace, callback)).then(function () {
      var state = getState();

      if (!!state.shared.auth.email && !state.shared.auth.profileIsConfirmed && state.shared.auth.profileIsWorking) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["b" /* navigateTo */])('registration/accountCreated'));
        return;
      }

      if (!state.shared.auth.maintenanceMessage) {
        processTags(nextState);
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__home_actions__["a" /* retrieveActiveTournaments */])(nextState.location.query));
      }

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_topBanner_actionTypes__["b" /* setTitle */])('Event Registration'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_topBanner_actionTypes__["c" /* setSubTitle */])(''));
    });
  };
};

var handleRegistrationCheckoutRosterRouteEnter = function handleRegistrationCheckoutRosterRouteEnter(nextState, replace, callback) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__shared_actionTypes__["a" /* clearShared */])());
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_util_detectIE__["a" /* detectIE */])() && JSON.parse(localStorage.forceRefresh || false)) {
      localStorage.forceRefresh = false;
      window.location.reload();
    }

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      dispatch(loadTournament(nextState.params.tournamentId)).then(function () {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__checkout_actions__["a" /* restoreLocalDataForCheckout */])()).then(function () {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__rostercheckout_actions__["a" /* retrieveEvents */])(nextState.params.tournamentId)).then(function () {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__rostercheckout_actions__["b" /* retrieveEntriesFromCart */])()).then(function () {
              dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__rostercheckout_actions__["c" /* retrieveVirtualEntriesFromCart */])());
              dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__checkout_actions__["b" /* validateCart */])());
            });
          });
        });
      });

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_topBanner_actionTypes__["c" /* setSubTitle */])('Roster'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_actions__["b" /* retrieveUserVirtualEntries */])(nextState.params.tournamentId));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_actions__["c" /* retrieveCountries */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_actions__["d" /* retrieveStates */])());
    }).catch(function () {});
  };
};

var loadTournament = function loadTournament(id) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_topBanner_actionTypes__["b" /* setTitle */])(''));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["d" /* getJsonAsync */])('registration/tournament/' + id)).then(function (tournament) {
        dispatch(verifyCartState(id));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actionTypes__["a" /* setTournamentInState */])(tournament));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_topBanner_actionTypes__["b" /* setTitle */])(tournament.name));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_topBanner_actionTypes__["a" /* setTopBannerImagePath */])(tournament.customImageLargePath));
        resolve(tournament);
      }).catch(function (error) {
        return reject(error);
      });
    });
  };
};

var verifyCartState = function verifyCartState(tournamentId) {
  return function () {
    var cart = getShoppingCart();

    // clear registration cart when navigating to another tournament
    if (tournamentId !== cart.tournamentId) {
      delete localStorage.cart;
    }
  };
};

var getShoppingCart = function getShoppingCart() {
  var cart = JSON.parse(localStorage.cart || null) || {};

  return _extends({}, cart, {
    squads: cart.squads || [],
    virtualEvents: cart.virtualEvents || []
  });
};

var setShoppingCart = function setShoppingCart(updatedCart, tournamentId) {
  return function () {
    updatedCart.tournamentId = tournamentId;
    localStorage.cart = JSON.stringify(updatedCart);
  };
};

var processTags = function processTags(nextState) {
  var keys = Object.keys(nextState.location.query);
  var tagsPresent = false;
  var tags = '';

  keys.forEach(function (key) {
    if (key.toLowerCase() == 'tags') {
      tagsPresent = true;
      tags = nextState.location.query[key];
    }
  });

  if (!tagsPresent) {
    if (localStorage.tags) {
      nextState.location.query.tags = localStorage.tags;

      if (history && history.replaceState) {
        history.replaceState(history.state, null, window.location.href + '?tags=' + nextState.location.query.tags);
      }
    }
  } else {
    nextState.location.query.tags = tags;

    localStorage.tags = nextState.location.query.tags;
  }
};

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(433);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return displayActiveTournaments; });
/* unused harmony export displayMaintenanceMessage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setTournamentLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setPaymentMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return displayBirthDateModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return displayRequiredProfileFieldsModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setAgeInState; });
/* unused harmony export setSearchTournamentValue */


var displayActiveTournaments = function displayActiveTournaments(activeTournaments) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_ACTIVE_TOURNAMENTS_FOR_REG_HOME */],
    payload: {
      activeTournaments: activeTournaments,
      loadingTournaments: false
    }
  };
};

var displayMaintenanceMessage = function displayMaintenanceMessage(maintenanceMessage) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DISPLAY_MAINTENANCE_MESSAGE_FOR_REG_HOME */],
    payload: {
      maintenanceMessage: maintenanceMessage
    }
  };
};

var setTournamentLoading = function setTournamentLoading() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_TOURNAMENT_LOADING_FOR_REG_HOME */],
    payload: {}
  };
};

var setPaymentMessage = function setPaymentMessage(message) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_PAYMENT_MESSAGE_FOR_REG_HOME */],
    payload: message
  };
};

var displayBirthDateModal = function displayBirthDateModal(showModal) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* DISPLAY_BIRTH_DATE_MODAL */],
    payload: showModal
  };
};

var displayRequiredProfileFieldsModal = function displayRequiredProfileFieldsModal(showModal) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* DISPLAY_REQUIRED_PROFILE_FIELDS_MODAL */],
    payload: showModal
  };
};

var setAgeInState = function setAgeInState(age) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* SET_CAPTAIN_AGE_FOR_SELECTED_TOURNAMENT */],
    payload: age
  };
};

var setSearchTournamentValue = function setSearchTournamentValue(searchValue) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* SET_SEARCH_TOURNAMENT_VALUE_FOR_REG_HOME */],
    payload: { searchValue: searchValue }
  };
};

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_auth_actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(201);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleScheduleClick; });
/* unused harmony export handleResendEmailClick */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleManageClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return retrieveActiveTournaments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return handleSendToProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handleBirthDateModalCancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handleRequiredProfileFieldsModalCancel; });
/* unused harmony export handleTournamentSearch */
/* unused harmony export handleTournamentSearchEnterKeyPress */




var handleScheduleClick = function handleScheduleClick(tournamentId) {
  return function (dispatch, getState) {
    var authState = getState().shared.auth;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_auth_actions__["l" /* getLoggedInUser */])().then(function (user) {
      if (user && !authState.profileIsConfirmed) {
        return;
      } else if (user && !authState.profileIsValid) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["b" /* displayRequiredProfileFieldsModal */])(true));
      } else {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["b" /* navigateTo */])('registration/schedule/' + tournamentId));
      }
    });
  };
};

var handleResendEmailClick = function handleResendEmailClick(tournamentId) {
  return function (dispatch, getState) {
    var authState = getState().shared.auth;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_auth_actions__["l" /* getLoggedInUser */])().then(function (user) {
      if (user && !authState.profileIsConfirmed) {
        return;
      } else if (user && !authState.profileIsValid) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["b" /* displayRequiredProfileFieldsModal */])(true));
      } else {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["b" /* navigateTo */])('registration/schedule/' + tournamentId));
      }
    });
  };
};

var handleManageClick = function handleManageClick(tournamentId) {
  return function (dispatch, getState) {
    var authState = getState().shared.auth;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_auth_actions__["l" /* getLoggedInUser */])().then(function (user) {
      if (user && !authState.profileIsConfirmed) {
        return;
      } else if (user && !authState.profileIsValid) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["b" /* displayRequiredProfileFieldsModal */])(true));
      } else {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["b" /* navigateTo */])('registration/manage/' + tournamentId));
      }
    });
  };
};

var retrieveActiveTournaments = function retrieveActiveTournaments(query) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["c" /* setTournamentLoading */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["e" /* postJsonAsync */])('registration/tournament/active', query)).then(function (data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["d" /* displayActiveTournaments */])(data));
    }).catch(function () {});
  };
};

var handleSendToProfile = function handleSendToProfile() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_auth_actions__["i" /* goToProfile */])());
  };
};

var handleBirthDateModalCancel = function handleBirthDateModalCancel() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["e" /* displayBirthDateModal */])(false));
  };
};

var handleRequiredProfileFieldsModalCancel = function handleRequiredProfileFieldsModalCancel() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["b" /* displayRequiredProfileFieldsModal */])(false));
  };
};

var handleTournamentSearch = function handleTournamentSearch() {
  return function (dispatch, getState) {
    var home = getState().registration.home;
    var searchValue = home.searchValue;

    if (searchValue && searchValue.length > 0) searchValue = searchValue.toLowerCase();
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["c" /* setTournamentLoading */])());

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["d" /* getJsonAsync */])('registration/tournament/active')).then(function (data) {
      if (searchValue && searchValue.length > 0) {
        data = data.filter(function (d) {
          return d.name.toLowerCase().indexOf(searchValue) > -1;
        });
      }
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["d" /* displayActiveTournaments */])(data));
    }).catch(function () {});
  };
};

var handleTournamentSearchEnterKeyPress = function handleTournamentSearchEnterKeyPress(event) {
  return function (dispatch) {
    if (event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation();
      dispatch(handleTournamentSearch());
    }
  };
};

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(459);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return displayEventPriceDetailModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setEventPriceDetailData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cancelEventPriceDetailModal; });


var displayEventPriceDetailModal = function displayEventPriceDetailModal() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_EVENT_PRICE_DETAILS_MODAL_SHARED */]
  };
};

var setEventPriceDetailData = function setEventPriceDetailData(basePrice, fees) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_EVENT_PRICE_DETAILS_DATA_SHARED */],
    payload: {
      basePrice: basePrice,
      fees: fees
    }
  };
};

var cancelEventPriceDetailModal = function cancelEventPriceDetailModal() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* CANCEL_EVENT_PRICE_DETAILS_MODAL_SHARED */]
  };
};

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(285);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deactivateFee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return retrieveEventTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return validate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return handleSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return handleCancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return handleNewFeeClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return retrieveInactiveFees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return retrieveActiveFees; });





var deactivateFee = function deactivateFee(feeId) {
  return function (dispatch, getState) {
    var tournament = getState().tournament.base.tournamentInfo;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["a" /* deactivateProcessStart */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["g" /* putJsonAsync */])('addonfee/' + feeId + '/deactivate')).then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["b" /* deactivateProcessEnd */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["c" /* cancelDeactivateModal */])());
      dispatch(retrieveActiveFees(tournament.id));
      dispatch(retrieveInactiveFees(tournament.id));
      __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Saved!', 'Add-on fee saved successfully.');
    }).catch(function () {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["b" /* deactivateProcessEnd */])());
    });
  };
};

var retrieveEventTypes = function retrieveEventTypes(tournamentId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["d" /* getJsonAsync */])('tournament/' + tournamentId + '/events/')).then(function (data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["d" /* setEventTypesInState */])(data.map(function (_ref) {
        var id = _ref.id,
            name = _ref.name;
        return {
          value: id,
          label: name
        };
      })));
    });
  };
};

var validate = function validate(values) {
  var errors = {};

  if (!values.description) {
    errors.description = 'Required';
  }
  if (!values.eventId) {
    errors.eventId = 'Required';
  }
  if (!values.fee) {
    errors.fee = 'Required';
  }

  return errors;
};

var handleSave = function handleSave(data) {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var tournament = getState().tournament.base.tournamentInfo;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["e" /* postJsonAsync */])('addonfee', data)).then(function () {
        __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Saved!', 'Add-on fee saved successfully.');
        dispatch(retrieveActiveFees(tournament.id));
        resolve();
      }).catch(function () {
        return resolve();
      });
    });
  };
};

var handleCancel = function handleCancel() {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["e" /* cancelFeeItemForm */])());
  };
};

var handleNewFeeClick = function handleNewFeeClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["e" /* cancelFeeItemForm */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["f" /* displayNewFee */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["initialize"])('feeItemForm', {}));
  };
};

var retrieveInactiveFees = function retrieveInactiveFees(tournamentId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["d" /* getJsonAsync */])('tournament/' + tournamentId + '/fees/inactive')).then(function (data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["g" /* displayInactiveFees */])(data));
    });
  };
};

var retrieveActiveFees = function retrieveActiveFees(tournamentId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["d" /* getJsonAsync */])('tournament/' + tournamentId + '/fees/active')).then(function (data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["h" /* displayActiveFees */])(data));
    });
  };
};

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return permissionsFormName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_TOURNAMENT_MANAGER_EDITING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_TOURNAMENT_MANAGERS_IN_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_TOURNAMENT_ADMINISTRATOR_EDITING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_TOURNAMENT_ADMINISTRATORS_IN_STATE; });
var permissionsFormName = 'tournamentPermissions';
var SET_TOURNAMENT_MANAGER_EDITING = "SET_TOURNAMENT_MANAGER_EDITING";
var SET_TOURNAMENT_MANAGERS_IN_STATE = "SET_TOURNAMENT_MANAGERS_IN_STATE";
var SET_TOURNAMENT_ADMINISTRATOR_EDITING = "SET_TOURNAMENT_ADMINISTRATOR_EDITING";
var SET_TOURNAMENT_ADMINISTRATORS_IN_STATE = "SET_TOURNAMENT_ADMINISTRATORS_IN_STATE";

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(288);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return deactivateBundlingRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return retrieveBundlingRuleEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return validate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handleSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return handleCancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return handleNewBundlingRuleClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return retrieveActiveBundles; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var deactivateBundlingRule = function deactivateBundlingRule(ruleId) {
  return function (dispatch, getState) {
    var tournament = getState().tournament.base.tournamentInfo;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["a" /* deactivateProcessStart */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["g" /* putJsonAsync */])('bundling/' + ruleId + '/deactivate')).then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["b" /* deactivateProcessEnd */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["c" /* cancelDeactivateModal */])());
      dispatch(retrieveActiveBundles(tournament.id));
      __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Saved!', 'Bundling rule deactivated successfully.');
    }).catch(function () {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["b" /* deactivateProcessEnd */])());
    });
  };
};

var retrieveBundlingRuleEvents = function retrieveBundlingRuleEvents(tournamentId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["d" /* getJsonAsync */])('bundling/' + tournamentId + '/bundlingruleevents/')).then(function (data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["d" /* setBundlingRuleEventsInState */])(data.map(function (_ref) {
        var id = _ref.id,
            displayName = _ref.displayName;
        return {
          value: id,
          label: displayName
        };
      })));
    });
  };
};

var validate = function validate(values) {
  var errors = {};

  if (!values.parentEventId) {
    errors.parentEventId = 'Required';
  }
  if (!values.childEventId) {
    errors.childEventId = 'Required';
  }
  if (!values.quantity) {
    errors.quantity = 'Required';
  }
  if (values.parentEventId && values.childEventId && values.parentEventId === values.childEventId) {
    errors.childEventId = 'Cannot be the same as parent event';
  }

  return errors;
};

var handleSave = function handleSave(data) {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var tournament = getState().tournament.base.tournamentInfo;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["e" /* postJsonAsync */])('bundling', _extends({}, data, {
        tournamentId: tournament.id
      }))).then(function () {
        __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Saved!', 'Bundling Rule saved successfully.');
        dispatch(retrieveActiveBundles(tournament.id));
        resolve();
      }).catch(function () {
        return resolve();
      });
    });
  };
};

var handleCancel = function handleCancel() {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["e" /* cancelBundlingRuleItemForm */])());
  };
};

var handleNewBundlingRuleClick = function handleNewBundlingRuleClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["e" /* cancelBundlingRuleItemForm */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["f" /* displayNewBundlingRule */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["initialize"])('bundlingRuleItemForm', {}));
  };
};

var retrieveActiveBundles = function retrieveActiveBundles(tournamentId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["d" /* getJsonAsync */])('bundling/' + tournamentId + '/active')).then(function (data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["g" /* displayActiveBundlingRules */])(data));
    });
  };
};

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(473);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setTournamentStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setTournamentHasPendingChanges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setAvailableStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return publishStarts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return publishEnds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return displayConfirmStatusChangeModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cancelConfirmStatusChangeModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setExportSystemInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return loadingStarts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return loadingEnds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setExportStatus; });


var setTournamentStatus = function setTournamentStatus(status) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_TOURNAMENT_STATUS_FOR_TOURNAMENT_STATUS */],
    payload: status
  };
};

var setTournamentHasPendingChanges = function setTournamentHasPendingChanges(hasPendingChanges) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_TOURNAMENT_HAS_PENDING_CHANGES_FOR_TOURNAMENT_STATUS */],
    payload: hasPendingChanges
  };
};

var setAvailableStatuses = function setAvailableStatuses(statuses) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_AVAILABLE_STATUSES_FOR_TOURNAMENT_STATUS */],
    payload: statuses
  };
};

var publishStarts = function publishStarts() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* PUBLISH_STARTS_FOR_TOURNAMENT */]
  };
};

var publishEnds = function publishEnds() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* PUBLISH_ENDS_FOR_TOURNAMENT */]
  };
};

var displayConfirmStatusChangeModal = function displayConfirmStatusChangeModal(status) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* DISPLAY_CONFIRM_MODAL_FOR_STATUS_CHANGE */],
    payload: status
  };
};

var cancelConfirmStatusChangeModal = function cancelConfirmStatusChangeModal() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* CANCEL_CONFIRM_MODAL_FOR_STATUS_CHANGE */]
  };
};

var setExportSystemInfo = function setExportSystemInfo(exportSystemData) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* SET_EXPORT_SYSTEM_INFO */],
    payload: exportSystemData
  };
};

var loadingStarts = function loadingStarts() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* LOADING_STARTS_FOR_TOURNAMENT */]
  };
};

var loadingEnds = function loadingEnds() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* LOADING_ENDS_FOR_TOURNAMENT */]
  };
};

var setExportStatus = function setExportStatus(exportStatusData) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* SET_EXPORT_STATUS */],
    payload: exportStatusData
  };
};

/***/ }),
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var Size = exports.Size = {
  LARGE: 'large',
  SMALL: 'small',
  XSMALL: 'xsmall'
};

var SIZE_MAP = exports.SIZE_MAP = {
  large: 'lg',
  medium: 'md',
  small: 'sm',
  xsmall: 'xs',
  lg: 'lg',
  md: 'md',
  sm: 'sm',
  xs: 'xs'
};

var DEVICE_SIZES = exports.DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];

var State = exports.State = {
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info'
};

var Style = exports.Style = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  LINK: 'link',
  INVERSE: 'inverse'
};

/***/ }),
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(418);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setTournamentInformation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setReturningToCalendar; });


var setTournamentInformation = function setTournamentInformation(tournament) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_TOURNAMENT_INFORMATION_FOR_ADMIN */],
    payload: tournament
  };
};

var setReturningToCalendar = function setReturningToCalendar() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_RETURNING_TO_CALENDAR_FOR_ADMIN */]
  };
};

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(410);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setSearchBowlerValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return displayBowlerAudit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return displayBowlerAuditHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return displayBowlerAuditDetails; });


var setSearchBowlerValue = function setSearchBowlerValue(searchValue) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_ADMIN_AUDIT_SEARCH_BOWLER_VALUE */],
    payload: searchValue
  };
};

var displayBowlerAudit = function displayBowlerAudit(searchValue) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_ADMIN_AUDIT_SEARCH_BOWLERS */],
    payload: searchValue
  };
};

var displayBowlerAuditHeader = function displayBowlerAuditHeader(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_ADMIN_AUDIT_BOWLER_HEADER */],
    payload: data
  };
};

var displayBowlerAuditDetails = function displayBowlerAuditDetails(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_ADMIN_AUDIT_BOWLER_DETAILS */],
    payload: data
  };
};

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(411);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setSearchCaptainValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return displayCaptainAudit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return displayCaptainAuditHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return displayCaptainAuditDetails; });


var setSearchCaptainValue = function setSearchCaptainValue(searchValue) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_ADMIN_AUDIT_SEARCH_CAPTAIN_VALUE */],
    payload: searchValue
  };
};

var displayCaptainAudit = function displayCaptainAudit(searchValue) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_ADMIN_AUDIT_SEARCH_CAPTAINS */],
    payload: searchValue
  };
};

var displayCaptainAuditHeader = function displayCaptainAuditHeader(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_ADMIN_AUDIT_CAPTAIN_HEADER */],
    payload: data
  };
};

var displayCaptainAuditDetails = function displayCaptainAuditDetails(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_ADMIN_AUDIT_CAPTAIN_DETAILS */],
    payload: data
  };
};

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_ADMIN_AUDIT_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SELECT_ADMIN_AUDIT_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADMIN_AUDIT_TAB_TOURNAMENTS_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADMIN_AUDIT_TAB_CAPTAINS_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADMIN_AUDIT_TAB_TEAMS_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ADMIN_AUDIT_TAB_VIRTUAL_ENTRIES_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ADMIN_AUDIT_TAB_BOWLERS_LABEL; });
var CLEAR_ADMIN_AUDIT_SEARCH = 'CLEAR_ADMIN_AUDIT_SEARCH';
var SELECT_ADMIN_AUDIT_TAB = 'SELECT_ADMIN_AUDIT_TAB';

var ADMIN_AUDIT_TAB_TOURNAMENTS_LABEL = 'Tournaments';
var ADMIN_AUDIT_TAB_CAPTAINS_LABEL = 'Captains';
var ADMIN_AUDIT_TAB_TEAMS_LABEL = 'Teams';
var ADMIN_AUDIT_TAB_VIRTUAL_ENTRIES_LABEL = 'Virtual Entries';
var ADMIN_AUDIT_TAB_BOWLERS_LABEL = 'Bowlers';

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditTeamLedgerDetail_jsx__ = __webpack_require__(721);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var mapStateToProps = function mapStateToProps(props) {
  return _extends({}, props);
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditTeamLedgerDetail_jsx__["a" /* default */]);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(415);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setSearchTournamentValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return displayTournamentAudit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return displayTournamentAuditHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return displayTournamentAuditDetails; });


var setSearchTournamentValue = function setSearchTournamentValue(searchValue) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_ADMIN_AUDIT_SEARCH_TOURNAMENT_VALUE */],
    payload: searchValue
  };
};

var displayTournamentAudit = function displayTournamentAudit(searchValue) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_ADMIN_AUDIT_SEARCH_TOURNAMENTS */],
    payload: searchValue
  };
};

var displayTournamentAuditHeader = function displayTournamentAuditHeader(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_ADMIN_AUDIT_TOURNAMENT_HEADER */],
    payload: data
  };
};

var displayTournamentAuditDetails = function displayTournamentAuditDetails(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_ADMIN_AUDIT_TOURNAMENT_DETAILS */],
    payload: data
  };
};

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(416);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setSearchVirtualEntryValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return displayVirtualEntryAudit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return displayVirtualEntryAuditHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return displayVirtualEntryAuditDetails; });


var setSearchVirtualEntryValue = function setSearchVirtualEntryValue(searchValue) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_ADMIN_AUDIT_SEARCH_VIRTUAL_ENTRY_VALUE */],
    payload: searchValue
  };
};

var displayVirtualEntryAudit = function displayVirtualEntryAudit(searchValue) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_ADMIN_AUDIT_SEARCH_VIRTUAL_ENTRYS */],
    payload: searchValue
  };
};

var displayVirtualEntryAuditHeader = function displayVirtualEntryAuditHeader(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_ADMIN_AUDIT_VIRTUAL_ENTRY_HEADER */],
    payload: data
  };
};

var displayVirtualEntryAuditDetails = function displayVirtualEntryAuditDetails(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_ADMIN_AUDIT_VIRTUAL_ENTRY_DETAILS */],
    payload: data
  };
};

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(420);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return setAvailableBowlersInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setEntryStateDisabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return setEntryReadOnlyInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return setEntrySummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return clearRosterPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setVirtualEntriesToModify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setStates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setCountries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return updateRosterInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return searchingFinished; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return searchingStarts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setMemberSearchField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return moveRosterUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return moveRosterDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return setMemberAvgField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return setIsProfessional; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setRosterPositions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return displayEntryModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return displaySquadChangeModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return displayEventChangeModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return setEntryDetailBalance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return setEntryDetailCaptainId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return setEntryDetailTournament; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return setEntryDetailId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return displayPaymentLogHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return setPaymentLogHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return cancelEntryDetailPaymentModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return displayEntryDetailPaymentModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return hideEntryDetailPaymentModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return setEntryDetailCoordinator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return setEntryDetailCaptain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return displayEntryDetailCoordinatorModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return hideEntryDetailCoordinatorModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return cancelEntryDetailCoordinatorModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return displayEntryDetailChangeCaptainModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return hideEntryDetailChangeCaptainModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return cancelEntryDetailChangeCaptainModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return setIsNewCaptainOnSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return setVisibleEntryDetailRefundModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return setCreditPurchaseTransactions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return displayReactivationModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return setAdminEntryDetailRefundType; });


var setAvailableBowlersInState = function setAvailableBowlersInState(bowlers) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_AVAILABLE_BOWLERS_FOR_ADMIN_ENTRY_DETAIL */],
    payload: bowlers
  };
};

var setEntryStateDisabled = function setEntryStateDisabled(disabled) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_STATE_DISABLED_FOR_ADMIN_ENTRY_DETAIL */],
    payload: disabled
  };
};

var setEntryReadOnlyInfo = function setEntryReadOnlyInfo(readOnlyInfo) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_READONLY_INFO_FOR_ADMIN_ENTRY_DETAIL */],
    payload: readOnlyInfo
  };
};

var setEntrySummary = function setEntrySummary(summary) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_SUMMARY_FOR_ADMIN_ENTRY_DETAIL */],
    payload: summary
  };
};

var clearRosterPosition = function clearRosterPosition(index) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* CLEAR_ROSTER_POSITION_FOR_ADMIN_ENTRY_DETAIL */],
    payload: index
  };
};

var setVirtualEntriesToModify = function setVirtualEntriesToModify(virtualEntriesToModify) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SET_VIRTUAL_ENTRIES_TO_MODIFY_FOR_ADMIN_ENTRY_DETAIL */],
    payload: virtualEntriesToModify
  };
};

var setStates = function setStates(states) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* SET_STATES_FOR_ADMIN_ENTRY_DETAIL */],
    payload: states
  };
};

var setCountries = function setCountries(countries) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* SET_COUNTRIES_FOR_ADMIN_ENTRY_DETAIL */],
    payload: countries
  };
};

var updateRosterInfo = function updateRosterInfo(rosterInfo) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* UPDATE_ROSTER_INFO_FOR_ADMIN_ENTRY_DETAIL */],
    payload: rosterInfo
  };
};

var searchingFinished = function searchingFinished() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* SEARCHING_MEMBER_FINISHED_FOR_ADMIN_ENTRY_DETAIL */]
  };
};

var searchingStarts = function searchingStarts(rosterPosition) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* SEARCHING_MEMBER_STARTS_FOR_ADMIN_ENTRY_DETAIL */],
    payload: rosterPosition
  };
};

var setMemberSearchField = function setMemberSearchField(roster) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* SET_MEMBER_SEARCH_FIELD_FOR_ADMIN_ENTRY_DETAIL */],
    payload: roster
  };
};

var moveRosterUp = function moveRosterUp(index) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* MOVE_ROSTER_POSITION_UP_FOR_ADMIN_ENTRY_DETAIL */],
    payload: index
  };
};

var moveRosterDown = function moveRosterDown(index) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* MOVE_ROSTER_POSITION_DOWN_FOR_ADMIN_ENTRY_DETAIL */],
    payload: index
  };
};

var setMemberAvgField = function setMemberAvgField(position, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["o" /* SET_BOWLER_AVG_FOR_ADMIN_ENTRY_DETAIL_ROSTER_POSITION */],
    payload: { position: position, value: value }
  };
};

var setIsProfessional = function setIsProfessional(position, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["p" /* SET_IS_PROFESSIONAL_FOR_ADMIN_ENTRY_DETAIL_ROSTER_POSITION */],
    payload: { position: position, value: value }
  };
};

var setRosterPositions = function setRosterPositions(rosterPositions) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["q" /* SET_ROSTER_POSITIONS_FOR_ADMIN_ENTRY_DETAIL */],
    payload: rosterPositions
  };
};

var displayEntryModal = function displayEntryModal(visible) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["r" /* SET_ROSTER_MODAL_VISIBILITY_FOR_ADMIN_ENTRY_DETAIL */],
    payload: visible
  };
};

var displaySquadChangeModal = function displaySquadChangeModal(showModal) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["s" /* DISPLAY_ENTRY_DETAIL_CHANGE_SQUAD_MODAL */],
    payload: showModal
  };
};

var displayEventChangeModal = function displayEventChangeModal(showModal) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["t" /* DISPLAY_ENTRY_DETAIL_CHANGE_EVENT_MODAL */],
    payload: showModal
  };
};

var setEntryDetailBalance = function setEntryDetailBalance(balance) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["u" /* SET_ENTRY_DETAIL_BALANCE_FOR_ADMIN */],
    payload: balance
  };
};

var setEntryDetailCaptainId = function setEntryDetailCaptainId(captainId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["v" /* SET_ENTRY_DETAIL_CAPTAINID_FOR_ADMIN */],
    payload: captainId
  };
};

var setEntryDetailTournament = function setEntryDetailTournament(tournament) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["w" /* SET_ENTRY_DETAIL_TOURNAMENT_FOR_ADMIN */],
    payload: tournament
  };
};

var setEntryDetailId = function setEntryDetailId(entryId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["x" /* SET_ENTRY_DETAIL_ID_FOR_ADMIN */],
    payload: entryId
  };
};

var displayPaymentLogHistory = function displayPaymentLogHistory(optionalShowLog) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* DISPLAY_PAYMENT_LOG_HISTORY_FOR_ADMIN_ENTRY_DETAIL */],
    payload: optionalShowLog
  };
};

var setPaymentLogHistory = function setPaymentLogHistory(paymentLogHistory) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["z" /* SET_PAYMENT_LOG_HISTORY_FOR_ADMIN_ENTRY_DETAIL */],
    payload: paymentLogHistory
  };
};

var cancelEntryDetailPaymentModal = function cancelEntryDetailPaymentModal() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["A" /* CANCEL_ENTRY_DETAIL_PAYMENT_MODAL */]
  };
};

var displayEntryDetailPaymentModal = function displayEntryDetailPaymentModal() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["B" /* DISPLAY_ENTRY_DETAIL_PAYMENT_MODAL */]
  };
};

var hideEntryDetailPaymentModal = function hideEntryDetailPaymentModal() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["C" /* HIDE_ENTRY_DETAIL_PAYMENT_MODAL */]
  };
};

var setEntryDetailCoordinator = function setEntryDetailCoordinator(coordinator) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["D" /* SET_ENTRY_DETAIL_COORDINATOR_FOR_ADMIN */],
    payload: coordinator
  };
};

var setEntryDetailCaptain = function setEntryDetailCaptain(captain) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["E" /* SET_ENTRY_DETAIL_CAPTAIN_FOR_ADMIN */],
    payload: captain
  };
};

var displayEntryDetailCoordinatorModal = function displayEntryDetailCoordinatorModal() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["F" /* SHOW_HIDE_ENTRY_DETAIL_COORDINATOR_MODAL_FOR_ADMIN */],
    payload: true
  };
};

var hideEntryDetailCoordinatorModal = function hideEntryDetailCoordinatorModal() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["F" /* SHOW_HIDE_ENTRY_DETAIL_COORDINATOR_MODAL_FOR_ADMIN */],
    payload: false
  };
};

var cancelEntryDetailCoordinatorModal = function cancelEntryDetailCoordinatorModal() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["F" /* SHOW_HIDE_ENTRY_DETAIL_COORDINATOR_MODAL_FOR_ADMIN */],
    payload: false
  };
};

var displayEntryDetailChangeCaptainModal = function displayEntryDetailChangeCaptainModal() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["G" /* SHOW_HIDE_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN */],
    payload: true
  };
};

var hideEntryDetailChangeCaptainModal = function hideEntryDetailChangeCaptainModal() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["G" /* SHOW_HIDE_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN */],
    payload: false
  };
};

var cancelEntryDetailChangeCaptainModal = function cancelEntryDetailChangeCaptainModal() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["G" /* SHOW_HIDE_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN */],
    payload: false
  };
};

var setIsNewCaptainOnSearch = function setIsNewCaptainOnSearch(isNew) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["H" /* SET_IS_NEW_CAPTAIN_ENTRY_DETAIL */],
    payload: isNew
  };
};

var setVisibleEntryDetailRefundModal = function setVisibleEntryDetailRefundModal(visible) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["I" /* SHOW_HIDE_ENTRY_DETAIL_REFUND_MODAL_FOR_ADMIN */],
    payload: visible
  };
};

var setCreditPurchaseTransactions = function setCreditPurchaseTransactions(creditPurchaseTransactions) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["J" /* SET_ENTRY_DETAIL_CREDIT_PURCHASE_TRANSACTIONS */],
    payload: creditPurchaseTransactions
  };
};

var displayReactivationModal = function displayReactivationModal(showModal) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["K" /* SHOW_HIDE_ENTRY_DETAIL_REACTIVATION_MODAL_FOR_ADMIN */],
    payload: showModal
  };
};

var setAdminEntryDetailRefundType = function setAdminEntryDetailRefundType(refundType) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["L" /* SET_ADMIN_ENTRY_DETAIL_REFUND_TYPE */],
    payload: refundType
  };
};

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(421);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setIncludePastTournamentsInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setSearchValueInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setSearchResultInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setSearchBySelected; });


var setIncludePastTournamentsInState = function setIncludePastTournamentsInState(checked) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_INCLUDE_PAST_TOURNAMENTS_IN_STATE_FOR_ADMIN_HOME */],
    payload: checked
  };
};

var setSearchValueInState = function setSearchValueInState(searchValue) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_SEARCH_VALUE_IN_STATE_FOR_ADMIN_HOME */],
    payload: searchValue
  };
};

var setSearchResultInState = function setSearchResultInState(searchResult) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_SEARCH_RESULT_IN_STATE_FOR_ADMIN_HOME */],
    payload: searchResult
  };
};

var setSearchBySelected = function setSearchBySelected(id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_SEARCH_BY_SELECTED_FOR_ADMIN_HOME */],
    payload: id
  };
};

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(865);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadFinancialAccounts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handleDeactivateAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handleAccountNameEditClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleEditAccountModalCancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return handleEditAccountModalSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return completeCreateAccount; });







var loadFinancialAccounts = function loadFinancialAccounts() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["d" /* getJsonAsync */])('finance/getaccounts')).then(function (data) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["a" /* displayFinanceAccountsList */])(data));
    }).catch(function () {});
  };
};

var handleDeactivateAccount = function handleDeactivateAccount(data) {
  return function (dispatch) {

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["e" /* postJsonAsync */])('finance/deactivateaccount', { accountId: data })).then(function (response) {

      if (response != null && response.isSuccess == true) {
        dispatch(loadFinancialAccounts());
      } else {
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].error('Error', 'An error occured while deactivating the account.');
      }
    }).catch(function () {
      __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].error('Error', 'An error occured while deactivating the account.');
    });
  };
};

var handleAccountNameEditClick = function handleAccountNameEditClick(accountId) {
  return function (dispatch, getState) {
    var accountsList = getState().finance.accounts.accountsList;
    var account = accountsList.accounts.find(function (x) {
      return x.id === accountId;
    });
    var accountName = account.name;
    var data = {
      accountId: accountId,
      accountName: accountName
    };

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["b" /* displayEditAccountModalVisibility */])(true));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["initialize"])('editAccountForm', data));
    setTimeout(function () {
      // focus field after animatation finished (~800ms) by directly accessing the dom
      document.querySelectorAll('.modal-dialog #editAccountForm [name=accountName]')[0].focus();
    }, 800);
  };
};

var handleEditAccountModalCancel = function handleEditAccountModalCancel() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["b" /* displayEditAccountModalVisibility */])(false));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["reset"])('editAccountForm'));
  };
};

var handleEditAccountModalSave = function handleEditAccountModalSave(data) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["e" /* postJsonAsync */])('finance/modifyaccount', data)).then(function () {
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Saved!', 'Account successfully saved.');
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["b" /* displayEditAccountModalVisibility */])(false));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["reset"])('editAccountForm'));
        dispatch(loadFinancialAccounts());
        resolve();
      }).catch(function (error) {
        return reject(error);
      });
    });
  };
};

var completeCreateAccount = function completeCreateAccount() {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {

      var urlParams = new URLSearchParams(window.location.search);
      var code = urlParams.get('code');
      var state = urlParams.get('state');
      var request = { code: code, state: state };

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_actions__["e" /* postJsonAsync */])('finance/createaccount', request)).then(function (response) {

        if (response != null && response.isSuccess == true) {
          __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Account created successfully!');
          resolve();
        } else {
          __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].error('Error Creating Account!', 'An error occured while creating the account.');
          reject();
        }
      }).catch(function (error) {
        return reject(error);
      });
    });
  };
};

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SELECT_ADMIN_FINANCE_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADMIN_AUDIT_FINANCE_MANAGEACCOUNTS_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADMIN_AUDIT_FINANCE_VIEWFEES_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADMIN_AUDIT_FINANCE_SETFEES_LABEL; });
var SELECT_ADMIN_FINANCE_TAB = 'SELECT_ADMIN_FINANCE_TAB';

var ADMIN_AUDIT_FINANCE_MANAGEACCOUNTS_LABEL = 'Manage Accounts';
var ADMIN_AUDIT_FINANCE_VIEWFEES_LABEL = 'View Fees';
var ADMIN_AUDIT_FINANCE_SETFEES_LABEL = 'Set Fees';

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(443);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return displayGuideIfBundled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setNoDatesAvailable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setSelectedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateSquadQuantity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setSeletedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return displayAvailableDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return displaySquads; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return displayVirtualEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return updateBowlerOwnedVirtualEventQuantity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return updateTeamOwnedVirtualEventQuantity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateSquadCountInCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return updateBowlerOwnedVirtualEventCountInCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return updateTeamOwnedVirtualEventCountInCart; });


var displayGuideIfBundled = function displayGuideIfBundled(squadId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_GUIDE_IF_SQUAD_IS_BUNDLED */],
    payload: squadId
  };
};

var setNoDatesAvailable = function setNoDatesAvailable(value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_NO_DATES_AVAILABLE_FOR_REG_SCHEDULER */],
    payload: value
  };
};

var setSelectedDate = function setSelectedDate(date) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_CALENDAR_SELECTED_DATE */],
    payload: date
  };
};

var updateTotal = function updateTotal(cart) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* UPDATE_TOTAL_FOR_REG_SCHEDULER */],
    payload: cart
  };
};

var updateSquadQuantity = function updateSquadQuantity(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* UPDATE_SQUAD_QTY_FOR_REG_SCHEDULER */],
    payload: data
  };
};

var setSeletedDate = function setSeletedDate(selectedDate) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SET_SELECTED_DATE */],
    payload: selectedDate
  };
};

var displayAvailableDates = function displayAvailableDates(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* DISPLAY_AVAILABLE_DATES */],
    payload: data
  };
};

var displaySquads = function displaySquads(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* DISPLAY_SQUADS */],
    payload: data
  };
};

var displayVirtualEvents = function displayVirtualEvents(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* DISPLAY_BOWLER_OWNED_VIRTUAL_EVENTS */],
    payload: data
  };
};

var updateBowlerOwnedVirtualEventQuantity = function updateBowlerOwnedVirtualEventQuantity(virtualEventId, quantity) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_QTY_FOR_REG_SCHEDULER */],
    payload: { virtualEventId: virtualEventId, quantity: quantity }
  };
};

var updateTeamOwnedVirtualEventQuantity = function updateTeamOwnedVirtualEventQuantity(eventId, virtualEventId, quantity) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* UPDATE_TEAM_OWNED_VIRTUAL_EVENT_QTY_FOR_REG_SCHEDULER */],
    payload: { eventId: eventId, virtualEventId: virtualEventId, quantity: quantity }
  };
};

var updateSquadCountInCart = function updateSquadCountInCart(squadId, quantity) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* UPDATE_SQUAD_COUNT_IN_CART_FOR_REG_SCHEDULER */],
    payload: { squadId: squadId, quantity: quantity }
  };
};

var updateBowlerOwnedVirtualEventCountInCart = function updateBowlerOwnedVirtualEventCountInCart(virtualEventId, count) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_REG_SCHEDULER */],
    payload: { virtualEventId: virtualEventId, count: count }
  };
};

var updateTeamOwnedVirtualEventCountInCart = function updateTeamOwnedVirtualEventCountInCart(eventId, virtualEventId, count) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* UPDATE_TEAM_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_REG_SCHEDULER */],
    payload: { eventId: eventId, virtualEventId: virtualEventId, count: count }
  };
};

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return ASSIGN_CHILD_TEAM_OWNED_VIRTUAL_ENTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return ASSIGN_TEAM_OWNED_VIRTUAL_ENTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CALCULATE_BALANCE_DUE_FOR_REG_MANAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CANCEL_ENTRY_DETAILS_FOR_REG_MANAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CANCEL_ENTRY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CANCEL_PURCHASED_ENTRY_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CLOSE_VIRTUAL_BOWLER_EDITING_FOR_REG_MANAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CANCEL_VIRTUAL_EVENT_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return CLEAR_CART_BOWLERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return CLEAR_CART_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return CLEAR_PURCHASED_TEAM_OWNED_VIRTUAL_ENTRIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return CLEAR_SHARED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return CLEAR_POSITION_FOR_REG_ROSTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return CONVERT_ENTRIES_FROM_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return CONVERT_VIRTUAL_ENTRIES_FROM_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return CREATE_CART_ROSTER_POSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DISPLAY_ENTRY_DETAILS_FOR_REG_MANAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DISPLAY_CLEAR_CART_CONFIRMATION_FOR_CAPTAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DISPLAY_COUNTRIES_IN_DD_FOR_ENTRY_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return DISPLAY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE_TEAMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DISPLAY_PURCHASED_ENTRIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DISPLAY_PURCHASED_ENTRY_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DISPLAY_ROSTER_POSITIONS_FOR_REG_MANAGE_PURCHASES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DISPLAY_STATES_IN_DD_FOR_ENTRY_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DISPLAY_TEAM_OWNED_VIRTUAL_ENTRIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DISPLAY_VIRTUAL_ENTRIES_FOR_REG_MANAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DISPLAY_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return DISPLAY_VIRTUAL_EVENT_PAYMENT_LOG_FOR_REG_MANAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return MOVE_POSITION_DOWN_FOR_REG_ROSTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return MOVE_POSITION_UP_FOR_REG_ROSTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return REINSERT_MANAGED_ROSTER_IDS_INTO_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return REMOVE_CART_ENTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return REMOVE_UNASSIGNED_CHILD_VIRTUAL_ENTRIES_ROSTER_CHECKOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return REMOVE_UNASSIGNED_PARENT_VIRTUAL_ENTRIES_ROSTER_CHECKOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return REMOVE_VIRTUAL_ENTRY_BOWLER_FROM_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return RESET_TEAM_OWNED_VIRTUAL_ENTRY_EVENT_ASSIGNMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return SEARCHING_MEMBER_FINISHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return SEARCHING_MEMBER_STARTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_AVAILABLE_BOWLERS_IN_STATE_FOR_REG_MANAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SET_AVAILABLE_BOWLERS_IN_STATE_FOR_REG_MANAGE_FOR_VIRTUAL_ENTRIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SET_BOWLER_FOR_CART_VIRTUAL_ENTRY_FOR_REG_MANAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return SET_BOWLER_FOR_VIRTUAL_ENTRY_FOR_REG_MANAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return SET_CART_BOWLERS_FOR_CART_ROSTER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return SET_CART_ROSTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return SET_CART_ROSTER_ID_FOR_VIRTUAL_EVENT_IN_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return SET_CART_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return SET_CURRENT_ROSTER_CART_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return SET_CART_ROSTERS_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return SET_CART_ROSTER_ON_CART_VIRTUAL_ENTRIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return SET_CART_ROSTER_ON_EDITING_ENTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return SET_CURRENT_ROSTER_CART_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SET_ENTRY_DETAILS_IN_STATE_FOR_REG_MANAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SET_ENTRY_STATE_DISABLED_FOR_REG_MANAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return SET_IS_PROFESSIONAL_FOR_REG_ROSTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return SET_MEMBER_AVG_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return SET_MEMBER_SEARCH_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SET_REMOVE_VIRTUAL_ENTRY_CONFIRMATION_FOR_ROSTER_CHECKOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SET_ROSTER_CONFIRMATION_VISIBILITY_FOR_MANAGE_ENTRIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return SET_SELECTED_ENTRY_FOR_REG_MANAGE_ENTRIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return SET_SELECTED_VIRTUAL_EVENT_FOR_REG_MANAGE_ENTRIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SET_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return SET_VIRTUAL_ENTRY_ROSTER_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return STORE_TEAM_OWNED_VIRTUAL_ENTRY_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return UPDATE_CART_ENTRY_FOR_CHILD_TEAM_OWNED_VIRTUAL_ENTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return UPDATE_CART_ENTRY_FOR_PARENT_TEAM_OWNED_VIRTUAL_ENTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return UPDATE_ROSTER_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return UPDATE_VIRTUAL_AVAILABLE_ENTRY_FROM_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return VIRTUAL_ENTRY_SUBMITTING_FINISHED_FOR_REG_MANAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return VIRTUAL_ENTRY_SUBMITTING_STARTS_FOR_REG_MANAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return SET_BOWLER_FOR_CART_VIRTUAL_ENTRY_ALREADY_ASSIGNED_FOR_REG_MANAGE; });
var ASSIGN_CHILD_TEAM_OWNED_VIRTUAL_ENTRY = 'ASSIGN_CHILD_TEAM_OWNED_VIRTUAL_ENTRY';
var ASSIGN_TEAM_OWNED_VIRTUAL_ENTRY = 'ASSIGN_TEAM_OWNED_VIRTUAL_ENTRY';
var CALCULATE_BALANCE_DUE_FOR_REG_MANAGE = 'CALCULATE_BALANCE_DUE_FOR_REG_MANAGE';
var CANCEL_ENTRY_DETAILS_FOR_REG_MANAGE = 'CANCEL_ENTRY_DETAILS_FOR_REG_MANAGE';
var CANCEL_ENTRY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE = 'CANCEL_ENTRY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE';
var CANCEL_PURCHASED_ENTRY_FORM = 'CANCEL_PURCHASED_ENTRY_FORM';
var CLOSE_VIRTUAL_BOWLER_EDITING_FOR_REG_MANAGE = 'CLOSE_VIRTUAL_BOWLER_EDITING_FOR_REG_MANAGE';
var CANCEL_VIRTUAL_EVENT_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE = 'CANCEL_VIRTUAL_EVENT_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE';
var CLEAR_CART_BOWLERS = 'CLEAR_CART_BOWLERS';
var CLEAR_CART_ITEMS = 'CLEAR_CART_ITEMS';
var CLEAR_PURCHASED_TEAM_OWNED_VIRTUAL_ENTRIES = 'CLEAR_PURCHASED_TEAM_OWNED_VIRTUAL_EVENTS';
var CLEAR_SHARED = 'CLEAR_SHARED';
var CLEAR_POSITION_FOR_REG_ROSTERS = 'CLEAR_POSITION_FOR_REG_ROSTERS';
var CONVERT_ENTRIES_FROM_CART = 'CONVERT_ENTRIES_FROM_CART';
var CONVERT_VIRTUAL_ENTRIES_FROM_CART = 'CONVERT_VIRTUAL_ENTRIES_FROM_CART';
var CREATE_CART_ROSTER_POSITIONS = 'CREATE_CART_ROSTER_POSITIONS';
var DISPLAY_ENTRY_DETAILS_FOR_REG_MANAGE = 'DISPLAY_ENTRY_DETAILS_FOR_REG_MANAGE';
var DISPLAY_CLEAR_CART_CONFIRMATION_FOR_CAPTAIN = 'DISPLAY_CLEAR_CART_CONFIRMATION_FOR_CAPTAIN';
var DISPLAY_COUNTRIES_IN_DD_FOR_ENTRY_FORM = 'DISPLAY_COUNTRIES_IN_DD_FOR_ENTRY_FORM';
var DISPLAY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE_TEAMS = 'DISPLAY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE_TEAMS';
var DISPLAY_PURCHASED_ENTRIES = 'DISPLAY_PURCHASED_ENTRIES';
var DISPLAY_PURCHASED_ENTRY_FORM = 'DISPLAY_PURCHASED_ENTRY_FORM';
var DISPLAY_ROSTER_POSITIONS_FOR_REG_MANAGE_PURCHASES = 'DISPLAY_ROSTER_POSITIONS_FOR_REG_MANAGE_PURCHASES';
var DISPLAY_STATES_IN_DD_FOR_ENTRY_FORM = 'DISPLAY_STATES_IN_DD_FOR_ENTRY_FORM';
var DISPLAY_TEAM_OWNED_VIRTUAL_ENTRIES = 'DISPLAY_TEAM_OWNED_VIRTUAL_ENTRIES';
var DISPLAY_VIRTUAL_ENTRIES_FOR_REG_MANAGE = 'DISPLAY_VIRTUAL_ENTRIES_FOR_REG_MANAGE';
var DISPLAY_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE = 'DISPLAY_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE';
var DISPLAY_VIRTUAL_EVENT_PAYMENT_LOG_FOR_REG_MANAGE = 'DISPLAY_VIRTUAL_EVENT_PAYMENT_LOG_FOR_REG_MANAGE';
var MOVE_POSITION_DOWN_FOR_REG_ROSTERS = 'MOVE_POSITION_DOWN_FOR_REG_ROSTERS';
var MOVE_POSITION_UP_FOR_REG_ROSTER = 'MOVE_POSITION_UP_FOR_REG_ROSTER';
var REINSERT_MANAGED_ROSTER_IDS_INTO_CART = 'REINSERT_MANAGED_ROSTER_IDS_INTO_CART';
var REMOVE_CART_ENTRY = 'REMOVE_CART_ENTRY';
var REMOVE_UNASSIGNED_CHILD_VIRTUAL_ENTRIES_ROSTER_CHECKOUT = 'REMOVE_UNASSIGNED_CHILD_VIRTUAL_ENTRIES_ROSTER_CHECKOUT';
var REMOVE_UNASSIGNED_PARENT_VIRTUAL_ENTRIES_ROSTER_CHECKOUT = 'REMOVE_UNASSIGNED_PARENT_VIRTUAL_ENTRIES_ROSTER_CHECKOUT';
var REMOVE_VIRTUAL_ENTRY_BOWLER_FROM_CART = 'REMOVE_VIRTUAL_ENTRY_BOWLER_FROM_CART';
var RESET_TEAM_OWNED_VIRTUAL_ENTRY_EVENT_ASSIGNMENT = 'RESET_TEAM_OWNED_VIRTUAL_ENTRY_EVENT_ASSIGNMENT';
var SEARCHING_MEMBER_FINISHED = 'SEARCHING_MEMBER_FINISHED';
var SEARCHING_MEMBER_STARTS = 'SEARCHING_MEMBER_STARTS';
var SET_AVAILABLE_BOWLERS_IN_STATE_FOR_REG_MANAGE = 'SET_AVAILABLE_BOWLERS_IN_STATE_FOR_REG_MANAGE';
var SET_AVAILABLE_BOWLERS_IN_STATE_FOR_REG_MANAGE_FOR_VIRTUAL_ENTRIES = 'SET_AVAILABLE_BOWLERS_IN_STATE_FOR_REG_MANAGE_FOR_VIRTUAL_ENTRIES';
var SET_BOWLER_FOR_CART_VIRTUAL_ENTRY_FOR_REG_MANAGE = 'SET_BOWLER_FOR_CART_VIRTUAL_ENTRY_FOR_REG_MANAGE';
var SET_BOWLER_FOR_VIRTUAL_ENTRY_FOR_REG_MANAGE = 'SET_BOWLER_FOR_VIRTUAL_ENTRY_FOR_REG_MANAGE';
var SET_CART_BOWLERS_FOR_CART_ROSTER_ID = 'SET_CART_BOWLERS_FOR_CART_ROSTER_ID';
var SET_CART_ROSTER = 'SET_CART_ROSTER';
var SET_CART_ROSTER_ID_FOR_VIRTUAL_EVENT_IN_CART = 'SET_CART_ROSTER_ID_FOR_VIRTUAL_EVENT_IN_CART';
var SET_CART_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE = 'SET_CART_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE';
var SET_CURRENT_ROSTER_CART_COMPLETE = 'SET_CURRENT_ROSTER_CART_COMPLETE';
var SET_CART_ROSTERS_COMPLETE = 'SET_CART_ROSTERS_COMPLETE';
var SET_CART_ROSTER_ON_CART_VIRTUAL_ENTRIES = 'SET_CART_ROSTER_ON_CART_VIRTUAL_ENTRIES';
var SET_CART_ROSTER_ON_EDITING_ENTRY = 'SET_CART_ROSTER_ON_EDITING_ENTRY';
var SET_CURRENT_ROSTER_CART_ID = 'SET_CURRENT_ROSTER_CART_ID';
var SET_ENTRY_DETAILS_IN_STATE_FOR_REG_MANAGE = 'SET_ENTRY_DETAILS_IN_STATE_FOR_REG_MANAGE';
var SET_ENTRY_STATE_DISABLED_FOR_REG_MANAGE = 'SET_ENTRY_STATE_DISABLED_FOR_REG_MANAGE';
var SET_IS_PROFESSIONAL_FOR_REG_ROSTER = 'SET_IS_PROFESSIONAL_FOR_REG_ROSTER';
var SET_MEMBER_AVG_FIELD = 'SET_MEMBER_AVG_FIELD';
var SET_MEMBER_SEARCH_FIELD = 'SET_MEMBER_SEARCH_FIELD';
var SET_REMOVE_VIRTUAL_ENTRY_CONFIRMATION_FOR_ROSTER_CHECKOUT = 'SET_REMOVE_VIRTUAL_ENTRY_CONFIRMATION_FOR_ROSTER_CHECKOUT';
var SET_ROSTER_CONFIRMATION_VISIBILITY_FOR_MANAGE_ENTRIES = 'SET_ROSTER_CONFIRMATION_VISIBILITY_FOR_MANAGE_ENTRIES';
var SET_SELECTED_ENTRY_FOR_REG_MANAGE_ENTRIES = 'SET_SELECTED_ENTRY_FOR_REG_MANAGE_ENTRIES';
var SET_SELECTED_VIRTUAL_EVENT_FOR_REG_MANAGE_ENTRIES = 'SET_SELECTED_VIRTUAL_EVENT_FOR_REG_MANAGE_ENTRIES';
var SET_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE = 'SET_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE';
var SET_VIRTUAL_ENTRY_ROSTER_COMPLETE = 'SET_VIRTUAL_ENTRY_ROSTER_COMPLETE';
var STORE_TEAM_OWNED_VIRTUAL_ENTRY_MAP = 'STORE_TEAM_OWNED_VIRTUAL_ENTRY_MAP';
var UPDATE_CART_ENTRY_FOR_CHILD_TEAM_OWNED_VIRTUAL_ENTRY = 'UPDATE_CART_ENTRY_FOR_CHILD_TEAM_OWNED_VIRTUAL_ENTRY';
var UPDATE_CART_ENTRY_FOR_PARENT_TEAM_OWNED_VIRTUAL_ENTRY = 'UPDATE_CART_ENTRY_FOR_PARENT_TEAM_OWNED_VIRTUAL_ENTRY';
var UPDATE_ROSTER_INFO = 'UPDATE_ROSTER_INFO';
var UPDATE_VIRTUAL_AVAILABLE_ENTRY_FROM_CART = 'UPDATE_VIRTUAL_AVAILABLE_ENTRY_FROM_CART';
var VIRTUAL_ENTRY_SUBMITTING_FINISHED_FOR_REG_MANAGE = 'VIRTUAL_ENTRY_SUBMITTING_FINISHED_FOR_REG_MANAGE';
var VIRTUAL_ENTRY_SUBMITTING_STARTS_FOR_REG_MANAGE = 'VIRTUAL_ENTRY_SUBMITTING_STARTS_FOR_REG_MANAGE';
var SET_BOWLER_FOR_CART_VIRTUAL_ENTRY_ALREADY_ASSIGNED_FOR_REG_MANAGE = 'SET_BOWLER_FOR_CART_VIRTUAL_ENTRY_ALREADY_ASSIGNED_FOR_REG_MANAGE';

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldValidationError_jsx__ = __webpack_require__(111);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DollarInputField = function DollarInputField(_ref) {
  var autoFocus = _ref.autoFocus,
      disabled = _ref.disabled,
      input = _ref.input,
      label = _ref.label,
      placeholder = _ref.placeholder,
      step = _ref.step,
      min = _ref.min,
      style = _ref.style,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('input-group', { 'has-error': touched && error }) },
    label || placeholder ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'label',
      { style: { display: 'table-caption' },
        htmlFor: name },
      label || placeholder
    ) : null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: 'input-group-addon' },
      '$'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, input, {
      autoFocus: autoFocus,
      className: 'form-control',
      disabled: disabled,
      min: min,
      placeholder: placeholder,
      step: step,
      type: 'number',
      style: style
    })),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FieldValidationError_jsx__["a" /* default */], {
      touched: touched,
      error: error
    })
  );
};

DollarInputField.propTypes = {
  autoFocus: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  input: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  disabled: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  label: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,
  meta: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  name: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  placeholder: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  step: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  min: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  style: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};

/* harmony default export */ __webpack_exports__["a"] = DollarInputField;

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_StandardCheckboxField_jsx__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_DisplayIf_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);









var EntryRosterList = function EntryRosterList(_ref) {
  var sourceQty = _ref.sourceQty,
      source = _ref.source,
      bowlers = _ref.bowlers,
      parentEntryId = _ref.parentEntryId,
      childVirtualEntryEvents = _ref.childVirtualEntryEvents,
      eventIsLinked = _ref.eventIsLinked,
      childTeamOwnedVirtualEntries = _ref.childTeamOwnedVirtualEntries,
      rosterCheckout = _ref.rosterCheckout,
      showCalculatedDivisionToCaptain = _ref.showCalculatedDivisionToCaptain,
      onCartRoster = _ref.onCartRoster,
      onSearch = _ref.onSearch,
      onSearchChange = _ref.onSearchChange,
      onAvgChange = _ref.onAvgChange,
      onSearchEnterKeyPress = _ref.onSearchEnterKeyPress,
      onIsProfessionalChange = _ref.onIsProfessionalChange,
      onMoveUpClick = _ref.onMoveUpClick,
      onMoveDownClick = _ref.onMoveDownClick,
      onRosterPositionCleared = _ref.onRosterPositionCleared,
      onAssignChildTeamOwnedVirtualEventClick = _ref.onAssignChildTeamOwnedVirtualEventClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'contact-card-wrapper' },
    source.map(function (roster, rosterIndex) {
      var modifiedWithValue = roster._searchChanged && roster._searchValue !== roster.bowler.usbcId && !roster.usbcIdError;

      if (roster._searchValue === "" && !roster.bowler.usbcId) modifiedWithValue = false;

      var retrievedAndUnmodified = !modifiedWithValue && roster._retrieved && !roster.usbcIdError;
      var notRetrievedAndUnmodified = !modifiedWithValue && !roster._retrieved && !roster.usbcIdError;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'contact-card',
          key: rosterIndex
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'contact-card-info-wrapper' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'flex direction-column vertical-center' },
            sourceQty > 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              {
                className: 'btn-move-up',
                disabled: rosterIndex === 0,
                type: 'button',
                onClick: function onClick() {
                  return onMoveUpClick(rosterIndex);
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-up' })
            ) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('contact-card-avatar', { 'empty': !roster._retrieved })
              },
              rosterIndex + 1
            ),
            sourceQty > 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              {
                className: 'btn-move-down',
                disabled: rosterIndex === sourceQty - 1,
                type: 'button',
                onClick: function onClick() {
                  return onMoveDownClick(rosterIndex);
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-down' })
            ) : null
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'contact-card-info row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-lg-7 col-xs-12' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-xs-8' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'input-group-addon' },
                      'Member ID ',
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'small',
                        null,
                        '(###-###)'
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      name: 'usbcId-' + roster.position,
                      className: 'form-control',
                      type: 'text',
                      placeholder: '(ie. 1234-1234)',
                      pattern: '^\\d+(-\\d+)$',
                      value: roster._searchValue,
                      onChange: function onChange(event) {
                        return onSearchChange(roster, event);
                      },
                      onKeyDown: function onKeyDown(event) {
                        return onSearchEnterKeyPress(roster, event);
                      },
                      onInput: function onInput(event) {
                        return onSearchChange(roster, event);
                      },
                      list: 'usbcbowlers-' + roster.position
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'datalist',
                      { id: 'usbcbowlers-' + roster.position },
                      bowlers.map(function (b, index) {
                        return source.find(function (x) {
                          return x.bowler.id == b.id;
                        }) ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'option',
                          { key: index,
                            value: b.memberId },
                          b.name
                        );
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      {
                        type: 'button',
                        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('btn', { 'btn-primary': retrievedAndUnmodified }, { 'btn-primary-brand': notRetrievedAndUnmodified }, { 'btn-warning': modifiedWithValue }, { 'btn-danger': roster.usbcIdError }),
                        disabled: roster._processing,
                        onClick: function onClick() {
                          return onSearch(roster);
                        }
                      },
                      roster._processing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__["a" /* default */], null) : retrievedAndUnmodified ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-plus' })
                    ),
                    roster._errorMessage ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      {
                        type: 'button',
                        className: 'btn btn-link',
                        style: { marginLeft: 0, paddingTop: 0, paddingBottom: 0 },
                        onClick: function onClick() {
                          return onRosterPositionCleared(rosterIndex);
                        }
                      },
                      'Clear Position'
                    ) : null
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-xs-4' },
                  roster.averageRequired && roster._retrieved ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      {
                        className: 'input-group-addon avg' },
                      'AVG'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["Field"], {
                      name: 'average-' + roster.position,
                      disabled: roster.bowler.readOnly,
                      className: 'form-control',
                      required: roster.averageRequired,
                      onCustomChange: function onCustomChange(event) {
                        return onAvgChange(roster.position, event.target.value);
                      },
                      component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
                      style: { width: 60 }
                    })
                  ) : null
                )
              ),
              roster.usbcIdError ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'roster-notification' },
                ' Click the plus button or clear the member ID '
              ) : null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-xs-8' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    null,
                    roster.bowler.firstName,
                    ' ',
                    roster.bowler.initial ? roster.bowler.initial : '',
                    ' ',
                    roster.bowler.lastName,
                    ' ',
                    roster.bowler.lineage ? roster.bowler.lineage : ''
                  ),
                  roster._retrieved ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    {
                      type: 'button',
                      className: 'btn btn-link',
                      style: { marginLeft: 20, paddingTop: 0, paddingBottom: 0 },
                      onClick: function onClick() {
                        return onRosterPositionCleared(rosterIndex);
                      }
                    },
                    'Clear Position'
                  ) : null
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-xs-4' },
                  roster.bowler.gender ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    'Gender: ' + roster.bowler.gender
                  ) : null
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-xs-8' },
                  roster.bowler.city && roster.bowler.state && roster.bowler.zip ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    roster.bowler.city,
                    ', ',
                    roster.bowler.state,
                    ' ',
                    roster.bowler.zip
                  ) : null
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-xs-4' },
                  roster.bowler.birthDate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    'Age: ' + __WEBPACK_IMPORTED_MODULE_7_moment___default()().diff(roster.bowler.birthDate, 'years')
                  ) : null
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-xs-8' },
                  roster._retrieved ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'checkbox' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                        name: 'isProfessional-' + roster.position,
                        type: 'checkbox',
                        disabled: roster.bowler.readOnly,
                        checked: roster.bowler.isProfessional,
                        onChange: function onChange(event) {
                          return onIsProfessionalChange(roster.position, event.target.checked);
                        }
                      }),
                      ' ',
                      'This bowler is a Pro'
                    )
                  ) : null
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-xs-12' },
                  roster._errorMessage ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'roster-notification' },
                    roster._errorMessage
                  ) : null
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-xs-12' },
                  roster.bowler.isOnOtherRosters ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'roster-notification' },
                    'Warning: this bowler is already on other rosters for this event'
                  ) : null
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-lg-5 col-xs-12' },
              childVirtualEntryEvents && childVirtualEntryEvents.length > 0 ? childVirtualEntryEvents.map(function (virtualEvent, eventIndex) {
                var entry = childTeamOwnedVirtualEntries.find(function (entry) {
                  return entry.parentTeamEntryId == parentEntryId && entry.rosterPosition == roster.position && entry.virtualEventName == virtualEvent.name;
                });
                var entryAssigned = entry ? true : false;
                var remaining = rosterCheckout ? childTeamOwnedVirtualEntries.filter(function (entry) {
                  return entry.virtualEventName === virtualEvent.name && !entry.isPurchased && entry.parentTeamEntryId == null;
                }).length : virtualEvent.remaining;

                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row',
                    key: eventIndex },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-12' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["Field"], {
                      id: 'assignChildVirtualEntry' + rosterIndex + '-' + eventIndex,
                      name: 'assignChildVirtualEntry' + rosterIndex + '-' + eventIndex,
                      checked: entryAssigned,
                      disabled: rosterCheckout && !onCartRoster && entryAssigned && (entry ? entry.isPurchased : true) || !entryAssigned && virtualEvent.remaining == 0,
                      component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardCheckboxField_jsx__["a" /* default */],
                      label: 'Assign ' + virtualEvent.name + ' (' + (rosterCheckout && !onCartRoster && entryAssigned && (entry ? entry.isPurchased : true) ? 'already assigned' : remaining + ' remaining') + ')',
                      title: rosterCheckout && !onCartRoster && entryAssigned ? 'This virtual event is already assigned to this entry. Its assignment can be changed on the Manage page after checkout.' : null,
                      onCustomChange: function onCustomChange(event) {
                        return onAssignChildTeamOwnedVirtualEventClick(virtualEvent.name, parentEntryId, rosterIndex + 1, event.target.checked);
                      }
                    })
                  )
                );
              }) : null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_shared_DisplayIf_jsx__["a" /* default */],
                { condition: showCalculatedDivisionToCaptain && eventIsLinked },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Division'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    !roster.bowler ? '-' : !roster.divisionName ? 'Not Assigned' : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'p',
                      null,
                      roster.divisionName
                    )
                  )
                )
              )
            )
          )
        )
      );
    }),
    source.filter(function (r) {
      return r.bowler.isProfessional;
    }).length > 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'roster-notification' },
      'Warning: There is more than one professional bowler on this roster'
    ) : null
  );
};

EntryRosterList.propTypes = {
  sourceQty: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  source: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  bowlers: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  parentEntryId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  childVirtualEntryEvents: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  eventIsLinked: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  childTeamOwnedVirtualEntries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  rosterCheckout: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  showCalculatedDivisionToCaptain: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCartRoster: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onSearch: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSearchChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSearchEnterKeyPress: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onIsProfessionalChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onAvgChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onMoveUpClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onMoveDownClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onRosterPositionCleared: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onAssignChildTeamOwnedVirtualEventClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

EntryRosterList.defaultProps = {
  bowlers: [],
  rosterCheckout: window.location.href.indexOf("rostercheckout") >= 0,
  onCartRoster: false
};

/* harmony default export */ __webpack_exports__["a"] = EntryRosterList;

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldValidationError_jsx__ = __webpack_require__(111);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var MinimalField = function MinimalField(_ref) {
  var children = _ref.children,
      classString = _ref.classString,
      autoFocus = _ref.autoFocus,
      disabled = _ref.disabled,
      input = _ref.input,
      type = _ref.type,
      placeholder = _ref.placeholder,
      step = _ref.step,
      min = _ref.min,
      style = _ref.style,
      required = _ref.required,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      onCustomChange = _ref.onCustomChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(classString, { 'has-error': touched && error }) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, input, {
      autoFocus: autoFocus,
      className: 'form-control',
      disabled: disabled,
      min: min,
      placeholder: placeholder,
      step: step,
      style: style,
      type: type,
      required: required,
      onChange: function onChange(event) {
        // redux-form overrides change event if provided to Field
        // use custom handler for other specific handling
        onCustomChange(event);
        input.onChange(event);
      }
    })),
    children,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FieldValidationError_jsx__["a" /* default */], {
      touched: touched,
      error: error
    })
  );
};

MinimalField.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,
  classString: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  autoFocus: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  input: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  disabled: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  meta: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  name: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  placeholder: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  type: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  step: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  min: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  style: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  required: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCustomChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

MinimalField.defaultProps = {
  classString: '',
  type: 'text',
  onCustomChange: function onCustomChange() {}
};

/* harmony default export */ __webpack_exports__["a"] = MinimalField;

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rostersHasUserIdModifications; });

var rostersHasUserIdModifications = function rostersHasUserIdModifications(rosterPositions) {
  // Make sure we don't save if there are modifications in the user ID 

  var hasRosterPositionChanged = false;

  rosterPositions.map(function (roster) {
    var modifiedWithValue = roster._searchChanged && roster._searchValue !== roster.bowler.usbcId;

    if (roster._searchValue === "" && !roster.bowler.usbcId) modifiedWithValue = false;
    if (modifiedWithValue) {
      hasRosterPositionChanged = true;
      roster.usbcIdError = true;
    }
  });

  return hasRosterPositionChanged;
};

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Authorize_jsx__ = __webpack_require__(983);



var isAuthorized = function isAuthorized(rolesToVerify, userRoles) {
  return rolesToVerify.filter(function (item) {
    return !['children'].includes(item) && userRoles.includes(item);
  }).length > 0;
};

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    authorized: isAuthorized(Object.keys(props), state.shared.auth.roles)
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__Authorize_jsx__["a" /* default */]);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventPriceDetailsModal_jsx__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(203);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var mapStateToProps = function mapStateToProps(state) {
  return _extends({
    visible: state.shared.eventPriceDetailsModal.showEventPriceDetailsModal
  }, state.shared.eventPriceDetailsModal.eventPriceDetailsData);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["c" /* cancelEventPriceDetailModal */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__EventPriceDetailsModal_jsx__["a" /* default */]);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCountInCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCountInReviewCart; });

var getCountInCart = function getCountInCart(state) {
    var total = 0;

    if (state === null) return total;

    total += getVirtualEventsCount(state.virtualEvents, "countInCart");

    total += !state.events ? 0 : state.events.reduce(function (acc, currenEvent) {
        return acc + currenEvent.squads.reduce(function (nestedAcc, currentSquad) {
            return nestedAcc + (!currentSquad.countInCart ? 0 : parseInt(currentSquad.countInCart, 10));
        }, 0);
    }, 0);

    return isNaN(total) ? 0 : total;
};
var getCountInReviewCart = function getCountInReviewCart(state) {
    var total = 0;

    if (state === null) return total;

    total += getVirtualEventsCount(state.virtualEvents, "quantity");

    total += !state.squads ? 0 : state.squads.reduce(function (acc, squad) {
        return acc + (!squad.countInCart ? 0 : parseInt(squad.countInCart, 10));
    }, 0);

    return isNaN(total) ? 0 : total;
};

var getVirtualEventsCount = function getVirtualEventsCount(virtualEvents, key) {
    return !virtualEvents ? 0 : virtualEvents.reduce(function (acc, currentVirtualEvent) {
        return acc + (!currentVirtualEvent[key] ? 0 : parseInt(currentVirtualEvent[key], 10));
    }, 0);
};



/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(462);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setSquadCapacity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return displaySquads; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hideCapacityDialog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return displayCapacityDialog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return displayEventsInDropDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setSquadVisibility; });


var setSquadCapacity = function setSquadCapacity(id, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_SQUAD_CAPACITY_FOR_TOURNAMENT_CAPACITY */],
    payload: {
      id: id,
      value: value
    }
  };
};

var displaySquads = function displaySquads(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DISPLAY_SQUADS_FOR_TOURNAMENT_CAPACITY */],
    payload: data
  };
};

var hideCapacityDialog = function hideCapacityDialog() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* HIDE_CAPACITY_DIALOG */]
  };
};

var displayCapacityDialog = function displayCapacityDialog(title) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* DISPLAY_CAPACITY_DIALOG */],
    payload: title
  };
};

var displayEventsInDropDown = function displayEventsInDropDown(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* DISPLAY_EVENTS_IN_DDL */],
    payload: data
  };
};

var setSquadVisibility = function setSquadVisibility(id, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SET_SQUAD_VISIBILITY */],
    payload: {
      id: id,
      value: value
    }
  };
};

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_validators__ = __webpack_require__(139);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return retrieveSquadsByTournament; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleUpdateButtonClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handleCapacitySave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleUpdateSquadCapacity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return handleUpdateSquadVisibility; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return validate; });







var retrieveSquadsByTournament = function retrieveSquadsByTournament(tournamentId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["a" /* displaySquads */])(null));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_actions__["d" /* getJsonAsync */])('tournament/' + tournamentId + '/squads/capacity')).then(function (data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["a" /* displaySquads */])(data));
    });
  };
};

var handleUpdateButtonClick = function handleUpdateButtonClick() {
  return function (dispatch, getState) {
    var _getState$tournament$ = getState().tournament.base.tournamentInfo,
        tournamentId = _getState$tournament$.id,
        startDate = _getState$tournament$.startDate,
        endDate = _getState$tournament$.endDate;


    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_actions__["d" /* getJsonAsync */])('tournament/' + tournamentId + '/events/')).then(function (data) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["b" /* displayEventsInDropDown */])(data.map(function (_ref) {
        var id = _ref.id,
            name = _ref.name;
        return {
          value: id,
          label: name
        };
      })));

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["c" /* displayCapacityDialog */])('Update Availability'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["initialize"])('capacityAvailabilityForm', {
        startDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate).format('YYYY-MM-DD'),
        endDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(endDate).format('YYYY-MM-DD')
      }));
    });
  };
};

var handleCapacitySave = function handleCapacitySave(data) {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {

      // scrub times from datepicker values
      data.startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.startDate).format('YYYY-MM-DD');
      data.endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.endDate).format('YYYY-MM-DD');

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_actions__["e" /* postJsonAsync */])('capacity', data)).then(function () {
        var tournamentId = getState().tournament.base.tournamentInfo.id;

        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Saved!', 'Squad capacity was successfully saved.');
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["d" /* hideCapacityDialog */])());
        dispatch(retrieveSquadsByTournament(tournamentId));
        resolve();
      }).catch(function () {
        return resolve();
      });
    });
  };
};

var handleUpdateSquadCapacity = function handleUpdateSquadCapacity(data) {
  return function (dispatch) {
    if (data.dirty) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_actions__["e" /* postJsonAsync */])('capacity/' + data.squadId, data.inputValue)).then(function () {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["e" /* setSquadCapacity */])(data.squadId, data.inputValue));
        __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Saved!', 'Squad capacity was successfully saved.');
      }).catch(function () {});
    }
  };
};

var handleUpdateSquadVisibility = function handleUpdateSquadVisibility(id, value) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_actions__["g" /* putJsonAsync */])('squad/' + id + '/hideFromCaptains', { squadId: id, hideFromCaptains: value })).then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["f" /* setSquadVisibility */])(id, value));
      __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success('Saved!', 'Squad visibility was successfully updated.');
    }).catch(function () {});
  };
};

var validate = function validate(data) {
  var errors = {};

  if (!data.capacity && data.capacity !== 0) {
    errors.capacity = 'Capacity is required';
  } else if (data.capacity < 0) {
    errors.capacity = 'Capacity must be greater than zero';
  } else if (data.capacity > 100) {
    errors.capacity = 'Capacity must be less than one hundred';
  }

  if (!data.eventId) {
    errors.eventId = 'Event must specified.';
  }

  if (!data.startDate || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_validators__["b" /* validateDate */])(data.startDate)) {
    errors.startDate = 'We need to be able to set a start date';
  }

  if (!data.endDate || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_validators__["b" /* validateDate */])(data.endDate)) {
    errors.endDate = 'We need to be able to set an end date';
  }

  if (data.startDate && data.endDate && data.startDate > data.endDate) {
    errors.startDate = 'Start date must be less or equals to end date';
    errors.endDate = 'End date must be greater than start date';
  }

  return errors;
};

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_error_actionTypes__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actionTypes__ = __webpack_require__(1033);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handleDivisionClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return validate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return handleSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return handleCancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handeNewDivisionClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleEventClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return handleVirtualEventClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return retrieveDivisionsEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return retrieveDivisionVirtualEvents; });
/* unused harmony export retrieveDivisionByEvent */
/* unused harmony export retrieveDivisionByVirtualEvent */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var handleDivisionClick = function handleDivisionClick(divisionId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["a" /* setDivisionDisplayDefault */])(divisionId));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["d" /* getJsonAsync */])('division/' + divisionId)).then(function (data) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["b" /* cancelDivisionItemForm */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["c" /* displayDivisionInForm */])(divisionId));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["initialize"])('divisionItemForm', data));
    });
  };
};

var validate = function validate(_ref) {
  var name = _ref.name,
      minAverage = _ref.minAverage,
      maxAverage = _ref.maxAverage,
      minAge = _ref.minAge,
      maxAge = _ref.maxAge;


  var errors = {};

  if (!name) {
    errors.name = 'Name is required';
  }

  if (!minAverage && minAverage !== 0) {
    errors.minAverage = 'Min Average is required';
  } else if (isNaN(Number(minAverage))) {
    errors.minAverage = 'Must be a valid number';
  } else if (Number(minAverage) < 0) {
    errors.minAverage = 'Must be zero or a greater number';
  } else if (Number(minAverage) > 9900) {
    errors.minAverage = 'Cannot be greater than 9900';
  } else if (!isNaN(Number(maxAverage)) && Number(minAverage) > Number(maxAverage)) {
    errors.minAverage = 'Min Average must be less than Max Average';
  }

  if (!maxAverage && minAverage !== 0) {
    errors.maxAverage = 'Max Average is required';
  } else if (isNaN(Number(maxAverage))) {
    errors.minAverage = 'Must be a valid number';
  } else if (Number(maxAverage) < 0) {
    errors.maxAverage = 'Must be zero or a greater number';
  } else if (Number(maxAverage) > 9900) {
    errors.maxAverage = 'Cannot be greater than 9900';
  }

  if (isNaN(Number(maxAge))) {
    errors.maxAge = 'Max Age Limit must be a valid number';
  } else if (Number(maxAge) > 999) {
    errors.maxAge = 'Max Age Limit must be less than 999';
  }
  if (isNaN(Number(minAge))) {
    errors.minAge = 'Min Age Limit must be a valid number';
  } else if (Number(minAge) > 999) {
    errors.minAge = 'Min Age Limit must be less than 999';
  } else if (!isNaN(Number(maxAge)) && Number(minAge) > Number(maxAge)) {
    errors.minAge = 'Min Age Limit must be less than Max Age Limit';
  }

  return errors;
};

var handleSave = function handleSave(data) {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var tournamentState = getState().tournament,
          _tournamentState$divi = tournamentState.divisions,
          eventIdSelected = _tournamentState$divi.eventIdSelected,
          virtualEventIdSelected = _tournamentState$divi.virtualEventIdSelected,
          tournamentId = tournamentState.base.tournamentInfo.id;

      var averageBased = getState().tournament.divisions.selectedEventAverageBased;
      var ageBased = getState().tournament.divisions.selectedEventAgeBased;
      var genderBased = getState().tournament.divisions.selectedEventGenderBased;

      var bodyData = _extends({}, data, {
        eventId: eventIdSelected,
        virtualEventId: virtualEventIdSelected
      }, {
        averageBased: averageBased,
        ageBased: ageBased,
        genderBased: genderBased
      });
      var promise = data.id ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["g" /* putJsonAsync */])('division', bodyData) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["e" /* postJsonAsync */])('division', bodyData);

      dispatch(promise).then(function () {
        __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Saved!', 'Division saved successfully.');
        if (eventIdSelected) {
          dispatch(retrieveDivisionByEvent(eventIdSelected));
        } else {
          dispatch(retrieveDivisionByVirtualEvent(virtualEventIdSelected));
        }
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["n" /* loadTournament */])(tournamentId));
        resolve();
      }).catch(function () {
        return resolve();
      });
    });
  };
};

var handleCancel = function handleCancel() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_error_actionTypes__["a" /* setErrorList */])([]));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["b" /* cancelDivisionItemForm */])());
  };
};

var handeNewDivisionClick = function handeNewDivisionClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["b" /* cancelDivisionItemForm */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["d" /* displayNewDivision */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["initialize"])('divisionItemForm', { displayDefault: true, averageBased: false, ageBased: false }));
  };
};

var handleEventClick = function handleEventClick(eventId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["e" /* setVirtualEventSelectedInState */])(null));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["f" /* highlightSelectedVirtualEvent */])(null));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["g" /* setEventSelectedInState */])(eventId));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["h" /* hightlightSelectedEvent */])(eventId));
    dispatch(retrieveDivisionByEvent(eventId));
  };
};

var handleVirtualEventClick = function handleVirtualEventClick(virtualEventId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["g" /* setEventSelectedInState */])(null));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["h" /* hightlightSelectedEvent */])(null));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["e" /* setVirtualEventSelectedInState */])(virtualEventId));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["f" /* highlightSelectedVirtualEvent */])(virtualEventId));
    dispatch(retrieveDivisionByVirtualEvent(virtualEventId));
  };
};

var retrieveDivisionsEvents = function retrieveDivisionsEvents(tournamentId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["d" /* getJsonAsync */])('tournament/' + tournamentId + '/events')).then(function (data) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["i" /* displayEvents */])(data));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["g" /* setEventSelectedInState */])(null));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["j" /* displayDivisions */])([]));
    });
  };
};

var retrieveDivisionVirtualEvents = function retrieveDivisionVirtualEvents(tournamentId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["d" /* getJsonAsync */])('tournament/' + tournamentId + '/virtualevents')).then(function (virtualEvents) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["k" /* displayVirtualEvents */])(virtualEvents));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["e" /* setVirtualEventSelectedInState */])(null));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["j" /* displayDivisions */])([]));
    });
  };
};

var retrieveDivisionByEvent = function retrieveDivisionByEvent(eventId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["d" /* getJsonAsync */])('event/' + eventId + '/divisions')).then(function (data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["j" /* displayDivisions */])(data));
    });
  };
};

var retrieveDivisionByVirtualEvent = function retrieveDivisionByVirtualEvent(virtualEventId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["d" /* getJsonAsync */])('virtualevent/' + virtualEventId + '/divisions')).then(function (data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actionTypes__["j" /* displayDivisions */])(data));
    });
  };
};

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(468);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deactivateProcessEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deactivateProcessStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cancelDeactivateModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return displayDeactivateModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setEventTypesInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return displayNewFee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cancelFeeItemForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return displayInactiveFees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return displayActiveFees; });


var deactivateProcessEnd = function deactivateProcessEnd() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DEACTIVATE_PROCESS_END_FOR_SETUP_FEES */]
  };
};

var deactivateProcessStart = function deactivateProcessStart() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEACTIVATE_PROCESS_START_FOR_SETUP_FEES */]
  };
};

var cancelDeactivateModal = function cancelDeactivateModal() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* CANCEL_DEACTIVATE_MODAL_FOR_SETUP_FEES */]
  };
};

var displayDeactivateModal = function displayDeactivateModal(feeItem) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* DISPLAY_DEACTIVATE_MODAL_FOR_SETUP_FEES */],
    payload: feeItem
  };
};

var setEventTypesInState = function setEventTypesInState(eventTypes) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* SET_EVENT_TYPES_IN_STATE_FOR_SETUP_FEES */],
    payload: eventTypes
  };
};

var displayNewFee = function displayNewFee() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* DISPLAY_NEW_FEE_FOR_SETUP */]
  };
};

var cancelFeeItemForm = function cancelFeeItemForm() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* CANCEL_FEE_FORM_FOR_SETUP */]
  };
};

var displayInactiveFees = function displayInactiveFees(inactiveFees) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* DISPLAY_INACTIVE_FEES_FOR_SETUP */],
    payload: inactiveFees
  };
};

var displayActiveFees = function displayActiveFees(activeFees) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* DISPLAY_ACTIVE_FEES_FOR_SETUP */],
    payload: activeFees
  };
};

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(470);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return displayCenterSaveButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return displayCentersDropdownList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return displayThemes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return displayTimeZones; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return handleLocationNameChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setCanAssignTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setCanDeleteTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setCards; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setCardSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setDataExportOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setExportSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setIsAddingTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return setIsNewTournament; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setLocationCertificationNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return setStripeAccounts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return setStripeAccountSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setTagIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return setAvailableTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setTournamentLocations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setTournamentLocationSearchResults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return setTournamentTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return toggleTournamentLocationEditing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return setIsSuperUser; });


var displayCenterSaveButton = function displayCenterSaveButton(saveable) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_CENTER_SAVE_BUTTON */],
    payload: saveable
  };
};

var displayCentersDropdownList = function displayCentersDropdownList(selectable) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DISPLAY_CENTERS_DROPDOWN_LIST */],
    payload: selectable
  };
};

var displayThemes = function displayThemes(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* DISPLAY_THEMES */],
    payload: data
  };
};

var displayTimeZones = function displayTimeZones(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* DISPLAY_TIME_ZONES */],
    payload: data
  };
};

var handleLocationNameChange = function handleLocationNameChange(locationName) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* SET_TOURNAMENT_LOCATION_NAME_VALUE */],
    payload: locationName
  };
};

var setCanAssignTag = function setCanAssignTag(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SET_CAN_ASSIGN_TAG */],
    payload: data
  };
};

var setCanDeleteTag = function setCanDeleteTag(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* SET_CAN_DELETE_TAG */],
    payload: data
  };
};

var setCards = function setCards(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* SET_CARDS */],
    payload: data
  };
};

var setCardSelection = function setCardSelection(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* SET_CARD_SELECTION */],
    payload: data
  };
};

var setDataExportOptions = function setDataExportOptions(options) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* SET_TOURNAMENT_EXPORT_OPTIONS_IN_STATE */],
    payload: options
  };
};

var setExportSelection = function setExportSelection(option) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* SET_TOURNAMENT_EXPORT_SELECTION_IN_STATE */],
    payload: option
  };
};

var setIsAddingTag = function setIsAddingTag(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* SET_IS_ADDING_TAG */],
    payload: data
  };
};

var setIsNewTournament = function setIsNewTournament(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* SET_IS_NEW_TOURNAMENT */],
    payload: data
  };
};

var setLocationCertificationNumber = function setLocationCertificationNumber(certificationNumber) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* SET_LOCATION_CERTIFICATION_NUMBER */],
    payload: certificationNumber
  };
};

var setStripeAccounts = function setStripeAccounts(options) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["o" /* SET_STRIPE_ACCOUNTS */],
    payload: options
  };
};

var setStripeAccountSelection = function setStripeAccountSelection(option) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["p" /* SET_STRIPE_ACCOUNT_SELECTION */],
    payload: option
  };
};

var setTagIndex = function setTagIndex(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["q" /* SET_TAG_INDEX */],
    payload: data
  };
};

var setAvailableTags = function setAvailableTags(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["r" /* SET_AVAILABLE_TAGS */],
    payload: data
  };
};

var setTournamentLocations = function setTournamentLocations(locations) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["s" /* SET_TOURNAMENT_LOCATIONS_IN_STATE */],
    payload: locations
  };
};

var setTournamentLocationSearchResults = function setTournamentLocationSearchResults(locationSearchResults) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["t" /* SET_TOURNAMENT_LOCATION_SEARCH_RESULTS */],
    payload: locationSearchResults
  };
};

var setTournamentTags = function setTournamentTags(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["u" /* SET_TOURNAMENT_TAGS */],
    payload: data
  };
};

var toggleTournamentLocationEditing = function toggleTournamentLocationEditing(id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["v" /* SET_TOURNAMENT_LOCATION_EDITING */],
    payload: id
  };
};

var setIsSuperUser = function setIsSuperUser(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["w" /* SET_IS_SUPER_USER */],
    payload: data
  };
};

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(205);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setupTournamentPermissionsForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return retrieveManagers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return handleManagerAddClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return handleManagerSaveClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return handleManagerEditClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return handleManagerCancelClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return handleManagerRemoveClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return retrieveAdministrators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return handleAdministratorAddClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handleAdministratorSaveClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handleAdministratorCancelClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return handleAdministratorRemoveClick; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var setupTournamentPermissionsForm = function setupTournamentPermissionsForm() {
  return function (dispatch, getState) {
    var data = getState().tournament.base.tournamentInfo;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["initialize"])(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* permissionsFormName */], _extends({}, data)));
  };
};

var retrieveManagers = function retrieveManagers(tournamentId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["d" /* getJsonAsync */])('setup/tournament/' + tournamentId + '/managers')).then(function (data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["a" /* setTournamentManagers */])(data));
    });
  };
};

var handleManagerAddClick = function handleManagerAddClick() {
  return function (dispatch, getState) {
    var managers = getState().tournament.permissions.managers;

    if (!managers) managers = [];

    if (!managers.some(function (m) {
      return m.editing;
    })) {
      managers.push({
        id: null,
        email: '',
        isPrimary: !managers.some(function (m) {
          return m.isPrimary;
        })
      });
    }

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["a" /* setTournamentManagers */])(managers));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["registerField"])(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* permissionsFormName */], 'tournamentManagerEmail', 'Field'));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["change"])(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* permissionsFormName */], 'tournamentManagerEmail', ''));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["b" /* toggleTournamentManagerEditing */])(null));
  };
};

var handleManagerSaveClick = function handleManagerSaveClick(id) {
  return function (dispatch, getState) {
    var tournamentId = getState().tournament.base.tournamentInfo.id;
    var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["formValueSelector"])(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* permissionsFormName */]);
    var email = selector(getState(), 'tournamentManagerEmail');
    var data = {
      id: id,
      email: email,
      tournamentId: tournamentId
    };
    var promise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["e" /* postJsonAsync */])('setup/tournament/' + tournamentId + '/manager', data);

    dispatch(promise).then(function (response) {
      if (response) __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Saved!', 'Tournament manager saved successfully.');else __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].error('Not Allowed', 'Email address does not belong to tournament manager role.');
      dispatch(retrieveManagers(tournamentId));
    });
  };
};

var handleManagerEditClick = function handleManagerEditClick(id, email) {
  return function (dispatch) {
    // We must provide the option to edit the primary manager
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["registerField"])(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* permissionsFormName */], 'tournamentManagerEmail', 'Field'));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["change"])(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* permissionsFormName */], 'tournamentManagerEmail', email));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["b" /* toggleTournamentManagerEditing */])(id));
  };
};

var handleManagerCancelClick = function handleManagerCancelClick() {
  return function (dispatch, getState) {
    var tournamentId = getState().tournament.base.tournamentInfo.id;

    dispatch(retrieveManagers(tournamentId));
  };
};

var handleManagerRemoveClick = function handleManagerRemoveClick(id) {
  return function (dispatch, getState) {
    var tournamentId = getState().tournament.base.tournamentInfo.id;
    var data = {
      id: id
    };

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["e" /* postJsonAsync */])('setup/tournament/' + tournamentId + '/manager/' + id + '/remove', data)).then(function () {
      __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Removed!', 'Tournament manager removed successfully.');
      dispatch(retrieveManagers(tournamentId));
    });
  };
};

var retrieveAdministrators = function retrieveAdministrators(tournamentId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["d" /* getJsonAsync */])('setup/tournament/' + tournamentId + '/administrators')).then(function (data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["c" /* setTournamentAdministrators */])(data));
    });
  };
};

var handleAdministratorAddClick = function handleAdministratorAddClick() {
  return function (dispatch, getState) {
    var administrators = getState().tournament.permissions.administrators;

    if (!administrators) administrators = [];

    if (!administrators.some(function (m) {
      return m.editing;
    })) {
      administrators.push({
        id: null,
        email: ''
      });
    }

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["c" /* setTournamentAdministrators */])(administrators));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["registerField"])(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* permissionsFormName */], 'tournamentAdministratorEmail', 'Field'));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["change"])(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* permissionsFormName */], 'tournamentAdministratorEmail', ''));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["d" /* toggleTournamentAdministratorEditing */])(null));
  };
};

var handleAdministratorSaveClick = function handleAdministratorSaveClick(id) {
  return function (dispatch, getState) {
    var tournamentId = getState().tournament.base.tournamentInfo.id;
    var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["formValueSelector"])(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* permissionsFormName */]);
    var email = selector(getState(), 'tournamentAdministratorEmail');
    var data = {
      id: id,
      email: email,
      tournamentId: tournamentId
    };

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["e" /* postJsonAsync */])('setup/tournament/' + tournamentId + '/administrator', data)).then(function (response) {
      if (response) __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Saved!', 'Tournament administrator saved successfully.');else __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].error('Not Allowed', 'Email address does not belong to tournament administrator role.');
      dispatch(retrieveAdministrators(tournamentId));
    });
  };
};

var handleAdministratorCancelClick = function handleAdministratorCancelClick() {
  return function (dispatch, getState) {
    var tournamentId = getState().tournament.base.tournamentInfo.id;

    dispatch(retrieveAdministrators(tournamentId));
  };
};

var handleAdministratorRemoveClick = function handleAdministratorRemoveClick(id) {
  return function (dispatch, getState) {
    var tournamentId = getState().tournament.base.tournamentInfo.id;
    var data = {
      id: id
    };

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["e" /* postJsonAsync */])('setup/tournament/' + tournamentId + '/administrator/' + id + '/remove', data)).then(function () {
      __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Removed!', 'Tournament administrator removed successfully.');
      dispatch(retrieveAdministrators(tournamentId));
    });
  };
};

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(472);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deactivateProcessEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deactivateProcessStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cancelDeactivateModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return displayDeactivateModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setBundlingRuleEventsInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return displayActiveBundlingRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return displayNewBundlingRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cancelBundlingRuleItemForm; });


var deactivateProcessEnd = function deactivateProcessEnd() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DEACTIVATE_PROCESS_END_FOR_BUNDLING_RULES */]
  };
};

var deactivateProcessStart = function deactivateProcessStart() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEACTIVATE_PROCESS_START_FOR_BUNDLING_RULES */]
  };
};

var cancelDeactivateModal = function cancelDeactivateModal() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* CANCEL_DEACTIVATE_MODAL_FOR_BUNDLING_RULES */]
  };
};

var displayDeactivateModal = function displayDeactivateModal(ruleItem) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* DISPLAY_DEACTIVATE_MODAL_FOR_BUNDLING_RULES */],
    payload: ruleItem
  };
};

var setBundlingRuleEventsInState = function setBundlingRuleEventsInState(eventTypes) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* SET_EVENT_TYPES_IN_STATE_FOR_BUNDLING_RULES */],
    payload: eventTypes
  };
};

var displayActiveBundlingRules = function displayActiveBundlingRules(activeRules) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* DISPLAY_ACTIVE_RULES_FOR_BUNDLING_RULES */],
    payload: activeRules
  };
};

var displayNewBundlingRule = function displayNewBundlingRule() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* DISPLAY_NEW_BUNDLING_RULE_FOR_BUNDLING_RULES */]
  };
};

var cancelBundlingRuleItemForm = function cancelBundlingRuleItemForm() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* CANCEL_BUNDLING_RULE_FORM_FOR_BUNDLING_RULES */]
  };
};

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(290);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return displaySquadDeleteModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return displaySquadDeleteConfirmModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return displayEventsInDropDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hideSquadDialog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return hideSquadDeleteDialog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return displaySquadDialog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return displayNextMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return displayPreviousMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return displaySpecificMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return displaySquads; });


var displaySquadDeleteModal = function displaySquadDeleteModal(error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_SQUAD_DELETE_MODAL */],
    payload: {
      error: error
    }
  };
};

var displaySquadDeleteConfirmModal = function displaySquadDeleteConfirmModal(warningMessage, error, choices, confirmation) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DISPLAY_SQUAD_DELETE_CONFIRM_MODAL */],
    payload: {
      warningMessage: warningMessage,
      error: error,
      choices: choices,
      confirmation: confirmation
    }
  };
};

var displayEventsInDropDown = function displayEventsInDropDown(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* DISPLAY_EVENTS_IN_DDL */],
    payload: data
  };
};

var hideSquadDialog = function hideSquadDialog() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* HIDE_SQUAD_DIALOG */]
  };
};

var hideSquadDeleteDialog = function hideSquadDeleteDialog() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* HIDE_SQUAD_DELETE_DIALOG */]
  };
};

var displaySquadDialog = function displaySquadDialog(title) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* DISPLAY_SQUAD_DIALOG */],
    payload: title
  };
};

var displayNextMonth = function displayNextMonth() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* DISPLAY_NEXT_MONTH */]
  };
};

var displayPreviousMonth = function displayPreviousMonth() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* DISPLAY_PREVIOUS_MONTH */]
  };
};

var displaySpecificMonth = function displaySpecificMonth(month, year) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* DISPLAY_SPECIFIC_MONTH */],
    payload: {
      month: month,
      year: year
    }
  };
};

var displaySquads = function displaySquads(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* DISPLAY_TOURNAMENT_SQUADS */],
    payload: data
  };
};

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DISPLAY_EVENTS_IN_DDL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HIDE_SQUAD_DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return HIDE_SQUAD_DELETE_DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DISPLAY_SQUAD_DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DISPLAY_NEXT_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DISPLAY_PREVIOUS_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DISPLAY_TOURNAMENT_SQUADS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DISPLAY_SPECIFIC_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DISPLAY_SQUAD_DELETE_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DISPLAY_SQUAD_DELETE_CONFIRM_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ERROR_UNTIL_REQUIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ERROR_UNTIL_BEFORE_START_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ERROR_UNTIL_AFTER_END_DATE; });
var DISPLAY_EVENTS_IN_DDL = 'DISPLAY_EVENTS_IN_DDL';
var HIDE_SQUAD_DIALOG = 'HIDE_SQUAD_DIALOG';
var HIDE_SQUAD_DELETE_DIALOG = 'HIDE_SQUAD_DELETE_DIALOG';
var DISPLAY_SQUAD_DIALOG = 'DISPLAY_SQUAD_DIALOG';
var DISPLAY_NEXT_MONTH = 'DISPLAY_NEXT_MONTH';
var DISPLAY_PREVIOUS_MONTH = 'DISPLAY_PREVIOUS_MONTH';
var DISPLAY_TOURNAMENT_SQUADS = 'DISPLAY_TOURNAMENT_SQUADS';
var DISPLAY_SPECIFIC_MONTH = 'DISPLAY_SPECIFIC_MONTH';
var DISPLAY_SQUAD_DELETE_MODAL = 'DISPLAY_SQUAD_DELETE_MODAL';
var DISPLAY_SQUAD_DELETE_CONFIRM_MODAL = 'DISPLAY_SQUAD_DELETE_CONFIRM_MODAL';
var ERROR_UNTIL_REQUIRED = 'Please enter a valid date to repeat until.';
var ERROR_UNTIL_BEFORE_START_DATE = 'Repeat until date must be after squad date.';
var ERROR_UNTIL_AFTER_END_DATE = 'Can\'t repeat past tournament end date.';

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(207);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return handleSetStatusClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return retrieveAvailableStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return handlePublish; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return retrieveExportSystemName; });
/* unused harmony export handleExport */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handleBeginExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handleDownloadExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setExportStatusData; });





var handleSetStatusClick = function handleSetStatusClick(status) {
  return function (dispatch, getState) {
    var tournamentId = getState().tournament.base.tournamentInfo.id;
    var isExport = getState().tournament.status.systemShouldExport;

    var data = {
      "statusName": status,
      "isExport": isExport
    };

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["g" /* putJsonAsync */])('setup/tournament/' + tournamentId + '/status', data)).then(function () {
      __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Status Changed!', 'Tournament status successfully changed.');
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["c" /* cancelConfirmStatusChangeModal */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["a" /* setTournamentStatus */])(status));
      dispatch(retrieveAvailableStatuses());
    }).catch(function () {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["c" /* cancelConfirmStatusChangeModal */])());
    });
  };
};

var retrieveAvailableStatuses = function retrieveAvailableStatuses() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["d" /* getJsonAsync */])('setup/tournament/status')).then(function (statuses) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["d" /* setAvailableStatuses */])(statuses));
    });
  };
};

var handlePublish = function handlePublish() {
  return function (dispatch, getState) {
    var tournamentId = getState().tournament.base.tournamentInfo.id;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["e" /* publishStarts */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["e" /* postJsonAsync */])('setup/tournament/' + tournamentId + '/publish')).then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["f" /* publishEnds */])());
      __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Published!', 'Tournament published successfully.');
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["n" /* loadTournament */])(tournamentId));
    }).catch(function () {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["f" /* publishEnds */])());
    });
  };
};

var retrieveExportSystemName = function retrieveExportSystemName() {
  return function (dispatch, getState) {
    var exportId = getState().tournament.base.tournamentInfo.exportId;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["g" /* loadingStarts */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["d" /* getJsonAsync */])('export/tournament')).then(function (data) {
      var exportSystem = data.find(function (x) {
        return x.id === exportId;
      });
      var exportSystemName = exportSystem ? exportSystem.description : '';
      var systemShouldExport = exportSystem ? exportSystem.isExport : false;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["h" /* setExportSystemInfo */])({ exportSystemName: exportSystemName, systemShouldExport: systemShouldExport }));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["i" /* loadingEnds */])());
    });
  };
};

var handleExport = function handleExport() {
  return function (dispatch, getState) {
    var tournamentId = getState().tournament.base.tournamentInfo.id;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["e" /* publishStarts */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["e" /* postJsonAsync */])('export/tournament/' + tournamentId)).then(function (response) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["f" /* publishEnds */])());
      __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Exported!', 'Tournament exported successfully.');
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["n" /* loadTournament */])(tournamentId));

      download("Tournament.JSON", response);
    }).catch(function () {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["f" /* publishEnds */])());
    });
  };
};

var handleBeginExport = function handleBeginExport() {
  return function (dispatch, getState) {
    var tournamentId = getState().tournament.base.tournamentInfo.id;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["e" /* publishStarts */])());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["e" /* postJsonAsync */])('export/tournament/' + tournamentId + '/BeginExport')).then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["f" /* publishEnds */])());
      __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Exported Started!', 'We have begun to export your tournament.');
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["n" /* loadTournament */])(tournamentId)).then(function (data) {
        dispatch(setExportStatusData(data));
      });
    }).catch(function () {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["f" /* publishEnds */])());
    });
  };
};

var download = function download(filename, text) {
  var a = document.createElement('a');
  var blob = new Blob([JSON.stringify(text)], { type: 'application/text' });
  var url = window.URL.createObjectURL(blob);

  if (navigator.msSaveBlob) {
    // IE10+ : (has Blob, but not a[download] or URL)
    return navigator.msSaveBlob(blob, filename);
  } else {
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
};

var handleDownloadExport = function handleDownloadExport() {
  return function (dispatch, getState) {
    var tournamentId = getState().tournament.base.tournamentInfo.id;
    var exportFileName = getState().tournament.status.exportFileName || 'Tournament.json';

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["d" /* getJsonAsync */])('export/tournament/' + tournamentId + '/downloadexport')).then(function (response) {
      download(exportFileName, response);
    });
  };
};

var setExportStatusData = function setExportStatusData(data) {
  return function (dispatch) {
    var exportStatus = data.exportStatus;
    var exportFileLocation = data.exportFileLocation;
    var exportFileName = data.exportFileName;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["j" /* setExportStatus */])({ exportStatus: exportStatus, exportFileLocation: exportFileLocation, exportFileName: exportFileName }));
  };
};

/***/ }),
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(265);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearAdminAuditSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectAuditTab; });


var clearAdminAuditSearch = function clearAdminAuditSearch() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CLEAR_ADMIN_AUDIT_SEARCH */],
    payload: null
  };
};

var selectAuditTab = function selectAuditTab(auditTab) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SELECT_ADMIN_AUDIT_TAB */],
    payload: auditTab
  };
};

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_ADMIN_AUDIT_SEARCH_BOWLER_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_ADMIN_AUDIT_SEARCH_BOWLERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ADMIN_AUDIT_BOWLER_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_ADMIN_AUDIT_BOWLER_DETAILS; });
var SET_ADMIN_AUDIT_SEARCH_BOWLER_VALUE = 'SET_ADMIN_AUDIT_SEARCH_BOWLER_VALUE';
var SET_ADMIN_AUDIT_SEARCH_BOWLERS = 'SET_ADMIN_AUDIT_SEARCH_BOWLERS';
var SET_ADMIN_AUDIT_BOWLER_HEADER = 'SET_ADMIN_AUDIT_BOWLER_HEADER';
var SET_ADMIN_AUDIT_BOWLER_DETAILS = 'SET_ADMIN_AUDIT_BOWLER_DETAILS';

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_ADMIN_AUDIT_SEARCH_CAPTAIN_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_ADMIN_AUDIT_SEARCH_CAPTAINS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ADMIN_AUDIT_CAPTAIN_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_ADMIN_AUDIT_CAPTAIN_DETAILS; });
var SET_ADMIN_AUDIT_SEARCH_CAPTAIN_VALUE = 'SET_ADMIN_AUDIT_SEARCH_CAPTAIN_VALUE';
var SET_ADMIN_AUDIT_SEARCH_CAPTAINS = 'SET_ADMIN_AUDIT_SEARCH_CAPTAINS';
var SET_ADMIN_AUDIT_CAPTAIN_HEADER = 'SET_ADMIN_AUDIT_CAPTAIN_HEADER';
var SET_ADMIN_AUDIT_CAPTAIN_DETAILS = 'SET_ADMIN_AUDIT_CAPTAIN_DETAILS';

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditSearchEntry_jsx__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var mapStateToProps = function mapStateToProps(props) {
  return _extends({}, props);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onNavigationClick: function onNavigationClick(route) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["b" /* navigateTo */])(route));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditSearchEntry_jsx__["a" /* default */]);

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(414);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setSearchTeamValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return displayTeamAudit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return displayTeamAuditHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return displayTeamAuditDetails; });


var setSearchTeamValue = function setSearchTeamValue(searchValue) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_ADMIN_AUDIT_SEARCH_TEAM_VALUE */],
    payload: searchValue
  };
};

var displayTeamAudit = function displayTeamAudit(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_ADMIN_AUDIT_SEARCH_TEAMS */],
    payload: data
  };
};

var displayTeamAuditHeader = function displayTeamAuditHeader(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_ADMIN_AUDIT_ENTRY_HEADER */],
    payload: data
  };
};

var displayTeamAuditDetails = function displayTeamAuditDetails(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_ADMIN_AUDIT_ENTRY_DETAILS */],
    payload: data
  };
};

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_ADMIN_AUDIT_SEARCH_TEAM_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_ADMIN_AUDIT_SEARCH_TEAMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ADMIN_AUDIT_ENTRY_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_ADMIN_AUDIT_ENTRY_DETAILS; });
var SET_ADMIN_AUDIT_SEARCH_TEAM_VALUE = 'SET_ADMIN_AUDIT_SEARCH_TEAM_VALUE';
var SET_ADMIN_AUDIT_SEARCH_TEAMS = 'SET_ADMIN_AUDIT_SEARCH_TEAMS';
var SET_ADMIN_AUDIT_ENTRY_HEADER = 'SET_ADMIN_AUDIT_ENTRY_HEADER';
var SET_ADMIN_AUDIT_ENTRY_DETAILS = 'SET_ADMIN_AUDIT_ENTRY_DETAILS';

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_ADMIN_AUDIT_SEARCH_TOURNAMENT_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_ADMIN_AUDIT_SEARCH_TOURNAMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ADMIN_AUDIT_TOURNAMENT_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_ADMIN_AUDIT_TOURNAMENT_DETAILS; });
var SET_ADMIN_AUDIT_SEARCH_TOURNAMENT_VALUE = 'SET_ADMIN_AUDIT_SEARCH_TOURNAMENT_VALUE';
var SET_ADMIN_AUDIT_SEARCH_TOURNAMENTS = 'SET_ADMIN_AUDIT_SEARCH_TOURNAMENTS';
var SET_ADMIN_AUDIT_TOURNAMENT_HEADER = 'SET_ADMIN_AUDIT_TOURNAMENT_HEADER';
var SET_ADMIN_AUDIT_TOURNAMENT_DETAILS = 'SET_ADMIN_AUDIT_TOURNAMENT_DETAILS';

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_ADMIN_AUDIT_SEARCH_VIRTUAL_ENTRY_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_ADMIN_AUDIT_SEARCH_VIRTUAL_ENTRYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ADMIN_AUDIT_VIRTUAL_ENTRY_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_ADMIN_AUDIT_VIRTUAL_ENTRY_DETAILS; });
var SET_ADMIN_AUDIT_SEARCH_VIRTUAL_ENTRY_VALUE = 'SET_ADMIN_AUDIT_SEARCH_VIRTUAL_ENTRY_VALUE';
var SET_ADMIN_AUDIT_SEARCH_VIRTUAL_ENTRYS = 'SET_ADMIN_AUDIT_SEARCH_VIRTUAL_ENTRYS';
var SET_ADMIN_AUDIT_VIRTUAL_ENTRY_HEADER = 'SET_ADMIN_AUDIT_VIRTUAL_ENTRY_HEADER';
var SET_ADMIN_AUDIT_VIRTUAL_ENTRY_DETAILS = 'SET_ADMIN_AUDIT_VIRTUAL_ENTRY_DETAILS';

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_PAYMENT_VIRTUAL_EVENTS_FOR_ADMIN_CAPTAIN_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DISPLAY_PAYMENT_ENTRIES_FOR_ADMIN_CAPTAIN_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_PAYMENT_ENTRIES_FOR_ADMIN_CAPTAIN_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_PAYMENTS_FOR_ADMIN_CAPTAIN_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DISPLAY_NOTES_MODAL_FOR_ADMIN_CAPTAIN_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_CAPTAIN_DETAILS_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_CAPTAIN_ENTRIES_BY_TOURNAMENT_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_CAPTAIN_BALANCE_DUE_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_CAPTAIN_SELECTED_TOURNAMENT_VIRTUAL_EVENT_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_CAPTAIN_SELECTED_TOURNAMENT_ENTRY_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_CAPTAIN_COLLAPSED_TOURNAMENT_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CALCULATE_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return DISABLE_OTHER_TOURNAMENT_SELECTION_FOR_ADMIN_CAPTAIN_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return DISPLAY_PAYMENT_MODAL_FOR_ADMIN_CAPTAIN_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DISPLAY_UPDATE_MODAL_FOR_ADMIN_CAPTAIN_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return RESET_CAPTAIN_DETAILS_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SHOW_CAPTAIN_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return HIDE_CAPTAIN_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SET_IS_NEW_CAPTAIN_ENTRIES_MODAL_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SET_AFFECTED_VIRTUAL_ENTRIES_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SET_SELECTED_AFFECTED_VIRTUAL_ENTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return SET_ALL_AFFECTED_VIRTUAL_ENTRIES_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_CHANGE_MULTIPLE_ENTRIES_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHANGE_HIDE_CANCELLED_ENTRIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHANGE_HIDE_ARCHIVED_ENTRIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_VALIDATION_MESSAGES_FOR_CAPTAIN_DETAIL; });
var SET_PAYMENT_VIRTUAL_EVENTS_FOR_ADMIN_CAPTAIN_DETAIL = 'SET_PAYMENT_VIRTUAL_EVENTS_FOR_ADMIN_CAPTAIN_DETAIL';
var DISPLAY_PAYMENT_ENTRIES_FOR_ADMIN_CAPTAIN_DETAIL = 'DISPLAY_PAYMENT_ENTRIES_FOR_ADMIN_CAPTAIN_DETAIL';
var SET_PAYMENT_ENTRIES_FOR_ADMIN_CAPTAIN_DETAIL = 'SET_PAYMENT_ENTRIES_FOR_ADMIN_CAPTAIN_DETAIL';
var SET_PAYMENTS_FOR_ADMIN_CAPTAIN_DETAIL = 'SET_PAYMENTS_FOR_ADMIN_CAPTAIN_DETAIL';
var DISPLAY_NOTES_MODAL_FOR_ADMIN_CAPTAIN_DETAIL = 'DISPLAY_NOTES_MODAL_FOR_ADMIN_CAPTAIN_DETAIL';
var SET_CAPTAIN_DETAILS_FOR_ADMIN = 'SET_CAPTAIN_DETAILS_FOR_ADMIN';
var SET_CAPTAIN_ENTRIES_BY_TOURNAMENT_FOR_ADMIN = 'SET_CAPTAIN_ENTRIES_BY_TOURNAMENT_FOR_ADMIN';
var SET_CAPTAIN_BALANCE_DUE_FOR_ADMIN = 'SET_CAPTAIN_BALANCE_DUE_FOR_ADMIN';
var SET_CAPTAIN_SELECTED_TOURNAMENT_VIRTUAL_EVENT_FOR_ADMIN = 'SET_CAPTAIN_SELECTED_TOURNAMENT_VIRTUAL_EVENT_FOR_ADMIN';
var SET_CAPTAIN_SELECTED_TOURNAMENT_ENTRY_FOR_ADMIN = 'SET_CAPTAIN_SELECTED_TOURNAMENT_ENTRY_FOR_ADMIN';
var SET_CAPTAIN_COLLAPSED_TOURNAMENT_FOR_ADMIN = 'SET_CAPTAIN_COLLAPSED_TOURNAMENT_FOR_ADMIN';
var CALCULATE_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_DETAIL = 'CALCULATE_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_DETAIL';
var DISABLE_OTHER_TOURNAMENT_SELECTION_FOR_ADMIN_CAPTAIN_DETAIL = 'DISABLE_OTHER_TOURNAMENT_SELECTION_FOR_ADMIN_CAPTAIN_DETAIL';
var DISPLAY_PAYMENT_MODAL_FOR_ADMIN_CAPTAIN_DETAIL = 'DISPLAY_PAYMENT_MODAL_FOR_ADMIN_CAPTAIN_DETAIL';
var DISPLAY_UPDATE_MODAL_FOR_ADMIN_CAPTAIN_DETAIL = 'DISPLAY_UPDATE_MODAL_FOR_ADMIN_CAPTAIN_DETAIL';
var RESET_CAPTAIN_DETAILS_FOR_ADMIN = 'RESET_CAPTAIN_DETAILS_FOR_ADMIN';
var SHOW_CAPTAIN_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN = 'SHOW_CAPTAIN_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN';
var HIDE_CAPTAIN_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN = 'HIDE_CAPTAIN_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN';
var SET_IS_NEW_CAPTAIN_ENTRIES_MODAL_FOR_ADMIN = 'SET_IS_NEW_CAPTAIN_ENTRIES_MODAL_FOR_ADMIN';
var SET_AFFECTED_VIRTUAL_ENTRIES_FOR_ADMIN = 'SET_AFFECTED_VIRTUAL_ENTRIES_FOR_ADMIN';
var SET_SELECTED_AFFECTED_VIRTUAL_ENTRY = 'SET_SELECTED_AFFECTED_VIRTUAL_ENTRY';
var SET_ALL_AFFECTED_VIRTUAL_ENTRIES_SELECTED = 'SET_ALL_AFFECTED_VIRTUAL_ENTRIES_SELECTED';
var SET_CHANGE_MULTIPLE_ENTRIES_ERRORS = 'SET_CHANGE_MULTIPLE_ENTRIES_ERRORS';
var CHANGE_HIDE_CANCELLED_ENTRIES = 'CHANGE_HIDE_CANCELLED_ENTRIES';
var CHANGE_HIDE_ARCHIVED_ENTRIES = 'CHANGE_HIDE_ARCHIVED_ENTRIES';
var SET_VALIDATION_MESSAGES_FOR_CAPTAIN_DETAIL = 'SET_VALIDATION_MESSAGES_FOR_CAPTAIN_DETAIL';

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_TOURNAMENT_INFORMATION_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_RETURNING_TO_CALENDAR_FOR_ADMIN; });
var SET_TOURNAMENT_INFORMATION_FOR_ADMIN = 'SET_TOURNAMENT_INFORMATION_FOR_ADMIN';
var SET_RETURNING_TO_CALENDAR_FOR_ADMIN = 'SET_RETURNING_TO_CALENDAR_FOR_ADMIN';

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardModal_jsx__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_DisplayIf_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__VirtualEntryContainer_jsx__ = __webpack_require__(813);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EntryCaptainChangeForm; });








var EntryCaptainChangeForm = function EntryCaptainChangeForm(_ref) {
  var visible = _ref.visible,
      isNew = _ref.isNew,
      submitButtonText = _ref.submitButtonText,
      affectedVirtualEntries = _ref.affectedVirtualEntries,
      allAffectedVirtualEntriesSelected = _ref.allAffectedVirtualEntriesSelected,
      onCancelClick = _ref.onCancelClick,
      handleSubmit = _ref.handleSubmit,
      onSubmit = _ref.onSubmit,
      onSearchClick = _ref.onSearchClick,
      onSelectAllChecked = _ref.onSelectAllChecked;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_shared_StandardModal_jsx__["a" /* default */],
    {
      title: 'Change Captain',
      visible: visible,
      onCloseClick: onCancelClick,
      bodyOverflow: true },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'form',
      { onSubmit: handleSubmit(onSubmit) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], { name: 'captainEmail',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'Email' })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'form-group text-right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-lg',
            onClick: onSearchClick
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-search' }),
          ' ',
          'Search'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-6' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], { name: 'captainFirstName',
            disabled: !isNew,
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'First Name' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-6' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], { name: 'captainLastName',
            disabled: !isNew,
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'Last Name' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_shared_DisplayIf_jsx__["a" /* default */],
          { condition: affectedVirtualEntries && affectedVirtualEntries.length > 0 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-sm-12' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 20, paddingBottom: 20 } },
              'The following virtual entries will be affected by this move. Please review them and mark the ones you would like to move as well:'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child custom-checkbox-container',
                style: { width: 250 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                type: 'checkbox',
                id: 'selectAllAffected',
                checked: allAffectedVirtualEntriesSelected,
                onChange: function onChange() {
                  return onSelectAllChecked();
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                {
                  htmlFor: 'selectAllAffected' },
                'Select All'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group' },
              affectedVirtualEntries.filter(function (entry) {
                return entry.entryName !== null;
              }).map(function (item, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { key: index },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__VirtualEntryContainer_jsx__["a" /* default */], item)
                );
              }),
              affectedVirtualEntries.filter(function (entry) {
                return entry.bowlerName !== null;
              }).map(function (item, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { key: index },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__VirtualEntryContainer_jsx__["a" /* default */], item)
                );
              })
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'form-group text-right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-link',
            onClick: function onClick() {
              return onCancelClick();
            }
          },
          'Cancel'
        ),
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'submit',
            className: 'btn btn-primary btn-lg'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
          ' ',
          submitButtonText
        )
      )
    )
  );
};

EntryCaptainChangeForm.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  isNew: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  submitButtonText: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  affectedVirtualEntries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  allAffectedVirtualEntriesSelected: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  onSearchClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSelectAllChecked: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["b"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'adminEntryCaptainChangeForm'
})(EntryCaptainChangeForm);

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_STATE_DISABLED_FOR_ADMIN_ENTRY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_STATES_FOR_ADMIN_ENTRY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_VIRTUAL_ENTRIES_TO_MODIFY_FOR_ADMIN_ENTRY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_READONLY_INFO_FOR_ADMIN_ENTRY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_SUMMARY_FOR_ADMIN_ENTRY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CLEAR_ROSTER_POSITION_FOR_ADMIN_ENTRY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_COUNTRIES_FOR_ADMIN_ENTRY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UPDATE_ROSTER_INFO_FOR_ADMIN_ENTRY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SEARCHING_MEMBER_FINISHED_FOR_ADMIN_ENTRY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SEARCHING_MEMBER_STARTS_FOR_ADMIN_ENTRY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_MEMBER_SEARCH_FIELD_FOR_ADMIN_ENTRY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return MOVE_ROSTER_POSITION_UP_FOR_ADMIN_ENTRY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return MOVE_ROSTER_POSITION_DOWN_FOR_ADMIN_ENTRY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_BOWLER_AVG_FOR_ADMIN_ENTRY_DETAIL_ROSTER_POSITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_IS_PROFESSIONAL_FOR_ADMIN_ENTRY_DETAIL_ROSTER_POSITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SET_ROSTER_POSITIONS_FOR_ADMIN_ENTRY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SET_ROSTER_MODAL_VISIBILITY_FOR_ADMIN_ENTRY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SET_ENTRY_DETAIL_BALANCE_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SET_ENTRY_DETAIL_CAPTAINID_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return DISPLAY_PAYMENT_LOG_HISTORY_FOR_ADMIN_ENTRY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return SET_PAYMENT_LOG_HISTORY_FOR_ADMIN_ENTRY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CANCEL_ENTRY_DETAIL_PAYMENT_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return DISPLAY_ENTRY_DETAIL_PAYMENT_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return HIDE_ENTRY_DETAIL_PAYMENT_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SET_ENTRY_DETAIL_ID_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SET_ENTRY_DETAIL_TOURNAMENT_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return DISPLAY_ENTRY_DETAIL_CHANGE_SQUAD_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return SET_ENTRY_DETAIL_COORDINATOR_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SET_ENTRY_DETAIL_CAPTAIN_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return SHOW_HIDE_ENTRY_DETAIL_COORDINATOR_MODAL_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return SHOW_HIDE_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SET_IS_NEW_CAPTAIN_ENTRY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_AVAILABLE_BOWLERS_FOR_ADMIN_ENTRY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return SHOW_HIDE_ENTRY_DETAIL_REFUND_MODAL_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return SET_ENTRY_DETAIL_CREDIT_PURCHASE_TRANSACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SHOW_HIDE_ENTRY_DETAIL_REACTIVATION_MODAL_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return SET_ADMIN_ENTRY_DETAIL_REFUND_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return DISPLAY_ENTRY_DETAIL_CHANGE_EVENT_MODAL; });
var SET_STATE_DISABLED_FOR_ADMIN_ENTRY_DETAIL = 'SET_STATE_DISABLED_FOR_ADMIN_ENTRY_DETAIL';
var SET_STATES_FOR_ADMIN_ENTRY_DETAIL = 'SET_STATES_FOR_ADMIN_ENTRY_DETAIL';
var SET_VIRTUAL_ENTRIES_TO_MODIFY_FOR_ADMIN_ENTRY_DETAIL = 'SET_VIRTUAL_ENTRIES_TO_MODIFY_FOR_ADMIN_ENTRY_DETAIL';
var SET_READONLY_INFO_FOR_ADMIN_ENTRY_DETAIL = 'SET_READONLY_INFO_FOR_ADMIN_ENTRY_DETAIL';
var SET_SUMMARY_FOR_ADMIN_ENTRY_DETAIL = 'SET_SUMMARY_FOR_ADMIN_ENTRY_DETAIL';
var CLEAR_ROSTER_POSITION_FOR_ADMIN_ENTRY_DETAIL = 'CLEAR_ROSTER_POSITION_FOR_ADMIN_ENTRY_DETAIL';
var SET_COUNTRIES_FOR_ADMIN_ENTRY_DETAIL = 'SET_COUNTRIES_FOR_ADMIN_ENTRY_DETAIL';
var UPDATE_ROSTER_INFO_FOR_ADMIN_ENTRY_DETAIL = 'UPDATE_ROSTER_INFO_FOR_ADMIN_ENTRY_DETAIL';
var SEARCHING_MEMBER_FINISHED_FOR_ADMIN_ENTRY_DETAIL = 'SEARCHING_MEMBER_FINISHED_FOR_ADMIN_ENTRY_DETAIL';
var SEARCHING_MEMBER_STARTS_FOR_ADMIN_ENTRY_DETAIL = 'SEARCHING_MEMBER_STARTS_FOR_ADMIN_ENTRY_DETAIL';
var SET_MEMBER_SEARCH_FIELD_FOR_ADMIN_ENTRY_DETAIL = 'SET_MEMBER_SEARCH_FIELD_FOR_ADMIN_ENTRY_DETAIL';
var MOVE_ROSTER_POSITION_UP_FOR_ADMIN_ENTRY_DETAIL = 'MOVE_ROSTER_POSITION_UP_FOR_ADMIN_ENTRY_DETAIL';
var MOVE_ROSTER_POSITION_DOWN_FOR_ADMIN_ENTRY_DETAIL = 'MOVE_ROSTER_POSITION_DOWN_FOR_ADMIN_ENTRY_DETAIL';
var SET_BOWLER_AVG_FOR_ADMIN_ENTRY_DETAIL_ROSTER_POSITION = 'SET_BOWLER_AVG_FOR_ADMIN_ENTRY_DETAIL_ROSTER_POSITION';
var SET_IS_PROFESSIONAL_FOR_ADMIN_ENTRY_DETAIL_ROSTER_POSITION = 'SET_IS_PROFESSIONAL_FOR_ADMIN_ENTRY_DETAIL_ROSTER_POSITION';
var SET_ROSTER_POSITIONS_FOR_ADMIN_ENTRY_DETAIL = 'SET_ROSTER_POSITIONS_FOR_ADMIN_ENTRY_DETAIL';
var SET_ROSTER_MODAL_VISIBILITY_FOR_ADMIN_ENTRY_DETAIL = 'SET_ROSTER_MODAL_VISIBILITY_FOR_ADMIN_ENTRY_DETAIL';
var SET_ENTRY_DETAIL_BALANCE_FOR_ADMIN = 'SET_ENTRY_DETAIL_BALANCE_FOR_ADMIN';
var SET_ENTRY_DETAIL_CAPTAINID_FOR_ADMIN = 'SET_ENTRY_DETAIL_CAPTAINID_FOR_ADMIN';
var DISPLAY_PAYMENT_LOG_HISTORY_FOR_ADMIN_ENTRY_DETAIL = 'DISPLAY_PAYMENT_LOG_HISTORY_FOR_ADMIN_ENTRY_DETAIL';
var SET_PAYMENT_LOG_HISTORY_FOR_ADMIN_ENTRY_DETAIL = 'SET_PAYMENT_LOG_HISTORY_FOR_ADMIN_ENTRY_DETAIL';
var CANCEL_ENTRY_DETAIL_PAYMENT_MODAL = 'CANCEL_ENTRY_DETAIL_PAYMENT_MODAL';
var DISPLAY_ENTRY_DETAIL_PAYMENT_MODAL = 'DISPLAY_ENTRY_DETAIL_PAYMENT_MODAL';
var HIDE_ENTRY_DETAIL_PAYMENT_MODAL = 'HIDE_ENTRY_DETAIL_PAYMENT_MODAL';
var SET_ENTRY_DETAIL_ID_FOR_ADMIN = 'SET_ENTRY_DETAIL_ID_FOR_ADMIN';
var SET_ENTRY_DETAIL_TOURNAMENT_FOR_ADMIN = 'SET_ENTRY_DETAIL_TOURNAMENT_FOR_ADMIN';
var DISPLAY_ENTRY_DETAIL_CHANGE_SQUAD_MODAL = 'DISPLAY_ENTRY_DETAIL_CHANGE_SQUAD_MODAL';
var SET_ENTRY_DETAIL_COORDINATOR_FOR_ADMIN = 'SET_ENTRY_DETAIL_COORDINATOR_FOR_ADMIN';
var SET_ENTRY_DETAIL_CAPTAIN_FOR_ADMIN = 'SET_ENTRY_DETAIL_CAPTAIN_FOR_ADMIN';
var SHOW_HIDE_ENTRY_DETAIL_COORDINATOR_MODAL_FOR_ADMIN = 'SHOW_HIDE_ENTRY_DETAIL_COORDINATOR_MODAL_FOR_ADMIN';
var SHOW_HIDE_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN = 'SHOW_HIDE_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN';
var SET_IS_NEW_CAPTAIN_ENTRY_DETAIL = 'SET_IS_NEW_CAPTAIN_ENTRY_DETAIL';
var SET_AVAILABLE_BOWLERS_FOR_ADMIN_ENTRY_DETAIL = 'SET_AVAILABLE_BOWLERS_FOR_ADMIN_ENTRY_DETAIL';
var SHOW_HIDE_ENTRY_DETAIL_REFUND_MODAL_FOR_ADMIN = 'SHOW_HIDE_ENTRY_DETAIL_REFUND_MODAL_FOR_ADMIN';
var SET_ENTRY_DETAIL_CREDIT_PURCHASE_TRANSACTIONS = 'SET_ENTRY_DETAIL_CREDIT_PURCHASE_TRANSACTIONS';
var SHOW_HIDE_ENTRY_DETAIL_REACTIVATION_MODAL_FOR_ADMIN = 'SHOW_HIDE_ENTRY_DETAIL_REACTIVATION_MODAL_FOR_ADMIN';
var SET_ADMIN_ENTRY_DETAIL_REFUND_TYPE = 'SET_ADMIN_ENTRY_DETAIL_REFUND_TYPE';
var DISPLAY_ENTRY_DETAIL_CHANGE_EVENT_MODAL = 'DISPLAY_ENTRY_DETAIL_CHANGE_EVENT_MODAL';

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_INCLUDE_PAST_TOURNAMENTS_IN_STATE_FOR_ADMIN_HOME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_SEARCH_VALUE_IN_STATE_FOR_ADMIN_HOME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_SEARCH_RESULT_IN_STATE_FOR_ADMIN_HOME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_SEARCH_BY_SELECTED_FOR_ADMIN_HOME; });
var SET_INCLUDE_PAST_TOURNAMENTS_IN_STATE_FOR_ADMIN_HOME = 'SET_INCLUDE_PAST_TOURNAMENTS_IN_STATE_FOR_ADMIN_HOME';
var SET_SEARCH_VALUE_IN_STATE_FOR_ADMIN_HOME = 'SET_SEARCH_VALUE_IN_STATE_FOR_ADMIN_HOME';
var SET_SEARCH_RESULT_IN_STATE_FOR_ADMIN_HOME = 'SET_SEARCH_RESULT_IN_STATE_FOR_ADMIN_HOME';
var SET_SEARCH_BY_SELECTED_FOR_ADMIN_HOME = 'SET_SEARCH_BY_SELECTED_FOR_ADMIN_HOME';

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOAD_RESERVATION_REVIEW_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_SQUAD_QTY_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_CART_TOTAL_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UPDATE_VIRTUAL_EVENT_QTY_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PROCESSING_STARTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PROCESSING_FINISHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DISPLAY_CLEAR_CART_CONFIRMATION_FOR_ADMIN; });
var LOAD_RESERVATION_REVIEW_FOR_ADMIN = 'LOAD_RESERVATION_REVIEW_FOR_ADMIN';
var UPDATE_SQUAD_QTY_FOR_ADMIN = 'UPDATE_SQUAD_QTY_FOR_ADMIN';
var UPDATE_CART_TOTAL_FOR_ADMIN = 'UPDATE_CART_TOTAL_FOR_ADMIN';
var UPDATE_VIRTUAL_EVENT_QTY_FOR_ADMIN = 'UPDATE_VIRTUAL_EVENT_QTY_FOR_ADMIN';
var PROCESSING_STARTED = 'PROCESSING_STARTED';
var PROCESSING_FINISHED = 'PROCESSING_FINISHED';
var DISPLAY_CLEAR_CART_CONFIRMATION_FOR_ADMIN = 'DISPLAY_CLEAR_CART_CONFIRMATION_FOR_ADMIN';

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_SELECTED_DATE_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_SQUAD_QTY_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_AVAILABLE_EVENTS_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_NO_DATES_AVAILABLE_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_ACTIVE_TOURNAMENTS_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DISPLAY_AVAILABLE_SQUAD_DATES_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DISPLAY_BOWLER_OWNED_VIRTUAL_EVENTS_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DISPLAY_GUIDE_IF_SQUAD_IS_BUNDLED_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_TOTAL_FOR_ADMIN_RESERVATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPDATE_SQUAD_COUNT_IN_CART_FOR_ADMIN_SCHEDULER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_QTY_FOR_ADMIN_SCHEDULER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_ADMIN_SCHEDULER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UPDATE_TEAM_OWNED_VIRTUAL_EVENT_QTY_FOR_ADMIN_SCHEDULER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return UPDATE_TEAM_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_ADMIN_SCHEDULER; });
var SET_SELECTED_DATE_FOR_ADMIN = 'SET_SELECTED_DATE_FOR_ADMIN';
var SET_SQUAD_QTY_FOR_ADMIN = 'SET_SQUAD_QTY_FOR_ADMIN';
var SET_AVAILABLE_EVENTS_FOR_ADMIN = 'SET_AVAILABLE_EVENTS_FOR_ADMIN';
var SET_NO_DATES_AVAILABLE_FOR_ADMIN = 'SET_NO_DATES_AVAILABLE_FOR_ADMIN';
var SET_ACTIVE_TOURNAMENTS_FOR_ADMIN = 'SET_ACTIVE_TOURNAMENTS_FOR_ADMIN';
var DISPLAY_AVAILABLE_SQUAD_DATES_FOR_ADMIN = 'DISPLAY_AVAILABLE_SQUAD_DATES_FOR_ADMIN';
var DISPLAY_BOWLER_OWNED_VIRTUAL_EVENTS_FOR_ADMIN = 'DISPLAY_BOWLER_OWNED_VIRTUAL_EVENTS_FOR_ADMIN';
var DISPLAY_GUIDE_IF_SQUAD_IS_BUNDLED_FOR_ADMIN = 'DISPLAY_GUIDE_IF_SQUAD_IS_BUNDLED_FOR_ADMIN';
var UPDATE_TOTAL_FOR_ADMIN_RESERVATION = 'UPDATE_TOTAL_FOR_ADMIN_RESERVATION';
var UPDATE_SQUAD_COUNT_IN_CART_FOR_ADMIN_SCHEDULER = 'UPDATE_SQUAD_COUNT_IN_CART_FOR_ADMIN_SCHEDULER';
var UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_QTY_FOR_ADMIN_SCHEDULER = 'UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_QTY_FOR_ADMIN_SCHEDULER';
var UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_ADMIN_SCHEDULER = 'UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_ADMIN_SCHEDULER';
var UPDATE_TEAM_OWNED_VIRTUAL_EVENT_QTY_FOR_ADMIN_SCHEDULER = 'UPDATE_TEAM_OWNED_VIRTUAL_EVENT_QTY_FOR_ADMIN_SCHEDULER';
var UPDATE_TEAM_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_ADMIN_SCHEDULER = 'UPDATE_TEAM_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_ADMIN_SCHEDULER';

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_SUBMITTING_FOR_ADMIN_VIRTUAL_EVENT_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_VIRTUAL_ENTRY_BOWLER_FOR_ADMIN_VIRTUAL_EVENT_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_VIRTUAL_ENTRY_TEAM_FOR_ADMIN_VIRTUAL_EVENT_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_DETAILS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_AVAILABLE_BOWLERS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_AVAILABLE_TEAMS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_VIRTUAL_ENTRIES_FOR_ADMIN_VIRTUAL_EVENT_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CALCULATE_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_VIRTUAL_ENTRY_SELECTED_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DISPLAY_PAYMENT_MODAL_FOR_ADMIN_VIRTUAL_ENTRY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_REFUND_TYPE_FOR_ADMIN_VIRTUAL_ENTRY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DISPLAY_CAPTAIN_VIRTUAL_ENTRY_CHANGE_MODAL_FOR_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_IS_NEW_CAPTAIN_VIRTUAL_ENTRIES_MODAL_FOR_ADMIN; });
/* unused harmony export HIDE_CAPTAIN_VIRTUAL_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_VIRTUAL_EVENT_DETAIL_CREDIT_PURCHASE_TRANSACTIONS; });
var SET_SUBMITTING_FOR_ADMIN_VIRTUAL_EVENT_DETAIL = 'SET_SUBMITTING_FOR_ADMIN_VIRTUAL_EVENT_DETAIL';
var SET_VIRTUAL_ENTRY_BOWLER_FOR_ADMIN_VIRTUAL_EVENT_DETAIL = 'SET_VIRTUAL_ENTRY_BOWLER_FOR_ADMIN_VIRTUAL_EVENT_DETAIL';
var SET_VIRTUAL_ENTRY_TEAM_FOR_ADMIN_VIRTUAL_EVENT_DETAIL = 'SET_VIRTUAL_ENTRY_TEAM_FOR_ADMIN_VIRTUAL_EVENT_DETAIL';
var SET_DETAILS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL = 'SET_DETAILS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL';
var SET_AVAILABLE_BOWLERS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL = 'SET_AVAILABLE_BOWLERS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL';
var SET_AVAILABLE_TEAMS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL = 'SET_AVAILABLE_TEAMS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL';
var SET_VIRTUAL_ENTRIES_FOR_ADMIN_VIRTUAL_EVENT_DETAIL = 'SET_VIRTUAL_ENTRIES_FOR_ADMIN_VIRTUAL_EVENT_DETAIL';
var CALCULATE_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL = 'CALCULATE_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL';
var SET_VIRTUAL_ENTRY_SELECTED_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL = 'SET_VIRTUAL_ENTRY_SELECTED_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL';
var DISPLAY_PAYMENT_MODAL_FOR_ADMIN_VIRTUAL_ENTRY_DETAIL = 'DISPLAY_PAYMENT_MODAL_FOR_ADMIN_VIRTUAL_ENTRY_DETAIL';
var SET_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL = 'SET_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL';
var SET_REFUND_TYPE_FOR_ADMIN_VIRTUAL_ENTRY_DETAIL = 'SET_REFUND_TYPE_FOR_ADMIN_VIRTUAL_ENTRY_DETAIL';
var DISPLAY_CAPTAIN_VIRTUAL_ENTRY_CHANGE_MODAL_FOR_ADMIN = 'DISPLAY_CAPTAIN_VIRTUAL_ENTRY_CHANGE_MODAL_FOR_ADMIN';
var SET_IS_NEW_CAPTAIN_VIRTUAL_ENTRIES_MODAL_FOR_ADMIN = 'SET_IS_NEW_CAPTAIN_VIRTUAL_ENTRIES_MODAL_FOR_ADMIN';
var HIDE_CAPTAIN_VIRTUAL_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN = 'HIDE_CAPTAIN_VIRTUAL_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN';
var SET_VIRTUAL_EVENT_DETAIL_CREDIT_PURCHASE_TRANSACTIONS = 'SET_VIRTUAL_EVENT_DETAIL_CREDIT_PURCHASE_TRANSACTIONS';

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var NoItemsToDisplay = function NoItemsToDisplay() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "alert alert-warning text-center" },
    "Sorry, no items found."
  );
};

/* harmony default export */ __webpack_exports__["a"] = NoItemsToDisplay;

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_FINANCE_ACCOUNTS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DISPLAY_ACCOUNT_NAME_MODAL; });
var SET_FINANCE_ACCOUNTS_LIST = 'SET_FINANCE_ACCOUNTS_LIST';
var DISPLAY_ACCOUNT_NAME_MODAL = 'DISPLAY_ACCOUNT_NAME_MODAL';

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_ADMIN_FINANCE_FEES_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DISPLAY_GROUP_TECH_FEE_MODAL_FOR_DEFAULT_TECH_FEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DISPLAY_TOURNAMENT_TECH_FEE_MODAL_FOR_DEFAULT_TECH_FEE; });
var SET_ADMIN_FINANCE_FEES_LIST = 'SET_ADMIN_FINANCE_FEES_LIST';
var DISPLAY_GROUP_TECH_FEE_MODAL_FOR_DEFAULT_TECH_FEE = 'DISPLAY_GROUP_TECH_FEE_MODAL_FOR_DEFAULT_TECH_FEE';
var DISPLAY_TOURNAMENT_TECH_FEE_MODAL_FOR_DEFAULT_TECH_FEE = 'DISPLAY_TOURNAMENT_TECH_FEE_MODAL_FOR_DEFAULT_TECH_FEE';

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DISPLAY_GO_HOME; });
var DISPLAY_GO_HOME = 'DISPLAY_GO_HOME';

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(432);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setTournamentInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setReturningToCalendarFlag; });


var setTournamentInState = function setTournamentInState(tournament) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_TOURNAMENT_ID */],
    payload: tournament
  };
};

var setReturningToCalendarFlag = function setReturningToCalendarFlag() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_RETURNING_TO_CALENDAR */]
  };
};

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_constants__ = __webpack_require__(97);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setPayInFullDisabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadCheckout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return updateSquadQuantity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return updateVirtualEventQuantity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return updateCartTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return updateSchedulerSquadCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateSchedulerVirtualEventCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setProcessingStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setProcessingFinished; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setAlreadyValidated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return clearPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return setTermsUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setValidationMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return setAgreeToTerms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return createCheckoutPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return showPaymentDialogEmbeddedForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return hidePaymentDialogEmbeddedForm; });




var setPayInFullDisabled = function setPayInFullDisabled(disabled) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_PAY_IN_FULL_DISABLED_FOR_REG_CHECKOUT */],
    payload: disabled
  };
};

var loadCheckout = function loadCheckout(cart) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* LOAD_CHECKOUT */],
    payload: cart
  };
};

var updateSquadQuantity = function updateSquadQuantity(squad) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* UPDATE_SQUAD_QTY_FOR_REG_CHECKOUT */],
    payload: squad
  };
};

var updateVirtualEventQuantity = function updateVirtualEventQuantity(virtualEvent) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* UPDATE_VIRTUAL_EVENT_QTY_FOR_REG_CHECKOUT */],
    payload: virtualEvent
  };
};

var updateCartTotal = function updateCartTotal() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* UPDATE_CART_TOTAL_FOR_REG_CHECKOUT */]
  };
};

var updateSchedulerSquadCount = function updateSchedulerSquadCount(squad, count) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1_shared_constants__["d" /* UPDATE_SCHEDULER_SQUAD_COUNT */],
    payload: {
      squad: squad,
      count: count
    }
  };
};
var updateSchedulerVirtualEventCount = function updateSchedulerVirtualEventCount(virtualEvent, count) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1_shared_constants__["e" /* UPDATE_SCHEDULER_VIRTUAL_EVENT_COUNT */],
    payload: {
      virtualEvent: virtualEvent,
      count: count
    }
  };
};

var setProcessingStarted = function setProcessingStarted() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* PROCESSING_STARTED */]
  };
};

var setProcessingFinished = function setProcessingFinished() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* PROCESSING_FINISHED */]
  };
};

var setAlreadyValidated = function setAlreadyValidated(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* SET_ALREADY_VALIDATED */],
    payload: payload
  };
};

var clearPayment = function clearPayment() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* CLEAR_PAYMENT */]
  };
};

var setTermsUrl = function setTermsUrl(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* SET_TERMS_URL_FOR_REG_CHECKOUT */],
    payload: payload
  };
};

var setValidationMessages = function setValidationMessages(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* SET_VALIDATION_MESSAGES_FOR_REG_CHECKOUT */],
    payload: payload
  };
};

var setAgreeToTerms = function setAgreeToTerms(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* SET_AGREE_TO_TERMS_FOR_REG_CHECKOUT */],
    payload: payload
  };
};

var createCheckoutPayment = function createCheckoutPayment(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* CREATE_CHECKOUT_PAYMENT */],
    payload: payload
  };
};

var showPaymentDialogEmbeddedForm = function showPaymentDialogEmbeddedForm() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* SHOW_PAYMENT_DIALOG_EMBEDDED_FORM */],
    payload: true
  };
};

var hidePaymentDialogEmbeddedForm = function hidePaymentDialogEmbeddedForm() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* SHOW_PAYMENT_DIALOG_EMBEDDED_FORM */],
    payload: false
  };
};

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_PAY_IN_FULL_DISABLED_FOR_REG_CHECKOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOAD_CHECKOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PROCESSING_STARTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PROCESSING_FINISHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UPDATE_SQUAD_QTY_FOR_REG_CHECKOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATE_CART_TOTAL_FOR_REG_CHECKOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_VIRTUAL_EVENT_QTY_FOR_REG_CHECKOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_ALREADY_VALIDATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CLEAR_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_TERMS_URL_FOR_REG_CHECKOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_AGREE_TO_TERMS_FOR_REG_CHECKOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_VALIDATION_MESSAGES_FOR_REG_CHECKOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CREATE_CHECKOUT_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SHOW_PAYMENT_DIALOG_EMBEDDED_FORM; });
// action types constants
var SET_PAY_IN_FULL_DISABLED_FOR_REG_CHECKOUT = 'SET_PAY_IN_FULL_DISABLED_FOR_REG_CHECKOUT';
var LOAD_CHECKOUT = 'LOAD_CHECKOUT';
var PROCESSING_STARTED = 'PROCESSING_STARTED';
var PROCESSING_FINISHED = 'PROCESSING_FINISHED';
var UPDATE_SQUAD_QTY_FOR_REG_CHECKOUT = 'UPDATE_SQUAD_QTY_FOR_REG_CHECKOUT';
var UPDATE_CART_TOTAL_FOR_REG_CHECKOUT = 'UPDATE_CART_TOTAL_FOR_REG_CHECKOUT';
var UPDATE_VIRTUAL_EVENT_QTY_FOR_REG_CHECKOUT = 'UPDATE_VIRTUAL_EVENT_QTY_FOR_REG_CHECKOUT';
var SET_ALREADY_VALIDATED = 'SET_ALREADY_VALIDATED';
var CLEAR_PAYMENT = 'CLEAR_PAYMENT';
var SET_TERMS_URL_FOR_REG_CHECKOUT = 'SET_TERMS_URL_FOR_REG_CHECKOUT';
var SET_AGREE_TO_TERMS_FOR_REG_CHECKOUT = 'SET_AGREE_TO_TERMS_FOR_REG_CHECKOUT';
var SET_VALIDATION_MESSAGES_FOR_REG_CHECKOUT = 'SET_VALIDATION_MESSAGES_FOR_REG_CHECKOUT';
var CREATE_CHECKOUT_PAYMENT = 'CREATE_CHECKOUT_PAYMENT';
var SHOW_PAYMENT_DIALOG_EMBEDDED_FORM = 'SHOW_PAYMENT_DIALOG_EMBEDDED_FORM';

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_TOURNAMENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_RETURNING_TO_CALENDAR; });
var SET_TOURNAMENT_ID = 'SET_TOURNAMENT_ID';
var SET_RETURNING_TO_CALENDAR = 'SET_RETURNING_TO_CALENDAR';

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DISPLAY_ACTIVE_TOURNAMENTS_FOR_REG_HOME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DISPLAY_MAINTENANCE_MESSAGE_FOR_REG_HOME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_PAYMENT_MESSAGE_FOR_REG_HOME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_SEARCH_TOURNAMENT_VALUE_FOR_REG_HOME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DISPLAY_BIRTH_DATE_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DISPLAY_REQUIRED_PROFILE_FIELDS_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_CAPTAIN_AGE_FOR_SELECTED_TOURNAMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_TOURNAMENT_LOADING_FOR_REG_HOME; });
var DISPLAY_ACTIVE_TOURNAMENTS_FOR_REG_HOME = 'DISPLAY_ACTIVE_TOURNAMENTS_FOR_REG_HOME';
var DISPLAY_MAINTENANCE_MESSAGE_FOR_REG_HOME = 'DISPLAY_MAINTENANCE_MESSAGE_FOR_REG_HOME';
var SET_PAYMENT_MESSAGE_FOR_REG_HOME = 'SET_PAYMENT_MESSAGE_FOR_REG_HOME';
var SET_SEARCH_TOURNAMENT_VALUE_FOR_REG_HOME = 'SET_SEARCH_TOURNAMENT_VALUE_FOR_REG_HOME';
var DISPLAY_BIRTH_DATE_MODAL = 'DISPLAY_BIRTH_DATE_MODAL';
var DISPLAY_REQUIRED_PROFILE_FIELDS_MODAL = 'DISPLAY_REQUIRED_PROFILE_FIELDS_MODAL';
var SET_CAPTAIN_AGE_FOR_SELECTED_TOURNAMENT = 'SET_CAPTAIN_AGE_FOR_SELECTED_TOURNAMENT';
var SET_TOURNAMENT_LOADING_FOR_REG_HOME = 'SET_TOURNAMENT_LOADING_FOR_REG_HOME';

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_StandardCheckboxField_jsx__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EntryRosterFormVirtualEntriesToModifyContainer_jsx__ = __webpack_require__(911);









var EntryRosterForm = function EntryRosterForm(_ref) {
  var disableState = _ref.disableState,
      roster = _ref.roster,
      rosterPositionsQty = _ref.rosterPositionsQty,
      countries = _ref.countries,
      states = _ref.states,
      parentVirtualEntryEvents = _ref.parentVirtualEntryEvents,
      parentTeamOwnedVirtualEntries = _ref.parentTeamOwnedVirtualEntries,
      entryId = _ref.entryId,
      eventId = _ref.eventId,
      handleSubmit = _ref.handleSubmit,
      pristine = _ref.pristine,
      submitting = _ref.submitting,
      rosterCheckout = _ref.rosterCheckout,
      onCancelClick = _ref.onCancelClick,
      onSubmit = _ref.onSubmit,
      onCountryChange = _ref.onCountryChange,
      onAssignTeamOwnedVirtualEventClick = _ref.onAssignTeamOwnedVirtualEventClick;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'form',
    {
      onSubmit: handleSubmit(onSubmit),
      noValidate: true },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: {
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column'
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-6 col-xs-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            disabled: rosterPositionsQty === 2 || rosterPositionsQty === 1,
            autoFocus: rosterPositionsQty > 2,
            className: 'form-control',
            name: 'name',
            type: 'text',
            placeholder: 'Team Name',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */] })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-6 col-xs-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            className: 'form-control',
            name: 'pairCode',
            type: 'text',
            placeholder: 'Companion Code',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            tooltip: '(Optional) Enter the Reservation Number of the other team you want to bowl/cross with on your pair.',
            tooltipPosition: 'top' })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-6 col-xs-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'countryId',
            placeholder: 'Country',
            component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__["a" /* default */],
            options: countries,
            simpleValue: true,
            searchable: true,
            matchPos: 'start',
            onCustomChange: onCountryChange })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-6 col-xs-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            disabled: disableState,
            className: 'form-control',
            name: 'state',
            placeholder: 'State',
            component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__["a" /* default */],
            options: states,
            simpleValue: true,
            searchable: true,
            matchPos: 'start' })
        )
      ),
      parentVirtualEntryEvents.filter(function (x) {
        return x.eventId === eventId;
      }).length > 0 ? parentVirtualEntryEvents.filter(function (x) {
        return x.eventId === eventId;
      }).map(function (virtualEvent, index) {
        var entry = parentTeamOwnedVirtualEntries.find(function (entry) {
          return entry.teamEntryId == entryId && entry.virtualEventName == virtualEvent.name;
        });
        var entryAssigned = entry ? true : false;
        var remaining = rosterCheckout ? parentTeamOwnedVirtualEntries.filter(function (entry) {
          return entry.virtualEventName === virtualEvent.name && !entry.isPurchased && entry.teamEntryId == null;
        }).length : virtualEvent.remaining;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row',
            key: index },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-12' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              id: 'assignVirtualEntry' + index,
              name: 'assignVirtualEntry' + index,
              checked: entryAssigned,
              disabled: rosterCheckout && entryAssigned && (entry ? entry.isPurchased : true) || !entryAssigned && remaining === 0,
              component: __WEBPACK_IMPORTED_MODULE_5_shared_StandardCheckboxField_jsx__["a" /* default */],
              label: 'Assign ' + virtualEvent.name + ' (' + (rosterCheckout && entryAssigned && (entry ? entry.isPurchased : true) ? 'already assigned' : remaining + ' remaining') + ')',
              title: rosterCheckout && entryAssigned ? 'This virtual event is already assigned to this entry. Its assignment can be changed on the Manage page after checkout.' : null,
              onCustomChange: function onCustomChange(event) {
                return onAssignTeamOwnedVirtualEventClick(virtualEvent.name, entryId, event.target.checked);
              } })
          )
        );
      }) : null,
      roster,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__EntryRosterFormVirtualEntriesToModifyContainer_jsx__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'form-group text-right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-link',
            disabled: submitting,
            onClick: onCancelClick },
          'Cancel'
        ),
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'submit',
            className: 'btn btn-primary btn-lg',
            disabled: pristine || submitting },
          submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
          ' ',
          'Save Changes'
        )
      )
    )
  );
};

EntryRosterForm.propTypes = {
  disableState: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  roster: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,
  rosterPositionsQty: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  countries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  states: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  parentVirtualEntryEvents: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  parentTeamOwnedVirtualEntries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  entryId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  eventId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  pristine: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  submitting: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onCountryChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onAssignTeamOwnedVirtualEventClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  rosterCheckout: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool
};

EntryRosterForm.defaultProps = {
  disableState: false,
  rosterPositionsQty: 0,
  countries: [],
  states: [],
  submitting: false,
  rosterCheckout: window.location.href.indexOf("rostercheckout") >= 0
};

/* harmony default export */ __webpack_exports__["a"] = EntryRosterForm;

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_ConfirmDialog_jsx__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_actionTypes__ = __webpack_require__(39);






var mapStateToProps = function mapStateToProps(state) {
  return {
    visible: state.registration.shared.rosterConfirmationVisible,
    title: 'Confirm Before Leave',
    content: 'There are unsaved roster changes. What would you like to do?',
    cancelBtnLabel: 'Discard and continue',
    confirmBtnLabel: 'Save and continue'
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["handleRosterConfirmationCancel"])());
    },
    onCloseClick: function onCloseClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_actionTypes__["r" /* setRosterConfirmationVisibility */])(false));
    },
    onConfirmClick: function onConfirmClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["submit"])('entryForm'));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2_shared_ConfirmDialog_jsx__["a" /* default */]);

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_EntryRosterList_jsx__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_actionTypes__ = __webpack_require__(39);






var entryFormSelector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["formValueSelector"])('entryForm');

var mapStateToProps = function mapStateToProps(state) {
  return {
    source: state.registration.shared.rosterPositions,
    sourceQty: state.registration.shared.rosterPositions.length,
    bowlers: state.registration.shared.bowlers,
    parentEntryId: entryFormSelector(state, 'id'),
    childVirtualEntryEvents: state.registration.shared.childVirtualEntryEvents.filter(function (x) {
      var editingCartEntry = state.registration.shared.entries.find(function (y) {
        return y.editing;
      });

      return editingCartEntry ? x.eventId === editingCartEntry.eventId : false;
    }),
    eventIsLinked: state.registration.shared.entries.find(function (e) {
      return e.editing;
    }).eventIsLinked,
    childTeamOwnedVirtualEntries: state.registration.shared.childTeamOwnedVirtualEntries,
    rosterCheckout: window.location.href.indexOf("rostercheckout") >= 0,
    showCalculatedDivisionToCaptain: state.registration.base.showCalculatedDivisionToCaptain
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSearchEnterKeyPress: function onSearchEnterKeyPress(roster, event) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["handleSearchEnterKeyPress"])(roster, event));
    },
    onSearchChange: function onSearchChange(roster, event) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["handleSearchChange"])(roster, event));
    },
    onSearch: function onSearch(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["handleSearch"])(data));
    },
    onAvgChange: function onAvgChange(position, value) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_actionTypes__["_16" /* setMemberAvgField */])(position, value));
    },
    onIsProfessionalChange: function onIsProfessionalChange(position, value) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["handleIsProfessionalChange"])(position, value));
    },
    onMoveUpClick: function onMoveUpClick(index) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["handleMoveUpClick"])(index));
    },
    onMoveDownClick: function onMoveDownClick(index) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["handleMoveDownClick"])(index));
    },
    onRosterPositionCleared: function onRosterPositionCleared(index) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["handleRosterPositionCleared"])(index));
    },
    onAssignChildTeamOwnedVirtualEventClick: function onAssignChildTeamOwnedVirtualEventClick(virtualEventName, parentTeamEntryId, rosterPosition, value) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["handleAssignChildTeamOwnedVirtualEventClick"])(virtualEventName, parentTeamEntryId, rosterPosition, value));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2_shared_EntryRosterList_jsx__["a" /* default */]);

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(438);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return displaySquadChangeModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setPaymentLogHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setCaptRosterWarnings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return displayEventChangeModal; });


var displaySquadChangeModal = function displaySquadChangeModal(showModal) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_SQUAD_CHANGE_MODAL_FOR_CAPTAIN */],
    payload: showModal
  };
};

var setPaymentLogHistory = function setPaymentLogHistory(paymentLogHistory) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE_TEAMS */],
    payload: paymentLogHistory
  };
};

var setCaptRosterWarnings = function setCaptRosterWarnings(virtualEntriesToModify) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_ROSTER_WARNINGS_FOR_CAPT_ENTRY_DETAIL */],
    payload: virtualEntriesToModify
  };
};

var displayEventChangeModal = function displayEventChangeModal(showModal) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* DISPLAY_EVENT_CHANGE_MODAL_FOR_CAPTAIN */],
    payload: showModal
  };
};

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DISPLAY_SQUAD_CHANGE_MODAL_FOR_CAPTAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE_TEAMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ROSTER_WARNINGS_FOR_CAPT_ENTRY_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DISPLAY_EVENT_CHANGE_MODAL_FOR_CAPTAIN; });
var DISPLAY_SQUAD_CHANGE_MODAL_FOR_CAPTAIN = 'DISPLAY_SQUAD_CHANGE_MODAL_FOR_CAPTAIN';
var SET_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE_TEAMS = 'SET_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE_TEAMS';
var SET_ROSTER_WARNINGS_FOR_CAPT_ENTRY_DETAIL = 'SET_ROSTER_WARNINGS_FOR_CAPT_ENTRY_DETAIL';
var DISPLAY_EVENT_CHANGE_MODAL_FOR_CAPTAIN = 'DISPLAY_EVENT_CHANGE_MODAL_FOR_CAPTAIN';

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_Submitting_jsx__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VirtualEntryBowler_jsx__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var VirtualEntryBowlerList = function VirtualEntryBowlerList(_ref) {
  var zindexvalue = _ref.zindexvalue,
      virtualEventId = _ref.virtualEventId,
      source = _ref.source,
      bowlers = _ref.bowlers,
      virtualBowlers = _ref.virtualBowlers,
      submitting = _ref.submitting,
      showCalculatedDivisionToCaptain = _ref.showCalculatedDivisionToCaptain,
      onVirtualEntryBowlerChange = _ref.onVirtualEntryBowlerChange,
      onVirtualEntryRemoveClick = _ref.onVirtualEntryRemoveClick,
      onCancelClick = _ref.onCancelClick,
      onUpdateClick = _ref.onUpdateClick,
      assignedByOtherCaptain = _ref.assignedByOtherCaptain;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'panel panel-default animated fadeIn',
      style: { position: 'relative', zIndex: zindexvalue } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-body' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'contact-card-wrapper' },
        source.map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { key: index },
            item && item.id && (item.id.length < 36 || item.id.toString().length < 36) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'text-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                {
                  type: 'button',
                  className: 'btn btn-danger btn-sm',
                  onClick: function onClick() {
                    return onVirtualEntryRemoveClick(virtualEventId, item.id);
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-trash-o' }),
                ' ',
                'Remove'
              )
            ) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__VirtualEntryBowler_jsx__["a" /* default */], _extends({}, item, {
              bowlers: bowlers.filter(function (b) {
                return virtualBowlers.length > 0 ? item.bowlerId == b.id || !virtualBowlers.some(function (vb) {
                  return vb.bowlerId == b.id;
                }) && !source.some(function (s) {
                  return s.bowlerId == b.id;
                }) : item.bowlerId == b.id || !source.some(function (s) {
                  return s.bowlerId == b.id;
                });
              }),
              position: index + 1,
              onBowlerChange: onVirtualEntryBowlerChange,
              divisionName: item.divisionName,
              showCalculatedDivisionToCaptain: showCalculatedDivisionToCaptain
            }))
          );
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'form-group text-right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-link',
            disabled: submitting,
            onClick: onCancelClick
          },
          'Cancel'
        ),
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-primary btn-lg',
            disabled: submitting || assignedByOtherCaptain,
            onClick: function onClick() {
              return onUpdateClick(virtualEventId);
            }
          },
          submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_shared_Submitting_jsx__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
          ' ',
          'Update'
        )
      )
    )
  );
};

VirtualEntryBowlerList.propTypes = {
  zindexvalue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  virtualEventId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  source: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  bowlers: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  virtualBowlers: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  submitting: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onVirtualEntryBowlerChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onVirtualEntryRemoveClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onUpdateClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  showCalculatedDivisionToCaptain: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  assignedByOtherCaptain: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool
};

VirtualEntryBowlerList.defaultProps = {
  source: [],
  bowlers: [],
  virtualBowlers: []
};

/* harmony default export */ __webpack_exports__["a"] = VirtualEntryBowlerList;

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualEntryPaymentLog_jsx__ = __webpack_require__(961);



var mapStateToProps = function mapStateToProps(state) {
  return state.registration.manage.paymentLog;
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__VirtualEntryPaymentLog_jsx__["a" /* default */]);

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(442);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cancelCartRosterEntryForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setRostersComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setEventsForRosterCheckout; });


var cancelCartRosterEntryForm = function cancelCartRosterEntryForm() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CANCEL_CART_ROSTER_ENTRY_FORM */]
    };
};

var setRostersComplete = function setRostersComplete(payload) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_ROSTERS_COMPLETE */],
        payload: payload
    };
};

var setEventsForRosterCheckout = function setEventsForRosterCheckout(payload) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_EVENTS_FOR_ROSTER_CHECKOUT */],
        payload: payload
    };
};

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL_CART_ROSTER_ENTRY_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_ROSTERS_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_EVENTS_FOR_ROSTER_CHECKOUT; });
var CANCEL_CART_ROSTER_ENTRY_FORM = 'CANCEL_CART_ROSTER_ENTRY_FORM';
var SET_ROSTERS_COMPLETE = 'SET_ROSTERS_COMPLETE';
var SET_EVENTS_FOR_ROSTER_CHECKOUT = 'SET_EVENTS_FOR_ROSTER_CHECKOUT';

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_NO_DATES_AVAILABLE_FOR_REG_SCHEDULER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_TOTAL_FOR_REG_SCHEDULER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATE_SQUAD_QTY_FOR_REG_SCHEDULER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_SELECTED_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DISPLAY_AVAILABLE_DATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DISPLAY_SQUADS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DISPLAY_BOWLER_OWNED_VIRTUAL_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_QTY_FOR_REG_SCHEDULER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_TEAM_OWNED_VIRTUAL_EVENT_QTY_FOR_REG_SCHEDULER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_SQUAD_COUNT_IN_CART_FOR_REG_SCHEDULER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_REG_SCHEDULER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return UPDATE_TEAM_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_REG_SCHEDULER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_CALENDAR_SELECTED_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DISPLAY_GUIDE_IF_SQUAD_IS_BUNDLED; });
var SET_NO_DATES_AVAILABLE_FOR_REG_SCHEDULER = 'SET_NO_DATES_AVAILABLE_FOR_REG_SCHEDULER';
var UPDATE_TOTAL_FOR_REG_SCHEDULER = 'UPDATE_TOTAL_FOR_REG_SCHEDULER';
var UPDATE_SQUAD_QTY_FOR_REG_SCHEDULER = 'UPDATE_SQUAD_QTY_FOR_REG_SCHEDULER';
var SET_SELECTED_DATE = 'SET_SELECTED_DATE';
var DISPLAY_AVAILABLE_DATES = 'DISPLAY_AVAILABLE_DATES';
var DISPLAY_SQUADS = 'DISPLAY_SQUADS';
var DISPLAY_BOWLER_OWNED_VIRTUAL_EVENTS = 'DISPLAY_BOWLER_OWNED_VIRTUAL_EVENTS';
var UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_QTY_FOR_REG_SCHEDULER = 'UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_QTY_FOR_REG_SCHEDULER';
var UPDATE_TEAM_OWNED_VIRTUAL_EVENT_QTY_FOR_REG_SCHEDULER = 'UPDATE_TEAM_OWNED_VIRTUAL_EVENT_QTY_FOR_REG_SCHEDULER';
var UPDATE_SQUAD_COUNT_IN_CART_FOR_REG_SCHEDULER = 'UPDATE_SQUAD_COUNT_IN_CART_FOR_REG_SCHEDULER';
var UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_REG_SCHEDULER = 'UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_REG_SCHEDULER';
var UPDATE_TEAM_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_REG_SCHEDULER = 'UPDATE_TEAM_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_REG_SCHEDULER';
var SET_CALENDAR_SELECTED_DATE = 'SET_CALENDAR_SELECTED_DATE';
var DISPLAY_GUIDE_IF_SQUAD_IS_BUNDLED = 'DISPLAY_GUIDE_IF_SQUAD_IS_BUNDLED';

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_ClearCartConfirmationModal_jsx__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(39);





var mapStateToProps = function mapStateToProps(state) {
  return {
    visible: state.registration.payment.showClearCartConfirmation
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["Q" /* displayClearCartConfirmation */])(false));
    },
    onContinueClick: function onContinueClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["o" /* cancelCheckout */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1_shared_ClearCartConfirmationModal_jsx__["a" /* default */]);

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_util_formatCurrency__ = __webpack_require__(27);


Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_1_shared_util_formatCurrency__["a" /* formatCurrency */];

var CartFooter = function CartFooter(_ref) {
  var visible = _ref.visible,
      total = _ref.total,
      countInCart = _ref.countInCart,
      onReviewClick = _ref.onReviewClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    visible ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'flex space-between vertical-center animated fadeIn' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h4',
        { className: 'flex-2' },
        'Total: $',
        total.formatCurrency(2)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          disabled: !total && countInCart == 0,
          type: 'button',
          className: 'btn btn-primary btn-lg',
          onClick: onReviewClick
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-shopping-cart' }),
        ' ',
        !total && countInCart == 0 ? 'Cart Empty' : 'Review Selection'
      )
    ) : null
  );
};

CartFooter.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  total: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  countInCart: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  onReviewClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

CartFooter.defaultProps = {
  visible: false,
  total: 0,
  countInCart: 0
};

/* harmony default export */ __webpack_exports__["a"] = CartFooter;

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_StandardModal_jsx__ = __webpack_require__(23);



var OrderReviewConfirmationModal = function OrderReviewConfirmationModal(_ref) {
  var visible = _ref.visible,
      onCancelClick = _ref.onCancelClick,
      onContinueClick = _ref.onContinueClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_shared_StandardModal_jsx__["a" /* default */],
    {
      title: 'Clear Cart',
      visible: visible,
      onCloseClick: onCancelClick },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        'You are about to remove all items from the cart. Are you sure?'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'text-right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-link',
            onClick: function onClick() {
              return onCancelClick();
            }
          },
          'Cancel'
        ),
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'submit',
            className: 'btn btn-primary btn-lg',
            onClick: function onClick() {
              return onContinueClick();
            }
          },
          'I\'m Sure'
        )
      )
    )
  );
};

OrderReviewConfirmationModal.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onContinueClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = OrderReviewConfirmationModal;

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_StandardModal_jsx__ = __webpack_require__(23);



var ConfirmDialog = function ConfirmDialog(_ref) {
  var visible = _ref.visible,
      title = _ref.title,
      content = _ref.content,
      cancelBtnLabel = _ref.cancelBtnLabel,
      confirmBtnLabel = _ref.confirmBtnLabel,
      onConfirmClick = _ref.onConfirmClick,
      onCancelClick = _ref.onCancelClick,
      onCloseClick = _ref.onCloseClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_shared_StandardModal_jsx__["a" /* default */],
    {
      title: title || 'Confirm',
      visible: visible,
      onCloseClick: onCloseClick },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      content || 'Do you want to continue?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'text-right' },
      onCancelClick ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          type: 'button',
          className: 'btn btn-link',
          onClick: onCancelClick },
        cancelBtnLabel || 'Cancel'
      ) : null,
      onConfirmClick ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          type: 'button',
          className: 'btn btn-primary btn-lg',
          onClick: onConfirmClick },
        confirmBtnLabel || 'Confirm'
      ) : null
    )
  );
};

ConfirmDialog.propTypes = {
  cancelBtnLabel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  confirmBtnLabel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  content: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,
  title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onConfirmClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onCloseClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

ConfirmDialog.defaultProps = {
  content: null,
  title: '',
  visible: false,
  cancelBtnLabel: '',
  confirmBtnLabel: ''
};

/* harmony default export */ __webpack_exports__["a"] = ConfirmDialog;

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_util_formatCurrency__ = __webpack_require__(27);


Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_1_shared_util_formatCurrency__["a" /* formatCurrency */];

var EntryPaymentLog = function EntryPaymentLog(_ref) {
  var entryFeeDescription = _ref.entryFeeDescription,
      entryFeeAmount = _ref.entryFeeAmount,
      addOnFees = _ref.addOnFees,
      payments = _ref.payments,
      refunds = _ref.refunds,
      total = _ref.total,
      grandTotal = _ref.grandTotal;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'panel panel-default' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-heading' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h3',
        { className: 'panel-title' },
        'Payment Log'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-body' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'flex-3' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            'Description'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            entryFeeDescription
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'flex-1' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'text-right' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'small',
              null,
              'Amount'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'flex text-right' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'flex-2' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              { className: 'flex-1' },
              '$' + entryFeeAmount.formatCurrency(2)
            )
          ),
          addOnFees.map(function (fee, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: index,
                className: 'flex text-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'flex-2' },
                fee.description
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'flex-1' },
                fee.amount ? '$' + fee.amount.formatCurrency(2) : '$' + fee.amount
              )
            );
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'flex text-right' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              { className: 'flex-2' },
              'Total'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              { className: 'flex-1' },
              '$' + total.formatCurrency(2)
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
      payments.map(function (payment, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: index,
            className: 'flex' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'flex-3' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              payment.description
            ),
            payment.notes != null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              'Notes: ',
              payment.notes,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
            ) : null
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'flex-1' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'flex text-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                { className: 'flex-2' },
                ''
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                { className: 'flex-1' },
                '$' + (-payment.amount).formatCurrency(2)
              )
            )
          )
        );
      }),
      refunds.map(function (refund, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: index,
            className: 'flex' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'flex-3' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              refund.description
            ),
            refund.notes != null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              'Refund Notes: ',
              refund.notes,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
            ) : null
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'flex-1' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'flex text-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                { className: 'flex-2' },
                ''
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                { className: 'flex-1' },
                '$' + (-refund.amount).formatCurrency(2)
              )
            )
          )
        );
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'flex-1' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'flex text-right' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              { className: 'flex-2' },
              'Total Due'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              { className: 'flex-1' },
              '$' + grandTotal.formatCurrency(2)
            )
          )
        )
      )
    )
  );
};

EntryPaymentLog.propTypes = {
  entryFeeDescription: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  entryFeeAmount: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  addOnFees: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  payments: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  refunds: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  total: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  grandTotal: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number
};

EntryPaymentLog.defaultProps = {
  entryFeeDescription: '',
  entryFeeAmount: 0,
  addOnFees: [],
  payments: [],
  refunds: [],
  total: 0,
  grandTotal: 0
};

/* harmony default export */ __webpack_exports__["a"] = EntryPaymentLog;

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);



var EntryWithRosterReadOnly = function EntryWithRosterReadOnly(_ref) {
  var teamName = _ref.teamName,
      state = _ref.state,
      country = _ref.country,
      rosterPositions = _ref.rosterPositions,
      pairCode = _ref.pairCode,
      groupCode = _ref.groupCode;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 250 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Team Name'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          teamName || '-'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 150 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Country'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          country || '-'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 200 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'State'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          state || '-'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 150 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Group Code'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          groupCode || '-'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 150 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Companion Code'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          pairCode || '-'
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'contact-card-wrapper' },
      rosterPositions.map(function (position, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'contact-card',
            key: index },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'contact-card-info-wrapper' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('contact-card-avatar', { 'empty': !position.usbcId }) },
                index + 1
              )
            ),
            position.usbcId ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'contact-card-info' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'contact-card-title' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  position.firstName,
                  ' ',
                  position.lastName,
                  ' ',
                  position.usbcId ? '(' + position.usbcId + ')' : ''
                )
              ),
              position.email ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { href: 'mailto:' + (position.email || '') },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-envelope' }),
                ' ',
                position.email
              ) : null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                (position.average || 0) + ' (Avg)'
              ),
              position.isProfessional ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                'Pro Bowler'
              ) : null
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'contact-card-info' },
              'Empty roster position'
            )
          )
        );
      })
    )
  );
};

EntryWithRosterReadOnly.propTypes = {
  teamName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  state: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  country: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  rosterPositions: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  pairCode: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  groupCode: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

EntryWithRosterReadOnly.defaultProps = {
  rosterPositions: []
};

/* harmony default export */ __webpack_exports__["a"] = EntryWithRosterReadOnly;

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_Link_jsx__ = __webpack_require__(61);



var JumbotronLink = function JumbotronLink(_ref) {
  var message = _ref.message,
      linkPath = _ref.linkPath,
      linkText = _ref.linkText;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'jumbotron' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      message
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_shared_Link_jsx__["a" /* default */],
        {
          to: linkPath,
          className: 'btn btn-primary btn-lg'
        },
        linkText
      )
    )
  );
};

JumbotronLink.propTypes = {
  message: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  linkPath: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  linkText: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = JumbotronLink;

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eventPriceDetailsModal_EventPriceDetailsModalContainer_jsx__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error_ErrorListContainer_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_util_formatCurrency__ = __webpack_require__(27);





Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_3_shared_util_formatCurrency__["a" /* formatCurrency */];

var OrderReview = function OrderReview(_ref) {
  var title = _ref.title,
      total = _ref.total,
      children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__eventPriceDetailsModal_EventPriceDetailsModalContainer_jsx__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-heading' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          { className: 'panel-title' },
          title
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-body' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__error_ErrorListContainer_jsx__["a" /* default */], null),
        children,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          { className: 'text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            null,
            'Total: $',
            total.formatCurrency(2)
          )
        )
      )
    )
  );
};

OrderReview.defaultProps = {
  title: 'Order Review',
  total: 0
};

OrderReview.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  total: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  children: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node
};

/* harmony default export */ __webpack_exports__["a"] = OrderReview;

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_util_squadComparator__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderReviewSquadItem_jsx__ = __webpack_require__(977);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var OrderReviewSquadList = function OrderReviewSquadList(_ref) {
  var eventsInCart = _ref.eventsInCart,
      qtyNotEditable = _ref.qtyNotEditable,
      onRemoveSquadItem = _ref.onRemoveSquadItem,
      onRemoveVirtualEvent = _ref.onRemoveVirtualEvent,
      onEventSquadFeesClick = _ref.onEventSquadFeesClick,
      onQuantityChange = _ref.onQuantityChange,
      onVirtualEventQuantityChange = _ref.onVirtualEventQuantityChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    eventsInCart.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group' },
      eventsInCart.sort(__WEBPACK_IMPORTED_MODULE_1_shared_util_squadComparator__["a" /* squadComparator */]).map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__OrderReviewSquadItem_jsx__["a" /* default */], _extends({
          key: index
        }, item, {
          qtyNotEditable: qtyNotEditable,
          onSquadFeesClick: onEventSquadFeesClick,
          onQuantityChange: onQuantityChange,
          onVirtualEventQuantityChange: onVirtualEventQuantityChange,
          onRemoveSquadItem: onRemoveSquadItem,
          onRemoveVirtualEvent: onRemoveVirtualEvent
        }));
      })
    ) : null
  );
};

OrderReviewSquadList.defaultProps = {
  eventsInCart: []
};

OrderReviewSquadList.propTypes = {
  eventsInCart: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  qtyNotEditable: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onEventSquadFeesClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onQuantityChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onVirtualEventQuantityChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onRemoveSquadItem: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onRemoveVirtualEvent: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = OrderReviewSquadList;

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_infinite_calendar__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_infinite_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_infinite_calendar__);



var calendarTheme = {
  selectionColor: 'rgb(0,51,141)',
  textColor: {
    default: 'rgb(99,102,106)',
    active: 'rgb(255,255,255)'
  },
  weekdayColor: 'rgb(58,113,210)',
  headerColor: 'rgb(0,51,141)',
  floatingNav: {
    background: 'rgba(58,113,210,0.96)',
    color: 'rgb(255,255,255)',
    chevron: 'rgb(84,207,112)'
  }
};

var RegistrationCalendar = function RegistrationCalendar(_ref) {
  var visible = _ref.visible,
      selectedDate = _ref.selectedDate,
      disabledDates = _ref.disabledDates,
      min = _ref.min,
      minDate = _ref.minDate,
      max = _ref.max,
      maxDate = _ref.maxDate,
      onSelectDate = _ref.onSelectDate;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    visible ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-default calendar-div' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_infinite_calendar___default.a, {
        theme: calendarTheme,
        width: '100%',
        height: 336,
        keyboardSupport: true,
        disabledDates: disabledDates,
        onSelect: onSelectDate,
        selectedDate: selectedDate,
        min: min,
        minDate: minDate,
        max: max,
        maxDate: maxDate,
        showTodayHelper: false
      })
    ) : null
  );
};

RegistrationCalendar.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  selectedDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  disabledDates: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string),
  min: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  minDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  max: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  maxDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onSelectDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = RegistrationCalendar;

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScheduleSquadList_jsx__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_Panel_jsx__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_DisplayIf_jsx__ = __webpack_require__(12);






var ScheduleEventList = function ScheduleEventList(_ref) {
  var source = _ref.source,
      selectedDate = _ref.selectedDate,
      onEventSquadQuantityChange = _ref.onEventSquadQuantityChange,
      onEventSquadAddClick = _ref.onEventSquadAddClick,
      onEventSquadFeesClick = _ref.onEventSquadFeesClick,
      onNextDateClick = _ref.onNextDateClick,
      onQuantityChange = _ref.onQuantityChange,
      onAddClick = _ref.onAddClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    source.map(function (tournamentEvent, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_shared_Panel_jsx__["a" /* default */],
        { key: index,
          className: 'panel-primary',
          title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            tournamentEvent.name + ' squads for ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(selectedDate).format('ddd, MMM Do'),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_shared_DisplayIf_jsx__["a" /* default */],
              { condition: tournamentEvent.isLinked,
                className: 'panel-sub-heading' },
              'One “Qty” is one doubles set and two singles entries.',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              tournamentEvent.bundledParentNumberOfBowlers ? 'For example: 2 teams (' + tournamentEvent.bundledParentNumberOfBowlers * 2 + ' bowlers)\n                  should purchase ' + tournamentEvent.bundledParentNumberOfBowlers + ' sets.' : ''
            )
          ) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ScheduleSquadList_jsx__["a" /* default */], {
          source: tournamentEvent.squads,
          onQuantityChange: onEventSquadQuantityChange,
          onSquadFeesClick: onEventSquadFeesClick,
          onAddClick: onEventSquadAddClick,
          onNextDateClick: onNextDateClick
        }),
        tournamentEvent.teamOwnedVirtualEvents.map(function (virtualEvent, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              key: index,
              style: { padding: 0 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'panel-heading' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'indent',
                style: { width: 80 } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                { className: 'panel-title' },
                virtualEvent.name
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'panel-body' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'list-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'indent',
                  style: { width: 80 } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'list-group-item-labeled' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'list-group-item-labeled-child',
                      style: { width: 80 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      'Price ($)'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      virtualEvent.price.formatCurrency(2)
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'list-group-item-labeled-child',
                      style: { width: 80 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      'Available'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      'N/A'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'list-group-item-labeled-child',
                      style: { width: 80 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      'Quantity'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      style: { width: 80 },
                      value: virtualEvent.quantity,
                      type: 'number',
                      min: '0',
                      step: '1',
                      onChange: function onChange(event) {
                        return onQuantityChange(tournamentEvent.id, virtualEvent.id, event.target.value);
                      }
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'list-group-item-labeled-child',
                      style: { width: 100 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      {
                        className: virtualEvent.quantity > 0 ? 'btn btn-warning' : 'btn btn-link',
                        type: 'button',
                        disabled: !virtualEvent.quantity,
                        onClick: function onClick() {
                          return onAddClick({
                            id: virtualEvent.id,
                            name: virtualEvent.name,
                            quantity: virtualEvent.quantity,
                            price: virtualEvent.price,
                            eventId: tournamentEvent.id
                          });
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-shopping-cart' }),
                      ' ',
                      virtualEvent.quantity > 0 ? 'Add (' + virtualEvent.quantity + ')' : 'Add'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'list-group-item-labeled-child',
                      style: { width: 80 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      'In Cart'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      virtualEvent.countInCart
                    )
                  )
                )
              )
            )
          );
        })
      );
    })
  );
};

ScheduleEventList.propTypes = {
  source: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  selectedDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onEventSquadQuantityChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onEventSquadAddClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onEventSquadFeesClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onNextDateClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onQuantityChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onAddClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

ScheduleEventList.defaultProps = {
  source: []
};

/* harmony default export */ __webpack_exports__["a"] = ScheduleEventList;

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_util_formatCurrency__ = __webpack_require__(27);


Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_1_shared_util_formatCurrency__["a" /* formatCurrency */];

var VirtualEvent = function VirtualEvent(_ref) {
  var virtualEvents = _ref.virtualEvents,
      showAllEvent = _ref.showAllEvent,
      onAddClick = _ref.onAddClick,
      onQuantityChange = _ref.onQuantityChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    showAllEvent ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-primary' },
      virtualEvents.map(function (virtualEvent, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: index },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'panel-heading' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              { className: 'panel-title' },
              virtualEvent.name
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'panel-body' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'list-group-item-labeled' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'list-group-item-labeled-child',
                    style: { width: 80 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    null,
                    'Time'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    null,
                    'N/A'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'list-group-item-labeled-child',
                    style: { width: 80 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    null,
                    'Price ($)'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    null,
                    virtualEvent.price.formatCurrency(2)
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'list-group-item-labeled-child',
                    style: { width: 80 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    null,
                    'Available'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    null,
                    'N/A'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'list-group-item-labeled-child',
                    style: { width: 80 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    null,
                    'Quantity'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                    style: { width: 80 },
                    value: virtualEvent.quantity,
                    type: 'number',
                    min: '0',
                    step: '1',
                    onChange: function onChange(event) {
                      return onQuantityChange(virtualEvent.id, event.target.value);
                    } })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'list-group-item-labeled-child',
                    style: { width: 100 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    {
                      className: virtualEvent.quantity > 0 ? 'btn btn-warning' : 'btn btn-link',
                      type: 'button',
                      disabled: !virtualEvent.quantity,
                      onClick: function onClick() {
                        return onAddClick({
                          id: virtualEvent.id,
                          name: virtualEvent.name,
                          quantity: virtualEvent.quantity,
                          price: virtualEvent.price,
                          owner: virtualEvent.owner
                        });
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-shopping-cart' }),
                    ' ',
                    virtualEvent.quantity > 0 ? 'Add (' + virtualEvent.quantity + ')' : 'Add'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'list-group-item-labeled-child',
                    style: { width: 80 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    null,
                    'In Cart'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    null,
                    virtualEvent.countInCart
                  )
                )
              )
            )
          )
        );
      })
    ) : null
  );
};

VirtualEvent.defaultProps = {
  showAllEvent: false,
  id: null,
  name: '',
  quantity: 0,
  price: 0,
  countInCart: 0
};

VirtualEvent.propTypes = {
  virtualEvents: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  showAllEvent: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  id: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  name: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  quantity: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  price: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  countInCart: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  onAddClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onQuantityChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = VirtualEvent;

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualEventItem_jsx__ = __webpack_require__(981);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var VirtualEventList = function VirtualEventList(_ref) {
  var virtualEvents = _ref.virtualEvents,
      qtyNotEditable = _ref.qtyNotEditable,
      onRemoveVirtualEvent = _ref.onRemoveVirtualEvent,
      onQuantityChange = _ref.onQuantityChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    virtualEvents.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group' },
      virtualEvents.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__VirtualEventItem_jsx__["a" /* default */], _extends({
          key: index
        }, item, {
          qtyNotEditable: qtyNotEditable,
          onQuantityChange: onQuantityChange,
          onRemoveVirtualEvent: onRemoveVirtualEvent
        }));
      })
    ) : null
  );
};

VirtualEventList.defaultProps = {
  virtualEvents: []
};

VirtualEventList.propTypes = {
  virtualEvents: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  qtyNotEditable: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onQuantityChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onRemoveVirtualEvent: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = VirtualEventList;

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_EMAIL_FOR_SHARED_AUTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_ROLES_FOR_SHARED_AUTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_PERMISSIONS_FOR_SHARED_AUTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_DISPLAY_NAME_FOR_SHARED_AUTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_PROFILE_VALIDATIONS_FOR_SHARED_AUTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_DOB_FOR_SHARED_AUTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_GROUP_NAME_FOR_SHARED_AUTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_IS_ALLOWED_FOR_SHARED_AUTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_IS_VALID_TYPE_FOR_SHARED_AUTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_MAINTENANCE_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_LOGIN_ATTEMPTED; });
var SET_EMAIL_FOR_SHARED_AUTH = 'SET_EMAIL_FOR_SHARED_AUTH';
var SET_ROLES_FOR_SHARED_AUTH = 'SET_ROLES_FOR_SHARED_AUTH';
var SET_PERMISSIONS_FOR_SHARED_AUTH = 'SET_PERMISSIONS_FOR_SHARED_AUTH';
var SET_DISPLAY_NAME_FOR_SHARED_AUTH = 'SET_DISPLAY_NAME_FOR_SHARED_AUTH';
var SET_PROFILE_VALIDATIONS_FOR_SHARED_AUTH = 'SET_PROFILE_VALIDATIONS_FOR_SHARED_AUTH';
var SET_DOB_FOR_SHARED_AUTH = 'SET_DOB_FOR_SHARED_AUTH';
var SET_GROUP_NAME_FOR_SHARED_AUTH = 'SET_GROUP_NAME_FOR_SHARED_AUTH';
var SET_IS_ALLOWED_FOR_SHARED_AUTH = 'SET_IS_ALLOWED_FOR_SHARED_AUTH';
var SET_IS_VALID_TYPE_FOR_SHARED_AUTH = 'SET_IS_VALID_TYPE_FOR_SHARED_AUTH';
var SET_MAINTENANCE_MESSAGE = 'SET_MAINTENANCE_MESSAGE';
var SET_LOGIN_ATTEMPTED = 'SET_LOGIN_ATTEMPTED';

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_ERROR_LIST_FOR_SHARED; });
var SET_ERROR_LIST_FOR_SHARED = 'SET_ERROR_LIST_FOR_SHARED';

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DISPLAY_EVENT_PRICE_DETAILS_MODAL_SHARED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CANCEL_EVENT_PRICE_DETAILS_MODAL_SHARED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_EVENT_PRICE_DETAILS_DATA_SHARED; });
var DISPLAY_EVENT_PRICE_DETAILS_MODAL_SHARED = 'DISPLAY_EVENT_PRICE_DETAILS_MODAL_SHARED';
var CANCEL_EVENT_PRICE_DETAILS_MODAL_SHARED = 'CANCEL_EVENT_PRICE_DETAILS_MODAL_SHARED';
var SET_EVENT_PRICE_DETAILS_DATA_SHARED = 'SET_EVENT_PRICE_DETAILS_DATA_SHARED';

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HIDE_ICON_FOR_SHARED_NAVIGATION_BAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DISPLAY_ICON_FOR_SHARED_NAVIGATION_BAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_NAVIGATION_ACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HIDE_NAVIGATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DISPLAY_NAVIGATION; });
var HIDE_ICON_FOR_SHARED_NAVIGATION_BAR = 'HIDE_ICON_FOR_SHARED_NAVIGATION_BAR';
var DISPLAY_ICON_FOR_SHARED_NAVIGATION_BAR = 'DISPLAY_ICON_FOR_SHARED_NAVIGATION_BAR';
var SET_NAVIGATION_ACTIVE = 'SET_NAVIGATION_ACTIVE';
var HIDE_NAVIGATION = 'HIDE_NAVIGATION';
var DISPLAY_NAVIGATION = 'DISPLAY_NAVIGATION';

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_TOP_BANNER_IMAGE_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_SUBTITLE; });
var SET_TOP_BANNER_IMAGE_PATH = 'SET_TOP_BANNER_IMAGE_PATH';
var SET_TITLE = 'SET_TITLE';
var SET_SUBTITLE = 'SET_SUBTITLE';

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SET_SQUAD_CAPACITY_AS_DIRTY_FOR_SETUP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_SQUAD_CAPACITY_FOR_TOURNAMENT_CAPACITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DISPLAY_SQUADS_FOR_TOURNAMENT_CAPACITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HIDE_CAPACITY_DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DISPLAY_CAPACITY_DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DISPLAY_EVENTS_IN_DDL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_SQUAD_VISIBILITY; });
var SET_SQUAD_CAPACITY_AS_DIRTY_FOR_SETUP = 'SET_SQUAD_CAPACITY_AS_DIRTY_FOR_SETUP';
var SET_SQUAD_CAPACITY_FOR_TOURNAMENT_CAPACITY = 'SET_SQUAD_CAPACITY_FOR_TOURNAMENT_CAPACITY';
var DISPLAY_SQUADS_FOR_TOURNAMENT_CAPACITY = 'DISPLAY_SQUADS_FOR_TOURNAMENT_CAPACITY';
var HIDE_CAPACITY_DIALOG = 'HIDE_CAPACITY_DIALOG';
var DISPLAY_CAPACITY_DIALOG = 'DISPLAY_CAPACITY_DIALOG';
var DISPLAY_EVENTS_IN_DDL = 'DISPLAY_EVENTS_IN_DDL';
var SET_SQUAD_VISIBILITY = 'SET_SQUAD_VISIBILITY';

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(54);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleCancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setupTournamentComForm; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var handleSave = function handleSave(data) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      var promise = data.id ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["g" /* putJsonAsync */])('setup/tournament/' + data.id, data) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["e" /* postJsonAsync */])('setup/tournament', data);

      dispatch(promise).then(function () {
        __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Saved!', 'Tournament saved Successfully.');
        resolve();
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["initialize"])('tournamentCom', data));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["n" /* loadTournament */])(data.id));
      }).catch(function () {
        return resolve();
      });
    });
  };
};

var handleCancel = function handleCancel() {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["b" /* navigateTo */])('tournament'));
  };
};

var setupTournamentComForm = function setupTournamentComForm() {
  return function (dispatch, getState) {
    var data = getState().tournament.base.tournamentInfo;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["initialize"])('tournamentCom', _extends({}, data)));
  };
};

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_TOURNAMENT_FOR_SETUP; });
var SET_TOURNAMENT_FOR_SETUP = 'SET_TOURNAMENT_FOR_SETUP';

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DISPLAY_DIVISION_IN_FORM_FOR_TOURNAMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_EVENT_SELECTED_FOR_TOURNAMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_VIRTUAL_EVENT_SELECTED_FOR_TOURNAMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DISPLAY_NEW_DIVISION_FOR_TOURNAMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CANCEL_DIVISION_FORM_FOR_TOURNAMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return HIGHTLIGHT_SELECTED_EVENT_FOR_TOURNAMENT_DIVISIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return HIGHLIGHT_SELECTED_VIRTUAL_EVENT_FOR_TOURNAMENT_DIVISIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DISPLAY_EVENTS_FOR_TOURNAMENT_DIVISIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DISPLAY_VIRTUAL_EVENTS_FOR_TOURNAMENT_DIVISIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DISPLAY_DIVISION_FOR_TOURNAMENT_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_DIVISION_DISPLAY_DEFAULT; });
var DISPLAY_DIVISION_IN_FORM_FOR_TOURNAMENT = 'DISPLAY_DIVISION_IN_FORM_FOR_TOURNAMENT';
var SET_EVENT_SELECTED_FOR_TOURNAMENT = 'SET_EVENT_SELECTED_FOR_TOURNAMENT';
var SET_VIRTUAL_EVENT_SELECTED_FOR_TOURNAMENT = 'SET_VIRTUAL_EVENT_SELECTED_FOR_TOURNAMENT';
var DISPLAY_NEW_DIVISION_FOR_TOURNAMENT = 'DISPLAY_NEW_DIVISION_FOR_TOURNAMENT';
var CANCEL_DIVISION_FORM_FOR_TOURNAMENT = 'CANCEL_DIVISION_FORM_FOR_TOURNAMENT';
var HIGHTLIGHT_SELECTED_EVENT_FOR_TOURNAMENT_DIVISIONS = 'HIGHTLIGHT_SELECTED_EVENT_FOR_TOURNAMENT_DIVISIONS';
var HIGHLIGHT_SELECTED_VIRTUAL_EVENT_FOR_TOURNAMENT_DIVISIONS = 'HIGHLIGHT_SELECTED_VIRTUAL_EVENT_FOR_TOURNAMENT_DIVISIONS';
var DISPLAY_EVENTS_FOR_TOURNAMENT_DIVISIONS = 'DISPLAY_EVENTS_FOR_TOURNAMENT_DIVISIONS';
var DISPLAY_VIRTUAL_EVENTS_FOR_TOURNAMENT_DIVISIONS = 'DISPLAY_VIRTUAL_EVENTS_FOR_TOURNAMENT_DIVISIONS';
var DISPLAY_DIVISION_FOR_TOURNAMENT_EVENT = 'DISPLAY_DIVISION_FOR_TOURNAMENT_EVENT';
var SET_DIVISION_DISPLAY_DEFAULT = 'SET_DIVISION_DISPLAY_DEFAULT';

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DISPLAY_VIRTUAL_EVENT_FORM_FOR_TOURNAMENT_SETUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CANCEL_VIRTUAL_EVENT_FORM_FOR_TOURNAMENT_SETUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DISPLAY_VIRTUAL_EVENTS_FOR_TOURNAMENT_SETUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DISPLAY_NEW_VIRTUAL_EVENT_FOR_TOURNAMENT_SETUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DISPLAY_NEW_BOWL_EVENT_FOR_TOURNAMENT_SETUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DISPLAY_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CANCEL_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DISPLAY_BOWL_EVENTS_FOR_TOURNAMENT_SETUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_AGE_OPTIONS_FOR_DIVISONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DISPLAY_VIRTUAL_EVENT_SCORING_METHOD_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DISPLAY_VIRTUAL_EVENT_OWNED_BY_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GET_VIRTUAL_EVENT_SCORING_METHODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return GET_VIRTUAL_EVENT_OWNED_BY_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DISPLAY_VIRTUAL_EVENT_AGE_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return GET_HANDICAP_APPLIED_TO_OPTIONS_FOR_VIRTUAL_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_AGE_VERIFICATION_EVENT_FOR_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return GET_AVAILABLE_LOCATION_OPTIONS_FOR_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return DELETE_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP; });
var DISPLAY_VIRTUAL_EVENT_FORM_FOR_TOURNAMENT_SETUP = 'DISPLAY_VIRTUAL_EVENT_FORM_FOR_TOURNAMENT_SETUP';
var CANCEL_VIRTUAL_EVENT_FORM_FOR_TOURNAMENT_SETUP = 'CANCEL_VIRTUAL_EVENT_FORM_FOR_TOURNAMENT_SETUP';
var DISPLAY_VIRTUAL_EVENTS_FOR_TOURNAMENT_SETUP = 'DISPLAY_VIRTUAL_EVENTS_FOR_TOURNAMENT_SETUP';
var DISPLAY_NEW_VIRTUAL_EVENT_FOR_TOURNAMENT_SETUP = 'DISPLAY_NEW_VIRTUAL_EVENT_FOR_TOURNAMENT_SETUP';
var DISPLAY_NEW_BOWL_EVENT_FOR_TOURNAMENT_SETUP = 'DISPLAY_NEW_BOWL_EVENT_FOR_TOURNAMENT_SETUP';
var DISPLAY_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP = 'DISPLAY_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP';
var CANCEL_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP = 'CANCEL_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP';
var DISPLAY_BOWL_EVENTS_FOR_TOURNAMENT_SETUP = 'DISPLAY_BOWL_EVENTS_FOR_TOURNAMENT_SETUP';
var SET_AGE_OPTIONS_FOR_DIVISONS = 'SET_AGE_OPTIONS_FOR_DIVISONS';
var DISPLAY_VIRTUAL_EVENT_SCORING_METHOD_OPTIONS = 'DISPLAY_VIRTUAL_EVENT_SCORING_METHOD_OPTIONS';
var DISPLAY_VIRTUAL_EVENT_OWNED_BY_OPTIONS = 'DISPLAY_VIRTUAL_EVENT_OWNED_BY_OPTIONS';
var GET_VIRTUAL_EVENT_SCORING_METHODS = 'GET_VIRTUAL_EVENT_SCORING_METHODS';
var GET_VIRTUAL_EVENT_OWNED_BY_OPTIONS = 'GET_VIRTUAL_EVENT_OWNED_BY_OPTIONS';
var DISPLAY_VIRTUAL_EVENT_AGE_OPTIONS = 'DISPLAY_VIRTUAL_EVENT_AGE_OPTIONS';
var GET_HANDICAP_APPLIED_TO_OPTIONS_FOR_VIRTUAL_EVENT = 'GET_HANDICAP_APPLIED_TO_OPTIONS_FOR_VIRTUAL_EVENT';
var SET_AGE_VERIFICATION_EVENT_FOR_EVENT = 'SET_AGE_VERIFICATION_EVENT_FOR_EVENT';
var GET_AVAILABLE_LOCATION_OPTIONS_FOR_EVENT = 'GET_AVAILABLE_LOCATION_OPTIONS_FOR_EVENT';
var DELETE_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP = 'DELETE_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP';

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FeeItem_jsx__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FeeItemFormContainer_jsx__ = __webpack_require__(1053);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FeeList = function FeeList(_ref) {
  var source = _ref.source,
      onFeeItemSwitchClick = _ref.onFeeItemSwitchClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group animated fadeIn' },
    source.map(function (item, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: index },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__FeeItem_jsx__["a" /* default */], _extends({}, item, {
          onSwitchClick: onFeeItemSwitchClick
        })),
        item.editing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FeeItemFormContainer_jsx__["a" /* default */], null) : null
      );
    })
  );
};

FeeList.propTypes = {
  source: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  onFeeItemSwitchClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = FeeList;

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEACTIVATE_PROCESS_END_FOR_SETUP_FEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEACTIVATE_PROCESS_START_FOR_SETUP_FEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CANCEL_DEACTIVATE_MODAL_FOR_SETUP_FEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DISPLAY_DEACTIVATE_MODAL_FOR_SETUP_FEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_EVENT_TYPES_IN_STATE_FOR_SETUP_FEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DISPLAY_NEW_FEE_FOR_SETUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CANCEL_FEE_FORM_FOR_SETUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DISPLAY_INACTIVE_FEES_FOR_SETUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DISPLAY_ACTIVE_FEES_FOR_SETUP; });
var DEACTIVATE_PROCESS_END_FOR_SETUP_FEES = 'DEACTIVATE_PROCESS_END_FOR_SETUP_FEES';
var DEACTIVATE_PROCESS_START_FOR_SETUP_FEES = 'DEACTIVATE_PROCESS_START_FOR_SETUP_FEES';
var CANCEL_DEACTIVATE_MODAL_FOR_SETUP_FEES = 'CANCEL_DEACTIVATE_MODAL_FOR_SETUP_FEES';
var DISPLAY_DEACTIVATE_MODAL_FOR_SETUP_FEES = 'DISPLAY_DEACTIVATE_MODAL_FOR_SETUP_FEES';
var SET_EVENT_TYPES_IN_STATE_FOR_SETUP_FEES = 'SET_EVENT_TYPES_IN_STATE_FOR_SETUP_FEES';
var DISPLAY_NEW_FEE_FOR_SETUP = 'DISPLAY_NEW_FEE_FOR_SETUP';
var CANCEL_FEE_FORM_FOR_SETUP = 'CANCEL_FEE_FORM_FOR_SETUP';
var DISPLAY_INACTIVE_FEES_FOR_SETUP = 'DISPLAY_INACTIVE_FEES_FOR_SETUP';
var DISPLAY_ACTIVE_FEES_FOR_SETUP = 'DISPLAY_ACTIVE_FEES_FOR_SETUP';

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LocationsPanelContainer_jsx__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TagPanelContainer_jsx__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_DisplayIf_jsx__ = __webpack_require__(12);











var required = function required(value) {
  return value ? undefined : 'Required';
};

var SetupForm = function SetupForm(_ref) {
  var error = _ref.error,
      pristine = _ref.pristine,
      submitLabel = _ref.submitLabel,
      submitting = _ref.submitting,
      timeZones = _ref.timeZones,
      themes = _ref.themes,
      cards = _ref.cards,
      readOnly = _ref.readOnly,
      handleSubmit = _ref.handleSubmit,
      onCancel = _ref.onCancel,
      onSubmit = _ref.onSubmit,
      exportOptions = _ref.exportOptions,
      stripeAccountOptions = _ref.stripeAccountOptions,
      canEditTournamentName = _ref.canEditTournamentName,
      statusDisplayName = _ref.statusDisplayName,
      groupName = _ref.groupName,
      isAllowed = _ref.isAllowed,
      permissions = _ref.permissions,
      onPartnerLoginClick = _ref.onPartnerLoginClick,
      onExitPartnerClick = _ref.onExitPartnerClick;

  var canMigratePartnersFromV2 = permissions.find(function (permission) {
    return permission === "CanMigratePartnersFromV2";
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'flex center animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'form',
      {
        className: 'col-xs-12 col-lg-8',
        onSubmit: handleSubmit(onSubmit) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel panel-primary' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'panel-heading' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'panel-title' },
            'General Information'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_shared_DisplayIf_jsx__["a" /* default */],
          { condition: isAllowed && canMigratePartnersFromV2 && groupName != undefined && groupName !== '' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-12' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alert alert-danger text-center' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-xs-3 text-left cursor-pointer', style: { fontSize: '10px', fontWeight: 'bold' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { onClick: onPartnerLoginClick, type: 'button' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-user' }),
                    ' Manage another Partner Hub'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-xs-6 text-center' },
                  'You are managing a tournament for ',
                  groupName
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-xs-3 text-right cursor-pointer', style: { fontSize: '10px', fontWeight: 'bold' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { onClick: onExitPartnerClick, type: 'button' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-sign-out' }),
                    ' Exit Partner Hub Mode'
                  )
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'panel-body' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            autoFocus: true,
            name: 'name',
            type: 'text',
            placeholder: 'Name',
            label: 'Tournament Name',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            tooltip: 'Use a descriptive name such as 2021 TX State Womens Championship, 2021 USBC Open Championships',
            tooltipPosition: 'top',
            disabled: readOnly || !canEditTournamentName,
            validate: [required]
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'startDate',
            type: 'date',
            todayHighlight: true,
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'Start Date',
            label: 'Start Date',
            disabled: readOnly,
            validate: [required]
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'endDate',
            type: 'date',
            todayHighlight: true,
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'End Date',
            label: 'End Date',
            disabled: readOnly,
            validate: [required]
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'registrationCloseDate',
            type: 'date',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'Registration Close Date',
            label: 'Registration Close Date',
            tooltip: 'Registration closes to the public at 12:00am on the date entered. Choose the day after your tournament registration closes',
            tooltipPosition: 'top',
            disabled: readOnly,
            validate: [required]
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'defaultAverage',
            type: 'number',
            step: '1',
            min: '0',
            max: '300',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'Default Average',
            label: 'Default Average',
            tooltip: 'Enter the average identified in tournament rules if bowler has no qualifying USBC average, i.e. bowling scratch',
            tooltipPosition: 'top',
            disabled: readOnly,
            validate: [required]
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'timeZone',
            component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__["a" /* default */],
            options: timeZones,
            placeholder: 'Time Zone',
            label: 'Time Zone',
            simpleValue: true,
            searchable: false,
            disabled: readOnly,
            validate: [required]
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'bccEmail',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'BCC email to copy all sent emails',
            label: 'BCC Email',
            tooltip: 'BCC will receive copies of all Registration emails sent to the Captain',
            tooltipPosition: 'top',
            maxLength: '250',
            disabled: readOnly,
            validate: [required]
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'sort',
            type: 'number',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'Display order on main registration page',
            label: 'Tournament Display Sort Order',
            tooltip: 'Identify the position you want the tournament card to display on the main screen. From left to right: 1st, 2nd, 3rd, etc.',
            tooltipPosition: 'top',
            disabled: readOnly
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'theme',
            component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__["a" /* default */],
            options: themes,
            placeholder: 'Blue',
            simpleValue: true,
            searchable: false,
            label: 'Theme Color',
            tooltip: 'Identify the color of the displayed tournament card',
            tooltipPosition: 'top',
            disabled: readOnly
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_shared_DisplayIf_jsx__["a" /* default */],
            { condition: groupName && window.GROUP_ENABLED === "true" ? false : false },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'cardId',
              component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__["a" /* default */],
              options: cards,
              placeholder: 'Available Images',
              simpleValue: true,
              searchable: false,
              label: 'Card Image',
              disabled: readOnly
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_shared_DisplayIf_jsx__["a" /* default */],
        { condition: isAllowed && groupName && window.GROUP_ENABLED === "true" ? true : false },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TagPanelContainer_jsx__["a" /* default */], null)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__LocationsPanelContainer_jsx__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel panel-default' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'panel-heading' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'panel-title' },
            'Primary Contact'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'panel-body' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'contactName',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'Tournament Contact Name',
            disabled: readOnly
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'contactPhone',
            type: 'tel',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'Phone',
            disabled: readOnly
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'tournamentPhone',
            type: 'tel',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'Tournament Phone',
            disabled: readOnly,
            tooltip: 'Phone Number Captains call with questions.',
            tooltipPosition: 'top'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'contactAddress',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'Address',
            disabled: readOnly
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'contactEmail',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'Email',
            disabled: readOnly
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'membershipId',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'Membership ID',
            disabled: readOnly
          }),
          error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'text-danger text-right' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              error
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_shared_DisplayIf_jsx__["a" /* default */],
        { condition: isAllowed && groupName && window.GROUP_ENABLED === "true" ? true : false },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'panel panel-default' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'panel-heading' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'panel-title' },
              'Stripe Account'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'panel-body' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'stripeAccountId',
              component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__["a" /* default */],
              options: stripeAccountOptions,
              placeholder: 'Stripe Account',
              label: 'Choose your Stripe account:',
              simpleValue: true,
              searchable: false,
              disabled: readOnly,
              validate: [required]
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel panel-default' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'panel-heading' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'panel-title' },
            'Tournament Management System'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'panel-body' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'exportId',
            component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__["a" /* default */],
            options: exportOptions,
            placeholder: 'Tournament Management System',
            label: 'Choose your tournament management system:',
            tooltip: 'Identify the system you will use to manage/run your tournament. Associations select WinLABS',
            tooltipPosition: 'top',
            simpleValue: true,
            searchable: false,
            disabled: readOnly || (statusDisplayName ? statusDisplayName !== 'Setup' : false),
            validate: [required]
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'form-group text-right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-link',
            disabled: submitting,
            onClick: onCancel
          },
          'Cancel'
        ),
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'submit',
            className: 'btn btn-primary btn-lg',
            disabled: pristine || submitting
          },
          submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
          ' ',
          submitLabel
        )
      )
    )
  );
};

SetupForm.propTypes = {
  cards: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  error: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  exportOptions: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  onCancel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  pristine: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired,
  readOnly: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  stripeAccountOptions: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  submitLabel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  submitting: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired,
  themes: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  timeZones: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  canEditTournamentName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  statusDisplayName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  isAllowed: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onPartnerLoginClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onExitPartnerClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'tournamentSetup',
  onSubmitFail: function onSubmitFail(errors) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions__["o" /* default */])(errors);
  }
})(SetupForm);

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DISPLAY_CENTER_SAVE_BUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DISPLAY_CENTERS_DROPDOWN_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DISPLAY_THEMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DISPLAY_TIME_ZONES; });
/* unused harmony export SET_CAN_ADD_TAG */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_CAN_ASSIGN_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_CAN_DELETE_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_CARDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_CARD_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_IS_ADDING_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_IS_NEW_TOURNAMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_LOCATION_CERTIFICATION_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_STRIPE_ACCOUNT_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_STRIPE_ACCOUNTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SET_TAG_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SET_AVAILABLE_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_TOURNAMENT_EXPORT_OPTIONS_IN_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_TOURNAMENT_EXPORT_SELECTION_IN_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SET_TOURNAMENT_LOCATION_EDITING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_TOURNAMENT_LOCATION_NAME_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SET_TOURNAMENT_LOCATION_SEARCH_RESULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_TOURNAMENT_LOCATIONS_IN_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SET_TOURNAMENT_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SET_IS_SUPER_USER; });
var DISPLAY_CENTER_SAVE_BUTTON = "DISPLAY_CENTER_SAVE_BUTTON";
var DISPLAY_CENTERS_DROPDOWN_LIST = "DISPLAY_CENTERS_DROPDOWN_LIST";
var DISPLAY_THEMES = "DISPLAY_THEMES";
var DISPLAY_TIME_ZONES = "DISPLAY_TIME_ZONES";
var SET_CAN_ADD_TAG = "SET_CAN_ADD_TAG";
var SET_CAN_ASSIGN_TAG = "SET_CAN_ASSIGN_TAG";
var SET_CAN_DELETE_TAG = "SET_CAN_DELETE_TAG";
var SET_CARDS = "SET_CARDS";
var SET_CARD_SELECTION = 'SET_CARD_SELECTION';
var SET_IS_ADDING_TAG = "SET_IS_ADDING_TAG";
var SET_IS_NEW_TOURNAMENT = "SET_IS_NEW_TOURNAMENT";
var SET_LOCATION_CERTIFICATION_NUMBER = "SET_LOCATION_CERTIFICATION_NUMBER";
var SET_STRIPE_ACCOUNT_SELECTION = 'SET_STRIPE_ACCOUNT_SELECTION';
var SET_STRIPE_ACCOUNTS = 'SET_STRIPE_ACCOUNTS';
var SET_TAG_INDEX = "SET_TAG_INDEX";
var SET_AVAILABLE_TAGS = "SET_AVAILABLE_TAGS";
var SET_TOURNAMENT_EXPORT_OPTIONS_IN_STATE = "SET_TOURNAMENT_EXPORT_OPTIONS_IN_STATE";
var SET_TOURNAMENT_EXPORT_SELECTION_IN_STATE = "SET_TOURNAMENT_EXPORT_SELECTION_IN_STATE";
var SET_TOURNAMENT_LOCATION_EDITING = "SET_TOURNAMENT_LOCATION_EDITING";
var SET_TOURNAMENT_LOCATION_NAME_VALUE = "SET_TOURNAMENT_LOCATION_NAME_VALUE";
var SET_TOURNAMENT_LOCATION_SEARCH_RESULTS = "SET_TOURNAMENT_LOCATION_SEARCH_RESULTS";
var SET_TOURNAMENT_LOCATIONS_IN_STATE = "SET_TOURNAMENT_LOCATIONS_IN_STATE";
var SET_TOURNAMENT_TAGS = "SET_TOURNAMENT_TAGS";
var SET_IS_SUPER_USER = "SET_IS_SUPER_USER";

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(54);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return retrieveRestriction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return validate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return handleCancel; });





var retrieveRestriction = function retrieveRestriction(tournamentId) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["d" /* getJsonAsync */])('setup/tournament/' + tournamentId + '/restriction')).then(function (data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["initialize"])('tournamentRestrictions', data));
    });
  };
};

var validate = function validate(data) {
  var errors = {};

  if (data.enforceMinimumCaptainAge && !data.minimumCaptainAge) {
    errors.minimumCaptainAge = 'Minimum Captain Age is required if "Enforce a minimum captain age" is checked.';
  }

  return errors;
};

var handleSave = function handleSave(data) {
  return function (dispatch, getState) {
    return new Promise(function (resolve) {
      var tournamentState = getState().tournament,
          tournamentId = tournamentState.base.tournamentInfo.id;

      var promise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["g" /* putJsonAsync */])('setup/tournament/' + tournamentId + '/restriction', data);

      dispatch(promise).then(function () {
        __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success('Saved!', 'Restrictions saved successfully.');
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["n" /* loadTournament */])(tournamentId));
        resolve();
      }).catch(function () {
        return resolve();
      });
    });
  };
};

var handleCancel = function handleCancel() {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_actions__["b" /* navigateTo */])('tournament'));
  };
};

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEACTIVATE_PROCESS_END_FOR_BUNDLING_RULES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEACTIVATE_PROCESS_START_FOR_BUNDLING_RULES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CANCEL_DEACTIVATE_MODAL_FOR_BUNDLING_RULES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DISPLAY_DEACTIVATE_MODAL_FOR_BUNDLING_RULES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_EVENT_TYPES_IN_STATE_FOR_BUNDLING_RULES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DISPLAY_NEW_BUNDLING_RULE_FOR_BUNDLING_RULES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DISPLAY_ACTIVE_RULES_FOR_BUNDLING_RULES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CANCEL_BUNDLING_RULE_FORM_FOR_BUNDLING_RULES; });
var DEACTIVATE_PROCESS_END_FOR_BUNDLING_RULES = 'DEACTIVATE_PROCESS_END_FOR_BUNDLING_RULES,';
var DEACTIVATE_PROCESS_START_FOR_BUNDLING_RULES = 'DEACTIVATE_PROCESS_START_FOR_BUNDLING_RULES';
var CANCEL_DEACTIVATE_MODAL_FOR_BUNDLING_RULES = 'CANCEL_DEACTIVATE_MODAL_FOR_BUNDLING_RULES';
var DISPLAY_DEACTIVATE_MODAL_FOR_BUNDLING_RULES = 'DISPLAY_DEACTIVATE_MODAL_FOR_BUNDLING_RULES';
var SET_EVENT_TYPES_IN_STATE_FOR_BUNDLING_RULES = 'SET_EVENT_TYPES_IN_STATE_FOR_BUNDLING_RULES';
var DISPLAY_NEW_BUNDLING_RULE_FOR_BUNDLING_RULES = 'DISPLAY_NEW_BUNDLING_RULE_FOR_BUNDLING_RULES';
var DISPLAY_ACTIVE_RULES_FOR_BUNDLING_RULES = 'DISPLAY_ACTIVE_RULES_FOR_BUNDLING_RULES';
var CANCEL_BUNDLING_RULE_FORM_FOR_BUNDLING_RULES = 'CANCEL_BUNDLING_RULE_FORM_FOR_BUNDLING_RULES';

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_TOURNAMENT_STATUS_FOR_TOURNAMENT_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_TOURNAMENT_HAS_PENDING_CHANGES_FOR_TOURNAMENT_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_AVAILABLE_STATUSES_FOR_TOURNAMENT_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PUBLISH_STARTS_FOR_TOURNAMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PUBLISH_ENDS_FOR_TOURNAMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CANCEL_CONFIRM_MODAL_FOR_STATUS_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DISPLAY_CONFIRM_MODAL_FOR_STATUS_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_EXPORT_SYSTEM_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LOADING_STARTS_FOR_TOURNAMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LOADING_ENDS_FOR_TOURNAMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_EXPORT_STATUS; });
var SET_TOURNAMENT_STATUS_FOR_TOURNAMENT_STATUS = 'SET_TOURNAMENT_STATUS_FOR_TOURNAMENT_STATUS';
var SET_TOURNAMENT_HAS_PENDING_CHANGES_FOR_TOURNAMENT_STATUS = 'SET_TOURNAMENT_HAS_PENDING_CHANGES_FOR_TOURNAMENT_STATUS';
var SET_AVAILABLE_STATUSES_FOR_TOURNAMENT_STATUS = 'SET_AVAILABLE_STATUSES_FOR_TOURNAMENT_STATUS';
var PUBLISH_STARTS_FOR_TOURNAMENT = 'PUBLISH_STARTS_FOR_TOURNAMENT';
var PUBLISH_ENDS_FOR_TOURNAMENT = 'PUBLISH_ENDS_FOR_TOURNAMENT';
var CANCEL_CONFIRM_MODAL_FOR_STATUS_CHANGE = 'CANCEL_CONFIRM_MODAL_FOR_STATUS_CHANGE';
var DISPLAY_CONFIRM_MODAL_FOR_STATUS_CHANGE = 'DISPLAY_CONFIRM_MODAL_FOR_STATUS_CHANGE';
var SET_EXPORT_SYSTEM_INFO = 'SET_EXPORT_SYSTEM_INFO';
var LOADING_STARTS_FOR_TOURNAMENT = 'LOADING_STARTS_FOR_TOURNAMENT';
var LOADING_ENDS_FOR_TOURNAMENT = 'LOADING_ENDS_FOR_TOURNAMENT';
var SET_EXPORT_STATUS = 'SET_EXPORT_STATUS';

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(475);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return displayTournaments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setSearchTournamentValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return startLoadingTournaments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateShowAllTournaments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setCanCreateTournaments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return displayGroupName; });


var displayTournaments = function displayTournaments(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_TOURNAMENTS */],
    payload: { entries: data }
  };
};

var setSearchTournamentValue = function setSearchTournamentValue(searchValue) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_SEARCH_TOURNAMENT_VALUE_FOR_TOURNAMENTS */],
    payload: { searchValue: searchValue }
  };
};

var startLoadingTournaments = function startLoadingTournaments() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* START_LOADING_TOURNAMENTS */],
    payload: {}
  };
};

var updateShowAllTournaments = function updateShowAllTournaments(showAllTournaments) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* UPDATE_SHOW_ALL_TOURNAMENTS */],
    payload: showAllTournaments
  };
};

var setCanCreateTournaments = function setCanCreateTournaments(canCreateTournaments) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* SET_CAN_CREATE_TOURNAMENTS */],
    payload: canCreateTournaments
  };
};

var displayGroupName = function displayGroupName(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* DISPLAY_GROUP_NAME */],
    payload: data
  };
};

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DISPLAY_TOURNAMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_SEARCH_TOURNAMENT_VALUE_FOR_TOURNAMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return START_LOADING_TOURNAMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_SHOW_ALL_TOURNAMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_CAN_CREATE_TOURNAMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DISPLAY_GROUP_NAME; });
var DISPLAY_TOURNAMENTS = 'DISPLAY_TOURNAMENTS';
var SET_SEARCH_TOURNAMENT_VALUE_FOR_TOURNAMENTS = 'SET_SEARCH_TOURNAMENT_VALUE_FOR_TOURNAMENTS';
var START_LOADING_TOURNAMENTS = 'START_LOADING_TOURNAMENTS';
var UPDATE_SHOW_ALL_TOURNAMENTS = 'UPDATE_SHOW_ALL_TOURNAMENTS';
var SET_CAN_CREATE_TOURNAMENTS = 'SET_CAN_CREATE_TOURNAMENTS';
var DISPLAY_GROUP_NAME = 'DISPLAY_GROUP_NAME';

/***/ }),
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scss_common_scss__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scss_common_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__scss_common_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__favicon_ico__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__favicon_ico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__favicon_ico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_350x200_Pinstar_Thmnl_jpg__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_350x200_Pinstar_Thmnl_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__img_350x200_Pinstar_Thmnl_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_bowler_png__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_bowler_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__img_bowler_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_usbc_banner_png__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_usbc_banner_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__img_usbc_banner_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_lib_Router__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_lib_Router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_router_lib_Router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router_lib_browserHistory__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router_lib_browserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_router_lib_browserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router_redux__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__routes__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_ga__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_ga__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_variables__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_facebook_pixel__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_facebook_pixel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_facebook_pixel__);
/* eslint-disable import/default */





















//Unique Google Analytics tracking number
__WEBPACK_IMPORTED_MODULE_16_react_ga___default.a.initialize(__WEBPACK_IMPORTED_MODULE_17_shared_variables__["a" /* GOOGLE_ANALYTICS_TRACKING_ID */]);

// Create an enhanced history that syncs navigation events with the store
var history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_react_router_redux__["syncHistoryWithStore"])(__WEBPACK_IMPORTED_MODULE_11_react_router_lib_browserHistory___default.a, __WEBPACK_IMPORTED_MODULE_14__store___default.a);

__WEBPACK_IMPORTED_MODULE_18_react_facebook_pixel___default.a.init(__WEBPACK_IMPORTED_MODULE_17_shared_variables__["b" /* FACEBOOK_PIXEL_ID */]);

__WEBPACK_IMPORTED_MODULE_18_react_facebook_pixel___default.a.pageView(); // For tracking page view

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_9_react_redux__["Provider"],
  { store: __WEBPACK_IMPORTED_MODULE_14__store___default.a },
  __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_lib_Router___default.a, {
    history: history,
    routes: __WEBPACK_IMPORTED_MODULE_13__routes__["a" /* default */],
    onUpdate: function onUpdate() {
      return __WEBPACK_IMPORTED_MODULE_14__store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_shared_actions__["a" /* handleRouterUpdate */])());
    }
  })
), document.getElementById('app'));

/***/ }),
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_variables__ = __webpack_require__(38);



var About = function About() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      __WEBPACK_IMPORTED_MODULE_1_shared_variables__["g" /* APP_VERSION */]
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = About;

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__About_jsx__ = __webpack_require__(686);






var routes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, {
    path: 'about',
    component: __WEBPACK_IMPORTED_MODULE_4__About_jsx__["a" /* default */],
    onEnter: function onEnter() {
      __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["b" /* setTitle */])('About'));
    }
  })
);

/* harmony default export */ __webpack_exports__["a"] = routes;

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_Link_jsx__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tournamentAudit_AuditSearchTournamentListContainer_jsx__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__captainAudit_AuditSearchCaptainListContainer_jsx__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__entryAudit_AuditSearchEntryListContainer_jsx__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__virtualEntryAudit_AuditSearchVirtualEntryListContainer_jsx__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__bowlerAudit_AuditSearchBowlerListContainer_jsx__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(265);











var AuditHome = function AuditHome(_ref) {
  var actions = _ref.actions,
      selectedAction = _ref.selectedAction,
      onSelectAuditTab = _ref.onSelectAuditTab;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-sm-3 col-lg-2' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'left-navigation-bar' },
          actions.map(function (action, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                key: index },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_shared_Link_jsx__["a" /* default */],
                {
                  to: action.to,
                  className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("btn", { "btn-default": !action.active }, { "btn-primary": action.active }),
                  onClick: function onClick() {
                    return onSelectAuditTab(action);
                  } },
                action.label
              )
            );
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-sm-9 col-lg-10' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
          { condition: selectedAction.label == __WEBPACK_IMPORTED_MODULE_9__constants__["c" /* ADMIN_AUDIT_TAB_TOURNAMENTS_LABEL */],
            className: 'animated fadeIn' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__tournamentAudit_AuditSearchTournamentListContainer_jsx__["a" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
          { condition: selectedAction.label == __WEBPACK_IMPORTED_MODULE_9__constants__["d" /* ADMIN_AUDIT_TAB_CAPTAINS_LABEL */],
            className: 'animated fadeIn' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__captainAudit_AuditSearchCaptainListContainer_jsx__["a" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
          { condition: selectedAction.label == __WEBPACK_IMPORTED_MODULE_9__constants__["e" /* ADMIN_AUDIT_TAB_TEAMS_LABEL */],
            className: 'animated fadeIn' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__entryAudit_AuditSearchEntryListContainer_jsx__["a" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
          { condition: selectedAction.label == __WEBPACK_IMPORTED_MODULE_9__constants__["f" /* ADMIN_AUDIT_TAB_VIRTUAL_ENTRIES_LABEL */],
            className: 'animated fadeIn' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__virtualEntryAudit_AuditSearchVirtualEntryListContainer_jsx__["a" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
          { condition: selectedAction.label == __WEBPACK_IMPORTED_MODULE_9__constants__["g" /* ADMIN_AUDIT_TAB_BOWLERS_LABEL */],
            className: 'animated fadeIn' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__bowlerAudit_AuditSearchBowlerListContainer_jsx__["a" /* default */], null)
        )
      )
    )
  );
};

AuditHome.defaultProps = {};

AuditHome.propTypes = {
  actions: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  selectedAction: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  onSelectAuditTab: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = AuditHome;

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditHome_jsx__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(409);




var mapStateToProps = function mapStateToProps(state) {
  return {
    actions: state.admin.audit.auditActions,
    selectedAction: state.admin.audit.auditActions.find(function (a) {
      return a.active;
    })
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSelectAuditTab: function onSelectAuditTab(auditTab) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["b" /* selectAuditTab */])(auditTab));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditHome_jsx__["a" /* default */]);

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResultsNotFound_jsx__ = __webpack_require__(46);




var AuditBowlerDetail = function AuditBowlerDetail(_ref) {
  var changeDate = _ref.changeDate,
      userEmail = _ref.userEmail,
      audits = _ref.audits;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'panel panel-primary' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-heading' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'alert alert-info text-center' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-6' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'col-xs-12' },
              'Audit Date'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                changeDate ? '' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(changeDate).format('MMM Do, YYYY, hh:mm:ss A') : '-'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-6' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'col-xs-12' },
              'User Email'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                userEmail
              )
            )
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-body' },
      audits && audits.length == 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ResultsNotFound_jsx__["a" /* default */], null) : null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group' },
        audits ? audits.map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'list-group-item-labeled',
              key: index },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child',
                style: { width: 250 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Message'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '' + item.message
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child',
                style: { width: 100 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Type'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                item.typeName
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child',
                style: { width: 100 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Property'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                item.propertyName
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child',
                style: { width: 150 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Original'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                item.originalValue
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child',
                style: { width: 150 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Current Value'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                item.currentValue
              )
            )
          );
        }) : null
      )
    )
  );
};

AuditBowlerDetail.propTypes = {
  changeDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  userEmail: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  audits: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

AuditBowlerDetail.defaultProps = {};

/* harmony default export */ __webpack_exports__["a"] = AuditBowlerDetail;

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditBowlerDetail_jsx__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(130);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var mapStateToProps = function mapStateToProps(props) {
  return _extends({}, props);
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditBowlerDetail_jsx__["a" /* default */]);

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResultsNotFound_jsx__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AuditBowlerDetailContainer_jsx__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AuditBowlerHeaderContainer_jsx__ = __webpack_require__(695);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var AuditBowlerDetailList = function AuditBowlerDetailList(_ref) {
  var list = _ref.list,
      headerBowler = _ref.headerBowler;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-heading row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'panel-title' },
            'Bowler'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-body' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'list-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AuditBowlerHeaderContainer_jsx__["a" /* default */], headerBowler)
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-heading row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'panel-title' },
            'Bowler History'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-body' },
        list && list.length == 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ResultsNotFound_jsx__["a" /* default */], null) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'list-group' },
          list ? list.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AuditBowlerDetailContainer_jsx__["a" /* default */], _extends({ key: index
            }, item, {
              showLink: true }));
          }) : null
        )
      )
    )
  );
};

AuditBowlerDetailList.defaultProps = {};

AuditBowlerDetailList.propTypes = {
  list: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  headerBowler: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};

/* harmony default export */ __webpack_exports__["a"] = AuditBowlerDetailList;

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditBowlerDetailList_jsx__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(263);





var mapStateToProps = function mapStateToProps(state) {
  return {
    headerBowler: state.admin.bowlerAudit.headerBowler,
    list: state.admin.bowlerAudit.auditDetails
  };
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditBowlerDetailList_jsx__["a" /* default */]);

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var AuditBowlerHeader = function AuditBowlerHeader(_ref) {
  var bowlerNationalId = _ref.bowlerNationalId,
      bowlerName = _ref.bowlerName,
      email = _ref.email,
      gender = _ref.gender,
      tournamentName = _ref.tournamentName;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "list-group-item-labeled" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "list-group-item-labeled-child",
        style: { width: 200 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        'National ID'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        bowlerNationalId ? "" + bowlerNationalId : 'Loading...'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "list-group-item-labeled-child",
        style: { width: 120 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        'Name'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        bowlerName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "list-group-item-labeled-child",
        style: { width: 300 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        'Email'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        email
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "list-group-item-labeled-child",
        style: { width: 100 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        'Gender'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        gender
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "list-group-item-labeled-child",
        style: { width: 250 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        'Tournament'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        tournamentName
      )
    )
  );
};

AuditBowlerHeader.propTypes = {
  tournamentName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  bowlerNationalId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  bowlerName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  email: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  gender: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

AuditBowlerHeader.defaultProps = {};

/* harmony default export */ __webpack_exports__["a"] = AuditBowlerHeader;

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditBowlerHeader_jsx__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(130);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var mapStateToProps = function mapStateToProps(props) {
  return _extends({}, props);
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditBowlerHeader_jsx__["a" /* default */]);

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var AuditSearchBowler = function AuditSearchBowler(_ref) {
  var bowlerId = _ref.bowlerId,
      bowlerNationalId = _ref.bowlerNationalId,
      bowlerName = _ref.bowlerName,
      tournamentName = _ref.tournamentName,
      teamName = _ref.teamName,
      captainName = _ref.captainName,
      coordinatorName = _ref.coordinatorName,
      onNavigationClick = _ref.onNavigationClick;

  if (teamName && teamName.length > 0) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "list-group-item-labeled" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "list-group-item-labeled-child",
        style: { width: 200 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        'Tournament'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        "" + tournamentName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "list-group-item-labeled-child",
        style: { width: 150 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        'Name'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        "" + bowlerName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "a",
      { className: "list-group-item-labeled-child has-link",
        style: { width: 80 },
        onClick: function onClick() {
          return onNavigationClick("admin/audit/bowler/" + bowlerId);
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        'National Id'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        bowlerNationalId
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "list-group-item-labeled-child",
        style: { width: 325 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        'Teams'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        teamName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "list-group-item-labeled-child",
        style: { width: 250 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        'Captains'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        captainName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "list-group-item-labeled-child",
        style: { width: 210 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        coordinatorName && coordinatorName.trim().length > 0 ? 'Coordinators' : 'No coordinator'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        coordinatorName
      )
    )
  );

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "list-group-item-labeled" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "list-group-item-labeled-child",
        style: { width: 200 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        'Tournament'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        "" + tournamentName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "list-group-item-labeled-child",
        style: { width: 200 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        'Name'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        "" + bowlerName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "a",
      { className: "list-group-item-labeled-child has-link",
        style: { width: 80 },
        onClick: function onClick() {
          return onNavigationClick("admin/audit/bowler/" + bowlerId);
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        'National Id'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        bowlerNationalId
      )
    )
  );
};

AuditSearchBowler.propTypes = {
  addressBase: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  bowlerId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  bowlerNationalId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  bowlerName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  teamName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  entryNumber: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  entryId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  tournamentId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  tournamentName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  captainName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  coordinatorName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onNavigationClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

AuditSearchBowler.defaultProps = {};

/* harmony default export */ __webpack_exports__["a"] = AuditSearchBowler;

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditSearchBowler_jsx__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var mapStateToProps = function mapStateToProps(props) {
  return _extends({}, props);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onNavigationClick: function onNavigationClick(route) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["b" /* navigateTo */])(route));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditSearchBowler_jsx__["a" /* default */]);

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResultsLimited_jsx__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResultsNotFound_jsx__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AuditSearchBowlerContainer_jsx__ = __webpack_require__(697);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var AuditSearchBowlerList = function AuditSearchBowlerList(_ref) {
  var searchValue = _ref.searchValue,
      onSearchEnterKeyPress = _ref.onSearchEnterKeyPress,
      onSearchClick = _ref.onSearchClick,
      onSearchValueChange = _ref.onSearchValueChange,
      list = _ref.list,
      exceededResultLimit = _ref.exceededResultLimit;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-heading row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'panel-title' },
            'Search Bowler History'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-body' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'animated fadeIn flex wrap' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'row col-xs-12' },
            'You can search for entries by bowler name, or national ID.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('input-group input-group-md'), style: { padding: "0px 0px 16px 0px", minWidth: "360px" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text',
              autoFocus: true,
              placeholder: 'Type your search here...',
              className: 'form-control',
              value: searchValue,
              onChange: function onChange(event) {
                return onSearchValueChange(event.target.value);
              },
              onKeyDown: onSearchEnterKeyPress
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'input-group-btn' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'btn btn-primary',
                  type: 'button',
                  onClick: onSearchClick,
                  disabled: !searchValue || searchValue.trim().length < 3 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-search' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            { className: 'row col-xs-12' },
            'A minimum of three characters are required.'
          )
        ),
        exceededResultLimit ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ResultsLimited_jsx__["a" /* default */], null) : null,
        list && list.length == 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ResultsNotFound_jsx__["a" /* default */], null) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'list-group' },
          list ? list.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__AuditSearchBowlerContainer_jsx__["a" /* default */], _extends({ key: index
            }, item));
          }) : null
        )
      )
    )
  );
};

AuditSearchBowlerList.defaultProps = {
  searchValue: '',
  exceededResultLimit: false
};

AuditSearchBowlerList.propTypes = {
  onSearchClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSearchEnterKeyPress: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSearchValueChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  searchValue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  exceededResultLimit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  list: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

/* harmony default export */ __webpack_exports__["a"] = AuditSearchBowlerList;

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditSearchBowlerList_jsx__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(263);





var mapStateToProps = function mapStateToProps(state) {
  return {
    searchValue: state.admin.bowlerAudit.searchBowlerAuditValue,
    exceededResultLimit: state.admin.bowlerAudit.searchExceededResultLimit,
    list: state.admin.bowlerAudit.searchBowlers
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSearchEnterKeyPress: function onSearchEnterKeyPress(event) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* handleBowlerSearchEnterKeyPress */])(event));
    },
    onSearchClick: function onSearchClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* handleBowlerSearch */])());
    },
    onSearchValueChange: function onSearchValueChange(searchValue) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["d" /* setSearchBowlerValue */])(searchValue));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditSearchBowlerList_jsx__["a" /* default */]);

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(410);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  searchBowlerAuditValue: '',
  headerBowler: {
    bowlerId: null,
    bowlerName: '',
    tournamentId: null,
    tournamentName: '',
    eventName: '',
    entryNumber: '',
    teamName: '',
    captainName: '',
    coordinatorName: ''
  },

  auditDetails: null,
  searchBowlers: null,
  searchExceededResultLimit: false
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_ADMIN_AUDIT_SEARCH_BOWLER_VALUE */]:
      return _extends({}, state, {
        searchBowlerAuditValue: payload
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_ADMIN_AUDIT_SEARCH_BOWLERS */]:
      return _extends({}, state, {
        searchBowlers: payload.list,
        searchExceededResultLimit: payload.exceededSearchLimit
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_ADMIN_AUDIT_BOWLER_HEADER */]:
      {
        var bowler = initialState.headerBowler;

        if (payload && payload.bowler) {
          bowler = payload.bowler;
        }

        return _extends({}, state, {
          headerBowler: bowler
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_ADMIN_AUDIT_BOWLER_DETAILS */]:
      {
        var auditDetails = initialState.auditDetails;

        if (payload && payload.list) {
          auditDetails = payload.list;
        }

        return _extends({}, state, {
          auditDetails: auditDetails
        });
      }

    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResultsNotFound_jsx__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__teamLedger_AuditTeamLedgerDetailContainer_jsx__ = __webpack_require__(266);





var AuditCaptainDetail = function AuditCaptainDetail(_ref) {
  var changeDate = _ref.changeDate,
      userEmail = _ref.userEmail,
      audits = _ref.audits,
      teamLedgerAudits = _ref.teamLedgerAudits;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'panel panel-primary' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-heading' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'alert alert-info text-center' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-6' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'col-xs-12' },
              'Audit Date'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                changeDate ? '' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(changeDate).format('MMM Do, YYYY, hh:mm:ss A') : '-'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-6' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'col-xs-12' },
              'User Email'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                userEmail
              )
            )
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-body' },
      audits && audits.length == 0 && teamLedgerAudits && teamLedgerAudits.length == 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ResultsNotFound_jsx__["a" /* default */], null) : null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group' },
        audits ? audits.map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'list-group-item-labeled',
              key: index },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child',
                style: { width: 250 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Message'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '' + item.message
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child',
                style: { width: 100 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Type'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                item.typeName
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child',
                style: { width: 100 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Property'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                item.propertyName
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child',
                style: { width: 150 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Original'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                item.originalValue
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child',
                style: { width: 150 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Current Value'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                item.currentValue
              )
            )
          );
        }) : null
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__teamLedger_AuditTeamLedgerDetailContainer_jsx__["a" /* default */], { details: teamLedgerAudits })
    )
  );
};

AuditCaptainDetail.propTypes = {
  changeDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  userEmail: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  audits: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  teamLedgerAudits: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

AuditCaptainDetail.defaultProps = {};

/* harmony default export */ __webpack_exports__["a"] = AuditCaptainDetail;

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditCaptainDetail_jsx__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(131);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var mapStateToProps = function mapStateToProps(props) {
  return _extends({}, props);
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditCaptainDetail_jsx__["a" /* default */]);

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResultsNotFound_jsx__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AuditCaptainDetailContainer_jsx__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AuditCaptainHeaderContainer_jsx__ = __webpack_require__(706);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var AuditCaptainDetailList = function AuditCaptainDetailList(_ref) {
  var list = _ref.list,
      headerCaptain = _ref.headerCaptain;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-heading row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'panel-title' },
            'Captain'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-body' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'list-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AuditCaptainHeaderContainer_jsx__["a" /* default */], headerCaptain)
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-heading row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'panel-title' },
            'Captain History'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-body' },
        list && list.length == 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ResultsNotFound_jsx__["a" /* default */], null) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'list-group' },
          list ? list.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AuditCaptainDetailContainer_jsx__["a" /* default */], _extends({ key: index
            }, item));
          }) : null
        )
      )
    )
  );
};

AuditCaptainDetailList.defaultProps = {};

AuditCaptainDetailList.propTypes = {
  list: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  headerCaptain: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};

/* harmony default export */ __webpack_exports__["a"] = AuditCaptainDetailList;

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditCaptainDetailList_jsx__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(264);





var mapStateToProps = function mapStateToProps(state) {
  return {
    headerCaptain: state.admin.captainAudit.headerCaptain,
    list: state.admin.captainAudit.auditDetails
  };
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditCaptainDetailList_jsx__["a" /* default */]);

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



var AuditCaptainHeader = function AuditCaptainHeader(_ref) {
  var captainName = _ref.captainName,
      captainEmail = _ref.captainEmail,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      tournamentName = _ref.tournamentName;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group-item-labeled' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 250 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Captain'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        captainName
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        captainEmail
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 250 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Tournament Name'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        tournamentName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 120 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Start'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        startDate ? '' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(startDate).format('MMM Do, YYYY') : '-'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 120 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'End'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        endDate ? '' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(endDate).format('MMM Do, YYYY') : '-'
      )
    )
  );
};

AuditCaptainHeader.propTypes = {
  captainName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  captainEmail: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  startDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  endDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  tournamentName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

AuditCaptainHeader.defaultProps = {};

/* harmony default export */ __webpack_exports__["a"] = AuditCaptainHeader;

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditCaptainHeader_jsx__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(131);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var mapStateToProps = function mapStateToProps(props) {
  return _extends({}, props);
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditCaptainHeader_jsx__["a" /* default */]);

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



var AuditSearchCaptain = function AuditSearchCaptain(_ref) {
  var captainId = _ref.captainId,
      captainName = _ref.captainName,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      tournamentId = _ref.tournamentId,
      tournamentName = _ref.tournamentName,
      captainEmail = _ref.captainEmail,
      onNavigationClick = _ref.onNavigationClick;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group-item-labeled' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      { className: 'list-group-item-labeled-child has-link',
        style: { width: 200 },
        onClick: function onClick() {
          return onNavigationClick('admin/audit/captain/' + captainId + '/' + tournamentId);
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Captain'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        captainName
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        captainEmail
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 250 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Tournament Name'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        tournamentName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 120 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Start'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        startDate ? '' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(startDate).format('MMM Do, YYYY') : '-'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 120 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'End'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        endDate ? '' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(endDate).format('MMM Do, YYYY') : '-'
      )
    )
  );
};

AuditSearchCaptain.propTypes = {
  addressBase: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  captainId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  captainName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  startDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  endDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  tournamentId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  tournamentName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  captainEmail: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onNavigationClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

AuditSearchCaptain.defaultProps = {};

/* harmony default export */ __webpack_exports__["a"] = AuditSearchCaptain;

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditSearchCaptain_jsx__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var mapStateToProps = function mapStateToProps(props) {
  return _extends({}, props);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onNavigationClick: function onNavigationClick(route) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["b" /* navigateTo */])(route));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditSearchCaptain_jsx__["a" /* default */]);

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResultsLimited_jsx__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResultsNotFound_jsx__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AuditSearchCaptainContainer_jsx__ = __webpack_require__(708);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var AuditSearchCaptainList = function AuditSearchCaptainList(_ref) {
  var searchValue = _ref.searchValue,
      onSearchEnterKeyPress = _ref.onSearchEnterKeyPress,
      onSearchClick = _ref.onSearchClick,
      onSearchValueChange = _ref.onSearchValueChange,
      list = _ref.list,
      exceededResultLimit = _ref.exceededResultLimit;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-heading row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'panel-title' },
            'Search Captain History'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-body' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'animated fadeIn flex wrap' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'row col-xs-12' },
            'You can search for captains by their name or email.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('input-group input-group-md'), style: { padding: "0px 0px 16px 0px", minWidth: "360px" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text',
              autoFocus: true,
              placeholder: 'Type your search here...',
              className: 'form-control',
              value: searchValue,
              onChange: function onChange(event) {
                return onSearchValueChange(event.target.value);
              },
              onKeyDown: onSearchEnterKeyPress
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'input-group-btn' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'btn btn-primary',
                  type: 'button',
                  onClick: onSearchClick,
                  disabled: !searchValue || searchValue.trim().length < 3 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-search' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            { className: 'row col-xs-12' },
            'A minimum of three characters are required.'
          )
        ),
        exceededResultLimit ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ResultsLimited_jsx__["a" /* default */], null) : null,
        list && list.length == 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ResultsNotFound_jsx__["a" /* default */], null) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'list-group' },
          list ? list.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__AuditSearchCaptainContainer_jsx__["a" /* default */], _extends({ key: index
            }, item));
          }) : null
        )
      )
    )
  );
};

AuditSearchCaptainList.defaultProps = {
  searchValue: '',
  exceededResultLimit: false
};

AuditSearchCaptainList.propTypes = {
  onSearchClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSearchEnterKeyPress: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSearchValueChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  searchValue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  exceededResultLimit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  list: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

/* harmony default export */ __webpack_exports__["a"] = AuditSearchCaptainList;

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditSearchCaptainList_jsx__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(264);





var mapStateToProps = function mapStateToProps(state) {
  return {
    searchValue: state.admin.captainAudit.searchCaptainAuditValue,
    exceededResultLimit: state.admin.captainAudit.searchExceededResultLimit,
    list: state.admin.captainAudit.searchCaptains
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSearchEnterKeyPress: function onSearchEnterKeyPress(event) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* handleCaptainSearchEnterKeyPress */])(event));
    },
    onSearchClick: function onSearchClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* handleCaptainSearch */])());
    },
    onSearchValueChange: function onSearchValueChange(searchValue) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["d" /* setSearchCaptainValue */])(searchValue));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditSearchCaptainList_jsx__["a" /* default */]);

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(411);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  searchCaptainAuditValue: '',
  headerCaptain: {
    captainId: null,
    captainName: '',
    startDate: '',
    endDate: '',
    timeZone: '',
    contactName: '',
    registrationCloseDate: ''
  },

  auditDetails: null,
  searchCaptains: null,
  searchExceededResultLimit: false
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_ADMIN_AUDIT_SEARCH_CAPTAIN_VALUE */]:
      return _extends({}, state, {
        searchCaptainAuditValue: payload
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_ADMIN_AUDIT_SEARCH_CAPTAINS */]:
      return _extends({}, state, {
        searchCaptains: payload.list,
        searchExceededResultLimit: payload.exceededSearchLimit
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_ADMIN_AUDIT_CAPTAIN_HEADER */]:
      {
        var captain = initialState.headerCaptain;

        if (payload && payload.captain) {
          captain = payload.captain;
        }

        return _extends({}, state, {
          headerCaptain: captain
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_ADMIN_AUDIT_CAPTAIN_DETAILS */]:
      {
        var auditDetails = initialState.auditDetails;

        if (payload && payload.list) {
          auditDetails = payload.list;
        }

        return _extends({}, state, {
          auditDetails: auditDetails
        });
      }

    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



var AuditSearchEntry = function AuditSearchEntry(_ref) {
  var tournamentName = _ref.tournamentName,
      eventName = _ref.eventName,
      teamName = _ref.teamName,
      entryId = _ref.entryId,
      entryNumber = _ref.entryNumber,
      captainName = _ref.captainName,
      coordinatorName = _ref.coordinatorName,
      isCancelled = _ref.isCancelled,
      bowlDateTime = _ref.bowlDateTime,
      tournamentTimeZone = _ref.tournamentTimeZone,
      showLink = _ref.showLink,
      onNavigationClick = _ref.onNavigationClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group-item-labeled' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 200 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Tournament'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        '' + tournamentName
      )
    ),
    showLink ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      { className: 'list-group-item-labeled-child has-link',
        style: { width: 120 },
        onClick: function onClick() {
          return onNavigationClick('admin/audit/entry/' + entryId);
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Reservation Number'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        entryNumber || '-'
      )
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 120 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Reservation Number'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        entryNumber || '-'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 125 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Event'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        '' + eventName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 175 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Team'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        teamName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 210 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Date'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        bowlDateTime ? __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(bowlDateTime).format('MMM Do, YYYY, hh:mm:ss A') + '\n          (' + tournamentTimeZone + ')' : isCancelled ? 'CANCELLED' : '-'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 250 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Captain'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        captainName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 210 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        coordinatorName && coordinatorName.trim().length > 0 ? 'Coordinator' : 'No coordinator'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        coordinatorName
      )
    )
  );
};

AuditSearchEntry.propTypes = {
  addressBase: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  eventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  teamName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  entryNumber: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  bowlDateTime: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  tournamentTimeZone: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  entryId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  tournamentId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  tournamentName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  captainName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  coordinatorName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  isCancelled: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  showLink: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onNavigationClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

AuditSearchEntry.defaultProps = {
  showLink: true
};

/* harmony default export */ __webpack_exports__["a"] = AuditSearchEntry;

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResultsNotFound_jsx__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__teamLedger_AuditTeamLedgerDetailContainer_jsx__ = __webpack_require__(266);





var AuditSearchEntryDetail = function AuditSearchEntryDetail(_ref) {
  var changeDate = _ref.changeDate,
      userEmail = _ref.userEmail,
      eventName = _ref.eventName,
      audits = _ref.audits,
      teamLedgerAudits = _ref.teamLedgerAudits;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'panel panel-primary' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-heading' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'alert alert-info text-center' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-4' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'col-xs-12' },
              'Audit Date'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                changeDate ? '' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(changeDate).format('MMM Do, YYYY, hh:mm:ss A') : '-'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-4' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'col-xs-12' },
              'Event'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                eventName
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-4' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'col-xs-12' },
              'User Email'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                userEmail
              )
            )
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-body' },
      audits && audits.length == 0 && teamLedgerAudits && teamLedgerAudits.length == 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ResultsNotFound_jsx__["a" /* default */], null) : null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group' },
        audits ? audits.map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'list-group-item-labeled',
              key: index },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child',
                style: { width: 250 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Message'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '' + item.message
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child',
                style: { width: 100 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Type'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                item.typeName
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child',
                style: { width: 100 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Property'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                item.propertyName
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child',
                style: { width: 150 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Original'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                item.originalValue
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child',
                style: { width: 150 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Current Value'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                item.currentValue
              )
            )
          );
        }) : null
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__teamLedger_AuditTeamLedgerDetailContainer_jsx__["a" /* default */], { details: teamLedgerAudits })
    )
  );
};

AuditSearchEntryDetail.propTypes = {
  changeDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  userEmail: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  eventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  audits: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  teamLedgerAudits: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

AuditSearchEntryDetail.defaultProps = {};

/* harmony default export */ __webpack_exports__["a"] = AuditSearchEntryDetail;

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditSearchEntryDetail_jsx__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(163);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var mapStateToProps = function mapStateToProps(props) {
  return _extends({}, props);
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditSearchEntryDetail_jsx__["a" /* default */]);

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResultsNotFound_jsx__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AuditSearchEntryContainer_jsx__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AuditSearchEntryDetailContainer_jsx__ = __webpack_require__(714);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var AuditSearchEntryDetailList = function AuditSearchEntryDetailList(_ref) {
  var headerEntry = _ref.headerEntry,
      list = _ref.list;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-heading row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'panel-title' },
            'Entry'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-body' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'list-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AuditSearchEntryContainer_jsx__["a" /* default */], _extends({}, headerEntry, {
            showLink: false }))
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-heading row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'panel-title' },
            'Entry History'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-body' },
        list && list.length == 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ResultsNotFound_jsx__["a" /* default */], null) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'list-group' },
          list ? list.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AuditSearchEntryDetailContainer_jsx__["a" /* default */], _extends({ key: index
            }, item));
          }) : null
        )
      )
    )
  );
};

AuditSearchEntryDetailList.defaultProps = {
  searchValue: ''
};

AuditSearchEntryDetailList.propTypes = {
  onSearchClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSearchEnterKeyPress: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSearchValueChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  searchValue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  list: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  headerEntry: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};

/* harmony default export */ __webpack_exports__["a"] = AuditSearchEntryDetailList;

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditSearchEntryDetailList_jsx__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(163);




var mapStateToProps = function mapStateToProps(state) {
  return {
    headerEntry: state.admin.entryAudit.headerEntry,
    list: state.admin.entryAudit.auditDetails
  };
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditSearchEntryDetailList_jsx__["a" /* default */]);

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResultsLimited_jsx__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResultsNotFound_jsx__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AuditSearchEntryContainer_jsx__ = __webpack_require__(412);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var AuditSearchEntryList = function AuditSearchEntryList(_ref) {
  var searchValue = _ref.searchValue,
      onSearchEnterKeyPress = _ref.onSearchEnterKeyPress,
      onSearchClick = _ref.onSearchClick,
      onSearchValueChange = _ref.onSearchValueChange,
      list = _ref.list,
      exceededResultLimit = _ref.exceededResultLimit;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-heading row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'panel-title' },
            'Search Teams History'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-body' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'animated fadeIn flex wrap' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'row col-xs-12' },
            'You can search for entries by entry name, entry number or captain name.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('input-group input-group-md'), style: { padding: "0px 0px 16px 0px", minWidth: "360px" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text',
              autoFocus: true,
              placeholder: 'Type your search here...',
              className: 'form-control',
              value: searchValue,
              onChange: function onChange(event) {
                return onSearchValueChange(event.target.value);
              },
              onKeyDown: onSearchEnterKeyPress
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'input-group-btn' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'btn btn-primary',
                  type: 'button',
                  onClick: onSearchClick,
                  disabled: !searchValue || searchValue.trim().length < 3 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-search' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            { className: 'row col-xs-12' },
            'A minimum of three characters are required.'
          )
        ),
        exceededResultLimit ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ResultsLimited_jsx__["a" /* default */], null) : null,
        list && list.length == 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ResultsNotFound_jsx__["a" /* default */], null) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'list-group' },
          list ? list.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__AuditSearchEntryContainer_jsx__["a" /* default */], _extends({ key: index
            }, item, {
              showLink: true }));
          }) : null
        )
      )
    )
  );
};

AuditSearchEntryList.defaultProps = {
  searchValue: '',
  exceededResultLimit: false
};

AuditSearchEntryList.propTypes = {
  onSearchClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSearchEnterKeyPress: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSearchValueChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  searchValue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  exceededResultLimit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  list: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

/* harmony default export */ __webpack_exports__["a"] = AuditSearchEntryList;

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditSearchEntryList_jsx__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(413);





var mapStateToProps = function mapStateToProps(state) {
  return {
    searchValue: state.admin.entryAudit.searchEntryAuditValue,
    exceededResultLimit: state.admin.entryAudit.searchTeamsExceededResultLimit,
    list: state.admin.entryAudit.searchTeams
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSearchEnterKeyPress: function onSearchEnterKeyPress(event) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* handleTeamSearchEnterKeyPress */])(event));
    },
    onSearchClick: function onSearchClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* handleTeamSearch */])());
    },
    onSearchValueChange: function onSearchValueChange(searchValue) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["d" /* setSearchTeamValue */])(searchValue));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditSearchEntryList_jsx__["a" /* default */]);

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(414);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  searchEntryAuditValue: '',
  headerEntry: {
    tournamentId: null,
    tournamentName: '',
    eventName: '',
    teamName: '',
    entryId: null,
    tournamentTimeZone: '',
    entryNumber: '',
    captainName: '',
    coordinatorName: '',
    bowlDateTime: null,
    isCancelled: false
  },

  auditDetails: null,
  searchTeams: null,
  searchTeamsExceededResultLimit: false
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {

    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_ADMIN_AUDIT_SEARCH_TEAM_VALUE */]:
      return _extends({}, state, {
        searchEntryAuditValue: payload
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_ADMIN_AUDIT_SEARCH_TEAMS */]:
      return _extends({}, state, {
        searchTeams: payload.list,
        searchTeamsExceededResultLimit: payload.exceededSearchLimit
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_ADMIN_AUDIT_ENTRY_HEADER */]:
      {
        var entry = initialState.headerEntry;

        if (payload.entry) {
          entry = payload.entry;
        }

        return _extends({}, state, {
          headerEntry: entry
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_ADMIN_AUDIT_ENTRY_DETAILS */]:
      {
        var auditDetails = initialState.auditDetails;

        if (payload.list) {
          auditDetails = payload.list;
        }

        return _extends({}, state, {
          auditDetails: auditDetails
        });
      }

    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(265);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  auditActions: [{
    active: true,
    label: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* ADMIN_AUDIT_TAB_TOURNAMENTS_LABEL */],
    to: "admin/audit"
  }, {
    active: false,
    label: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* ADMIN_AUDIT_TAB_CAPTAINS_LABEL */],
    to: "admin/audit"
  }, {
    active: false,
    label: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ADMIN_AUDIT_TAB_TEAMS_LABEL */],
    to: "admin/audit"
  }, {
    active: false,
    label: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* ADMIN_AUDIT_TAB_VIRTUAL_ENTRIES_LABEL */],
    to: "admin/audit"
  }, {
    active: false,
    label: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* ADMIN_AUDIT_TAB_BOWLERS_LABEL */],
    to: "admin/audit"
  }]
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CLEAR_ADMIN_AUDIT_SEARCH */]:
      return _extends({}, initialState);

    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SELECT_ADMIN_AUDIT_TAB */]:
      state.auditActions.forEach(function (a) {
        return a.active = a.label == payload.label;
      });
      return _extends({}, state);

    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_util_formatCurrency__ = __webpack_require__(27);


Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_1_shared_util_formatCurrency__["a" /* formatCurrency */];

var AuditTeamLedgerDetail = function AuditTeamLedgerDetail(_ref) {
  var details = _ref.details;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    details && details.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'New Transactions'
    ) : null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group' },
      details ? details.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'list-group-item-labeled',
            key: index },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'list-group-item-labeled-child',
              style: { width: 100 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              'Transaction Type'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              item.transactionType
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'list-group-item-labeled-child',
              style: { width: 100 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              'Date'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '' + item.date
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'list-group-item-labeled-child',
              style: { width: 70 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              'Amount'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '$' + item.amount
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'list-group-item-labeled-child',
              style: { width: 200 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              'Description'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              item.description
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'list-group-item-labeled-child',
              style: { width: 200 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              'Notes'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              item.notes
            )
          )
        );
      }) : null
    )
  );
};

AuditTeamLedgerDetail.propTypes = {
  details: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

AuditTeamLedgerDetail.defaultProps = {};

/* harmony default export */ __webpack_exports__["a"] = AuditTeamLedgerDetail;

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



var AuditSearchTournament = function AuditSearchTournament(_ref) {
  var tournamentId = _ref.tournamentId,
      tournamentName = _ref.tournamentName,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      registrationCloseDate = _ref.registrationCloseDate,
      onNavigationClick = _ref.onNavigationClick;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group-item-labeled' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      { className: 'list-group-item-labeled-child has-link',
        style: { width: 200 },
        onClick: function onClick() {
          return onNavigationClick('admin/audit/tournament/' + tournamentId);
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Tournament'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        tournamentName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 120 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Start'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        startDate ? '' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(startDate).format('MMM Do, YYYY') : '-'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 120 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'End'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        endDate ? '' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(endDate).format('MMM Do, YYYY') : '-'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 120 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Registration Close'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        registrationCloseDate ? '' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(registrationCloseDate).format('MMM Do, YYYY') : '-'
      )
    )
  );
};

AuditSearchTournament.propTypes = {
  addressBase: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  tournamentId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  tournamentName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  startDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  endDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  registrationCloseDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onNavigationClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

AuditSearchTournament.defaultProps = {};

/* harmony default export */ __webpack_exports__["a"] = AuditSearchTournament;

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditSearchTournament_jsx__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var mapStateToProps = function mapStateToProps(props) {
  return _extends({}, props);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onNavigationClick: function onNavigationClick(route) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["b" /* navigateTo */])(route));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditSearchTournament_jsx__["a" /* default */]);

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResultsLimited_jsx__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResultsNotFound_jsx__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AuditSearchTournamentContainer_jsx__ = __webpack_require__(723);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var AuditSearchTournamentList = function AuditSearchTournamentList(_ref) {
  var searchValue = _ref.searchValue,
      onSearchEnterKeyPress = _ref.onSearchEnterKeyPress,
      onSearchClick = _ref.onSearchClick,
      onSearchValueChange = _ref.onSearchValueChange,
      list = _ref.list,
      exceededResultLimit = _ref.exceededResultLimit;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-heading row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'panel-title' },
            'Search Tournament History'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-body' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'animated fadeIn flex wrap' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'row col-xs-12' },
            'You can search for tournaments by their name.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('input-group input-group-md'), style: { padding: "0px 0px 16px 0px", minWidth: "360px" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text',
              autoFocus: true,
              placeholder: 'Type your search here...',
              className: 'form-control',
              value: searchValue,
              onChange: function onChange(event) {
                return onSearchValueChange(event.target.value);
              },
              onKeyDown: onSearchEnterKeyPress
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'input-group-btn' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'btn btn-primary',
                  type: 'button',
                  onClick: onSearchClick,
                  disabled: !searchValue || searchValue.trim().length < 3 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-search' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            { className: 'row col-xs-12' },
            'A minimum of three characters are required.'
          )
        ),
        exceededResultLimit ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ResultsLimited_jsx__["a" /* default */], null) : null,
        list && list.length == 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ResultsNotFound_jsx__["a" /* default */], null) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'list-group' },
          list ? list.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__AuditSearchTournamentContainer_jsx__["a" /* default */], _extends({ key: index
            }, item));
          }) : null
        )
      )
    )
  );
};

AuditSearchTournamentList.defaultProps = {
  searchValue: '',
  exceededResultLimit: false
};

AuditSearchTournamentList.propTypes = {
  onSearchClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSearchEnterKeyPress: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSearchValueChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  searchValue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  exceededResultLimit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  list: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

/* harmony default export */ __webpack_exports__["a"] = AuditSearchTournamentList;

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditSearchTournamentList_jsx__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(267);





var mapStateToProps = function mapStateToProps(state) {
  return {
    searchValue: state.admin.tournamentAudit.searchTournamentAuditValue,
    exceededResultLimit: state.admin.tournamentAudit.searchExceededResultLimit,
    list: state.admin.tournamentAudit.searchTournaments
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSearchEnterKeyPress: function onSearchEnterKeyPress(event) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* handleTournamentSearchEnterKeyPress */])(event));
    },
    onSearchClick: function onSearchClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* handleTournamentSearch */])());
    },
    onSearchValueChange: function onSearchValueChange(searchValue) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["d" /* setSearchTournamentValue */])(searchValue));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditSearchTournamentList_jsx__["a" /* default */]);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResultsNotFound_jsx__ = __webpack_require__(46);




var AuditTournamentDetail = function AuditTournamentDetail(_ref) {
  var changeDate = _ref.changeDate,
      userEmail = _ref.userEmail,
      audits = _ref.audits;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'panel panel-primary' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-heading' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'alert alert-info text-center' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-6' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'col-xs-12' },
              'Audit Date'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                changeDate ? '' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(changeDate).format('MMM Do, YYYY, hh:mm:ss A') : '-'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-6' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'col-xs-12' },
              'User Email'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                userEmail
              )
            )
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-body' },
      audits && audits.length == 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ResultsNotFound_jsx__["a" /* default */], null) : null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group' },
        audits ? audits.map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'list-group-item-labeled',
              key: index },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child',
                style: { width: 250 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Message'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '' + item.message
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child',
                style: { width: 100 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Type'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                item.typeName
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child',
                style: { width: 100 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Property'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                item.propertyName
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child',
                style: { width: 150 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Original'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                item.originalValue
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child',
                style: { width: 150 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Current Value'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                item.currentValue
              )
            )
          );
        }) : null
      )
    )
  );
};

AuditTournamentDetail.propTypes = {
  changeDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  userEmail: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  audits: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

AuditTournamentDetail.defaultProps = {};

/* harmony default export */ __webpack_exports__["a"] = AuditTournamentDetail;

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditTournamentDetail_jsx__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(132);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var mapStateToProps = function mapStateToProps(props) {
  return _extends({}, props);
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditTournamentDetail_jsx__["a" /* default */]);

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResultsNotFound_jsx__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AuditTournamentDetailContainer_jsx__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AuditTournamentHeaderContainer_jsx__ = __webpack_require__(731);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var AuditTournamentDetailList = function AuditTournamentDetailList(_ref) {
  var list = _ref.list,
      headerTournament = _ref.headerTournament;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-heading row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'panel-title' },
            'Tournament'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-body' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'list-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AuditTournamentHeaderContainer_jsx__["a" /* default */], headerTournament)
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-heading row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'panel-title' },
            'Tournament History'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-body' },
        list && list.length == 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ResultsNotFound_jsx__["a" /* default */], null) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'list-group' },
          list ? list.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AuditTournamentDetailContainer_jsx__["a" /* default */], _extends({ key: index
            }, item));
          }) : null
        )
      )
    )
  );
};

AuditTournamentDetailList.defaultProps = {};

AuditTournamentDetailList.propTypes = {
  list: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  headerTournament: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};

/* harmony default export */ __webpack_exports__["a"] = AuditTournamentDetailList;

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditTournamentDetailList_jsx__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(267);





var mapStateToProps = function mapStateToProps(state) {
  return {
    headerTournament: state.admin.tournamentAudit.headerTournament,
    list: state.admin.tournamentAudit.auditDetails
  };
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditTournamentDetailList_jsx__["a" /* default */]);

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



var AuditTournamentHeader = function AuditTournamentHeader(_ref) {
  var tournamentName = _ref.tournamentName,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      registrationCloseDate = _ref.registrationCloseDate,
      contactName = _ref.contactName;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group-item-labeled' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 250 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Tournament'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        tournamentName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 120 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Start'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        startDate ? '' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(startDate).format('MMM Do, YYYY') : '-'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 120 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'End'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        endDate ? '' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(endDate).format('MMM Do, YYYY') : '-'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 120 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Registration Close'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        registrationCloseDate ? '' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(registrationCloseDate).format('MMM Do, YYYY') : '-'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 250 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Contact'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        contactName
      )
    )
  );
};

AuditTournamentHeader.propTypes = {
  tournamentName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  startDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  endDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  registrationCloseDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  contactName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

AuditTournamentHeader.defaultProps = {};

/* harmony default export */ __webpack_exports__["a"] = AuditTournamentHeader;

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditTournamentHeader_jsx__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(132);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var mapStateToProps = function mapStateToProps(props) {
  return _extends({}, props);
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditTournamentHeader_jsx__["a" /* default */]);

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(415);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  searchTournamentAuditValue: '',
  headerTournament: {
    tournamentId: null,
    tournamentName: '',
    startDate: '',
    endDate: '',
    timeZone: '',
    contactName: '',
    registrationCloseDate: ''
  },

  auditDetails: null,
  searchTournaments: null,
  searchExceededResultLimit: false
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_ADMIN_AUDIT_SEARCH_TOURNAMENT_VALUE */]:
      return _extends({}, state, {
        searchTournamentAuditValue: payload
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_ADMIN_AUDIT_SEARCH_TOURNAMENTS */]:
      return _extends({}, state, {
        searchTournaments: payload.list,
        searchExceededResultLimit: payload.exceededSearchLimit
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_ADMIN_AUDIT_TOURNAMENT_HEADER */]:
      {
        var tournament = initialState.headerTournament;

        if (payload && payload.tournament) {
          tournament = payload.tournament;
        }

        return _extends({}, state, {
          headerTournament: tournament
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_ADMIN_AUDIT_TOURNAMENT_DETAILS */]:
      {
        var auditDetails = initialState.auditDetails;

        if (payload && payload.list) {
          auditDetails = payload.list;
        }

        return _extends({}, state, {
          auditDetails: auditDetails
        });
      }

    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var AuditSearchVirtualEntry = function AuditSearchVirtualEntry(_ref) {
  var virtualEntryId = _ref.virtualEntryId,
      virtualEventName = _ref.virtualEventName,
      captainName = _ref.captainName,
      bowlerName = _ref.bowlerName,
      tournamentName = _ref.tournamentName,
      onNavigationClick = _ref.onNavigationClick;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "list-group-item-labeled" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "a",
      { className: "list-group-item-labeled-child has-link",
        style: { width: 200 },
        onClick: function onClick() {
          return onNavigationClick("admin/audit/virtualEntry/" + virtualEntryId);
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        'Virtual Event'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        virtualEventName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "list-group-item-labeled-child",
        style: { width: 120 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        'Captain'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        captainName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "list-group-item-labeled-child",
        style: { width: 120 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        'Bowler'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        bowlerName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "list-group-item-labeled-child",
        style: { width: 230 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        'Tournament'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        tournamentName
      )
    )
  );
};

AuditSearchVirtualEntry.propTypes = {
  addressBase: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  virtualEntryId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  virtualEventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  captainName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  bowlerName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  tournamentName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onNavigationClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

AuditSearchVirtualEntry.defaultProps = {};

/* harmony default export */ __webpack_exports__["a"] = AuditSearchVirtualEntry;

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditSearchVirtualEntry_jsx__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var mapStateToProps = function mapStateToProps(props) {
  return _extends({}, props);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onNavigationClick: function onNavigationClick(route) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["b" /* navigateTo */])(route));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditSearchVirtualEntry_jsx__["a" /* default */]);

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResultsLimited_jsx__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResultsNotFound_jsx__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AuditSearchVirtualEntryContainer_jsx__ = __webpack_require__(734);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var AuditSearchVirtualEntryList = function AuditSearchVirtualEntryList(_ref) {
  var searchValue = _ref.searchValue,
      onSearchEnterKeyPress = _ref.onSearchEnterKeyPress,
      onSearchClick = _ref.onSearchClick,
      onSearchValueChange = _ref.onSearchValueChange,
      list = _ref.list,
      exceededResultLimit = _ref.exceededResultLimit;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-heading row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'panel-title' },
            'Search Virtual Entry History'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-body' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'animated fadeIn flex wrap' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'row col-xs-12' },
            'You can search for virtual entries by entry name, entry number, bowler name, or captain name.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('input-group input-group-md'), style: { padding: "0px 0px 16px 0px", minWidth: "360px" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text',
              autoFocus: true,
              placeholder: 'Type your search here...',
              className: 'form-control',
              value: searchValue,
              onChange: function onChange(event) {
                return onSearchValueChange(event.target.value);
              },
              onKeyDown: onSearchEnterKeyPress
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'input-group-btn' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'btn btn-primary',
                  type: 'button',
                  onClick: onSearchClick,
                  disabled: !searchValue || searchValue.trim().length < 3 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-search' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            { className: 'row col-xs-12' },
            'A minimum of three characters are required.'
          )
        ),
        exceededResultLimit ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ResultsLimited_jsx__["a" /* default */], null) : null,
        list && list.length == 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ResultsNotFound_jsx__["a" /* default */], null) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'list-group' },
          list ? list.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__AuditSearchVirtualEntryContainer_jsx__["a" /* default */], _extends({ key: index
            }, item));
          }) : null
        )
      )
    )
  );
};

AuditSearchVirtualEntryList.defaultProps = {
  searchValue: '',
  exceededResultLimit: false
};

AuditSearchVirtualEntryList.propTypes = {
  onSearchClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSearchEnterKeyPress: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSearchValueChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  searchValue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  exceededResultLimit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  list: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

/* harmony default export */ __webpack_exports__["a"] = AuditSearchVirtualEntryList;

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditSearchVirtualEntryList_jsx__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(268);





var mapStateToProps = function mapStateToProps(state) {
  return {
    searchValue: state.admin.virtualEntryAudit.searchVirtualEntryAuditValue,
    exceededResultLimit: state.admin.virtualEntryAudit.searchExceededResultLimit,
    list: state.admin.virtualEntryAudit.searchVirtualEntrys
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSearchEnterKeyPress: function onSearchEnterKeyPress(event) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* handleVirtualEntrySearchEnterKeyPress */])(event));
    },
    onSearchClick: function onSearchClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* handleVirtualEntrySearch */])());
    },
    onSearchValueChange: function onSearchValueChange(searchValue) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["d" /* setSearchVirtualEntryValue */])(searchValue));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditSearchVirtualEntryList_jsx__["a" /* default */]);

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResultsNotFound_jsx__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__teamLedger_AuditTeamLedgerDetailContainer_jsx__ = __webpack_require__(266);





var AuditVirtualEntryDetail = function AuditVirtualEntryDetail(_ref) {
  var changeDate = _ref.changeDate,
      userEmail = _ref.userEmail,
      audits = _ref.audits,
      teamLedgerAudits = _ref.teamLedgerAudits;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'panel panel-primary' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-heading' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'alert alert-info text-center' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-6' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'col-xs-12' },
              'Audit Date'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                changeDate ? '' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(changeDate).format('MMM Do, YYYY, hh:mm:ss A') : '-'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-6' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'col-xs-12' },
              'User Email'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                userEmail
              )
            )
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-body' },
      audits && audits.length == 0 && teamLedgerAudits && teamLedgerAudits.length == 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ResultsNotFound_jsx__["a" /* default */], null) : null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group' },
        audits ? audits.map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'list-group-item-labeled',
              key: index },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child',
                style: { width: 250 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Message'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '' + item.message
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child',
                style: { width: 100 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Type'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                item.typeName
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child',
                style: { width: 100 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Property'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                item.propertyName
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child',
                style: { width: 150 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Original'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                item.originalValue
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'list-group-item-labeled-child',
                style: { width: 150 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Current Value'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                item.currentValue
              )
            )
          );
        }) : null
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__teamLedger_AuditTeamLedgerDetailContainer_jsx__["a" /* default */], { details: teamLedgerAudits })
    )
  );
};

AuditVirtualEntryDetail.propTypes = {
  changeDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  userEmail: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  audits: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  teamLedgerAudits: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

AuditVirtualEntryDetail.defaultProps = {};

/* harmony default export */ __webpack_exports__["a"] = AuditVirtualEntryDetail;

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditVirtualEntryDetail_jsx__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(133);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var mapStateToProps = function mapStateToProps(props) {
  return _extends({}, props);
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditVirtualEntryDetail_jsx__["a" /* default */]);

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResultsNotFound_jsx__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AuditVirtualEntryDetailContainer_jsx__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AuditVirtualEntryHeaderContainer_jsx__ = __webpack_require__(742);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var AuditVirtualEntryDetailList = function AuditVirtualEntryDetailList(_ref) {
  var list = _ref.list,
      headerVirtualEntry = _ref.headerVirtualEntry;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-heading row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'panel-title' },
            'Virtual Entry'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-body' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'list-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AuditVirtualEntryHeaderContainer_jsx__["a" /* default */], headerVirtualEntry)
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-heading row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'panel-title' },
            'Virtual Entry History'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-body' },
        list && list.length == 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ResultsNotFound_jsx__["a" /* default */], null) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'list-group' },
          list ? list.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AuditVirtualEntryDetailContainer_jsx__["a" /* default */], _extends({ key: index
            }, item));
          }) : null
        )
      )
    )
  );
};

AuditVirtualEntryDetailList.defaultProps = {};

AuditVirtualEntryDetailList.propTypes = {
  list: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  headerVirtualEntry: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};

/* harmony default export */ __webpack_exports__["a"] = AuditVirtualEntryDetailList;

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditVirtualEntryDetailList_jsx__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(268);





var mapStateToProps = function mapStateToProps(state) {
  return {
    headerVirtualEntry: state.admin.virtualEntryAudit.headerVirtualEntry,
    list: state.admin.virtualEntryAudit.auditDetails
  };
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditVirtualEntryDetailList_jsx__["a" /* default */]);

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var AuditVirtualEntryHeader = function AuditVirtualEntryHeader(_ref) {
  var virtualEventName = _ref.virtualEventName,
      captainName = _ref.captainName,
      bowlerName = _ref.bowlerName,
      tournamentName = _ref.tournamentName;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "list-group-item-labeled" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "list-group-item-labeled-child",
        style: { width: 250 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        'Virtual Event'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        virtualEventName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "list-group-item-labeled-child",
        style: { width: 150 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        'Captain'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        captainName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "list-group-item-labeled-child",
        style: { width: 150 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        'Bowler'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        bowlerName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "list-group-item-labeled-child",
        style: { width: 250 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        'Tournament'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        tournamentName
      )
    )
  );
};

AuditVirtualEntryHeader.propTypes = {
  virtualEventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  captainName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  bowlerName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  tournamentName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

AuditVirtualEntryHeader.defaultProps = {};

/* harmony default export */ __webpack_exports__["a"] = AuditVirtualEntryHeader;

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuditVirtualEntryHeader_jsx__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(133);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var mapStateToProps = function mapStateToProps(props) {
  return _extends({}, props);
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AuditVirtualEntryHeader_jsx__["a" /* default */]);

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(416);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  searchVirtualEntryAuditValue: '',
  headerVirtualEntry: {
    virtualEntryId: null,
    virtualEntryName: '',
    startDate: '',
    endDate: '',
    timeZone: '',
    contactName: '',
    registrationCloseDate: ''
  },

  auditDetails: null,
  searchVirtualEntrys: null,
  searchExceededResultLimit: false
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_ADMIN_AUDIT_SEARCH_VIRTUAL_ENTRY_VALUE */]:
      return _extends({}, state, {
        searchVirtualEntryAuditValue: payload
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_ADMIN_AUDIT_SEARCH_VIRTUAL_ENTRYS */]:
      return _extends({}, state, {
        searchVirtualEntrys: payload.list,
        searchExceededResultLimit: payload.exceededSearchLimit
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_ADMIN_AUDIT_VIRTUAL_ENTRY_HEADER */]:
      {
        var virtualEntry = initialState.headerVirtualEntry;

        if (payload && payload.virtualEntry) {
          virtualEntry = payload.virtualEntry;
        }

        return _extends({}, state, {
          headerVirtualEntry: virtualEntry
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_ADMIN_AUDIT_VIRTUAL_ENTRY_DETAILS */]:
      {
        var auditDetails = initialState.auditDetails;

        if (payload && payload.list) {
          auditDetails = payload.list;
        }

        return _extends({}, state, {
          auditDetails: auditDetails
        });
      }

    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_Panel_jsx__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CaptainPaymentListContainer_jsx__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_util_formatCurrency__ = __webpack_require__(27);





Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_4_shared_util_formatCurrency__["a" /* formatCurrency */];

var CaptainBalanceDetail = function CaptainBalanceDetail(_ref) {
  var balance = _ref.balance,
      selectedBalance = _ref.selectedBalance,
      selectedEntriesWithoutBalance = _ref.selectedEntriesWithoutBalance,
      onPayBalanceClick = _ref.onPayBalanceClick,
      onPayBalanceOtherClick = _ref.onPayBalanceOtherClick,
      onPaymentLogClick = _ref.onPaymentLogClick,
      enabledWebHooks = _ref.enabledWebHooks,
      onWebHooksClick = _ref.onWebHooksClick,
      environment = _ref.environment,
      validationMessages = _ref.validationMessages;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-xs-12' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'alert alert-info text-center' },
          'Payments may only be accepted for a single tournament per transaction.'
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
      { condition: Array.isArray(validationMessages) && validationMessages.length > 0 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-xs-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'alert alert-danger text-center' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              validationMessages ? validationMessages.map(function (message, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { key: index },
                  '' + message
                );
              }) : null
            )
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_shared_Panel_jsx__["a" /* default */],
      { className: 'panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'row vertical-center' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-md-6' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'panel-title',
              style: { display: 'inline-block', marginBottom: 10, marginTop: 6 } },
            'Captain\'s Balance: ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '$' + balance.formatCurrency(2)
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'small',
              null,
              selectedBalance ? '(Amount to Pay - $' + selectedBalance.formatCurrency(2) + ')' : ''
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-md-6 flex vertical-center right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              style: { fontSize: 18, minWidth: 150, marginLeft: 10 },
              className: 'btn btn-link',
              type: 'button',
              onClick: onPaymentLogClick },
            'Payment Log'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              style: { minWidth: 150, marginLeft: 10 },
              type: 'button',
              className: 'btn btn-default btn-lg',
              disabled: !selectedBalance || selectedEntriesWithoutBalance,
              onClick: onPayBalanceOtherClick },
            'Cash/Check'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              style: { minWidth: 150, marginLeft: 10 },
              type: 'button',
              className: 'btn btn-primary btn-lg',
              disabled: !selectedBalance || selectedEntriesWithoutBalance,
              onClick: onPayBalanceClick },
            'Credit Card'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
          { condition: !!selectedBalance && environment != 'PROD' && environment != 'PRODUCTION',
            className: 'custom-checkbox-container',
            style: { float: "right", paddingRight: 15 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'checkbox',
            id: 'webHooks',
            checked: enabledWebHooks,
            onChange: function onChange(event) {
              return onWebHooksClick(event.target.checked);
            } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            { htmlFor: 'webHooks' },
            'Click here to process payments in real time.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
          { condition: selectedEntriesWithoutBalance && selectedBalance > 0 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-12' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { marginTop: 18, marginRight: 6, marginBottom: -12, marginLeft: 6 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'alert alert-warning text-center' },
                'Cannot make payments to entries without balance.'
              )
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CaptainPaymentListContainer_jsx__["a" /* default */], null)
    )
  );
};

CaptainBalanceDetail.propTypes = {
  balance: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  selectedBalance: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  selectedEntriesWithoutBalance: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onPayBalanceClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onPayBalanceOtherClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onPaymentLogClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  enabledWebHooks: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onWebHooksClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  environment: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  validationMessages: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string)
};

/* harmony default export */ __webpack_exports__["a"] = CaptainBalanceDetail;

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CaptainBalanceDetail_jsx__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_webHooks_actions__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_variables__ = __webpack_require__(38);






var mapStateToProps = function mapStateToProps(state) {
  return {
    balance: state.admin.captainDetail.balance,
    selectedBalance: state.admin.captainDetail.selectedBalance,
    selectedEntriesWithoutBalance: state.admin.captainDetail.selectedEntriesWithoutBalance,
    validationMessages: state.admin.captainDetail.validationMessages,
    environment: __WEBPACK_IMPORTED_MODULE_4_shared_variables__["h" /* ENVIRONMENT */]
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onPayBalanceClick: function onPayBalanceClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["p" /* handlePayBalanceClick */])());
    },
    onPayBalanceOtherClick: function onPayBalanceOtherClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["q" /* handlePayBalanceOtherClick */])());
    },
    onPaymentLogClick: function onPaymentLogClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["r" /* handlePaymentLogClick */])());
    },
    onWebHooksClick: function onWebHooksClick(checked) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_webHooks_actions__["a" /* handleWebHooksClick */])(checked));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CaptainBalanceDetail_jsx__["a" /* default */]);

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_Panel_jsx__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_Link_jsx__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TournamentEntryContainer_jsx__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CaptainBalanceDetailContainer_jsx__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CaptainEntryOptionsContainer_jsx__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CaptainDetailPaymentModalContainer_jsx__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CaptainDetailNotesContainer_jsx__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CaptainDetailNotesModalContainer_jsx__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CaptainDetailUpdateModalContainer_jsx__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_DisplayIf_jsx__ = __webpack_require__(12);












var CaptainDetail = function CaptainDetail(_ref) {
  var captainName = _ref.captainName,
      captainEmail = _ref.captainEmail,
      captainAddress1 = _ref.captainAddress1,
      captainAddress2 = _ref.captainAddress2,
      captainCity = _ref.captainCity,
      captainState = _ref.captainState,
      captainCountry = _ref.captainCountry,
      captainZip = _ref.captainZip,
      captainPhoneNumber = _ref.captainPhoneNumber,
      showSearchLink = _ref.showSearchLink,
      loadingTournaments = _ref.loadingTournaments,
      tournamentEntries = _ref.tournamentEntries,
      onUpdateClicked = _ref.onUpdateClicked,
      hideCancelledEntries = _ref.hideCancelledEntries,
      hideArchivedEntries = _ref.hideArchivedEntries,
      onHideCancelledEntriesChange = _ref.onHideCancelledEntriesChange,
      onHideArchivedEntriesChange = _ref.onHideArchivedEntriesChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CaptainDetailPaymentModalContainer_jsx__["a" /* default */], null),
    showSearchLink ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-md-12' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_shared_Link_jsx__["a" /* default */],
          {
            className: 'btn btn-link',
            style: { paddingLeft: 0 },
            to: 'admin/search' },
          'Back to search results'
        )
      )
    ) : null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-md-6 col-xs-12' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__CaptainDetailUpdateModalContainer_jsx__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_shared_Panel_jsx__["a" /* default */],
          { className: 'panel-primary',
            style: { minHeight: 200 },
            title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              captainName,
              ' ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'small',
                null,
                '(TC)'
              )
            ) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h5',
            null,
            'Contact'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            captainEmail
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_shared_DisplayIf_jsx__["a" /* default */],
            { condition: !!captainAddress1 },
            captainAddress1
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_shared_DisplayIf_jsx__["a" /* default */],
            { condition: !!captainAddress2 },
            captainAddress2
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_shared_DisplayIf_jsx__["a" /* default */],
            { condition: !!captainCity || !!captainState || !!captainCountry || !!captainZip },
            captainCity,
            ' ',
            captainState,
            ' ',
            captainCountry,
            ' ',
            captainZip
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_shared_DisplayIf_jsx__["a" /* default */],
            { condition: !!captainPhoneNumber },
            captainPhoneNumber
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'flex right' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-link',
                onClick: function onClick() {
                  return onUpdateClicked();
                } },
              'Update Name'
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-md-6 col-xs-12' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CaptainDetailNotesContainer_jsx__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CaptainDetailNotesModalContainer_jsx__["a" /* default */], null)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-md-12' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CaptainBalanceDetailContainer_jsx__["a" /* default */], null)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-md-12' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CaptainEntryOptionsContainer_jsx__["a" /* default */], null)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'custom-checkbox-container',
        style: { margin: '1px 1px', display: 'inline-block' } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'checkbox',
        id: 'hideCancelled',
        disabled: loadingTournaments,
        checked: hideCancelledEntries,
        onChange: function onChange(event) {
          return onHideCancelledEntriesChange(event.target.checked);
        } }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'label',
        { htmlFor: 'hideCancelled' },
        'Hide Cancelled Entries'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'custom-checkbox-container',
        style: { margin: '1px 1px', display: 'inline-block', paddingLeft: '10px' } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'checkbox',
        id: 'hideArchived',
        disabled: loadingTournaments,
        checked: hideArchivedEntries,
        onChange: function onChange(event) {
          return onHideArchivedEntriesChange(event.target.checked);
        } }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'label',
        { htmlFor: 'hideArchived' },
        'Hide Archived Entries'
      )
    ),
    loadingTournaments ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'alert alert-info text-center',
        style: { margin: '16px 0px' } },
      'Loading entries'
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      tournamentEntries.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-md-12',
            key: index },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TournamentEntryContainer_jsx__["a" /* default */], item)
        );
      })
    )
  );
};

CaptainDetail.defaultProps = {
  captainName: '',
  captainEmail: '',
  captainAddress1: '',
  captainAddress2: '',
  captainCity: '',
  captainState: '',
  captainCountry: '',
  captainZip: '',
  captainPhoneNumber: '',
  showSearchLink: false,
  loadingTournaments: false,
  tournamentEntries: []
};

CaptainDetail.propTypes = {
  captainName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  captainEmail: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  captainAddress1: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  captainAddress2: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  captainCity: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  captainState: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  captainCountry: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  captainZip: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  captainPhoneNumber: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  showSearchLink: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  loadingTournaments: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  tournamentEntries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  onUpdateClicked: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  hideCancelledEntries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onHideCancelledEntriesChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  hideArchivedEntries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onHideArchivedEntriesChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = CaptainDetail;

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CaptainDetail_jsx__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(51);




var mapStateToProps = function mapStateToProps(state) {
  return {
    captainName: state.admin.captainDetail.captainName,
    captainEmail: state.admin.captainDetail.captainEmail,
    captainAddress1: state.admin.captainDetail.captainAddress1,
    captainAddress2: state.admin.captainDetail.captainAddress2,
    captainCity: state.admin.captainDetail.captainCity,
    captainState: state.admin.captainDetail.captainState,
    captainCountry: state.admin.captainDetail.captainCountry,
    captainZip: state.admin.captainDetail.captainZip,
    captainPhoneNumber: state.admin.captainDetail.captainPhoneNumber,
    tournamentEntries: state.admin.captainDetail.tournaments,
    loadingTournaments: state.admin.captainDetail.loadingTournaments,
    showSearchLink: !!state.admin.home.searchValue,
    balance: state.admin.captainDetail.balance,
    hideCancelledEntries: state.admin.captainDetail.hideCancelledEntries,
    hideArchivedEntries: state.admin.captainDetail.hideArchivedEntries
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onUpdateClicked: function onUpdateClicked() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["d" /* handleUpdateClicked */])());
    },
    onHideCancelledEntriesChange: function onHideCancelledEntriesChange(newValue) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["e" /* onHideCancelledEntriesChange */])(newValue));
    },
    onHideArchivedEntriesChange: function onHideArchivedEntriesChange(newValue) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* onHideArchivedEntriesChange */])(newValue));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CaptainDetail_jsx__["a" /* default */]);

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_Panel_jsx__ = __webpack_require__(44);



var CaptainDetailNotes = function CaptainDetailNotes(_ref) {
  var notes = _ref.notes,
      onEditClick = _ref.onEditClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_shared_Panel_jsx__["a" /* default */],
    { className: 'panel-primary',
      style: { minHeight: 200 },
      title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Notes',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-link pull-right',
            onClick: onEditClick },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-pencil' }),
          ' ',
          'Edit'
        )
      ) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: {
          overflowY: 'auto',
          height: 102
        } },
      notes || 'Click \'Edit\' to add notes here...'
    )
  );
};

CaptainDetailNotes.propTypes = {
  notes: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onEditClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

CaptainDetailNotes.defaultProps = {
  notes: ''
};

/* harmony default export */ __webpack_exports__["a"] = CaptainDetailNotes;

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CaptainDetailNotes_jsx__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(51);




var mapStateToProps = function mapStateToProps(state) {
  return {
    notes: state.admin.captainDetail.notes
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onEditClick: function onEditClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["x" /* handleNotesEditClick */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CaptainDetailNotes_jsx__["a" /* default */]);

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_StandardModal_jsx__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardTextArea_jsx__ = __webpack_require__(136);





var CaptainDetailNotesModal = function CaptainDetailNotesModal(_ref) {
  var visible = _ref.visible,
      onCancel = _ref.onCancel,
      handleSubmit = _ref.handleSubmit,
      onSubmit = _ref.onSubmit;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_shared_StandardModal_jsx__["a" /* default */],
    {
      title: 'Captain Notes',
      visible: visible,
      onCloseClick: onCancel },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        { id: 'captainDetailNotesForm',
          onSubmit: handleSubmit(onSubmit) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'notes',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardTextArea_jsx__["a" /* default */],
            label: 'Notes',
            placeholder: 'Enter your notes here...',
            style: { height: 200 }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-link',
              onClick: function onClick() {
                return onCancel();
              }
            },
            'Cancel'
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'submit',
              className: 'btn btn-primary btn-lg'
            },
            'Save Notes'
          )
        )
      )
    )
  );
};

CaptainDetailNotesModal.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'adminCaptainDetailNotesForm'
})(CaptainDetailNotesModal);

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CaptainDetailNotesModal_jsx__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(51);




var mapStateToProps = function mapStateToProps(state) {
  return {
    visible: state.admin.captainDetail.showNotesModal
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCancel: function onCancel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["v" /* handleNotesModalCancel */])());
    },
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["w" /* handleNotesModalSave */])(data));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CaptainDetailNotesModal_jsx__["a" /* default */]);

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_StandardModal_jsx__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_StandardTextArea_jsx__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_DisplayIf_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_util_formatCurrency__ = __webpack_require__(27);








Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_7_shared_util_formatCurrency__["a" /* formatCurrency */];

var CaptainDetailPaymentModal = function CaptainDetailPaymentModal(_ref) {
  var paymentType = _ref.paymentType,
      amount = _ref.amount,
      visible = _ref.visible,
      onCancel = _ref.onCancel,
      handleSubmit = _ref.handleSubmit,
      onSubmit = _ref.onSubmit;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_shared_StandardModal_jsx__["a" /* default */],
    {
      title: 'Accept Payment',
      visible: visible,
      onCloseClick: onCancel },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        {
          onSubmit: handleSubmit(onSubmit) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          null,
          'Select Payment Method'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: 'form-group',
            style: { display: 'flex', flexFlow: 'column' }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'paymentType',
              component: 'input',
              type: 'radio',
              value: 'Cash' }),
            ' Cash'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'paymentType',
              component: 'input',
              type: 'radio',
              value: 'Check' }),
            ' Check'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'paymentType',
              component: 'input',
              type: 'radio',
              value: 'USBC Credit' }),
            ' USBC Credit'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'paymentType',
              component: 'input',
              type: 'radio',
              value: 'USBC Carryover' }),
            ' USBC Carryover'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'paymentType',
              component: 'input',
              type: 'radio',
              value: 'Manual Stripe Transaction' }),
            ' Manual Stripe Transaction'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_shared_DisplayIf_jsx__["a" /* default */],
          { condition: paymentType == 'Check' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'checkNumber',
              type: 'number',
              component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
              placeholder: 'Check Number',
              style: { maxWidth: 300 },
              min: '0'
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_shared_DisplayIf_jsx__["a" /* default */],
          { condition: paymentType == 'Manual Stripe Transaction' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'stripeTransactionId',
              component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
              placeholder: 'Stripe Transaction Id',
              style: { width: '30%' }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { marginBottom: 20 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            'Payment Amount'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            '$' + amount.formatCurrency(2)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'notes',
            component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardTextArea_jsx__["a" /* default */],
            placeholder: 'Notes go here',
            maxLength: '255'
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-link',
              onClick: function onClick() {
                return onCancel();
              }
            },
            'Cancel'
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'submit',
              className: 'btn btn-primary btn-lg'
            },
            'Save'
          )
        )
      )
    )
  );
};

CaptainDetailPaymentModal.propTypes = {
  paymentType: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  amount: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

CaptainDetailPaymentModal.defaultProps = {
  amount: 0
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'adminCaptainPaymentForm'
})(CaptainDetailPaymentModal);

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CaptainDetailPaymentModal_jsx__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(51);





var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["formValueSelector"])('adminCaptainPaymentForm');

var mapStateToProps = function mapStateToProps(state) {
  return {
    paymentType: selector(state, 'paymentType'),
    amount: selector(state, 'amount'),
    visible: state.admin.captainDetail.showPaymentModal
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCancel: function onCancel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["A" /* handlePayBalanceOtherCancelClick */])());
    },
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["B" /* handlePayBalanceOtherAcceptClick */])(data));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__CaptainDetailPaymentModal_jsx__["a" /* default */]);

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardModal_jsx__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);






var CaptainDetailUpdateModal = function CaptainDetailUpdateModal(_ref) {
  var visible = _ref.visible,
      onCancelClick = _ref.onCancelClick,
      handleSubmit = _ref.handleSubmit,
      onSubmit = _ref.onSubmit;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_shared_StandardModal_jsx__["a" /* default */],
    {
      title: 'Update Captain',
      visible: visible,
      onCloseClick: onCancelClick },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'form',
      { onSubmit: handleSubmit(onSubmit) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'hidden',
        name: 'captainId' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-6' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], { name: 'captainFirstName',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'First Name' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-6' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], { name: 'captainLastName',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'Last Name' })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'form-group text-right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-link',
            onClick: function onClick() {
              return onCancelClick();
            }
          },
          'Cancel'
        ),
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'submit',
            className: 'btn btn-primary btn-lg'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
          ' ',
          'Save'
        )
      )
    )
  );
};

CaptainDetailUpdateModal.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'adminCaptainDetailUpdateForm'
})(CaptainDetailUpdateModal);

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CaptainDetailUpdateModal_jsx__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(51);




var mapStateToProps = function mapStateToProps(state) {
  return {
    visible: state.admin.captainDetail.showUpdateModal
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["y" /* handleCaptainDetailUpdateCancelClick */])());
    },
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["z" /* handleCaptainDetailUpdateFormSave */])(data));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CaptainDetailUpdateModal_jsx__["a" /* default */]);

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__entryDetail_EntryCaptainChangeFormModal_jsx__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actionTypes__ = __webpack_require__(134);






var mapStateToProps = function mapStateToProps(state) {
  return {
    visible: state.admin.captainDetail.showCaptainEntryChangeCaptainModal,
    isNew: state.admin.captainDetail.isNewCaptainOnSearch,
    submitButtonText: state.admin.captainDetail.isNewCaptainOnSearch ? 'Create' : 'Update',
    validate: __WEBPACK_IMPORTED_MODULE_3__actions__["l" /* validateEntryCaptainChangeForm */],
    affectedVirtualEntries: state.admin.captainDetail.affectedVirtualEntries,
    allAffectedVirtualEntriesSelected: state.admin.captainDetail.allAffectedVirtualEntriesSelected
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["m" /* handleEntryChangeCaptainCancelClick */])());
    },
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["n" /* handleChangeEntriesCaptainFormSave */])(data));
    },
    onSearchClick: function onSearchClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["o" /* handleEntryChangeCaptainSearchClick */])());
    },
    onSelectAllChecked: function onSelectAllChecked() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["y" /* setAllAffectedVirtualEntriesSelected */])());
    }
  };
};

var entryCaptainChangeReduxForm = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'CaptainEntryChangeCaptainForm'
})(__WEBPACK_IMPORTED_MODULE_2__entryDetail_EntryCaptainChangeFormModal_jsx__["a" /* EntryCaptainChangeForm */]);

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(entryCaptainChangeReduxForm);

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_Panel_jsx__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CaptainEntryChangeCaptainFormModalContainer_jsx__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__ = __webpack_require__(12);





var CaptainEntryOptions = function CaptainEntryOptions(_ref) {
  var hasSelectedVirtualEntries = _ref.hasSelectedVirtualEntries,
      hasSelectedEntries = _ref.hasSelectedEntries,
      changeMultipleEntriesErrors = _ref.changeMultipleEntriesErrors,
      onChangeEntriesCaptainClick = _ref.onChangeEntriesCaptainClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_shared_Panel_jsx__["a" /* default */],
      { className: 'panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'row vertical-center' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-6 col-xs-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'panel-title',
              style: { display: 'inline-block', marginBottom: 10, marginTop: 6 } },
            'Change entries'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-6 col-xs-12 flex vertical-center right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              style: { minWidth: 150, marginLeft: 10 },
              type: 'button',
              className: 'btn btn-default btn-lg',
              disabled: !hasSelectedEntries && !hasSelectedVirtualEntries,
              onClick: onChangeEntriesCaptainClick },
            'Change Captain'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
          { condition: changeMultipleEntriesErrors != undefined && changeMultipleEntriesErrors != '' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-12' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { id: 'sharedErrorList',
                className: 'alert alert-danger col-xs-12' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'ul',
                null,
                changeMultipleEntriesErrors
              )
            )
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CaptainEntryChangeCaptainFormModalContainer_jsx__["a" /* default */], null)
  );
};

CaptainEntryOptions.propTypes = {
  hasSelectedEntries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  hasSelectedVirtualEntries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  changeMultipleEntriesErrors: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onChangeEntriesCaptainClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = CaptainEntryOptions;

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CaptainEntryOptions_jsx__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(51);




var mapStateToProps = function mapStateToProps(state) {
  return {
    changeMultipleEntriesErrors: state.admin.captainDetail.changeMultipleEntriesErrors,
    hasSelectedVirtualEntries: state.admin.captainDetail.hasSelectedVirtualEntries,
    hasSelectedEntries: state.admin.captainDetail.hasSelectedEntries
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onChangeEntriesCaptainClick: function onChangeEntriesCaptainClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["k" /* handleChangeEntriesCaptainClick */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CaptainEntryOptions_jsx__["a" /* default */]);

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CaptainPaymentEntryListItemContainer_jsx__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CaptainPaymentVirtualEventListItemContainer_jsx__ = __webpack_require__(768);




var CaptainPaymentEntryList = function CaptainPaymentEntryList(_ref) {
  var paymentEntries = _ref.paymentEntries,
      paymentVirtualEvents = _ref.paymentVirtualEvents;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group' },
    paymentEntries.length ? paymentEntries.map(function (paymentEntry, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'animated fadeIn',
          key: index },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__CaptainPaymentEntryListItemContainer_jsx__["a" /* default */], paymentEntry)
      );
    }) : null,
    paymentVirtualEvents.length ? paymentVirtualEvents.map(function (paymentVirtualEvent, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'animated fadeIn',
          key: index },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CaptainPaymentVirtualEventListItemContainer_jsx__["a" /* default */], paymentVirtualEvent)
      );
    }) : null
  );
};

CaptainPaymentEntryList.propTypes = {
  paymentEntries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  paymentVirtualEvents: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

CaptainPaymentEntryList.defaultProps = {
  paymentEntries: [],
  paymentVirtualEvents: []
};

/* harmony default export */ __webpack_exports__["a"] = CaptainPaymentEntryList;

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CaptainPaymentEntryList_jsx__ = __webpack_require__(759);



var mapStateToProps = function mapStateToProps(state) {
  return {
    paymentEntries: state.admin.captainDetail.paymentEntries,
    paymentVirtualEvents: state.admin.captainDetail.paymentVirtualEvents
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__CaptainPaymentEntryList_jsx__["a" /* default */]);

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_util_formatCurrency__ = __webpack_require__(27);



Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_2_shared_util_formatCurrency__["a" /* formatCurrency */];

var CaptainPaymentEntryListItem = function CaptainPaymentEntryListItem(_ref) {
  var entryId = _ref.entryId,
      reservationNumber = _ref.reservationNumber,
      eventName = _ref.eventName,
      squadDateTime = _ref.squadDateTime,
      amountApplied = _ref.amountApplied,
      onEntryLinkClick = _ref.onEntryLinkClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: { "margin-bottom": -10 } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child has-link',
          style: { width: 235, "margin-bottom": 10 },
          onClick: function onClick() {
            return onEntryLinkClick(entryId);
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Reservation No.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          reservationNumber || 'N/A'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 125, "margin-bottom": 10 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Amount Applied'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          '$' + amountApplied.formatCurrency(2)
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 250, "margin-bottom": 10 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Squad Time'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          squadDateTime ? '' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(squadDateTime).format('MMM Do, YYYY, hh:mm A') : '-'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 250, "margin-bottom": 10 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Event Name'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          eventName
        )
      )
    )
  );
};

CaptainPaymentEntryListItem.propTypes = {
  entryId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  reservationNumber: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  eventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  squadDateTime: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  amountApplied: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  onEntryLinkClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

CaptainPaymentEntryListItem.defaultProps = {
  entryId: '',
  reservationNumber: '',
  eventName: '',
  squadDateTime: '',
  amountApplied: 0
};

/* harmony default export */ __webpack_exports__["a"] = CaptainPaymentEntryListItem;

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CaptainPaymentEntryListItem_jsx__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(51);




var mapStateToProps = function mapStateToProps(state, props) {
  return props;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onEntryLinkClick: function onEntryLinkClick(entryId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["u" /* handleEntryLinkClick */])(entryId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CaptainPaymentEntryListItem_jsx__["a" /* default */]);

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CaptainPaymentListItemContainer_jsx__ = __webpack_require__(766);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var CaptainPaymentList = function CaptainPaymentList(_ref) {
  var payments = _ref.payments;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    payments.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'animated fadeIn' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group no-border no-justify-content' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          { className: 'list-heading',
            style: { "margin-bottom": 20 } },
          'Payment Log'
        ),
        payments.map(function (payment, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { key: index },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { style: { "margin-top": 5, "margin-bottom": 5 } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__CaptainPaymentListItemContainer_jsx__["a" /* default */], _extends({ key: index
            }, payment))
          );
        })
      )
    ) : null
  );
};

CaptainPaymentList.propTypes = {
  payments: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

CaptainPaymentList.defaultProps = {
  payments: []
};

/* harmony default export */ __webpack_exports__["a"] = CaptainPaymentList;

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CaptainPaymentList_jsx__ = __webpack_require__(763);



var mapStateToProps = function mapStateToProps(state) {
  return {
    payments: state.admin.captainDetail.payments
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__CaptainPaymentList_jsx__["a" /* default */]);

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_DisplayIf_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CaptainPaymentEntryListContainer_jsx__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_util_formatCurrency__ = __webpack_require__(27);





Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_4_shared_util_formatCurrency__["a" /* formatCurrency */];

var CaptainPaymentListItem = function CaptainPaymentListItem(_ref) {
  var acceptedByEmail = _ref.acceptedByEmail,
      amountPaid = _ref.amountPaid,
      displayEntries = _ref.displayEntries,
      entriesQty = _ref.entriesQty,
      notes = _ref.notes,
      checkNumber = _ref.checkNumber,
      creditCardTransactionId = _ref.creditCardTransactionId,
      onViewEntriesClick = _ref.onViewEntriesClick,
      onPrintConfirmationClick = _ref.onPrintConfirmationClick,
      paymentDateTime = _ref.paymentDateTime,
      paymentId = _ref.paymentId,
      paymentMethod = _ref.paymentMethod,
      tournamentName = _ref.tournamentName,
      tournamentTimeZoneName = _ref.tournamentTimeZoneName;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group-item-labeled' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 250, "margin-bottom": 10 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Payment Date'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(paymentDateTime).format('MMM Do, YYYY, hh:mm A') + ' (' + tournamentTimeZoneName + ')'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 125, "margin-bottom": 10 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Amount Paid'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        '$' + amountPaid.formatCurrency(2)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 200, "margin-bottom": 10 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Tournament'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        tournamentName || '-'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 100, "margin-bottom": 10 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Payment Method'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        paymentMethod || '-'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 210, "margin-bottom": 10 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Accepted By'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        acceptedByEmail || '-'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 140, "margin-bottom": 10 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        { className: 'btn btn-link',
          onClick: function onClick() {
            return onViewEntriesClick(paymentId);
          } },
        'View Entries (' + entriesQty + ')'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_shared_DisplayIf_jsx__["a" /* default */],
        { condition: amountPaid > 0 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-link',
            onClick: function onClick() {
              return onPrintConfirmationClick(paymentId);
            } },
          'Print Confirmation'
        )
      )
    ),
    checkNumber ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 210, "margin-bottom": 10 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Check Number'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        checkNumber
      )
    ) : null,
    creditCardTransactionId ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 260, "margin-bottom": 10 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Transaction ID'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        creditCardTransactionId
      )
    ) : null,
    notes ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child has-long-text full-width' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Notes'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        notes
      )
    ) : null,
    displayEntries ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CaptainPaymentEntryListContainer_jsx__["a" /* default */], null) : null
  );
};

CaptainPaymentListItem.propTypes = {
  acceptedByEmail: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  amountPaid: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  displayEntries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  entriesQty: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  notes: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  checkNumber: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  creditCardTransactionId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onViewEntriesClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onPrintConfirmationClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  paymentDateTime: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  paymentId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  paymentMethod: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  tournamentName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  tournamentTimeZoneName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

CaptainPaymentListItem.defaultProps = {
  acceptedByEmail: '',
  amountPaid: 0,
  displayEntries: false,
  entriesQty: 0,
  notes: '',
  paymentDateTime: '',
  paymentId: '',
  paymentMethod: '',
  tournamentName: '',
  tournamentTimeZoneName: ''
};

/* harmony default export */ __webpack_exports__["a"] = CaptainPaymentListItem;

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CaptainPaymentListItem_jsx__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(51);




var mapStateToProps = function mapStateToProps(state, props) {
  return props;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onViewEntriesClick: function onViewEntriesClick(paymentId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["s" /* handleViewEntriesClick */])(paymentId));
    },
    onPrintConfirmationClick: function onPrintConfirmationClick(paymentId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["t" /* handlePrintConfirmationClick */])(paymentId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CaptainPaymentListItem_jsx__["a" /* default */]);

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_util_formatCurrency__ = __webpack_require__(27);


Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_1_shared_util_formatCurrency__["a" /* formatCurrency */];

var CaptainPaymentEntryListItem = function CaptainPaymentEntryListItem(_ref) {
  var virtualEventId = _ref.virtualEventId,
      eventName = _ref.eventName,
      amountApplied = _ref.amountApplied,
      onVirtualEventLinkClick = _ref.onVirtualEventLinkClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group-item-labeled' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child has-link',
        style: { width: 235 },
        onClick: function onClick() {
          return onVirtualEventLinkClick(virtualEventId);
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Virtual Event'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        eventName || '-'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 125 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Amount Applied'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        '$' + amountApplied.formatCurrency(2)
      )
    )
  );
};

CaptainPaymentEntryListItem.propTypes = {
  virtualEventId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  eventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  amountApplied: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  onVirtualEventLinkClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

CaptainPaymentEntryListItem.defaultProps = {
  virtualEventId: '',
  eventName: '',
  amountApplied: 0
};

/* harmony default export */ __webpack_exports__["a"] = CaptainPaymentEntryListItem;

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CaptainPaymentVirtualEventListItem_jsx__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(51);




var mapStateToProps = function mapStateToProps(state, props) {
  return props;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onVirtualEventLinkClick: function onVirtualEventLinkClick(virtualEventId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["h" /* handleVirtualEventLinkClick */])(virtualEventId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CaptainPaymentVirtualEventListItem_jsx__["a" /* default */]);

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_util_formatCurrency__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_DisplayIf_jsx__ = __webpack_require__(12);





Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_3_shared_util_formatCurrency__["a" /* formatCurrency */];

var Entry = function Entry(_ref) {
  var balanceDue = _ref.balanceDue,
      eventName = _ref.eventName,
      name = _ref.name,
      entryNumber = _ref.entryNumber,
      id = _ref.id,
      tournamentId = _ref.tournamentId,
      isCancelled = _ref.isCancelled,
      selected = _ref.selected,
      selectable = _ref.selectable,
      squadDateTime = _ref.squadDateTime,
      timeZoneDisplayName = _ref.timeZoneDisplayName,
      onSelectChecked = _ref.onSelectChecked,
      onNavigationClick = _ref.onNavigationClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group-item-labeled' },
    isCancelled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-group-item-labeled-child custom-checkbox-container',
      style: { width: 25 } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child custom-checkbox-container',
        style: { width: 25 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
        type: 'checkbox',
        id: 'entry-' + id,
        disabled: !selectable,
        checked: selected,
        onChange: function onChange() {
          return onSelectChecked(tournamentId, id);
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', {
        htmlFor: 'entry-' + id })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 125 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Event Name'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        '' + eventName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 250 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Team Name'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        name
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      { className: 'list-group-item-labeled-child has-link',
        style: { width: 120 },
        onClick: function onClick() {
          return onNavigationClick('admin/entry/' + id);
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Reservation Number'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        entryNumber || '-'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_shared_DisplayIf_jsx__["a" /* default */],
      { condition: __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(squadDateTime).second() === 10 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 250, color: 'red' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Date'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          squadDateTime ? __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(squadDateTime).format('hh:mm A, MMM Do, YYYY') + '\n            (' + timeZoneDisplayName + ')' : isCancelled ? 'CANCELLED' : '-'
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_shared_DisplayIf_jsx__["a" /* default */],
      { condition: __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(squadDateTime).second() === 0 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 250 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Date'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          squadDateTime ? __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(squadDateTime).format('hh:mm A, MMM Do, YYYY') + '\n            (' + timeZoneDisplayName + ')' : isCancelled ? 'CANCELLED' : '-'
        )
      )
    ),
    isCancelled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-group-item-labeled-child',
      style: { width: 145 } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('list-group-item-labeled-child', { 'bg-danger': balanceDue }),
        style: { width: 145, height: 40, alignItems: 'center', justifyContent: 'center' } },
      balanceDue ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'strong',
        { className: 'flex center' },
        '$' + balanceDue.formatCurrency(2) + ' DUE'
      ) : null
    )
  );
};

Entry.propTypes = {
  addressBase: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  balanceDue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  eventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  name: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  entryNumber: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  squadDateTime: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  timeZoneDisplayName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  id: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  tournamentId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  isCancelled: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  selected: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  selectable: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onSelectChecked: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onNavigationClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

Entry.defaultProps = {
  balanceDue: 0
};

/* harmony default export */ __webpack_exports__["a"] = Entry;

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Entry_jsx__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var mapStateToProps = function mapStateToProps(props) {
  return _extends({}, props);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onEntryClick: function onEntryClick(entryId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["i" /* handleEntryClick */])(entryId));
    },
    onSelectChecked: function onSelectChecked(tournamentId, entryId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["j" /* handleEntrySelectChecked */])(tournamentId, entryId));
    },
    onNavigationClick: function onNavigationClick(route) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_actions__["b" /* navigateTo */])(route));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__Entry_jsx__["a" /* default */]);

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EntryContainer_jsx__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VirtualEventContainer_jsx__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_util_formatCurrency__ = __webpack_require__(27);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_3_shared_util_formatCurrency__["a" /* formatCurrency */];

var TournamentEntry = function TournamentEntry(_ref) {
  var id = _ref.id,
      name = _ref.name,
      collapsed = _ref.collapsed,
      entries = _ref.entries,
      virtualEvents = _ref.virtualEvents,
      eventSummaries = _ref.eventSummaries,
      onCollapseTournament = _ref.onCollapseTournament,
      balanceDue = _ref.balanceDue;

  var eventSummariesText = '';

  eventSummaries.map(function (item) {
    if (eventSummariesText != '') eventSummariesText = eventSummariesText + ', ';
    eventSummariesText = '' + eventSummariesText + item.name + ' (' + item.count + ')';
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: { display: 'flex' } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h3',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { onClick: function onClick() {
              return onCollapseTournament(id);
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: collapsed ? "fa fa-expand" : "fa fa-compress",
            style: { marginRight: '14px' } })
        ),
        name + ' - Balance Due: $' + balanceDue.formatCurrency(2)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { flex: '30%' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { style: { marginBottom: '0px', marginLeft: '10px', marginTop: '29px' } },
            eventSummariesText
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { id: 'entries',
        className: collapsed ? "collapse" : "collapse in" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group' },
        entries.map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__EntryContainer_jsx__["a" /* default */], _extends({
            key: index
          }, item));
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group' },
        virtualEvents.map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__VirtualEventContainer_jsx__["a" /* default */], _extends({
            key: index
          }, item));
        })
      )
    )
  );
};

TournamentEntry.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  name: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  collapsed: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCollapseTournament: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  entries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  virtualEvents: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  eventSummaries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  balanceDue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number
};

TournamentEntry.defaultProps = {
  name: '',
  collapsed: false,
  entries: [],
  virtualEvents: [],
  eventSummaries: [],
  balanceDue: 0
};

/* harmony default export */ __webpack_exports__["a"] = TournamentEntry;

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TournamentEntry_jsx__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(134);




var mapStateToProps = function mapStateToProps(state) {
  return state.admin.captainDetail;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCollapseTournament: function onCollapseTournament(tournamentId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["s" /* setTournamentCollapsed */])(tournamentId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__TournamentEntry_jsx__["a" /* default */]);

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_util_formatCurrency__ = __webpack_require__(27);



Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_2_shared_util_formatCurrency__["a" /* formatCurrency */];

var VirtualEvent = function VirtualEvent(_ref) {
  var balanceDue = _ref.balanceDue,
      selectable = _ref.selectable,
      selected = _ref.selected,
      tournamentId = _ref.tournamentId,
      virtualEventId = _ref.virtualEventId,
      virtualEventName = _ref.virtualEventName,
      onSelectChecked = _ref.onSelectChecked,
      onVirtualEventLinkClick = _ref.onVirtualEventLinkClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group-item-labeled' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child custom-checkbox-container',
        style: { width: 25 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
        type: 'checkbox',
        id: 'entry-' + virtualEventId,
        disabled: !selectable,
        checked: selected,
        onChange: function onChange() {
          return onSelectChecked(tournamentId, virtualEventId);
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', {
        htmlFor: 'entry-' + virtualEventId })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child has-link',
        style: { width: 860 },
        onClick: function onClick() {
          return onVirtualEventLinkClick(virtualEventId);
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Virtual Event'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        virtualEventName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('list-group-item-labeled-child', { 'bg-danger': balanceDue }),
        style: { width: 145, height: 40, alignItems: 'center', justifyContent: 'center' } },
      balanceDue ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'strong',
        { className: 'flex center' },
        '$' + balanceDue.formatCurrency(2) + ' DUE'
      ) : null
    )
  );
};

VirtualEvent.propTypes = {
  balanceDue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  selectable: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  selected: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  tournamentId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  virtualEventId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  virtualEventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onSelectChecked: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onVirtualEventLinkClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

VirtualEvent.defaultProps = {
  balanceDue: 0
};

/* harmony default export */ __webpack_exports__["a"] = VirtualEvent;

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualEvent_jsx__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(51);




var mapStateToProps = function mapStateToProps(state, props) {
  return props;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSelectChecked: function onSelectChecked(tournamentId, entryId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["g" /* handleVirtualEventSelectChecked */])(tournamentId, entryId));
    },
    onVirtualEventLinkClick: function onVirtualEventLinkClick(virtualEventId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["h" /* handleVirtualEventLinkClick */])(virtualEventId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__VirtualEvent_jsx__["a" /* default */]);

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(417);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  balance: 0,
  captainEmail: '',
  captainId: '',
  captainName: '',
  captainFirstName: '',
  captainLastName: '',
  captainAddress1: '',
  captainAddress2: '',
  captainCity: '',
  captainState: '',
  captainCountry: '',
  captainZip: '',
  captainPhoneNumber: '',
  notes: '',
  changeMultipleEntriesErrors: '',
  payments: [],
  paymentEntries: [],
  paymentVirtualEvents: [],
  selectedBalance: 0,
  hasSelectedEntries: false,
  hasSelectedVirtualEntries: false,
  canChangeEntriesCaptain: false,
  selectedEntriesWithoutBalance: false,
  showNotesModal: false,
  showPaymentModal: false,
  showUpdateModal: false,
  hideCancelledEntries: true,
  hideArchivedEntries: true,
  tournaments: [],
  loadingTournaments: true,
  showCaptainEntryChangeCaptainModal: false,
  isNewCaptainOnSearch: false,
  affectedVirtualEntries: [],
  allAffectedVirtualEntriesSelected: false,
  validationMessages: null
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["t" /* RESET_CAPTAIN_DETAILS_FOR_ADMIN */]:
      return _extends({}, state, initialState);
    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_CHANGE_MULTIPLE_ENTRIES_ERRORS */]:
      return _extends({}, state, {
        changeMultipleEntriesErrors: payload
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* CHANGE_HIDE_CANCELLED_ENTRIES */]:
      return _extends({}, state, {
        hideCancelledEntries: payload,
        loadingTournaments: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* CHANGE_HIDE_ARCHIVED_ENTRIES */]:
      return _extends({}, state, {
        hideArchivedEntries: payload,
        loadingTournaments: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DISPLAY_UPDATE_MODAL_FOR_ADMIN_CAPTAIN_DETAIL */]:
      return _extends({}, state, {
        showUpdateModal: payload || initialState.showUpdateModal
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_PAYMENT_VIRTUAL_EVENTS_FOR_ADMIN_CAPTAIN_DETAIL */]:
      return _extends({}, state, {
        paymentVirtualEvents: payload || initialState.paymentVirtualEvents
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* DISPLAY_PAYMENT_ENTRIES_FOR_ADMIN_CAPTAIN_DETAIL */]:
      return _extends({}, state, {
        payments: state.payments.map(function (x) {
          return paymentReducer(x, { type: type, payload: payload });
        })
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* SET_PAYMENT_ENTRIES_FOR_ADMIN_CAPTAIN_DETAIL */]:
      return _extends({}, state, {
        paymentEntries: payload || initialState.paymentEntries
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* SET_PAYMENTS_FOR_ADMIN_CAPTAIN_DETAIL */]:
      return _extends({}, state, {
        payments: payload || initialState.payments
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* DISPLAY_NOTES_MODAL_FOR_ADMIN_CAPTAIN_DETAIL */]:
      return _extends({}, state, {
        showNotesModal: payload || initialState.showNotesModal
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["s" /* DISPLAY_PAYMENT_MODAL_FOR_ADMIN_CAPTAIN_DETAIL */]:
      {
        return _extends({}, state, {
          showPaymentModal: payload || initialState.showPaymentModal
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["r" /* DISABLE_OTHER_TOURNAMENT_SELECTION_FOR_ADMIN_CAPTAIN_DETAIL */]:
      {
        var newPayload = {
          tournamentId: payload,
          anySelected: false
        };

        state.tournaments.forEach(function (t) {
          if (newPayload.anySelected) return;
          newPayload.anySelected = t.entries.some(function (entry) {
            return !!entry.selected;
          }) || t.virtualEvents.some(function (virtualEvent) {
            return !!virtualEvent.selected;
          });
        });

        return _extends({}, state, {
          tournaments: state.tournaments.map(function (x) {
            return tournamentReducer(x, { type: type, payload: newPayload });
          })
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["o" /* SET_CAPTAIN_SELECTED_TOURNAMENT_ENTRY_FOR_ADMIN */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* SET_CAPTAIN_SELECTED_TOURNAMENT_VIRTUAL_EVENT_FOR_ADMIN */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants__["p" /* SET_CAPTAIN_COLLAPSED_TOURNAMENT_FOR_ADMIN */]:
      return _extends({}, state, {
        tournaments: state.tournaments.map(function (x) {
          return tournamentReducer(x, { type: type, payload: payload });
        })
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["q" /* CALCULATE_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_DETAIL */]:
      {
        var selectedBalance = 0;
        var hasSelectedEntries = false;
        var hasSelectedVirtualEntries = false;
        var canChangeEntriesCaptain = false;
        var selectedEntriesWithoutBalance = false;

        state.tournaments.forEach(function (t) {
          selectedBalance += t.entries.filter(function (entry) {
            return entry.selected;
          }).reduce(function (sum, entry) {
            return sum + entry.balanceDue;
          }, 0);
          selectedBalance += t.virtualEvents.filter(function (virtualEvent) {
            return virtualEvent.selected;
          }).reduce(function (sum, virtualEvent) {
            return sum + virtualEvent.balanceDue;
          }, 0);

          if (t.entries.filter(function (entry) {
            return entry.selected;
          }).length > 0) hasSelectedEntries = true;

          if (t.virtualEvents.filter(function (entry) {
            return entry.selected;
          }).length > 0) hasSelectedVirtualEntries = true;

          if (hasSelectedEntries && !hasSelectedVirtualEntries) canChangeEntriesCaptain = true;

          if (t.entries.filter(function (entry) {
            return entry.selected && entry.balanceDue == 0;
          }).length > 0 || t.virtualEvents.filter(function (entry) {
            return entry.selected && entry.balanceDue == 0;
          }).length > 0) selectedEntriesWithoutBalance = true;
        });

        return _extends({}, state, {
          selectedBalance: selectedBalance,
          hasSelectedEntries: hasSelectedEntries,
          hasSelectedVirtualEntries: hasSelectedVirtualEntries,
          changeMultipleEntriesErrors: '',
          canChangeEntriesCaptain: canChangeEntriesCaptain,
          selectedEntriesWithoutBalance: selectedEntriesWithoutBalance
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* SET_CAPTAIN_ENTRIES_BY_TOURNAMENT_FOR_ADMIN */]:
      {
        var tournaments = initialState.tournaments;

        if (payload) {
          // set default state on nested arrays
          tournaments = payload.map(function (x) {
            return _extends({}, x, {
              selected: false,
              collapsed: false,
              entries: x.entries.map(function (y) {
                return _extends({}, y, {
                  selected: false,
                  selectable: true,
                  hasBalance: y.balanceDue > 0
                });
              }),
              virtualEvents: x.virtualEvents.map(function (z) {
                return _extends({}, z, {
                  selected: false,
                  selectable: true,
                  hasBalance: z.balanceDue > 0
                });
              })
            });
          });
        }

        return _extends({}, state, {
          tournaments: tournaments,
          loadingTournaments: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* SET_CAPTAIN_DETAILS_FOR_ADMIN */]:
      {
        return payload ? _extends({}, state, {
          captainName: payload.captainName || initialState.captainName,
          captainFirstName: payload.captainFirstName || initialState.captainFirstName,
          captainLastName: payload.captainLastName || initialState.captainLastName,
          captainEmail: payload.captainEmail || initialState.captainEmail,
          captainAddress1: payload.captainAddress1 || initialState.captainAddress1,
          captainAddress2: payload.captainAddress2 || initialState.captainAddress2,
          captainCity: payload.captainCity || initialState.captainCity,
          captainState: payload.captainState || initialState.captainState,
          captainCountry: payload.captainCountry || initialState.captainCountry,
          captainZip: payload.captainZip || initialState.captainZip,
          captainPhoneNumber: payload.captainPhoneNumber || initialState.captainPhoneNumber,
          captainId: payload.captainId || initialState.captainId,
          notes: payload.notes || initialState.notes
        }) : state;
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* SET_CAPTAIN_BALANCE_DUE_FOR_ADMIN */]:
      {
        return _extends({}, state, {
          balance: payload || initialState.balance
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["w" /* SET_IS_NEW_CAPTAIN_ENTRIES_MODAL_FOR_ADMIN */]:
      {
        return _extends({}, state, {
          isNewCaptainOnSearch: payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["v" /* HIDE_CAPTAIN_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants__["u" /* SHOW_CAPTAIN_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN */]:
      {
        return _extends({}, state, {
          showCaptainEntryChangeCaptainModal: payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["x" /* SET_AFFECTED_VIRTUAL_ENTRIES_FOR_ADMIN */]:
      {
        var affectedVirtualEntries = payload;

        affectedVirtualEntries.filter(function (entry) {
          return entry.entryName !== null;
        }).forEach(function (entry) {
          return entry.selected = true;
        });

        return _extends({}, state, {
          affectedVirtualEntries: affectedVirtualEntries
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* SET_SELECTED_AFFECTED_VIRTUAL_ENTRY */]:
      {
        var newAffectedVirtualEntries = state.affectedVirtualEntries.slice();
        var selectedEntry = newAffectedVirtualEntries.filter(function (entry) {
          return entry.virtualEntryId == payload.virtualEntryId;
        })[0];

        if (selectedEntry) {
          selectedEntry.selected = payload.selected;
        }

        var newAllAffectedVirtualEntriesSelected = newAffectedVirtualEntries.every(function (entry) {
          return entry.selected;
        });

        return _extends({}, state, {
          affectedVirtualEntries: newAffectedVirtualEntries,
          allAffectedVirtualEntriesSelected: newAllAffectedVirtualEntriesSelected
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["z" /* SET_ALL_AFFECTED_VIRTUAL_ENTRIES_SELECTED */]:
      {
        var _newAffectedVirtualEntries = state.affectedVirtualEntries.slice();
        var _newAllAffectedVirtualEntriesSelected = !state.allAffectedVirtualEntriesSelected;

        _newAffectedVirtualEntries.forEach(function (entry) {
          return entry.selected = _newAllAffectedVirtualEntriesSelected;
        });

        return _extends({}, state, {
          affectedVirtualEntries: _newAffectedVirtualEntries,
          allAffectedVirtualEntriesSelected: _newAllAffectedVirtualEntriesSelected
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_VALIDATION_MESSAGES_FOR_CAPTAIN_DETAIL */]:
      return _extends({}, state, {
        validationMessages: payload
      });

    default:
      return state;
  }
};

var tournamentReducer = function tournamentReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["r" /* DISABLE_OTHER_TOURNAMENT_SELECTION_FOR_ADMIN_CAPTAIN_DETAIL */]:
      {
        state.selected = state.id === payload.tournamentId && payload.anySelected;
        return _extends({}, state, {
          entries: state.entries.map(function (x) {
            return entryReducer(x, { type: type, payload: payload });
          }),
          virtualEvents: state.virtualEvents.map(function (x) {
            return entryReducer(x, { type: type, payload: payload });
          })
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* SET_CAPTAIN_SELECTED_TOURNAMENT_VIRTUAL_EVENT_FOR_ADMIN */]:
      return state.id === payload.tournamentId ? _extends({}, state, {
        virtualEvents: state.virtualEvents.map(function (x) {
          return virtualEventReducer(x, { type: type, payload: payload });
        })
      }) : state;
    case __WEBPACK_IMPORTED_MODULE_0__constants__["o" /* SET_CAPTAIN_SELECTED_TOURNAMENT_ENTRY_FOR_ADMIN */]:
      return state.id === payload.tournamentId ? _extends({}, state, {
        entries: state.entries.map(function (x) {
          return entryReducer(x, { type: type, payload: payload });
        })
      }) : state;
    case __WEBPACK_IMPORTED_MODULE_0__constants__["p" /* SET_CAPTAIN_COLLAPSED_TOURNAMENT_FOR_ADMIN */]:
      {
        return state.id === payload.tournamentId ? _extends({}, state, {
          collapsed: !state.collapsed
        }) : state;
      }
    default:
      return state;
  }
};

var entryReducer = function entryReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref3 = arguments[1];
  var type = _ref3.type,
      payload = _ref3.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["r" /* DISABLE_OTHER_TOURNAMENT_SELECTION_FOR_ADMIN_CAPTAIN_DETAIL */]:
      {
        var isSelectable = state.tournamentId === payload.tournamentId || !payload.anySelected;

        return _extends({}, state, {
          selectable: isSelectable,
          hasBalance: state.balanceDue > 0
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["o" /* SET_CAPTAIN_SELECTED_TOURNAMENT_ENTRY_FOR_ADMIN */]:
      {
        return state.id === payload.entryId ? _extends({}, state, {
          selected: !state.selected
        }) : state;
      }
    default:
      return state;
  }
};

var virtualEventReducer = function virtualEventReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref4 = arguments[1];
  var type = _ref4.type,
      payload = _ref4.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* SET_CAPTAIN_SELECTED_TOURNAMENT_VIRTUAL_EVENT_FOR_ADMIN */]:
      {
        return state.virtualEventId === payload.virtualEventId ? _extends({}, state, {
          selected: !state.selected
        }) : state;
      }
    default:
      return state;
  }
};

var paymentReducer = function paymentReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref5 = arguments[1];
  var type = _ref5.type,
      payload = _ref5.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* DISPLAY_PAYMENT_ENTRIES_FOR_ADMIN_CAPTAIN_DETAIL */]:
      {
        return _extends({}, state, {
          displayEntries: state.paymentId === payload ? !state.displayEntries : false
        });
      }
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EntryPaymentLogContainer_jsx__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_DisplayIf__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_util_formatCurrency__ = __webpack_require__(27);




Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_3_shared_util_formatCurrency__["a" /* formatCurrency */];

var BalanceDetail = function BalanceDetail(_ref) {
  var balance = _ref.balance,
      showPaymentLog = _ref.showPaymentLog,
      isCancelled = _ref.isCancelled,
      onPaymentLogClick = _ref.onPaymentLogClick,
      onEntryDetailPaymentClick = _ref.onEntryDetailPaymentClick,
      onEntryDetailCreditCardPaymentClick = _ref.onEntryDetailCreditCardPaymentClick,
      onRefundClick = _ref.onRefundClick,
      enabledWebHooks = _ref.enabledWebHooks,
      onWebHooksClick = _ref.onWebHooksClick,
      environment = _ref.environment;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-heading',
          style: { paddingTop: 15 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row flex vertical-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-2',
              style: { marginTop: 5 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h1',
              { className: 'panel-title' },
              'Team Balance'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-3',
              style: { marginTop: 5 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'panel-title' },
              '$' + balance.formatCurrency(2)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-7 flex vertical-center right',
              style: { marginTop: 5 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              {
                style: { fontSize: 18, minWidth: 150, marginLeft: 10 },
                className: 'btn btn-link',
                type: 'button',
                onClick: function onClick() {
                  return onPaymentLogClick();
                } },
              'Payment Log'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              {
                style: { mindWidth: 150, marginLeft: 10 },
                className: 'btn btn-default btn-lg',
                type: 'button',
                onClick: function onClick() {
                  return onRefundClick();
                } },
              'Refund'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_shared_DisplayIf__["a" /* default */],
              { condition: !!balance && !isCancelled },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                {
                  style: { minWidth: 150, marginLeft: 10 },
                  className: 'btn btn-default btn-lg',
                  type: 'button',
                  onClick: function onClick() {
                    return onEntryDetailPaymentClick();
                  } },
                'Cash/Check'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                {
                  style: { minWidth: 150, marginLeft: 10 },
                  className: 'btn btn-primary btn-lg',
                  type: 'button',
                  onClick: function onClick() {
                    return onEntryDetailCreditCardPaymentClick();
                  } },
                'Credit Card'
              )
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-body',
          style: { padding: 0 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_shared_DisplayIf__["a" /* default */],
          { condition: !!balance && !isCancelled && environment != 'PROD' && environment != 'PRODUCTION',
            className: 'custom-checkbox-container',
            style: { float: "right", paddingRight: 15 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'checkbox',
            id: 'webHooks',
            checked: enabledWebHooks,
            onChange: function onChange(event) {
              return onWebHooksClick(event.target.checked);
            } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            { htmlFor: 'webHooks' },
            'Click here to process payments in real time.'
          )
        )
      )
    ),
    showPaymentLog ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'animated fadeIn' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__EntryPaymentLogContainer_jsx__["a" /* default */], null)
    ) : null
  );
};

BalanceDetail.propTypes = {
  balance: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  showPaymentLog: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  isCancelled: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onPaymentLogClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onEntryDetailPaymentClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onEntryDetailCreditCardPaymentClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onRefundClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  enabledWebHooks: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onWebHooksClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  environment: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

BalanceDetail.defaultProps = {
  balance: 0,
  showPaymentLog: false,
  isCancelled: false
};

/* harmony default export */ __webpack_exports__["a"] = BalanceDetail;

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BalanceDetail_jsx__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_webHooks_actions__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_variables__ = __webpack_require__(38);






var mapStateToProps = function mapStateToProps(state) {
  return {
    balance: state.admin.entryDetail.balance,
    showPaymentLog: state.admin.entryDetail.showPaymentLog,
    isCancelled: state.admin.entryDetail.isCancelled,
    selectedEntriesWithoutBalance: state.admin.captainDetail.selectedEntriesWithoutBalance,
    environment: __WEBPACK_IMPORTED_MODULE_4_shared_variables__["h" /* ENVIRONMENT */]
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onPaymentLogClick: function onPaymentLogClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["S" /* handlePaymentLogClick */])());
    },
    onEntryDetailPaymentClick: function onEntryDetailPaymentClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["Q" /* handleEntryDetailPaymentClick */])());
    },
    onEntryDetailCreditCardPaymentClick: function onEntryDetailCreditCardPaymentClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["T" /* handleEntryDetailCreditCardPaymentClick */])());
    },
    onRefundClick: function onRefundClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["U" /* handleEntryDetailRefundClick */])());
    },
    onWebHooksClick: function onWebHooksClick(checked) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_webHooks_actions__["a" /* handleWebHooksClick */])(checked));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__BalanceDetail_jsx__["a" /* default */]);

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_Panel_jsx__ = __webpack_require__(44);



var EntryCancel = function EntryCancel(_ref) {
  var readOnly = _ref.readOnly,
      isCancelled = _ref.isCancelled,
      onEntryDetailCancelEntryClick = _ref.onEntryDetailCancelEntryClick,
      onEntryDetailReactivateEntryClick = _ref.onEntryDetailReactivateEntryClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_shared_Panel_jsx__["a" /* default */],
    {
      className: 'panel-primary',
      title: isCancelled ? "Reactivate Entry" : "Cancel Entry",
      style: {} },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-sm-12' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group' },
          isCancelled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              'This entry has already been canceled'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              'If you would like to reactivate this entry, please click the button below'
            )
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            'Clicking the button below will cancel the entry, remove them from their squad, and allow you to enter in any amount you refunded them.'
          )
        )
      )
    ),
    isCancelled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-sm-12' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'submit',
            className: 'btn btn-default pull-right',
            style: { borderRadius: 10 },
            onClick: function onClick() {
              return onEntryDetailReactivateEntryClick();
            } },
          'Reactivate'
        )
      )
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-sm-12' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'submit',
            className: 'btn btn-default pull-right',
            style: { borderRadius: 10 },
            onClick: function onClick() {
              return onEntryDetailCancelEntryClick();
            },
            disabled: readOnly },
          'Cancel'
        )
      )
    )
  );
};

EntryCancel.propTypes = {
  readOnly: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  isCancelled: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onEntryDetailCancelEntryClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onEntryDetailReactivateEntryClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

EntryCancel.defaultProps = {
  readOnly: false,
  isCancelled: false
};

/* harmony default export */ __webpack_exports__["a"] = EntryCancel;

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EntryCancel_jsx__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(42);




var mapStateToProps = function mapStateToProps(state) {
  return state.admin.entryDetail;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onEntryDetailCancelEntryClick: function onEntryDetailCancelEntryClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["t" /* handleEntryDetailCancelEntryClick */])());
    },
    onEntryDetailReactivateEntryClick: function onEntryDetailReactivateEntryClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["u" /* handleEntryDetailReactivateEntryClick */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__EntryCancel_jsx__["a" /* default */]);

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EntryCaptainChangeFormModal_jsx__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__captainDetail_actionTypes__ = __webpack_require__(134);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var mapStateToProps = function mapStateToProps(state) {
  return _extends({
    visible: state.admin.entryDetail.showEntryDetailChangeCaptainModal,
    isNew: state.admin.entryDetail.isNew,
    submitButtonText: state.admin.entryDetail.isNew ? 'Create' : 'Update'
  }, state.admin.entryDetail.coordinator, {
    validate: __WEBPACK_IMPORTED_MODULE_2__actions__["i" /* validateEntryCaptainChangeForm */],
    affectedVirtualEntries: state.admin.captainDetail.affectedVirtualEntries,
    allAffectedVirtualEntriesSelected: state.admin.captainDetail.allAffectedVirtualEntriesSelected
  });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["j" /* handleEntryChangeCaptainCancelClick */])());
    },
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["k" /* handleEntryCaptainChangeFormSave */])(data));
    },
    onSearchClick: function onSearchClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["l" /* handleEntryChangeCaptainSearchClick */])());
    },
    onSelectAllChecked: function onSelectAllChecked() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__captainDetail_actionTypes__["y" /* setAllAffectedVirtualEntriesSelected */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__EntryCaptainChangeFormModal_jsx__["b" /* default */]);

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_Link_jsx__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_Panel_jsx__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__ = __webpack_require__(12);





var EntryCaptainDetails = function EntryCaptainDetails(_ref) {
  var captainId = _ref.captainId,
      captainFirstName = _ref.captainFirstName,
      captainLastName = _ref.captainLastName,
      captainEmail = _ref.captainEmail,
      readOnly = _ref.readOnly,
      onChangeCaptainClick = _ref.onChangeCaptainClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_shared_Panel_jsx__["a" /* default */],
    {
      className: 'panel-primary',
      title: 'Captain Details',
      style: {} },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-sm-12' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            captainFirstName,
            ' ',
            captainLastName
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            captainEmail
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-sm-6' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_shared_Link_jsx__["a" /* default */],
          { className: 'btn btn-link',
            to: 'admin/captain/' + captainId },
          'View Captain'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-sm-6' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
          { condition: !readOnly },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'submit',
              className: 'btn btn-link pull-right',
              onClick: function onClick() {
                return onChangeCaptainClick();
              } },
            'Change Team Captain'
          )
        )
      )
    )
  );
};

EntryCaptainDetails.propTypes = {
  captainId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  captainFirstName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  captainLastName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  captainEmail: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  readOnly: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onChangeCaptainClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

EntryCaptainDetails.defaultProps = {
  captainId: '',
  firstName: '',
  lastName: '',
  email: '',
  readOnly: false
};

/* harmony default export */ __webpack_exports__["a"] = EntryCaptainDetails;

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EntryCaptainDetail_jsx__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(42);




var mapStateToProps = function mapStateToProps(state) {
  return state.admin.entryDetail.captain;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onChangeCaptainClick: function onChangeCaptainClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["m" /* handleEntryDetailChangeCaptainClick */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__EntryCaptainDetail_jsx__["a" /* default */]);

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_Panel_jsx__ = __webpack_require__(44);



var EntryCoordinatorDetails = function EntryCoordinatorDetails(_ref) {
  var firstName = _ref.firstName,
      lastName = _ref.lastName,
      email = _ref.email,
      onEntryDetailCoordinatorUpdateClick = _ref.onEntryDetailCoordinatorUpdateClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_shared_Panel_jsx__["a" /* default */],
    {
      className: 'panel-primary',
      title: 'Coordinator Details',
      style: {} },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-sm-12' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            firstName,
            ' ',
            lastName
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            email
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-sm-12' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'submit',
            className: 'btn btn-link pull-right',
            onClick: function onClick() {
              return onEntryDetailCoordinatorUpdateClick();
            } },
          'Update'
        )
      )
    )
  );
};

EntryCoordinatorDetails.propTypes = {
  firstName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  lastName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  email: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onEntryDetailCoordinatorUpdateClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

EntryCoordinatorDetails.defaultProps = {
  firstName: '',
  lastName: '',
  email: ''
};

/* harmony default export */ __webpack_exports__["a"] = EntryCoordinatorDetails;

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EntryCoordinatorDetail_jsx__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(42);




var mapStateToProps = function mapStateToProps(state) {
  return state.admin.entryDetail.coordinator;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onEntryDetailCoordinatorUpdateClick: function onEntryDetailCoordinatorUpdateClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["h" /* handleEntryDetailCoordinatorUpdateClick */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__EntryCoordinatorDetail_jsx__["a" /* default */]);

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_Link_jsx__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EntryCaptainDetailContainer_jsx__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EntryCoordinatorDetailContainer_jsx__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EntryDetailSummaryContainer_jsx__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BalanceDetailContainer_jsx__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EntryDetailPaymentModalContainer_jsx__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EntryDetailSquadChangeModalContainer_jsx__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EntryDetailEventChangeModalContainer_jsx__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EntryDetailCoordinatorModalContainer_jsx__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__EntryCaptainChangeFormModalContainer_jsx__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__EntryCancelContainer_jsx__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__EntryDetailRefundModalContainer_jsx__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__EntryDetailReactivationModalContainer_jsx__ = __webpack_require__(794);















var EntryDetail = function EntryDetail(_ref) {
  var showSearchLink = _ref.showSearchLink;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'animated fadeIn' },
    showSearchLink ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-md-12' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_shared_Link_jsx__["a" /* default */],
          {
            className: 'btn btn-link',
            style: { paddingLeft: 0 },
            to: 'admin/search' },
          'Back to search results'
        )
      )
    ) : null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-md-12' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__BalanceDetailContainer_jsx__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__EntryDetailPaymentModalContainer_jsx__["a" /* default */], null)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-md-6' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__EntryDetailSummaryContainer_jsx__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__EntryDetailSquadChangeModalContainer_jsx__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__EntryDetailEventChangeModalContainer_jsx__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__EntryCancelContainer_jsx__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__EntryDetailRefundModalContainer_jsx__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__EntryDetailReactivationModalContainer_jsx__["a" /* default */], null)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-md-6' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__EntryCaptainDetailContainer_jsx__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__EntryCaptainChangeFormModalContainer_jsx__["a" /* default */], null)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-md-6' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__EntryCoordinatorDetailContainer_jsx__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__EntryDetailCoordinatorModalContainer_jsx__["a" /* default */], null)
      )
    )
  );
};

EntryDetail.propTypes = {
  showSearchLink: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool
};

EntryDetail.defaultProps = {
  showSearchLink: false
};

/* harmony default export */ __webpack_exports__["a"] = EntryDetail;

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EntryDetail_jsx__ = __webpack_require__(785);



var mapStateToProps = function mapStateToProps(state) {
  return {
    showSearchLink: !!state.admin.home.searchValue
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__EntryDetail_jsx__["a" /* default */]);

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardModal_jsx__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);






var EntryDetailCoordinatorModal = function EntryDetailCoordinatorModal(_ref) {
  var visible = _ref.visible,
      onCancelClick = _ref.onCancelClick,
      handleSubmit = _ref.handleSubmit,
      onSubmit = _ref.onSubmit;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_shared_StandardModal_jsx__["a" /* default */],
    {
      title: 'Update Coordinator',
      visible: visible,
      onCloseClick: onCancelClick },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'form',
      { onSubmit: handleSubmit(onSubmit) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-6' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], { name: 'firstName',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'First Name' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-6' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], { name: 'lastName',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'Last Name' })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], { name: 'email',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'Email' })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'form-group text-right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-link',
            onClick: function onClick() {
              return onCancelClick();
            }
          },
          'Cancel'
        ),
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'submit',
            className: 'btn btn-primary btn-lg'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
          ' ',
          'Save'
        )
      )
    )
  );
};

EntryDetailCoordinatorModal.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'adminEntryCoordinatorDetailForm'
})(EntryDetailCoordinatorModal);

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EntryDetailCoordinatorModal_jsx__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(42);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var mapStateToProps = function mapStateToProps(state) {
  return _extends({
    visible: state.admin.entryDetail.showEntryDetailCoordinatorModal
  }, state.admin.entryDetail.coordinator);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["e" /* handleEntryDetailCoordinatorUpdateCancelClick */])());
    },
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* handleCoordinatorSave */])(data));
    },
    validate: __WEBPACK_IMPORTED_MODULE_2__actions__["g" /* validateEntryCoordinatorDetailForm */]
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__EntryDetailCoordinatorModal_jsx__["a" /* default */]);

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_StandardModal_jsx__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);







var required = function required(value) {
  return value ? undefined : 'Required';
};

var EntryDetailSquadChangeModal = function EntryDetailSquadChangeModal(_ref) {
  var availableEvents = _ref.availableEvents,
      visible = _ref.visible,
      onCancel = _ref.onCancel,
      handleSubmit = _ref.handleSubmit,
      onSubmit = _ref.onSubmit,
      entryId = _ref.entryId;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_shared_StandardModal_jsx__["a" /* default */],
    {
      title: 'Change Event',
      visible: visible,
      onCloseClick: onCancel },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        {
          onSubmit: handleSubmit(onSubmit) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], { name: 'entryId',
          value: entryId,
          type: 'hidden',
          component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'currentSquadId',
            component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__["a" /* default */],
            options: availableEvents,
            label: 'Available Events',
            placeholder: availableEvents.length ? 'Select an option' : 'No available times',
            simpleValue: true,
            searchable: true,
            validate: [required]
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-link',
              onClick: function onClick() {
                return onCancel();
              }
            },
            'Cancel'
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'submit',
              className: 'btn btn-primary btn-lg'
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
            ' ',
            'Save'
          )
        )
      )
    )
  );
};

EntryDetailSquadChangeModal.propTypes = {
  availableEvents: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  entryId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

EntryDetailSquadChangeModal.defaultProps = {
  availableEvents: []
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'adminEntryDetailEventChangeForm'
})(EntryDetailSquadChangeModal);

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EntryDetailEventChangeModal_jsx__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(42);





var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["formValueSelector"])('adminEntryDetailEventChangeForm');

var mapStateToProps = function mapStateToProps(state) {
  return {
    visible: state.admin.entryDetail.showEventChangeModal,
    availableEvents: selector(state, 'availableEvents')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["v" /* handleEventChangeSave */])(data));
    },
    onCancel: function onCancel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["w" /* handleEventChangeCancel */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__EntryDetailEventChangeModal_jsx__["a" /* default */]);

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_StandardModal_jsx__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_StandardTextArea_jsx__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_DollarInputField_jsx__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_DisplayIf_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);









var EntryDetailPaymentModal = function EntryDetailPaymentModal(_ref) {
  var visible = _ref.visible,
      onCancelClick = _ref.onCancelClick,
      handleSubmit = _ref.handleSubmit,
      onSubmit = _ref.onSubmit,
      paymentType = _ref.paymentType;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_shared_StandardModal_jsx__["a" /* default */],
    {
      title: 'Accept Payment',
      visible: visible,
      onCloseClick: onCancelClick },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        {
          onSubmit: handleSubmit(onSubmit) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          null,
          'Select Payment Method'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: 'form-group',
            style: { display: 'flex', flexFlow: 'column' }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'paymentType',
              component: 'input',
              type: 'radio',
              value: 'Cash' }),
            ' Cash'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'paymentType',
              component: 'input',
              type: 'radio',
              value: 'Check' }),
            ' Check'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'paymentType',
              component: 'input',
              type: 'radio',
              value: 'USBC Credit' }),
            ' USBC Credit'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'paymentType',
              component: 'input',
              type: 'radio',
              value: 'USBC Carryover' }),
            ' USBC Carryover'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'paymentType',
              component: 'input',
              type: 'radio',
              value: 'Manual Stripe Transaction' }),
            ' Manual Stripe Transaction'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_shared_DisplayIf_jsx__["a" /* default */],
          { condition: paymentType == 'Check' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'checkNumber',
              component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
              placeholder: 'Check Number',
              style: { width: '30%' }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_shared_DisplayIf_jsx__["a" /* default */],
          { condition: paymentType == 'Manual Stripe Transaction' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'stripeTransactionId',
              component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
              placeholder: 'Stripe Transaction Id',
              style: { width: '30%' }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { marginBottom: 20 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'amount',
            label: 'Payment Amount',
            placeholder: 'US Dollars',
            component: __WEBPACK_IMPORTED_MODULE_5_shared_DollarInputField_jsx__["a" /* default */],
            style: { width: '25%' }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'notes',
            component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardTextArea_jsx__["a" /* default */],
            placeholder: 'Notes go here',
            maxLength: '255'
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-link',
              onClick: function onClick() {
                return onCancelClick();
              }
            },
            'Cancel'
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'submit',
              className: 'btn btn-primary btn-lg'
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
            ' ',
            'Save'
          )
        )
      )
    )
  );
};

EntryDetailPaymentModal.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  paymentType: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'adminEntryPaymentForm'
})(EntryDetailPaymentModal);

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EntryDetailPaymentModal_jsx__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(42);





var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["formValueSelector"])('adminEntryPaymentForm');

var mapStateToProps = function mapStateToProps(state) {
  return {
    visible: state.admin.entryDetail.showEntryDetailPaymentModal,
    paymentType: selector(state, 'paymentType')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["P" /* handleEntryDetailPaymentCancelClick */])());
    },
    onEntryDetailPaymentClick: function onEntryDetailPaymentClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["Q" /* handleEntryDetailPaymentClick */])());
    },
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["R" /* handlePaymentSave */])(data));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__EntryDetailPaymentModal_jsx__["a" /* default */]);

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_StandardModal_jsx__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);







var EntryDetailReactivationModal = function EntryDetailReactivationModal(_ref) {
  var minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      availableSquads = _ref.availableSquads,
      visible = _ref.visible,
      onCancel = _ref.onCancel,
      handleSubmit = _ref.handleSubmit,
      onSubmit = _ref.onSubmit,
      onDateChange = _ref.onDateChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_shared_StandardModal_jsx__["a" /* default */],
    {
      title: 'Reactivate Entry',
      visible: visible,
      onCloseClick: onCancel },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'Please pick a squad that you would like to assign this entry to upon reactivation.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        {
          onSubmit: handleSubmit(onSubmit) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'currentSquadDate',
            type: 'date',
            minDate: minDate,
            maxDate: maxDate,
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'Select A Date',
            onCustomChange: onDateChange
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'currentSquadId',
            component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__["a" /* default */],
            options: availableSquads,
            label: 'Available Squads',
            placeholder: 'No results found',
            simpleValue: true,
            searchable: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-link',
              onClick: function onClick() {
                return onCancel();
              }
            },
            'Cancel'
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'submit',
              className: 'btn btn-primary btn-lg'
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
            ' ',
            'Save'
          )
        )
      )
    )
  );
};

EntryDetailReactivationModal.propTypes = {
  minDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  maxDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  availableSquads: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onDateChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

EntryDetailReactivationModal.defaultProps = {
  availableSquads: []
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'adminEntryDetailReactivation'
})(EntryDetailReactivationModal);

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EntryDetailReactivationModal_jsx__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(42);





var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["formValueSelector"])('adminEntryDetailReactivationForm');

var mapStateToProps = function mapStateToProps(state) {
  return {
    validate: __WEBPACK_IMPORTED_MODULE_3__actions__["n" /* validateEntryDetailSquadChangeForm */],
    visible: state.admin.entryDetail.showReactivationModal,
    minDate: state.admin.entryDetail.tournament.startDate,
    maxDate: state.admin.entryDetail.tournament.endDate,
    availableSquads: selector(state, 'availableSquads')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["o" /* handleReactivationSave */])(data));
    },
    onCancel: function onCancel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["p" /* handleReactivationCancel */])());
    },
    onDateChange: function onDateChange(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["q" /* handleReactivationChangeSquadDateChanged */])(data));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__EntryDetailReactivationModal_jsx__["a" /* default */]);

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_StandardModal_jsx__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_StandardTextArea_jsx__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_DollarInputField_jsx__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_StandardSelectField_jsx__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_DisplayIf_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EntryDetailRefundModalVirtualEntriesToModifyContainer_jsx__ = __webpack_require__(798);











var EntryDetailRefundModal = function EntryDetailRefundModal(_ref) {
  var visible = _ref.visible,
      onCancelClick = _ref.onCancelClick,
      handleSubmit = _ref.handleSubmit,
      onSubmit = _ref.onSubmit,
      entryId = _ref.entryId,
      paymentType = _ref.paymentType,
      refundType = _ref.refundType,
      purchaseTransactions = _ref.purchaseTransactions;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_shared_StandardModal_jsx__["a" /* default */],
    {
      title: 'Refund',
      visible: visible,
      onCloseClick: onCancelClick },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: { overflowY: "auto" } },
      refundType === 'refundWithCancellation' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        'Please enter refund amount below if a refund was also issued with this cancellation. Otherwise, you are only required to add applicable notes.'
      ) : null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        {
          onSubmit: handleSubmit(onSubmit) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], { name: 'entryId',
          value: entryId,
          type: 'hidden',
          component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          null,
          'Select Refund Method'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: 'form-group',
            style: { display: 'flex', flexFlow: 'column' }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'paymentType',
              component: 'input',
              type: 'radio',
              value: 'Cash' }),
            ' Cash'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'paymentType',
              component: 'input',
              type: 'radio',
              value: 'Check' }),
            ' Check'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'paymentType',
              component: 'input',
              type: 'radio',
              value: 'USBC Credit' }),
            ' USBC Credit'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'paymentType',
              component: 'input',
              type: 'radio',
              value: 'USBC Carryover' }),
            ' USBC Carryover'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'paymentType',
              component: 'input',
              type: 'radio',
              value: 'Manual Stripe Transaction' }),
            ' Manual Stripe Transaction'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'paymentType',
              component: 'input',
              type: 'radio',
              disabled: purchaseTransactions.length === 0,
              value: 'Stripe Purchase Transaction' }),
            ' Stripe Purchase Transaction'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_shared_DisplayIf_jsx__["a" /* default */],
          { condition: paymentType == 'Check' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'checkNumber',
              component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
              placeholder: 'Check Number',
              style: { width: '30%' }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_shared_DisplayIf_jsx__["a" /* default */],
          { condition: paymentType == 'Manual Stripe Transaction' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'stripeTransactionId',
              component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
              placeholder: 'Stripe Transaction Id',
              style: { width: '80%' }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_shared_DisplayIf_jsx__["a" /* default */],
          { condition: paymentType == 'Stripe Purchase Transaction' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'stripeTransactionId',
              component: __WEBPACK_IMPORTED_MODULE_6_shared_StandardSelectField_jsx__["a" /* default */],
              placeholder: 'Stripe Transaction Id',
              options: purchaseTransactions.map(function (x) {
                return {
                  value: x.creditCardTransactionId,
                  label: x.shortDescription
                };
              }),
              simpleValue: true,
              required: true,
              style: { width: '80%' }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { marginBottom: 20 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'amount',
            label: 'Refund Amount',
            placeholder: 'US Dollars',
            component: __WEBPACK_IMPORTED_MODULE_5_shared_DollarInputField_jsx__["a" /* default */],
            style: { width: '25%' }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'notes',
            component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardTextArea_jsx__["a" /* default */],
            placeholder: 'Notes go here',
            maxLength: '255'
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-link',
              onClick: function onClick() {
                return onCancelClick();
              }
            },
            'Cancel'
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'submit',
              className: 'btn btn-primary btn-lg'
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
            ' ',
            'Save'
          )
        ),
        refundType === 'refundWithCancellation' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__EntryDetailRefundModalVirtualEntriesToModifyContainer_jsx__["a" /* default */], null) : null
      )
    )
  );
};

EntryDetailRefundModal.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  entryId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  paymentType: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  refundType: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  purchaseTransactions: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'adminEntryRefundForm'
})(EntryDetailRefundModal);

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EntryDetailRefundModal_jsx__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(42);





var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["formValueSelector"])('adminEntryRefundForm');

var mapStateToProps = function mapStateToProps(state) {
  return {
    visible: state.admin.entryDetail.showEntryDetailRefundModal,
    paymentType: selector(state, 'paymentType'),
    refundType: state.admin.entryDetail.refundType,
    purchaseTransactions: state.admin.entryDetail.creditPurchaseTransactions ? state.admin.entryDetail.creditPurchaseTransactions : []
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["r" /* handleEntryDetailRefundCancelClick */])());
    },
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["s" /* handleEntryDetailRefundSubmitClick */])(data));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__EntryDetailRefundModal_jsx__["a" /* default */]);

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var EntryDetailRefundModalVirtualEntriesToModify = function EntryDetailRefundModalVirtualEntriesToModify(_ref) {
  var captainFirstName = _ref.captainFirstName,
      captainLastName = _ref.captainLastName,
      virtualEntriesToModify = _ref.virtualEntriesToModify;

  if (!virtualEntriesToModify || virtualEntriesToModify.length == 0) return null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
    virtualEntriesToModify.map(function (virtualEntry, rosterIndex) {

      var bowlerName = virtualEntry.displayName + " (" + virtualEntry.usbcId + ")";
      var captainName = captainFirstName + " " + captainLastName;
      var virtualEventName = virtualEntry.virtualEventName;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "alert alert-warning",
          key: rosterIndex },
        "Bowler ",
        bowlerName,
        " will no longer be on any of Captain ",
        captainName,
        "'s rosters, if you continue with this cancellation they will be removed from the ",
        virtualEventName,
        " as well."
      );
    })
  );
};

EntryDetailRefundModalVirtualEntriesToModify.propTypes = {
  virtualEntriesToModify: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  captainFirstName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  captainLastName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

EntryDetailRefundModalVirtualEntriesToModify.defaultProps = {
  virtualEntriesToModify: [],
  captainFirstName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  captainLastName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

/* harmony default export */ __webpack_exports__["a"] = EntryDetailRefundModalVirtualEntriesToModify;

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EntryDetailRefundModalVirtualEntriesToModify_jsx__ = __webpack_require__(797);



var mapStateToProps = function mapStateToProps(state) {
  return {
    virtualEntriesToModify: state.admin.entryDetail.virtualEntriesToModify,
    captainFirstName: String(state.admin.entryDetail.captain.captainFirstName),
    captainLastName: String(state.admin.entryDetail.captain.captainLastName)
  };
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__EntryDetailRefundModalVirtualEntriesToModify_jsx__["a" /* default */]);

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_StandardModal_jsx__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);







var EntryDetailSquadChangeModal = function EntryDetailSquadChangeModal(_ref) {
  var minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      availableSquads = _ref.availableSquads,
      visible = _ref.visible,
      onCancel = _ref.onCancel,
      handleSubmit = _ref.handleSubmit,
      onSubmit = _ref.onSubmit,
      entryId = _ref.entryId,
      onDateChange = _ref.onDateChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_shared_StandardModal_jsx__["a" /* default */],
    {
      title: 'Change Squad',
      visible: visible,
      onCloseClick: onCancel },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        {
          onSubmit: handleSubmit(onSubmit) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], { name: 'entryId',
          value: entryId,
          type: 'hidden',
          component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'currentSquadDate',
            type: 'date',
            minDate: minDate,
            maxDate: maxDate,
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'Select A Date',
            onCustomChange: onDateChange
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'currentSquadId',
            component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__["a" /* default */],
            options: availableSquads,
            label: 'Available Squads',
            placeholder: 'No results found',
            simpleValue: true,
            searchable: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-link',
              onClick: function onClick() {
                return onCancel();
              }
            },
            'Cancel'
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'submit',
              className: 'btn btn-primary btn-lg'
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
            ' ',
            'Save'
          )
        )
      )
    )
  );
};

EntryDetailSquadChangeModal.propTypes = {
  minDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  maxDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  availableSquads: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  entryId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onDateChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

EntryDetailSquadChangeModal.defaultProps = {
  availableSquads: []
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'adminEntryDetailSquadChangeForm'
})(EntryDetailSquadChangeModal);

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EntryDetailSquadChangeModal_jsx__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(42);





var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["formValueSelector"])('adminEntryDetailSquadChangeForm');

var mapStateToProps = function mapStateToProps(state) {
  return {
    validate: __WEBPACK_IMPORTED_MODULE_3__actions__["n" /* validateEntryDetailSquadChangeForm */],
    visible: state.admin.entryDetail.showSquadChangeModal,
    minDate: state.admin.entryDetail.tournament.startDate,
    maxDate: state.admin.entryDetail.tournament.endDate,
    availableSquads: selector(state, 'availableSquads')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["x" /* handleSquadChangeSave */])(data));
    },
    onCancel: function onCancel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["y" /* handleSquadChangeCancel */])());
    },
    onDateChange: function onDateChange(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["z" /* handleChangeSquadDateChanged */])(data));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__EntryDetailSquadChangeModal_jsx__["a" /* default */]);

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EntryRosterModalContainer_jsx__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_Panel_jsx__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_DisplayIf_jsx__ = __webpack_require__(12);






var EntryDetailSummary = function EntryDetailSummary(_ref) {
  var groupCode = _ref.groupCode,
      pairCode = _ref.pairCode,
      entryNumber = _ref.entryNumber,
      teamName = _ref.teamName,
      tournamentName = _ref.tournamentName,
      squadDateTime = _ref.squadDateTime,
      timeZoneDisplayName = _ref.timeZoneDisplayName,
      readOnly = _ref.readOnly,
      isCancelled = _ref.isCancelled,
      onManageRosterClick = _ref.onManageRosterClick,
      onViewRosterClick = _ref.onViewRosterClick,
      onChangeSquadClick = _ref.onChangeSquadClick,
      onRemoveSquadClick = _ref.onRemoveSquadClick,
      onChangeEventClick = _ref.onChangeEventClick,
      divisionName = _ref.divisionName,
      allowChangeBetweenFreeEvents = _ref.allowChangeBetweenFreeEvents;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_shared_Panel_jsx__["a" /* default */],
    { className: 'panel-primary',
      title: 'Entry Details' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-sm-6' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            'Tournament'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            tournamentName || '-'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-sm-6' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            'Team Name'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            teamName || '-'
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-sm-5' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            'Reservation No.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            entryNumber || '-'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-sm-4' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            'Group Code'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            groupCode || '-'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-sm-3' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            'Companion Code'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            pairCode || '-'
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-sm-5' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            'Squad Date/Time'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            squadDateTime ? __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(squadDateTime).format('MMM Do, YYYY - hh:mm A') + '\n              (' + timeZoneDisplayName + ')' : '-'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-sm-4' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            'Cancelled'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            isCancelled ? 'Yes' : 'No'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-sm-3' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            'Division'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            divisionName
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_shared_DisplayIf_jsx__["a" /* default */],
        { condition: !isCancelled && !readOnly },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-link pull-left',
            onClick: onChangeSquadClick },
          squadDateTime ? 'Change Squad' : 'Add Squad'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_shared_DisplayIf_jsx__["a" /* default */],
          { condition: allowChangeBetweenFreeEvents },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-link pull-left',
              onClick: onChangeEventClick },
            'Change Event'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_shared_DisplayIf_jsx__["a" /* default */],
          { condition: !!squadDateTime },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-link pull-left',
              onClick: onRemoveSquadClick },
            'Remove Squad'
          )
        )
      ),
      readOnly ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          className: 'btn btn-link pull-right',
          type: 'button',
          onClick: onViewRosterClick },
        'View Roster'
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          className: 'btn btn-link pull-right',
          type: 'button',
          onClick: onManageRosterClick },
        'Manage Roster'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__EntryRosterModalContainer_jsx__["a" /* default */], null)
  );
};

EntryDetailSummary.propTypes = {
  groupCode: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  pairCode: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  entryNumber: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  divisionName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  teamName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  tournamentName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  squadDateTime: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  timeZoneDisplayName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  readOnly: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  isCancelled: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onManageRosterClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onViewRosterClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onChangeSquadClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onRemoveSquadClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onChangeEventClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  allowChangeBetweenFreeEvents: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool
};

EntryDetailSummary.defaultProps = {
  groupCode: '',
  pairCode: '',
  entryNumber: '',
  divisionName: '',
  teamName: '',
  tournamentName: '',
  squadDateTime: '',
  timeZoneDisplayName: '',
  readOnly: false,
  isCancelled: false,
  allowChangeBetweenFreeEvents: false
};

/* harmony default export */ __webpack_exports__["a"] = EntryDetailSummary;

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EntryDetailSummary_jsx__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(42);




var mapStateToProps = function mapStateToProps(state) {
  return {
    entryNumber: state.admin.entryDetail.entryNumber,
    groupCode: state.admin.entryDetail.groupCode,
    pairCode: state.admin.entryDetail.pairCode,
    readOnly: state.admin.entryDetail.readOnly,
    squadDateTime: state.admin.entryDetail.squadDateTime,
    timeZoneDisplayName: state.admin.entryDetail.timeZoneDisplayName,
    teamName: state.admin.entryDetail.teamName,
    divisionName: state.admin.entryDetail.divisionName,
    isCancelled: state.admin.entryDetail.isCancelled,
    tournamentName: state.admin.entryDetail.tournament.name,
    allowChangeBetweenFreeEvents: state.admin.entryDetail.tournament.allowChangeBetweenFreeEvents
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onManageRosterClick: function onManageRosterClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["A" /* handleAdminManageRosterClick */])());
    },
    onViewRosterClick: function onViewRosterClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["B" /* handleViewRosterClick */])());
    },
    onChangeSquadClick: function onChangeSquadClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["C" /* handleSquadChangeClick */])());
    },
    onChangeEventClick: function onChangeEventClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["D" /* handleEventChangeClick */])());
    },
    onRemoveSquadClick: function onRemoveSquadClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["E" /* handleRemoveSquadClick */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__EntryDetailSummary_jsx__["a" /* default */]);

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_EntryPaymentLog_jsx__ = __webpack_require__(448);



var mapStateToProps = function mapStateToProps(state) {
  return state.admin.entryDetail.paymentLog;
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1_shared_EntryPaymentLog_jsx__["a" /* default */]);

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EntryRosterFormVirtualEntriesToModifyContainer_jsx__ = __webpack_require__(807);








var EntryRosterForm = function EntryRosterForm(_ref) {
  var disableState = _ref.disableState,
      roster = _ref.roster,
      rosterPositionsQty = _ref.rosterPositionsQty,
      countries = _ref.countries,
      states = _ref.states,
      handleSubmit = _ref.handleSubmit,
      submitting = _ref.submitting,
      onCancelClick = _ref.onCancelClick,
      onSubmit = _ref.onSubmit,
      onCountryChange = _ref.onCountryChange,
      errors = _ref.errors;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'form',
    {
      onSubmit: handleSubmit(onSubmit),
      noValidate: true },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: {
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          "overflowY": 'auto',
          "overflowX": 'hidden',
          "marginRight": errors.length > 0 ? '-15px' : '0'
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: errors.length > 0 ? "modalNonErrorBody" : "" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-sm-6 col-xs-12' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              disabled: rosterPositionsQty === 2 || rosterPositionsQty === 1,
              autoFocus: rosterPositionsQty > 2,
              className: 'form-control',
              name: 'name',
              type: 'text',
              placeholder: 'Team Name',
              component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */] })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-sm-6 col-xs-12' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'countryId',
              placeholder: 'Country',
              component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__["a" /* default */],
              options: countries,
              simpleValue: true,
              searchable: true,
              matchPos: 'start',
              onCustomChange: onCountryChange })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-sm-4 col-xs-12' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              disabled: disableState,
              className: 'form-control',
              name: 'state',
              placeholder: 'State',
              component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__["a" /* default */],
              options: states,
              simpleValue: true,
              searchable: true,
              matchPos: 'start' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-sm-4 col-xs-12' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              className: 'form-control',
              name: 'groupCode',
              type: 'text',
              placeholder: 'Group Code',
              component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
              maxLength: '10',
              tooltip: 'Teams that want to bowl on lanes near each other should all have the same Group Code.',
              tooltipPosition: 'top' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-sm-4 col-xs-12' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              className: 'form-control',
              name: 'pairCode',
              type: 'text',
              placeholder: 'Companion Code',
              component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
              tooltip: '(Optional) Enter the Reservation Number of the other team you want to bowl/cross with on your pair.',
              tooltipPosition: 'top' })
          )
        ),
        roster,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__EntryRosterFormVirtualEntriesToModifyContainer_jsx__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-link',
              disabled: submitting,
              onClick: onCancelClick },
            'Cancel'
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'submit',
              className: 'btn btn-primary btn-lg',
              disabled: submitting },
            submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
            ' ',
            'Save Changes'
          )
        )
      )
    )
  );
};

EntryRosterForm.propTypes = {
  disableState: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  roster: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,
  rosterPositionsQty: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  countries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  states: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired,
  pristine: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onCountryChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  errors: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string)
};

EntryRosterForm.defaultProps = {
  disableState: false,
  rosterPositionsQty: 0,
  countries: [],
  states: [],
  submitting: false
};

/* harmony default export */ __webpack_exports__["a"] = EntryRosterForm;

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EntryRosterForm_jsx__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EntryRosterListContainer_jsx__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(42);







var EntryRosterFormWrapper = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["reduxForm"])({
  form: 'adminEntryRosterForm',
  roster: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__EntryRosterListContainer_jsx__["a" /* default */], null),
  destroyOnUnmount: false
})(__WEBPACK_IMPORTED_MODULE_3__EntryRosterForm_jsx__["a" /* default */]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    disableState: state.admin.entryDetail.disableState,
    validate: __WEBPACK_IMPORTED_MODULE_5__actions__["G" /* validateEntryRosterForm */],
    countries: state.admin.entryDetail.countries,
    states: state.admin.entryDetail.states,
    rosterPositionsQty: state.admin.entryDetail.rosterPositions.length,
    errors: state.shared.error.source
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["H" /* handleSaveEntryRosterForm */])(data));
    },
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["F" /* handleCancelClick */])());
    },
    onCountryChange: function onCountryChange(value) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["I" /* handleCountryChange */])(value));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(EntryRosterFormWrapper);

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var EntryRosterFormVirtualEntriesToModify = function EntryRosterFormVirtualEntriesToModify(_ref) {
  var captainFirstName = _ref.captainFirstName,
      captainLastName = _ref.captainLastName,
      virtualEntriesToModify = _ref.virtualEntriesToModify;

  if (!virtualEntriesToModify || virtualEntriesToModify.length == 0) return null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
    virtualEntriesToModify.map(function (virtualEntry, rosterIndex) {

      var bowlerName = virtualEntry.displayName + " (" + virtualEntry.usbcId + ")";
      var captainName = captainFirstName + " " + captainLastName;
      var virtualEventName = virtualEntry.virtualEventName;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "alert alert-warning",
          key: rosterIndex },
        "Bowler ",
        bowlerName,
        " is no longer on any of Captain ",
        captainName,
        "'s rosters, if you continue with this removal they will be removed from the ",
        virtualEventName,
        " as well."
      );
    })
  );
};

EntryRosterFormVirtualEntriesToModify.propTypes = {
  virtualEntriesToModify: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  captainFirstName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  captainLastName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

EntryRosterFormVirtualEntriesToModify.defaultProps = {
  virtualEntriesToModify: [],
  captainFirstName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  captainLastName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

/* harmony default export */ __webpack_exports__["a"] = EntryRosterFormVirtualEntriesToModify;

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EntryRosterFormVirtualEntriesToModify_jsx__ = __webpack_require__(806);



var mapStateToProps = function mapStateToProps(state) {
    return {
        virtualEntriesToModify: state.admin.entryDetail.virtualEntriesToModify,
        captainFirstName: String(state.admin.entryDetail.captain.captainFirstName),
        captainLastName: String(state.admin.entryDetail.captain.captainLastName)
    };
};

var mapDispatchToProps = function mapDispatchToProps() {
    return {};
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__EntryRosterFormVirtualEntriesToModify_jsx__["a" /* default */]);

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_EntryRosterList_jsx__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(269);





var mapStateToProps = function mapStateToProps(state) {
  return {
    source: state.admin.entryDetail.rosterPositions,
    sourceQty: state.admin.entryDetail.rosterPositions.length,
    bowlers: state.admin.entryDetail.bowlers
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSearchEnterKeyPress: function onSearchEnterKeyPress(roster, event) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["J" /* handleSearchEnterKeyPress */])(roster, event));
    },
    onSearchChange: function onSearchChange(roster, event) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["K" /* handleSearchChange */])(roster, event));
    },
    onSearch: function onSearch(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["L" /* handleSearch */])(data));
    },
    onAvgChange: function onAvgChange(position, value) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["O" /* setMemberAvgField */])(position, value));
    },
    onIsProfessionalChange: function onIsProfessionalChange(position, value) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["P" /* setIsProfessional */])(position, value));
    },
    onMoveUpClick: function onMoveUpClick(index) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["M" /* handleMoveUpClick */])(index));
    },
    onMoveDownClick: function onMoveDownClick(index) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["N" /* handleMoveDownClick */])(index));
    },
    onRosterPositionCleared: function onRosterPositionCleared(index) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["O" /* handleRosterPositionCleared */])(index));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1_shared_EntryRosterList_jsx__["a" /* default */]);

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_StandardModal_jsx__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EntryRosterReadOnlyContainer_jsx__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EntryRosterFormContainer_jsx__ = __webpack_require__(805);





var EntryRosterModal = function EntryRosterModal(_ref) {
  var readOnly = _ref.readOnly,
      visible = _ref.visible,
      onCloseClick = _ref.onCloseClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_shared_StandardModal_jsx__["a" /* default */],
    {
      title: 'Entry and Roster Information',
      visible: visible,
      onCloseClick: onCloseClick,
      wideModal: true,
      bodyOverflow: true },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      readOnly ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__EntryRosterReadOnlyContainer_jsx__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__EntryRosterFormContainer_jsx__["a" /* default */], null)
    )
  );
};

EntryRosterModal.propTypes = {
  readOnly: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCloseClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = EntryRosterModal;

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EntryRosterModal_jsx__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(42);




var mapStateToProps = function mapStateToProps(state) {
  return {
    readOnly: state.admin.entryDetail.readOnly,
    visible: state.admin.entryDetail.showEntryRosterModal
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCloseClick: function onCloseClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["F" /* handleCancelClick */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__EntryRosterModal_jsx__["a" /* default */]);

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_EntryWithRosterReadOnly_jsx__ = __webpack_require__(449);



var mapStateToProps = function mapStateToProps(state) {
  return state.admin.entryDetail.readOnlyInfo;
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1_shared_EntryWithRosterReadOnly_jsx__["a" /* default */]);

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var Entry = function Entry(_ref) {
  var virtualEntryId = _ref.virtualEntryId,
      selected = _ref.selected,
      bowlerName = _ref.bowlerName,
      bowlerWillBeRemoved = _ref.bowlerWillBeRemoved,
      entryName = _ref.entryName,
      virtualEventName = _ref.virtualEventName,
      onSelectChecked = _ref.onSelectChecked;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "list-group-item-labeled" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "list-group-item-labeled-child custom-checkbox-container",
        style: { width: 25 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "checkbox",
        id: "entry-" + virtualEntryId,
        checked: selected,
        onChange: function onChange() {
          return onSelectChecked(virtualEntryId, !selected);
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
        htmlFor: "entry-" + virtualEntryId })
    ),
    bowlerName ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "list-group-item-labeled-child",
        style: { width: 450 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        'Bowler Name'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        virtualEventName + " - " + bowlerName,
        bowlerWillBeRemoved ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "i",
          null,
          "(Will be removed if unchecked)"
        ) : null
      )
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "list-group-item-labeled-child",
        style: { width: 450 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        'Team Name'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        virtualEventName + " - " + entryName,
        " ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "i",
          null,
          "(Will be removed if unchecked)"
        )
      )
    )
  );
};

Entry.propTypes = {
  virtualEntryId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  selected: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  bowlerName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  bowlerWillBeRemoved: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  entryName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  virtualEventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onSelectChecked: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

Entry.defaultProps = {};

/* harmony default export */ __webpack_exports__["a"] = Entry;

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualEntry_jsx__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__captainDetail_actionTypes__ = __webpack_require__(134);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var mapStateToProps = function mapStateToProps(state, props) {
  var selected = undefined;
  var virtualEntry = state.admin.captainDetail.affectedVirtualEntries.filter(function (entry) {
    return entry.virtualEntryId == props.virtualEntryId;
  })[0];

  // Sometimes old information comes in the props parameter 
  if (virtualEntry) {
    selected = virtualEntry.selected;
  }

  return _extends({}, props, {
    selected: selected
  });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSelectChecked: function onSelectChecked(virtualEntryId, selected) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__captainDetail_actionTypes__["z" /* setSelectedAffectedVirtualEntry */])(virtualEntryId, selected));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__VirtualEntry_jsx__["a" /* default */]);

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return blankRosterPosition; });
var blankRosterPosition = {
  _searchValue: "",
  _retrieved: false,
  usbcIdError: false,
  averageRequired: false,
  _errorMessage: null,
  bowler: {},
  usbcId: ""
};

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dataModel__ = __webpack_require__(814);
/* unused harmony export initialState */
/* unused harmony export reducer */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





var initialState = {
  balance: 0,
  bowlers: [],
  captainId: '',
  coordinator: {},
  captain: {},
  countries: [],
  disableState: false,
  divisionName: '',
  entryId: '',
  entryNumber: '',
  groupCode: '',
  isCancelled: false,
  pairCode: '',
  paymentLog: {},
  readOnly: false,
  readOnlyInfo: {},
  rosterPositions: [],
  squadDateTime: '',
  showEntryDetailCoordinatorModal: false,
  showEntryDetailCaptainModal: false,
  showEntryDetailChangeCaptainModal: false,
  isNew: false,
  showEntryDetailPaymentModal: false,
  showEntryRosterModal: false,
  showPaymentLog: false,
  showSquadChangeModal: false,
  showEventChangeModal: false,
  showEntryDetailRefundModal: false,
  states: [],
  virtualEntriesToModify: [],
  teamName: '',
  timeZoneDisplayName: '',
  tournament: {},
  showReactivationModal: false,
  refundType: 'refundOnly'
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_AVAILABLE_BOWLERS_FOR_ADMIN_ENTRY_DETAIL */]:
      {
        return _extends({}, state, {
          bowlers: payload || initialState.bowlers
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_STATE_DISABLED_FOR_ADMIN_ENTRY_DETAIL */]:
      return _extends({}, state, {
        disableState: payload || false
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_READONLY_INFO_FOR_ADMIN_ENTRY_DETAIL */]:
      return _extends({}, state, {
        readOnlyInfo: payload || initialState.readOnlyInfo
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_SUMMARY_FOR_ADMIN_ENTRY_DETAIL */]:
      return _extends({}, state, {
        entryNumber: payload.entryNumber || initialState.entryNumber,
        groupCode: payload.groupCode || initialState.groupCode,
        pairCode: payload.pairCode || initialState.pairCode,
        readOnly: payload.readOnly || initialState.readOnly,
        teamName: payload.teamName || initialState.teamName,
        divisionName: payload.divisionName || initialState.divisionName,
        timeZoneDisplayName: payload.timeZoneDisplayName || initialState.timeZoneDisplayName,
        squadDateTime: payload.squadDateTime || initialState.squadDateTime,
        eventId: payload.eventId || initialState.eventId,
        isCancelled: payload.isCancelled || initialState.isCancelled
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* CLEAR_ROSTER_POSITION_FOR_ADMIN_ENTRY_DETAIL */]:
      return !isNaN(Number(payload)) ? _extends({}, state, {
        rosterPositions: state.rosterPositions.map(function (x, i) {
          return i === Number(payload) ? _extends({}, x, __WEBPACK_IMPORTED_MODULE_1__dataModel__["a" /* blankRosterPosition */], {
            averageRequired: x.averageRequired,
            _errorMessage: null
          }) : x;
        })
      }) : state;
    case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* SET_STATES_FOR_ADMIN_ENTRY_DETAIL */]:
      return _extends({}, state, {
        states: payload || initialState.states
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SET_VIRTUAL_ENTRIES_TO_MODIFY_FOR_ADMIN_ENTRY_DETAIL */]:
      return _extends({}, state, {
        virtualEntriesToModify: payload || initialState.virtualEntriesToModify
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* SET_COUNTRIES_FOR_ADMIN_ENTRY_DETAIL */]:
      return _extends({}, state, {
        countries: payload || initialState.countries
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* MOVE_ROSTER_POSITION_UP_FOR_ADMIN_ENTRY_DETAIL */]:
      {
        var currentPosition = payload;

        if (typeof currentPosition === 'undefined' || currentPosition <= 0) {
          return state; // do nothing if first in array
        }

        var rosters = [].concat(_toConsumableArray(state.rosterPositions));
        var tmp = rosters[currentPosition];

        // swap positions with correct position number
        rosters[currentPosition] = _extends({}, rosters[currentPosition - 1], {
          position: rosters[currentPosition - 1].position + 1
        });
        rosters[currentPosition - 1] = _extends({}, tmp, {
          position: tmp.position - 1
        });
        return _extends({}, state, {
          rosterPositions: rosters
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* MOVE_ROSTER_POSITION_DOWN_FOR_ADMIN_ENTRY_DETAIL */]:
      {
        var _currentPosition = payload;

        if (typeof _currentPosition === 'undefined' || _currentPosition >= state.rosterPositions.length) {
          return state; // do nothing if last in array
        }

        var _rosters = [].concat(_toConsumableArray(state.rosterPositions));
        var _tmp = _rosters[_currentPosition];

        // swap positions with correct position
        _rosters[_currentPosition] = _extends({}, _rosters[_currentPosition + 1], {
          position: _rosters[_currentPosition + 1].position - 1
        });
        _rosters[_currentPosition + 1] = _extends({}, _tmp, {
          position: _tmp.position + 1
        });
        return _extends({}, state, {
          rosterPositions: _rosters
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* UPDATE_ROSTER_INFO_FOR_ADMIN_ENTRY_DETAIL */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* SEARCHING_MEMBER_FINISHED_FOR_ADMIN_ENTRY_DETAIL */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* SEARCHING_MEMBER_STARTS_FOR_ADMIN_ENTRY_DETAIL */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* SET_MEMBER_SEARCH_FIELD_FOR_ADMIN_ENTRY_DETAIL */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants__["o" /* SET_BOWLER_AVG_FOR_ADMIN_ENTRY_DETAIL_ROSTER_POSITION */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants__["p" /* SET_IS_PROFESSIONAL_FOR_ADMIN_ENTRY_DETAIL_ROSTER_POSITION */]:
      return _extends({}, state, {
        rosterPositions: state.rosterPositions.map(function (x) {
          return rosterPositionReducer(x, { type: type, payload: payload });
        })
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["q" /* SET_ROSTER_POSITIONS_FOR_ADMIN_ENTRY_DETAIL */]:
      return _extends({}, state, {
        rosterPositions: payload || initialState.rosterPositions
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["r" /* SET_ROSTER_MODAL_VISIBILITY_FOR_ADMIN_ENTRY_DETAIL */]:
      return _extends({}, state, {
        showEntryRosterModal: payload || initialState.showEntryRosterModal
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["s" /* DISPLAY_ENTRY_DETAIL_CHANGE_SQUAD_MODAL */]:
      {
        return _extends({}, state, {
          showSquadChangeModal: payload || initialState.showSquadChangeModal
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["t" /* DISPLAY_ENTRY_DETAIL_CHANGE_EVENT_MODAL */]:
      {
        return _extends({}, state, {
          showEventChangeModal: payload || initialState.showEventChangeModal
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["u" /* SET_ENTRY_DETAIL_BALANCE_FOR_ADMIN */]:
      {
        return _extends({}, state, {
          balance: payload || initialState.balance
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["v" /* SET_ENTRY_DETAIL_CAPTAINID_FOR_ADMIN */]:
      {
        return _extends({}, state, {
          captainId: payload || initialState.captainId
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["x" /* SET_ENTRY_DETAIL_ID_FOR_ADMIN */]:
      {
        return _extends({}, state, {
          entryId: payload || initialState.entryId
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["w" /* SET_ENTRY_DETAIL_TOURNAMENT_FOR_ADMIN */]:
      {
        return _extends({}, state, {
          tournament: payload || initialState.tournament
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["D" /* SET_ENTRY_DETAIL_COORDINATOR_FOR_ADMIN */]:
      {
        return _extends({}, state, {
          coordinator: payload || initialState.coordinator
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["E" /* SET_ENTRY_DETAIL_CAPTAIN_FOR_ADMIN */]:
      {
        return _extends({}, state, {
          captain: payload || initialState.captain
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["z" /* SET_PAYMENT_LOG_HISTORY_FOR_ADMIN_ENTRY_DETAIL */]:
      {
        return _extends({}, state, {
          paymentLog: payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* DISPLAY_PAYMENT_LOG_HISTORY_FOR_ADMIN_ENTRY_DETAIL */]:
      {
        return _extends({}, state, {
          showPaymentLog: payload == null ? !state.showPaymentLog : payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["A" /* CANCEL_ENTRY_DETAIL_PAYMENT_MODAL */]:
      {
        return _extends({}, state, {
          showEntryDetailPaymentModal: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["B" /* DISPLAY_ENTRY_DETAIL_PAYMENT_MODAL */]:
      {
        return _extends({}, state, {
          showEntryDetailPaymentModal: true
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["C" /* HIDE_ENTRY_DETAIL_PAYMENT_MODAL */]:
      {
        return _extends({}, state, {
          showEntryDetailPaymentModal: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["F" /* SHOW_HIDE_ENTRY_DETAIL_COORDINATOR_MODAL_FOR_ADMIN */]:
      {
        return _extends({}, state, {
          showEntryDetailCoordinatorModal: payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["G" /* SHOW_HIDE_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN */]:
      {
        return _extends({}, state, {
          showEntryDetailChangeCaptainModal: payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["H" /* SET_IS_NEW_CAPTAIN_ENTRY_DETAIL */]:
      {
        return _extends({}, state, {
          isNew: payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["I" /* SHOW_HIDE_ENTRY_DETAIL_REFUND_MODAL_FOR_ADMIN */]:
      {
        return _extends({}, state, {
          showEntryDetailRefundModal: payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["J" /* SET_ENTRY_DETAIL_CREDIT_PURCHASE_TRANSACTIONS */]:
      {
        return _extends({}, state, {
          creditPurchaseTransactions: payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["K" /* SHOW_HIDE_ENTRY_DETAIL_REACTIVATION_MODAL_FOR_ADMIN */]:
      {
        return _extends({}, state, {
          showReactivationModal: payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["L" /* SET_ADMIN_ENTRY_DETAIL_REFUND_TYPE */]:
      {
        return _extends({}, state, {
          refundType: payload
        });
      }
    default:
      return state;
  }
};

var rosterPositionReducer = function rosterPositionReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* UPDATE_ROSTER_INFO_FOR_ADMIN_ENTRY_DETAIL */]:
      {
        if (state.position !== payload.position) return state;
        var searchChanged = state._searchChanged;

        if (!payload._errorMessage) {
          searchChanged = false;
        }
        return _extends({}, state, payload, {
          _retrieved: !payload._errorMessage,
          _searchChanged: searchChanged
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* SEARCHING_MEMBER_FINISHED_FOR_ADMIN_ENTRY_DETAIL */]:
      return _extends({}, state, {
        _processing: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* SEARCHING_MEMBER_STARTS_FOR_ADMIN_ENTRY_DETAIL */]:
      return _extends({}, state, {
        _processing: state.position === payload.position
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* SET_MEMBER_SEARCH_FIELD_FOR_ADMIN_ENTRY_DETAIL */]:
      {
        if (state.position !== payload.position) return state;
        return _extends({}, state, {
          _searchValue: payload._searchValue,
          _searchChanged: true,
          usbcIdError: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["o" /* SET_BOWLER_AVG_FOR_ADMIN_ENTRY_DETAIL_ROSTER_POSITION */]:
      return state.position === payload.position ? _extends({}, state, {
        bowler: _extends({}, state.bowler, {
          average: payload.value
        })
      }) : state;
    case __WEBPACK_IMPORTED_MODULE_0__constants__["p" /* SET_IS_PROFESSIONAL_FOR_ADMIN_ENTRY_DETAIL_ROSTER_POSITION */]:
      return state.position === payload.position ? _extends({}, state, {
        bowler: _extends({}, state.bowler, {
          isProfessional: Boolean(payload.value)
        })
      }) : state;
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_Link_jsx__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SearchContainer_jsx__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchResultContainer_jsx__ = __webpack_require__(822);





var AdminHome = function AdminHome() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-md-8 col-md-offset-2 text-right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_shared_Link_jsx__["a" /* default */],
          {
            className: 'btn btn-primary btn-lg',
            to: 'admin/squads'
          },
          'Reserve Squads'
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-md-8 col-md-offset-2' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SearchContainer_jsx__["a" /* default */], null)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SearchResultContainer_jsx__["a" /* default */], null)
  );
};

/* harmony default export */ __webpack_exports__["a"] = AdminHome;

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var IncludePastTournamentsCheckbox = function IncludePastTournamentsCheckbox(_ref) {
  var includePastTournaments = _ref.includePastTournaments,
      onIncludePastTournamentChange = _ref.onIncludePastTournamentChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'custom-checkbox-container',
      style: { margin: '0 15px' } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'checkbox',
      id: 'includePastTournaments',
      checked: includePastTournaments,
      onChange: function onChange(event) {
        return onIncludePastTournamentChange(event.target.checked);
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'label',
      { htmlFor: 'includePastTournaments' },
      'Include Past Tournaments'
    )
  );
};

IncludePastTournamentsCheckbox.propTypes = {
  includePastTournaments: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onIncludePastTournamentChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

IncludePastTournamentsCheckbox.defaultProps = {
  includePastTournaments: false
};

/* harmony default export */ __webpack_exports__["a"] = IncludePastTournamentsCheckbox;

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__IncludePastTournamentsCheckbox_jsx__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(195);




var mapStateToProps = function mapStateToProps(state) {
  return {
    includePastTournaments: state.admin.home.includePastTournaments
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onIncludePastTournamentChange: function onIncludePastTournamentChange(checked) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["d" /* handleIncludePastTournamentsChange */])(checked));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__IncludePastTournamentsCheckbox_jsx__["a" /* default */]);

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);




var Search = function Search(_ref) {
  var searchByOptions = _ref.searchByOptions,
      selectedOption = _ref.selectedOption,
      searchValue = _ref.searchValue,
      onSearchByOptionClick = _ref.onSearchByOptionClick,
      onSearchEnterKeyPress = _ref.onSearchEnterKeyPress,
      onSearchClick = _ref.onSearchClick,
      onSearchValueChange = _ref.onSearchValueChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'A minimum of three characters are required.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('input-group input-group-lg') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'input-group-btn' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select___default.a, {
          options: searchByOptions.map(function (item) {
            return { value: item.id, label: item.description };
          }),
          searchable: false,
          clearable: false,
          className: 'Big-Select',
          value: selectedOption ? [selectedOption].map(function (item) {
            return { value: item.id, label: item.description };
          }).find(function () {
            return true;
          }) : null,
          onChange: function onChange(event) {
            if (event) onSearchByOptionClick(event.value);else onSearchByOptionClick(null);
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text',
        autoFocus: true,
        placeholder: 'Type your search here...',
        className: 'form-control',
        value: searchValue,
        onChange: function onChange(event) {
          return onSearchValueChange(event.target.value);
        },
        onKeyDown: onSearchEnterKeyPress
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'input-group-btn' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-primary',
            type: 'button',
            onClick: onSearchClick,
            disabled: !searchValue || searchValue.trim().length < 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-search' })
        )
      )
    )
  );
};

Search.propTypes = {
  searchByOptions: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  selectedOption: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  searchValue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onSearchByOptionClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSearchEnterKeyPress: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSearchClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSearchValueChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

Search.defaultProps = {
  searchByOptions: [],
  searchValue: ''
};

/* harmony default export */ __webpack_exports__["a"] = Search;

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Search_jsx__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(195);





var mapStateToProps = function mapStateToProps(state) {
  return {
    searchByOptions: state.admin.home.searchByOptions,
    selectedOption: state.admin.home.searchByOptions.find(function (o) {
      return o.selected;
    }),
    searchValue: state.admin.home.searchValue
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSearchByOptionClick: function onSearchByOptionClick(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["c" /* setSearchBySelected */])(id));
    },
    onSearchEnterKeyPress: function onSearchEnterKeyPress(event) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["e" /* handleSearchEnterKeyPress */])(event));
    },
    onSearchClick: function onSearchClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* handleSearch */])());
    },
    onSearchValueChange: function onSearchValueChange(searchValue) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["d" /* setSearchValueInState */])(searchValue));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__Search_jsx__["a" /* default */]);

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SearchResultItemContainer_jsx__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_DisplayIf_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IncludePastTournamentsCheckboxContainer_jsx__ = __webpack_require__(818);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var SearchResult = function SearchResult(_ref) {
  var source = _ref.source;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_shared_DisplayIf_jsx__["a" /* default */],
    { condition: source !== null,
      className: 'animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__IncludePastTournamentsCheckboxContainer_jsx__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    source && source.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group' },
      source.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__SearchResultItemContainer_jsx__["a" /* default */], _extends({ key: index
        }, item));
      })
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'alert alert-info' },
      'Nothing found, please try again.'
    )
  );
};

SearchResult.propTypes = {
  source: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

SearchResult.defaultProps = {
  source: null
};

/* harmony default export */ __webpack_exports__["a"] = SearchResult;

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SearchResult_jsx__ = __webpack_require__(821);



var mapStateToProps = function mapStateToProps(state) {
  return {
    source: state.admin.home.searchResult
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__SearchResult_jsx__["a" /* default */]);

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



var SearchResultItem = function SearchResultItem(_ref) {
  var entryId = _ref.entryId,
      entryNumber = _ref.entryNumber,
      tournamentName = _ref.tournamentName,
      teamName = _ref.teamName,
      captainId = _ref.captainId,
      captainName = _ref.captainName,
      eventType = _ref.eventType,
      bowlDateTime = _ref.bowlDateTime,
      coordinatorName = _ref.coordinatorName,
      isCancelled = _ref.isCancelled,
      onEntryClick = _ref.onEntryClick,
      onCaptainClick = _ref.onCaptainClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group-item-labeled' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child has-link',
        style: { width: 90 },
        onClick: function onClick() {
          return onEntryClick(entryId);
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Reservation No.'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        entryNumber || '-'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 200 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Tournament'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        tournamentName || '-'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 150 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Team Name'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        teamName || '-'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child has-link',
        style: { width: 150 },
        onClick: function onClick() {
          return onCaptainClick(captainId);
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Captain'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        '' + captainName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 150 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Coordinator'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        coordinatorName || '-'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 75 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Event'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        eventType || '-'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 200 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Bowl Date Time'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        bowlDateTime ? '' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(bowlDateTime).format('hh:mm A, MMM Do, YYYY') : isCancelled ? 'CANCELLED' : '-'
      )
    )
  );
};

SearchResultItem.propTypes = {
  entryId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  entryNumber: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  tournamentName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  teamName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  captainId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  captainName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  eventType: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  bowlDateTime: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  coordinatorName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  isCancelled: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onEntryClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onCaptainClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

SearchResultItem.defaultProps = {
  entryId: '',
  entryNumber: '',
  tournamentName: '',
  teamName: '',
  captainName: '',
  eventType: '',
  bowlDateTime: '',
  coordinatorName: '',
  isCancelled: false
};

/* harmony default export */ __webpack_exports__["a"] = SearchResultItem;

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SearchResultItem_jsx__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(195);




var mapStateToProps = function mapStateToProps(state, props) {
  return props;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onEntryClick: function onEntryClick(entryId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* handleEntryClick */])(entryId));
    },
    onCaptainClick: function onCaptainClick(captainId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* handleCaptainClick */])(captainId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__SearchResultItem_jsx__["a" /* default */]);

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__searchByOptions__ = __webpack_require__(826);
/* unused harmony export initialState */
/* unused harmony export reducer */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var initialState = {
  searchByOptions: __WEBPACK_IMPORTED_MODULE_1__searchByOptions__["a" /* default */],
  searchResult: null,
  searchValue: '',
  includePastTournaments: false
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_INCLUDE_PAST_TOURNAMENTS_IN_STATE_FOR_ADMIN_HOME */]:
      return _extends({}, state, {
        includePastTournaments: payload || initialState.includePastTournaments
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_SEARCH_VALUE_IN_STATE_FOR_ADMIN_HOME */]:
      return _extends({}, state, {
        searchValue: payload || initialState.searchValue
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_SEARCH_RESULT_IN_STATE_FOR_ADMIN_HOME */]:
      return _extends({}, state, {
        searchResult: payload || initialState.searchResult
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_SEARCH_BY_SELECTED_FOR_ADMIN_HOME */]:
      return _extends({}, state, {
        searchByOptions: state.searchByOptions.map(function (x) {
          return searchByOptionReducer(x, { type: type, payload: payload });
        })
      });
    default:
      return state;
  }
};

var searchByOptionReducer = function searchByOptionReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_SEARCH_BY_SELECTED_FOR_ADMIN_HOME */]:
      return _extends({}, state, {
        selected: state.id === payload
      });
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = [{ id: 1, description: 'Search By Member ID or Name', selected: true }, { id: 2, description: 'Search By Captains & Coordinators', selected: false }, { id: 3, description: 'Search By Reservation Number', selected: false }];

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(418);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  tournament: null,
  returningToCalendar: false
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_RETURNING_TO_CALENDAR_FOR_ADMIN */]:
      return _extends({}, state, {
        returningToCalendar: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_TOURNAMENT_INFORMATION_FOR_ADMIN */]:
      return _extends({}, state, {
        tournament: payload || initialState.tournament
      });
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__ = __webpack_require__(16);




var CaptainInformationForm = function CaptainInformationForm() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'form',
    {
      className: 'animated fadeIn',
      noValidate: true
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-body' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'flex justify-content direction-column' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'panel-body-sub-heading' },
            'Captain Information (Required)'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-sm-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                name: 'firstName',
                type: 'text',
                component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */],
                placeholder: 'First Name'
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-sm-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                name: 'lastName',
                type: 'text',
                component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */],
                placeholder: 'Last Name'
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-sm-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                name: 'email',
                type: 'text',
                component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */],
                placeholder: 'Email'
              })
            )
          )
        )
      )
    )
  );
};

CaptainInformationForm.propTypes = {};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'captainInformationForm'
})(CaptainInformationForm);

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_ClearCartConfirmationModal_jsx__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(196);





var mapStateToProps = function mapStateToProps(state) {
  return {
    visible: state.admin.review.showClearCartConfirmation
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["b" /* displayClearCartConfirmation */])(false));
    },
    onContinueClick: function onContinueClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* cancelReservation */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1_shared_ClearCartConfirmationModal_jsx__["a" /* default */]);

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__ = __webpack_require__(16);




var CoordinatorInformationForm = function CoordinatorInformationForm() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'form',
    {
      className: 'animated fadeIn',
      noValidate: true
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-body' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'flex justify-content direction-column' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'panel-body-sub-heading' },
            'Coordinator Information (Optional)'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-sm-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                name: 'firstName',
                type: 'text',
                component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */],
                placeholder: 'First Name'
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-sm-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                name: 'lastName',
                type: 'text',
                component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */],
                placeholder: 'Last Name'
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-sm-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                name: 'email',
                type: 'text',
                component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */],
                placeholder: 'Email'
              })
            )
          )
        )
      )
    )
  );
};

CoordinatorInformationForm.propTypes = {};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'coordintorInformationForm'
})(CoordinatorInformationForm);

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SquadListContainer_jsx__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VirtualEventListContainer_jsx__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_OrderReview_jsx__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_JumbotronLink_jsx__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CaptainInformationForm_jsx__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CoordinatorInformationForm_jsx__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ClearCartConfirmationContainer_jsx__ = __webpack_require__(829);










var ReservationReview = function ReservationReview(_ref) {
  var processing = _ref.processing,
      cart = _ref.cart,
      total = _ref.total,
      countInCart = _ref.countInCart,
      onClearCartClick = _ref.onClearCartClick,
      onContinueReservingClick = _ref.onContinueReservingClick,
      onReserveClick = _ref.onReserveClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_shared_OrderReview_jsx__["a" /* default */],
      {
        total: total
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__SquadListContainer_jsx__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__VirtualEventListContainer_jsx__["a" /* default */], null),
      !cart || !cart.squads.length && !cart.virtualEvents.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_JumbotronLink_jsx__["a" /* default */], {
        message: 'Go to the scheduler to reserve squads for a captain.',
        linkPath: 'admin/squads',
        linkText: 'Reserve a Squad'
      }) : null
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CaptainInformationForm_jsx__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CoordinatorInformationForm_jsx__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ClearCartConfirmationContainer_jsx__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'text-right' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          type: 'button',
          className: 'btn btn-link',
          disabled: processing,
          onClick: onClearCartClick
        },
        'Clear My Cart'
      ),
      ' ',
      total > 0 || countInCart > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-link',
            disabled: processing,
            onClick: onContinueReservingClick
          },
          'Return to Calendar'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-primary btn-lg',
            disabled: processing,
            onClick: onReserveClick
          },
          'Reserve Now'
        )
      ) : null
    )
  );
};

ReservationReview.propTypes = {
  processing: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  cart: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  total: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  countInCart: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  onClearCartClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onContinueReservingClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onReserveClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

ReservationReview.defaultProps = {
  total: 0,
  countInCart: 0
};

/* harmony default export */ __webpack_exports__["a"] = ReservationReview;

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ReservationReview_jsx__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_util_getCountInCart__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actionTypes__ = __webpack_require__(196);






var mapStateToProps = function mapStateToProps(state) {
  return {
    cart: state.admin.review.cart,
    processing: state.admin.review.processing,
    total: state.admin.review.total,
    countInCart: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_util_getCountInCart__["a" /* getCountInReviewCart */])({
      squads: state.admin.review.cart ? state.admin.review.cart.squads : null,
      events: state.admin.review.cart ? state.admin.review.cart.events : null,
      virtualEvents: state.admin.review.cart ? state.admin.review.cart.virtualEvents : null
    })
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onClearCartClick: function onClearCartClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["b" /* displayClearCartConfirmation */])(true));
    },
    onReserveClick: function onReserveClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* handleReserveClick */])());
    },
    onContinueReservingClick: function onContinueReservingClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* handleContinueReservingClick */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ReservationReview_jsx__["a" /* default */]);

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_OrderReviewSquadList_jsx__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(197);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var mapStateToProps = function mapStateToProps(state) {
  return _extends({}, state.admin.review.cart, {
    eventsInCart: state.admin.review.eventsInCart,
    qtyNotEditable: false
  });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onRemoveSquadItem: function onRemoveSquadItem(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["f" /* removeSquadItemFromAdminCart */])(id));
    },
    onRemoveVirtualEvent: function onRemoveVirtualEvent(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* removeVirtualEventFromAdminCart */])(id));
    },
    onEventSquadFeesClick: function onEventSquadFeesClick(eventPrice, eventAddOnFees) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["q" /* handleSquadFeesButtonClick */])(eventPrice, eventAddOnFees));
    },
    onQuantityChange: function onQuantityChange(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["g" /* handleOnSquadQuantityChange */])(data));
    },
    onVirtualEventQuantityChange: function onVirtualEventQuantityChange(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["e" /* handleOnVirtualEventQuantityChange */])(data));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1_shared_OrderReviewSquadList_jsx__["a" /* default */]);

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_VirtualEventList_jsx__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(197);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var mapStateToProps = function mapStateToProps(state) {
  return _extends({}, state.admin.review.cart, {
    virtualEvents: state.admin.review.bowlerOwnedVirtualEvents,
    qtyNotEditable: false
  });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onRemoveVirtualEvent: function onRemoveVirtualEvent(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["d" /* removeVirtualEventFromAdminCart */])(id));
    },
    onQuantityChange: function onQuantityChange(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["e" /* handleOnVirtualEventQuantityChange */])(data));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1_shared_VirtualEventList_jsx__["a" /* default */]);

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(422);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  cart: null,
  total: 0,
  processing: false,
  amount: 0,
  description: '',
  showClearCartConfirmation: false
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* DISPLAY_CLEAR_CART_CONFIRMATION_FOR_ADMIN */]:
      {
        return _extends({}, state, {
          showClearCartConfirmation: payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* LOAD_RESERVATION_REVIEW_FOR_ADMIN */]:
      {
        var cart = payload;
        var squadsInCart = cart.squads,
            virtualEventsInCart = cart.virtualEvents;
        var eventsInCart = cart.squads.concat(cart.virtualEvents.filter(function (virtualEvent) {
          return virtualEvent.eventId;
        }));

        eventsInCart.forEach(function (event) {
          if (cart.squads.length && !event.eventNumberOfBowlers) {
            event.eventNumberOfBowlers = eventsInCart.find(function (innerEvent) {
              return innerEvent.eventNumberOfBowlers && innerEvent.eventId === event.eventId;
            }).eventNumberOfBowlers;
          }
        });

        var bowlerOwnedVirtualEvents = cart.virtualEvents.filter(function (virtualEvent) {
          return !virtualEvent.eventId;
        });

        var total = squadsInCart.reduce(function (a, b) {
          return a + b.eventTotalPrice * b.quantity;
        }, 0) + virtualEventsInCart.reduce(function (a, b) {
          return a + b.price * b.quantity;
        }, 0);

        return _extends({}, state, {
          cart: cart,
          total: total,
          amount: total.toFixed(2).replace(/\./, ''),
          description: squadsInCart.map(function (item) {
            return item.summary;
          }).join(','),
          eventsInCart: eventsInCart,
          bowlerOwnedVirtualEvents: bowlerOwnedVirtualEvents
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* UPDATE_CART_TOTAL_FOR_ADMIN */]:
      {
        var _squadsInCart = state.cart.squads,
            _virtualEventsInCart = state.cart.virtualEvents;
        var _total = _squadsInCart.reduce(function (a, b) {
          return a + b.eventTotalPrice * b.quantity;
        }, 0) + _virtualEventsInCart.reduce(function (a, b) {
          return a + b.price * b.quantity;
        }, 0);

        var _eventsInCart = _squadsInCart.concat(_virtualEventsInCart.filter(function (virtualEvent) {
          return virtualEvent.eventId;
        }));
        var _bowlerOwnedVirtualEvents = _virtualEventsInCart.filter(function (virtualEvent) {
          return !virtualEvent.eventId;
        });

        return _extends({}, state, {
          eventsInCart: _eventsInCart,
          bowlerOwnedVirtualEvents: _bowlerOwnedVirtualEvents,
          total: _total
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* UPDATE_SQUAD_QTY_FOR_ADMIN */]:
      return _extends({}, state, {
        cart: _extends({}, state.cart, {
          squads: state.cart.squads.map(function (x) {
            return squadReducer(x, { type: type, payload: payload });
          })
        })
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* UPDATE_VIRTUAL_EVENT_QTY_FOR_ADMIN */]:
      return _extends({}, state, {
        cart: _extends({}, state.cart, {
          virtualEvents: state.cart.virtualEvents.map(function (x) {
            return virtualEventReducer(x, { type: type, payload: payload });
          })
        })
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* PROCESSING_STARTED */]:
      return _extends({}, state, {
        processing: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* PROCESSING_FINISHED */]:
      return _extends({}, state, {
        processing: false
      });
    default:
      return state;
  }
};

var squadReducer = function squadReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* UPDATE_SQUAD_QTY_FOR_ADMIN */]:
      {
        if (state.id !== payload.squadId) {
          return state;
        }

        var newQty = Number(payload.inputValue || 0);
        var adminAvailable = state.adminAvailable;
        var quantity = state.quantity;

        if (newQty > payload.max) {
          newQty = payload.max;
        } else if (newQty < 0) {
          newQty = 0;
        }

        return _extends({}, state, {
          quantity: newQty
          //adminAvailable: adminAvailable - quantity
        });
      }

    default:
      return state;
  }
};

var virtualEventReducer = function virtualEventReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref3 = arguments[1];
  var type = _ref3.type,
      payload = _ref3.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* UPDATE_VIRTUAL_EVENT_QTY_FOR_ADMIN */]:
      return state.id === payload.virtualEventId ? _extends({}, state, {
        quantity: Number(payload.inputValue)
      }) : state;

    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_reducer__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__review_reducer__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__schedule_reducer__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__captainDetail_reducer__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__entryDetail_reducer__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducer__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__virtualEventDetail_reducer__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__audit_reducer__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__audit_bowlerAudit_reducer__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__audit_tournamentAudit_reducer__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__audit_entryAudit_reducer__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__audit_virtualEntryAudit_reducer__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__audit_captainAudit_reducer__ = __webpack_require__(711);















var reducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  base: __WEBPACK_IMPORTED_MODULE_6__reducer__["a" /* default */],
  home: __WEBPACK_IMPORTED_MODULE_1__home_reducer__["a" /* default */],
  review: __WEBPACK_IMPORTED_MODULE_2__review_reducer__["a" /* default */],
  schedule: __WEBPACK_IMPORTED_MODULE_3__schedule_reducer__["a" /* default */],
  captainDetail: __WEBPACK_IMPORTED_MODULE_4__captainDetail_reducer__["a" /* default */],
  entryDetail: __WEBPACK_IMPORTED_MODULE_5__entryDetail_reducer__["a" /* default */],
  virtualEventDetail: __WEBPACK_IMPORTED_MODULE_7__virtualEventDetail_reducer__["a" /* default */],
  audit: __WEBPACK_IMPORTED_MODULE_8__audit_reducer__["a" /* default */],
  bowlerAudit: __WEBPACK_IMPORTED_MODULE_9__audit_bowlerAudit_reducer__["a" /* default */],
  tournamentAudit: __WEBPACK_IMPORTED_MODULE_10__audit_tournamentAudit_reducer__["a" /* default */],
  virtualEntryAudit: __WEBPACK_IMPORTED_MODULE_12__audit_virtualEntryAudit_reducer__["a" /* default */],
  entryAudit: __WEBPACK_IMPORTED_MODULE_11__audit_entryAudit_reducer__["a" /* default */],
  captainAudit: __WEBPACK_IMPORTED_MODULE_13__audit_captainAudit_reducer__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home_AdminHome_jsx__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__audit_AuditHomeContainer_jsx__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__audit_entryAudit_AuditSearchEntryDetailListContainer_jsx__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__audit_virtualEntryAudit_AuditVirtualEntryDetailListContainer_jsx__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__audit_bowlerAudit_AuditBowlerDetailListContainer_jsx__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__audit_tournamentAudit_AuditTournamentDetailListContainer_jsx__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__audit_captainAudit_AuditCaptainDetailListContainer_jsx__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__schedule_ReserveSquadsContainer_jsx__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__review_ReservationReviewContainer_jsx__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__entryDetail_EntryDetailContainer_jsx__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__captainDetail_CaptainDetailContainer_jsx__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__virtualEventDetail_VirtualEventDetail_jsx__ = __webpack_require__(855);
// libraries




// actions


// components













var adminRole = "superuser,admin";
var adminOrManagerRole = "superuser,admin,manager";

var routes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'admin',
    role: adminRole,
    component: __WEBPACK_IMPORTED_MODULE_4__home_AdminHome_jsx__["a" /* default */],
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* handleAdminHomeRouteEnter */])(nextState, replace, callback));
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'admin/search',
    role: adminRole,
    component: __WEBPACK_IMPORTED_MODULE_4__home_AdminHome_jsx__["a" /* default */],
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* handleAdminBackToSearchRouteEnter */])(nextState, replace, callback));
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'admin/audit',
    role: adminOrManagerRole,
    component: __WEBPACK_IMPORTED_MODULE_5__audit_AuditHomeContainer_jsx__["a" /* default */],
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["c" /* handleAuditHomeRouteEnter */])(nextState, replace, callback));
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'admin/audit/entry/:entryId',
    role: adminOrManagerRole,
    component: __WEBPACK_IMPORTED_MODULE_6__audit_entryAudit_AuditSearchEntryDetailListContainer_jsx__["a" /* default */],
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* handleAuditEntryRouteEnter */])(nextState, replace, callback));
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'admin/audit/virtualEntry/:virtualEntryId',
    role: adminOrManagerRole,
    component: __WEBPACK_IMPORTED_MODULE_7__audit_virtualEntryAudit_AuditVirtualEntryDetailListContainer_jsx__["a" /* default */],
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["e" /* handleAuditVirtualEntryRouteEnter */])(nextState, replace, callback));
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'admin/audit/bowler/:bowlerId',
    role: adminOrManagerRole,
    component: __WEBPACK_IMPORTED_MODULE_8__audit_bowlerAudit_AuditBowlerDetailListContainer_jsx__["a" /* default */],
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["f" /* handleAuditBowlerRouteEnter */])(nextState, replace, callback));
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'admin/audit/tournament/:tournamentId',
    role: adminOrManagerRole,
    component: __WEBPACK_IMPORTED_MODULE_9__audit_tournamentAudit_AuditTournamentDetailListContainer_jsx__["a" /* default */],
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["g" /* handleAuditTournamentRouteEnter */])(nextState, replace, callback));
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'admin/audit/captain/:captainId/:tournamentId',
    role: adminOrManagerRole,
    component: __WEBPACK_IMPORTED_MODULE_10__audit_captainAudit_AuditCaptainDetailListContainer_jsx__["a" /* default */],
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["h" /* handleAuditCaptainRouteEnter */])(nextState, replace, callback));
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'admin/squads',
    role: adminRole,
    component: __WEBPACK_IMPORTED_MODULE_11__schedule_ReserveSquadsContainer_jsx__["a" /* default */],
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["i" /* handleAdminSquadsRouteEnter */])(nextState, replace, callback));
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'admin/review/:tournamentId',
    role: adminRole,
    component: __WEBPACK_IMPORTED_MODULE_12__review_ReservationReviewContainer_jsx__["a" /* default */],
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["j" /* handleAdminReviewRouteEnter */])(nextState, replace, callback));
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'admin/entry/:entryId',
    role: adminRole,
    component: __WEBPACK_IMPORTED_MODULE_13__entryDetail_EntryDetailContainer_jsx__["a" /* default */],
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["k" /* handleAdminEntryDetailRouteEnter */])(nextState, replace, callback));
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'admin/entry/:entryId/:paymentId',
    role: adminRole,
    component: __WEBPACK_IMPORTED_MODULE_13__entryDetail_EntryDetailContainer_jsx__["a" /* default */],
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["k" /* handleAdminEntryDetailRouteEnter */])(nextState, replace, callback));
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'admin/captain/:captainId',
    role: adminRole,
    component: __WEBPACK_IMPORTED_MODULE_14__captainDetail_CaptainDetailContainer_jsx__["a" /* default */],
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["l" /* handleAdminCaptainDetailRouteEnter */])(nextState, replace, callback));
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'admin/captain/:captainId/:paymentId',
    role: adminRole,
    component: __WEBPACK_IMPORTED_MODULE_14__captainDetail_CaptainDetailContainer_jsx__["a" /* default */],
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["l" /* handleAdminCaptainDetailRouteEnter */])(nextState, replace, callback));
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'admin/captain/:captainId/virtualevent/:virtualEventId',
    role: adminRole,
    component: __WEBPACK_IMPORTED_MODULE_15__virtualEventDetail_VirtualEventDetail_jsx__["a" /* default */],
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["m" /* handleAdminVirtualEventDetailRouteEnter */])(nextState, replace, callback));
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'admin/captain/:captainId/virtualevent/:virtualEventId/:paymentId',
    role: adminRole,
    component: __WEBPACK_IMPORTED_MODULE_15__virtualEventDetail_VirtualEventDetail_jsx__["a" /* default */],
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["m" /* handleAdminVirtualEventDetailRouteEnter */])(nextState, replace, callback));
    }
  })
);

/* harmony default export */ __webpack_exports__["a"] = routes;

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_CartFooter_jsx__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_util_getCountInCart__ = __webpack_require__(281);





var mapStateToProps = function mapStateToProps(state) {
  return {
    total: state.admin.schedule.total,
    countInCart: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_util_getCountInCart__["b" /* getCountInCart */])({
      virtualEvents: state.admin.schedule.virtualEvents,
      events: state.admin.schedule.availableEvents
    }),
    visible: !!state.admin.base.tournament && (!state.admin.schedule.noDatesAvailable || !!state.admin.schedule.allEvent.id)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onReviewClick: function onReviewClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["e" /* handleReviewReservationsClick */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1_shared_CartFooter_jsx__["a" /* default */]);

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_RegistrationCalendar_jsx__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(135);




var mapStateToProps = function mapStateToProps(state) {
  return state.admin.schedule.calendar;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSelectDate: function onSelectDate(date) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* handleDateSelection */])(date));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1_shared_RegistrationCalendar_jsx__["a" /* default */]);

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScheduleEventListContainer_jsx__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RegistrationCalendarContainer_jsx__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_eventPriceDetailsModal_EventPriceDetailsModalContainer_jsx__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VirtualEventContainer_jsx__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CartFooterContainer_jsx__ = __webpack_require__(838);








var ReserveSquads = function ReserveSquads(_ref) {
  var noDatesAvailable = _ref.noDatesAvailable,
      tournamentId = _ref.tournamentId,
      tournamentName = _ref.tournamentName,
      tournaments = _ref.tournaments,
      onTournamentChange = _ref.onTournamentChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-md-4' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            { htmlFor: 'activeTournaments' },
            'Select Tournament'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select___default.a, {
            name: 'activeTournaments',
            options: tournaments,
            simpleValue: true,
            searchable: true,
            value: tournamentId,
            onChange: function onChange(value) {
              return onTournamentChange(value);
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-md-8' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          { className: 'text-center' },
          tournamentName
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-md-12' },
        noDatesAvailable ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'alert alert-info animated fadeIn' },
          'No dates available for this tournament.'
        ) : null
      )
    ),
    noDatesAvailable ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__VirtualEventContainer_jsx__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CartFooterContainer_jsx__["a" /* default */], null)
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-md-4' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RegistrationCalendarContainer_jsx__["a" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-md-8' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ScheduleEventListContainer_jsx__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__VirtualEventContainer_jsx__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CartFooterContainer_jsx__["a" /* default */], null)
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_eventPriceDetailsModal_EventPriceDetailsModalContainer_jsx__["a" /* default */], null)
    )
  );
};

ReserveSquads.propTypes = {
  noDatesAvailable: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  tournamentId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  tournamentName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  tournaments: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  onTournamentChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

ReserveSquads.defaultProps = {
  noDatesAvailable: false,
  tournamentId: null,
  tournamentName: '',
  tournaments: []
};

/* harmony default export */ __webpack_exports__["a"] = ReserveSquads;

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ReserveSquads_jsx__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(135);




var mapStateToProps = function mapStateToProps(state) {
  return {
    tournaments: state.admin.schedule.tournaments,
    tournamentId: state.admin.base.tournament ? state.admin.base.tournament.id : null,
    tournamentName: state.admin.base.tournament ? state.admin.base.tournament.name : '',
    noDatesAvailable: state.admin.schedule.noDatesAvailable
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onTournamentChange: function onTournamentChange(tournamentId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["d" /* handleTournamentChange */])(tournamentId));
    },
    onSelectDate: function onSelectDate(date) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* handleDateSelection */])(date));
    },
    onReviewReservations: function onReviewReservations() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["e" /* handleReviewReservationsClick */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ReserveSquads_jsx__["a" /* default */]);

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_ScheduleEventList_jsx__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actionTypes__ = __webpack_require__(198);






var mapStateToProps = function mapStateToProps(state) {
  return {
    source: state.admin.schedule.availableEvents,
    selectedDate: state.admin.schedule.calendar.selectedDate
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onEventSquadFeesClick: function onEventSquadFeesClick(eventPrice, eventAddOnFees) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["q" /* handleSquadFeesButtonClick */])(eventPrice, eventAddOnFees));
    },
    onEventSquadQuantityChange: function onEventSquadQuantityChange(squadId, quantity, max) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["b" /* setSquadQuantity */])(squadId, quantity, max));
    },
    onEventSquadAddClick: function onEventSquadAddClick(squadId, quantity) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["f" /* handleEventSquadAddClick */])(squadId, quantity));
    },
    onNextDateClick: function onNextDateClick(date) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* handleDateSelection */])(date));
    },
    onAddClick: function onAddClick(item) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["g" /* handleTeamOwnedVirtualEventAddClick */])(item));
    },
    onQuantityChange: function onQuantityChange(eventId, virtualEventId, quantity) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["k" /* updateTeamOwnedVirtualEventQuantity */])(eventId, virtualEventId, quantity));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1_shared_ScheduleEventList_jsx__["a" /* default */]);

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_VirtualEvent_jsx__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(198);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var mapStateToProps = function mapStateToProps(state) {
  return _extends({}, state.admin.schedule.allEvent, {
    virtualEvents: state.admin.schedule.virtualEvents,
    showAllEvent: true
  });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onAddClick: function onAddClick(item) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["h" /* handleBowlerOwnedVirtualEventAddClick */])(item));
    },
    onQuantityChange: function onQuantityChange(virtualEventId, quantity) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["j" /* updateBowlerOwnedVirtualEventQuantity */])(virtualEventId, quantity));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1_shared_VirtualEvent_jsx__["a" /* default */]);

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_constants__ = __webpack_require__(97);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var initialState = {
  total: 0,
  availableEvents: [],
  noDatesAvailable: false,
  calendar: {},
  tournaments: [],
  virtualEvents: [],
  allEvent: {}
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* UPDATE_TOTAL_FOR_ADMIN_RESERVATION */]:
      {
        payload = payload || {};
        var adminCart = _extends({}, payload, {
          squads: payload.squads || [],
          virtualEvents: payload.virtualEvents || []
        });

        var total = 0;

        adminCart.squads.forEach(function (item) {
          total = total + item.quantity * item.eventTotalPrice;
        });

        adminCart.virtualEvents.forEach(function (item) {
          total = total + item.quantity * item.price;
        });

        return _extends({}, state, {
          total: total
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* DISPLAY_BOWLER_OWNED_VIRTUAL_EVENTS_FOR_ADMIN */]:
      {
        var cart = {
          virtualEvents: payload.cart.virtualEvents || []
        };

        var virtualEvents = payload.virtualEvents || [];

        if (virtualEvents != undefined && virtualEvents.length > 0) {
          virtualEvents.forEach(function (virtualEvent) {
            var cartVirtualEvent = cart.virtualEvents.find(function (x) {
              return x.id === virtualEvent.id;
            }) || null;

            if (cartVirtualEvent !== null) {
              virtualEvent.countInCart = cartVirtualEvent.quantity;
            } else {
              virtualEvent.countInCart = Number(0);
            }
          });

          return _extends({}, state, {
            virtualEvents: virtualEvents.map(function (virtualEvent) {
              if (virtualEvent.owner === __WEBPACK_IMPORTED_MODULE_1__shared_constants__["f" /* BOWLER */]) {
                return _extends({}, virtualEvent, { quantity: Number(0) });
              }
            }).filter(function (virtualEvent) {
              return virtualEvent;
            })
          });
        }
        return _extends({}, state);
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_SELECTED_DATE_FOR_ADMIN */]:
      return _extends({}, state, {
        calendar: _extends({}, state.calendar, {
          selectedDate: payload || null
        })
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* SET_SQUAD_QTY_FOR_ADMIN */]:
      return _extends({}, state, {
        availableEvents: state.availableEvents.map(function (x) {
          return eventReducer(x, { type: type, payload: payload });
        })
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SET_AVAILABLE_EVENTS_FOR_ADMIN */]:
      {
        if (!payload) {
          return _extends({}, state, {
            availableEvents: []
          });
        }
        var _cart = {
          squads: payload.cart.squads || []
        };

        payload.events.forEach(function (item) {
          item.squads.forEach(function (squad) {
            var cartSquad = _cart.squads.find(function (x) {
              return x.id === squad.id;
            }) || null;

            if (cartSquad !== null) {
              squad.countInCart = cartSquad.quantity;
              squad.available = squad.available - cartSquad.quantity;
            }

            squad.showBundleGuide = false;
          });

          var virtualEventCart = {
            virtualEvents: payload.cart.virtualEvents || []
          };

          var virtualEvents = item.teamOwnedVirtualEvents || [];

          virtualEvents.forEach(function (virtualEvent) {
            var cartVirtualEvent = virtualEventCart.virtualEvents.find(function (x) {
              return x.id === virtualEvent.id;
            }) || null;

            if (cartVirtualEvent !== null) {
              virtualEvent.countInCart = cartVirtualEvent.quantity;
            } else {
              virtualEvent.countInCart = Number(0);
            }

            virtualEvent.quantity = Number(0);
          });
        });

        return _extends({}, state, {
          availableEvents: payload.events || []
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* SET_NO_DATES_AVAILABLE_FOR_ADMIN */]:
      return _extends({}, state, {
        noDatesAvailable: payload || false
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* DISPLAY_AVAILABLE_SQUAD_DATES_FOR_ADMIN */]:
      return payload ? _extends({}, state, {
        calendar: payload
      }) : state;

    case __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* SET_ACTIVE_TOURNAMENTS_FOR_ADMIN */]:
      return _extends({}, state, {
        tournaments: payload || []
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_GUIDE_IF_SQUAD_IS_BUNDLED_FOR_ADMIN */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* UPDATE_SQUAD_COUNT_IN_CART_FOR_ADMIN_SCHEDULER */]:
      {
        return _extends({}, state, {
          availableEvents: state.availableEvents.map(function (x) {
            return eventReducer(x, { type: type, payload: payload });
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_QTY_FOR_ADMIN_SCHEDULER */]:
      {
        return _extends({}, state, {
          virtualEvents: state.virtualEvents.map(function (x) {
            return eventReducer(x, { type: type, payload: payload });
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_ADMIN_SCHEDULER */]:
      {
        return _extends({}, state, {
          virtualEvents: state.virtualEvents.map(function (x) {
            return eventReducer(x, { type: type, payload: payload });
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* UPDATE_TEAM_OWNED_VIRTUAL_EVENT_QTY_FOR_ADMIN_SCHEDULER */]:
      {
        return _extends({}, state, {
          availableEvents: state.availableEvents.map(function (event) {
            if (event.id === payload.eventId) {
              return _extends({}, event, {
                teamOwnedVirtualEvents: event.teamOwnedVirtualEvents.map(function (x) {
                  return eventReducer(x, { type: type, payload: payload });
                })
              });
            }

            return event;
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* UPDATE_TEAM_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_ADMIN_SCHEDULER */]:
      {
        return _extends({}, state, {
          availableEvents: state.availableEvents.map(function (event) {
            if (event.id === payload.eventId) {
              return _extends({}, event, {
                teamOwnedVirtualEvents: event.teamOwnedVirtualEvents.map(function (x) {
                  return eventReducer(x, { type: type, payload: payload });
                })
              });
            }

            return event;
          })
        });
      }

    default:
      return state;
  }
};

var eventReducer = function eventReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_GUIDE_IF_SQUAD_IS_BUNDLED_FOR_ADMIN */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* SET_SQUAD_QTY_FOR_ADMIN */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* UPDATE_SQUAD_COUNT_IN_CART_FOR_ADMIN_SCHEDULER */]:
      return _extends({}, state, {
        squads: state.squads.map(function (x) {
          return squadReducer(x, { type: type, payload: payload });
        })
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* UPDATE_TEAM_OWNED_VIRTUAL_EVENT_QTY_FOR_ADMIN_SCHEDULER */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_QTY_FOR_ADMIN_SCHEDULER */]:
      return state.id === payload.virtualEventId ? _extends({}, state, {
        quantity: !payload.quantity ? 0 : Number(payload.quantity)
      }) : state;

    case __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* UPDATE_TEAM_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_ADMIN_SCHEDULER */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_ADMIN_SCHEDULER */]:
      return state.id === payload.virtualEventId ? _extends({}, state, {
        countInCart: state.countInCart ? state.countInCart + Number(payload.count) : Number(payload.count)
      }) : state;

    default:
      return state;
  }
};

var squadReducer = function squadReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref3 = arguments[1];
  var type = _ref3.type,
      payload = _ref3.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_GUIDE_IF_SQUAD_IS_BUNDLED_FOR_ADMIN */]:
      {
        return state.id === payload ? _extends({}, state, {
          showBundleGuide: state.hasBundledChild
        }) : state;
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* SET_SQUAD_QTY_FOR_ADMIN */]:
      {
        if (state.id !== payload.squadId) {
          return state;
        }

        var newQty = Number(payload.inputValue || 0);
        var available = state.available;
        var adminAvailable = state.adminAvailable;
        var quantity = state.quantity;

        if (newQty > payload.max) {
          newQty = payload.max;
        } else if (newQty < 0) {
          newQty = 0;
        }

        return payload.addedToCart ? _extends({}, state, {
          quantity: newQty,
          available: available - quantity,
          adminAvailable: adminAvailable - quantity
        }) : _extends({}, state, {
          quantity: newQty
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* UPDATE_SQUAD_COUNT_IN_CART_FOR_ADMIN_SCHEDULER */]:
      {
        return state.id === payload.squadId ? _extends({}, state, {
          countInCart: state.countInCart ? state.countInCart + payload.quantity : payload.quantity
        }) : state;
      }

    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardModal_jsx__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CaptainVirtualEntryChangeModal; });






var CaptainVirtualEntryChangeModal = function CaptainVirtualEntryChangeModal(_ref) {
  var visible = _ref.visible,
      isNew = _ref.isNew,
      submitButtonText = _ref.submitButtonText,
      hasError = _ref.hasError,
      onCancelClick = _ref.onCancelClick,
      handleSubmit = _ref.handleSubmit,
      onSubmit = _ref.onSubmit,
      onSearchClick = _ref.onSearchClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_shared_StandardModal_jsx__["a" /* default */],
    {
      title: 'Change Captain',
      visible: visible,
      onCloseClick: onCancelClick },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'form',
      { onSubmit: handleSubmit(onSubmit) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], { name: 'captainEmail',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'Email' })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'form-group text-right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-lg',
            onClick: onSearchClick
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-search' }),
          ' ',
          'Search'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-6' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], { name: 'captainFirstName',
            disabled: !isNew,
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'First Name' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-6' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], { name: 'captainLastName',
            disabled: !isNew,
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'Last Name' })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'form-group text-right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-link',
            onClick: function onClick() {
              return onCancelClick();
            }
          },
          'Cancel'
        ),
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'submit',
            className: 'btn btn-primary btn-lg',
            disabled: hasError
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
          ' ',
          submitButtonText
        )
      )
    )
  );
};

CaptainVirtualEntryChangeModal.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  isNew: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  submitButtonText: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  hasError: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  onSearchClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* unused harmony default export */ var _unused_webpack_default_export = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'adminCaptainVirtualEntryChangeModal'
})(CaptainVirtualEntryChangeModal);

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CaptainVirtualEntryChangeModal_jsx__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(164);





var mapStateToProps = function mapStateToProps(state) {
  return {
    visible: state.admin.virtualEventDetail.showCaptainVirtualEntryChangeModal,
    isNew: state.admin.virtualEventDetail.isNewCaptainOnSearch,
    submitButtonText: state.admin.virtualEventDetail.isNewCaptainOnSearch ? 'Create' : 'Update',
    validate: __WEBPACK_IMPORTED_MODULE_3__actions__["m" /* validateVirtualEntryCaptainChangeForm */],
    hasError: state.shared.error.source && state.shared.error.source.length > 0
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["n" /* handleVirtualEntryChangeCaptainCancelClick */])());
    },
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["o" /* handleChangeVirtualEntriesCaptainFormSave */])(data));
    },
    onSearchClick: function onSearchClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["p" /* handleVirtualEntryChangeCaptainSearchClick */])());
    }
  };
};

var entryCaptainChangeReduxForm = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'CaptainVirtualEntryChangeForm'
})(__WEBPACK_IMPORTED_MODULE_2__CaptainVirtualEntryChangeModal_jsx__["a" /* CaptainVirtualEntryChangeModal */]);

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(entryCaptainChangeReduxForm);

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_Panel_jsx__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CaptainVirtualEntryChangeModalContainer_jsx__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_util_formatCurrency__ = __webpack_require__(27);




Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_3_shared_util_formatCurrency__["a" /* formatCurrency */];

var CaptainVirtualEntryOptions = function CaptainVirtualEntryOptions(_ref) {
  var hasSelectedEntries = _ref.hasSelectedEntries,
      onChangeEntriesCaptainClick = _ref.onChangeEntriesCaptainClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_shared_Panel_jsx__["a" /* default */],
      { className: 'panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'row vertical-center' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-6 col-xs-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'panel-title',
              style: { display: 'inline-block', marginBottom: 10, marginTop: 6 } },
            'Change virtual entries'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-6 col-xs-12 flex vertical-center right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              style: { minWidth: 150, marginLeft: 10 },
              type: 'button',
              className: 'btn btn-default btn-lg',
              disabled: !hasSelectedEntries,
              onClick: onChangeEntriesCaptainClick },
            'Change Captain'
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CaptainVirtualEntryChangeModalContainer_jsx__["a" /* default */], null)
  );
};

CaptainVirtualEntryOptions.propTypes = {
  hasSelectedEntries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onChangeEntriesCaptainClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = CaptainVirtualEntryOptions;

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CaptainVirtualEntryOptions_jsx__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(199);




var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedEntries: state.admin.virtualEventDetail.selectedVirtualEntries,
    hasSelectedEntries: state.admin.virtualEventDetail.hasSelectedVirtualEntries
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onChangeEntriesCaptainClick: function onChangeEntriesCaptainClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["p" /* displayCaptainVirtualEntryChangeModal */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CaptainVirtualEntryOptions_jsx__["a" /* default */]);

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_util_formatCurrency__ = __webpack_require__(27);





Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_4_shared_util_formatCurrency__["a" /* formatCurrency */];

var VirtualEntryDetail = function VirtualEntryDetail(_ref) {
  var id = _ref.id,
      bowlerId = _ref.bowlerId,
      bowlerName = _ref.bowlerName,
      usbcId = _ref.usbcId,
      entryId = _ref.entryId,
      position = _ref.position,
      divisionName = _ref.divisionName,
      bowlers = _ref.bowlers,
      teams = _ref.teams,
      balance = _ref.balance,
      selected = _ref.selected,
      isCancelled = _ref.isCancelled,
      onBowlerChange = _ref.onBowlerChange,
      onTeamChange = _ref.onTeamChange,
      onSelectChecked = _ref.onSelectChecked,
      onCancelClick = _ref.onCancelClick,
      onReactivateClick = _ref.onReactivateClick,
      onRefundClick = _ref.onRefundClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group-item-labeled' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 45 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'custom-checkbox-container' },
        isCancelled ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
            type: 'checkbox',
            id: 'entry-' + id,
            checked: selected,
            onChange: function onChange() {
              return onSelectChecked(id);
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', {
            htmlFor: 'entry-' + id })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 45 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Entry'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        position
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 300 } },
      isCancelled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'strong',
        {
          className: 'list-group-item-labeled-child',
          style: { marginTop: 10, alignItems: 'center' } },
        'CANCELLED'
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        teams.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'Team'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select___default.a, {
            name: 'team-' + position,
            options: teams.map(function (x) {
              return {
                value: x.id,
                label: x.description
              };
            }),
            value: entryId,
            simpleValue: true,
            searchable: true,
            onChange: function onChange(value) {
              return onTeamChange(id, value);
            }
          })
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'Bowler'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select___default.a, {
            name: 'bowler-' + position,
            options: bowlers.map(function (x) {
              return {
                value: x.id,
                label: x.description
              };
            }),
            placeholder: bowlerId ? bowlerName + ' (' + usbcId + ')' : 'Select...',
            value: bowlerId,
            simpleValue: true,
            searchable: true,
            onChange: function onChange(value) {
              return onBowlerChange(id, value);
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
            { condition: bowlers.find(function (b) {
                return b.id == bowlerId;
              }) ? bowlers.find(function (b) {
                return b.id == bowlerId;
              }).assignedByOtherCaptain : false },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'btn btn-danger',
                disabled: true,
                style: { opacity: 1, marginTop: 5, width: 460, color: '#FFF' } },
              'Bowler already entered into All Events by another captain'
            )
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 150 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Division'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        divisionName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 150 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('list-group-item-labeled-child', { 'bg-danger': balance && !isCancelled }, { 'bg-warning': isCancelled }),
          style: { width: 145, height: 40, alignItems: 'center', justifyContent: 'center', borderRadius: 20 } },
        balance ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          { className: 'flex center' },
          '$' + balance.formatCurrency(2) + ' ' + (isCancelled ? 'BALANCE' : 'DUE')
        ) : null
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 135 } },
      !isCancelled && !balance ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        { className: 'btn btn-default btn-lg',
          style: { height: 40 },
          onClick: function onClick() {
            return onRefundClick(id);
          } },
        'Refund'
      ) : null
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 135 } },
      isCancelled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        { className: 'btn btn-default btn-lg',
          style: { height: 40 },
          onClick: function onClick() {
            return onReactivateClick(id);
          } },
        'Reactivate'
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        { className: 'btn btn-default btn-lg',
          style: { height: 40 },
          onClick: function onClick() {
            return onCancelClick(id);
          } },
        'Cancel'
      )
    )
  );
};

VirtualEntryDetail.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  bowlerId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  bowlerName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  divisionName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  usbcId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  entryId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  position: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number.isRequired,
  bowlers: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  teams: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  balance: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  selected: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  isCancelled: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onBowlerChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onTeamChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSelectChecked: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onReactivateClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onRefundClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

VirtualEntryDetail.defaultProps = {
  bowlers: [],
  teams: [],
  balance: 0
};

/* harmony default export */ __webpack_exports__["a"] = VirtualEntryDetail;

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualEntry_jsx__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(164);





var mapStateToProps = function mapStateToProps(state, props) {
  return props;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onBowlerChange: function onBowlerChange(virtualEntryId, bowlerId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["n" /* setBowlerForVirtualEntry */])(virtualEntryId, bowlerId));
    },
    onTeamChange: function onTeamChange(virtualEntryId, entryId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["o" /* setTeamForVirtualEntry */])(virtualEntryId, entryId));
    },
    onSelectChecked: function onSelectChecked(virtualEntryId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["g" /* handleVirtualEntrySelectChecked */])(virtualEntryId));
    },
    onCancelClick: function onCancelClick(virtualEntryId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["h" /* handleVirtualEntryCancelClick */])(virtualEntryId));
    },
    onReactivateClick: function onReactivateClick(virtualEntryId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["i" /* handleVirtualEntryReactivateClick */])(virtualEntryId));
    },
    onRefundClick: function onRefundClick(virtualEntryId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["j" /* handleVirtualEntryRefundClick */])(virtualEntryId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__VirtualEntry_jsx__["a" /* default */]);

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_Panel_jsx__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VirtualEntryContainer_jsx__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VirtualEntryPaymentModalContainer_jsx__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_DisplayIf_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_util_formatCurrency__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CaptainVirtualEntryOptionsContainer_jsx__ = __webpack_require__(848);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_7_shared_util_formatCurrency__["a" /* formatCurrency */];

var VirtualEntryList = function VirtualEntryList(_ref) {
  var virtualEventId = _ref.virtualEventId,
      virtualEntries = _ref.virtualEntries,
      bowlers = _ref.bowlers,
      teams = _ref.teams,
      submitting = _ref.submitting,
      balance = _ref.balance,
      selectedBalance = _ref.selectedBalance,
      onSaveChangesClick = _ref.onSaveChangesClick,
      onCaptainDetailsLinkClick = _ref.onCaptainDetailsLinkClick,
      onPayBalanceClick = _ref.onPayBalanceClick,
      onPayBalanceOtherClick = _ref.onPayBalanceOtherClick,
      enabledWebHooks = _ref.enabledWebHooks,
      onWebHooksClick = _ref.onWebHooksClick,
      environment = _ref.environment;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_shared_DisplayIf_jsx__["a" /* default */],
      { condition: virtualEntries !== null },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_shared_Panel_jsx__["a" /* default */],
        { className: 'panel-primary' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row flex vertical-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-6' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'panel-title',
                style: { display: 'inline-block' } },
              'All Event Balance:'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'panel-title',
                style: { display: 'inline-block' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '$' + balance.formatCurrency(2)
              ),
              ' ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'small',
                null,
                '(Amount to Pay - $' + selectedBalance.formatCurrency(2) + ')'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-6 flex vertical-center right' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              {
                style: { minWidth: 150, marginLeft: 10 },
                type: 'button',
                disabled: !selectedBalance,
                onClick: onPayBalanceOtherClick,
                className: 'btn btn-default btn-lg' },
              'Cash/Check'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              {
                style: { minWidth: 150, marginLeft: 10 },
                type: 'button',
                disabled: !selectedBalance,
                onClick: onPayBalanceClick,
                className: 'btn btn-primary btn-lg' },
              'Credit Card'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_shared_DisplayIf_jsx__["a" /* default */],
          { condition: !!balance && environment != 'PROD' && environment != 'PRODUCTION',
            className: 'custom-checkbox-container',
            style: { float: "right", paddingRight: 15 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'checkbox',
            id: 'webHooks',
            checked: enabledWebHooks,
            onChange: function onChange(event) {
              return onWebHooksClick(event.target.checked);
            } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            { htmlFor: 'webHooks' },
            'Click here to process payments in real time.'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CaptainVirtualEntryOptionsContainer_jsx__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'form-group text-right animated fadeIn' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-link',
            type: 'button',
            onClick: onCaptainDetailsLinkClick },
          'Back To Captain Details'
        ),
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-primary btn-lg',
            disabled: submitting,
            onClick: function onClick() {
              return onSaveChangesClick(virtualEventId);
            }
          },
          submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__["a" /* default */], null) : null,
          ' ',
          'Save Changes'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__VirtualEntryPaymentModalContainer_jsx__["a" /* default */], null),
      virtualEntries && virtualEntries.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group' },
        virtualEntries.map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__VirtualEntryContainer_jsx__["a" /* default */], _extends({
            key: index
          }, item, {
            bowlers: bowlers.filter(function (b) {
              return item.bowlerId == b.id || !virtualEntries.some(function (e) {
                return e.bowlerId == b.id;
              });
            }),
            teams: teams.filter(function (t) {
              return item.entryId == t.id || !virtualEntries.some(function (e) {
                return e.entryId == t.id;
              });
            }),
            position: index + 1
          }));
        })
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'alert alert-info' },
        'No virtual entries to display.'
      )
    )
  );
};

VirtualEntryList.propTypes = {
  virtualEventId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  virtualEntries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  bowlers: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  teams: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  submitting: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  balance: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  selectedBalance: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  onSaveChangesClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onCaptainDetailsLinkClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onPayBalanceClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onPayBalanceOtherClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  enabledWebHooks: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onWebHooksClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  environment: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

VirtualEntryList.defaultProps = {
  virtualEntries: null,
  bowlers: [],
  teams: [],
  balance: 0,
  selectedBalance: 0
};

/* harmony default export */ __webpack_exports__["a"] = VirtualEntryList;

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualEntryList_jsx__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_webHooks_actions__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_variables__ = __webpack_require__(38);






var mapStateToProps = function mapStateToProps(state) {
  return {
    virtualEventId: state.admin.virtualEventDetail.virtualEventId,
    virtualEntries: state.admin.virtualEventDetail.virtualEntries,
    bowlers: state.admin.virtualEventDetail.bowlers,
    teams: state.admin.virtualEventDetail.teams,
    submitting: state.admin.virtualEventDetail.submitting,
    balance: state.admin.virtualEventDetail.balance,
    selectedBalance: state.admin.virtualEventDetail.selectedBalance,
    environment: __WEBPACK_IMPORTED_MODULE_4_shared_variables__["h" /* ENVIRONMENT */]
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSaveChangesClick: function onSaveChangesClick(virtualEventId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* handleSaveVirtualEventEntriesBowlers */])(virtualEventId));
    },
    onCaptainDetailsLinkClick: function onCaptainDetailsLinkClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["d" /* handleCaptainDetailsLinkClick */])());
    },
    onPayBalanceClick: function onPayBalanceClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["e" /* handlePayBalanceClick */])());
    },
    onPayBalanceOtherClick: function onPayBalanceOtherClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* handlePayBalanceOtherClick */])());
    },
    onWebHooksClick: function onWebHooksClick(checked) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_webHooks_actions__["a" /* handleWebHooksClick */])(checked));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__VirtualEntryList_jsx__["a" /* default */]);

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_StandardModal_jsx__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_DollarInputField_jsx__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_StandardSelectField_jsx__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_StandardTextArea_jsx__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_DisplayIf_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_util_formatCurrency__ = __webpack_require__(27);










Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_9_shared_util_formatCurrency__["a" /* formatCurrency */];

var VirtualEntryPaymentModal = function VirtualEntryPaymentModal(_ref) {
  var paymentType = _ref.paymentType,
      amount = _ref.amount,
      visible = _ref.visible,
      paymentModalType = _ref.paymentModalType,
      virtualEntryId = _ref.virtualEntryId,
      refundType = _ref.refundType,
      onCancel = _ref.onCancel,
      handleSubmit = _ref.handleSubmit,
      onSubmit = _ref.onSubmit,
      purchaseTransactions = _ref.purchaseTransactions;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_shared_StandardModal_jsx__["a" /* default */],
    {
      title: 'Accept ' + paymentModalType,
      visible: visible,
      onCloseClick: onCancel },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      paymentModalType === "Refund" && refundType === 'refundWithCancellation' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        'Please enter refund amount below if a refund was also issued with this cancellation. Otherwise, you are only required to add applicable notes.'
      ) : null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        {
          onSubmit: handleSubmit(onSubmit) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          null,
          'Select ' + paymentModalType + ' Method'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], { name: 'virtualEntryId',
          value: virtualEntryId,
          type: 'hidden',
          component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: 'form-group',
            style: { display: 'flex', flexFlow: 'column' }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'paymentType',
              component: 'input',
              type: 'radio',
              value: 'Cash' }),
            ' Cash'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'paymentType',
              component: 'input',
              type: 'radio',
              value: 'Check' }),
            ' Check'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'paymentType',
              component: 'input',
              type: 'radio',
              value: 'USBC Credit' }),
            ' USBC Credit'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'paymentType',
              component: 'input',
              type: 'radio',
              value: 'USBC Carryover' }),
            ' USBC Carryover'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'paymentType',
              component: 'input',
              type: 'radio',
              value: 'Manual Stripe Transaction' }),
            ' Manual Stripe Transaction'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'paymentType',
              component: 'input',
              type: 'radio',
              value: 'Stripe Purchase Transaction' }),
            ' Stripe Purchase Transaction'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_shared_DisplayIf_jsx__["a" /* default */],
          { condition: paymentType == 'Check' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'checkNumber',
              type: 'number',
              component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
              placeholder: 'Check Number',
              style: { maxWidth: 300 },
              min: '0'
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_shared_DisplayIf_jsx__["a" /* default */],
          { condition: paymentType == 'Manual Stripe Transaction' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'stripeTransactionId',
              component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
              placeholder: 'Stripe Transaction Id',
              style: { width: '30%' }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_shared_DisplayIf_jsx__["a" /* default */],
          { condition: paymentType == 'Stripe Purchase Transaction' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'stripeTransactionId',
              component: __WEBPACK_IMPORTED_MODULE_5_shared_StandardSelectField_jsx__["a" /* default */],
              placeholder: 'Stripe Transaction Id',
              options: purchaseTransactions.map(function (x) {
                return {
                  value: x.creditCardTransactionId,
                  label: x.shortDescription
                };
              }),
              simpleValue: true,
              required: true,
              style: { width: '80%' }
            })
          )
        ),
        paymentModalType === 'Payment' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { marginBottom: 20 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            null,
            paymentModalType + ' Amount'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            '$' + Number(amount).formatCurrency(2)
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { marginBottom: 20 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'amount',
            label: 'Refund Amount',
            placeholder: 'US Dollars',
            component: __WEBPACK_IMPORTED_MODULE_4_shared_DollarInputField_jsx__["a" /* default */],
            style: { width: '25%' }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'notes',
            component: __WEBPACK_IMPORTED_MODULE_6_shared_StandardTextArea_jsx__["a" /* default */],
            placeholder: 'Notes go here',
            maxLength: '255'
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-link',
              onClick: function onClick() {
                return onCancel();
              }
            },
            'Cancel'
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'submit',
              className: 'btn btn-primary btn-lg'
            },
            'Save'
          )
        )
      )
    )
  );
};

VirtualEntryPaymentModal.propTypes = {
  paymentType: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  amount: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string, __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number]),
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  paymentModalType: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  virtualEntryId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  refundType: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onCancel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  purchaseTransactions: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

VirtualEntryPaymentModal.defaultProps = {
  amount: 0
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'adminVirtualEntryPaymentForm'
})(VirtualEntryPaymentModal);

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VirtualEntryPaymentModal_jsx__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(164);





var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["formValueSelector"])('adminVirtualEntryPaymentForm');

var mapStateToProps = function mapStateToProps(state) {
  return {
    paymentType: selector(state, 'paymentType'),
    amount: selector(state, 'amount'),
    visible: state.admin.virtualEventDetail.showPaymentModal,
    paymentModalType: state.admin.virtualEventDetail.paymentModalType,
    refundType: state.admin.virtualEventDetail.refundType,
    purchaseTransactions: state.admin.virtualEventDetail.creditPurchaseTransactions ? state.admin.virtualEventDetail.creditPurchaseTransactions : []
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCancel: function onCancel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["k" /* handlePayBalanceOtherCancelClick */])());
    },
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["l" /* handlePaymentModalSubmitClick */])(data));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__VirtualEntryPaymentModal_jsx__["a" /* default */]);

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualEntryListContainer_jsx__ = __webpack_require__(852);



var VirtualEventDetail = function VirtualEventDetail() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row flex center' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-xs-12' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__VirtualEntryListContainer_jsx__["a" /* default */], null)
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = VirtualEventDetail;

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(424);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  balance: 0,
  virtualEventId: '',
  vitualEventName: '',
  captainId: '',
  captainName: '',
  virtualEntries: null,
  bowlers: [],
  teams: [],
  submitting: false,
  selectedBalance: 0,
  paymentModalType: 'Payment',
  refundType: 'refundOnly',
  selectedVirtualEntries: [],
  hasSelectedVirtualEntries: false,
  showCaptainVirtualEntryChangeModal: false,
  isNewCaptainOnSearch: false
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_SUBMITTING_FOR_ADMIN_VIRTUAL_EVENT_DETAIL */]:
      return _extends({}, state, {
        submitting: payload || initialState.submitting
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_VIRTUAL_ENTRY_BOWLER_FOR_ADMIN_VIRTUAL_EVENT_DETAIL */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_VIRTUAL_ENTRY_TEAM_FOR_ADMIN_VIRTUAL_EVENT_DETAIL */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* SET_VIRTUAL_ENTRY_SELECTED_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL */]:
      {
        var newVirtualEntries = state.virtualEntries.map(function (x) {
          return virtualEntryReducer(x, { type: type, payload: payload });
        });
        var selectedVirtualEntries = newVirtualEntries.filter(function (entry) {
          return entry.selected;
        });
        var hasSelectedVirtualEntries = newVirtualEntries.some(function (entry) {
          return entry.selected;
        });

        return _extends({}, state, {
          virtualEntries: newVirtualEntries,
          selectedVirtualEntries: selectedVirtualEntries,
          hasSelectedVirtualEntries: hasSelectedVirtualEntries
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_DETAILS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL */]:
      return _extends({}, state, payload || {});
    case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* SET_AVAILABLE_BOWLERS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL */]:
      return _extends({}, state, {
        bowlers: payload || initialState.bowlers
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SET_AVAILABLE_TEAMS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL */]:
      return _extends({}, state, {
        teams: payload || initialState.teams
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* SET_VIRTUAL_ENTRIES_FOR_ADMIN_VIRTUAL_EVENT_DETAIL */]:
      {
        var virtualEntries = initialState.virtualEntries;
        var selectedBalance = 0;
        var balance = 0;

        if (payload) {
          virtualEntries = payload.map(function (x) {
            return _extends({}, x, {
              selected: false
            });
          });

          balance = virtualEntries.reduce(function (sum, virtualEntry) {
            return sum + virtualEntry.balance;
          }, 0);
        }
        return _extends({}, state, {
          balance: balance,
          virtualEntries: virtualEntries,
          selectedBalance: selectedBalance
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* CALCULATE_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL */]:
      {
        var _selectedBalance = state.virtualEntries.filter(function (virtualEntry) {
          return virtualEntry.selected;
        }).reduce(function (sum, virtualEntry) {
          return sum + virtualEntry.balance;
        }, 0);

        return _extends({}, state, {
          selectedBalance: _selectedBalance
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* SET_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL */]:
      {
        return _extends({}, state, {
          selectedBalance: payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* DISPLAY_PAYMENT_MODAL_FOR_ADMIN_VIRTUAL_ENTRY_DETAIL */]:
      return _extends({}, state, {
        showPaymentModal: payload.showModal || initialState.showPaymentModal,
        paymentModalType: payload.paymentModalType || initialState.paymentModalType
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* SET_REFUND_TYPE_FOR_ADMIN_VIRTUAL_ENTRY_DETAIL */]:
      {
        return _extends({}, state, {
          refundType: payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* DISPLAY_CAPTAIN_VIRTUAL_ENTRY_CHANGE_MODAL_FOR_ADMIN */]:
      {
        return _extends({}, state, {
          showCaptainVirtualEntryChangeModal: payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* SET_IS_NEW_CAPTAIN_VIRTUAL_ENTRIES_MODAL_FOR_ADMIN */]:
      {
        return _extends({}, state, {
          isNewCaptainOnSearch: payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["o" /* SET_VIRTUAL_EVENT_DETAIL_CREDIT_PURCHASE_TRANSACTIONS */]:
      {
        return _extends({}, state, {
          creditPurchaseTransactions: payload
        });
      }
    default:
      return state;
  }
};

var virtualEntryReducer = function virtualEntryReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_VIRTUAL_ENTRY_BOWLER_FOR_ADMIN_VIRTUAL_EVENT_DETAIL */]:
      return payload && payload.virtualEntryId === state.id ? _extends({}, state, {
        bowlerId: payload.bowlerId
      }) : state;
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_VIRTUAL_ENTRY_TEAM_FOR_ADMIN_VIRTUAL_EVENT_DETAIL */]:
      return payload && payload.virtualEntryId === state.id ? _extends({}, state, {
        entryId: payload.entryId
      }) : state;
    case __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* SET_VIRTUAL_ENTRY_SELECTED_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL */]:
      return payload === state.id ? _extends({}, state, {
        selected: !state.selected
      }) : state;
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_Link_jsx__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__accounts_AccountsListContainer_jsx__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fees_FeesListContainer_jsx__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(272);








var FinanceHome = function FinanceHome(_ref) {
  var actions = _ref.actions,
      selectedAction = _ref.selectedAction,
      onSelectFinanceTab = _ref.onSelectFinanceTab;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-sm-3 col-lg-2' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'left-navigation-bar' },
          actions.map(function (action, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                key: index },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_shared_Link_jsx__["a" /* default */],
                {
                  to: action.to,
                  className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("btn", { "btn-default": !action.active }, { "btn-primary": action.active }),
                  onClick: function onClick() {
                    return onSelectFinanceTab(action);
                  } },
                action.label
              )
            );
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-sm-9 col-lg-10' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
          { condition: selectedAction.label == __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* ADMIN_AUDIT_FINANCE_MANAGEACCOUNTS_LABEL */],
            className: 'animated fadeIn' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__accounts_AccountsListContainer_jsx__["a" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
          { condition: selectedAction.label == __WEBPACK_IMPORTED_MODULE_6__constants__["b" /* ADMIN_AUDIT_FINANCE_SETFEES_LABEL */] || selectedAction.label == __WEBPACK_IMPORTED_MODULE_6__constants__["c" /* ADMIN_AUDIT_FINANCE_VIEWFEES_LABEL */],
            className: 'animated fadeIn' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__fees_FeesListContainer_jsx__["a" /* default */], null)
        )
      )
    )
  );
};

FinanceHome.defaultProps = {};

FinanceHome.propTypes = {
  actions: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  selectedAction: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  onSelectFinanceTab: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = FinanceHome;

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FinanceHome_jsx__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(867);




var mapStateToProps = function mapStateToProps(state) {
  return {
    actions: state.finance.base.financeActions,
    selectedAction: state.finance.base.financeActions.find(function (a) {
      return a.active;
    })
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSelectFinanceTab: function onSelectFinanceTab(financeTab) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["a" /* selectFinanceTab */])(financeTab));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__FinanceHome_jsx__["a" /* default */]);

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_DisplayIf_jsx__ = __webpack_require__(12);



var AccountDetail = function AccountDetail(_ref) {
  var id = _ref.id,
      isActive = _ref.isActive,
      name = _ref.name,
      loginUrl = _ref.loginUrl,
      owner = _ref.owner,
      tournamentCount = _ref.tournamentCount,
      onDeactivateClick = _ref.onDeactivateClick,
      onEditAccountNameClick = _ref.onEditAccountNameClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { className: 'list-group-item-labeled-child has-link',
          style: { width: 250 },
          href: '' + loginUrl },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Account Name'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          name
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 150 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Account Owner'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          owner
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 100 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'text-center' },
          'Tournaments'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'text-center' },
          tournamentCount
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child has-link',
          style: { width: 120 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_shared_DisplayIf_jsx__["a" /* default */],
          { condition: isActive,
            className: 'animated fadeIn' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-link',
              disabled: tournamentCount > 0,
              onClick: function onClick() {
                return onDeactivateClick(id);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-window-close' }),
            ' ',
            'Deactivate'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_shared_DisplayIf_jsx__["a" /* default */],
          { condition: !isActive,
            className: 'animated fadeIn' },
          'Deactivated'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 50 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn btn-link pull-right',
              onClick: function onClick() {
                return onEditAccountNameClick(id);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-pencil' }),
            ' ',
            'Edit'
          )
        )
      )
    )
  );
};

AccountDetail.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  isActive: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  name: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  loginUrl: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  owner: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  tournamentCount: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  onDeactivateClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onEditAccountNameClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

AccountDetail.defaultProps = {
  isActive: false
};

/* harmony default export */ __webpack_exports__["a"] = AccountDetail;

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AccountDetail_jsx__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(271);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var mapStateToProps = function mapStateToProps(props) {
  return _extends({}, props);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onDeactivateClick: function onDeactivateClick(accountId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["e" /* handleDeactivateAccount */])(accountId));
    },
    onEditAccountNameClick: function onEditAccountNameClick(accountId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* handleAccountNameEditClick */])(accountId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AccountDetail_jsx__["a" /* default */]);

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NoItemsToDisplay_jsx__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AccountDetailContainer_jsx__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditAccountModalContainer_jsx__ = __webpack_require__(864);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var AccountsList = function AccountsList(_ref) {
  var accountList = _ref.accountList;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-heading row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'panel-title' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              'Accounts',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { type: 'button',
                  className: 'btn btn-link pull-right',
                  href: !accountList || !accountList.createAccountUrl ? '#' : accountList.createAccountUrl },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-plus' }),
                'Add Account'
              )
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-body' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'animated fadeIn flex wrap' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'row col-xs-12' },
            'All accounts associated with the Group.'
          )
        ),
        !accountList || !accountList.accounts || accountList.accounts.length == 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__NoItemsToDisplay_jsx__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'list-group' },
          accountList.accounts ? accountList.accounts.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AccountDetailContainer_jsx__["a" /* default */], _extends({ key: index
            }, item));
          }) : null
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__EditAccountModalContainer_jsx__["a" /* default */], null)
      )
    )
  );
};

AccountsList.defaultProps = {};

AccountsList.propTypes = {
  accountList: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};

/* harmony default export */ __webpack_exports__["a"] = AccountsList;

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AccountsList_jsx__ = __webpack_require__(861);



var mapStateToProps = function mapStateToProps(state) {
    return {
        accountList: state.finance.accounts.accountsList
    };
};

var mapDispatchToProps = function mapDispatchToProps() {
    return {};
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AccountsList_jsx__["a" /* default */]);

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_StandardModal_jsx__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__ = __webpack_require__(16);





var required = function required(value) {
  return value ? undefined : 'Required';
};

var EditAccountModal = function EditAccountModal(_ref) {
  var visible = _ref.visible,
      onCancel = _ref.onCancel,
      handleSubmit = _ref.handleSubmit,
      onSubmit = _ref.onSubmit;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_shared_StandardModal_jsx__["a" /* default */],
    {
      title: 'Stripe Connect Account Name',
      visible: visible,
      onCloseClick: onCancel },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        { id: 'editAccountForm',
          onSubmit: handleSubmit(onSubmit) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'accountName',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            label: 'Account Name',
            placeholder: 'Enter account name...',
            validate: [required]
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-link',
              onClick: function onClick() {
                return onCancel();
              }
            },
            'Cancel'
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'submit',
              className: 'btn btn-primary btn-lg'
            },
            'Save'
          )
        )
      )
    )
  );
};

EditAccountModal.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'editAccountForm'
})(EditAccountModal);

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditAccountModal_jsx__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(271);




var mapStateToProps = function mapStateToProps(state) {
  return {
    visible: state.finance.accounts.showEditAccountModal
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCancel: function onCancel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* handleEditAccountModalCancel */])());
    },
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["d" /* handleEditAccountModalSave */])(data));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__EditAccountModal_jsx__["a" /* default */]);

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(426);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return displayFinanceAccountsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return displayEditAccountModalVisibility; });


var displayFinanceAccountsList = function displayFinanceAccountsList(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_FINANCE_ACCOUNTS_LIST */],
    payload: data
  };
};

var displayEditAccountModalVisibility = function displayEditAccountModalVisibility(visible) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DISPLAY_ACCOUNT_NAME_MODAL */],
    payload: visible
  };
};

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(426);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  accountsList: null,
  showEditAccountModal: false
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_FINANCE_ACCOUNTS_LIST */]:
      return _extends({}, state, {
        accountsList: payload
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DISPLAY_ACCOUNT_NAME_MODAL */]:
      return _extends({}, state, {
        showEditAccountModal: payload || initialState.showEditAccountModal
      });
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(272);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectFinanceTab; });


var selectFinanceTab = function selectFinanceTab(financeTab) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SELECT_ADMIN_FINANCE_TAB */],
        payload: financeTab
    };
};

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_auth_actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_actions__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_topBanner_actionTypes__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__accounts_actions__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fees_actions__ = __webpack_require__(165);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleFinanceHomeRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleAccountCreatedRouteEnter; });










var handleFinanceHomeRouteEnter = function handleFinanceHomeRouteEnter(nextState, replace, callback) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_topBanner_actionTypes__["b" /* setTitle */])('Finance'));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_topBanner_actionTypes__["c" /* setSubTitle */])(''));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__accounts_actions__["a" /* loadFinancialAccounts */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__fees_actions__["a" /* loadFinancialAccountFees */])());
    }).catch(function () {});
  };
};

var handleAccountCreatedRouteEnter = function handleAccountCreatedRouteEnter(nextState, replace, callback) {
  return function (dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_auth_actions__["f" /* checkAuth */])(nextState, replace, callback)).then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__accounts_actions__["b" /* completeCreateAccount */])()).then(function () {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_actions__["b" /* navigateTo */])('finance'));
      });
    }).catch(function () {});
  };
};

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TournamentTechFeeModalContainer_jsx__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_auth_AuthorizeContainer_jsx__ = __webpack_require__(279);




var FeeDetail = function FeeDetail(_ref) {
  var tournamentName = _ref.tournamentName,
      accountName = _ref.accountName,
      fee = _ref.fee,
      defaultTechnologyFee = _ref.defaultTechnologyFee,
      tournamentId = _ref.tournamentId,
      onEditTournamentTechFeeClick = _ref.onEditTournamentTechFeeClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 300 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Tournament'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          tournamentName
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 200 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Account'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          accountName
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 100 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Technology Fee'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          fee == defaultTechnologyFee ? fee + '% (default)' : fee + '%'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_shared_auth_AuthorizeContainer_jsx__["a" /* default */],
        { hqfinancialofficer: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'list-group-item-labeled-child',
            style: { width: 100 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-link pull-right',
                onClick: function onClick() {
                  return onEditTournamentTechFeeClick(tournamentId);
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-pencil' }),
              ' ',
              'Edit'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TournamentTechFeeModalContainer_jsx__["a" /* default */], null)
          )
        )
      )
    )
  );
};

FeeDetail.propTypes = {
  tournamentName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  accountName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  fee: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  defaultTechnologyFee: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  tournamentId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onEditTournamentTechFeeClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

FeeDetail.defaultProps = {};

/* harmony default export */ __webpack_exports__["a"] = FeeDetail;

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FeeDetail_jsx__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(165);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var mapStateToProps = function mapStateToProps(state, props) {
  return _extends({}, props, {
    defaultTechnologyFee: state.finance.fees.feesList.defaultTechnologyFee
  });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onEditTournamentTechFeeClick: function onEditTournamentTechFeeClick(tournamentId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* handleTournamentTechFeeEditClick */])(tournamentId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__FeeDetail_jsx__["a" /* default */]);

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NoItemsToDisplay_jsx__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FeeDetailContainer_jsx__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GroupTechFeeModalContainer_jsx__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_auth_AuthorizeContainer_jsx__ = __webpack_require__(279);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var FeesList = function FeesList(_ref) {
  var feeData = _ref.feeData,
      onEditDefaultTechFeeClick = _ref.onEditDefaultTechFeeClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-heading row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'panel-title' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              'Technology Fees'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'pull-right' },
              'Default Fee: ',
              feeData ? feeData.defaultTechnologyFee : 0,
              '%',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_shared_auth_AuthorizeContainer_jsx__["a" /* default */],
                { hqfinancialofficer: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-link pull-right',
                    onClick: onEditDefaultTechFeeClick },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-pencil' }),
                  ' ',
                  'Edit'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__GroupTechFeeModalContainer_jsx__["a" /* default */], null)
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-body' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'animated fadeIn flex wrap' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'row col-xs-12' },
            'Technology Fee for each Tournament.'
          )
        ),
        !feeData || !feeData.tournamentTechnologyFees || feeData.tournamentTechnologyFees.length == 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__NoItemsToDisplay_jsx__["a" /* default */], null) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'list-group' },
          !!feeData && feeData.tournamentTechnologyFees ? feeData.tournamentTechnologyFees.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FeeDetailContainer_jsx__["a" /* default */], _extends({ key: index
            }, item));
          }) : null
        )
      )
    )
  );
};

FeesList.defaultProps = {};

FeesList.propTypes = {
  feeData: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  onEditDefaultTechFeeClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = FeesList;

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FeesList_jsx__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(165);




var mapStateToProps = function mapStateToProps(state) {
    return {
        feeData: state.finance.fees.feesList
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        onEditDefaultTechFeeClick: function onEditDefaultTechFeeClick() {
            return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* handleDefaultTechFeeEditClick */])());
        }
    };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__FeesList_jsx__["a" /* default */]);

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_StandardModal_jsx__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__ = __webpack_require__(16);





var required = function required(value) {
  return value ? undefined : 'Required';
};

var pattern = /^-?\d+\.?\d*$/;
var numberOnly = function numberOnly(value) {
  return pattern.test(value) ? undefined : 'Only Numeric values allowed';
};

var GroupTechFeeModal = function GroupTechFeeModal(_ref) {
  var visible = _ref.visible,
      onCancel = _ref.onCancel,
      handleSubmit = _ref.handleSubmit,
      onSubmit = _ref.onSubmit;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_shared_StandardModal_jsx__["a" /* default */],
    {
      title: 'Default Technology Fee',
      visible: visible,
      onCloseClick: onCancel },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        { id: 'groupTechFeeForm',
          onSubmit: handleSubmit(onSubmit) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'fee',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            label: 'Default Fee',
            placeholder: 'Enter default tech fee...',
            validate: ([required], [numberOnly])
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-link',
              onClick: function onClick() {
                return onCancel();
              }
            },
            'Cancel'
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'submit',
              className: 'btn btn-primary btn-lg'
            },
            'Save'
          )
        )
      )
    )
  );
};

GroupTechFeeModal.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'groupTechFeeForm'
})(GroupTechFeeModal);

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GroupTechFeeModal_jsx__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(165);




var mapStateToProps = function mapStateToProps(state) {
  return {
    visible: state.finance.fees.showDefaultTechFeeModal
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCancel: function onCancel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* handleDefaultTechFeeModalCancel */])());
    },
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["g" /* handleDefaultTechFeeModalSave */])(data));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__GroupTechFeeModal_jsx__["a" /* default */]);

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_StandardModal_jsx__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__ = __webpack_require__(16);





var required = function required(value) {
  return value ? undefined : 'Required';
};
var pattern = /^-?\d+\.?\d*$/;
var numberOnly = function numberOnly(value) {
  return pattern.test(value) ? undefined : 'Only Numeric values allowed';
};
var uniqueFee = function uniqueFee(value) {
  return value == defaultTechFee ? 'Technology Fee cannot be the same as the Default Fee' : undefined;
};
var defaultTechFee = 0;

var TournamentTechFeeModal = function TournamentTechFeeModal(_ref) {
  var visible = _ref.visible,
      defaultTechnologyFee = _ref.defaultTechnologyFee,
      onCancel = _ref.onCancel,
      handleSubmit = _ref.handleSubmit,
      onSubmit = _ref.onSubmit;

  defaultTechFee = defaultTechnologyFee;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_shared_StandardModal_jsx__["a" /* default */],
    {
      title: 'Tournament Technology Fee',
      visible: visible,
      onCloseClick: onCancel },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        { id: 'tournamentTechFeeForm',
          onSubmit: handleSubmit(onSubmit) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'fee',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            label: 'Technology Fee',
            placeholder: 'Enter tournament tech fee...',
            validate: ([required], [numberOnly], [uniqueFee])
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-link',
              onClick: function onClick() {
                return onCancel();
              }
            },
            'Cancel'
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'submit',
              className: 'btn btn-primary btn-lg'
            },
            'Save'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'hidden',
          name: 'tournamentId' })
      )
    )
  );
};

TournamentTechFeeModal.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  defaultTechnologyFee: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  onCancel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'tournamentTechFeeForm'
})(TournamentTechFeeModal);

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TournamentTechFeeModal_jsx__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(165);




var mapStateToProps = function mapStateToProps(state) {
  return {
    visible: state.finance.fees.showTournamentTechFeeModal,
    defaultTechnologyFee: state.finance.fees.feesList.defaultTechnologyFee
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCancel: function onCancel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["d" /* handleTournamentTechFeeModalCancel */])());
    },
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["e" /* handleTournamentTechFeeModalSave */])(data));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__TournamentTechFeeModal_jsx__["a" /* default */]);

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(427);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return displayFinancialFeesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return displayDefaultTechFeeModalVisibility; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return displayTournamentTechFeeModalVisibility; });


var displayFinancialFeesList = function displayFinancialFeesList(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_ADMIN_FINANCE_FEES_LIST */],
    payload: data
  };
};

var displayDefaultTechFeeModalVisibility = function displayDefaultTechFeeModalVisibility(visible) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DISPLAY_GROUP_TECH_FEE_MODAL_FOR_DEFAULT_TECH_FEE */],
    payload: visible
  };
};

var displayTournamentTechFeeModalVisibility = function displayTournamentTechFeeModalVisibility(visible) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* DISPLAY_TOURNAMENT_TECH_FEE_MODAL_FOR_DEFAULT_TECH_FEE */],
    payload: visible
  };
};

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(427);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  feesList: null,
  showDefaultTechFeeModal: false
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_ADMIN_FINANCE_FEES_LIST */]:
      return _extends({}, state, {
        feesList: payload
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DISPLAY_GROUP_TECH_FEE_MODAL_FOR_DEFAULT_TECH_FEE */]:
      return _extends({}, state, {
        showDefaultTechFeeModal: payload || initialState.showDefaultTechFeeModal
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* DISPLAY_TOURNAMENT_TECH_FEE_MODAL_FOR_DEFAULT_TECH_FEE */]:
      return _extends({}, state, {
        showTournamentTechFeeModal: payload || initialState.showTournamentTechFeeModal
      });
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(272);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  financeActions: [{
    active: true,
    label: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ADMIN_AUDIT_FINANCE_MANAGEACCOUNTS_LABEL */],
    to: "finance"
  }, {
    active: false,
    label: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* ADMIN_AUDIT_FINANCE_VIEWFEES_LABEL */],
    to: "finance"
  }]
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SELECT_ADMIN_FINANCE_TAB */]:
      state.financeActions.forEach(function (a) {
        return a.active = a.label == payload.label;
      });
      return _extends({}, state);

    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fees_reducer__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__accounts_reducer__ = __webpack_require__(866);






var reducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  base: __WEBPACK_IMPORTED_MODULE_1__reducer__["a" /* default */],
  fees: __WEBPACK_IMPORTED_MODULE_2__fees_reducer__["a" /* default */],
  accounts: __WEBPACK_IMPORTED_MODULE_3__accounts_reducer__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FinanceHomeContainer_jsx__ = __webpack_require__(858);
// libraries




// actions




var superOrFinanceRole = "superuser,financialofficer,hqfinancialofficer";

var routes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'finance',
        role: superOrFinanceRole,
        component: __WEBPACK_IMPORTED_MODULE_4__FinanceHomeContainer_jsx__["a" /* default */],
        onEnter: function onEnter(nextState, replace, callback) {
            return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* handleFinanceHomeRouteEnter */])(nextState, replace, callback));
        }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'finance/accountcreated',
        role: superOrFinanceRole,
        component: __WEBPACK_IMPORTED_MODULE_4__FinanceHomeContainer_jsx__["a" /* default */],
        onEnter: function onEnter(nextState, replace, callback) {
            return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* handleAccountCreatedRouteEnter */])(nextState, replace, callback));
        }
    })
);

/* harmony default export */ __webpack_exports__["a"] = routes;

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_DisplayIf_jsx__ = __webpack_require__(12);



var AccountCreated = function AccountCreated(_ref) {
  var addressBase = _ref.addressBase,
      onResendEmailClick = _ref.onResendEmailClick,
      displayGoHome = _ref.displayGoHome;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h2',
      null,
      'Please Confirm Your Email'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'We\'ve created your account. To protect your private information, we need to confirm your email address.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'Please check your email for a link to confirm your email address and enable your account.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'Can\u2019t find your verification email?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      {
        type: 'button',
        className: 'btn btn-secondary',
        onClick: onResendEmailClick },
      'Resend email'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_shared_DisplayIf_jsx__["a" /* default */],
      { condition: displayGoHome,
        className: 'animated fadeIn' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        'Already verified your email?'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { href: addressBase + '/registration' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-secondary' },
          'Home'
        )
      )
    )
  );
};

AccountCreated.propTypes = {
  addressBase: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onResendEmailClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  displayGoHome: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired
};

AccountCreated.defaultProps = {};

/* harmony default export */ __webpack_exports__["a"] = AccountCreated;

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AccountCreated_jsx__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(885);




var mapStateToProps = function mapStateToProps(state) {
  var addressBase = window.location.href.substring(window.location.origin.length, window.location.href.indexOf('/registration/accountCreated'));

  // This is needed for development testing. 
  if (addressBase == "0") addressBase = "";

  return {
    displayGoHome: state.registration.accountCreated.displayGoHome,
    addressBase: addressBase
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onResendEmailClick: function onResendEmailClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* handleResendEmailClick */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AccountCreated_jsx__["a" /* default */]);

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(428);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return displayGoHome; });


var displayGoHome = function displayGoHome(show) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_GO_HOME */],
    payload: show
  };
};

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_auth_actions__ = __webpack_require__(62);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleResendEmailClick; });


var handleResendEmailClick = function handleResendEmailClick() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_auth_actions__["m" /* goToProfileVerifyAccount */])());
  };
};

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(428);
/* unused harmony export reducer */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  displayGoHome: false
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_GO_HOME */]:
      {
        return _extends({}, state, {
          displayGoHome: payload
        });
      }
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SquadListContainer_jsx__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VirtualEventListContainer_jsx__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_OrderReview_jsx__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_JumbotronLink_jsx__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_ClearCartConfirmationContainer_jsx__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_DisplayIf_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EmbededForm_PaymentFormContainer_jsx__ = __webpack_require__(890);










var Checkout = function Checkout(_ref) {
  var disablePayInFull = _ref.disablePayInFull,
      tournamentId = _ref.tournamentId,
      tournamentName = _ref.tournamentName,
      tournamentStripeKey = _ref.tournamentStripeKey,
      processing = _ref.processing,
      cart = _ref.cart,
      total = _ref.total,
      amount = _ref.amount,
      onClearCartClick = _ref.onClearCartClick,
      onPay = _ref.onPay,
      onCreatePaymentClientSecret = _ref.onCreatePaymentClientSecret,
      onContinueShoppingClick = _ref.onContinueShoppingClick,
      termsUrl = _ref.termsUrl,
      agreedToTerms = _ref.agreedToTerms,
      onAgreeToTermsClick = _ref.onAgreeToTermsClick,
      enabledWebHooks = _ref.enabledWebHooks,
      onWebHooksClick = _ref.onWebHooksClick,
      environment = _ref.environment,
      validationMessages = _ref.validationMessages,
      showPaymentDialog = _ref.showPaymentDialog;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_shared_OrderReview_jsx__["a" /* default */],
      {
        total: total
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__SquadListContainer_jsx__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__VirtualEventListContainer_jsx__["a" /* default */], null),
      !cart || !cart.squads.length && !cart.virtualEvents.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_JumbotronLink_jsx__["a" /* default */], {
        message: 'Your shopping cart is empty.',
        linkPath: 'registration/schedule/' + tournamentId,
        linkText: 'Return to Calendar'
      }) : null
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_ClearCartConfirmationContainer_jsx__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_shared_DisplayIf_jsx__["a" /* default */],
      { condition: !!termsUrl,
        className: 'custom-checkbox-container',
        style: { float: "right", paddingBottom: 15 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'checkbox',
        id: 'agreeToTerms',
        checked: agreedToTerms,
        onChange: function onChange(event) {
          return onAgreeToTermsClick(event.target.checked);
        } }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'label',
        { htmlFor: 'agreeToTerms' },
        'Check here to agree to the \xA0',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { target: '_blank',
            rel: 'noopener noreferrer',
            href: termsUrl },
          'Terms & Conditions'
        ),
        '.'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_shared_DisplayIf_jsx__["a" /* default */],
        { condition: amount > 0 && environment != 'PROD' && environment != 'PRODUCTION',
          className: 'custom-checkbox-container',
          style: { float: "left", paddingBottom: 15 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'checkbox',
          id: 'webHooks',
          checked: enabledWebHooks,
          onChange: function onChange(event) {
            return onWebHooksClick(event.target.checked);
          } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          { htmlFor: 'webHooks' },
          'Click here to process payments in real time.'
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_shared_DisplayIf_jsx__["a" /* default */],
      { condition: Array.isArray(validationMessages) && validationMessages.length > 0 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-xs-12' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'alert alert-danger text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            validationMessages ? validationMessages.map(function (message, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: index },
                '' + message
              );
            }) : null
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_shared_DisplayIf_jsx__["a" /* default */],
      { condition: !termsUrl && amount > 0 && environment != 'PROD' && environment != 'PRODUCTION',
        className: 'custom-checkbox-container',
        style: { float: "right", paddingBottom: 15 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'checkbox',
        id: 'webHooks',
        checked: enabledWebHooks,
        onChange: function onChange(event) {
          return onWebHooksClick(event.target.checked);
        } }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'label',
        { htmlFor: 'webHooks' },
        'Click here to process payments in real time.'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__EmbededForm_PaymentFormContainer_jsx__["a" /* default */], { onCreatePaymentClientSecret: onCreatePaymentClientSecret,
      tournamentStripeKey: tournamentStripeKey, cart: cart, total: total, processing: processing,
      tournamentName: tournamentName, validationMessages: validationMessages,
      showPaymentDialog: showPaymentDialog }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'text-right',
        style: { float: "right", width: "100%" } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-link',
            disabled: processing,
            onClick: onClearCartClick
          },
          'Clear My Cart'
        ),
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-link',
            disabled: processing,
            onClick: onContinueShoppingClick
          },
          'Return to Calendar'
        ),
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'display inline' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-primary btn-lg',
              disabled: termsUrl && !agreedToTerms || disablePayInFull || processing || validationMessages,
              onClick: function onClick() {
                return onPay({
                  amount: amount,
                  cart: cart
                });
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-credit-card' }),
            ' ',
            processing ? 'Processing...' : amount > 0 ? 'Pay Full Amount' : 'Complete Transaction'
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_shared_DisplayIf_jsx__["a" /* default */], { condition: processing,
      className: 'spinnerBackdrop' })
  );
};

Checkout.propTypes = {
  disablePayInFull: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  tournamentId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  processing: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  cart: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  total: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  amount: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onClearCartClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onPay: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onContinueShoppingClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  termsUrl: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  agreedToTerms: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onAgreeToTermsClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  enabledWebHooks: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onWebHooksClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  environment: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  validationMessages: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string),
  showPaymentDialog: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancelPaymentEmbeddedForm: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = Checkout;

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Checkout_jsx__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_actionTypes__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_actions__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_webHooks_actions__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_variables__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(110);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










var mapStateToProps = function mapStateToProps(state) {
  return _extends({}, state.registration.base, state.registration.payment, {
    environment: __WEBPACK_IMPORTED_MODULE_5_shared_variables__["h" /* ENVIRONMENT */]
  });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onClearCartClick: function onClearCartClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_actionTypes__["Q" /* displayClearCartConfirmation */])(true));
    },
    onPay: function onPay(paymentDetail) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["i" /* openPaymentDialog */])(paymentDetail));
    },
    onCreatePaymentClientSecret: function onCreatePaymentClientSecret(paymentDetail) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["j" /* createPaymentClientSecret */])(paymentDetail));
    },
    onContinueShoppingClick: function onContinueShoppingClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_actions__["h" /* handleContinueShoppingClick */])());
    },
    onAgreeToTermsClick: function onAgreeToTermsClick(checked) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["k" /* handleAgreeToTermsClick */])(checked));
    },
    onWebHooksClick: function onWebHooksClick(checked) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_webHooks_actions__["a" /* handleWebHooksClick */])(checked));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__Checkout_jsx__["a" /* default */]);

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_stripe_elements__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_stripe_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_stripe_elements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_DisplayIf_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_StandardModal_jsx__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PaymentForm_css__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PaymentForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__PaymentForm_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var requiredErrorMessages = {
    cardholderNameRequired: "Your card holder Name is incomplete.",
    cardNumberRequired: "Your card number is incomplete.",
    cardExpiryRequired: "Your card’s expiration date is incomplete.",
    cardCvcRequired: "Your card’s security code is incomplete."
};

var PaymentForm = function (_Component) {
    _inherits(PaymentForm, _Component);

    function PaymentForm(props) {
        _classCallCheck(this, PaymentForm);

        var _this = _possibleConstructorReturn(this, (PaymentForm.__proto__ || Object.getPrototypeOf(PaymentForm)).call(this, props));

        _this.state = {
            paymentError: null,
            success: false,
            isLoading: false,
            paymentRequest: null,
            canMakePayment: false,
            paymentProcessing: false,
            cardElements: {
                cardholderName: { complete: false, error: requiredErrorMessages.cardholderNameRequired, touched: false },
                cardNumber: { complete: false, error: requiredErrorMessages.cardNumberRequired, touched: false },
                cardExpiry: { complete: false, error: requiredErrorMessages.cardExpiryRequired, touched: false },
                cardCvc: { complete: false, error: requiredErrorMessages.cardCvcRequired, touched: false }
            }
        };

        _this.handleFormSubmit = _this.handleFormSubmit.bind(_this);
        _this.handlePaymentRequestButtonClick = _this.handlePaymentRequestButtonClick.bind(_this);
        _this.handleNameChange = _this.handleNameChange.bind(_this);
        _this.handleCardElementChange = _this.handleCardElementChange.bind(_this);

        if (!_this.props.stripe) {
            console.warn("Stripe has not loaded yet.");
            return _possibleConstructorReturn(_this);
        }

        var _this$props = _this.props,
            stripe = _this$props.stripe,
            total = _this$props.total;


        if (stripe) {

            var paymentRequest = stripe.paymentRequest({
                country: 'US',
                currency: 'usd',
                total: { label: 'Total Amount', amount: total * 100 }
            });

            paymentRequest.canMakePayment().then(function (result) {
                console.log('canMakePayment', result);
                if (result) {
                    _this.setState({ paymentRequest: paymentRequest });
                    _this.setState({ canMakePayment: !!result });
                } else {
                    console.warn("Payment Request is still not available.");
                }
            });

            paymentRequest.on('paymentmethod', function (event) {
                var _this$props2 = _this.props,
                    stripe = _this$props2.stripe,
                    createPaymentClientSecret = _this$props2.createPaymentClientSecret,
                    registration = _this$props2.registration,
                    processPayment = _this$props2.processPayment,
                    cart = _this$props2.cart,
                    closePaymentDialogEmbeddedForm = _this$props2.closePaymentDialogEmbeddedForm;


                console.log("cart", cart);

                var thisInst = _this;

                createPaymentClientSecret(cart).then(function (result) {

                    var errorMessages = result.messages;

                    if (!errorMessages || errorMessages.length == 0) {

                        var clientSecret = result.paymentId;

                        if (!clientSecret) {
                            event.complete('fail');
                            return;
                        }

                        stripe.confirmPaymentIntent(clientSecret, {
                            payment_method: event.paymentMethod.id
                        }).then(function (result) {
                            if (result.error) {
                                thisInst.setPaymentError(result.error.message);
                                event.complete('fail');
                            } else {
                                var paymentDetail = {
                                    PaymentId: result.paymentIntent.id,
                                    TournamentId: registration.base.tournamentId
                                };

                                processPayment(paymentDetail);

                                event.complete('success');
                                closePaymentDialogEmbeddedForm();
                            }
                        });
                    } else {
                        event.complete('fail');
                    }
                }).catch(function (error) {
                    event.complete('fail');
                });
            });
        }
        return _this;
    }

    _createClass(PaymentForm, [{
        key: 'handleNameChange',
        value: function handleNameChange(event) {
            var value = event.target.value;

            this.setState(function (prevState) {
                return {
                    cardElements: _extends({}, prevState.cardElements, {
                        cardholderName: {
                            value: value,
                            complete: !!value,
                            error: !value ? requiredErrorMessages.cardholderNameRequired : '',
                            touched: true
                        }
                    })
                };
            });
        }
    }, {
        key: 'handleCardElementChange',
        value: function handleCardElementChange(change) {
            this.setState(function (prevState) {
                return {
                    cardElements: _extends({}, prevState.cardElements, _defineProperty({}, change.elementType, {
                        complete: change.complete,
                        error: change.error ? change.error.message : !change.complete ? requiredErrorMessages[change.elementType] : '',
                        touched: true
                    }))
                };
            });
        }
    }, {
        key: 'handleFormSubmit',
        value: function handleFormSubmit(event) {
            var _this2 = this;

            event.preventDefault();

            this.setState(function (prevState) {
                return _extends({}, prevState, {
                    cardElements: {
                        cardholderName: _extends({}, prevState.cardElements.cardholderName, { touched: true }),
                        cardNumber: _extends({}, prevState.cardElements.cardNumber, { touched: true }),
                        cardExpiry: _extends({}, prevState.cardElements.cardExpiry, { touched: true }),
                        cardCvc: _extends({}, prevState.cardElements.cardCvc, { touched: true })
                    }
                });
            });

            var _props = this.props,
                createPaymentClientSecret = _props.createPaymentClientSecret,
                cart = _props.cart;


            if (!!this.state.cardElements.cardholderName.error || !!this.state.cardElements.cardNumber.error || !!this.state.cardElements.cardExpiry.error || !!this.state.cardElements.cardCvc.error) {
                return;
            }

            this.startPaymentProcessingState();

            createPaymentClientSecret(cart).then(function (result) {

                var errorMessages = result.messages;

                if (!errorMessages || errorMessages.length == 0) {
                    var _props2 = _this2.props,
                        stripe = _props2.stripe,
                        registration = _props2.registration,
                        _processPayment = _props2.processPayment,
                        _closePaymentDialogEmbeddedForm = _props2.closePaymentDialogEmbeddedForm;

                    var cardNumberElement = _this2.props.elements.getElement('cardNumber');

                    var clientSecret = result.paymentId;

                    if (!stripe || !clientSecret) {
                        _this2.finishPaymentProcessingState();
                        return;
                    }

                    try {
                        var thisInst = _this2;
                        stripe.confirmCardPayment(clientSecret, {
                            payment_method: {
                                card: cardNumberElement,
                                billing_details: {
                                    name: _this2.state.cardholderName // Include cardholder name
                                }
                            }
                        }).then(function (result) {

                            thisInst.finishPaymentProcessingState();

                            if (result.error) {
                                thisInst.setPaymentError(result.error.message);
                            } else {
                                var paymentDetail = {
                                    PaymentId: result.paymentIntent.id,
                                    TournamentId: registration.base.tournamentId
                                };

                                _processPayment(paymentDetail);
                                _closePaymentDialogEmbeddedForm();
                            }
                        });
                    } catch (err) {
                        console.error('Unexpected error:', err);
                    }
                } else {
                    _this2.finishPaymentProcessingState();
                }
            }).catch(function (error) {
                _this2.finishPaymentProcessingState();
            });
        }
    }, {
        key: 'handlePaymentRequestButtonClick',
        value: function handlePaymentRequestButtonClick(event) {
            var _this3 = this;

            event.preventDefault();

            this.startPaymentProcessingState();

            var _props3 = this.props,
                createPaymentClientSecret = _props3.createPaymentClientSecret,
                cart = _props3.cart;


            createPaymentClientSecret(cart).then(function (result) {

                _this3.finishPaymentProcessingState();

                var errorMessages = result.messages;

                if (!errorMessages || errorMessages.length == 0) {
                    _this3.state.paymentRequest.update({
                        country: 'US',
                        currency: 'usd',
                        total: { label: 'Total Amount', amount: result.totalPaid * 100 }
                    });

                    _this3.state.paymentRequest.show();
                }
            }).catch(function (error) {
                _this3.finishPaymentProcessingState();
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var createOptions = function createOptions(fontSize, padding) {
                return {
                    style: {
                        base: {
                            fontSize: fontSize,
                            color: '#424770',
                            letterSpacing: '0.025em',
                            fontFamily: 'Source Code Pro, monospace',
                            '::placeholder': {
                                color: '#aab7c4'
                            },
                            padding: padding
                        },
                        invalid: {
                            color: '#9e2146'
                        }
                    }
                };
            };

            var _state = this.state,
                paymentRequest = _state.paymentRequest,
                canMakePayment = _state.canMakePayment,
                paymentProcessing = _state.paymentProcessing,
                paymentError = _state.paymentError;
            var _props4 = this.props,
                _props4$externalProce = _props4.externalProcessing,
                externalProcessing = _props4$externalProce === undefined ? processing : _props4$externalProce,
                tournamentName = _props4.tournamentName,
                total = _props4.total,
                validationMessages = _props4.validationMessages,
                closePaymentDialogEmbeddedForm = _props4.closePaymentDialogEmbeddedForm,
                showPaymentDialog = _props4.showPaymentDialog;


            var processing = externalProcessing || paymentProcessing;

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_shared_StandardModal_jsx__["a" /* default */],
                {
                    title: 'Payment',
                    visible: showPaymentDialog,
                    onCloseClick: closePaymentDialogEmbeddedForm,
                    disableClose: processing },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'col-md-12 mb-3' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { className: 'payment-info custom-card h-100' },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    'div',
                                    { className: 'd-flex justify-content-center mb-1' },
                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                        'span',
                                        { className: 'fst-italic fw-bold text-center' },
                                        tournamentName
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr', null),
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    'h4',
                                    { className: 'text-right' },
                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                        'strong',
                                        null,
                                        'Total: $',
                                        total.formatCurrency(2)
                                    )
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'col-md-12' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'form',
                                { onSubmit: this.handleFormSubmit, className: 'stripe-container' },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    'div',
                                    { className: 'panel panel-default' },
                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                        'div',
                                        { className: 'panel-body' },
                                        canMakePayment === true && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                            'div',
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_stripe_elements__["PaymentRequestButtonElement"], {
                                                className: "PaymentRequestButton " + (processing ? 'div-disabled' : ''),
                                                paymentRequest: paymentRequest,
                                                onClick: this.handlePaymentRequestButtonClick }),
                                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                'div',
                                                { className: 'Divider' },
                                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr', null),
                                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                    'p',
                                                    { className: 'Divider-Text Text Text-color--gray400 Text-fontSize--14 Text-fontWeight--400' },
                                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                        'span',
                                                        { className: 'DividerText' },
                                                        'Or pay with card'
                                                    )
                                                )
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                            'div',
                                            { className: 'row' },
                                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                'div',
                                                { className: 'col-md-12' },
                                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                    'div',
                                                    { className: 'form-group' },
                                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                        'label',
                                                        { className: 'stripe-label' },
                                                        'Card number'
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_stripe_elements__["CardNumberElement"], _extends({
                                                        onChange: this.handleCardElementChange
                                                    }, createOptions(this.props.fontSize))),
                                                    !!this.state.cardElements.cardNumber.error && this.state.cardElements.cardNumber.touched == true && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                        'div',
                                                        { className: 'error-text' },
                                                        this.state.cardElements.cardNumber.error
                                                    )
                                                )
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                            'div',
                                            { className: 'row' },
                                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                'div',
                                                { className: 'col-md-6' },
                                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                    'div',
                                                    { className: 'form-group' },
                                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                        'label',
                                                        { className: 'stripe-label' },
                                                        'Expiration date'
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_stripe_elements__["CardExpiryElement"], _extends({
                                                        onChange: this.handleCardElementChange
                                                    }, createOptions(this.props.fontSize))),
                                                    !!this.state.cardElements.cardExpiry.error && this.state.cardElements.cardExpiry.touched == true && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                        'div',
                                                        { className: 'error-text' },
                                                        this.state.cardElements.cardExpiry.error
                                                    )
                                                )
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                'div',
                                                { className: 'col-md-6' },
                                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                    'div',
                                                    { className: 'form-group' },
                                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                        'label',
                                                        { className: 'stripe-label' },
                                                        'CVC'
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_stripe_elements__["CardCVCElement"], _extends({
                                                        onChange: this.handleCardElementChange
                                                    }, createOptions(this.props.fontSize))),
                                                    !!this.state.cardElements.cardCvc.error && this.state.cardElements.cardCvc.touched == true && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                        'div',
                                                        { className: 'error-text' },
                                                        this.state.cardElements.cardCvc.error
                                                    )
                                                )
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                            'div',
                                            { className: 'row' },
                                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                'div',
                                                { className: 'col-md-12' },
                                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                    'div',
                                                    { className: 'form-group' },
                                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                        'label',
                                                        { className: 'stripe-label' },
                                                        ' Cardholder Name'
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
                                                        id: 'billingName', name: 'billingName',
                                                        type: 'text',
                                                        placeholder: 'Full Name',
                                                        value: this.state.cardElements.cardholderName.value,
                                                        onChange: this.handleNameChange,
                                                        className: 'StripeElement InputElement'
                                                    }),
                                                    !!this.state.cardElements.cardholderName.error && this.state.cardElements.cardholderName.touched == true && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                        'div',
                                                        { className: 'error-text' },
                                                        this.state.cardElements.cardholderName.error
                                                    )
                                                )
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_4_shared_DisplayIf_jsx__["a" /* default */],
                                            { condition: Array.isArray(validationMessages) && validationMessages.length > 0 },
                                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                'div',
                                                { className: 'row' },
                                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                    'div',
                                                    { className: 'col-xs-12' },
                                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                        'div',
                                                        { className: 'alert alert-danger text-center Text-fontSize--14 payment-alert' },
                                                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                            'div',
                                                            null,
                                                            validationMessages ? validationMessages.map(function (message, index) {
                                                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                                    'div',
                                                                    { key: index },
                                                                    '' + message
                                                                );
                                                            }) : null
                                                        )
                                                    )
                                                )
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_4_shared_DisplayIf_jsx__["a" /* default */],
                                            { condition: !!paymentError },
                                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                'div',
                                                { className: 'row' },
                                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                    'div',
                                                    { className: 'col-xs-12' },
                                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                        'div',
                                                        { className: 'alert alert-danger text-center Text-fontSize--14 payment-alert' },
                                                        paymentError
                                                    )
                                                )
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                        'div',
                                        { className: 'panel-footer' },
                                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                            'div',
                                            { className: 'row' },
                                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                'div',
                                                { className: 'col-md-12' },
                                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                    'div',
                                                    { className: 'display inline' },
                                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                        'button',
                                                        {
                                                            className: 'btn btn-primary btn-lg',
                                                            disabled: processing,
                                                            type: 'submit'
                                                        },
                                                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'fa fa-credit-card' }),
                                                        ' ',
                                                        processing ? 'Processing...' : 'Pay'
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                        'button',
                                                        {
                                                            type: 'button',
                                                            className: 'btn btn-link',
                                                            disabled: processing,
                                                            onClick: function onClick() {
                                                                return closePaymentDialogEmbeddedForm();
                                                            }
                                                        },
                                                        'Cancel'
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'startPaymentProcessingState',
        value: function startPaymentProcessingState() {
            this.setState(function (prevState) {
                return _extends({}, prevState, {
                    paymentProcessing: true,
                    paymentError: null
                });
            });
        }
    }, {
        key: 'finishPaymentProcessingState',
        value: function finishPaymentProcessingState() {
            this.setState(function (prevState) {
                return _extends({}, prevState, {
                    paymentProcessing: false
                });
            });
        }
    }, {
        key: 'setPaymentError',
        value: function setPaymentError(errorMessage) {
            this.setState(function (prevState) {
                return _extends({}, prevState, {
                    paymentError: errorMessage
                });
            });
        }
    }]);

    return PaymentForm;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
    return _extends({}, state);
};

var mapDispatchToProps = {
    processPayment: __WEBPACK_IMPORTED_MODULE_3__actions__["c" /* processPayment */],
    createPaymentClientSecret: __WEBPACK_IMPORTED_MODULE_3__actions__["j" /* createPaymentClientSecret */],
    closePaymentDialogEmbeddedForm: __WEBPACK_IMPORTED_MODULE_3__actions__["l" /* closePaymentDialogEmbeddedForm */]
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_stripe_elements__["injectStripe"])(PaymentForm));

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_stripe_elements__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_stripe_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_stripe_elements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PaymentForm_jsx__ = __webpack_require__(889);





var PaymentFormContainer = function PaymentFormContainer(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'Checkout' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_stripe_elements__["StripeProvider"],
            { apiKey: props.tournamentStripeKey },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_stripe_elements__["Elements"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__PaymentForm_jsx__["a" /* default */], props)
            )
        )
    );
};

/* harmony default export */ __webpack_exports__["a"] = PaymentFormContainer;

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_OrderReviewSquadList_jsx__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(110);





var mapStateToProps = function mapStateToProps(state) {
  return {
    eventsInCart: state.registration.payment.eventsInCart,
    qtyNotEditable: state.registration.base.requireRosterBeforeCheckout
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onRemoveSquadItem: function onRemoveSquadItem(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["m" /* removeSquadItemFromCart */])(id));
    },
    onRemoveVirtualEvent: function onRemoveVirtualEvent(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["g" /* removeVirtualEventFromCart */])(id));
    },
    onEventSquadFeesClick: function onEventSquadFeesClick(eventPrice, eventAddOnFees) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["n" /* handleSquadFeesButtonClick */])(eventPrice, eventAddOnFees));
    },
    onQuantityChange: function onQuantityChange(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["o" /* handleOnSquadQuantityChange */])(data));
    },
    onVirtualEventQuantityChange: function onVirtualEventQuantityChange(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["h" /* handleOnVirtualEventQuantityChange */])(data));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1_shared_OrderReviewSquadList_jsx__["a" /* default */]);

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_VirtualEventList_jsx__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(110);





var mapStateToProps = function mapStateToProps(state) {
  return {
    virtualEvents: state.registration.payment.bowlerOwnedVirtualEvents,
    qtyNotEditable: state.registration.base.requireRosterBeforeCheckout
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onRemoveVirtualEvent: function onRemoveVirtualEvent(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["g" /* removeVirtualEventFromCart */])(id));
    },
    onQuantityChange: function onQuantityChange(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["h" /* handleOnVirtualEventQuantityChange */])(data));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1_shared_VirtualEventList_jsx__["a" /* default */]);

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_constants__ = __webpack_require__(274);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var initialState = {
  cart: null,
  total: 0,
  processing: false,
  showClearCartConfirmation: false,
  disablePayInFull: true,
  alreadyValidated: false,
  termsUrl: '',
  agreedToTerms: false,
  validationMessages: null
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_PAY_IN_FULL_DISABLED_FOR_REG_CHECKOUT */]:
      return _extends({}, state, {
        disablePayInFull: typeof payload !== 'undefined' && payload !== null ? payload : initialState.disablePayInFull
      });
    case __WEBPACK_IMPORTED_MODULE_1__shared_constants__["d" /* DISPLAY_CLEAR_CART_CONFIRMATION_FOR_CAPTAIN */]:
      return _extends({}, state, {
        showClearCartConfirmation: payload
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* LOAD_CHECKOUT */]:
      {
        var cart = payload;
        var squadsInCart = cart.squads,
            virtualEventsInCart = cart.virtualEvents;
        var eventsInCart = cart.squads.concat(cart.virtualEvents.filter(function (virtualEvent) {
          return virtualEvent.eventId;
        }));

        eventsInCart.forEach(function (event) {
          if (!event.eventNumberOfBowlers) {
            var mappedEvent = eventsInCart.find(function (innerEvent) {
              return innerEvent.eventNumberOfBowlers && innerEvent.eventId === event.eventId;
            });

            if (mappedEvent) {
              event.eventNumberOfBowlers = mappedEvent.eventNumberOfBowlers;
            }
          }
        });

        var bowlerOwnedVirtualEvents = cart.virtualEvents.filter(function (virtualEvent) {
          return !virtualEvent.eventId;
        });

        var total = squadsInCart.reduce(function (a, b) {
          return a + b.eventTotalPrice * b.quantity;
        }, 0) + virtualEventsInCart.reduce(function (a, b) {
          return a + b.price * b.quantity;
        }, 0);

        return _extends({}, state, {
          cart: cart,
          total: total,
          amount: total.toFixed(2).replace(/\./, ''),
          description: squadsInCart.map(function (item) {
            return item.summary;
          }).join(','),
          eventsInCart: eventsInCart,
          bowlerOwnedVirtualEvents: bowlerOwnedVirtualEvents
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* PROCESSING_STARTED */]:
      return _extends({}, state, {
        processing: true
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* PROCESSING_FINISHED */]:
      return _extends({}, state, {
        processing: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* UPDATE_CART_TOTAL_FOR_REG_CHECKOUT */]:
      {
        var _squadsInCart = state.cart.squads,
            _virtualEventsInCart = state.cart.virtualEvents;
        var _total = _squadsInCart.reduce(function (a, b) {
          return a + b.eventTotalPrice * b.quantity;
        }, 0) + _virtualEventsInCart.reduce(function (a, b) {
          return a + b.price * b.quantity;
        }, 0);

        return _extends({}, state, {
          total: _total
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* UPDATE_SQUAD_QTY_FOR_REG_CHECKOUT */]:
      return _extends({}, state, {
        cart: _extends({}, state.cart, {
          squads: state.cart.squads.map(function (x) {
            return squadReducer(x, { type: type, payload: payload });
          })
        })
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* SET_ALREADY_VALIDATED */]:
      return _extends({}, state, {
        alreadyValidated: payload
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* UPDATE_VIRTUAL_EVENT_QTY_FOR_REG_CHECKOUT */]:
      return _extends({}, state, {
        cart: _extends({}, state.cart, {
          virtualEvents: state.cart.virtualEvents.map(function (x) {
            return virtualEventReducer(x, { type: type, payload: payload });
          })
        })
      });
    case __WEBPACK_IMPORTED_MODULE_1__shared_constants__["_1" /* SET_CURRENT_ROSTER_CART_ID */]:
      {
        var _cart = state.cart;
        var _squadsInCart2 = _cart.squads.slice();
        var _virtualEventsInCart2 = _cart.virtualEvents.slice();
        var editingCartEntry = _squadsInCart2.find(function (squad) {
          return squad.cartRosterId == payload.oldId;
        });

        if (!editingCartEntry) {
          editingCartEntry = _virtualEventsInCart2.find(function (cartEntry) {
            return cartEntry.cartRosterId == payload.oldId;
          });
        }

        if (editingCartEntry) {
          editingCartEntry.cartRosterId = payload.newId;
        }

        return _extends({}, state, {
          cart: _extends({}, _cart, {
            squads: _squadsInCart2,
            virtualEvents: _virtualEventsInCart2
          })
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* CLEAR_PAYMENT */]:
      return initialState;

    case __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* SET_TERMS_URL_FOR_REG_CHECKOUT */]:
      return _extends({}, state, {
        termsUrl: payload
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* SET_VALIDATION_MESSAGES_FOR_REG_CHECKOUT */]:
      return _extends({}, state, {
        validationMessages: payload
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* SET_AGREE_TO_TERMS_FOR_REG_CHECKOUT */]:
      return _extends({}, state, {
        agreedToTerms: payload
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* CREATE_CHECKOUT_PAYMENT */]:
      console.log('CREATE_CHECKOUT_PAYMENT', payload);
      return _extends({}, state, {
        checkoutPayment: payload
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* SHOW_PAYMENT_DIALOG_EMBEDDED_FORM */]:
      return _extends({}, state, {
        showPaymentDialog: payload
      });

    default:
      return state;
  }
};

var squadReducer = function squadReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* UPDATE_SQUAD_QTY_FOR_REG_CHECKOUT */]:
      return state.id === payload.squadId ? _extends({}, state, {
        quantity: Number(payload.inputValue)
      }) : state;
    default:
      return state;
  }
};

var virtualEventReducer = function virtualEventReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref3 = arguments[1];
  var type = _ref3.type,
      payload = _ref3.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* UPDATE_VIRTUAL_EVENT_QTY_FOR_REG_CHECKOUT */]:
      return state.id === payload.virtualEventId ? _extends({}, state, {
        quantity: Number(payload.inputValue)
      }) : state;
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TournamentListContainer_jsx__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TournamentRequirementModalContainer_jsx__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RequiredProfileFieldsModalContainer_jsx__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_DisplayIf_jsx__ = __webpack_require__(12);






var RegHome = function RegHome(_ref) {
  var activeTournamentsQty = _ref.activeTournamentsQty,
      paymentMessage = _ref.paymentMessage,
      loadingTournaments = _ref.loadingTournaments,
      groupName = _ref.groupName,
      isAllowed = _ref.isAllowed,
      onPartnerLoginClick = _ref.onPartnerLoginClick,
      onExitPartnerClick = _ref.onExitPartnerClick,
      roles = _ref.roles;

  var isCaptain = !roles.length;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TournamentRequirementModalContainer_jsx__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RequiredProfileFieldsModalContainer_jsx__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_shared_DisplayIf_jsx__["a" /* default */],
      { condition: !!paymentMessage, className: 'flex center animated fadeIn' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-xs-12' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'alert alert-success' },
          paymentMessage
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_shared_DisplayIf_jsx__["a" /* default */],
      { condition: !isCaptain && !isAllowed && groupName != undefined && groupName !== '', className: 'flex center animated fadeIn' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-xs-12' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'alert alert-danger text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-xs-3 text-left cursor-pointer', style: { fontSize: '10px', fontWeight: 'bold' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { onClick: onPartnerLoginClick, type: 'button' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-user' }),
                ' Manage another Partner Hub'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-xs-6 text-center' },
              groupName,
              ' is not supported by Event Registration.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-xs-3 text-right cursor-pointer', style: { fontSize: '10px', fontWeight: 'bold' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { onClick: onExitPartnerClick, type: 'button' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-sign-out' }),
                ' Exit Partner Hub Mode'
              )
            )
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'flex center animated fadeIn' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-xs-12' },
        loadingTournaments ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'alert alert-info',
            style: { margin: "16px" } },
          'Loading tournament data.'
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          activeTournamentsQty ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TournamentListContainer_jsx__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'alert alert-info',
              style: { margin: "16px" } },
            'No active tournaments found.'
          )
        )
      )
    )
  );
};

RegHome.propTypes = {
  activeTournamentsQty: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  paymentMessage: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  maintenanceMessage: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  loadingTournaments: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  groupName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  isAllowed: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onExitPartnerClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onPartnerLoginClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

RegHome.defaultProps = {
  activeTournamentsQty: 0,
  paymentMessage: '',
  maintenanceMessage: null,
  loadingTournaments: true
};

/* harmony default export */ __webpack_exports__["a"] = RegHome;

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RegHome_jsx__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_topBanner_actions__ = __webpack_require__(138);




var mapStateToProps = function mapStateToProps(state) {
  return {
    activeTournamentCount: state.registration.home.activeTournamentCount,
    activeTournamentsQty: state.registration.home.activeTournaments.length,
    loadingTournaments: state.registration.home.loadingTournaments,
    paymentMessage: state.registration.home.paymentMessage,
    groupName: state.shared.auth.groupName,
    isAllowed: state.shared.auth.isAllowed,
    roles: state.shared.auth.roles,
    permissions: state.shared.auth.permissions
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onPartnerLoginClick: function onPartnerLoginClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_topBanner_actions__["a" /* handlePartnerLoginClick */])());
    },
    onExitPartnerClick: function onExitPartnerClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_topBanner_actions__["b" /* handleExitPartnerClick */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__RegHome_jsx__["a" /* default */]);

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_StandardModal_jsx__ = __webpack_require__(23);



var RequiredProfileFieldsModal = function RequiredProfileFieldsModal(_ref) {
    var visible = _ref.visible,
        message = _ref.message,
        onSubmit = _ref.onSubmit,
        onCancel = _ref.onCancel;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_shared_StandardModal_jsx__["a" /* default */],
        {
            title: 'Missing Required Profile Fields',
            visible: visible,
            onCloseClick: onCancel },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    message
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group text-right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    {
                        type: 'button',
                        className: 'btn btn-link',
                        onClick: function onClick() {
                            return onCancel();
                        }
                    },
                    'Cancel'
                ),
                ' ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    {
                        onClick: function onClick() {
                            return onSubmit();
                        },
                        className: 'btn btn-primary btn-lg'
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
                    ' ',
                    'OK'
                )
            )
        )
    );
};

RequiredProfileFieldsModal.propTypes = {
    visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
    message: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
    onCancel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
    onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

RequiredProfileFieldsModal.defaultProps = {
    visible: false,
    message: ''
};

/* harmony default export */ __webpack_exports__["a"] = RequiredProfileFieldsModal;

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RequiredProfileFieldsModal_jsx__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(202);




var mapStateToProps = function mapStateToProps(state) {
  return {
    visible: state.registration.home.showRequiredProfileFieldsModal,
    message: state.shared.auth.validationMessage
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSubmit: function onSubmit() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["d" /* handleSendToProfile */])());
    },
    onCancel: function onCancel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["e" /* handleRequiredProfileFieldsModalCancel */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__RequiredProfileFieldsModal_jsx__["a" /* default */]);

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_variables__ = __webpack_require__(38);




var TournamentItem = function TournamentItem(_ref) {
  var id = _ref.id,
      name = _ref.name,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      customImagePath = _ref.customImagePath,
      canCaptainPurchase = _ref.canCaptainPurchase,
      canCaptainManage = _ref.canCaptainManage,
      captainPurchaseReason = _ref.captainPurchaseReason,
      theme = _ref.theme,
      onScheduleClick = _ref.onScheduleClick,
      onManageClick = _ref.onManageClick;

  var redGradient = 'linear-gradient(rgba(183, 18, 52, 0.6), rgba(183, 18, 52, 0.7))';
  var blueGradient = 'linear-gradient(rgba(0, 51, 141, 0.6), rgba(0, 51, 141, 0.7))';
  var orangeGradient = 'linear-gradient(rgba(255, 105, 19, 0.4), rgba(255, 106, 19, 0.5))';
  var gradient = blueGradient;

  if (theme == 'red') {
    gradient = redGradient;
  } else if (theme == 'orange') {
    gradient = orangeGradient;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'card' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'card-heading',
        style: {
          background: gradient + ',\n          url(' + (customImagePath || __WEBPACK_IMPORTED_MODULE_2_shared_variables__["j" /* DEFAULT_TOURNAMENT_IMG */]) + ')\n          no-repeat center center',
          backgroundSize: 'cover'
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h3',
        null,
        name
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'small',
        null,
        'Starts: ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(startDate).format('M/D/YYYY') + ', Ends: ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(endDate).format('M/D/YYYY')
      )
    ),
    captainPurchaseReason ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-body alert-danger' },
      captainPurchaseReason
    ) : null,
    canCaptainPurchase || canCaptainManage ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-body' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex space-around' },
        canCaptainPurchase ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            className: 'btn btn-primary btn-lg',
            type: 'button',
            onClick: function onClick() {
              return onScheduleClick(id);
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-calendar' }),
          ' ',
          'Register'
        ) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            className: 'btn btn-secondary',
            type: 'button',
            onClick: function onClick() {
              return onManageClick(id);
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-wrench' }),
          ' ',
          'Manage'
        )
      )
    ) : null
  );
};

TournamentItem.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  startDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  endDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  customImagePath: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  canCaptainPurchase: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired,
  canCaptainManage: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired,
  captainPurchaseReason: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  theme: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onScheduleClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  onManageClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = TournamentItem;

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TournamentItem_jsx__ = __webpack_require__(898);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var TournamentList = function TournamentList(_ref) {
  var entries = _ref.entries,
      onScheduleClick = _ref.onScheduleClick,
      onManageClick = _ref.onManageClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'animated fadeIn flex wrap' },
    entries.map(function (item, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          key: index,
          className: 'col-sm-6 col-md-4' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TournamentItem_jsx__["a" /* default */], _extends({}, item, {
          onScheduleClick: onScheduleClick,
          onManageClick: onManageClick
        }))
      );
    })
  );
};

TournamentList.propTypes = {
  entries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  onScheduleClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onManageClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

TournamentList.defaultProps = {
  entries: []
};

/* harmony default export */ __webpack_exports__["a"] = TournamentList;

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TournamentList_jsx__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(202);




var mapStateToProps = function mapStateToProps(state) {
  return {
    entries: state.registration.home.activeTournaments
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onScheduleClick: function onScheduleClick(tournamentId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* handleScheduleClick */])(tournamentId));
    },
    onManageClick: function onManageClick(tournamentId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* handleManageClick */])(tournamentId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__TournamentList_jsx__["a" /* default */]);

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_StandardModal_jsx__ = __webpack_require__(23);



var TournamentRequirementModal = function TournamentRequirementModal(_ref) {
    var visible = _ref.visible,
        age = _ref.age,
        onCancel = _ref.onCancel;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_shared_StandardModal_jsx__["a" /* default */],
        {
            title: 'Tournament Requirement',
            visible: visible,
            onCloseClick: onCancel },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    'The tournament requires you to be ' + age + ' years old to register. '
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group text-right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    {
                        onClick: function onClick() {
                            return onCancel();
                        },
                        className: 'btn btn-primary btn-lg'
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
                    ' ',
                    'OK'
                )
            )
        )
    );
};

TournamentRequirementModal.propTypes = {
    visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
    age: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
    onCancel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

TournamentRequirementModal.defaultProps = {
    visible: false,
    age: 0
};

/* harmony default export */ __webpack_exports__["a"] = TournamentRequirementModal;

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TournamentRequirementModal_jsx__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(202);




var mapStateToProps = function mapStateToProps(state) {
  return {
    visible: state.registration.home.showBirthDateModal,
    age: state.registration.home.captainAge
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCancel: function onCancel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* handleBirthDateModalCancel */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__TournamentRequirementModal_jsx__["a" /* default */]);

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(433);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  activeTournaments: [],
  activeTournamentCount: undefined,
  paymentMessage: '',
  maintenanceMessage: null,
  searchValue: '',
  loadingTournaments: true,
  showBirthDateModal: false,
  showRequiredProfileFieldsModal: false,
  captainAge: 0
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_PAYMENT_MESSAGE_FOR_REG_HOME */]:
      return _extends({}, state, {
        paymentMessage: payload || initialState.paymentMessage
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* SET_SEARCH_TOURNAMENT_VALUE_FOR_REG_HOME */]:
      return _extends({}, state, {
        searchValue: payload.searchValue || initialState.searchValue
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_TOURNAMENT_LOADING_FOR_REG_HOME */]:
      return _extends({}, state, {
        loadingTournaments: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_ACTIVE_TOURNAMENTS_FOR_REG_HOME */]:
      {
        var activeTournamentCount = state.activeTournamentCount;

        if (payload && payload.activeTournaments && !activeTournamentCount) activeTournamentCount = payload.activeTournaments.length;
        if (!payload) payload = { activeTournaments: [], loadingTournaments: false };
        return _extends({}, state, payload, {
          activeTournamentCount: activeTournamentCount
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DISPLAY_MAINTENANCE_MESSAGE_FOR_REG_HOME */]:
      {
        return _extends({}, state, payload);
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* DISPLAY_BIRTH_DATE_MODAL */]:
      return _extends({}, state, {
        showBirthDateModal: payload || initialState.showBirthDateModal
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* DISPLAY_REQUIRED_PROFILE_FIELDS_MODAL */]:
      return _extends({}, state, {
        showRequiredProfileFieldsModal: payload || initialState.showRequiredProfileFieldsModal
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* SET_CAPTAIN_AGE_FOR_SELECTED_TOURNAMENT */]:
      return _extends({}, state, {
        captainAge: payload || initialState.captainAge
      });
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_variables__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EntryFormContainer_jsx__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EntryPaymentLogContainer_jsx__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EntryRosterReadOnlyContainer_jsx__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_Panel_jsx__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_util_formatCurrency__ = __webpack_require__(27);










Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_9_shared_util_formatCurrency__["a" /* formatCurrency */];

var Entry = function Entry(_ref) {
  var zindexvalue = _ref.zindexvalue,
      disableState = _ref.disableState,
      balanceDue = _ref.balanceDue,
      editing = _ref.editing,
      eventName = _ref.eventName,
      id = _ref.id,
      name = _ref.name,
      entryNumber = _ref.entryNumber,
      isCancelled = _ref.isCancelled,
      readOnly = _ref.readOnly,
      selected = _ref.selected,
      showEntryDetails = _ref.showEntryDetails,
      showPaymentLog = _ref.showPaymentLog,
      squadDateTime = _ref.squadDateTime,
      timeZoneDisplayName = _ref.timeZoneDisplayName,
      onViewRosterClick = _ref.onViewRosterClick,
      onManageRosterClick = _ref.onManageRosterClick,
      onPaymentLogClick = _ref.onPaymentLogClick,
      onSelectChecked = _ref.onSelectChecked,
      onSquadChangeClick = _ref.onSquadChangeClick,
      onEventChangeClick = _ref.onEventChangeClick,
      onPrintEntryClick = _ref.onPrintEntryClick,
      onPrintPaymentLogClick = _ref.onPrintPaymentLogClick,
      rosterComplete = _ref.rosterComplete,
      showCalculatedDivisionToCaptain = _ref.showCalculatedDivisionToCaptain,
      allowChangeBetweenFreeEvents = _ref.allowChangeBetweenFreeEvents,
      divisionName = _ref.divisionName;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('list-group-item-labeled', { 'highlight animated flipInX': editing || showPaymentLog || showEntryDetails }, { 'bg-warning': !isCancelled && balanceDue }),
        style: { position: 'relative', zIndex: zindexvalue } },
      isCancelled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-group-item-labeled-child custom-checkbox-container',
        style: { width: 25 } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child custom-checkbox-container',
          style: { width: 25 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
          type: 'checkbox',
          id: 'entry-' + id,
          disabled: !balanceDue,
          checked: selected,
          onChange: function onChange() {
            return onSelectChecked(id);
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { htmlFor: 'entry-' + id })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 125 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Event Name'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          '' + eventName
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 120 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Reservation Number'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          entryNumber
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 175 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Team Name'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          name
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 220 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Date'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          squadDateTime ? __WEBPACK_IMPORTED_MODULE_2_moment___default.a.parseZone(squadDateTime).format('hh:mm A, MMM Do, YYYY') + '\n            (' + timeZoneDisplayName + ')' : isCancelled ? 'CANCELLED' : '-'
        )
      ),
      isCancelled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-group-item-labeled-child',
        style: { width: 110 } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('list-group-item-labeled-child', { 'bg-danger': balanceDue }),
          style: { width: 110 } },
        balanceDue ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-link bg-danger bold-font',
            type: 'button',
            disabled: true,
            style: { color: '#000' } },
          '$' + balanceDue.formatCurrency(2) + ' DUE'
        ) : null
      ),
      isCancelled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-group-item-labeled-child',
        style: { width: 170 } }) : !rosterComplete ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('list-group-item-labeled-child', { 'bg-info': !rosterComplete }),
          style: { width: 170 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-link bg-info bold-font',
            type: 'button',
            disabled: true,
            style: { color: '#000' } },
          'Roster Incomplete'
        )
      ) : showCalculatedDivisionToCaptain ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 170 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Division'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          divisionName
        )
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-group-item-labeled-child',
        style: { width: 170 } }),
      isCancelled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-group-item-labeled-child',
        style: { width: 90 } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 90 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["DropdownButton"],
          { id: 'actions-dropdown-' + id,
            className: 'btn btn-link',
            title: "Actions" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["MenuItem"],
            { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('entry-dropdown-link', { 'bg-info bold-font': !rosterComplete }),
              onSelect: function onSelect() {
                return readOnly ? onViewRosterClick(id) : onManageRosterClick(id);
              },
              eventKey: 'manageRoster' },
            readOnly ? 'View Roster' : 'Manage Roster'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["MenuItem"],
            { className: 'entry-dropdown-link',
              onSelect: function onSelect() {
                return onPrintEntryClick(id);
              },
              eventKey: 'printRoster' },
            'Print Roster'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["MenuItem"],
            { className: 'entry-dropdown-link',
              onSelect: function onSelect() {
                return onPrintPaymentLogClick(id);
              },
              eventKey: 'printPaymentLog' },
            'Print Payment Log'
          ),
          __WEBPACK_IMPORTED_MODULE_4_shared_variables__["i" /* ALLOW_CAPTAIN_CHANGE_SQUAD */] && !readOnly ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["MenuItem"],
            { className: 'entry-dropdown-link',
              onSelect: function onSelect() {
                return onSquadChangeClick(id, squadDateTime);
              },
              eventKey: 'changeSquad' },
            'Change Squad'
          ) : null,
          __WEBPACK_IMPORTED_MODULE_4_shared_variables__["i" /* ALLOW_CAPTAIN_CHANGE_SQUAD */] && !readOnly && allowChangeBetweenFreeEvents ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["MenuItem"],
            { className: 'entry-dropdown-link',
              onSelect: function onSelect() {
                return onEventChangeClick(id, squadDateTime);
              },
              eventKey: 'changeEvent' },
            'Change Event'
          ) : null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["MenuItem"],
            { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('entry-dropdown-link', { 'bg-danger bold-font': balanceDue }),
              onSelect: function onSelect() {
                return onPaymentLogClick(id);
              },
              eventKey: 'paymentLog' },
            balanceDue ? 'Balance Detail' : 'Payment Log'
          )
        )
      )
    ),
    editing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_shared_Panel_jsx__["a" /* default */],
      { className: 'panel-primary animated fadeIn',
        style: { position: 'relative', zIndex: 0 },
        title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'flex space-between' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'panel-title' },
            'Entry and Roster Information'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'flex right wrap' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              {
                className: 'btn btn-link',
                href: 'http://webapps.bowl.com/USBCFindA',
                target: '_blank' },
              'Find a member'
            )
          )
        ) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__EntryFormContainer_jsx__["a" /* default */], { disableState: disableState })
    ) : null,
    showPaymentLog ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__EntryPaymentLogContainer_jsx__["a" /* default */], null) : null,
    showEntryDetails ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_shared_Panel_jsx__["a" /* default */],
      { className: 'panel-primary animated fadeIn',
        style: { position: 'relative', zIndex: 0 },
        title: 'Entry and Roster Information' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__EntryRosterReadOnlyContainer_jsx__["a" /* default */], null)
    ) : null
  );
};

Entry.propTypes = {
  zindexvalue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  disableState: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  balanceDue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  editing: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  eventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  id: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  entryNumber: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  isCancelled: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  readOnly: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  selected: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  showEntryDetails: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  showPaymentLog: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  squadDateTime: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  timeZoneDisplayName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onViewRosterClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onManageRosterClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onPaymentLogClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSelectChecked: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSquadChangeClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onEventChangeClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onPrintEntryClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onPrintPaymentLogClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  rosterComplete: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  showCalculatedDivisionToCaptain: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  divisionName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  allowChangeBetweenFreeEvents: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool
};

Entry.defaultProps = {
  disableState: false,
  balanceDue: 0,
  rosterComplete: false,
  allowChangeBetweenFreeEvents: false
};

/* harmony default export */ __webpack_exports__["a"] = Entry;

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Entry_jsx__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_actions__ = __webpack_require__(60);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var mapStateToProps = function mapStateToProps(state, props) {
  return _extends({
    showCalculatedDivisionToCaptain: state.registration.base.showCalculatedDivisionToCaptain,
    allowChangeBetweenFreeEvents: state.registration.base.allowChangeBetweenFreeEvents
  }, props);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onViewRosterClick: function onViewRosterClick(entryId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_actions__["l" /* handleViewRosterClick */])(entryId));
    },
    onManageRosterClick: function onManageRosterClick(entryId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_actions__["m" /* handleManageRosterClick */])(entryId));
    },
    onPaymentLogClick: function onPaymentLogClick(entryId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["handlePaymentLogSelection"])(entryId));
    },
    onPrintEntryClick: function onPrintEntryClick(entryId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["handlePrintEntryClick"])(entryId));
    },
    onPrintPaymentLogClick: function onPrintPaymentLogClick(entryId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["handlePrintPaymentLogClick"])(entryId));
    },
    onSelectChecked: function onSelectChecked(entryId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["handleEntrySelectChecked"])(entryId));
    },
    onSquadChangeClick: function onSquadChangeClick(entryId, squadDateTime) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["handleSquadChangeClick"])(entryId, squadDateTime));
    },
    onEventChangeClick: function onEventChangeClick(entryId, squadDateTime) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["handleEventChangeClick"])(entryId, squadDateTime));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__Entry_jsx__["a" /* default */]);

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EntryRosterForm_jsx__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RosterListContainer_jsx__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_actionTypes__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(53);








var EntryRosterFormWrapper = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["reduxForm"])({
  form: 'entryForm',
  roster: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RosterListContainer_jsx__["a" /* default */], null),
  rosterCheckout: window.location.href.indexOf("rostercheckout") >= 0
})(__WEBPACK_IMPORTED_MODULE_3__EntryRosterForm_jsx__["a" /* default */]);

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["formValueSelector"])('entryForm');

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    disableState: props.disableState,
    validate: __WEBPACK_IMPORTED_MODULE_6__actions__["validate"],
    countries: state.registration.shared.countries,
    states: state.registration.shared.states,
    rosterPositionsQty: selector(state, 'rosterPositionsQty'),
    parentVirtualEntryEvents: state.registration.shared.parentVirtualEntryEvents,
    parentTeamOwnedVirtualEntries: state.registration.shared.parentTeamOwnedVirtualEntries,
    eventId: state.registration.shared.entries.find(function (x) {
      return x.editing;
    }).eventId,
    entryId: selector(state, 'id')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["handleSave"])(data));
    },
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_actionTypes__["r" /* setRosterConfirmationVisibility */])(true));
    },
    onCountryChange: function onCountryChange(value) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["handleCountryChange"])(value));
    },
    onAssignTeamOwnedVirtualEventClick: function onAssignTeamOwnedVirtualEventClick(virtualEventName, teamEntryId, value) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["handleAssignTeamOwnedVirtualEventClick"])(virtualEventName, teamEntryId, value));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(EntryRosterFormWrapper);

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EntryContainer_jsx__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var EntryList = function EntryList(_ref) {
  var entries = _ref.entries,
      onSelectChecked = _ref.onSelectChecked,
      teamOwnedVirtualEntriesAvailable = _ref.teamOwnedVirtualEntriesAvailable;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    teamOwnedVirtualEntriesAvailable.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'table',
      { className: 'info-summary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'thead',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'tr',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'th',
            null,
            'Virtual Event Name'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'th',
            null,
            'Available Entries'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'th',
            null,
            'Total Entries'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'th',
            null,
            'Balance Due'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'tbody',
        null,
        teamOwnedVirtualEntriesAvailable.map(function (entry, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'tr',
            { key: index,
              className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({ 'bg-warning': entry.balanceDue }) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'td',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'list-group-item-labeled-child custom-checkbox-container',
                  style: { width: 25 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                  type: 'checkbox',
                  id: 'entry-' + entry.virtualEventId,
                  disabled: !entry.balanceDue,
                  checked: entry.selected,
                  onChange: function onChange() {
                    return onSelectChecked(entry.virtualEventId);
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { htmlFor: 'entry-' + entry.virtualEventId })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'td',
              null,
              entry.virtualEventName
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'td',
              null,
              entry.availableEntries
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'td',
              null,
              entry.totalEntries
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'td',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('list-group-item-labeled-child', { 'bg-danger': entry.balanceDue }),
                  style: { width: 110, borderRadius: 25 } },
                entry.balanceDue ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-link bg-danger bold-font',
                    type: 'button',
                    disabled: true,
                    style: { color: '#000' } },
                  '$' + entry.balanceDue.formatCurrency(2) + ' DUE'
                ) : null
              )
            )
          );
        })
      )
    ) : null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group' },
      entries.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__EntryContainer_jsx__["a" /* default */], _extends({
          key: index,
          zindexvalue: entries.length + 1003 - index // Stack zIndex inversely to prevent hiding dropdowns
        }, item));
      })
    )
  );
};

EntryList.propTypes = {
  entries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  onSelectChecked: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  teamOwnedVirtualEntriesAvailable: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

/* harmony default export */ __webpack_exports__["a"] = EntryList;

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EntryList_jsx__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(53);




var mapStateToProps = function mapStateToProps(state) {
    return state.registration.shared;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        onSelectChecked: function onSelectChecked(entryId) {
            return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["handleEntrySelectChecked"])(entryId));
        }
    };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__EntryList_jsx__["a" /* default */]);

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_EntryPaymentLog_jsx__ = __webpack_require__(448);



var mapStateToProps = function mapStateToProps(state) {
  return state.registration.manage.paymentLog;
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1_shared_EntryPaymentLog_jsx__["a" /* default */]);

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var EntryRosterForm = function EntryRosterForm(_ref) {
  var virtualEntriesToModify = _ref.virtualEntriesToModify;

  if (!virtualEntriesToModify || virtualEntriesToModify.length == 0) return null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
    virtualEntriesToModify.map(function (virtualEntry, rosterIndex) {

      var bowlerName = virtualEntry.displayName + " (" + virtualEntry.usbcId + ")";
      var virtualEventName = virtualEntry.virtualEventName;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "alert alert-warning",
          key: rosterIndex },
        "Bowler ",
        bowlerName,
        " is no longer on any of your rosters, if you continue with this removal they will be removed from your ",
        virtualEventName,
        " as well."
      );
    })
  );
};

EntryRosterForm.propTypes = {
  virtualEntriesToModify: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

EntryRosterForm.defaultProps = {
  virtualEntriesToModify: []
};

/* harmony default export */ __webpack_exports__["a"] = EntryRosterForm;

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EntryRosterFormVirtualEntriesToModify_jsx__ = __webpack_require__(910);



var mapStateToProps = function mapStateToProps(state) {
  return {
    virtualEntriesToModify: state.registration.manage.virtualEntriesToModify
  };
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__EntryRosterFormVirtualEntriesToModify_jsx__["a" /* default */]);

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_EntryWithRosterReadOnly_jsx__ = __webpack_require__(449);



var mapStateToProps = function mapStateToProps(state) {
  return state.registration.shared.entryDetails;
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1_shared_EntryWithRosterReadOnly_jsx__["a" /* default */]);

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_StandardModal_jsx__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardSelectField_jsx__ = __webpack_require__(37);





var required = function required(value) {
  return value ? undefined : 'Required';
};

var CaptainManageEventChangeModal = function CaptainManageEventChangeModal(_ref) {
  var availableEvents = _ref.availableEvents,
      currentEventName = _ref.currentEventName,
      visible = _ref.visible,
      handleSubmit = _ref.handleSubmit,
      onCancel = _ref.onCancel,
      onSubmit = _ref.onSubmit;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_shared_StandardModal_jsx__["a" /* default */],
    {
      title: 'Change Event - ' + currentEventName,
      visible: visible,
      onCloseClick: onCancel },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        {
          onSubmit: handleSubmit(onSubmit) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
          name: 'parentSquadId',
          component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardSelectField_jsx__["a" /* default */],
          options: availableEvents,
          label: 'Available Events',
          placeholder: availableEvents.length ? 'Select an option' : 'No available times',
          simpleValue: true,
          searchable: true,
          validate: [required]
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-link',
              onClick: function onClick() {
                return onCancel();
              }
            },
            'Cancel'
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'submit',
              className: 'btn btn-primary btn-lg'
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
            ' ',
            'Save'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'hidden',
          name: 'entryId' })
      )
    )
  );
};

CaptainManageEventChangeModal.propTypes = {
  availableEvents: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  currentEventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  entryId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  onCancel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

CaptainManageEventChangeModal.defaultProps = {
  availableEvents: [],
  currentEventName: '',
  entryId: '',
  visible: false
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'captainManageEventChangeForm'
})(CaptainManageEventChangeModal);

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventChangeModal_jsx__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(53);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["formValueSelector"])('captainManageEventChangeForm');

var mapStateToProps = function mapStateToProps(state) {
  return _extends({
    visible: state.registration.manage.showEventChangeModal
  }, selector(state, 'availableEvents', 'currentEventName', 'entryId'));
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["handleEventChangeSave"])(data));
    },
    onCancel: function onCancel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["handleEventChangeCancel"])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__EventChangeModal_jsx__["a" /* default */]);

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EntryListContainer_jsx__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VirtualEntryListContainer_jsx__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PayBalanceContainer_jsx__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RosterConfirmationDialogContainer_jsx__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SquadChangeModalContainer_jsx__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EventChangeModalContainer_jsx__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_DisplayIf_jsx__ = __webpack_require__(12);









var Manage = function Manage(_ref) {
  var entriesQty = _ref.entriesQty,
      allRostersComplete = _ref.allRostersComplete,
      virtualEntriesQty = _ref.virtualEntriesQty,
      rosterMessage = _ref.rosterMessage,
      loadingEntries = _ref.loadingEntries,
      loadingVirtualEntries = _ref.loadingVirtualEntries;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_shared_DisplayIf_jsx__["a" /* default */],
      { condition: allRostersComplete },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-12 animated fadeIn' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'alert alert-success text-center' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'You\'re all done!'
            )
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_shared_DisplayIf_jsx__["a" /* default */],
      { condition: !!rosterMessage },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-12 animated fadeIn' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'alert alert-info text-center' },
            rosterMessage ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              rosterMessage
            ) : null
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'animated fadeIn' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PayBalanceContainer_jsx__["a" /* default */], null),
      loadingEntries ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'alert alert-info' },
        'Loading entries'
      ) : entriesQty ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__EntryListContainer_jsx__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'alert alert-info' },
        'No entries to display'
      ),
      loadingVirtualEntries ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'alert alert-info' },
        'Loading virtual entries'
      ) : virtualEntriesQty ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__VirtualEntryListContainer_jsx__["a" /* default */], null) : null
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RosterConfirmationDialogContainer_jsx__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SquadChangeModalContainer_jsx__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__EventChangeModalContainer_jsx__["a" /* default */], null)
  );
};

Manage.propTypes = {
  entriesQty: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  allRostersComplete: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  virtualEntriesQty: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  rosterMessage: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  loadingEntries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  loadingVirtualEntries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool
};

Manage.defaultProps = {
  entriesQty: 0,
  allRostersComplete: false,
  virtualEntriesQty: 0,
  rosterMessage: '',
  loadingEntries: true,
  loadingVirtualEntries: true
};

/* harmony default export */ __webpack_exports__["a"] = Manage;

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Manage_jsx__ = __webpack_require__(915);



var mapStateToProps = function mapStateToProps(state) {
  return {
    entriesQty: state.registration.shared.entries.length,
    allRostersComplete: state.registration.shared.entries.every(function (e) {
      return e.rosterComplete;
    }),
    virtualEntriesQty: state.registration.shared.virtualEntries.length,
    rosterMessage: state.registration.base.rosterMessage,
    loadingEntries: state.registration.shared.loadingEntries,
    loadingVirtualEntries: state.registration.shared.loadingVirtualEntries
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__Manage_jsx__["a" /* default */]);

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_DisplayIf_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_util_formatCurrency__ = __webpack_require__(27);



Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_2_shared_util_formatCurrency__["a" /* formatCurrency */];

var PayBalance = function PayBalance(_ref) {
  var balanceDue = _ref.balanceDue,
      onPayBalanceClick = _ref.onPayBalanceClick,
      onPurchaseClick = _ref.onPurchaseClick,
      enabledWebHooks = _ref.enabledWebHooks,
      onWebHooksClick = _ref.onWebHooksClick,
      environment = _ref.environment;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'flex right' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_shared_DisplayIf_jsx__["a" /* default */],
        { condition: !!balanceDue,
          className: 'display inline' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-primary btn-lg',
            type: 'button',
            onClick: onPayBalanceClick },
          'Pay $' + balanceDue.formatCurrency(2)
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'display inline' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            style: { minWidth: 150, marginLeft: 10 },
            className: 'btn btn-default btn-lg',
            type: 'button',
            onClick: function onClick() {
              return onPurchaseClick();
            } },
          'Register More'
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'flex right' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_shared_DisplayIf_jsx__["a" /* default */],
        { condition: !!balanceDue && environment != 'PROD' && environment != 'PRODUCTION',
          className: 'custom-checkbox-container',
          style: { float: "left", paddingBottom: 15 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'checkbox',
          id: 'webHooks',
          checked: enabledWebHooks,
          onChange: function onChange(event) {
            return onWebHooksClick(event.target.checked);
          } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          { htmlFor: 'webHooks' },
          'Click here to process payments in real time.'
        )
      )
    )
  );
};

PayBalance.propTypes = {
  balanceDue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  onPayBalanceClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onPurchaseClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onPrintClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  enabledWebHooks: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onWebHooksClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  environment: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

PayBalance.defaultProps = {
  balanceDue: 0
};

/* harmony default export */ __webpack_exports__["a"] = PayBalance;

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PayBalance_jsx__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_webHooks_actions__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_variables__ = __webpack_require__(38);






var mapStateToProps = function mapStateToProps(state) {
  return {
    balanceDue: state.registration.shared.balanceDue,
    entriesCount: state.registration.shared.entries.length,
    environment: __WEBPACK_IMPORTED_MODULE_4_shared_variables__["h" /* ENVIRONMENT */]
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onPayBalanceClick: function onPayBalanceClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["handlePayBalanceClick"])());
    },
    onPurchaseClick: function onPurchaseClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["handlePurchaseClick"])());
    },
    onWebHooksClick: function onWebHooksClick(checked) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_webHooks_actions__["a" /* handleWebHooksClick */])(checked));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__PayBalance_jsx__["a" /* default */]);

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardModal_jsx__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_StandardSelectField_jsx__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_DisplayIf_jsx__ = __webpack_require__(12);








var CaptainManageSquadChangeModal = function CaptainManageSquadChangeModal(_ref) {
  var childSquadDateTime = _ref.childSquadDateTime,
      childEventName = _ref.childEventName,
      childAvailableSquads = _ref.childAvailableSquads,
      childrenEntries = _ref.childrenEntries,
      entryId = _ref.entryId,
      isBundledChild = _ref.isBundledChild,
      parentAvailableSquads = _ref.parentAvailableSquads,
      parentEventName = _ref.parentEventName,
      visible = _ref.visible,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      handleSubmit = _ref.handleSubmit,
      onCancel = _ref.onCancel,
      onSubmit = _ref.onSubmit,
      onDateChange = _ref.onDateChange,
      onTimeChange = _ref.onTimeChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_shared_StandardModal_jsx__["a" /* default */],
    {
      title: 'Change Squad - ' + parentEventName,
      visible: visible,
      onCloseClick: onCancel },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_shared_DisplayIf_jsx__["a" /* default */],
        { condition: isBundledChild },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'alert alert-info' },
          'To move a Doubles and Singles date, you must first move the Team entry date.'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        {
          onSubmit: handleSubmit(onSubmit) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
          disabled: isBundledChild,
          name: 'parentSquadDateTime',
          type: 'date',
          minDate: startDate,
          maxDate: endDate,
          component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardField_jsx__["a" /* default */],
          label: 'Date',
          onCustomChange: function onCustomChange(value) {
            return onDateChange(entryId, value);
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
          name: 'parentSquadId',
          component: __WEBPACK_IMPORTED_MODULE_5_shared_StandardSelectField_jsx__["a" /* default */],
          options: parentAvailableSquads,
          label: 'Available Times',
          placeholder: parentAvailableSquads.length ? 'Select an Option' : 'No available times',
          simpleValue: true,
          searchable: true,
          onCustomChange: function onCustomChange(value) {
            return onTimeChange(entryId, value);
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_shared_DisplayIf_jsx__["a" /* default */],
          { condition: !!childrenEntries.length },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            null,
            'Change Squad - ' + childEventName + ' to ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(childSquadDateTime).format('MM/DD/YYYY')
          ),
          childrenEntries.map(function (entry, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              key: i,
              name: 'childrenEntries[' + i + '][\'squadId\']',
              component: __WEBPACK_IMPORTED_MODULE_5_shared_StandardSelectField_jsx__["a" /* default */],
              options: childAvailableSquads,
              label: '#' + (i + 1) + ' Available Times For Squad (' + entry.teamName + ')',
              placeholder: childAvailableSquads.length ? 'Select an Option' : 'No available times',
              simpleValue: true,
              searchable: true
            });
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-link',
              onClick: function onClick() {
                return onCancel();
              }
            },
            'Cancel'
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'submit',
              className: 'btn btn-primary btn-lg'
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
            ' ',
            'Save'
          )
        )
      )
    )
  );
};

CaptainManageSquadChangeModal.propTypes = {
  childSquadDateTime: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  childEventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  childAvailableSquads: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  childrenEntries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  entryId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  isBundledChild: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  parentAvailableSquads: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  parentEventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  startDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  endDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  onCancel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onDateChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onTimeChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

CaptainManageSquadChangeModal.defaultProps = {
  childSquadDateTime: '',
  childEventName: '',
  childAvailableSquads: [],
  childrenEntries: [],
  entryId: '',
  isBundledChild: false,
  parentAvailableSquads: [],
  parentEventName: '',
  visible: false
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["reduxForm"])({
  form: 'captainManageSquadChangeForm'
})(CaptainManageSquadChangeModal);

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SquadChangeModal_jsx__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(53);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["formValueSelector"])('captainManageSquadChangeForm');

var mapStateToProps = function mapStateToProps(state) {
  return _extends({
    validate: __WEBPACK_IMPORTED_MODULE_3__actions__["validateCaptainManageSquadChangeForm"],
    visible: state.registration.manage.showSquadChangeModal
  }, selector(state, 'childAvailableSquads', 'childSquadDateTime', 'childEventName', 'childSquadDateTime', 'childrenEntries', 'entryId', 'isBundledChild', 'parentAvailableSquads', 'parentEventName', 'parentSquadDateTime', 'startDate', 'endDate'));
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["handleSquadChangeSave"])(data));
    },
    onCancel: function onCancel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["handleSquadChangeCancel"])());
    },
    onDateChange: function onDateChange(entryId, date) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["handleSquadDateChanged"])(entryId, date));
    },
    onTimeChange: function onTimeChange(entryId, parentSquadId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["handleSquadTimeChanged"])(entryId, parentSquadId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__SquadChangeModal_jsx__["a" /* default */]);

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VirtualEntryBowlerListContainer_jsx__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VirtualEntryPaymentLogContainer_jsx__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_util_formatCurrency__ = __webpack_require__(27);





Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_4_shared_util_formatCurrency__["a" /* formatCurrency */];

var VirtualEntry = function VirtualEntry(_ref) {
  var zindexvalue = _ref.zindexvalue,
      balanceDue = _ref.balanceDue,
      editing = _ref.editing,
      selected = _ref.selected,
      showPaymentLog = _ref.showPaymentLog,
      virtualEventId = _ref.virtualEventId,
      virtualEventName = _ref.virtualEventName,
      onManageRosterClick = _ref.onManageRosterClick,
      onPaymentLogClick = _ref.onPaymentLogClick,
      onSelectChecked = _ref.onSelectChecked,
      rosterComplete = _ref.rosterComplete;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("list-group-item-labeled", { "highlight animated flipInX": editing || showPaymentLog }, { 'bg-warning': balanceDue }),
        style: { position: 'relative', zIndex: zindexvalue } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child custom-checkbox-container',
          style: { width: 25 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
          type: 'checkbox',
          id: 'entry-' + virtualEventId,
          disabled: !balanceDue,
          checked: selected,
          onChange: function onChange() {
            return onSelectChecked(virtualEventId);
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', {
          htmlFor: 'entry-' + virtualEventId })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 740 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Virtual Event'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          virtualEventName
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('list-group-item-labeled-child', { 'bg-danger': balanceDue }),
          style: { width: 110 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('btn btn-link', { 'highlight-danger': balanceDue }),
            type: 'button',
            onClick: function onClick() {
              return onPaymentLogClick(virtualEventId);
            } },
          balanceDue ? '$' + balanceDue.formatCurrency(2) + ' DUE' : 'Payment Log'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: { width: 150 },
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('list-group-item-labeled-child', { 'bg-info': !rosterComplete }) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            className: 'btn btn-link',
            type: 'button',
            onClick: function onClick() {
              return onManageRosterClick(virtualEventId);
            }
          },
          'Manage Bowlers'
        )
      )
    ),
    editing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__VirtualEntryBowlerListContainer_jsx__["a" /* default */], { zindexvalue: zindexvalue }) : null,
    showPaymentLog ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__VirtualEntryPaymentLogContainer_jsx__["a" /* default */], null) : null
  );
};

VirtualEntry.propTypes = {
  zindexvalue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  balanceDue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  editing: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  selected: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  showPaymentLog: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  virtualEventId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  virtualEventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  onManageRosterClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onPaymentLogClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSelectChecked: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  rosterComplete: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool
};

VirtualEntry.defaultProps = {
  balanceDue: 0,
  rosterComplete: false
};

/* harmony default export */ __webpack_exports__["a"] = VirtualEntry;

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__ = __webpack_require__(12);





var VirtualEntryBowler = function VirtualEntryBowler(_ref) {
  var id = _ref.id,
      bowlerId = _ref.bowlerId,
      position = _ref.position,
      bowlers = _ref.bowlers,
      onBowlerChange = _ref.onBowlerChange,
      showCalculatedDivisionToCaptain = _ref.showCalculatedDivisionToCaptain;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'contact-card' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'contact-card-info-wrapper' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('contact-card-avatar', { 'empty': !bowlerId })
        },
        position
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'contact-card-info' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: {
              display: 'flex'
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                flex: 1,
                maxWidth: '360px',
                marginRight: '5px'
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              { htmlFor: 'bowler-' + position },
              'Bowler'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select___default.a, {
              name: 'bowler-' + position,
              options: bowlers.map(function (x) {
                return {
                  value: x.id,
                  label: x.name
                };
              }),
              placeholder: 'Select...',
              value: bowlerId,
              simpleValue: true,
              searchable: true,
              onChange: function onChange(value) {
                return onBowlerChange(id, value);
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
            { condition: showCalculatedDivisionToCaptain },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  flex: 1,
                  marginLeft: '20px'
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                { htmlFor: 'bowler-' + position },
                'Division'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                !bowlers.find(function (b) {
                  return b.id == bowlerId;
                }) ? '-' : !bowlers.find(function (b) {
                  return b.id == bowlerId;
                }).divisionName ? 'Not Assigned' : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  bowlers.find(function (b) {
                    return b.id == bowlerId;
                  }).divisionName
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
          { condition: bowlers.find(function (b) {
              return b.id == bowlerId;
            }) ? bowlers.find(function (b) {
              return b.id == bowlerId;
            }).assignedByOtherCaptain : false },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'btn btn-danger',
              disabled: true,
              style: { opacity: 1, marginTop: 5, maxWidth: 560 } },
            'Bowler already entered into All Events by another captain'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
          { condition: bowlers.find(function (b) {
              return b.id == bowlerId;
            }) ? !!bowlers.find(function (b) {
              return b.id == bowlerId;
            }).error : false },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'roster-notification' },
            'This bowler is no longer on your roster, please replace with a valid bowler'
          )
        )
      )
    )
  );
};

VirtualEntryBowler.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  bowlerId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  position: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number.isRequired,
  bowlers: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  onBowlerChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  showCalculatedDivisionToCaptain: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool
};

VirtualEntryBowler.defaultProps = {
  bowlers: []
};

/* harmony default export */ __webpack_exports__["a"] = VirtualEntryBowler;

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_Submitting_jsx__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VirtualEntryBowler_jsx__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var VirtualEntryBowlerList = function VirtualEntryBowlerList(_ref) {
  var zindexvalue = _ref.zindexvalue,
      virtualEventId = _ref.virtualEventId,
      source = _ref.source,
      bowlers = _ref.bowlers,
      submitting = _ref.submitting,
      onVirtualEntryBowlerChange = _ref.onVirtualEntryBowlerChange,
      onCancelClick = _ref.onCancelClick,
      onUpdateClick = _ref.onUpdateClick,
      showCalculatedDivisionToCaptain = _ref.showCalculatedDivisionToCaptain;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'panel panel-default animated fadeIn',
      style: { position: 'relative', zIndex: zindexvalue } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-body' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'contact-card-wrapper' },
        source.map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__VirtualEntryBowler_jsx__["a" /* default */], _extends({
            key: index
          }, item, {
            bowlers: bowlers.filter(function (b) {
              // bowlers: available bowlers server side at page load
              // source (virtualBowlers): dropdown list add/removes made by user
              return item.bowlerId == b.id || !source.some(function (s) {
                return s.bowlerId == b.id;
              });
            }),
            position: index + 1,
            onBowlerChange: onVirtualEntryBowlerChange,
            showCalculatedDivisionToCaptain: showCalculatedDivisionToCaptain
          }));
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'form-group text-right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-link',
            disabled: submitting,
            onClick: onCancelClick
          },
          'Cancel'
        ),
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-primary btn-lg',
            disabled: submitting,
            onClick: function onClick() {
              return onUpdateClick(virtualEventId);
            }
          },
          submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_shared_Submitting_jsx__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
          ' ',
          'Update'
        )
      )
    )
  );
};

VirtualEntryBowlerList.propTypes = {
  zindexvalue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  virtualEventId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  source: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  bowlers: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  submitting: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onVirtualEntryBowlerChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onUpdateClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  showCalculatedDivisionToCaptain: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool
};

VirtualEntryBowlerList.defaultProps = {
  source: [],
  bowlers: []
};

/* harmony default export */ __webpack_exports__["a"] = VirtualEntryBowlerList;

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualEntryBowlerList_jsx__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_actions__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_actionTypes__ = __webpack_require__(39);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var mapStateToProps = function mapStateToProps(state, props) {
  return _extends({
    virtualEventId: state.registration.shared.virtualEntries[0].virtualEventId,
    source: state.registration.shared.virtualBowlers,
    bowlers: state.registration.shared.bowlers,
    submitting: state.registration.shared.submittingVirtualBowlers,
    showCalculatedDivisionToCaptain: state.registration.base.showCalculatedDivisionToCaptain
  }, props);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onVirtualEntryBowlerChange: function onVirtualEntryBowlerChange(virtualEntryId, bowlerId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_actions__["p" /* handleVirtualEntryBowlerChange */])(virtualEntryId, bowlerId));
    },
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_actionTypes__["g" /* closeVirtualEntryEditing */])());
    },
    onUpdateClick: function onUpdateClick(virtualEventId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_actions__["k" /* handleUpdateVirtualEntry */])(virtualEventId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__VirtualEntryBowlerList_jsx__["a" /* default */]);

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualEntry_jsx__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_actions__ = __webpack_require__(60);





var mapStateToProps = function mapStateToProps(state, props) {
  return props;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onManageRosterClick: function onManageRosterClick(entryId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_actions__["i" /* handleVirtualEntryManageRosterClick */])(entryId));
    },
    onPaymentLogClick: function onPaymentLogClick(virtualEventId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["handleVirtualEntryPaymentLogClick"])(virtualEventId));
    },
    onSelectChecked: function onSelectChecked(virtualEventId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_actions__["j" /* handleVirtualEventSelectChecked */])(virtualEventId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__VirtualEntry_jsx__["a" /* default */]);

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualEntryContainer_jsx__ = __webpack_require__(925);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var VirtualEntryList = function VirtualEntryList(_ref) {
  var source = _ref.source;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group' },
    source.map(function (item, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__VirtualEntryContainer_jsx__["a" /* default */], _extends({
        key: index,
        zindexvalue: source.length + 3 - index // Stack zIndex inversely to prevent hiding dropdowns
      }, item));
    })
  );
};

VirtualEntryList.propTypes = {
  source: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

VirtualEntryList.defaultProps = {
  source: []
};

/* harmony default export */ __webpack_exports__["a"] = VirtualEntryList;

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualEntryList_jsx__ = __webpack_require__(926);



var mapStateToProps = function mapStateToProps(state) {
  return {
    source: state.registration.shared.virtualEntries
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__VirtualEntryList_jsx__["a" /* default */]);

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualEntryPaymentLogReservation_jsx__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_Panel_jsx__ = __webpack_require__(44);




var VirtualEntryPaymentLog = function VirtualEntryPaymentLog(_ref) {
  var reservationsDue = _ref.reservationsDue,
      reservationsPaid = _ref.reservationsPaid;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_shared_Panel_jsx__["a" /* default */],
      { title: 'Payment Log' },
      reservationsDue.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          null,
          'Reservations Due'
        ),
        reservationsDue.map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { key: index },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__VirtualEntryPaymentLogReservation_jsx__["a" /* default */], item),
            index < reservationsDue.length - 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null) : null
          );
        })
      ) : null,
      reservationsDue.length && reservationsPaid.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null) : null,
      reservationsPaid.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          null,
          'Reservations Paid'
        ),
        reservationsPaid.map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { key: index },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__VirtualEntryPaymentLogReservation_jsx__["a" /* default */], item),
            index < reservationsPaid.length - 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null) : null
          );
        })
      ) : null
    )
  );
};

VirtualEntryPaymentLog.propTypes = {
  reservationsDue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  reservationsPaid: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

VirtualEntryPaymentLog.defaultProps = {
  reservationsDue: [],
  reservationsPaid: []
};

/* harmony default export */ __webpack_exports__["a"] = VirtualEntryPaymentLog;

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualEntryPaymentLog_jsx__ = __webpack_require__(928);



var mapStateToProps = function mapStateToProps(state) {
  return state.registration.manage.paymentLog;
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__VirtualEntryPaymentLog_jsx__["a" /* default */]);

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_util_formatCurrency__ = __webpack_require__(27);


Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_1_shared_util_formatCurrency__["a" /* formatCurrency */];

var VirtualEntryPaymentLogReservation = function VirtualEntryPaymentLogReservation(_ref) {
  var reservationDescription = _ref.reservationDescription,
      paymentDescription = _ref.paymentDescription,
      transactionAmount = _ref.transactionAmount,
      paymentAmount = _ref.paymentAmount;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'flex' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex-3' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'small',
          null,
          'Description'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          reservationDescription
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex-1' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            'Amount'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'flex text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'flex-2' },
            'Base Fee'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'flex-1' },
            '$' + transactionAmount.formatCurrency(2)
          )
        )
      )
    ),
    paymentDescription && paymentAmount ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'flex' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex-3' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          paymentDescription
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex-1' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'flex text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            { className: 'flex-2' },
            'Payment'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            { className: 'flex-1' },
            '$' + paymentAmount.formatCurrency(2)
          )
        )
      )
    ) : null
  );
};

VirtualEntryPaymentLogReservation.propTypes = {
  reservationDescription: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  paymentDescription: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  transactionAmount: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  paymentAmount: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number
};

VirtualEntryPaymentLogReservation.defaultProps = {
  reservationDescription: '',
  paymentDescription: '',
  transactionAmount: 0,
  paymentAmount: 0
};

/* harmony default export */ __webpack_exports__["a"] = VirtualEntryPaymentLogReservation;

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(438);
/* unused harmony export initialState */
/* unused harmony export reducer */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  paymentLog: {},
  virtualEntriesToModify: [],
  showSquadChangeModal: false,
  showEventChangeModal: false
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_SQUAD_CHANGE_MODAL_FOR_CAPTAIN */]:
      {
        return _extends({}, state, {
          showSquadChangeModal: payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE_TEAMS */]:
      return _extends({}, state, {
        paymentLog: payload
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_ROSTER_WARNINGS_FOR_CAPT_ENTRY_DETAIL */]:
      return _extends({}, state, {
        virtualEntriesToModify: payload || initialState.virtualEntriesToModify
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* DISPLAY_EVENT_CHANGE_MODAL_FOR_CAPTAIN */]:
      {
        return _extends({}, state, {
          showEventChangeModal: payload
        });
      }
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home_reducer__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__checkout_reducer__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scheduler_reducer__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__manage_reducer__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_reducer__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rostercheckout_reducer__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__accountCreated_reducer__ = __webpack_require__(886);
/* unused harmony export base */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











var initialState = {
  tournamentId: '',
  tournamentName: '',
  tournamentPhoneNumber: '',
  marketingMessage: '',
  rosterMessage: '',
  canCaptainPurchase: false,
  captainPurchaseReason: '',
  showCalculatedDivisionToCaptain: false,
  returningToCalendar: false,
  tournamentStripeKey: '',
  requireRosterBeforeCheckout: false,
  blockFailedDivisionCalculation: false,
  paymentSuccessMessage: '',
  paymentFailureMessage: '',
  allowChangeBetweenFreeEvents: false
};

var base = function base() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* SET_RETURNING_TO_CALENDAR */]:
      {
        return _extends({}, state, {
          returningToCalendar: true
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* SET_TOURNAMENT_ID */]:
      return _extends({}, state, {
        tournamentId: payload.id,
        tournamentName: payload.name,
        tournamentPhoneNumber: payload.phoneNumber,
        marketingMessage: payload.marketingMessage,
        rosterMessage: payload.rosterMessage,
        canCaptainPurchase: payload.canCaptainPurchase,
        canCaptainManage: payload.canCaptainManage,
        captainPurchaseReason: payload.captainPurchaseReason,
        showCalculatedDivisionToCaptain: payload.showCalculatedDivisionToCaptain,
        tournamentStripeKey: payload.stripePublishableKey,
        requireRosterBeforeCheckout: payload.requireRosterBeforeCheckout,
        blockFailedDivisionCalculation: payload.blockFailedDivisionCalculation,
        paymentSuccessMessage: payload.paymentSuccessMessage,
        paymentFailureMessage: payload.paymentFailureMessage,
        captainPassesAgeRestrictions: payload.captainPassesAgeRestrictions,
        allowChangeBetweenFreeEvents: payload.allowChangeBetweenFreeEvents
      });

    default:
      return state;
  }
};

var registration = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  base: base,
  home: __WEBPACK_IMPORTED_MODULE_2__home_reducer__["a" /* default */],
  payment: __WEBPACK_IMPORTED_MODULE_3__checkout_reducer__["a" /* default */],
  scheduler: __WEBPACK_IMPORTED_MODULE_4__scheduler_reducer__["a" /* default */],
  manage: __WEBPACK_IMPORTED_MODULE_5__manage_reducer__["a" /* default */],
  shared: __WEBPACK_IMPORTED_MODULE_6__shared_reducer__["a" /* default */],
  rostercheckout: __WEBPACK_IMPORTED_MODULE_7__rostercheckout_reducer__["a" /* default */],
  accountCreated: __WEBPACK_IMPORTED_MODULE_8__accountCreated_reducer__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = registration;

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CartEntryFormContainer_jsx__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_Panel_jsx__ = __webpack_require__(44);







var CartEntry = function CartEntry(_ref) {
  var zindexvalue = _ref.zindexvalue,
      disableState = _ref.disableState,
      editing = _ref.editing,
      eventName = _ref.eventName,
      id = _ref.id,
      name = _ref.name,
      cartRosterId = _ref.cartRosterId,
      isCancelled = _ref.isCancelled,
      readOnly = _ref.readOnly,
      squadDateTime = _ref.squadDateTime,
      onViewRosterClick = _ref.onViewRosterClick,
      onManageRosterClick = _ref.onManageRosterClick,
      onRemoveRosterItemClick = _ref.onRemoveRosterItemClick,
      rosterComplete = _ref.rosterComplete,
      showCalculatedDivisionToCaptain = _ref.showCalculatedDivisionToCaptain,
      divisionName = _ref.divisionName;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled',
        style: { position: 'relative', zIndex: zindexvalue } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-group-item-labeled-child custom-checkbox-container',
        style: { width: 25 } }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 125 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Event Name'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          eventName
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 295 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Team Name'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          name
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 220 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Date'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          __WEBPACK_IMPORTED_MODULE_2_moment___default.a.parseZone(squadDateTime).format('hh:mm A, MMM Do, YYYY')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-group-item-labeled-child',
        style: { width: 110 } }),
      !rosterComplete ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('list-group-item-labeled-child', { 'bg-info': !rosterComplete }),
          style: { width: 170 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-link bg-info bold-font',
            type: 'button',
            disabled: true,
            style: { color: '#000' } },
          'Roster Incomplete'
        )
      ) : showCalculatedDivisionToCaptain ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 170 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Division'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          divisionName
        )
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-group-item-labeled-child',
        style: { width: 170 } }),
      isCancelled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-group-item-labeled-child',
        style: { width: 90 } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 90 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["DropdownButton"],
          { id: 'actions-dropdown-' + id,
            className: 'btn btn-link',
            title: "Actions" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["MenuItem"],
            { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('entry-dropdown-link', { 'bg-info bold-font': !rosterComplete }),
              onSelect: function onSelect() {
                return readOnly ? onViewRosterClick(cartRosterId) : onManageRosterClick(cartRosterId);
              },
              eventKey: 'manageRoster' },
            readOnly ? 'View Roster' : 'Manage Roster'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["MenuItem"],
            { className: 'entry-dropdown-link',
              onSelect: function onSelect() {
                return onRemoveRosterItemClick(cartRosterId);
              },
              eventKey: 'removeRosteritem' },
            'Remove Entry'
          )
        )
      )
    ),
    editing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_shared_Panel_jsx__["a" /* default */],
      { className: 'panel-primary animated fadeIn',
        style: { position: 'relative', zIndex: 0 },
        title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'flex space-between' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'panel-title' },
            'Entry and Roster Information'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'flex right wrap' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              {
                className: 'btn btn-link',
                href: 'http://webapps.bowl.com/USBCFindA',
                target: '_blank' },
              'Find a member'
            )
          )
        ) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CartEntryFormContainer_jsx__["a" /* default */], { disableState: disableState })
    ) : null
  );
};

CartEntry.propTypes = {
  zindexvalue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  disableState: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  editing: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  eventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  id: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  cartRosterId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  readOnly: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  squadDateTime: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  isCancelled: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onViewRosterClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onManageRosterClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onRemoveRosterItemClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  rosterComplete: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  showCalculatedDivisionToCaptain: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  divisionName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

/* harmony default export */ __webpack_exports__["a"] = CartEntry;

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartEntry_jsx__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(95);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var mapStateToProps = function mapStateToProps(state, props) {
  return _extends({
    showCalculatedDivisionToCaptain: state.registration.base.showCalculatedDivisionToCaptain
  }, props);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onViewRosterClick: function onViewRosterClick(entryId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["k" /* handleViewRosterClick */])(entryId));
    },
    onManageRosterClick: function onManageRosterClick(cartRosterId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["l" /* handleCheckOutManageRosterClick */])(cartRosterId));
    },
    onRemoveRosterItemClick: function onRemoveRosterItemClick(cartRosterId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["m" /* handleRemoveRosterItemClick */])(cartRosterId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CartEntry_jsx__["a" /* default */]);

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CartEntryRosterForm_jsx__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RosterListContainer_jsx__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_actionTypes__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(95);








var CartEntryRosterFormWrapper = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["reduxForm"])({
  form: 'entryForm',
  roster: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RosterListContainer_jsx__["a" /* default */], null),
  destroyOnUnmount: false
})(__WEBPACK_IMPORTED_MODULE_3__CartEntryRosterForm_jsx__["a" /* default */]);

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["formValueSelector"])('entryForm');

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    disableState: props.disableState,
    validate: __WEBPACK_IMPORTED_MODULE_6__actions__["n" /* validate */],
    countries: state.registration.shared.countries,
    states: state.registration.shared.states,
    rosterPositionsQty: selector(state, 'rosterPositionsQty'),
    parentVirtualEntryEvents: state.registration.shared.parentVirtualEntryEvents,
    parentTeamOwnedVirtualEntries: state.registration.shared.parentTeamOwnedVirtualEntries,
    entryId: selector(state, 'id'),
    eventId: state.registration.shared.cartEntries.find(function (x) {
      return x.editing;
    }) ? state.registration.shared.cartEntries.find(function (x) {
      return x.editing;
    }).eventId : null,
    maxEntries: selector(state, 'maxEntries')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["o" /* handleSave */])(data));
    },
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_actionTypes__["r" /* setRosterConfirmationVisibility */])(true));
    },
    onCountryChange: function onCountryChange(value) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["p" /* handleCountryChange */])(value));
    },
    onAssignTeamOwnedVirtualEventClick: function onAssignTeamOwnedVirtualEventClick(virtualEventName, teamEntryId, value) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["q" /* handleAssignTeamOwnedVirtualEventClick */])(virtualEventName, teamEntryId, value));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(CartEntryRosterFormWrapper);

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartEntryContainer_jsx__ = __webpack_require__(934);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var CartEntryList = function CartEntryList(_ref) {
  var cartRosters = _ref.cartRosters;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group' },
      cartRosters.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__CartEntryContainer_jsx__["a" /* default */], _extends({
          key: index,
          zindexvalue: cartRosters.length + 1003 - index // Stack zIndex inversely to prevent hiding dropdowns
        }, item));
      })
    )
  );
};

CartEntryList.propTypes = {
  cartRosters: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

/* harmony default export */ __webpack_exports__["a"] = CartEntryList;

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartEntryList_jsx__ = __webpack_require__(936);



var mapStateToProps = function mapStateToProps(state) {
  return {
    cartRosters: state.registration.shared.cartEntries
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__CartEntryList_jsx__["a" /* default */]);

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_StandardCheckboxField_jsx__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);








var CartEntryRosterForm = function CartEntryRosterForm(_ref) {
  var disableState = _ref.disableState,
      roster = _ref.roster,
      rosterPositionsQty = _ref.rosterPositionsQty,
      countries = _ref.countries,
      states = _ref.states,
      parentVirtualEntryEvents = _ref.parentVirtualEntryEvents,
      parentTeamOwnedVirtualEntries = _ref.parentTeamOwnedVirtualEntries,
      entryId = _ref.entryId,
      eventId = _ref.eventId,
      handleSubmit = _ref.handleSubmit,
      pristine = _ref.pristine,
      submitting = _ref.submitting,
      onCancelClick = _ref.onCancelClick,
      onSubmit = _ref.onSubmit,
      onCountryChange = _ref.onCountryChange,
      onAssignTeamOwnedVirtualEventClick = _ref.onAssignTeamOwnedVirtualEventClick,
      maxEntries = _ref.maxEntries;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'form',
    {
      onSubmit: handleSubmit(onSubmit),
      noValidate: true },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: {
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column'
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-6 col-xs-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            disabled: rosterPositionsQty === 2 || rosterPositionsQty === 1,
            autoFocus: rosterPositionsQty > 2,
            className: 'form-control',
            name: 'name',
            type: 'text',
            placeholder: 'Team Name',
            tooltip: 'If Team Name field is gray, the team name will auto-populate once roster is complete.',
            tooltipPosition: 'top',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */] })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-sm-6 col-xs-12' })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-6 col-xs-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'countryId',
            placeholder: 'Country',
            component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__["a" /* default */],
            options: countries,
            simpleValue: true,
            searchable: true,
            matchPos: 'start',
            onCustomChange: onCountryChange })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-6 col-xs-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            disabled: disableState,
            className: 'form-control',
            name: 'state',
            placeholder: 'State',
            component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__["a" /* default */],
            options: states,
            simpleValue: true,
            searchable: true,
            matchPos: 'start' })
        )
      ),
      parentVirtualEntryEvents.filter(function (x) {
        return x.eventId === eventId;
      }).length > 0 ? parentVirtualEntryEvents.filter(function (x) {
        return x.eventId === eventId;
      }).map(function (virtualEvent, index) {
        var entry = parentTeamOwnedVirtualEntries.find(function (entry) {
          return entry.teamEntryId == entryId && entry.virtualEventName == virtualEvent.name;
        });
        var entryAssigned = entry ? true : false;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row',
            key: index },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-12' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              id: 'assignVirtualEntry' + index,
              name: 'assignVirtualEntry' + index,
              checked: entryAssigned,
              disabled: !entryAssigned && virtualEvent.remaining == 0,
              component: __WEBPACK_IMPORTED_MODULE_5_shared_StandardCheckboxField_jsx__["a" /* default */],
              label: 'Assign ' + virtualEvent.name + ' (' + virtualEvent.remaining + ' remaining)',
              onCustomChange: function onCustomChange(event) {
                return onAssignTeamOwnedVirtualEventClick(virtualEvent.name, entryId, event.target.checked);
              } })
          )
        );
      }) : null,
      roster,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'form-group text-right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-link',
            disabled: submitting,
            onClick: onCancelClick },
          'Cancel'
        ),
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'submit',
            className: 'btn btn-primary btn-lg',
            disabled: pristine || submitting || maxEntries },
          submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
          ' ',
          'Save Changes'
        )
      )
    )
  );
};

CartEntryRosterForm.propTypes = {
  disableState: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  roster: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,
  rosterPositionsQty: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  countries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  states: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  parentVirtualEntryEvents: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  parentTeamOwnedVirtualEntries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  entryId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  eventId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  pristine: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  submitting: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onCountryChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onAssignTeamOwnedVirtualEventClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  maxEntries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired
};

CartEntryRosterForm.defaultProps = {
  disableState: false,
  rosterPositionsQty: 0,
  countries: [],
  states: [],
  submitting: false,
  maxEntries: false
};

/* harmony default export */ __webpack_exports__["a"] = CartEntryRosterForm;

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CartVirtualEntryBowlerListContainer_jsx__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VirtualEntryPaymentLogContainer_jsx__ = __webpack_require__(440);





var CartVirtualEntry = function CartVirtualEntry(_ref) {
  var zindexvalue = _ref.zindexvalue,
      balanceDue = _ref.balanceDue,
      editing = _ref.editing,
      selected = _ref.selected,
      showPaymentLog = _ref.showPaymentLog,
      virtualEventId = _ref.virtualEventId,
      virtualEventName = _ref.virtualEventName,
      cartRosterId = _ref.cartRosterId,
      totalEntries = _ref.totalEntries,
      onManageRosterClick = _ref.onManageRosterClick,
      onSelectChecked = _ref.onSelectChecked,
      rosterComplete = _ref.rosterComplete,
      virtualEntry = _ref.virtualEntry;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("list-group-item-labeled", { "highlight animated flipInX": editing || showPaymentLog }, { 'bg-warning': balanceDue }),
        style: { position: 'relative', zIndex: zindexvalue } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child custom-checkbox-container',
          style: { width: 25 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
          type: 'checkbox',
          id: 'entry-' + virtualEventId,
          disabled: !balanceDue,
          checked: selected,
          onChange: function onChange() {
            return onSelectChecked(cartRosterId);
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', {
          htmlFor: 'entry-' + virtualEventId })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 740 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Virtual Event'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          virtualEventName
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('list-group-item-labeled-child', { 'bg-danger': balanceDue }),
        style: { width: 110 } }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: { width: 150 },
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('list-group-item-labeled-child', { 'bg-info': !(rosterComplete && (virtualEntry ? virtualEntry.rosterComplete : true)) }) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            className: 'btn btn-link',
            type: 'button',
            onClick: function onClick() {
              return onManageRosterClick(cartRosterId, virtualEventId, totalEntries);
            }
          },
          'Manage Bowlers'
        )
      )
    ),
    editing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CartVirtualEntryBowlerListContainer_jsx__["a" /* default */], { zindexvalue: zindexvalue }) : null,
    showPaymentLog ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__VirtualEntryPaymentLogContainer_jsx__["a" /* default */], null) : null
  );
};

CartVirtualEntry.propTypes = {
  zindexvalue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  balanceDue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  editing: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  selected: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  showPaymentLog: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  virtualEventId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  virtualEventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  cartRosterId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  totalEntries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number.isRequired,
  onManageRosterClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onPaymentLogClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSelectChecked: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  rosterComplete: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  virtualEntry: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};

CartVirtualEntry.defaultProps = {
  balanceDue: 0,
  rosterComplete: false
};

/* harmony default export */ __webpack_exports__["a"] = CartVirtualEntry;

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualEntryBowlerList_jsx__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_actionTypes__ = __webpack_require__(39);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var mapStateToProps = function mapStateToProps(state, props) {
  return _extends({
    virtualEventId: state.registration.shared.cartVirtualEntries.find(function (x) {
      return x.editing;
    }) ? state.registration.shared.cartVirtualEntries.find(function (x) {
      return x.editing;
    }).virtualEventId : state.registration.shared.cartVirtualEntries[0].virtualEventId,
    quantity: state.registration.shared.cartVirtualEntries.find(function (x) {
      return x.editing;
    }) ? state.registration.shared.cartVirtualEntries.find(function (x) {
      return x.editing;
    }).quantity : state.registration.shared.cartVirtualEntries[0].quantity,
    source: state.registration.shared.cartVirtualBowlers,
    bowlers: state.registration.shared.bowlers,
    virtualBowlers: state.registration.shared.virtualBowlers,
    submitting: state.registration.shared.submittingVirtualBowlers,
    assignedByOtherCaptain: state.registration.shared.assignedByOtherCaptain,
    showCalculatedDivisionToCaptain: state.registration.base.showCalculatedDivisionToCaptain
  }, props);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onVirtualEntryBowlerChange: function onVirtualEntryBowlerChange(virtualEntryId, bowlerId, assignedByOtherCaptain) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_actionTypes__["_17" /* setBowlerForCartVirtualEntry */])(virtualEntryId, bowlerId));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_actionTypes__["_18" /* setBowlerForCartVirtualEntryAlreadyAssigned */])(assignedByOtherCaptain));
    },
    onVirtualEntryRemoveClick: function onVirtualEntryRemoveClick(virtualEventId, bowlerId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["i" /* handleRemoveVirtualEntryFromCart */])(virtualEventId, bowlerId));
    },
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_actionTypes__["g" /* closeVirtualEntryEditing */])());
    },
    onUpdateClick: function onUpdateClick(virtualEventId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["j" /* handleUpdateVirtualEntry */])(virtualEventId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__VirtualEntryBowlerList_jsx__["a" /* default */]);

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartVirtualEntry_jsx__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(95);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var mapStateToProps = function mapStateToProps(state, props) {
  return _extends({}, props, {
    virtualEventName: '(' + props.totalEntries + ') ' + props.virtualEventName
  });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onManageRosterClick: function onManageRosterClick(cartRosterId, virtualEntryId, virtualEntryQuantity) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["g" /* handleVirtualEntryManageRosterClick */])(cartRosterId, virtualEntryId, virtualEntryQuantity));
    },
    onSelectChecked: function onSelectChecked(cartRosterId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["h" /* handleVirtualEventSelectChecked */])(cartRosterId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CartVirtualEntry_jsx__["a" /* default */]);

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartVirtualEntryContainer_jsx__ = __webpack_require__(941);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var CartVirtualEntryList = function CartVirtualEntryList(_ref) {
  var source = _ref.source,
      virtualEntriesSource = _ref.virtualEntriesSource;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group' },
    source.map(function (item, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__CartVirtualEntryContainer_jsx__["a" /* default */], _extends({
        key: index,
        zindexvalue: source.length + 3 - index // Stack zIndex inversely to prevent hiding dropdowns
        , virtualEntry: virtualEntriesSource.find(function (virtualEntry) {
          return virtualEntry.virtualEventId === item.virtualEventId;
        })
      }, item));
    })
  );
};

CartVirtualEntryList.propTypes = {
  source: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  virtualEntriesSource: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

CartVirtualEntryList.defaultProps = {
  source: [],
  virtualEntriesSource: []
};

/* harmony default export */ __webpack_exports__["a"] = CartVirtualEntryList;

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartVirtualEntryList_jsx__ = __webpack_require__(942);



var mapStateToProps = function mapStateToProps(state) {
  return {
    source: state.registration.shared.cartVirtualEntries,
    virtualEntriesSource: state.registration.shared.virtualEntries
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__CartVirtualEntryList_jsx__["a" /* default */]);

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_ClearCartConfirmationContainer_jsx__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CartEntryListContainer_jsx__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CartVirtualEntryListContainer_jsx__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__manage_RosterConfirmationDialogContainer_jsx__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EntryListContainer_jsx__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__VirtualEntryListContainer_jsx__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RemoveVirtualEntriesConfirmationModalContainer_jsx__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TeamOwnedVirtualEntryTrackerContainer_jsx__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_constants__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_DisplayIf_jsx__ = __webpack_require__(12);












var CheckoutRoster = function CheckoutRoster(_ref) {
  var cart = _ref.cart,
      entries = _ref.entries,
      virtualEntries = _ref.virtualEntries,
      rostersComplete = _ref.rostersComplete,
      onClearCartClick = _ref.onClearCartClick,
      onContinueShoppingClick = _ref.onContinueShoppingClick,
      onReviewClick = _ref.onReviewClick,
      rosterMessage = _ref.rosterMessage;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_ClearCartConfirmationContainer_jsx__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__RemoveVirtualEntriesConfirmationModalContainer_jsx__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_shared_DisplayIf_jsx__["a" /* default */],
      { condition: !!rosterMessage },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-sm-12 animated fadeIn' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'alert alert-info text-center' },
            rosterMessage ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              rosterMessage
            ) : null
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      cart && cart.squads && cart.squads.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'alert' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Please assign your team members before proceeding to payment:'
        )
      ) : null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TeamOwnedVirtualEntryTrackerContainer_jsx__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CartEntryListContainer_jsx__["a" /* default */], null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      cart && cart.virtualEvents && cart.virtualEvents.length > 0 && cart.virtualEvents.find(function (virtualEntry) {
        return virtualEntry.owner === __WEBPACK_IMPORTED_MODULE_9__shared_constants__["f" /* BOWLER */];
      }) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'alert' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Please assign your virtual events before proceeding to payment:'
        )
      ) : null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CartVirtualEntryListContainer_jsx__["a" /* default */], null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'text-right' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-link',
            onClick: onClearCartClick
          },
          'Clear My Cart'
        ),
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-link',
            onClick: onContinueShoppingClick
          },
          'Return to Calendar'
        ),
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'display inline' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-primary btn-lg',
              disabled: !rostersComplete,
              onClick: onReviewClick
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-shopping-cart' }),
            ' ',
            'Review Cart'
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      entries && entries.length > 0 || virtualEntries && virtualEntries.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'alert' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Here are your existing (purchased) rosters:'
        )
      ) : null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__EntryListContainer_jsx__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__VirtualEntryListContainer_jsx__["a" /* default */], null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__manage_RosterConfirmationDialogContainer_jsx__["a" /* default */], null)
  );
};

CheckoutRoster.propTypes = {
  cart: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  entries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  virtualEntries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  rostersComplete: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onClearCartClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onContinueShoppingClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onReviewClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

CheckoutRoster.defaultProps = {
  cart: {
    squads: [],
    virtualEvents: []
  },
  entries: [],
  virtualEntries: [],
  rostersComplete: false
};

/* harmony default export */ __webpack_exports__["a"] = CheckoutRoster;

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CheckoutRoster_jsx__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_actionTypes__ = __webpack_require__(39);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var mapStateToProps = function mapStateToProps(state) {
  return _extends({}, state.registration.base, state.registration.payment, {
    rostersComplete: state.registration.rostercheckout.rostersComplete,
    entries: state.registration.shared.entries,
    virtualEntries: state.registration.shared.virtualEntries,
    rosterMessage: state.registration.base.rosterMessage
  });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onClearCartClick: function onClearCartClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_actionTypes__["Q" /* displayClearCartConfirmation */])(true));
    },
    onContinueShoppingClick: function onContinueShoppingClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["e" /* handleContinueShoppingSelection */])());
    },
    onReviewClick: function onReviewClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* handleReviewCartClick */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CheckoutRoster_jsx__["a" /* default */]);

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EntryFormContainer_jsx__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_Panel_jsx__ = __webpack_require__(44);







var Entry = function Entry(_ref) {
  var zindexvalue = _ref.zindexvalue,
      disableState = _ref.disableState,
      editing = _ref.editing,
      eventName = _ref.eventName,
      id = _ref.id,
      name = _ref.name,
      isCancelled = _ref.isCancelled,
      readOnly = _ref.readOnly,
      squadDateTime = _ref.squadDateTime,
      onViewRosterClick = _ref.onViewRosterClick,
      onManageRosterClick = _ref.onManageRosterClick,
      rosterComplete = _ref.rosterComplete,
      showCalculatedDivisionToCaptain = _ref.showCalculatedDivisionToCaptain,
      divisionName = _ref.divisionName;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled',
        style: { position: 'relative', zIndex: zindexvalue } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-group-item-labeled-child custom-checkbox-container',
        style: { width: 25 } }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 125 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Event Name'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          eventName
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 295 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Team Name'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          name
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 220 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Date'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          __WEBPACK_IMPORTED_MODULE_2_moment___default.a.parseZone(squadDateTime).format('hh:mm A, MMM Do, YYYY')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-group-item-labeled-child',
        style: { width: 110 } }),
      !rosterComplete ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('list-group-item-labeled-child', { 'bg-info': !rosterComplete }),
          style: { width: 170 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-link bg-info bold-font',
            type: 'button',
            disabled: true,
            style: { color: '#000' } },
          'Roster Incomplete'
        )
      ) : showCalculatedDivisionToCaptain ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 170 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Division'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          divisionName
        )
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-group-item-labeled-child',
        style: { width: 170 } }),
      isCancelled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-group-item-labeled-child',
        style: { width: 90 } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 90 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["DropdownButton"],
          { id: 'actions-dropdown-' + id,
            className: 'btn btn-link',
            title: "Actions" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["MenuItem"],
            { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('entry-dropdown-link', { 'bg-info bold-font': !rosterComplete }),
              onSelect: function onSelect() {
                return readOnly ? onViewRosterClick(id) : onManageRosterClick(id);
              },
              eventKey: 'manageRoster' },
            readOnly ? 'View Roster' : 'Manage Roster'
          )
        )
      )
    ),
    editing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_shared_Panel_jsx__["a" /* default */],
      { className: 'panel-primary animated fadeIn',
        style: { position: 'relative', zIndex: 0 },
        title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'flex space-between' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'panel-title' },
            'Entry and Roster Information'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'flex right wrap' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              {
                className: 'btn btn-link',
                href: 'http://webapps.bowl.com/USBCFindA',
                target: '_blank' },
              'Find a member'
            )
          )
        ) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__EntryFormContainer_jsx__["a" /* default */], {
        disableState: disableState,
        rosterCheckout: true })
    ) : null
  );
};

Entry.propTypes = {
  zindexvalue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  disableState: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  editing: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  eventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  id: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  readOnly: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  squadDateTime: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  isCancelled: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onViewRosterClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onManageRosterClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  rosterComplete: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  showCalculatedDivisionToCaptain: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  divisionName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

/* harmony default export */ __webpack_exports__["a"] = Entry;

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Entry_jsx__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_actions__ = __webpack_require__(60);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var mapStateToProps = function mapStateToProps(state, props) {
  return _extends({
    showCalculatedDivisionToCaptain: state.registration.base.showCalculatedDivisionToCaptain
  }, props);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onViewRosterClick: function onViewRosterClick(entryId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_actions__["l" /* handleViewRosterClick */])(entryId));
    },
    onManageRosterClick: function onManageRosterClick(entryId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_actions__["m" /* handleManageRosterClick */])(entryId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__Entry_jsx__["a" /* default */]);

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__manage_EntryRosterForm_jsx__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__manage_RosterListContainer_jsx__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_actionTypes__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__manage_actions__ = __webpack_require__(53);








var EntryRosterFormWrapper = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["reduxForm"])({
  form: 'entryForm',
  roster: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__manage_RosterListContainer_jsx__["a" /* default */], null),
  rosterCheckout: window.location.href.indexOf("rostercheckout") >= 0,
  destroyOnUnmount: false
})(__WEBPACK_IMPORTED_MODULE_3__manage_EntryRosterForm_jsx__["a" /* default */]);

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["formValueSelector"])('entryForm');

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    disableState: props.disableState,
    validate: __WEBPACK_IMPORTED_MODULE_6__manage_actions__["validate"],
    countries: state.registration.shared.countries,
    states: state.registration.shared.states,
    rosterPositionsQty: selector(state, 'rosterPositionsQty'),
    parentVirtualEntryEvents: state.registration.shared.parentVirtualEntryEvents,
    parentTeamOwnedVirtualEntries: state.registration.shared.parentTeamOwnedVirtualEntries,
    eventId: state.registration.shared.entries.find(function (x) {
      return x.editing;
    }).eventId,
    entryId: selector(state, 'id')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__manage_actions__["handleSave"])(data));
    },
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_actionTypes__["r" /* setRosterConfirmationVisibility */])(true));
    },
    onCountryChange: function onCountryChange(value) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__manage_actions__["handleCountryChange"])(value));
    },
    onAssignTeamOwnedVirtualEventClick: function onAssignTeamOwnedVirtualEventClick(virtualEventName, teamEntryId, value) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__manage_actions__["handleAssignTeamOwnedVirtualEventClick"])(virtualEventName, teamEntryId, value));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(EntryRosterFormWrapper);

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EntryContainer_jsx__ = __webpack_require__(947);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var EntryList = function EntryList(_ref) {
  var entries = _ref.entries;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group' },
      entries.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__EntryContainer_jsx__["a" /* default */], _extends({
          key: index,
          zindexvalue: entries.length + 1003 - index // Stack zIndex inversely to prevent hiding dropdowns
        }, item));
      })
    )
  );
};

EntryList.propTypes = {
  entries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

/* harmony default export */ __webpack_exports__["a"] = EntryList;

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EntryList_jsx__ = __webpack_require__(949);



var mapStateToProps = function mapStateToProps(state) {
  return state.registration.shared;
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__EntryList_jsx__["a" /* default */]);

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_ConfirmDialog_jsx__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_actionTypes__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_actions__ = __webpack_require__(60);





var mapStateToProps = function mapStateToProps(state) {
  return {
    visible: state.registration.shared.removeVirtualEntryConfirmationVisible,
    title: 'Confirm',
    content: 'This will remove the ' + state.registration.shared.virtualEntryToRemove.quantity + ' unassigned ' + state.registration.shared.virtualEntryToRemove.name + ' entries. Are you sure you want to do this?',
    cancelBtnLabel: 'Cancel',
    confirmBtnLabel: 'Save'
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_actionTypes__["_2" /* setRemoveVirtualEntryConfirmationVisibility */])(false));
    },
    onCloseClick: function onCloseClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_actionTypes__["_2" /* setRemoveVirtualEntryConfirmationVisibility */])(false));
    },
    onConfirmClick: function onConfirmClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_actions__["n" /* handleRemoveUnassignedVirtualEntries */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1_shared_ConfirmDialog_jsx__["a" /* default */]);

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_EntryRosterList_jsx__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__manage_actions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_actionTypes__ = __webpack_require__(39);







var entryFormSelector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["formValueSelector"])('entryForm');

var mapStateToProps = function mapStateToProps(state) {
  return {
    source: state.registration.shared.rosterPositions,
    sourceQty: state.registration.shared.rosterPositions.length,
    bowlers: state.registration.shared.bowlers,
    parentEntryId: entryFormSelector(state, 'id'),
    childVirtualEntryEvents: state.registration.shared.childVirtualEntryEvents.filter(function (x) {
      var editingCartEntry = state.registration.shared.cartEntries.find(function (y) {
        return y.editing;
      });

      return editingCartEntry ? x.eventId === editingCartEntry.eventId : false;
    }),
    childTeamOwnedVirtualEntries: state.registration.shared.childTeamOwnedVirtualEntries,
    onCartRoster: true,
    rosterCheckout: window.location.href.indexOf("rostercheckout") >= 0
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSearchEnterKeyPress: function onSearchEnterKeyPress(roster, event) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__manage_actions__["handleSearchEnterKeyPress"])(roster, event));
    },
    onSearchChange: function onSearchChange(roster, event) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__manage_actions__["handleSearchChange"])(roster, event));
    },
    onSearch: function onSearch(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__manage_actions__["handleSearch"])(data));
    },
    onAvgChange: function onAvgChange(position, value) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_actionTypes__["_16" /* setMemberAvgField */])(position, value));
    },
    onIsProfessionalChange: function onIsProfessionalChange(position, value) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__manage_actions__["handleIsProfessionalChange"])(position, value));
    },
    onMoveUpClick: function onMoveUpClick(index) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__manage_actions__["handleMoveUpClick"])(index));
    },
    onMoveDownClick: function onMoveDownClick(index) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__manage_actions__["handleMoveDownClick"])(index));
    },
    onRosterPositionCleared: function onRosterPositionCleared(index) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__manage_actions__["handleRosterPositionCleared"])(index));
    },
    onAssignChildTeamOwnedVirtualEventClick: function onAssignChildTeamOwnedVirtualEventClick(virtualEventName, parentTeamEntryId, rosterPosition, value) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["r" /* handleAssignChildTeamOwnedVirtualEventClick */])(virtualEventName, parentTeamEntryId, rosterPosition, value));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2_shared_EntryRosterList_jsx__["a" /* default */]);

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var TeamOwnedVirtualEntryTracker = function TeamOwnedVirtualEntryTracker(_ref) {
  var childTeamOwnedVirtualEntries = _ref.childTeamOwnedVirtualEntries,
      childVirtualEntryEvents = _ref.childVirtualEntryEvents,
      parentTeamOwnedVirtualEntries = _ref.parentTeamOwnedVirtualEntries,
      parentVirtualEntryEvents = _ref.parentVirtualEntryEvents,
      onRemoveUnassignedVirtualEntries = _ref.onRemoveUnassignedVirtualEntries;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    parentVirtualEntryEvents.length > 0 || childVirtualEntryEvents.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "info-summary" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "thead",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Virtual Event Name"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Available Entries"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Total Entries"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null)
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        parentVirtualEntryEvents.map(function (entry, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            { key: index },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              entry.name
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              parentTeamOwnedVirtualEntries.filter(function (x) {
                return x.virtualEventName == entry.name && x.teamEntryId == null && x.id.length < 36;
              }).length
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              parentTeamOwnedVirtualEntries.filter(function (x) {
                return x.virtualEventName == entry.name && x.id.length < 36;
              }).length
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "text-right" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "button",
                  {
                    type: "button",
                    className: "btn btn-link",
                    title: "Remove unassigned virtual entries from cart",
                    disabled: parentTeamOwnedVirtualEntries.filter(function (x) {
                      return x.virtualEventName == entry.name && x.teamEntryId == null;
                    }).length == 0,
                    onClick: function onClick() {
                      return onRemoveUnassignedVirtualEntries(true, entry.name, 'parent', parentTeamOwnedVirtualEntries.filter(function (x) {
                        return x.virtualEventName == entry.name && x.teamEntryId == null;
                      }).length);
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-trash-o" })
                )
              )
            )
          );
        }),
        childVirtualEntryEvents.filter(function (item, pos, self) {
          return self.findIndex(function (x) {
            return x.name === item.name;
          }) == pos;
        }).map(function (entry, index) {
          return childTeamOwnedVirtualEntries.filter(function (x) {
            return x.id.length < 36;
          }).length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            { key: index },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              entry.name
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              childTeamOwnedVirtualEntries.filter(function (x) {
                return x.virtualEventName == entry.name && x.parentTeamEntryId == null && x.id.length < 36;
              }).length
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              childTeamOwnedVirtualEntries.filter(function (x) {
                return x.virtualEventName == entry.name && x.id.length < 36;
              }).length
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "text-right" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "button",
                  {
                    type: "button",
                    className: "btn btn-link",
                    title: "Remove unassigned virtual entries from cart",
                    disabled: childTeamOwnedVirtualEntries.filter(function (x) {
                      return x.virtualEventName == entry.name && x.parentTeamEntryId == null;
                    }).length == 0,
                    onClick: function onClick() {
                      return onRemoveUnassignedVirtualEntries(true, entry.name, 'child', childTeamOwnedVirtualEntries.filter(function (x) {
                        return x.virtualEventName == entry.name && x.parentTeamEntryId == null;
                      }).length);
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-trash-o" })
                )
              )
            )
          ) : null;
        })
      )
    ) : null
  );
};

TeamOwnedVirtualEntryTracker.propTypes = {
  childTeamOwnedVirtualEntries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  childVirtualEntryEvents: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  parentTeamOwnedVirtualEntries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  parentVirtualEntryEvents: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  onRemoveUnassignedVirtualEntries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

TeamOwnedVirtualEntryTracker.defaultProps = {
  childTeamOwnedVirtualEntries: [],
  childVirtualEntryEvents: [],
  parentTeamOwnedVirtualEntries: [],
  parentVirtualEntryEvents: []
};

/* harmony default export */ __webpack_exports__["a"] = TeamOwnedVirtualEntryTracker;

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TeamOwnedVirtualEntryTracker_jsx__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_actionTypes__ = __webpack_require__(39);




var mapStateToProps = function mapStateToProps(state) {
  return {
    childTeamOwnedVirtualEntries: state.registration.shared.childTeamOwnedVirtualEntries,
    childVirtualEntryEvents: state.registration.shared.childVirtualEntryEvents,
    parentTeamOwnedVirtualEntries: state.registration.shared.parentTeamOwnedVirtualEntries,
    parentVirtualEntryEvents: state.registration.shared.parentVirtualEntryEvents
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onRemoveUnassignedVirtualEntries: function onRemoveUnassignedVirtualEntries(value, virtualEventName, childOrParent, quantity) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_actionTypes__["_2" /* setRemoveVirtualEntryConfirmationVisibility */])(value, virtualEventName, childOrParent, quantity));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__TeamOwnedVirtualEntryTracker_jsx__["a" /* default */]);

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VirtualEntryBowlerListContainer_jsx__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VirtualEntryPaymentLogContainer_jsx__ = __webpack_require__(440);





var VirtualEntry = function VirtualEntry(_ref) {
  var zindexvalue = _ref.zindexvalue,
      balanceDue = _ref.balanceDue,
      editing = _ref.editing,
      selected = _ref.selected,
      showPaymentLog = _ref.showPaymentLog,
      virtualEventId = _ref.virtualEventId,
      virtualEventName = _ref.virtualEventName,
      onManageRosterClick = _ref.onManageRosterClick,
      onSelectChecked = _ref.onSelectChecked,
      rosterComplete = _ref.rosterComplete;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("list-group-item-labeled", { "highlight animated flipInX": editing || showPaymentLog }, { 'bg-warning': balanceDue }),
        style: { position: 'relative', zIndex: zindexvalue } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child custom-checkbox-container',
          style: { width: 25 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
          type: 'checkbox',
          id: 'entry-' + virtualEventId,
          disabled: !balanceDue,
          checked: selected,
          onChange: function onChange() {
            return onSelectChecked(virtualEventId);
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', {
          htmlFor: 'entry-' + virtualEventId })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 740 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Virtual Event'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          virtualEventName
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('list-group-item-labeled-child', { 'bg-danger': balanceDue }),
        style: { width: 110 } }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: { width: 150 },
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('list-group-item-labeled-child', { 'bg-info': !rosterComplete }) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            className: 'btn btn-link',
            type: 'button',
            onClick: function onClick() {
              return onManageRosterClick(virtualEventId);
            }
          },
          'Manage Bowlers'
        )
      )
    ),
    editing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__VirtualEntryBowlerListContainer_jsx__["a" /* default */], { zindexvalue: zindexvalue }) : null,
    showPaymentLog ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__VirtualEntryPaymentLogContainer_jsx__["a" /* default */], null) : null
  );
};

VirtualEntry.propTypes = {
  zindexvalue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  balanceDue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  editing: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  selected: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  showPaymentLog: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  virtualEventId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  virtualEventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  onManageRosterClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onPaymentLogClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSelectChecked: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  rosterComplete: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool
};

VirtualEntry.defaultProps = {
  balanceDue: 0,
  rosterComplete: false
};

/* harmony default export */ __webpack_exports__["a"] = VirtualEntry;

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__ = __webpack_require__(12);





var VirtualEntryBowler = function VirtualEntryBowler(_ref) {
  var id = _ref.id,
      bowlerId = _ref.bowlerId,
      position = _ref.position,
      bowlers = _ref.bowlers,
      onBowlerChange = _ref.onBowlerChange,
      showCalculatedDivisionToCaptain = _ref.showCalculatedDivisionToCaptain,
      divisionName = _ref.divisionName;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'contact-card' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'contact-card-info-wrapper' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('contact-card-avatar', { 'empty': !bowlerId })
        },
        position
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'contact-card-info' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: {
              display: 'flex'
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                flex: 1,
                maxWidth: '360px',
                marginRight: '5px'
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              { htmlFor: 'bowler-' + position },
              'Bowler'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select___default.a, {
              name: 'bowler-' + position,
              options: bowlers.map(function (x) {
                return {
                  value: x.id,
                  label: x.name
                };
              }),
              placeholder: 'Select...',
              value: bowlerId,
              simpleValue: true,
              searchable: true,
              onChange: function onChange(value) {
                return onBowlerChange(id, value, bowlers.find(function (b) {
                  return b.id == value;
                }) ? bowlers.find(function (b) {
                  return b.id == value;
                }).assignedByOtherCaptain : false);
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
            { condition: showCalculatedDivisionToCaptain },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  flex: 1,
                  marginLeft: '20px'
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                { htmlFor: 'bowler-' + position },
                'Division'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                !bowlerId ? '-' : divisionName == '' ? 'Not Assigned' : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  divisionName
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
          { condition: bowlers.find(function (b) {
              return b.id == bowlerId;
            }) ? bowlers.find(function (b) {
              return b.id == bowlerId;
            }).assignedByOtherCaptain : false },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'btn btn-danger',
              disabled: true,
              style: { opacity: 1, marginTop: 5, maxWidth: 560 } },
            'Bowler already entered into All Events by another captain'
          )
        )
      )
    )
  );
};

VirtualEntryBowler.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string, __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number]),
  bowlerId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  bowlerName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  position: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number.isRequired,
  bowlers: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  onBowlerChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  showCalculatedDivisionToCaptain: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  divisionName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

VirtualEntryBowler.defaultProps = {
  bowlers: []
};

/* harmony default export */ __webpack_exports__["a"] = VirtualEntryBowler;

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualEntryBowlerList_jsx__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_actions__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_actionTypes__ = __webpack_require__(39);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var mapStateToProps = function mapStateToProps(state, props) {
  return _extends({
    virtualEventId: state.registration.shared.virtualEntries[0].virtualEventId,
    source: state.registration.shared.virtualBowlers,
    bowlers: state.registration.shared.bowlers,
    submitting: state.registration.shared.submittingVirtualBowlers,
    showCalculatedDivisionToCaptain: state.registration.base.showCalculatedDivisionToCaptain
  }, props);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onVirtualEntryBowlerChange: function onVirtualEntryBowlerChange(virtualEntryId, bowlerId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_actionTypes__["X" /* setBowlerForVirtualEntry */])(virtualEntryId, bowlerId));
    },
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_actionTypes__["g" /* closeVirtualEntryEditing */])());
    },
    onUpdateClick: function onUpdateClick(virtualEventId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_actions__["k" /* handleUpdateVirtualEntry */])(virtualEventId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__VirtualEntryBowlerList_jsx__["a" /* default */]);

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualEntry_jsx__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_actions__ = __webpack_require__(60);




var mapStateToProps = function mapStateToProps(state, props) {
  return props;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onManageRosterClick: function onManageRosterClick(entryId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_actions__["i" /* handleVirtualEntryManageRosterClick */])(entryId));
    },
    onSelectChecked: function onSelectChecked(virtualEventId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_actions__["j" /* handleVirtualEventSelectChecked */])(virtualEventId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__VirtualEntry_jsx__["a" /* default */]);

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualEntryContainer_jsx__ = __webpack_require__(958);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var VirtualEntryList = function VirtualEntryList(_ref) {
  var source = _ref.source;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group' },
    source.map(function (item, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__VirtualEntryContainer_jsx__["a" /* default */], _extends({
        key: index,
        zindexvalue: source.length + 3 - index // Stack zIndex inversely to prevent hiding dropdowns
      }, item));
    })
  );
};

VirtualEntryList.propTypes = {
  source: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

VirtualEntryList.defaultProps = {
  source: []
};

/* harmony default export */ __webpack_exports__["a"] = VirtualEntryList;

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualEntryList_jsx__ = __webpack_require__(959);



var mapStateToProps = function mapStateToProps(state) {
  return {
    source: state.registration.shared.virtualEntries
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__VirtualEntryList_jsx__["a" /* default */]);

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualEntryPaymentLogReservation_jsx__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_Panel_jsx__ = __webpack_require__(44);




var VirtualEntryPaymentLog = function VirtualEntryPaymentLog(_ref) {
  var reservationsDue = _ref.reservationsDue,
      reservationsPaid = _ref.reservationsPaid;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_shared_Panel_jsx__["a" /* default */],
      { title: 'Payment Log' },
      reservationsDue.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          null,
          'Reservations Due'
        ),
        reservationsDue.map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { key: index },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__VirtualEntryPaymentLogReservation_jsx__["a" /* default */], item),
            index < reservationsDue.length - 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null) : null
          );
        })
      ) : null,
      reservationsDue.length && reservationsPaid.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null) : null,
      reservationsPaid.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          null,
          'Reservations Paid'
        ),
        reservationsPaid.map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { key: index },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__VirtualEntryPaymentLogReservation_jsx__["a" /* default */], item),
            index < reservationsPaid.length - 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null) : null
          );
        })
      ) : null
    )
  );
};

VirtualEntryPaymentLog.propTypes = {
  reservationsDue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  reservationsPaid: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

VirtualEntryPaymentLog.defaultProps = {
  reservationsDue: [],
  reservationsPaid: []
};

/* harmony default export */ __webpack_exports__["a"] = VirtualEntryPaymentLog;

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_util_formatCurrency__ = __webpack_require__(27);


Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_1_shared_util_formatCurrency__["a" /* formatCurrency */];

var VirtualEntryPaymentLogReservation = function VirtualEntryPaymentLogReservation(_ref) {
  var reservationDescription = _ref.reservationDescription,
      paymentDescription = _ref.paymentDescription,
      transactionAmount = _ref.transactionAmount,
      paymentAmount = _ref.paymentAmount;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'flex' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex-3' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'small',
          null,
          'Description'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          reservationDescription
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex-1' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            'Amount'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'flex text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'flex-2' },
            'Base Fee'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'flex-1' },
            '$' + transactionAmount.formatCurrency(2)
          )
        )
      )
    ),
    paymentDescription && paymentAmount ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'flex' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex-3' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          paymentDescription
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex-1' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'flex text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            { className: 'flex-2' },
            'Payment'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            { className: 'flex-1' },
            '$' + paymentAmount.formatCurrency(2)
          )
        )
      )
    ) : null
  );
};

VirtualEntryPaymentLogReservation.propTypes = {
  reservationDescription: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  paymentDescription: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  transactionAmount: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  paymentAmount: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number
};

VirtualEntryPaymentLogReservation.defaultProps = {
  reservationDescription: '',
  paymentDescription: '',
  transactionAmount: 0,
  paymentAmount: 0
};

/* harmony default export */ __webpack_exports__["a"] = VirtualEntryPaymentLogReservation;

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(442);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  cartEntries: [],
  rostersComplete: false
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CANCEL_CART_ROSTER_ENTRY_FORM */]:
      return _extends({}, state, {
        editing: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_ROSTERS_COMPLETE */]:
      return _extends({}, state, {
        rostersComplete: payload || initialState.rostersComplete
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_EVENTS_FOR_ROSTER_CHECKOUT */]:
      return _extends({}, state, {
        events: payload
      });
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_lib_IndexRoute__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_lib_IndexRoute___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_router_lib_IndexRoute__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__home_actionTypes__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__home_RegHomeContainer_jsx__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__accountCreated_AccountCreatedContainer_jsx__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scheduler_SchedulerContainer_jsx__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__checkout_CheckoutContainer_jsx__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rostercheckout_CheckoutRosterContainer_jsx__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__manage_ManageContainer_jsx__ = __webpack_require__(916);





// actions


// actionTypes


// components







var routes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_lib_IndexRoute___default.a, { component: __WEBPACK_IMPORTED_MODULE_6__home_RegHomeContainer_jsx__["a" /* default */],
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* handleRegistrationHomeRouteEnter */])(nextState, replace, callback));
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'registration',
    component: __WEBPACK_IMPORTED_MODULE_6__home_RegHomeContainer_jsx__["a" /* default */],
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* handleRegistrationHomeRouteEnter */])(nextState, replace, callback));
    },
    onLeave: function onLeave() {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__home_actionTypes__["a" /* setPaymentMessage */])(''));
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'registration/schedule/:tournamentId',
    component: __WEBPACK_IMPORTED_MODULE_8__scheduler_SchedulerContainer_jsx__["a" /* default */],
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["b" /* handleRegistrationScheduleRouteEnter */])(nextState, replace, callback));
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'registration/accountCreated',
    component: __WEBPACK_IMPORTED_MODULE_7__accountCreated_AccountCreatedContainer_jsx__["a" /* default */],
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["c" /* handleAccountCreatedRouteEnter */])(nextState, replace, callback));
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'registration/checkout/:tournamentId',
    component: __WEBPACK_IMPORTED_MODULE_9__checkout_CheckoutContainer_jsx__["a" /* default */],
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["d" /* handleRegistrationCheckoutRouteEnter */])(nextState, replace, callback));
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'registration/checkout/:tournamentId/:paymentId',
    component: __WEBPACK_IMPORTED_MODULE_9__checkout_CheckoutContainer_jsx__["a" /* default */],
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["d" /* handleRegistrationCheckoutRouteEnter */])(nextState, replace, callback));
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'registration/manage/:tournamentId',
    component: __WEBPACK_IMPORTED_MODULE_11__manage_ManageContainer_jsx__["a" /* default */],
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["e" /* handleRegistrationManageRouteEnter */])(nextState, replace, callback));
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'registration/manage/:tournamentId/:paymentId',
    component: __WEBPACK_IMPORTED_MODULE_11__manage_ManageContainer_jsx__["a" /* default */],
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["e" /* handleRegistrationManageRouteEnter */])(nextState, replace, callback));
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'registration/rostercheckout/:tournamentId',
    component: __WEBPACK_IMPORTED_MODULE_10__rostercheckout_CheckoutRosterContainer_jsx__["a" /* default */],
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["f" /* handleRegistrationCheckoutRosterRouteEnter */])(nextState, replace, callback));
    }
  })
);

/* harmony default export */ __webpack_exports__["a"] = routes;

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_CartFooter_jsx__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_util_getCountInCart__ = __webpack_require__(281);





var mapStateToProps = function mapStateToProps(state) {
  return {
    total: state.registration.scheduler.total,
    countInCart: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_util_getCountInCart__["b" /* getCountInCart */])({
      virtualEvents: state.registration.scheduler.virtualEvents,
      events: state.registration.scheduler.events
    }),
    visible: !state.registration.scheduler.noDatesAvailable || !!state.registration.scheduler.allEvent.id
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onReviewClick: function onReviewClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["j" /* checkout */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1_shared_CartFooter_jsx__["a" /* default */]);

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_RegistrationCalendar_jsx__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(166);




var mapStateToProps = function mapStateToProps(state) {
  return state.registration.scheduler.calendar;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSelectDate: function onSelectDate(date) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* handleDateSelection */])(date));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1_shared_RegistrationCalendar_jsx__["a" /* default */]);

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_ScheduleEventList_jsx__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(273);





var mapStateToProps = function mapStateToProps(state) {
  return {
    source: state.registration.scheduler.events,
    selectedDate: state.registration.scheduler.calendar.selectedDate
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onEventSquadFeesClick: function onEventSquadFeesClick(eventPrice, eventAddOnFees) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["g" /* handleSquadFeesButtonClick */])(eventPrice, eventAddOnFees));
    },
    onEventSquadQuantityChange: function onEventSquadQuantityChange(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["b" /* updateSquadQuantity */])(data));
    },
    onEventSquadAddClick: function onEventSquadAddClick(squadId, quantity) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["h" /* handleEventSquadAddClick */])(squadId, quantity));
    },
    onNextDateClick: function onNextDateClick(date) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* handleDateSelection */])(date));
    },
    onAddClick: function onAddClick(item) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["i" /* handleTeamOwnedVirtualEventAddClick */])(item));
    },
    onQuantityChange: function onQuantityChange(eventId, virtualEventId, quantity) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["k" /* updateTeamOwnedVirtualEventQuantity */])(eventId, virtualEventId, quantity));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1_shared_ScheduleEventList_jsx__["a" /* default */]);

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScheduleEventListContainer_jsx__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VirtualEventContainer_jsx__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_eventPriceDetailsModal_EventPriceDetailsModalContainer_jsx__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RegistrationCalendarContainer_jsx__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CartFooterContainer_jsx__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_DisplayIf_jsx__ = __webpack_require__(12);








var Scheduler = function Scheduler(_ref) {
  var noDatesAvailable = _ref.noDatesAvailable,
      marketingMessage = _ref.marketingMessage,
      canCaptainPurchase = _ref.canCaptainPurchase;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'animated fadeIn' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_shared_DisplayIf_jsx__["a" /* default */],
        { condition: !!marketingMessage || noDatesAvailable || !canCaptainPurchase },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-sm-12 animated fadeIn' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alert alert-info text-center' },
              marketingMessage ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                marketingMessage
              ) : null,
              noDatesAvailable ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'No bowled events available for this tournament.'
              ) : null,
              !canCaptainPurchase ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Tournament is not available for purchase at this time. Please call USBC if you have any questions.'
              ) : null
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_shared_DisplayIf_jsx__["a" /* default */],
        { condition: canCaptainPurchase },
        noDatesAvailable ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__VirtualEventContainer_jsx__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CartFooterContainer_jsx__["a" /* default */], null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RegistrationCalendarContainer_jsx__["a" /* default */], null)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-8' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ScheduleEventListContainer_jsx__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__VirtualEventContainer_jsx__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CartFooterContainer_jsx__["a" /* default */], null)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_eventPriceDetailsModal_EventPriceDetailsModalContainer_jsx__["a" /* default */], null)
        )
      )
    )
  );
};

Scheduler.propTypes = {
  noDatesAvailable: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  marketingMessage: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  canCaptainPurchase: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool
};

/* harmony default export */ __webpack_exports__["a"] = Scheduler;

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Scheduler_jsx__ = __webpack_require__(968);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var mapStateToProps = function mapStateToProps(state) {
  return _extends({}, state.registration.scheduler, {
    marketingMessage: state.registration.base.marketingMessage,
    noDatesAvailable: state.registration.scheduler.noDatesAvailable,
    canCaptainPurchase: state.registration.base.canCaptainPurchase
  });
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__Scheduler_jsx__["a" /* default */]);

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_VirtualEvent_jsx__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(273);





var mapStateToProps = function mapStateToProps(state) {
  return {
    virtualEvents: state.registration.scheduler.virtualEvents,
    showAllEvent: !!state.registration.scheduler.calendar.selectedDate
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onAddClick: function onAddClick(item) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["k" /* handleBowlerOwnedVirtualEventAddClick */])(item));
    },
    onQuantityChange: function onQuantityChange(virtualEventId, quantity) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["j" /* updateBowlerOwnedVirtualEventQuantity */])(virtualEventId, quantity));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1_shared_VirtualEvent_jsx__["a" /* default */]);

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_constants__ = __webpack_require__(97);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





var initialState = {
  noDatesAvailable: false,
  calendar: {},
  events: [],
  total: 0,
  virtualEvents: [],
  allEvent: {}
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_CALENDAR_SELECTED_DATE */]:
      {
        state.calendar.selectedDate = payload;
        return _extends({}, state);
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_NO_DATES_AVAILABLE_FOR_REG_SCHEDULER */]:
      return _extends({}, state, {
        noDatesAvailable: payload || false
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* UPDATE_TOTAL_FOR_REG_SCHEDULER */]:
      {
        var cart = {
          squads: payload.squads || [],
          virtualEvents: payload.virtualEvents || []
        };

        var total = 0;

        total += cart.squads.reduce(function (acc, squad) {
          return acc + squad.quantity * squad.eventTotalPrice;
        }, 0);
        total += cart.virtualEvents.reduce(function (acc, virtualEvent) {
          return acc + virtualEvent.quantity * virtualEvent.price;
        }, 0);

        return _extends({}, state, {
          total: total
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* UPDATE_SQUAD_QTY_FOR_REG_SCHEDULER */]:
      {
        var newQty = payload.inputValue;

        if (payload.inputValue > payload.max) {
          newQty = payload.max;
        } else if (payload.inputValue < 0) {
          newQty = 0;
        }

        state.events.forEach(function (item) {
          item.squads.forEach(function (squad) {
            if (squad.id === payload.squadId) {
              if (payload.addedToCart && squad.available && squad.quantity) {
                // If payload.addedToCart is true means squads were just added to the cart
                // so we need to update the availability
                squad.available = squad.available - squad.quantity;
              }
              squad.quantity = Number(newQty);
              if (payload.removedFromCart && squad.available) {
                // If payload.addedToCart is true means squads were just added to the cart
                // so we need to update the availability
                squad.available = squad.available + 1;
              }
              squad.quantity = Number(newQty);
            }
          });
        });
        return _extends({}, state, { events: [].concat(_toConsumableArray(state.events)) });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SET_SELECTED_DATE */]:
      return _extends({}, state, {
        calendar: _extends({}, state.calendar, {
          selectedDate: payload
        })
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* DISPLAY_AVAILABLE_DATES */]:
      return _extends({}, state, {
        calendar: payload
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* DISPLAY_SQUADS */]:
      {
        var _cart = {
          squads: payload.cart.squads || []
        };

        payload.events.forEach(function (item) {
          item.squads.forEach(function (squad) {
            var cartSquad = _cart.squads.find(function (x) {
              return x.id === squad.id;
            }) || null;

            if (cartSquad !== null) {
              squad.countInCart = cartSquad.quantity;
              squad.available = squad.available - cartSquad.quantity;
            }

            squad.showBundleGuide = false;
          });

          var virtualEventCart = {
            virtualEvents: payload.cart.virtualEvents || []
          };

          var virtualEvents = item.teamOwnedVirtualEvents || [];

          virtualEvents.forEach(function (virtualEvent) {
            var cartVirtualEvent = virtualEventCart.virtualEvents.find(function (x) {
              return x.id === virtualEvent.id;
            }) || null;

            if (cartVirtualEvent !== null) {
              virtualEvent.countInCart = cartVirtualEvent.quantity;
            } else {
              virtualEvent.countInCart = Number(0);
            }

            virtualEvent.quantity = Number(0);
          });
        });

        return _extends({}, state, { events: payload.events });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* DISPLAY_BOWLER_OWNED_VIRTUAL_EVENTS */]:
      {
        var _cart2 = {
          virtualEvents: payload.cart.virtualEvents || []
        };

        var virtualEvents = payload.virtualEvents || [];

        virtualEvents.forEach(function (virtualEvent) {
          var cartVirtualEvent = _cart2.virtualEvents.find(function (x) {
            return x.id === virtualEvent.id;
          }) || null;

          if (cartVirtualEvent !== null) {
            virtualEvent.countInCart = cartVirtualEvent.quantity;
          } else {
            virtualEvent.countInCart = Number(0);
          }
        });

        return _extends({}, state, {
          virtualEvents: virtualEvents.map(function (virtualEvent) {
            if (virtualEvent.owner === __WEBPACK_IMPORTED_MODULE_1_shared_constants__["f" /* BOWLER */]) {
              return _extends({}, virtualEvent, { quantity: Number(0) });
            }
          }).filter(function (virtualEvent) {
            return virtualEvent;
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_QTY_FOR_REG_SCHEDULER */]:
      {
        return _extends({}, state, {
          virtualEvents: state.virtualEvents.map(function (virtualEvent) {
            if (virtualEvent.id === payload.virtualEventId) {
              return _extends({}, virtualEvent, {
                quantity: !payload.quantity ? 0 : Number(payload.quantity)
              });
            }

            return virtualEvent;
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* UPDATE_TEAM_OWNED_VIRTUAL_EVENT_QTY_FOR_REG_SCHEDULER */]:
      {
        return _extends({}, state, {
          events: state.events.map(function (event) {
            if (event.id === payload.eventId) {
              return _extends({}, event, {
                teamOwnedVirtualEvents: event.teamOwnedVirtualEvents.map(function (virtualEvent) {
                  if (virtualEvent.id === payload.virtualEventId) {
                    return _extends({}, virtualEvent, {
                      quantity: !payload.quantity ? 0 : Number(payload.quantity)
                    });
                  }

                  return virtualEvent;
                })
              });
            }

            return event;
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_GUIDE_IF_SQUAD_IS_BUNDLED */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* UPDATE_SQUAD_COUNT_IN_CART_FOR_REG_SCHEDULER */]:
      {
        return _extends({}, state, {
          events: state.events.map(function (x) {
            return eventReducer(x, { type: type, payload: payload });
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_REG_SCHEDULER */]:
      {
        return _extends({}, state, {
          virtualEvents: state.virtualEvents.map(function (virtualEvent) {
            if (virtualEvent.id === payload.virtualEventId) {
              return _extends({}, virtualEvent, {
                countInCart: virtualEvent.countInCart ? virtualEvent.countInCart + Number(payload.count) : Number(payload.count)
              });
            }

            return virtualEvent;
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* UPDATE_TEAM_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_REG_SCHEDULER */]:
      {
        return _extends({}, state, {
          events: state.events.map(function (event) {
            if (event.id === payload.eventId) {
              return _extends({}, event, {
                teamOwnedVirtualEvents: event.teamOwnedVirtualEvents.map(function (virtualEvent) {
                  if (virtualEvent.id === payload.virtualEventId) {
                    return _extends({}, virtualEvent, {
                      countInCart: virtualEvent.countInCart ? virtualEvent.countInCart + Number(payload.count) : Number(payload.count)
                    });
                  }

                  return virtualEvent;
                })
              });
            }

            return event;
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1_shared_constants__["d" /* UPDATE_SCHEDULER_SQUAD_COUNT */]:
      {
        // REG-2531
        // const events = state.events.slice();
        // let event = events.find(item => item.id == payload.squad.eventId);
        // let squadInScheduler = event.squads.find(item => item.id == payload.squad.id);
        var squadInScheduler = payload.squad;

        if (squadInScheduler) {
          squadInScheduler.countInCart = payload.count;
        }

        return _extends({}, state);
      }

    case __WEBPACK_IMPORTED_MODULE_1_shared_constants__["e" /* UPDATE_SCHEDULER_VIRTUAL_EVENT_COUNT */]:
      {
        var events = state.events.slice();
        var _virtualEvents = state.virtualEvents.slice();

        var virtualEventInScheduler = undefined;

        if (payload.virtualEvent.eventId) {
          var parentEvent = events.find(function (item) {
            return item.id == payload.virtualEvent.eventId;
          });

          if (parentEvent) {
            virtualEventInScheduler = parentEvent.teamOwnedVirtualEvents.find(function (item) {
              return item.id == payload.virtualEvent.id;
            });
          }
        } else {
          virtualEventInScheduler = _virtualEvents.find(function (item) {
            return item.id == payload.virtualEvent.id;
          });
        }

        if (virtualEventInScheduler) {
          virtualEventInScheduler.countInCart = payload.count;
        }

        return _extends({}, state, {
          events: events,
          virtualEvents: _virtualEvents
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1_shared_constants__["c" /* CLEAR_SCHEDULER_ITEMS */]:
      {
        var _events = state.events.slice();
        var _virtualEvents2 = state.virtualEvents.slice();

        _events.forEach(function (event) {
          event.squads.forEach(function (squad) {
            return squad.countInCart = 0;
          });
          event.teamOwnedVirtualEvents.forEach(function (virtualEvent) {
            return virtualEvent.countInCart = 0;
          });
        });

        _virtualEvents2.forEach(function (virtualEvent) {
          return virtualEvent.countInCart = 0;
        });

        return _extends({}, state, {
          events: _events,
          virtualEvents: _virtualEvents2
        });
      }

    default:
      return state;
  }
};

var eventReducer = function eventReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_GUIDE_IF_SQUAD_IS_BUNDLED */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* UPDATE_SQUAD_COUNT_IN_CART_FOR_REG_SCHEDULER */]:
      return _extends({}, state, {
        squads: state.squads.map(function (x) {
          return squadReducer(x, { type: type, payload: payload });
        })
      });
    default:
      return state;
  }
};

var squadReducer = function squadReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref3 = arguments[1];
  var type = _ref3.type,
      payload = _ref3.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_GUIDE_IF_SQUAD_IS_BUNDLED */]:
      {
        return state.id === payload ? _extends({}, state, {
          showBundleGuide: state.hasBundledChild
        }) : state;
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* UPDATE_SQUAD_COUNT_IN_CART_FOR_REG_SCHEDULER */]:
      {
        return state.id === payload.squadId ? _extends({}, state, {
          countInCart: state.countInCart ? state.countInCart + payload.quantity : payload.quantity
        }) : state;
      }
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return blankRosterPosition; });
var blankRosterPosition = {
  _searchValue: "",
  _retrieved: false,
  usbcIdError: false,
  averageRequired: false,
  bowler: {},
  usbcId: ""
};

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clone__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_clone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dataModel__ = __webpack_require__(972);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }








var initialState = {
  balanceDue: 0,
  bowlers: [],
  cartBowlers: [],
  entryDetails: {},
  entries: [],
  virtualEntries: [],
  teamOwnedVirtualEntriesAvailable: [],
  parentTeamOwnedVirtualEntries: [],
  childTeamOwnedVirtualEntries: [],
  parentVirtualEntryEvents: [],
  childVirtualEntryEvents: [],
  removeVirtualEntryConfirmationVisible: false,
  rosterConfirmationVisible: false,
  rosterConfirmationNextAction: '',
  rosterConfirmationNextActionArgs: null,
  rosterPositions: [],
  virtualBowlers: [],
  virtualEntryToRemove: {},
  submittingVirtualBowlers: false,
  assignedByOtherCaptain: false,
  loadingEntries: true,
  loadingVirtualEntries: true,
  cartEntries: [],
  cartVirtualEntries: [],
  cartVirtualBowlers: [],
  teamOwnedVirtualEntryMap: []
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* DISPLAY_VIRTUAL_ENTRIES_FOR_REG_MANAGE */]:
      if (payload) {
        var virtualEntries = payload.filter(function (entry) {
          return entry.owner === __WEBPACK_IMPORTED_MODULE_2_shared_constants__["f" /* BOWLER */];
        });
        var teamOwnedVirtualEntriesAvailable = payload.filter(function (entry) {
          return entry.owner === __WEBPACK_IMPORTED_MODULE_2_shared_constants__["b" /* TEAM_ENTRY */];
        });

        virtualEntries.forEach(function (entry) {
          return entry.virtualEventName = '(' + entry.totalEntries + ') ' + entry.virtualEventName;
        });

        return _extends({}, state, {
          virtualEntries: virtualEntries,
          teamOwnedVirtualEntriesAvailable: teamOwnedVirtualEntriesAvailable,
          loadingVirtualEntries: false
        });
      } else {
        return _extends({}, state, {
          loadingVirtualEntries: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DISPLAY_PURCHASED_ENTRIES */]:
      return _extends({}, state, {
        entries: payload,
        loadingEntries: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* DISPLAY_COUNTRIES_IN_DD_FOR_ENTRY_FORM */]:
      return _extends({}, state, {
        initialCountry: payload[0].value,
        countries: payload
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* DISPLAY_STATES_IN_DD_FOR_ENTRY_FORM */]:
      return _extends({}, state, {
        states: payload
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* DISPLAY_TEAM_OWNED_VIRTUAL_ENTRIES */]:
      {
        var stateParentTeamOwnedVirtualEntries = __WEBPACK_IMPORTED_MODULE_0_clone___default()(state.parentTeamOwnedVirtualEntries);
        var stateChildTeamOwnedVirtualEntries = __WEBPACK_IMPORTED_MODULE_0_clone___default()(state.childTeamOwnedVirtualEntries);
        var stateParentVirtualEntryEvents = __WEBPACK_IMPORTED_MODULE_0_clone___default()(state.parentVirtualEntryEvents);
        var stateChildVirtualEntryEvents = __WEBPACK_IMPORTED_MODULE_0_clone___default()(state.childVirtualEntryEvents);

        var payloadParentTeamOwnedVirtualEntries = payload.data.filter(function (event) {
          return event.childEvent === false && (stateParentTeamOwnedVirtualEntries.length > 0 ? stateParentTeamOwnedVirtualEntries.findIndex(function (x) {
            return x.id === event.id;
          }) < 0 : true);
        });
        var payloadChildTeamOwnedVirtualEntries = payload.data.filter(function (event) {
          return event.childEvent === true && (stateChildTeamOwnedVirtualEntries.length > 0 ? stateChildTeamOwnedVirtualEntries.findIndex(function (x) {
            return x.id == event.id;
          }) < 0 : true);
        });
        var payloadParentVirtualEntryEvents = [];
        var payloadChildVirtualEntryEvents = [];

        payloadParentTeamOwnedVirtualEntries.forEach(function (entry) {
          var existingPayloadEvent = payloadParentVirtualEntryEvents.filter(function (event) {
            return event.name == entry.virtualEventName;
          });
          var existingStateEvent = stateParentVirtualEntryEvents.filter(function (event) {
            return event.name == entry.virtualEventName;
          });

          if (existingPayloadEvent.length == 0 && existingStateEvent.length == 0) {
            payloadParentVirtualEntryEvents.push({ name: entry.virtualEventName, remaining: entry.teamEntryId ? 0 : 1, eventId: entry.eventId });
          } else {
            if (existingPayloadEvent.length > 0) {
              existingPayloadEvent[0].remaining += entry.teamEntryId ? 0 : 1;
            }
            if (existingStateEvent.length > 0) {
              existingStateEvent[0].remaining += entry.teamEntryId ? 0 : 1;
            }
          }
        });

        stateParentTeamOwnedVirtualEntries = stateParentTeamOwnedVirtualEntries.concat(payloadParentTeamOwnedVirtualEntries);

        payloadChildTeamOwnedVirtualEntries.forEach(function (entry) {
          var existingPayloadEvent = payloadChildVirtualEntryEvents.filter(function (event) {
            return event.name == entry.virtualEventName;
          });
          var existingStateEvent = stateChildVirtualEntryEvents.filter(function (event) {
            return event.name == entry.virtualEventName;
          });

          if (existingPayloadEvent.length == 0 && existingStateEvent.length == 0) {
            payloadChildVirtualEntryEvents.push({ name: entry.virtualEventName, remaining: entry.parentTeamEntryId ? 0 : 1, eventId: entry.eventId });
          } else {
            if (existingPayloadEvent.length > 0) {
              existingPayloadEvent[0].remaining += entry.parentTeamEntryId ? 0 : 1;
            }
            if (existingStateEvent.length > 0) {
              existingStateEvent[0].remaining += entry.parentTeamEntryId ? 0 : 1;
            }
          }
        });

        stateChildTeamOwnedVirtualEntries = stateChildTeamOwnedVirtualEntries.concat(payloadChildTeamOwnedVirtualEntries);

        payloadParentVirtualEntryEvents = stateParentVirtualEntryEvents.concat(payloadParentVirtualEntryEvents);
        payloadChildVirtualEntryEvents = stateChildVirtualEntryEvents.concat(payloadChildVirtualEntryEvents);

        return _extends({}, state, {
          parentTeamOwnedVirtualEntries: stateParentTeamOwnedVirtualEntries,
          childTeamOwnedVirtualEntries: stateChildTeamOwnedVirtualEntries,
          parentVirtualEntryEvents: payloadParentVirtualEntryEvents,
          childVirtualEntryEvents: payloadChildVirtualEntryEvents
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["U" /* STORE_TEAM_OWNED_VIRTUAL_ENTRY_MAP */]:
      {
        var teamOwnedVirtualEntryMap = state.teamOwnedVirtualEntryMap.concat(payload);

        return _extends({}, state, {
          teamOwnedVirtualEntryMap: teamOwnedVirtualEntryMap
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* CALCULATE_BALANCE_DUE_FOR_REG_MANAGE */]:
      {
        var entriesBalanceDue = state.entries.filter(function (entry) {
          return entry.selected;
        }).reduce(function (sum, entry) {
          return sum + entry.balanceDue;
        }, 0);
        var virtualEventsBalanceDue = state.virtualEntries.filter(function (virtualEntry) {
          return virtualEntry.selected;
        }).reduce(function (sum, virtualEntry) {
          return sum + virtualEntry.balanceDue;
        }, 0);
        var teamOwnedVirtualEventsBalanceDue = state.teamOwnedVirtualEntriesAvailable.filter(function (teamOwnedVirtualEntry) {
          return teamOwnedVirtualEntry.selected;
        }).reduce(function (sum, teamOwnedVirtualEntry) {
          return sum + teamOwnedVirtualEntry.balanceDue;
        }, 0);

        return _extends({}, state, {
          balanceDue: entriesBalanceDue + virtualEventsBalanceDue + teamOwnedVirtualEventsBalanceDue
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["v" /* SET_ENTRY_STATE_DISABLED_FOR_REG_MANAGE */]:
    case __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* CANCEL_ENTRY_DETAILS_FOR_REG_MANAGE */]:
    case __WEBPACK_IMPORTED_MODULE_1__constants__["i" /* CANCEL_ENTRY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE */]:
    case __WEBPACK_IMPORTED_MODULE_1__constants__["j" /* CANCEL_PURCHASED_ENTRY_FORM */]:
    case __WEBPACK_IMPORTED_MODULE_1__constants__["m" /* DISPLAY_ENTRY_DETAILS_FOR_REG_MANAGE */]:
    case __WEBPACK_IMPORTED_MODULE_1__constants__["V" /* DISPLAY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE_TEAMS */]:
    case __WEBPACK_IMPORTED_MODULE_1__constants__["n" /* DISPLAY_PURCHASED_ENTRY_FORM */]:
    case __WEBPACK_IMPORTED_MODULE_1__constants__["X" /* SET_SELECTED_ENTRY_FOR_REG_MANAGE_ENTRIES */]:
      return _extends({}, state, {
        entries: state.entries.map(function (x) {
          return entryReducer(x, { type: type, payload: payload });
        }),
        cartEntries: state.cartEntries.map(function (x) {
          return cartEntryReducer(x, { type: type, payload: payload });
        }),
        teamOwnedVirtualEntriesAvailable: state.teamOwnedVirtualEntriesAvailable.map(function (x) {
          return virtualEventReducer(x, { type: type, payload: payload });
        })
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["l" /* CANCEL_VIRTUAL_EVENT_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE */]:
    case __WEBPACK_IMPORTED_MODULE_1__constants__["k" /* CLOSE_VIRTUAL_BOWLER_EDITING_FOR_REG_MANAGE */]:
    case __WEBPACK_IMPORTED_MODULE_1__constants__["p" /* DISPLAY_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE */]:
    case __WEBPACK_IMPORTED_MODULE_1__constants__["W" /* DISPLAY_VIRTUAL_EVENT_PAYMENT_LOG_FOR_REG_MANAGE */]:
    case __WEBPACK_IMPORTED_MODULE_1__constants__["A" /* SET_SELECTED_VIRTUAL_EVENT_FOR_REG_MANAGE_ENTRIES */]:
      return _extends({}, state, {
        virtualEntries: state.virtualEntries.map(function (x) {
          return virtualEventReducer(x, { type: type, payload: payload });
        }),
        cartVirtualEntries: state.cartVirtualEntries.map(function (x) {
          return cartVirtualEventReducer(x, { type: type, payload: payload });
        })
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["T" /* ASSIGN_TEAM_OWNED_VIRTUAL_ENTRY */]:
      {
        var newParentTeamOwnedVirtualEntries = state.parentTeamOwnedVirtualEntries.slice();
        var newParentVirtualEntryEvents = state.parentVirtualEntryEvents.slice();
        var newTeamOwnedVirtualEntriesAvailable = state.teamOwnedVirtualEntriesAvailable.slice();
        var assignedVirtualEntryEvent = _extends({}, newParentVirtualEntryEvents.find(function (event) {
          return event.name == payload.virtualEventName;
        }));
        var assignedVirtualEntry = _extends({}, newParentTeamOwnedVirtualEntries.find(function (entry) {
          return entry.virtualEventName == payload.virtualEventName && entry.teamEntryId == null;
        }));
        var assignedTeamOwnedVirtualEntriesAvailable = _extends({}, newTeamOwnedVirtualEntriesAvailable.find(function (event) {
          return event.virtualEventName == payload.virtualEventName;
        }));
        var oneAlreadyAssigned = newParentTeamOwnedVirtualEntries.find(function (entry) {
          return entry.virtualEventName == payload.virtualEventName && entry.teamEntryId == payload.teamEntryId;
        });

        if (payload.value == true && oneAlreadyAssigned) {
          return _extends({}, state, {
            parentTeamOwnedVirtualEntries: newParentTeamOwnedVirtualEntries,
            parentVirtualEntryEvents: newParentVirtualEntryEvents,
            teamOwnedVirtualEntriesAvailable: newTeamOwnedVirtualEntriesAvailable
          });
        }

        if (payload.value == true && assignedVirtualEntry.id != undefined) {
          var existingEntryIndex = newParentTeamOwnedVirtualEntries.findIndex(function (entry) {
            return entry.virtualEventName == payload.virtualEventName && entry.teamEntryId == payload.teamEntryId;
          });
          var _entryIndex = newParentTeamOwnedVirtualEntries.findIndex(function (entry) {
            return entry.virtualEventName == payload.virtualEventName && entry.teamEntryId == null;
          });

          if (existingEntryIndex < 0) {
            assignedVirtualEntry.teamEntryId = payload.teamEntryId;
            newParentTeamOwnedVirtualEntries[_entryIndex] = assignedVirtualEntry;
            assignedVirtualEntryEvent.remaining -= 1;
          }

          assignedVirtualEntryEvent.assigned = true;
        } else {
          var clearedEntries = newParentTeamOwnedVirtualEntries.filter(function (entry) {
            return entry.virtualEventName == payload.virtualEventName && entry.teamEntryId == payload.teamEntryId;
          });

          clearedEntries.forEach(function (entry) {
            return entry.teamEntryId = null;
          });
          assignedVirtualEntryEvent.remaining += clearedEntries.length;
          assignedVirtualEntryEvent.assigned = false;
        }

        assignedTeamOwnedVirtualEntriesAvailable.availableEntries = assignedVirtualEntryEvent.remaining;
        var eventIndex = newParentVirtualEntryEvents.findIndex(function (event) {
          return event.name == payload.virtualEventName;
        });
        var entryIndex = newTeamOwnedVirtualEntriesAvailable.findIndex(function (entry) {
          return entry.virtualEventName == payload.virtualEventName;
        });

        newParentVirtualEntryEvents[eventIndex] = assignedVirtualEntryEvent;
        newTeamOwnedVirtualEntriesAvailable[entryIndex] = assignedTeamOwnedVirtualEntriesAvailable;

        return _extends({}, state, {
          parentTeamOwnedVirtualEntries: newParentTeamOwnedVirtualEntries,
          parentVirtualEntryEvents: newParentVirtualEntryEvents,
          teamOwnedVirtualEntriesAvailable: newTeamOwnedVirtualEntriesAvailable
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["_9" /* UPDATE_CART_ENTRY_FOR_PARENT_TEAM_OWNED_VIRTUAL_ENTRY */]:
      {
        var cartEntries = state.cartEntries;
        var editingCartEntry = cartEntries.find(function (cartEntry) {
          return cartEntry.editing;
        });
        var virtualEntry = state.parentTeamOwnedVirtualEntries.find(function (virtualEntry) {
          return virtualEntry.virtualEventName === payload.virtualEventName;
        });

        if (payload.value == true) {
          if (editingCartEntry.parentVirtualEntryAssignments && editingCartEntry.parentVirtualEntryAssignments.findIndex(function (x) {
            return x.virtualEventName === payload.virtualEventName;
          }) < 0) {
            editingCartEntry.parentVirtualEntryAssignments.push({ virtualEventId: virtualEntry.virtualEventId, virtualEventName: virtualEntry.virtualEventName });
          } else {
            editingCartEntry.parentVirtualEntryAssignments = [{ virtualEventId: virtualEntry.virtualEventId, virtualEventName: virtualEntry.virtualEventName }];
          }
        } else {
          var assignment = editingCartEntry.parentVirtualEntryAssignments.findIndex(function (x) {
            return x.virtualEventId == virtualEntry.virtualEventId;
          });

          editingCartEntry.parentVirtualEntryAssignments.splice(assignment, 1);
        }

        return _extends({}, state, {
          cartEntries: cartEntries
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["_10" /* UPDATE_CART_ENTRY_FOR_CHILD_TEAM_OWNED_VIRTUAL_ENTRY */]:
      {
        var _cartEntries = state.cartEntries;
        var _editingCartEntry = _cartEntries.find(function (cartEntry) {
          return cartEntry.editing;
        });
        var _virtualEntry = state.childTeamOwnedVirtualEntries.find(function (virtualEntry) {
          return virtualEntry.virtualEventName === payload.virtualEventName;
        });

        if (payload.value == true) {
          if (_editingCartEntry.childVirtualEntryAssignments && _editingCartEntry.childVirtualEntryAssignments.findIndex(function (x) {
            return x.virtualEventName === payload.virtualEventName && x.rosterPosition == payload.rosterPosition;
          }) < 0) {
            _editingCartEntry.childVirtualEntryAssignments.push({ virtualEventId: _virtualEntry.virtualEventId, virtualEventName: _virtualEntry.virtualEventName, rosterPosition: payload.rosterPosition });
          } else {
            _editingCartEntry.childVirtualEntryAssignments = [{ virtualEventId: _virtualEntry.virtualEventId, virtualEventName: _virtualEntry.virtualEventName, rosterPosition: payload.rosterPosition }];
          }
        } else {
          var _assignment = _editingCartEntry.childVirtualEntryAssignments.findIndex(function (x) {
            return x.virtualEventId == _virtualEntry.virtualEventId && x.rosterPosition == payload.rosterPosition;
          });

          _editingCartEntry.childVirtualEntryAssignments.splice(_assignment, 1);
        }

        return _extends({}, state, {
          cartEntries: _cartEntries
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["S" /* ASSIGN_CHILD_TEAM_OWNED_VIRTUAL_ENTRY */]:
      {
        var newChildTeamOwnedVirtualEntries = state.childTeamOwnedVirtualEntries.slice();
        var newChildVirtualEntryEvents = state.childVirtualEntryEvents.slice();
        var _newTeamOwnedVirtualEntriesAvailable = state.teamOwnedVirtualEntriesAvailable.slice();
        var _assignedVirtualEntryEvent = _extends({}, newChildVirtualEntryEvents.find(function (event) {
          return event.name == payload.virtualEventName;
        })); // REG-3345 && event.rosterPosition == payload.rosterPosition)};
        var _assignedVirtualEntry = _extends({}, newChildTeamOwnedVirtualEntries.find(function (entry) {
          return entry.virtualEventName == payload.virtualEventName && entry.parentTeamEntryId == null;
        }));
        var _assignedTeamOwnedVirtualEntriesAvailable = _extends({}, _newTeamOwnedVirtualEntriesAvailable.find(function (event) {
          return event.virtualEventName == payload.virtualEventName;
        }));
        var _oneAlreadyAssigned = newChildTeamOwnedVirtualEntries.find(function (entry) {
          return entry.virtualEventName == payload.virtualEventName && entry.parentTeamEntryId == payload.parentTeamEntryId && entry.rosterPosition == payload.rosterPosition;
        });

        if (payload.value == true && _oneAlreadyAssigned) {
          return _extends({}, state, {
            childTeamOwnedVirtualEntries: newChildTeamOwnedVirtualEntries,
            childVirtualEntryEvents: newChildVirtualEntryEvents,
            teamOwnedVirtualEntriesAvailable: _newTeamOwnedVirtualEntriesAvailable
          });
        }
        if (payload.value == true && _assignedVirtualEntry.id != undefined) {
          var _existingEntryIndex = newChildTeamOwnedVirtualEntries.findIndex(function (entry) {
            return entry.virtualEventName == payload.virtualEventName && entry.parentTeamEntryId == payload.parentTeamEntryId && entry.rosterPosition == payload.rosterPosition;
          });
          var _entryIndex3 = newChildTeamOwnedVirtualEntries.findIndex(function (entry) {
            return entry.virtualEventName == payload.virtualEventName && entry.parentTeamEntryId == null;
          });

          if (_existingEntryIndex < 0) {
            _assignedVirtualEntry.parentTeamEntryId = payload.parentTeamEntryId;
            _assignedVirtualEntry.rosterPosition = payload.rosterPosition;
            newChildTeamOwnedVirtualEntries[_entryIndex3] = _assignedVirtualEntry;

            _assignedVirtualEntryEvent.remaining -= 1;
            // fix remaining count for all other child entries as well
            newChildVirtualEntryEvents.filter(function (event) {
              return event.name == payload.virtualEventName;
            }).forEach(function (event) {
              return event.remaining -= 1;
            });
          }
          _assignedVirtualEntryEvent.assigned = true;
        } else {
          var _clearedEntries = newChildTeamOwnedVirtualEntries.filter(function (entry) {
            return entry.virtualEventName == payload.virtualEventName && entry.parentTeamEntryId == payload.parentTeamEntryId && entry.rosterPosition == payload.rosterPosition;
          });

          _clearedEntries.forEach(function (entry) {
            entry.teamEntryId = null;
            entry.parentTeamEntryId = null;
            entry.rosterPosition = null;
          });

          _assignedVirtualEntryEvent.remaining += _clearedEntries.length;
          // fix remaining count for all other child entries as well
          newChildVirtualEntryEvents.filter(function (event) {
            return event.name == payload.virtualEventName;
          }).forEach(function (event) {
            return event.remaining += _clearedEntries.length;
          });
          _assignedVirtualEntryEvent.assigned = false;
        }

        _assignedTeamOwnedVirtualEntriesAvailable.availableEntries = _assignedVirtualEntryEvent.remaining;
        var _eventIndex = newChildVirtualEntryEvents.findIndex(function (event) {
          return event.name == payload.virtualEventName && event.rosterPosition == payload.rosterPosition;
        });
        var _entryIndex2 = _newTeamOwnedVirtualEntriesAvailable.findIndex(function (entry) {
          return entry.virtualEventName == payload.virtualEventName;
        });

        newChildVirtualEntryEvents[_eventIndex] = _assignedVirtualEntryEvent;
        _newTeamOwnedVirtualEntriesAvailable[_entryIndex2] = _assignedTeamOwnedVirtualEntriesAvailable;

        return _extends({}, state, {
          childTeamOwnedVirtualEntries: newChildTeamOwnedVirtualEntries,
          childVirtualEntryEvents: newChildVirtualEntryEvents,
          teamOwnedVirtualEntriesAvailable: _newTeamOwnedVirtualEntriesAvailable
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["w" /* SET_REMOVE_VIRTUAL_ENTRY_CONFIRMATION_FOR_ROSTER_CHECKOUT */]:
      return _extends({}, state, {
        virtualEntryToRemove: payload.visible ? { name: payload.virtualEventName, childOrParent: payload.childOrParent, quantity: payload.quantity } : {},
        removeVirtualEntryConfirmationVisible: payload.visible || initialState.removeVirtualEntryConfirmationVisible
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["x" /* SET_ROSTER_CONFIRMATION_VISIBILITY_FOR_MANAGE_ENTRIES */]:
      return _extends({}, state, {
        rosterConfirmationVisible: payload.visible || initialState.rosterConfirmationVisible,
        rosterConfirmationNextAction: payload.nextAction || initialState.rosterConfirmationNextAction,
        rosterConfirmationNextActionArgs: payload.args || initialState.args
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["u" /* SET_ENTRY_DETAILS_IN_STATE_FOR_REG_MANAGE */]:
      return _extends({}, state, {
        entryDetails: payload || initialState.entryDetails
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["C" /* VIRTUAL_ENTRY_SUBMITTING_STARTS_FOR_REG_MANAGE */]:
      return _extends({}, state, {
        submittingVirtualBowlers: true
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["F" /* SET_BOWLER_FOR_CART_VIRTUAL_ENTRY_ALREADY_ASSIGNED_FOR_REG_MANAGE */]:
      return _extends({}, state, {
        assignedByOtherCaptain: payload
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["B" /* VIRTUAL_ENTRY_SUBMITTING_FINISHED_FOR_REG_MANAGE */]:
      return _extends({}, state, {
        submittingVirtualBowlers: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["s" /* SET_AVAILABLE_BOWLERS_IN_STATE_FOR_REG_MANAGE */]:
      {
        if (payload) {
          var filteredCartBowlers = state.cartBowlers ? state.cartBowlers.filter(function (bowler) {
            return payload.findIndex(function (p) {
              return p.memberId == bowler.memberId;
            }) == -1;
          }) : [];
          var uniqueBowlers = filteredCartBowlers.filter(function (element, index, object) {
            return object.map(function (e) {
              return e.id;
            }).indexOf(element.id) === index;
          });
          var bowlers = payload.concat(uniqueBowlers).sort(bowlerCompare);

          return _extends({}, state, {
            bowlers: bowlers
          });
        } else {
          return state;
        }
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["t" /* SET_AVAILABLE_BOWLERS_IN_STATE_FOR_REG_MANAGE_FOR_VIRTUAL_ENTRIES */]:
      {
        if (payload) {
          var _filteredCartBowlers = state.cartBowlers ? state.cartBowlers.filter(function (bowler) {
            return payload.findIndex(function (p) {
              return p.memberId == bowler.memberId;
            }) == -1;
          }) : [];
          var _uniqueBowlers = _filteredCartBowlers.filter(function (element, index, object) {
            return object.map(function (e) {
              return e.id;
            }).indexOf(element.id) === index;
          });
          var unassignedBowlers = payload.filter(function (x) {
            return !x.assignedByOtherCaptain;
          });
          var _bowlers = unassignedBowlers.concat(_uniqueBowlers).sort(bowlerCompare);

          return _extends({}, state, {
            bowlers: _bowlers
          });
        } else {
          return state;
        }
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["y" /* SET_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE */]:
      return payload ? _extends({}, state, {
        virtualBowlers: payload
      }) : state;
    case __WEBPACK_IMPORTED_MODULE_1__constants__["z" /* SET_CART_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE */]:
      return payload ? _extends({}, state, {
        cartVirtualBowlers: payload
      }) : state;
    case __WEBPACK_IMPORTED_MODULE_1__constants__["o" /* DISPLAY_ROSTER_POSITIONS_FOR_REG_MANAGE_PURCHASES */]:
      return _extends({}, state, {
        rosterPositions: payload
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["I" /* MOVE_POSITION_DOWN_FOR_REG_ROSTERS */]:
      {
        var currentPosition = payload;

        if (typeof currentPosition === 'undefined' || currentPosition >= state.rosterPositions.length) {
          return state; // do nothing if last in array
        }

        var rosters = [].concat(_toConsumableArray(state.rosterPositions));
        var tmp = rosters[currentPosition];

        // swap positions with correct position
        rosters[currentPosition] = _extends({}, rosters[currentPosition + 1], {
          position: rosters[currentPosition + 1].position - 1
        });
        rosters[currentPosition + 1] = _extends({}, tmp, {
          position: tmp.position + 1
        });
        return _extends({}, state, {
          rosterPositions: rosters
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["J" /* MOVE_POSITION_UP_FOR_REG_ROSTER */]:
      {
        var _currentPosition = payload;

        if (typeof _currentPosition === 'undefined' || _currentPosition <= 0) {
          return state; // do nothing if first in array
        }

        var _rosters = [].concat(_toConsumableArray(state.rosterPositions));
        var _tmp = _rosters[_currentPosition];

        // swap positions with correct position number
        _rosters[_currentPosition] = _extends({}, _rosters[_currentPosition - 1], {
          position: _rosters[_currentPosition - 1].position + 1
        });
        _rosters[_currentPosition - 1] = _extends({}, _tmp, {
          position: _tmp.position - 1
        });
        return _extends({}, state, {
          rosterPositions: _rosters
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["L" /* SET_IS_PROFESSIONAL_FOR_REG_ROSTER */]:
      {
        var rosterPositions = state.rosterPositions.map(function (item) {
          if (item.position === payload.position) {
            item.bowler = _extends({}, item.bowler, { isProfessional: Boolean(payload.value) });
            return item;
          } else {
            return item;
          }
        });

        return _extends({}, state, { rosterPositions: rosterPositions });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["M" /* UPDATE_ROSTER_INFO */]:
      {
        state.rosterPositions.forEach(function (entry) {
          if (entry.position === payload.position) {
            Object.assign(entry, payload, { _retrieved: !payload._errorMessage });
            if (!payload._errorMessage) {
              entry._searchChanged = false;
            }

            var _editingCartEntry2 = state.cartEntries.find(function (cartEntry) {
              return cartEntry.editing;
            });
            var editingEntry = state.entries.find(function (entry) {
              return entry.editing;
            });
            var editingEventId = _editingCartEntry2 ? _editingCartEntry2.eventId : editingEntry.eventId;

            if (state.cartBowlers.find(function (x) {
              return x.memberId === payload.usbcId && x.eventId === editingEventId;
            })) {
              if (!payload._errorMessage) {
                entry.bowler.isOnOtherRosters = true;
              }
            }

            return;
          }
        });
        return _extends({}, state, {
          rosterPositions: [].concat(_toConsumableArray(state.rosterPositions))
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["K" /* REINSERT_MANAGED_ROSTER_IDS_INTO_CART */]:
      {
        var newCartEntries = state.cartEntries.slice();

        payload.forEach(function (rosterEntry) {
          if (rosterEntry && rosterEntry.cartRosterId && rosterEntry.cartRosterId.length == 36) {
            var rosterItem = newCartEntries.find(function (entry) {
              return entry.eventId == rosterEntry.eventId && entry.squadId == rosterEntry.squadId && entry.cartRosterId.length < 36;
            });

            if (rosterItem) {
              rosterItem.cartRosterId = rosterEntry.cartRosterId;
              rosterItem.name = rosterEntry.name;
              rosterItem.rosterComplete = rosterEntry.rosterComplete;
            }
          }
        });
        return _extends({}, state, {
          cartEntries: newCartEntries
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["P" /* SET_MEMBER_SEARCH_FIELD */]:
      {
        state.rosterPositions.forEach(function (entry) {
          if (entry.position === payload.position) {
            entry._searchValue = payload._searchValue;
            entry._searchChanged = true;
            entry.usbcIdError = false;
            return;
          }
        });
        return _extends({}, state, {
          rosterPositions: [].concat(_toConsumableArray(state.rosterPositions))
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["N" /* SEARCHING_MEMBER_STARTS */]:
      {
        state.rosterPositions.forEach(function (entry) {
          entry._processing = entry.position === payload.position;
        });
        return _extends({}, state, {
          rosterPositions: [].concat(_toConsumableArray(state.rosterPositions))
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["O" /* SEARCHING_MEMBER_FINISHED */]:
      {
        state.rosterPositions.forEach(function (entry) {
          entry._processing = false;
          entry.usbcIdError = false;
        });
        return _extends({}, state, {
          rosterPositions: [].concat(_toConsumableArray(state.rosterPositions))
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["Q" /* SET_MEMBER_AVG_FIELD */]:
      {
        state.rosterPositions.forEach(function (entry) {
          if (entry.position === payload.position) {
            entry.bowler.average = payload.value;
            return;
          }
        });
        return _extends({}, state, {
          rosterPositions: [].concat(_toConsumableArray(state.rosterPositions))
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["R" /* CLEAR_POSITION_FOR_REG_ROSTERS */]:
      {
        var rosterPosition = state.rosterPositions[payload];
        var memberId = rosterPosition.bowler ? rosterPosition.bowler.usbcId : null;
        var bowlerId = rosterPosition.bowler ? rosterPosition.bowler.id : null;
        var _rosterPositions = __WEBPACK_IMPORTED_MODULE_0_clone___default()(state.rosterPositions);

        _rosterPositions[payload] = _extends({}, _rosterPositions[payload], __WEBPACK_IMPORTED_MODULE_3__dataModel__["a" /* blankRosterPosition */], {
          averageRequired: _rosterPositions[payload].averageRequired,
          _errorMessage: null
        });

        var bowlerIndex = state.cartBowlers.findIndex(function (b) {
          return b.memberId === memberId;
        });
        var _bowlers2 = __WEBPACK_IMPORTED_MODULE_0_clone___default()(state.cartBowlers);

        _bowlers2.splice(bowlerIndex, 1);

        var virtualBowlers = __WEBPACK_IMPORTED_MODULE_0_clone___default()(state.virtualBowlers);

        if (virtualBowlers.length > 0) {
          var virtualBowlerIndex = virtualBowlers.findIndex(function (b) {
            return b.bowlerId === bowlerId;
          });

          if (virtualBowlerIndex >= 0) {
            virtualBowlers[virtualBowlerIndex].bowlerId = '';
          }
        }

        return _extends({}, state, {
          rosterPositions: _rosterPositions,
          cartBowlers: _bowlers2,
          virtualBowlers: virtualBowlers
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["D" /* SET_BOWLER_FOR_VIRTUAL_ENTRY_FOR_REG_MANAGE */]:
      return _extends({}, state, {
        virtualBowlers: state.virtualBowlers.map(function (x) {
          return virtualBowlerReducer(x, { type: type, payload: payload });
        })
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["E" /* SET_BOWLER_FOR_CART_VIRTUAL_ENTRY_FOR_REG_MANAGE */]:
      return _extends({}, state, {
        cartVirtualBowlers: state.cartVirtualBowlers.map(function (x) {
          return virtualBowlerReducer(x, { type: type, payload: payload });
        }),
        virtualBowlers: state.virtualBowlers.map(function (x) {
          return virtualBowlerReducer(x, { type: type, payload: payload });
        })
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["q" /* REMOVE_UNASSIGNED_CHILD_VIRTUAL_ENTRIES_ROSTER_CHECKOUT */]:
      {
        var childTeamOwnedVirtualEntries = state.childTeamOwnedVirtualEntries.filter(function (x) {
          return x.virtualEventName !== payload.virtualEventName || x.virtualEventName === payload.virtualEventName && x.parentTeamEntryId !== null;
        });
        var removeAll = state.childTeamOwnedVirtualEntries.filter(function (x) {
          return x.virtualEventName === payload.virtualEventName;
        }).every(function (x) {
          return x.parentTeamEntryId == null;
        });
        var childVirtualEntryEvents = state.childVirtualEntryEvents.slice();

        if (removeAll) {
          childVirtualEntryEvents = childVirtualEntryEvents.filter(function (x) {
            return x.name !== payload.virtualEventName;
          });
        } else {
          childVirtualEntryEvents.forEach(function (event) {
            if (event.name === payload.virtualEventName) {
              event.remaining = childTeamOwnedVirtualEntries.filter(function (x) {
                return x.virtualEventName === payload.virtualEventNAme && x.parentTeamEntryId == null;
              }).length;
            }
          });
        }

        return _extends({}, state, {
          childTeamOwnedVirtualEntries: childTeamOwnedVirtualEntries,
          childVirtualEntryEvents: childVirtualEntryEvents
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["r" /* REMOVE_UNASSIGNED_PARENT_VIRTUAL_ENTRIES_ROSTER_CHECKOUT */]:
      {
        var parentTeamOwnedVirtualEntries = state.parentTeamOwnedVirtualEntries.filter(function (x) {
          return x.virtualEventName !== payload.virtualEventName || x.virtualEventName === payload.virtualEventName && x.teamEntryId !== null;
        });
        var _removeAll = state.parentTeamOwnedVirtualEntries.filter(function (x) {
          return x.virtualEventName === payload.virtualEventName;
        }).every(function (x) {
          return x.teamEntryId == null;
        });
        var parentVirtualEntryEvents = state.parentVirtualEntryEvents.slice();

        if (_removeAll) {
          var index = parentVirtualEntryEvents.findIndex(function (x) {
            return x.name === payload.virtualEventName;
          });

          parentVirtualEntryEvents.splice(index, 1);
        } else {
          parentVirtualEntryEvents.forEach(function (event) {
            if (event.name === payload.virtualEventName) {
              event.remaining = parentTeamOwnedVirtualEntries.filter(function (x) {
                return x.virtualEventName === payload.virtualEventName && x.teamEntryId == null;
              }).length;
            }
          });
        }

        return _extends({}, state, {
          parentTeamOwnedVirtualEntries: parentTeamOwnedVirtualEntries,
          parentVirtualEntryEvents: parentVirtualEntryEvents
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["G" /* REMOVE_VIRTUAL_ENTRY_BOWLER_FROM_CART */]:
      {
        var cartVirtualEntry = state.cartVirtualEntries.find(function (x) {
          return x.editing;
        });
        var cartVirtualBowlers = state.cartVirtualBowlers.filter(function (x) {
          return x.id != payload.bowlerId;
        });

        if (cartVirtualEntry.availableEntries > 0) {
          state.cartVirtualEntries.find(function (x) {
            return x.editing;
          }).availableEntries--;
        }
        if (cartVirtualEntry.totalEntries > 0) {
          state.cartVirtualEntries.find(function (x) {
            return x.editing;
          }).totalEntries--;
        }

        return _extends({}, state, {
          cartVirtualBowlers: cartVirtualBowlers
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["H" /* UPDATE_VIRTUAL_AVAILABLE_ENTRY_FROM_CART */]:
      {
        var _cartVirtualEntry = state.cartVirtualEntries.find(function (x) {
          return x.cartRosterId == payload.cartRosterId && x.virtualEventId == payload.virtualEventId;
        });

        if (_cartVirtualEntry.totalEntries === payload.virtualEntryQuantity) {
          _cartVirtualEntry.availableEntries = payload.virtualEntryQuantity - state.cartVirtualBowlers.filter(function (x) {
            return x.bowlerId;
          }).length;
        } else {
          _cartVirtualEntry.totalEntries = payload.virtualEntryQuantity;
          _cartVirtualEntry.availableEntries = payload.virtualEntryQuantity - state.cartVirtualBowlers.filter(function (x) {
            return x.bowlerId;
          }).length;
        }

        return _extends({}, state);
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["Z" /* CONVERT_ENTRIES_FROM_CART */]:
      {
        var entries = [];
        var entryNum = 0;
        var timeInMs = new Date().getTime();

        payload.squads.forEach(function (squad) {
          for (var i = 0; i < squad.quantity; i++) {
            var event = payload.events.find(function (e) {
              return e.id == squad.eventId;
            });
            var entry = {};

            entryNum++;

            entry.id = squad.id + '-' + entryNum;
            entry.name = 'Entry #' + entryNum;
            entry.eventId = squad.eventId;
            entry.eventName = squad.eventName;
            entry.entryNumber = '';
            entry.eventIsLinked = squad.eventIsLinked;
            entry.eventNumberOfBowlers = squad.eventNumberOfBowlers;
            entry.linkedEventName = '';
            entry.squadDateTime = squad.startDateTime;
            entry.squadId = squad.id;
            entry.timeZoneDisplayName = 'CT';
            entry.balanceDue = squad.eventPrice;
            entry.tournamentId = '';
            entry.rosterComplete = false;
            entry.isCancelled = false;
            entry.selected = false;
            entry.cartRosterId = '' + timeInMs + entryNum;
            entry.averageBased = event.averageBased;

            entries.push(entry);
          }
        });

        return _extends({}, state, {
          cartEntries: entries
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["_0" /* CONVERT_VIRTUAL_ENTRIES_FROM_CART */]:
      {
        var newVirtualEntries = [];
        var _timeInMs = new Date().getTime();

        newVirtualEntries = payload.filter(function (virtualEvent) {
          return !virtualEvent.eventId;
        }).map(function (virtualEvent) {
          return {
            virtualEventId: virtualEvent.id,
            virtualEventName: virtualEvent.name,
            balanceDue: 0,
            rosterComplete: false,
            owner: "Bowler",
            totalEntries: virtualEvent.quantity,
            availableEntries: virtualEvent.quantity,
            selected: false,
            showPaymentLog: false,
            editing: false,
            cartRosterId: virtualEvent.cartRosterId
          };
        });

        newVirtualEntries.forEach(function (virtualEvent, index) {
          if (!virtualEvent.cartRosterId) {
            virtualEvent.cartRosterId = '' + _timeInMs + index;
          }
        });

        return _extends({}, state, {
          cartVirtualEntries: newVirtualEntries
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["Y" /* CREATE_CART_ROSTER_POSITIONS */]:
      {
        var _rosterPositions2 = [];

        for (var i = 0; i < payload.eventNumberOfBowlers; i++) {
          _rosterPositions2.push({
            position: i + 1,
            averageRequired: payload.averageBased,
            bowler: {},
            _searchValue: "",
            _processing: false,
            _retrieved: false
          });
        }
        return _extends({}, state, {
          rosterPositions: _rosterPositions2
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["_1" /* SET_CURRENT_ROSTER_CART_ID */]:
      {
        var _newCartEntries = state.cartEntries.slice();
        var newCartVirtualEntries = state.cartVirtualEntries.slice();
        var _editingCartEntry3 = _newCartEntries.find(function (cartEntry) {
          return cartEntry.cartRosterId == payload.oldId;
        });

        if (!_editingCartEntry3) {
          _editingCartEntry3 = newCartVirtualEntries.find(function (cartEntry) {
            return cartEntry.cartRosterId == payload.oldId;
          });
        }

        _editingCartEntry3.cartRosterId = payload.newId;

        return _extends({}, state, {
          cartEntries: _newCartEntries,
          cartVirtualEntries: newCartVirtualEntries
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["_12" /* SET_CART_ROSTER_ON_EDITING_ENTRY */]:
      {
        var sharedEntries = state.entries.slice();
        var _editingCartEntry4 = sharedEntries.find(function (x) {
          return x.editing;
        });

        _editingCartEntry4.cartRosterId = payload.cartRosterId;

        return _extends({}, state, {
          entries: sharedEntries
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["_13" /* SET_CART_ROSTER_ID_FOR_VIRTUAL_EVENT_IN_CART */]:
      {
        var virtualEventsInCart = payload.virtualEvents;
        var virtualEventToBeUpdated = virtualEventsInCart.find(function (cartVirtualEvent) {
          return cartVirtualEvent.id === payload.virtualEventId;
        });

        virtualEventToBeUpdated.cartRosterId = payload.cartRosterId;

        return _extends({}, state, {
          cartVirtualEvents: virtualEventsInCart
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["_14" /* SET_CART_ROSTER_ON_CART_VIRTUAL_ENTRIES */]:
      {
        var assignedVirtualEntries = payload.assignedVirtualEntries;
        var cartRosterId = payload.cartRosterId;
        var currentParentTeamOwnedVirtualEntries = state.parentTeamOwnedVirtualEntries;
        var currentChildTeamOwnedVirtualEntries = state.childTeamOwnedVirtualEntries;

        assignedVirtualEntries.forEach(function (assignedVirtualEntry) {
          var parentIndex = currentParentTeamOwnedVirtualEntries.findIndex(function (x) {
            return x.id === assignedVirtualEntry.id;
          });
          var childIndex = currentChildTeamOwnedVirtualEntries.findIndex(function (x) {
            return x.id === assignedVirtualEntry.id;
          });

          if (parentIndex >= 0) {
            currentParentTeamOwnedVirtualEntries[parentIndex].cartRosterId = cartRosterId;
          }

          if (childIndex >= 0) {
            currentChildTeamOwnedVirtualEntries[childIndex].cartRosterId = cartRosterId;
          }
        });

        return _extends({}, state, {
          parentTeamOwnedVirtualEntries: currentParentTeamOwnedVirtualEntries,
          childTeamOwnedVirtualEntries: currentChildTeamOwnedVirtualEntries
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["_2" /* SET_CURRENT_ROSTER_CART_COMPLETE */]:
      {
        var _newCartEntries2 = state.cartEntries.slice();
        var _editingCartEntry5 = _newCartEntries2.find(function (cartEntry) {
          return cartEntry.editing;
        });

        _editingCartEntry5.rosterComplete = state.rosterPositions.every(function (rosterPosition) {
          return rosterPosition.bowler && rosterPosition.bowler.usbcId;
        });
        _editingCartEntry5.editing = false;
        _editingCartEntry5.name = payload.name;
        _editingCartEntry5.divisionName = payload.divisionName;

        return _extends({}, state, {
          cartEntries: _newCartEntries2
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["_3" /* SET_CART_ROSTERS_COMPLETE */]:
      {
        var _newCartEntries3 = state.cartEntries.slice();
        var _editingCartEntry6 = _newCartEntries3.find(function (cartEntry) {
          return cartEntry.cartRosterId === payload.cartRosterId;
        });

        if (payload.cartRoster) {
          var rosterData = JSON.parse(payload.cartRoster.rosterData);

          _editingCartEntry6.divisionName = rosterData.divisionName;
          _editingCartEntry6.rosterComplete = rosterData.rosterPositions.every(function (rosterPosition) {
            return rosterPosition.bowler && rosterPosition.bowler.usbcId;
          });
        } else {
          _editingCartEntry6.rosterComplete = false;
        }
        return _extends({}, state, {
          cartEntries: _newCartEntries3
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["_5" /* SET_CART_ROSTER */]:
      {
        var _newCartEntries4 = state.cartEntries.slice();
        var _editingCartEntry7 = _newCartEntries4.find(function (cartEntry) {
          return cartEntry.editing;
        });
        var _rosterPositions3 = [];

        if (payload) {
          var _rosterData = JSON.parse(payload.rosterData);

          if (_editingCartEntry7) {
            _editingCartEntry7.name = _rosterData.name;
            _editingCartEntry7.divisionName = _rosterData.divisionName;
            _rosterPositions3 = _rosterData.rosterPositions;
          }
        }

        return _extends({}, state, {
          cartEntries: _newCartEntries4,
          rosterPositions: _rosterPositions3
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["_6" /* SET_CART_BOWLERS_FOR_CART_ROSTER_ID */]:
      {
        var newCartBowlers = state.cartBowlers.filter(function (cartBowler) {
          return cartBowler.cartRosterId != payload.cartRosterId;
        });

        newCartBowlers = newCartBowlers.concat(payload.cartBowlers);

        return _extends({}, state, {
          cartBowlers: newCartBowlers
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["_15" /* CLEAR_CART_BOWLERS */]:
      {
        return _extends({}, state, {
          cartBowlers: []
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["_7" /* CLEAR_CART_ITEMS */]:
      return _extends({}, state, {
        cartEntries: [],
        cartVirtualEntries: [],
        cartVirtualBowlers: [],
        rosterPositions: [],
        parentTeamOwnedVirtualEntries: [],
        childTeamOwnedVirtualEntries: [],
        parentVirtualEntryEvents: [],
        childVirtualEntryEvents: []
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["_11" /* RESET_TEAM_OWNED_VIRTUAL_ENTRY_EVENT_ASSIGNMENT */]:
      {
        var _newParentVirtualEntryEvents = state.parentVirtualEntryEvents.slice();
        var _newChildVirtualEntryEvents = state.childVirtualEntryEvents.slice();

        _newParentVirtualEntryEvents.forEach(function (item) {
          item.assigned = false;
        });
        _newChildVirtualEntryEvents.forEach(function (item) {
          item.assigned = false;
        });

        return _extends({}, state, {
          parentVirtualEntryEvents: _newParentVirtualEntryEvents,
          childVirtualEntryEvents: _newChildVirtualEntryEvents
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["_8" /* REMOVE_CART_ENTRY */]:
      return _extends({}, state, {
        cartEntries: state.cartEntries.filter(function (entry) {
          return entry.cartRosterId != payload;
        })
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["_4" /* SET_VIRTUAL_ENTRY_ROSTER_COMPLETE */]:
      {
        var _newCartVirtualEntries = state.cartVirtualEntries.slice();
        var editingCartVirtualEntry = _newCartVirtualEntries.find(function (cartVirtualEntry) {
          return cartVirtualEntry.cartRosterId === payload.cartRosterId;
        });

        if (payload.cartRoster !== null) {
          var _rosterData2 = JSON.parse(payload.cartRoster.rosterData);

          editingCartVirtualEntry.divisionName = _rosterData2.divisionName;
          editingCartVirtualEntry.availableEntries = _rosterData2.virtualEntries.filter(function (rosterPosition) {
            return !rosterPosition.bowlerId;
          }).length;
          editingCartVirtualEntry.rosterComplete = editingCartVirtualEntry.availableEntries === 0;
        } else {
          editingCartVirtualEntry.availableEntries = 0;
          editingCartVirtualEntry.rosterComplete = true;
        }

        return _extends({}, state, {
          cartVirtualEntries: _newCartVirtualEntries
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__constants__["_16" /* CLEAR_SHARED */]:
      return initialState;
    case __WEBPACK_IMPORTED_MODULE_1__constants__["_17" /* CLEAR_PURCHASED_TEAM_OWNED_VIRTUAL_ENTRIES */]:
      {
        var _newParentTeamOwnedVirtualEntries = state.parentTeamOwnedVirtualEntries.filter(function (entry) {
          return entry.isPurchased === false;
        });
        var _newParentVirtualEntryEvents2 = state.parentVirtualEntryEvents.slice();

        _newParentVirtualEntryEvents2.forEach(function (event) {
          event.remaining = _newParentTeamOwnedVirtualEntries.filter(function (x) {
            return x.virtualEventName === event.name && x.teamEntryId == null;
          }).length;
        });

        return _extends({}, state, {
          parentTeamOwnedVirtualEntries: _newParentTeamOwnedVirtualEntries,
          parentVirtualEntryEvents: _newParentVirtualEntryEvents2
        });
      }
    default:
      return state;
  }
};

var entryReducer = function entryReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_1__constants__["v" /* SET_ENTRY_STATE_DISABLED_FOR_REG_MANAGE */]:
      return state.id === payload.entryId ? _extends({}, state, {
        disableState: payload.disabled || false
      }) : state;
    case __WEBPACK_IMPORTED_MODULE_1__constants__["X" /* SET_SELECTED_ENTRY_FOR_REG_MANAGE_ENTRIES */]:
      return state.id === payload ? _extends({}, state, {
        selected: !state.selected
      }) : state;
    case __WEBPACK_IMPORTED_MODULE_1__constants__["j" /* CANCEL_PURCHASED_ENTRY_FORM */]:
      return _extends({}, state, {
        editing: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["n" /* DISPLAY_PURCHASED_ENTRY_FORM */]:
      return _extends({}, state, {
        editing: state.id === payload ? !state.editing : false
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* CANCEL_ENTRY_DETAILS_FOR_REG_MANAGE */]:
      return _extends({}, state, {
        showEntryDetails: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["m" /* DISPLAY_ENTRY_DETAILS_FOR_REG_MANAGE */]:
      return _extends({}, state, {
        showEntryDetails: state.id === payload ? !state.showEntryDetails : false
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["V" /* DISPLAY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE_TEAMS */]:
      return _extends({}, state, {
        showPaymentLog: state.id === payload ? !state.showPaymentLog : false
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["i" /* CANCEL_ENTRY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE */]:
      return _extends({}, state, {
        showPaymentLog: false
      });
    default:
      return state;
  }
};

var virtualEventReducer = function virtualEventReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref3 = arguments[1];
  var type = _ref3.type,
      payload = _ref3.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_1__constants__["l" /* CANCEL_VIRTUAL_EVENT_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE */]:
      return _extends({}, state, {
        showPaymentLog: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["A" /* SET_SELECTED_VIRTUAL_EVENT_FOR_REG_MANAGE_ENTRIES */]:
      return state.virtualEventId === payload ? _extends({}, state, {
        selected: !state.selected
      }) : state;
    case __WEBPACK_IMPORTED_MODULE_1__constants__["W" /* DISPLAY_VIRTUAL_EVENT_PAYMENT_LOG_FOR_REG_MANAGE */]:
      return _extends({}, state, {
        showPaymentLog: state.virtualEventId === payload ? !state.showPaymentLog : false
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["X" /* SET_SELECTED_ENTRY_FOR_REG_MANAGE_ENTRIES */]:
      return state.virtualEventId === payload ? _extends({}, state, {
        selected: !state.selected
      }) : state;
    case __WEBPACK_IMPORTED_MODULE_1__constants__["k" /* CLOSE_VIRTUAL_BOWLER_EDITING_FOR_REG_MANAGE */]:
      return _extends({}, state, {
        editing: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["p" /* DISPLAY_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE */]:
      return _extends({}, state, {
        editing: state.virtualEventId === payload ? !state.editing : false
      });
    default:
      return state;
  }
};

var virtualBowlerReducer = function virtualBowlerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref4 = arguments[1];
  var type = _ref4.type,
      payload = _ref4.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_1__constants__["D" /* SET_BOWLER_FOR_VIRTUAL_ENTRY_FOR_REG_MANAGE */]:
      return state.id === payload.virtualEntryId ? _extends({}, state, {
        bowlerId: payload.bowlerId
      }) : state;
    case __WEBPACK_IMPORTED_MODULE_1__constants__["E" /* SET_BOWLER_FOR_CART_VIRTUAL_ENTRY_FOR_REG_MANAGE */]:
      return state.id === payload.virtualEntryId ? _extends({}, state, {
        bowlerId: payload.bowlerId,
        divisionName: payload.divisionName
      }) : state;
    default:
      return state;
  }
};

var cartEntryReducer = function cartEntryReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref5 = arguments[1];
  var type = _ref5.type,
      payload = _ref5.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_1__constants__["v" /* SET_ENTRY_STATE_DISABLED_FOR_REG_MANAGE */]:
      return state.cartRosterId === payload.entryId ? _extends({}, state, {
        disableState: payload.disabled || false
      }) : state;
    case __WEBPACK_IMPORTED_MODULE_1__constants__["X" /* SET_SELECTED_ENTRY_FOR_REG_MANAGE_ENTRIES */]:
      return state.cartRosterId === payload ? _extends({}, state, {
        selected: !state.selected
      }) : state;
    case __WEBPACK_IMPORTED_MODULE_1__constants__["j" /* CANCEL_PURCHASED_ENTRY_FORM */]:
      return _extends({}, state, {
        editing: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["n" /* DISPLAY_PURCHASED_ENTRY_FORM */]:
      return _extends({}, state, {
        editing: state.cartRosterId === payload ? !state.editing : false
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* CANCEL_ENTRY_DETAILS_FOR_REG_MANAGE */]:
      return _extends({}, state, {
        showEntryDetails: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["m" /* DISPLAY_ENTRY_DETAILS_FOR_REG_MANAGE */]:
      return _extends({}, state, {
        showEntryDetails: state.cartRosterId === payload ? !state.showEntryDetails : false
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["V" /* DISPLAY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE_TEAMS */]:
      return _extends({}, state, {
        showPaymentLog: state.cartRosterId === payload ? !state.showPaymentLog : false
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["i" /* CANCEL_ENTRY_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE */]:
      return _extends({}, state, {
        showPaymentLog: false
      });
    default:
      return state;
  }
};

var cartVirtualEventReducer = function cartVirtualEventReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref6 = arguments[1];
  var type = _ref6.type,
      payload = _ref6.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_1__constants__["l" /* CANCEL_VIRTUAL_EVENT_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE */]:
      return _extends({}, state, {
        showPaymentLog: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["A" /* SET_SELECTED_VIRTUAL_EVENT_FOR_REG_MANAGE_ENTRIES */]:
      return state.cartRosterId === payload ? _extends({}, state, {
        selected: !state.selected
      }) : state;
    case __WEBPACK_IMPORTED_MODULE_1__constants__["W" /* DISPLAY_VIRTUAL_EVENT_PAYMENT_LOG_FOR_REG_MANAGE */]:
      return _extends({}, state, {
        showPaymentLog: state.cartRosterId === payload ? !state.showPaymentLog : false
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["k" /* CLOSE_VIRTUAL_BOWLER_EDITING_FOR_REG_MANAGE */]:
      return _extends({}, state, {
        editing: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__constants__["p" /* DISPLAY_VIRTUAL_ENTRY_BOWLER_LIST_FOR_REG_MANAGE */]:
      return _extends({}, state, {
        editing: state.cartRosterId === payload ? !state.editing : false
      });
    default:
      return state;
  }
};

var bowlerCompare = function bowlerCompare(a, b) {
  if (a.name > b.name) {
    return 1;
  }
  if (a.name < b.name) {
    return -1;
  }
  return 0;
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_spinner__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__topBanner_TopBannerContainer_jsx__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_AuthenticationContainer_jsx__ = __webpack_require__(982);






var App = function App(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux_spinner__["Spinner"], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__topBanner_TopBannerContainer_jsx__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__auth_AuthenticationContainer_jsx__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        children
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux_toastr___default.a, null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe', { id: 'ifmContentsToPrint',
      style: { height: 0, width: 0, position: 'fixed', left: '-10px' }
    })
  );
};

App.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].element
};

/* harmony default export */ __webpack_exports__["a"] = App;

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_DisplayIf_jsx__ = __webpack_require__(12);




var BundlingPurchaseGuide = function BundlingPurchaseGuide(_ref) {
  var visible = _ref.visible,
      nextDate = _ref.nextDate,
      onNextDateClick = _ref.onNextDateClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_shared_DisplayIf_jsx__["a" /* default */],
    {
      condition: visible,
      className: 'animated fadeIn alert alert-success text-center',
      style: { width: '100%', marginTop: '10px', marginBottom: 0 } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      'Thank you. Please select ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          className: 'btn btn-link',
          onClick: function onClick() {
            return onNextDateClick(nextDate);
          } },
        __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(nextDate).format('MMM D')
      ),
      ' on the calendar to register for Doubles and Singles.'
    )
  );
};

BundlingPurchaseGuide.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  nextDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  onNextDateClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

BundlingPurchaseGuide.defaultProps = {
  visible: false,
  nextDate: ''
};

/* harmony default export */ __webpack_exports__["a"] = BundlingPurchaseGuide;

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_Link_jsx__ = __webpack_require__(61);



var NotFoundPage = function NotFoundPage() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_shared_Link_jsx__["a" /* default */],
      {
        className: 'btn btn-primary btn-lg',
        to: ''
      },
      'Go Back Home'
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = NotFoundPage;

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_util_formatCurrency__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_DisplayIf_jsx__ = __webpack_require__(12);





Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_3_shared_util_formatCurrency__["a" /* formatCurrency */];

var OrderReviewSquadItem = function OrderReviewSquadItem(_ref) {
  var id = _ref.id,
      eventName = _ref.eventName,
      startDateTime = _ref.startDateTime,
      quantity = _ref.quantity,
      available = _ref.available,
      adminAvailable = _ref.adminAvailable,
      eventPrice = _ref.eventPrice,
      eventAddOnFees = _ref.eventAddOnFees,
      eventTotalPrice = _ref.eventTotalPrice,
      name = _ref.name,
      price = _ref.price,
      qtyNotEditable = _ref.qtyNotEditable,
      onRemoveSquadItem = _ref.onRemoveSquadItem,
      onRemoveVirtualEvent = _ref.onRemoveVirtualEvent,
      onSquadFeesClick = _ref.onSquadFeesClick,
      onQuantityChange = _ref.onQuantityChange,
      onVirtualEventQuantityChange = _ref.onVirtualEventQuantityChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    eventAddOnFees ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: { width: 120 },
          className: 'list-group-item-labeled-child'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Event Name'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          eventName
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: { width: 150 },
          className: 'list-group-item-labeled-child'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Date'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          __WEBPACK_IMPORTED_MODULE_2_moment___default.a.parseZone(startDateTime).format('ddd, MMM DD YYYY')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: { width: 80 },
          className: 'list-group-item-labeled-child'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Time'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          __WEBPACK_IMPORTED_MODULE_2_moment___default.a.parseZone(startDateTime).format('hh:mm A')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: { width: 80 },
          className: 'list-group-item-labeled-child'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Quantity'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
          style: { width: 80 },
          disabled: !available && !adminAvailable || qtyNotEditable,
          type: 'number',
          min: '0',
          step: '1',
          max: adminAvailable ? adminAvailable : available,
          value: quantity,
          onChange: function onChange(event) {
            return onQuantityChange({
              squadId: id,
              inputValue: event.target.value,
              max: adminAvailable ? adminAvailable : available
            });
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()({ 'list-group-item-labeled-child': !eventAddOnFees.length }, { 'list-group-item-labeled-child-clickable': eventAddOnFees.length }),
          style: { width: 80 },
          onClick: eventAddOnFees.length ? function () {
            return onSquadFeesClick(eventPrice, eventAddOnFees);
          } : function () {}
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Unit Price ($)'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          eventTotalPrice.formatCurrency(2)
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 80 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Item Total ($)'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          (eventTotalPrice * quantity).formatCurrency(2)
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_shared_DisplayIf_jsx__["a" /* default */],
        { condition: !qtyNotEditable },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            style: { width: 80, marginTop: 8 },
            className: 'list-group-item-labeled-child'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              className: 'btn btn-link',
              type: 'button',
              onClick: function onClick() {
                return onRemoveSquadItem(id);
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-shopping-cart' }),
            ' ',
            'Remove'
          )
        )
      )
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-subitem-container' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
        style: { width: 120 },
        className: 'list-group-item-labeled-child'
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: { width: 918 },
          className: 'list-group-subitem-labeled'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            style: { width: 150 },
            className: 'list-group-item-labeled-child'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'Virtual Event'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            name
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          style: { width: 80 },
          className: 'list-group-item-labeled-child'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            style: { width: 80 },
            className: 'list-group-item-labeled-child'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'Quantity'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
            style: { width: 80 },
            disabled: qtyNotEditable,
            value: quantity,
            type: 'number',
            min: '0',
            step: '1',
            onChange: function onChange(event) {
              return onVirtualEventQuantityChange({
                virtualEventId: id,
                inputValue: event.target.value
              });
            } })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: 'list-group-item-labeled-child',
            style: { width: 80 }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'Unit Price ($)'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            price.formatCurrency(2)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: 'list-group-item-labeled-child',
            style: { width: 80 }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'Item Total ($)'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            (price * quantity).formatCurrency(2)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_shared_DisplayIf_jsx__["a" /* default */],
          { condition: !qtyNotEditable },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              style: { width: 80 },
              className: 'list-group-item-labeled-child'
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              {
                className: 'btn btn-link',
                type: 'button',
                onClick: function onClick() {
                  return onRemoveVirtualEvent(id);
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-shopping-cart' }),
              ' ',
              'Remove'
            )
          )
        )
      )
    )
  );
};

OrderReviewSquadItem.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  eventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  startDateTime: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  quantity: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  available: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  adminAvailable: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  eventPrice: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  eventAddOnFees: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  eventTotalPrice: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  name: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  price: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  qtyNotEditable: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onRemoveSquadItem: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onRemoveVirtualEvent: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSquadFeesClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onQuantityChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onVirtualEventQuantityChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

OrderReviewSquadItem.defaultProps = {
  eventTotalPrice: 0,
  quantity: 0
};

/* harmony default export */ __webpack_exports__["a"] = OrderReviewSquadItem;

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_util_dateComparator__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScheduleSquadListItem_jsx__ = __webpack_require__(979);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var ScheduleSquadList = function ScheduleSquadList(_ref) {
  var source = _ref.source,
      onQuantityChange = _ref.onQuantityChange,
      onAddClick = _ref.onAddClick,
      onSquadFeesClick = _ref.onSquadFeesClick,
      onNextDateClick = _ref.onNextDateClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group' },
    source.sort(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_util_dateComparator__["a" /* dateComparator */])('startDateTime')).map(function (squad, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ScheduleSquadListItem_jsx__["a" /* default */], _extends({
        key: index
      }, squad, {
        onAddClick: onAddClick,
        onFeesClick: onSquadFeesClick,
        onQuantityChange: onQuantityChange,
        onNextDateClick: onNextDateClick
      }));
    })
  );
};

ScheduleSquadList.propTypes = {
  source: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  onQuantityChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onAddClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSquadFeesClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onNextDateClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

ScheduleSquadList.defaultProps = {
  source: []
};

/* harmony default export */ __webpack_exports__["a"] = ScheduleSquadList;

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_BundlingPurchaseGuide_jsx__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_util_formatCurrency__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_DisplayIf_jsx__ = __webpack_require__(12);






Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_4_shared_util_formatCurrency__["a" /* formatCurrency */];

var ScheduleSquadListItem = function ScheduleSquadListItem(_ref) {
  var id = _ref.id,
      startDateTime = _ref.startDateTime,
      eventPrice = _ref.eventPrice,
      eventTotalPrice = _ref.eventTotalPrice,
      available = _ref.available,
      adminAvailable = _ref.adminAvailable,
      hideFromCaptains = _ref.hideFromCaptains,
      quantity = _ref.quantity,
      countInCart = _ref.countInCart,
      eventAddOnFees = _ref.eventAddOnFees,
      showBundleGuide = _ref.showBundleGuide,
      onAddClick = _ref.onAddClick,
      onFeesClick = _ref.onFeesClick,
      onQuantityChange = _ref.onQuantityChange,
      onNextDateClick = _ref.onNextDateClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group-item-labeled' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_shared_DisplayIf_jsx__["a" /* default */],
      { condition: __WEBPACK_IMPORTED_MODULE_2_moment___default.a.parseZone(startDateTime).second() === 10 && adminAvailable },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 80, color: 'red' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Time'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          __WEBPACK_IMPORTED_MODULE_2_moment___default.a.parseZone(startDateTime).format('hh:mm A')
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_shared_DisplayIf_jsx__["a" /* default */],
      { condition: __WEBPACK_IMPORTED_MODULE_2_moment___default.a.parseZone(startDateTime).second() === 0 || !adminAvailable },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled-child',
          style: { width: 80 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Time'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          __WEBPACK_IMPORTED_MODULE_2_moment___default.a.parseZone(startDateTime).format('hh:mm A')
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()({ 'list-group-item-labeled-child': !eventAddOnFees.length }, { 'list-group-item-labeled-child-clickable': eventAddOnFees.length }),
        style: { width: 80 },
        onClick: eventAddOnFees.length ? function () {
          return onFeesClick(eventPrice, eventAddOnFees);
        } : function () {} },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Price ($)'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        eventTotalPrice.formatCurrency(2)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 80 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Available',
        function () {
          var extraAdminAvailability = available !== (adminAvailable || available);

          return hideFromCaptains || extraAdminAvailability;
        }() ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'glyphicon glyphicon-exclamation-sign',
          title: (hideFromCaptains ? "Hidden from captains - " : "") + adminAvailable + ' available for Admins to reserve',
          style: { marginLeft: 5, color: '#fb9838' } }) : null
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        available > 0 ? available : 0
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 80 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Quantity'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
        style: { width: 80 },
        disabled: !available && !adminAvailable,
        type: 'number',
        min: '0',
        step: '1',
        max: adminAvailable ? adminAvailable : available,
        value: quantity,
        onChange: function onChange(event) {
          return onQuantityChange({
            squadId: id,
            inputValue: event.target.value,
            max: adminAvailable ? adminAvailable : available
          });
        }
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 100, marginTop: 8 } },
      (adminAvailable ? adminAvailable > 0 : available > 0) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          className: quantity > 0 ? 'btn btn-warning' : 'btn btn-link',
          type: 'button',
          disabled: !quantity,
          onClick: function onClick() {
            return onAddClick(id, quantity);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-shopping-cart' }),
        ' ',
        quantity > 0 ? 'Add (' + quantity + ')' : 'Add'
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'label label-danger' },
        'SOLD OUT'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 50 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'In Cart'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        countInCart
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_BundlingPurchaseGuide_jsx__["a" /* default */], {
      visible: showBundleGuide,
      nextDate: __WEBPACK_IMPORTED_MODULE_2_moment___default.a.parseZone(startDateTime).add(1, 'days'),
      onNextDateClick: onNextDateClick
    })
  );
};

ScheduleSquadListItem.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  startDateTime: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  eventPrice: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  eventTotalPrice: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  available: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  adminAvailable: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  hideFromCaptains: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  quantity: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  countInCart: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  eventAddOnFees: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  showBundleGuide: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onFeesClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onAddClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onQuantityChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onNextDateClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

ScheduleSquadListItem.defaultProps = {
  eventAddOnFees: [],
  quantity: 0,
  eventTotalPrice: 0,
  countInCart: 0,
  showBundleGuide: false
};

/* harmony default export */ __webpack_exports__["a"] = ScheduleSquadListItem;

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldValidationError_jsx__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var TimeField = function TimeField(_ref) {
  var disabled = _ref.disabled,
      increment = _ref.increment,
      input = _ref.input,
      label = _ref.label,
      matchPos = _ref.matchPos,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      name = _ref.name,
      placeholder = _ref.placeholder,
      searchable = _ref.searchable,
      simpleValue = _ref.simpleValue,
      style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('form-group', { 'has-error': touched && error }) },
    label || placeholder ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'label',
      { htmlFor: name },
      label || placeholder
    ) : null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select___default.a, _extends({}, input, {
      disabled: disabled,
      options: getTimeOptions(increment),
      placeholder: placeholder,
      searchable: searchable,
      matchPos: matchPos,
      simpleValue: simpleValue,
      style: style,
      onBlur: function onBlur() {
        return input.onBlur(input.value);
      }
    })),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FieldValidationError_jsx__["a" /* default */], {
      touched: touched,
      error: error
    })
  );
};

var getTimeOptions = function getTimeOptions(increment) {
  var options = [];
  var todaysDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD'),
      nextDay = __WEBPACK_IMPORTED_MODULE_4_moment___default()(todaysDate).add(1, 'day');

  for (var m = __WEBPACK_IMPORTED_MODULE_4_moment___default()(todaysDate); m.diff(nextDay, 'minutes') < 0; m.add(increment, 'minutes')) {
    options.push({ value: m.format('HH:mm'), label: m.format('hh:mm A') });
  }

  return options;
};

TimeField.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  increment: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  input: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  label: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,
  matchPos: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  meta: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  name: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  placeholder: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  searchable: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  simpleValue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  style: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};

TimeField.defaultProps = {
  disabled: false,
  increment: 15,
  input: {},
  label: null,
  matchPos: 'start',
  meta: {},
  name: '',
  placeholder: '',
  searchable: true,
  simpleValue: true,
  style: {}
};

/* harmony default export */ __webpack_exports__["a"] = TimeField;

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_util_formatCurrency__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_DisplayIf_jsx__ = __webpack_require__(12);



Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_1_shared_util_formatCurrency__["a" /* formatCurrency */];

var VirtualEventItem = function VirtualEventItem(_ref) {
  var id = _ref.id,
      name = _ref.name,
      quantity = _ref.quantity,
      price = _ref.price,
      qtyNotEditable = _ref.qtyNotEditable,
      onRemoveVirtualEvent = _ref.onRemoveVirtualEvent,
      onQuantityChange = _ref.onQuantityChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group-item-labeled' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        style: { width: 120 },
        className: 'list-group-item-labeled-child'
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Virtual Event'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        name
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
      style: { width: 150 },
      className: 'list-group-item-labeled-child'
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
      style: { width: 80 },
      className: 'list-group-item-labeled-child'
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        style: { width: 80 },
        className: 'list-group-item-labeled-child'
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Quantity'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
        style: { width: 80 },
        disabled: qtyNotEditable,
        value: quantity,
        type: 'number',
        min: '0',
        step: '1',
        onChange: function onChange(event) {
          return onQuantityChange({
            virtualEventId: id,
            inputValue: event.target.value
          });
        } })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'list-group-item-labeled-child',
        style: { width: 80 }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Unit Price ($)'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        price.formatCurrency(2)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'list-group-item-labeled-child',
        style: { width: 80 }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Item Total ($)'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        (price * quantity).formatCurrency(2)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_shared_DisplayIf_jsx__["a" /* default */],
      { condition: !qtyNotEditable },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: { width: 80 },
          className: 'list-group-item-labeled-child'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            className: 'btn btn-link',
            type: 'button',
            onClick: function onClick() {
              return onRemoveVirtualEvent(id);
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-shopping-cart' }),
          ' ',
          'Remove'
        )
      )
    )
  );
};

VirtualEventItem.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  name: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  quantity: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  price: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  qtyNotEditable: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onRemoveVirtualEvent: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onQuantityChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

VirtualEventItem.defaultProps = {
  price: 0,
  quantity: 0
};

/* harmony default export */ __webpack_exports__["a"] = VirtualEventItem;

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(62);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var AuthenticationContainer = function (_Component) {
    _inherits(AuthenticationContainer, _Component);

    function AuthenticationContainer(props) {
        _classCallCheck(this, AuthenticationContainer);

        var _this = _possibleConstructorReturn(this, (AuthenticationContainer.__proto__ || Object.getPrototypeOf(AuthenticationContainer)).call(this, props));

        props.signinSilent();
        return _this;
    }

    _createClass(AuthenticationContainer, [{
        key: "render",
        value: function render() {
            var props = this.props;

            return props.loginAttempted ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                props.children
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
        }
    }]);

    return AuthenticationContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AuthenticationContainer.propTypes = {
    children: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].element,
    loginAttempted: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
    signinSilent: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

var mapStateToProps = function mapStateToProps(state) {
    var shared = state.shared;


    return { loginAttempted: shared.auth.loginAttempted };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        signinSilent: function signinSilent() {
            return dispatch(__WEBPACK_IMPORTED_MODULE_2__actions_js__["o" /* signinSilent */]);
        }
    };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(AuthenticationContainer);

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var Authorize = function Authorize(_ref) {
  var authorized = _ref.authorized,
      children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "animated fadeIn banner-flex-right" },
    authorized ? children : null
  );
};

Authorize.propTypes = {
  authorized: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  children: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node
};

Authorize.defaultProps = {
  authorized: false,
  children: null
};

/* harmony default export */ __webpack_exports__["a"] = Authorize;

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var Maintenance = function Maintenance(_ref) {
  var maintenanceMessage = _ref.maintenanceMessage,
      onMaintenanceComplete = _ref.onMaintenanceComplete;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "alert alert-info text-center" },
      maintenanceMessage ? maintenanceMessage : onMaintenanceComplete(maintenanceMessage)
    )
  );
};

Maintenance.propTypes = {
  maintenanceMessage: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onMaintenanceComplete: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = Maintenance;

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Maintenance_jsx__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(62);




var mapStateToProps = function mapStateToProps(state) {
  return {
    maintenanceMessage: state.shared.auth.maintenanceMessage
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onMaintenanceComplete: function onMaintenanceComplete(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["n" /* handleMaintenanceComplete */])(data));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__Maintenance_jsx__["a" /* default */]);

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_Link_jsx__ = __webpack_require__(61);



var Unauthorized = function Unauthorized() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'alert alert-danger' },
      'Sorry, but you do not have permission to view this page. If you believe this is incorrect please contact your Registration support at USBC.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'flex center' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_shared_Link_jsx__["a" /* default */],
        {
          className: 'btn btn-primary btn-lg',
          to: '' },
        'Go Back Home'
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = Unauthorized;

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(457);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setEmailInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setRoleForUserInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setPermissionForUserInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setDisplayNameInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setProfileValidationsInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setDobInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setIsAllowedInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setIsValidTypeInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setGroupNameInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setMaintenanceMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setLoginAttempted; });


var setEmailInState = function setEmailInState(email) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_EMAIL_FOR_SHARED_AUTH */],
    payload: email
  };
};

var setRoleForUserInState = function setRoleForUserInState(roles) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_ROLES_FOR_SHARED_AUTH */],
    payload: roles
  };
};

var setPermissionForUserInState = function setPermissionForUserInState(permissions) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_PERMISSIONS_FOR_SHARED_AUTH */],
    payload: permissions
  };
};

var setDisplayNameInState = function setDisplayNameInState(userProfile) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_DISPLAY_NAME_FOR_SHARED_AUTH */],
    payload: userProfile
  };
};

var setProfileValidationsInState = function setProfileValidationsInState(userProfile) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* SET_PROFILE_VALIDATIONS_FOR_SHARED_AUTH */],
    payload: userProfile
  };
};

var setDobInState = function setDobInState(dob) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SET_DOB_FOR_SHARED_AUTH */],
    payload: dob
  };
};

var setIsAllowedInState = function setIsAllowedInState(isAllowed) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* SET_IS_ALLOWED_FOR_SHARED_AUTH */],
    payload: isAllowed
  };
};

var setIsValidTypeInState = function setIsValidTypeInState(isValidType) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* SET_IS_VALID_TYPE_FOR_SHARED_AUTH */],
    payload: isValidType
  };
};

var setGroupNameInState = function setGroupNameInState(groupName) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* SET_GROUP_NAME_FOR_SHARED_AUTH */],
    payload: groupName
  };
};

var setMaintenanceMessage = function setMaintenanceMessage(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* SET_MAINTENANCE_MESSAGE */],
    payload: payload
  };
};

var setLoginAttempted = function setLoginAttempted() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* SET_LOGIN_ATTEMPTED */],
    payload: { loginAttempted: true }
  };
};

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(457);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  email: null,
  displayName: null,
  roles: [],
  permissions: [],
  dob: null,
  profileIsValid: false,
  profileIsConfirmed: false,
  validationMessage: '',
  groupName: null,
  loginAttempted: false
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_EMAIL_FOR_SHARED_AUTH */]:
      return _extends({}, state, {
        email: payload || null
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_ROLES_FOR_SHARED_AUTH */]:
      return _extends({}, state, {
        roles: payload || []
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_PERMISSIONS_FOR_SHARED_AUTH */]:
      return _extends({}, state, {
        permissions: payload || []
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_DISPLAY_NAME_FOR_SHARED_AUTH */]:
      {
        var nameToDisplay = null;

        if (payload == null) {
          nameToDisplay = null;
        } else {
          if ((payload.firstName || payload.lastName) && payload.firstName == payload.lastName) {
            nameToDisplay = '' + (payload.firstName || '');
          } else if (payload.firstName || payload.lastName) {
            nameToDisplay = (payload.firstName || '') + ' ' + (payload.lastName || '');
          } else {
            nameToDisplay = payload.email;
          }
        }

        return _extends({}, state, {
          displayName: nameToDisplay
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* SET_PROFILE_VALIDATIONS_FOR_SHARED_AUTH */]:
      {
        var profileIsValid = false;
        var profileIsConfirmed = false;
        var profileIsWorking = false;
        var validationMessage = '';

        if (payload != null) {
          profileIsValid = payload.profileIsValid;
          profileIsConfirmed = payload.profileIsConfirmed;
          profileIsWorking = true;
          validationMessage = payload.validationMessage;
        }

        return _extends({}, state, {
          profileIsValid: profileIsValid,
          profileIsConfirmed: profileIsConfirmed,
          profileIsWorking: profileIsWorking,
          validationMessage: validationMessage
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SET_DOB_FOR_SHARED_AUTH */]:
      return _extends({}, state, {
        dob: payload || null
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* SET_GROUP_NAME_FOR_SHARED_AUTH */]:
      return _extends({}, state, {
        groupName: payload || null
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* SET_IS_ALLOWED_FOR_SHARED_AUTH */]:
      return _extends({}, state, {
        isAllowed: payload || false
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* SET_IS_VALID_TYPE_FOR_SHARED_AUTH */]:
      return _extends({}, state, {
        isValidType: payload || false
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* SET_MAINTENANCE_MESSAGE */]:
      return _extends({}, state, {
        maintenanceMessage: payload
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* SET_LOGIN_ATTEMPTED */]:
      return _extends({}, state, payload);
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MaintenanceContainer_jsx__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Unauthorized_jsx__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_auth_actions_js__ = __webpack_require__(62);








var routes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, {
    path: 'maintenance',
    component: __WEBPACK_IMPORTED_MODULE_4__MaintenanceContainer_jsx__["a" /* default */],
    onEnter: function onEnter() {
      __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_auth_actions_js__["a" /* retrieveMaintenanceMessage */])());
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, {
    path: 'signin/unauthorized',
    component: __WEBPACK_IMPORTED_MODULE_5__Unauthorized_jsx__["a" /* default */],
    onEnter: function onEnter() {
      __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_topBanner_actionTypes__["b" /* setTitle */])('Unauthorized'));
    }
  })
);

/* harmony default export */ __webpack_exports__["a"] = routes;

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_variables__ = __webpack_require__(38);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLIENT_ID; });
/* unused harmony export GROUP_ENABLED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SIGNIN_CALLBACK_URI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SIGNIN_SILENT_RENEW_URI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SIGNIN_RESPONSE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SIGNIN_SCOPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return POST_LOGOUT_REDIRECT_URI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SILENT_RENEWAL_SECONDS_BEFORE_EXPIRES; });


var CLIENT_ID = window.CLIENT_ID || '';
var GROUP_ENABLED = window.GROUP_ENABLED;
var SIGNIN_CALLBACK_URI = __WEBPACK_IMPORTED_MODULE_0_shared_variables__["f" /* BASE_URL */] + '/SignIn/Callback';
var SIGNIN_SILENT_RENEW_URI = __WEBPACK_IMPORTED_MODULE_0_shared_variables__["f" /* BASE_URL */] + '/SignIn/SilentRenew';
var SIGNIN_RESPONSE_TYPE = "id_token token";
var SIGNIN_SCOPES = "openid profile USBC-REGISTRATION-API USBC-PROFILE REGISTRATION_APIKEY_149CA60A-28F9-4DD8-BA65-2252B376AFD6";
var POST_LOGOUT_REDIRECT_URI = __WEBPACK_IMPORTED_MODULE_0_shared_variables__["f" /* BASE_URL */] + '/';
var SILENT_RENEWAL_SECONDS_BEFORE_EXPIRES = 120;

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var ErrorList = function ErrorList(_ref) {
  var source = _ref.source;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    source.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { id: "sharedErrorList",
        className: "alert alert-danger" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        null,
        'The following errors occured:'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "ul",
        null,
        source.map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            { key: index },
            item
          );
        })
      )
    ) : null
  );
};

ErrorList.propTypes = {
  source: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string)
};

ErrorList.defaultProps = {
  source: []
};

/* harmony default export */ __webpack_exports__["a"] = ErrorList;

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(458);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  source: []
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_ERROR_LIST_FOR_SHARED */]:
      return _extends({}, state, {
        source: payload
      });
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_StandardModal_jsx__ = __webpack_require__(23);



var EventPriceDetailsModal = function EventPriceDetailsModal(_ref) {
  var visible = _ref.visible,
      basePrice = _ref.basePrice,
      fees = _ref.fees,
      onCancelClick = _ref.onCancelClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_shared_StandardModal_jsx__["a" /* default */],
    {
      title: 'Price Breakdown',
      visible: visible,
      onCloseClick: onCancelClick },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-labeled' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: 'list-group-item-labeled-child',
            style: { width: 200 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'Description'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'Event'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: 'list-group-item-labeled-child',
            style: { width: 125 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'Amount ($)'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            basePrice
          )
        )
      ),
      fees.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            key: index,
            className: 'list-group-item-labeled' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: 'list-group-item-labeled-child',
              style: { width: 200 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              'Description'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              item.description
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: 'list-group-item-labeled-child',
              style: { width: 125 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              'Amount ($)'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              item.fee
            )
          )
        );
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'text-right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-primary btn-lg',
            onClick: onCancelClick
          },
          'Close'
        )
      )
    )
  );
};

EventPriceDetailsModal.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  basePrice: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  fees: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

EventPriceDetailsModal.defaultProps = {
  basePrice: 0,
  fees: []
};

/* harmony default export */ __webpack_exports__["a"] = EventPriceDetailsModal;

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(459);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  showEventPriceDetailsModal: false,
  eventPriceDetailsData: {}
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* CANCEL_EVENT_PRICE_DETAILS_MODAL_SHARED */]:
      return _extends({}, state, {
        showEventPriceDetailsModal: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_EVENT_PRICE_DETAILS_MODAL_SHARED */]:
      return _extends({}, state, {
        showEventPriceDetailsModal: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_EVENT_PRICE_DETAILS_DATA_SHARED */]:
      return _extends({}, state, {
        eventPriceDetailsData: payload
      });
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_Link_jsx__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__ = __webpack_require__(12);





var NavigationBar = function NavigationBar(_ref) {
  var actions = _ref.actions;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'btn-group navigation-bar' },
    actions.map(function (action, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_shared_Link_jsx__["a" /* default */],
        {
          key: index,
          to: action.to,
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("btn", { "btn-default": !action.active }, { "btn-primary": action.active }, { "nav-origin": action.navOrigin })
        },
        action.navOrigin ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-home' }) : action.label,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
          { condition: !!action.iconClassName,
            style: { display: 'inline' } },
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa ' + action.iconClassName + ' ' + (action.iconColorClassName || '') })
        )
      );
    })
  );
};

NavigationBar.propTypes = {
  actions: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object)
};

/* harmony default export */ __webpack_exports__["a"] = NavigationBar;

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavigationBar_jsx__ = __webpack_require__(995);



var mapStateToProps = function mapStateToProps(state) {
  return state.shared.navigationBar;
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__NavigationBar_jsx__["a" /* default */]);

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(460);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hideNavigationIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return displayNavigationIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hideNavigation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setNavigationActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return displayNavigation; });


var hideNavigationIcon = function hideNavigationIcon(key) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* HIDE_ICON_FOR_SHARED_NAVIGATION_BAR */],
    payload: key
  };
};

var displayNavigationIcon = function displayNavigationIcon(key, iconClassName, iconColorClassName) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DISPLAY_ICON_FOR_SHARED_NAVIGATION_BAR */],
    payload: { key: key, iconClassName: iconClassName, iconColorClassName: iconColorClassName }
  };
};

var hideNavigation = function hideNavigation() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* HIDE_NAVIGATION */]
  };
};

var setNavigationActive = function setNavigationActive(key) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_NAVIGATION_ACTIVE */],
    payload: key
  };
};

var displayNavigation = function displayNavigation(actions) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* DISPLAY_NAVIGATION */],
    payload: actions
  };
};

/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(460);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  actions: []
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* HIDE_ICON_FOR_SHARED_NAVIGATION_BAR */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DISPLAY_ICON_FOR_SHARED_NAVIGATION_BAR */]:
    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_NAVIGATION_ACTIVE */]:
      return _extends({}, state, {
        actions: state.actions.map(function (x) {
          return actionReducer(x, { type: type, payload: payload });
        })
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* HIDE_NAVIGATION */]:
      return _extends({}, state, {
        actions: []
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* DISPLAY_NAVIGATION */]:
      return _extends({}, state, {
        actions: payload
      });
    default:
      return state;
  }
};

var actionInitialState = {
  active: false,
  navOrigin: false,
  to: '',
  label: '',
  iconClassName: '',
  iconColorClassName: ''
};

var actionReducer = function actionReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : actionInitialState;
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* HIDE_ICON_FOR_SHARED_NAVIGATION_BAR */]:
      return state.key === payload ? _extends({}, state, {
        iconClassName: actionInitialState.iconClassName,
        iconColorClassName: actionInitialState.iconColorClassName
      }) : state;
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DISPLAY_ICON_FOR_SHARED_NAVIGATION_BAR */]:
      return state.key === payload.key ? _extends({}, state, {
        iconClassName: payload.iconClassName || actionInitialState.iconClassName,
        iconColorClassName: payload.iconColorClassName || actionInitialState.iconColorClassName
      }) : state;
    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_NAVIGATION_ACTIVE */]:
      return _extends({}, state, {
        active: state.key === payload
      });
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__topBanner_reducer__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__navigationBar_reducer__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eventPriceDetailsModal_reducer__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_reducer__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth_reducer__ = __webpack_require__(988);







/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  topBanner: __WEBPACK_IMPORTED_MODULE_1__topBanner_reducer__["a" /* default */],
  navigationBar: __WEBPACK_IMPORTED_MODULE_2__navigationBar_reducer__["a" /* default */],
  eventPriceDetailsModal: __WEBPACK_IMPORTED_MODULE_3__eventPriceDetailsModal_reducer__["a" /* default */],
  error: __WEBPACK_IMPORTED_MODULE_4__error_reducer__["a" /* default */],
  auth: __WEBPACK_IMPORTED_MODULE_5__auth_reducer__["a" /* default */]
});

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__topBanner_actionTypes__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NotFoundPage_jsx__ = __webpack_require__(976);







var routes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, {
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_4__NotFoundPage_jsx__["a" /* default */],
    onEnter: function onEnter() {
      __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__topBanner_actionTypes__["b" /* setTitle */])('404 Page Not Found'));
    }
  })
);

/* harmony default export */ __webpack_exports__["a"] = routes;

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_Link_jsx__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_navigationBar_NavigationBarContainer_jsx__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_auth_AuthorizeContainer_jsx__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserLoginContainer_jsx__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_DisplayIf_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_variables__ = __webpack_require__(38);








var TopBanner = function TopBanner(_ref) {
  var environment = _ref.environment,
      profileIsConfirmed = _ref.profileIsConfirmed,
      bannerImagePath = _ref.bannerImagePath,
      title = _ref.title,
      subTitle = _ref.subTitle,
      onLogoClick = _ref.onLogoClick,
      groupName = _ref.groupName,
      isAllowed = _ref.isAllowed;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'top-banner',
      style: {
        background: 'linear-gradient(rgba(0, 51, 141, 0.8), rgba(0, 51, 141, 0.8)),\n          url(' + (bannerImagePath || __WEBPACK_IMPORTED_MODULE_6_shared_variables__["k" /* DEFAULT_TOURNAMENT_IMG_LARGE */]) + ')\n          no-repeat center center',
        backgroundSize: 'cover'
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'container' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'top-banner-logo cursor-pointer',
        onClick: onLogoClick
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_shared_DisplayIf_jsx__["a" /* default */],
        { condition: environment != 'PROD' && environment != 'PRODUCTION' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'top-banner-enironment' },
          environment
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_shared_DisplayIf_jsx__["a" /* default */],
        { condition: isAllowed && groupName != undefined && groupName !== '' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'top-banner-group-name' },
          groupName
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'top-banner-actions' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_shared_DisplayIf_jsx__["a" /* default */],
          { condition: profileIsConfirmed },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'banner-flex-right' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_shared_Link_jsx__["a" /* default */],
              {
                className: 'btn btn-link',
                to: 'registration' },
              'Home'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_shared_auth_AuthorizeContainer_jsx__["a" /* default */],
            { admin: true, superuser: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_shared_DisplayIf_jsx__["a" /* default */],
              { condition: isAllowed || groupName == undefined || groupName === '' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_shared_Link_jsx__["a" /* default */],
                { className: 'btn btn-link', to: 'admin' },
                'Admin Dashboard'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_shared_auth_AuthorizeContainer_jsx__["a" /* default */],
            { admin: true, manager: true, superuser: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_shared_DisplayIf_jsx__["a" /* default */],
              { condition: isAllowed || groupName == undefined || groupName === '' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_shared_Link_jsx__["a" /* default */],
                { className: 'btn btn-link', to: 'admin/audit' },
                'Audit'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_shared_auth_AuthorizeContainer_jsx__["a" /* default */],
            { manager: true, superuser: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_shared_DisplayIf_jsx__["a" /* default */],
              { condition: isAllowed || groupName == undefined || groupName === '' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_shared_Link_jsx__["a" /* default */],
                { className: 'btn btn-link', to: 'tournament' },
                'Manage Tournament'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_shared_auth_AuthorizeContainer_jsx__["a" /* default */],
            { financialofficer: true, hqfinancialofficer: true, superuser: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_shared_DisplayIf_jsx__["a" /* default */],
              { condition: groupName && window.GROUP_ENABLED === "true" ? false : false },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_shared_Link_jsx__["a" /* default */],
                { className: 'btn btn-link',
                  to: 'finance' },
                'Financial Administration'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__UserLoginContainer_jsx__["a" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_shared_DisplayIf_jsx__["a" /* default */],
          { condition: !profileIsConfirmed },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__UserLoginContainer_jsx__["a" /* default */], null)
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h1',
        { className: 'top-banner-title' },
        title
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h2',
        { className: 'top-banner-subtitle' },
        subTitle
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_navigationBar_NavigationBarContainer_jsx__["a" /* default */], null)
    )
  );
};

TopBanner.defaultProps = {
  environment: 'UNKNOWN'
};

TopBanner.propTypes = {
  environment: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  profileIsConfirmed: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  bannerImagePath: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  subTitle: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onLogoClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  isAllowed: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool
};

/* harmony default export */ __webpack_exports__["a"] = TopBanner;

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TopBanner_jsx__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_variables__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var mapStateTopProps = function mapStateTopProps(state) {
  return _extends({}, state.shared.topBanner, {
    profileIsConfirmed: state.shared.auth.profileIsConfirmed,
    environment: __WEBPACK_IMPORTED_MODULE_3_shared_variables__["h" /* ENVIRONMENT */],
    groupName: state.shared.auth.groupName,
    isAllowed: state.shared.auth.isAllowed
  });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onLogoClick: function onLogoClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* handleLogoClick */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateTopProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__TopBanner_jsx__["a" /* default */]);

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(109);



var UserLogin = function UserLogin(_ref) {
  var username = _ref.username,
      isLoggedIn = _ref.isLoggedIn,
      onLoginClick = _ref.onLoginClick,
      onUserClick = _ref.onUserClick,
      onLogoutClick = _ref.onLogoutClick,
      onPartnerLoginClick = _ref.onPartnerLoginClick,
      groupName = _ref.groupName,
      isAllowed = _ref.isAllowed;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'user-login banner-flex-right' },
    isLoggedIn ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'banner-flex-right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["DropdownButton"],
          { id: 'actions-dropdown-UserDropDown',
            className: 'btn btn-link',
            title: 'Welcome ' + username },
          isAllowed && groupName && window.GROUP_ENABLED === "true" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["MenuItem"],
            { className: 'entry-dropdown-link',
              disabled: true },
            groupName
          ) : null,
          isAllowed && groupName && window.GROUP_ENABLED === "true" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["MenuItem"], { divider: true }) : null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["MenuItem"],
            { className: 'entry-dropdown-link',
              onSelect: onUserClick },
            'Edit Profile'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["MenuItem"],
            { className: 'entry-dropdown-link',
              onSelect: onLogoutClick },
            'Logout'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["MenuItem"], { divider: true }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["MenuItem"],
            { className: 'entry-dropdown-link', onSelect: onPartnerLoginClick },
            'Partner Hub Login'
          )
        )
      )
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      {
        className: 'btn btn-link banner-flex-right',
        onClick: onLoginClick },
      'Login'
    )
  );
};

UserLogin.propTypes = {
  username: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  isLoggedIn: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onLoginClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onUserClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onLogoutClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onPartnerLoginClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  groupName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

/* harmony default export */ __webpack_exports__["a"] = UserLogin;

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserLogin_jsx__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(138);




var mapStateTopProps = function mapStateTopProps(state) {
  var username = state.shared.auth.displayName;

  if (username == null) username = '';
  return {
    groupName: state.shared.auth.groupName,
    username: username,
    isLoggedIn: !!state.shared.auth.email,
    isAllowed: state.shared.auth.isAllowed,
    roles: state.shared.auth.roles,
    permissions: state.shared.auth.permissions
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onLoginClick: function onLoginClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["d" /* handleLoginClick */])());
    },
    onUserClick: function onUserClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["e" /* handleUserClick */])());
    },
    onLogoutClick: function onLogoutClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* handleLogoutClick */])());
    },
    onPartnerLoginClick: function onPartnerLoginClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* handlePartnerLoginClick */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateTopProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__UserLogin_jsx__["a" /* default */]);

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(461);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  title: '',
  subTitle: '',
  bannerImagePath: null
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_TOP_BANNER_IMAGE_PATH */]:
      return _extends({}, state, {
        bannerImagePath: payload || initialState.bannerImagePath
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_TITLE */]:
      return _extends({}, state, { title: payload });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_SUBTITLE */]:
      return _extends({}, state, { subTitle: payload });
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_lib_Button__ = __webpack_require__(1630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_lib_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_lib_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);





var daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

/* harmony default export */ __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'DatePickerCalendar',

  propTypes: {
    selectedDate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    displayDate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    minDate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    maxDate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    dayLabels: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,
    cellPadding: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    weekStartsOn: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    showTodayButton: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    todayButtonLabel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    roundedCorners: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    showWeeks: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  },

  handleClick: function handleClick(e) {
    var day = e.currentTarget.getAttribute('data-day');
    var newSelectedDate = this.setTimeToNoon(new Date(this.props.displayDate));

    newSelectedDate.setDate(day);
    this.props.onChange(newSelectedDate);
  },
  handleClickToday: function handleClickToday() {
    var newSelectedDate = this.setTimeToNoon(new Date());

    this.props.onChange(newSelectedDate);
  },
  setTimeToNoon: function setTimeToNoon(date) {
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  },
  getWeekNumber: function getWeekNumber(date) {
    var target = new Date(date.valueOf());
    var dayNr = (date.getDay() + 6) % 7;

    target.setDate(target.getDate() - dayNr + 3);
    var firstThursday = target.valueOf();

    target.setMonth(0, 1);
    if (target.getDay() !== 4) {
      target.setMonth(0, 1 + (4 - target.getDay() + 7) % 7);
    }
    return 1 + Math.ceil((firstThursday - target) / 604800000);
  },
  render: function render() {
    var _this = this;

    var currentDate = this.setTimeToNoon(new Date());
    var selectedDate = this.props.selectedDate ? this.setTimeToNoon(new Date(this.props.selectedDate)) : null;
    var minDate = this.props.minDate ? this.setTimeToNoon(new Date(this.props.minDate)) : null;
    var maxDate = this.props.maxDate ? this.setTimeToNoon(new Date(this.props.maxDate)) : null;
    var year = this.props.displayDate.getFullYear();
    var month = this.props.displayDate.getMonth();
    var firstDay = new Date(year, month, 1);
    var startingDay = this.props.weekStartsOn > 1 ? firstDay.getDay() - this.props.weekStartsOn + 7 : this.props.weekStartsOn === 1 ? firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1 : firstDay.getDay();
    var showWeeks = this.props.showWeeks;

    var monthLength = daysInMonth[month];

    if (month == 1) {
      if (year % 4 == 0 && year % 100 != 0 || year % 400 == 0) {
        monthLength = 29;
      }
    }

    var weeks = [];
    var day = 1;

    for (var i = 0; i < 9; i++) {
      var week = [];

      for (var j = 0; j <= 6; j++) {
        if (day <= monthLength && (i > 0 || j >= startingDay)) {
          var className = null;
          var date = new Date(year, month, day, 12, 0, 0, 0).toISOString();
          var beforeMinDate = minDate && Date.parse(date) < Date.parse(minDate);
          var afterMinDate = maxDate && Date.parse(date) > Date.parse(maxDate);
          var clickHandler = this.handleClick;
          var style = { cursor: 'pointer', padding: this.props.cellPadding, borderRadius: this.props.roundedCorners ? 5 : 0 };

          if (beforeMinDate || afterMinDate) {
            className = 'text-muted';
            clickHandler = null;
            style.cursor = 'default';
          } else if (Date.parse(date) === Date.parse(selectedDate)) {
            className = 'bg-primary';
          } else if (Date.parse(date) === Date.parse(currentDate)) {
            className = 'text-primary';
          }

          week.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'td',
            {
              key: j,
              'data-day': day,
              onClick: clickHandler,
              style: style,
              className: className
            },
            day
          ));
          day++;
        } else {
          week.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { key: j }));
        }
      }

      if (showWeeks) {
        var weekNum = this.getWeekNumber(new Date(year, month, day - 1, 12, 0, 0, 0));

        week.unshift(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          {
            key: 7,
            style: { padding: this.props.cellPadding, fontSize: '0.8em', color: 'darkgrey' },
            className: 'text-muted'
          },
          weekNum
        ));
      }

      weeks.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'tr',
        { key: i },
        week
      ));
      if (day > monthLength) {
        break;
      }
    }

    var weekColumn = showWeeks ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', {
      className: 'text-muted current-week',
      style: { padding: this.props.cellPadding } }) : null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'table',
      { className: 'text-center' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'thead',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'tr',
          null,
          weekColumn,
          this.props.dayLabels.map(function (label, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'td',
              {
                key: index,
                className: 'text-muted',
                style: { padding: _this.props.cellPadding } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'small',
                null,
                label
              )
            );
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'tbody',
        null,
        weeks
      ),
      this.props.showTodayButton && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'tfoot',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'tr',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'td',
            { colSpan: this.props.dayLabels.length,
              style: { paddingTop: '9px' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_lib_Button___default.a,
              {
                block: true,
                bsSize: 'xsmall',
                className: 'u-today-button',
                onClick: this.handleClickToday },
              this.props.todayButtonLabel
            )
          )
        )
      )
    );
  }
});

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);




/* harmony default export */ __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'DatePickerHeader',

  propTypes: {
    displayDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    monthLabels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
    previousButtonElement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
    nextButtonElement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
  },

  displayingMinMonth: function displayingMinMonth() {
    if (!this.props.minDate) return false;

    var displayDate = new Date(this.props.displayDate);
    var minDate = new Date(this.props.minDate);

    return minDate.getFullYear() == displayDate.getFullYear() && minDate.getMonth() == displayDate.getMonth();
  },
  displayingMaxMonth: function displayingMaxMonth() {
    if (!this.props.maxDate) return false;

    var displayDate = new Date(this.props.displayDate);
    var maxDate = new Date(this.props.maxDate);

    return maxDate.getFullYear() == displayDate.getFullYear() && maxDate.getMonth() == displayDate.getMonth();
  },
  handleClickPrevious: function handleClickPrevious() {
    var newDisplayDate = new Date(this.props.displayDate);

    newDisplayDate.setDate(1);
    newDisplayDate.setMonth(newDisplayDate.getMonth() - 1);
    this.props.onChange(newDisplayDate);
  },
  handleClickNext: function handleClickNext() {
    var newDisplayDate = new Date(this.props.displayDate);

    newDisplayDate.setDate(1);
    newDisplayDate.setMonth(newDisplayDate.getMonth() + 1);
    this.props.onChange(newDisplayDate);
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'text-center' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'text-muted pull-left datepicker-previous-wrapper',
          onClick: this.handleClickPrevious,
          style: { cursor: 'pointer' } },
        this.displayingMinMonth() ? null : this.props.previousButtonElement
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        this.props.monthLabels[this.props.displayDate.getMonth()],
        ' ',
        this.props.displayDate.getFullYear()
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'text-muted pull-right datepicker-next-wrapper',
          onClick: this.handleClickNext,
          style: { cursor: 'pointer' } },
        this.displayingMaxMonth() ? null : this.props.nextButtonElement
      )
    );
  }
});

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_lib_FormControl__ = __webpack_require__(1632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_lib_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_lib_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_InputGroup__ = __webpack_require__(1636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_InputGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_InputGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_lib_Overlay__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_lib_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_lib_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_lib_Popover__ = __webpack_require__(1640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_lib_Popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap_lib_Popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_create_react_class__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Calendar_jsx__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CalendarHeader_jsx__ = __webpack_require__(1007);
// See http://jszen.blogspot.com/2007/03/how-to-build-simple-calendar-with.html for calendar logic.
// Edits by USBC to fix an error found on our page












var instanceCount = 0;

/* harmony default export */ __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_7_create_react_class___default()({
  displayName: 'DatePicker',

  propTypes: {
    defaultValue: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    required: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    minDate: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    maxDate: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    cellPadding: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    autoComplete: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    placeholder: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    dayLabels: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
    monthLabels: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
    onChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onClear: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onBlur: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    autoFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    weekStartsOnMonday: function weekStartsOnMonday(props, propName, componentName) {
      if (props[propName]) {
        return new Error('Prop \'' + propName + '\' supplied to \'' + componentName + '\' is obsolete. Use \'weekStartsOn\' instead.');
      }
    },
    weekStartsOn: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
    clearButtonElement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
    showClearButton: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    previousButtonElement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
    nextButtonElement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
    calendarPlacement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]),
    dateFormat: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, // 'MM/DD/YYYY', 'DD/MM/YYYY', 'YYYY/MM/DD', 'DD-MM-YYYY'
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    bsSize: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    calendarContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    name: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    showTodayButton: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    todayButtonLabel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    instanceCount: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
    customControl: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    roundedCorners: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    showWeeks: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node]),
    onInvalid: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    noValidate: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
  },

  getDefaultProps: function getDefaultProps() {
    var language = typeof window !== 'undefined' && window.navigator ? (window.navigator.userLanguage || window.navigator.language || '').toLowerCase() : '';
    var dateFormat = !language || language === 'en-us' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';

    return {
      cellPadding: '5px',
      dayLabels: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      monthLabels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      clearButtonElement: '×',
      previousButtonElement: '<',
      nextButtonElement: '>',
      calendarPlacement: 'bottom',
      dateFormat: dateFormat,
      showClearButton: true,
      autoFocus: false,
      disabled: false,
      showTodayButton: false,
      todayButtonLabel: 'Today',
      autoComplete: 'on',
      showWeeks: false,
      instanceCount: instanceCount++,
      style: {
        width: '100%'
      },
      roundedCorners: false,
      noValidate: false
    };
  },
  getInitialState: function getInitialState() {
    if (this.props.value && this.props.defaultValue) {
      throw new Error('Conflicting DatePicker properties \'value\' and \'defaultValue\'');
    }
    var state = this.makeDateValues(this.props.value || this.props.defaultValue);

    if (this.props.weekStartsOn > 1) {
      state.dayLabels = this.props.dayLabels.slice(this.props.weekStartsOn).concat(this.props.dayLabels.slice(0, this.props.weekStartsOn));
    } else if (this.props.weekStartsOn === 1) {
      state.dayLabels = this.props.dayLabels.slice(1).concat(this.props.dayLabels.slice(0, 1));
    } else {
      state.dayLabels = this.props.dayLabels;
    }
    state.focused = false;
    state.inputFocused = false;
    state.placeholder = this.props.placeholder || this.props.dateFormat;
    state.separator = this.props.dateFormat.match(/[^A-Z]/)[0];
    return state;
  },
  makeDateValues: function makeDateValues(isoString) {
    var displayDate = void 0;
    var selectedDate = isoString ? new Date(isoString.slice(0, 10) + 'T12:00:00.000Z') : null;
    var minDate = this.props.minDate ? new Date(this.props.minDate.slice(0, 10) + 'T12:00:00.000Z') : null;
    var maxDate = this.props.maxDate ? new Date(this.props.maxDate.slice(0, 10) + 'T12:00:00.000Z') : null;

    if (minDate == "Invalid Date") minDate = new Date(this.props.minDate);
    if (maxDate == "Invalid Date") maxDate = new Date(this.props.maxDate);

    if (selectedDate && selectedDate != "Invalid Date") {
      displayDate = new Date(selectedDate);
    } else {
      var today = new Date(new Date().toISOString().slice(0, 10) + 'T12:00:00.000Z');

      if (minDate && Date.parse(minDate) >= Date.parse(today)) {
        displayDate = minDate;
      } else if (maxDate && Date.parse(maxDate) <= Date.parse(today)) {
        displayDate = maxDate;
      } else {
        displayDate = today;
      }

      selectedDate = isoString ? displayDate : null;
    }
    var inputValue = isoString ? this.makeInputValueString(selectedDate) : null;

    return {
      value: selectedDate ? selectedDate.toISOString() : null,
      displayDate: displayDate,
      selectedDate: selectedDate,
      inputValue: inputValue
    };
  },
  clear: function clear() {
    if (this.props.onClear) {
      this.props.onClear();
    } else {
      this.setState(this.makeDateValues(null));
    }

    if (this.props.onChange) {
      this.props.onChange(null, null);
    }
  },
  handleHide: function handleHide() {
    if (this.state.inputFocused) {
      return;
    }
    this.setState({
      focused: false
    });
    if (this.props.onBlur) {
      var event = document.createEvent('CustomEvent');

      event.initEvent('Change Date', true, false);
      __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.refs.hiddenInput).dispatchEvent(event);
      this.props.onBlur(event);
    }
  },
  handleKeyDown: function handleKeyDown(e) {
    if (e.which === 9 && this.state.inputFocused) {
      this.setState({
        focused: false
      });

      if (this.props.onBlur) {
        var event = document.createEvent('CustomEvent');

        event.initEvent('Change Date', true, false);
        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.refs.hiddenInput).dispatchEvent(event);
        this.props.onBlur(event);
      }
    }
  },
  handleFocus: function handleFocus() {
    if (this.state.focused === true) {
      return;
    }

    var placement = this.getCalendarPlacement();

    this.setState({
      inputFocused: true,
      focused: true,
      calendarPlacement: placement
    });

    if (this.props.onFocus) {
      var event = document.createEvent('CustomEvent');

      event.initEvent('Change Date', true, false);
      __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.refs.hiddenInput).dispatchEvent(event);
      this.props.onFocus(event);
    }
  },
  handleBlur: function handleBlur() {
    this.setState({
      inputFocused: false
    });
  },


  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return !(this.state.inputFocused === true && nextState.inputFocused === false);
  },

  getValue: function getValue() {
    return this.state.selectedDate && this.state.inputValue != null ? this.state.selectedDate.toISOString() : null;
  },
  getFormattedValue: function getFormattedValue() {
    return this.state.displayDate ? this.state.inputValue : null;
  },
  getCalendarPlacement: function getCalendarPlacement() {
    var tag = Object.prototype.toString.call(this.props.calendarPlacement);
    var isFunction = tag === '[object AsyncFunction]' || tag === '[object Function]' || tag === '[object GeneratorFunction]' || tag === '[object Proxy]';

    if (isFunction) {
      return this.props.calendarPlacement();
    } else {
      return this.props.calendarPlacement;
    }
  },
  makeInputValueString: function makeInputValueString(date) {
    var month = date.getMonth() + 1;
    var day = date.getDate();

    //this method is executed during intialState setup... handle a missing state properly
    var separator = this.state ? this.state.separator : this.props.dateFormat.match(/[^A-Z]/)[0];

    if (this.props.dateFormat.match(/MM.DD.YYYY/)) {
      return (month > 9 ? month : '0' + month) + separator + (day > 9 ? day : '0' + day) + separator + date.getFullYear();
    } else if (this.props.dateFormat.match(/DD.MM.YYYY/)) {
      return (day > 9 ? day : '0' + day) + separator + (month > 9 ? month : '0' + month) + separator + date.getFullYear();
    } else {
      return date.getFullYear() + separator + (month > 9 ? month : '0' + month) + separator + (day > 9 ? day : '0' + day);
    }
  },
  handleBadInput: function handleBadInput(originalValue) {
    var parts = originalValue.replace(new RegExp('[^0-9' + this.state.separator + ']'), '').split(this.state.separator);

    if (this.props.dateFormat.match(/MM.DD.YYYY/) || this.props.dateFormat.match(/DD.MM.YYYY/)) {
      if (parts[0] && parts[0].length > 2) {
        parts[1] = parts[0].slice(2) + (parts[1] || '');
        parts[0] = parts[0].slice(0, 2);
      }
      if (parts[1] && parts[1].length > 2) {
        parts[2] = parts[1].slice(2) + (parts[2] || '');
        parts[1] = parts[1].slice(0, 2);
      }
      if (parts[2]) {
        parts[2] = parts[2].slice(0, 4);
      }
    } else {
      if (parts[0] && parts[0].length > 4) {
        parts[1] = parts[0].slice(4) + (parts[1] || '');
        parts[0] = parts[0].slice(0, 4);
      }
      if (parts[1] && parts[1].length > 2) {
        parts[2] = parts[1].slice(2) + (parts[2] || '');
        parts[1] = parts[1].slice(0, 2);
      }
      if (parts[2]) {
        parts[2] = parts[2].slice(0, 2);
      }
    }
    this.setState({
      inputValue: parts.join(this.state.separator)
    });
  },
  handleInputChange: function handleInputChange() {

    var originalValue = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.refs.input).value;
    var inputValue = originalValue.replace(/(-|\/\/)/g, this.state.separator).slice(0, 10);

    if (!inputValue) {
      this.clear();
      return;
    }

    var month = void 0,
        day = void 0,
        year = void 0;

    if (this.props.dateFormat.match(/MM.DD.YYYY/)) {
      if (!inputValue.match(/[0-1][0-9].[0-3][0-9].[1-2][0-9][0-9][0-9]/)) {
        return this.handleBadInput(originalValue);
      }

      month = inputValue.slice(0, 2).replace(/[^0-9]/g, '');
      day = inputValue.slice(3, 5).replace(/[^0-9]/g, '');
      year = inputValue.slice(6, 10).replace(/[^0-9]/g, '');
    } else if (this.props.dateFormat.match(/DD.MM.YYYY/)) {
      if (!inputValue.match(/[0-3][0-9].[0-1][0-9].[1-2][0-9][0-9][0-9]/)) {
        return this.handleBadInput(originalValue);
      }

      day = inputValue.slice(0, 2).replace(/[^0-9]/g, '');
      month = inputValue.slice(3, 5).replace(/[^0-9]/g, '');
      year = inputValue.slice(6, 10).replace(/[^0-9]/g, '');
    } else {
      if (!inputValue.match(/[1-2][0-9][0-9][0-9].[0-1][0-9].[0-3][0-9]/)) {
        return this.handleBadInput(originalValue);
      }

      year = inputValue.slice(0, 4).replace(/[^0-9]/g, '');
      month = inputValue.slice(5, 7).replace(/[^0-9]/g, '');
      day = inputValue.slice(8, 10).replace(/[^0-9]/g, '');
    }

    var monthInteger = parseInt(month, 10);
    var dayInteger = parseInt(day, 10);
    var yearInteger = parseInt(year, 10);

    if (monthInteger > 12 || dayInteger > 31) {
      return this.handleBadInput(originalValue);
    }

    if (!isNaN(monthInteger) && !isNaN(dayInteger) && !isNaN(yearInteger) && monthInteger <= 12 && dayInteger <= 31 && yearInteger > 999) {
      var selectedDate = new Date(yearInteger, monthInteger - 1, dayInteger, 12, 0, 0, 0);

      this.setState({
        selectedDate: selectedDate,
        displayDate: selectedDate,
        value: selectedDate.toISOString()
      });

      if (this.props.onChange) {
        this.props.onChange(selectedDate.toISOString(), inputValue);
      }
    }

    this.setState({
      inputValue: inputValue
    });
  },
  onChangeMonth: function onChangeMonth(newDisplayDate) {
    this.setState({
      displayDate: newDisplayDate
    });
  },
  onChangeDate: function onChangeDate(newSelectedDate) {
    var inputValue = this.makeInputValueString(newSelectedDate);

    this.setState({
      inputValue: inputValue,
      selectedDate: newSelectedDate,
      displayDate: newSelectedDate,
      value: newSelectedDate.toISOString(),
      focused: false
    });

    if (this.props.onBlur) {
      var event = document.createEvent('CustomEvent');

      event.initEvent('Change Date', true, false);
      __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.refs.hiddenInput).dispatchEvent(event);
      this.props.onBlur(event);
    }

    if (this.props.onChange) {
      this.props.onChange(newSelectedDate.toISOString(), inputValue);
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
    var value = newProps.value;

    if (this.getValue() !== value) {
      this.setState(this.makeDateValues(value));
    }
  },
  render: function render() {
    var _this = this;

    var calendarHeader = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__CalendarHeader_jsx__["a" /* default */], {
      previousButtonElement: this.props.previousButtonElement,
      nextButtonElement: this.props.nextButtonElement,
      displayDate: this.state.displayDate,
      minDate: this.props.minDate,
      maxDate: this.props.maxDate,
      onChange: this.onChangeMonth,
      monthLabels: this.props.monthLabels,
      dateFormat: this.props.dateFormat });

    var control = this.props.customControl ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.customControl, {
      onKeyDown: this.handleKeyDown,
      value: this.state.inputValue || '',
      required: this.props.required,
      placeholder: this.state.focused ? this.props.dateFormat : this.state.placeholder,
      ref: 'input',
      disabled: this.props.disabled,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onChange: this.handleInputChange,
      className: this.props.className,
      style: this.props.style,
      autoComplete: this.props.autoComplete,
      onInvalid: this.props.onInvalid,
      noValidate: this.props.noValidate
    }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_lib_FormControl___default.a, {
      onKeyDown: this.handleKeyDown,
      value: this.state.inputValue || '',
      required: this.props.required,
      ref: 'input',
      type: 'text',
      className: this.props.className,
      style: this.props.style,
      autoFocus: this.props.autoFocus,
      disabled: this.props.disabled,
      placeholder: this.state.focused ? this.props.dateFormat : this.state.placeholder,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onChange: this.handleInputChange,
      autoComplete: this.props.autoComplete,
      onInvalid: this.props.onInvalid,
      noValidate: this.props.noValidate
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_InputGroup___default.a,
      {
        ref: 'inputGroup',
        bsClass: this.props.showClearButton ? this.props.bsClass : '',
        bsSize: this.props.bsSize,
        id: this.props.id ? this.props.id + '_group' : null },
      control,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_lib_Overlay___default.a,
        {
          rootClose: true,
          onHide: this.handleHide,
          show: this.state.focused,
          container: function container() {
            return _this.props.calendarContainer || __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this.refs.overlayContainer);
          },
          target: function target() {
            return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this.refs.input);
          },
          placement: this.state.calendarPlacement,
          delayHide: 200 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_lib_Popover___default.a,
          { id: 'date-picker-popover-' + this.props.instanceCount,
            className: 'date-picker-popover',
            title: calendarHeader },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Calendar_jsx__["a" /* default */], {
            cellPadding: this.props.cellPadding,
            selectedDate: this.state.selectedDate,
            displayDate: this.state.displayDate,
            onChange: this.onChangeDate,
            dayLabels: this.state.dayLabels,
            weekStartsOn: this.props.weekStartsOn,
            showTodayButton: this.props.showTodayButton,
            todayButtonLabel: this.props.todayButtonLabel,
            minDate: this.props.minDate,
            maxDate: this.props.maxDate,
            roundedCorners: this.props.roundedCorners,
            showWeeks: this.props.showWeeks
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { ref: 'overlayContainer',
        style: { position: 'relative' } }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { ref: 'hiddenInput',
        type: 'hidden',
        id: this.props.id,
        name: this.props.name,
        value: this.state.value || '',
        'data-formattedvalue': this.state.value ? this.state.inputValue : '' }),
      this.props.showClearButton && !this.props.customControl && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_lib_InputGroup___default.a.Addon,
        {
          onClick: this.props.disabled ? null : this.clear,
          style: { cursor: this.state.inputValue && !this.props.disabled ? 'pointer' : 'not-allowed' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { opacity: this.state.inputValue && !this.props.disabled ? 1 : 0.5 } },
          this.props.clearButtonElement
        )
      ),
      this.props.children
    );
  }
});

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dateComparator; });


var dateComparator = function dateComparator(prop) {
  return function (a, b) {
    if (!b[prop] || __WEBPACK_IMPORTED_MODULE_0_moment___default.a.parseZone(a[prop]).isBefore(__WEBPACK_IMPORTED_MODULE_0_moment___default.a.parseZone(b[prop]))) return -1;
    if (!a[prop] || __WEBPACK_IMPORTED_MODULE_0_moment___default.a.parseZone(a[prop]).isAfter(__WEBPACK_IMPORTED_MODULE_0_moment___default.a.parseZone(b[prop]))) return 1;
    return 0;
  };
};

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return detectIE; });
/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */

var detectIE = function detectIE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');

    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');

    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');

        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    var edge = ua.indexOf('Edge/');

    if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
};

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return squadComparator; });


var squadComparator = function squadComparator(a, b) {
  if (!b.eventNumberOfBowlers || a.eventNumberOfBowlers > b.eventNumberOfBowlers) {
    return -1;
  }
  if (!a.eventNumberOfBowlers || b.eventNumberOfBowlers > a.eventNumberOfBowlers) {
    return 1;
  }
  if (!b.startDateTime && a.startDateTime) {
    return -1;
  }
  if (b.startDateTime && !a.startDateTime) {
    return 1;
  }
  if (!b.startDateTime || __WEBPACK_IMPORTED_MODULE_0_moment___default.a.parseZone(a.startDateTime).isBefore(__WEBPACK_IMPORTED_MODULE_0_moment___default.a.parseZone(b.startDateTime))) {
    return -1;
  }
  if (!a.startDateTime || __WEBPACK_IMPORTED_MODULE_0_moment___default.a.parseZone(a.startDateTime).isAfter(__WEBPACK_IMPORTED_MODULE_0_moment___default.a.parseZone(b.startDateTime))) {
    return 1;
  }
  return 0;
};

/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(1013);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setWebHooks; });


var setWebHooks = function setWebHooks(payload) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_WEBHOOKS_FOR_REG_CHECKOUT */],
        payload: payload
    };
};

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_WEBHOOKS_FOR_REG_CHECKOUT; });
var SET_WEBHOOKS_FOR_REG_CHECKOUT = 'SET_WEBHOOKS_FOR_REG_CHECKOUT';

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(464);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setTournament; });


var setTournament = function setTournament(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_TOURNAMENT_FOR_SETUP */],
    payload: data
  };
};

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CapacitySquadList_jsx__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CapacityAvailabilityModal_jsx__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);





var Capacity = function Capacity(_ref) {
  var squads = _ref.squads,
      onUpdateClick = _ref.onUpdateClick,
      modalTitle = _ref.modalTitle,
      modalVisible = _ref.modalVisible,
      loadingSquads = _ref.loadingSquads,
      onModalCloseClick = _ref.onModalCloseClick,
      onSquadCapacityBlur = _ref.onSquadCapacityBlur,
      onSquadCapacityChange = _ref.onSquadCapacityChange,
      onSquadVisibilityChange = _ref.onSquadVisibilityChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'flex center animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'col-xs-12 col-lg-10' },
      loadingSquads ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'alert alert-info' },
        'Loading capacity data.'
      ) : squads.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              className: 'btn btn-primary btn-lg',
              disabled: !squads.length,
              onClick: onUpdateClick
            },
            'Bulk Update'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__CapacitySquadList_jsx__["a" /* default */], {
            squads: squads,
            onSquadCapacityBlur: onSquadCapacityBlur,
            onSquadCapacityChange: onSquadCapacityChange,
            onSquadVisibilityChange: onSquadVisibilityChange
          })
        )
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'alert alert-info' },
        'No information to display.'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CapacityAvailabilityModal_jsx__["a" /* default */], {
      title: modalTitle,
      visible: modalVisible,
      onCloseClick: onModalCloseClick
    })
  );
};

Capacity.propTypes = {
  squads: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  onUpdateClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  modalTitle: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  modalVisible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  loadingSquads: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onModalCloseClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSquadCapacityBlur: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSquadCapacityChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSquadVisibilityChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

Capacity.defaultProps = {
  squads: [],
  loadingSquads: true
};

/* harmony default export */ __webpack_exports__["a"] = Capacity;

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardSelectField_jsx__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_Submitting_jsx__ = __webpack_require__(35);






var CapacityAvailabilityForm = function CapacityAvailabilityForm(_ref) {
  var eventTypes = _ref.eventTypes,
      handleSubmit = _ref.handleSubmit,
      onCancel = _ref.onCancel,
      onSubmit = _ref.onSubmit,
      submitting = _ref.submitting,
      pristine = _ref.pristine;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'form',
    {
      onSubmit: handleSubmit(onSubmit),
      noValidate: true
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
      name: 'capacity',
      type: 'number',
      step: '1',
      min: '0',
      max: '100',
      placeholder: 'Capacity (as a % of total)',
      component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */]
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
      name: 'eventId',
      component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardSelectField_jsx__["a" /* default */],
      options: eventTypes,
      simpleValue: true,
      placeholder: 'Event',
      searchable: false
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
      name: 'startDate',
      type: 'date',
      placeholder: 'Start Date',
      component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */]
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
      name: 'endDate',
      type: 'date',
      placeholder: 'End Date',
      component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */]
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'form-group text-right' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          type: 'button',
          className: 'btn btn-link',
          disabled: submitting,
          onClick: onCancel
        },
        'Cancel'
      ),
      ' ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          type: 'submit',
          className: 'btn btn-primary btn-lg',
          disabled: pristine || submitting },
        submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_Submitting_jsx__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
        ' ',
        'Update'
      )
    )
  );
};

CapacityAvailabilityForm.propTypes = {
  eventTypes: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  onCancel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  pristine: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'capacityAvailabilityForm'
})(CapacityAvailabilityForm);

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CapacityAvailabilityForm_jsx__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(282);








var mapStateToProps = function mapStateToProps(state) {
  return {
    validate: __WEBPACK_IMPORTED_MODULE_2__actions__["e" /* validate */],
    eventTypes: state.tournament.capacity.eventTypes
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* handleCapacitySave */])(data));
    },
    onCancel: function onCancel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["d" /* hideCapacityDialog */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CapacityAvailabilityForm_jsx__["a" /* default */]);

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CapacityAvailabilityFormContainer_jsx__ = __webpack_require__(1017);






var CapacityAvailabilityModal = function CapacityAvailabilityModal(_ref) {
  var title = _ref.title,
      visible = _ref.visible,
      onCloseClick = _ref.onCloseClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("modal", { "display block animated fadeIn": visible })
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'modal-dialog' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'modal-content' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'modal-header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'close',
              'aria-hidden': 'true',
              onClick: onCloseClick
            },
            '\xD7'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'modal-title' },
            title
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'modal-body' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'flex center animated fadeIn' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-xs-12 col-lg-10' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CapacityAvailabilityFormContainer_jsx__["a" /* default */], null)
              )
            )
          )
        )
      )
    )
  );
};

CapacityAvailabilityModal.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCloseClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = CapacityAvailabilityModal;

/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Capacity_jsx__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(283);







var mapStateToProps = function mapStateToProps(state) {
  return state.tournament.capacity;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onUpdateClick: function onUpdateClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* handleUpdateButtonClick */])());
    },
    onModalCloseClick: function onModalCloseClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["d" /* hideCapacityDialog */])());
    },
    onSquadCapacityBlur: function onSquadCapacityBlur(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["c" /* handleUpdateSquadCapacity */])(data));
    },
    onSquadCapacityChange: function onSquadCapacityChange(id, value) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["e" /* setSquadCapacity */])(id, value));
    },
    onSquadVisibilityChange: function onSquadVisibilityChange(id, value) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* handleUpdateSquadVisibility */])(id, value));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__Capacity_jsx__["a" /* default */]);

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



var CapacitySquadItem = function CapacitySquadItem(_ref) {
  var id = _ref.id,
      eventName = _ref.eventName,
      date = _ref.date,
      totalEntries = _ref.totalEntries,
      numberSold = _ref.numberSold,
      numberAvailableForPurchase = _ref.numberAvailableForPurchase,
      hideFromCaptains = _ref.hideFromCaptains,
      dirty = _ref.dirty,
      onSquadCapacityBlur = _ref.onSquadCapacityBlur,
      onSquadCapacityChange = _ref.onSquadCapacityChange,
      onSquadVisibilityChange = _ref.onSquadVisibilityChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group-item-labeled' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        style: { width: 150 },
        className: 'list-group-item-labeled-child'
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Name'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        eventName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        style: { width: 150 },
        className: 'list-group-item-labeled-child'
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Date'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(date).format('D MMM, hh:mm A')
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        style: { width: 100 },
        className: 'list-group-item-labeled-child'
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Total Entries'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        totalEntries
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        style: { width: 100 },
        className: 'list-group-item-labeled-child'
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        '# Sold'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        numberSold
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Available For Purchase'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
        type: 'number',
        min: '0',
        step: '1',
        max: totalEntries,
        value: numberAvailableForPurchase,
        disabled: !totalEntries,
        onChange: function onChange(event) {
          return onSquadCapacityChange(id, event.target.value);
        },
        onBlur: function onBlur(event) {
          return onSquadCapacityBlur({
            squadId: id,
            inputValue: event.target.value,
            dirty: dirty
          });
        }
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        style: { width: 115 },
        className: 'list-group-item-labeled-child' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        {
          style: { margin: 'auto' } },
        'Hide From Captains'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
        style: { margin: 'auto' },
        type: 'checkbox',
        id: id,
        checked: hideFromCaptains,
        onChange: function onChange() {
          return onSquadVisibilityChange(id, !hideFromCaptains);
        }
      })
    )
  );
};

CapacitySquadItem.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  eventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  date: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  totalEntries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  numberSold: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  numberAvailableForPurchase: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  hideFromCaptains: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  dirty: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onSquadCapacityBlur: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSquadCapacityChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSquadVisibilityChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = CapacitySquadItem;

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CapacitySquadItem_jsx__ = __webpack_require__(1020);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var CapacitySquadList = function CapacitySquadList(_ref) {
  var squads = _ref.squads,
      onSquadCapacityBlur = _ref.onSquadCapacityBlur,
      onSquadCapacityChange = _ref.onSquadCapacityChange,
      onSquadVisibilityChange = _ref.onSquadVisibilityChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group' },
    squads.map(function (squad, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__CapacitySquadItem_jsx__["a" /* default */], _extends({
        key: index
      }, squad, {
        onSquadCapacityBlur: onSquadCapacityBlur,
        onSquadCapacityChange: onSquadCapacityChange,
        onSquadVisibilityChange: onSquadVisibilityChange
      }));
    })
  );
};

CapacitySquadList.propTypes = {
  squads: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  onSquadCapacityBlur: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSquadCapacityChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSquadVisibilityChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = CapacitySquadList;

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(462);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  squads: [],
  modalVisible: false,
  modalTitle: '',
  loadingSquads: true
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_SQUAD_CAPACITY_FOR_TOURNAMENT_CAPACITY */]:
      return _extends({}, state, { squads: state.squads.map(function (squad) {
          return squadReducer(squad, {
            type: type,
            payload: payload
          });
        }) });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DISPLAY_SQUADS_FOR_TOURNAMENT_CAPACITY */]:
      {
        return _extends({}, state, {
          loadingSquads: payload ? false : true
        }, { squads: payload });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* DISPLAY_CAPACITY_DIALOG */]:
      return _extends({}, state, {
        modalVisible: true,
        modalTitle: payload
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* HIDE_CAPACITY_DIALOG */]:
      return _extends({}, state, { modalVisible: false });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* DISPLAY_EVENTS_IN_DDL */]:
      return _extends({}, state, { eventTypes: payload });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SET_SQUAD_VISIBILITY */]:
      return _extends({}, state, { squads: state.squads.map(function (squad) {
          return squadReducer(squad, {
            type: type,
            payload: payload
          });
        }) });

    default:
      return state;
  }
};

var squadReducer = function squadReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_SQUAD_CAPACITY_FOR_TOURNAMENT_CAPACITY */]:
      if (state.id !== payload.id) {
        return state;
      }
      return _extends({}, state, {
        numberAvailableForPurchase: Number(payload.value),
        dirty: Number(state.numberAvailableForPurchase) !== Number(payload.value)
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SET_SQUAD_VISIBILITY */]:
      if (state.id !== payload.id) {
        return state;
      }
      return _extends({}, state, {
        hideFromCaptains: payload.value
      });
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_StandardTextArea_jsx__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(54);








var SetupForm = function SetupForm(_ref) {
  var pristine = _ref.pristine,
      submitting = _ref.submitting,
      readOnly = _ref.readOnly,
      handleSubmit = _ref.handleSubmit,
      onCancel = _ref.onCancel,
      onSubmit = _ref.onSubmit;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'flex center animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'form',
      {
        className: 'col-xs-12 col-lg-8',
        onSubmit: handleSubmit(onSubmit) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel panel-default' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'panel-heading' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'panel-title' },
            'User Messages',
            ' '
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'panel-body' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'marketingMessage',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardTextArea_jsx__["a" /* default */],
            placeholder: 'This message will be shown to captains on the View Squads screen',
            label: 'Captain\'s Squad Message',
            maxLength: '250',
            disabled: readOnly
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'rosterMessage',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardTextArea_jsx__["a" /* default */],
            placeholder: 'This message will be shown to captains on the Manage Roster screen',
            label: 'Captain\'s Roster Message',
            maxLength: '250',
            disabled: readOnly
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'paymentSuccessMessage',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardTextArea_jsx__["a" /* default */],
            placeholder: 'This message will be shown to captains when a payment is successfuly completed',
            label: 'Payment Success Message',
            maxLength: '250',
            disabled: readOnly
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'paymentFailureMessage',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardTextArea_jsx__["a" /* default */],
            placeholder: 'This message will be shown to captains when a payment fails',
            label: 'Payment Failure Message',
            maxLength: '250',
            disabled: readOnly
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel panel-default' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'panel-heading' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'panel-title' },
            'Email Template IDs',
            ' '
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'panel-body' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'welcomeEmailTemplateId',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'SendGrid Template Id for email when captain purchases entries',
            label: 'Captain Purchase Email Template Id',
            maxLength: '36',
            disabled: readOnly
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'adminReservationEmailTemplateId',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'SendGrid Template Id for email when captain reserves via Admin',
            label: 'Entry Reservation Email Template Id',
            maxLength: '36',
            disabled: readOnly
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'bowlerAddedToRosterEmailTemplateId',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'SendGrid Template Id for email when bowler is added to roster',
            label: 'Roster Addition Email Template Id',
            maxLength: '36',
            disabled: readOnly
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'squadChangedEmailTemplateId',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'SendGrid Template Id for email when squad is changed',
            label: 'Squad Changed Email Template Id',
            maxLength: '36',
            disabled: readOnly
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'form-group text-right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-link',
            disabled: submitting,
            onClick: onCancel
          },
          'Cancel'
        ),
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'submit',
            className: 'btn btn-primary btn-lg',
            disabled: pristine || submitting
          },
          submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
          ' ',
          "Update"
        )
      )
    )
  );
};

SetupForm.propTypes = {
  error: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  pristine: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired,
  readOnly: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  onCancel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'tournamentCom',
  onSubmitFail: function onSubmitFail(errors) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["o" /* default */])(errors);
  }
})(SetupForm);

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CommunicationForm_jsx__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(463);




var mapStateToProps = function mapStateToProps(state) {
  return {
    readOnly: state.tournament.base.tournamentInfo.readOnly
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* handleSave */])(data));
    },
    onCancel: function onCancel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* handleCancel */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CommunicationForm_jsx__["a" /* default */]);

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);



var DivisionItem = function DivisionItem(_ref) {
  var id = _ref.id,
      name = _ref.name,
      editing = _ref.editing,
      isDefault = _ref.isDefault,
      _onClick = _ref.onClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("list-group-item hover-highlight", { "highlight animated flipInX": editing }),
      onClick: function onClick() {
        return _onClick(id);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-inner-wrapper cursor-pointer' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group-item-heading' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-pencil' }),
        ' ',
        name,
        ' ',
        isDefault ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'b',
          null,
          '(Default Division)'
        ) : ""
      )
    )
  );
};

DivisionItem.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  name: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  editing: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  isDefault: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = DivisionItem;

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_StandardCheckboxField_jsx__ = __webpack_require__(96);






var DivisionItemForm = function DivisionItemForm(_ref) {
  var handleSubmit = _ref.handleSubmit,
      pristine = _ref.pristine,
      submitting = _ref.submitting,
      onCancel = _ref.onCancel,
      onSubmit = _ref.onSubmit,
      displayDefault = _ref.displayDefault,
      averageBased = _ref.averageBased,
      ageBased = _ref.ageBased,
      genderBased = _ref.genderBased;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'form',
    {
      className: 'animated fadeIn',
      onSubmit: handleSubmit(onSubmit),
      noValidate: true
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-body' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'flex justify-content direction-column' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'panel-body-sub-heading' },
            'General (Required)'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            autoFocus: true,
            name: 'name',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'Division Name',
            tooltip: 'Use a descriptive name such as Division 1 (0-150)',
            tooltipPosition: 'top'
          }),
          displayDefault ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-sm-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                name: 'isDefault',
                component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardCheckboxField_jsx__["a" /* default */],
                label: 'Set default'
              })
            )
          ) : null,
          averageBased ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-sm-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                name: 'minAverage',
                type: 'number',
                component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
                step: '1',
                min: '0',
                max: '9900',
                placeholder: 'Min. Average'
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-sm-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                className: 'col-sm-6',
                name: 'maxAverage',
                type: 'number',
                component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
                step: '1',
                min: '0',
                max: '9900',
                placeholder: 'Max Average'
              })
            )
          ) : null,
          ageBased ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-sm-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                name: 'minAge',
                type: 'number',
                component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
                step: '1',
                min: '0',
                max: '999',
                placeholder: 'Min Age Limit'
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-sm-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                name: 'maxAge',
                type: 'number',
                component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
                step: '1',
                min: '0',
                max: '110',
                placeholder: 'Max Age Limit'
              })
            )
          ) : null,
          genderBased ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-sm-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                name: 'minFemale',
                type: 'number',
                component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
                step: '1',
                min: '0',
                max: '99',
                placeholder: 'Min Female',
                label: 'Min Number Female'
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-sm-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                name: 'minMale',
                type: 'number',
                component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
                step: '1',
                min: '0',
                max: '99',
                placeholder: 'Min Male',
                label: 'Min Number Male'
              })
            )
          ) : null
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-link',
              disabled: submitting,
              onClick: onCancel
            },
            'Cancel'
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'submit',
              className: 'btn btn-primary btn-lg',
              disabled: pristine || submitting
            },
            submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
            ' ',
            'Save'
          )
        )
      )
    )
  );
};

DivisionItemForm.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  pristine: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired,
  onCancel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  displayDefault: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  averageBased: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  ageBased: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  genderBased: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'divisionItemForm'
})(DivisionItemForm);

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DivisionItemForm_jsx__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(284);




var mapStateToProps = function mapStateToProps(state) {
  return {
    validate: __WEBPACK_IMPORTED_MODULE_2__actions__["g" /* validate */],
    displayDefault: state.tournament.divisions.displayDefault,
    averageBased: state.tournament.divisions.selectedEventAverageBased,
    ageBased: state.tournament.divisions.selectedEventAgeBased,
    genderBased: state.tournament.divisions.selectedEventGenderBased
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["h" /* handleSave */])(data));
    },
    onCancel: function onCancel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["i" /* handleCancel */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__DivisionItemForm_jsx__["a" /* default */]);

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DivisionItemFormContainer_jsx__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DivisionItem_jsx__ = __webpack_require__(1025);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DivisionList = function DivisionList(_ref) {
  var entries = _ref.entries,
      onDivisionClick = _ref.onDivisionClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group' },
    entries.map(function (item, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: index },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DivisionItem_jsx__["a" /* default */], _extends({}, item, {
          onClick: onDivisionClick
        })),
        item.editing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DivisionItemFormContainer_jsx__["a" /* default */], null) : null
      );
    })
  );
};

DivisionList.propTypes = {
  entries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  onDivisionClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = DivisionList;

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventQuickList_jsx__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VirtualEventQuickList_jsx__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DivisionList_jsx__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);






var Divisions = function Divisions(_ref) {
  var eventIdSelected = _ref.eventIdSelected,
      virtualEventIdSelected = _ref.virtualEventIdSelected,
      selectedEventName = _ref.selectedEventName,
      events = _ref.events,
      virtualEvents = _ref.virtualEvents,
      divisions = _ref.divisions,
      onEventClick = _ref.onEventClick,
      onVirtualEventClick = _ref.onVirtualEventClick,
      onDivisionClick = _ref.onDivisionClick,
      onNewDivisionClick = _ref.onNewDivisionClick,
      canCreateDivision = _ref.canCreateDivision;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'flex center animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'col-xs-12 col-lg-10' },
      events.length || virtualEvents.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-sm-4 animated fadeIn',
              style: { marginTop: 10 } },
            events.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                null,
                'Bowled Events'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__EventQuickList_jsx__["a" /* default */], {
                entries: events,
                onSelect: onEventClick
              })
            ) : null,
            virtualEvents.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                null,
                'Virtual Events'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__VirtualEventQuickList_jsx__["a" /* default */], {
                entries: virtualEvents,
                onSelect: onVirtualEventClick
              })
            ) : null
          ),
          eventIdSelected || virtualEventIdSelected ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-sm-8 animated fadeIn' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'flex space-between vertical-center',
                style: { marginTop: 8, marginBottom: 8 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                null,
                selectedEventName + ' Divisions'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'text-right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  {
                    className: 'btn btn-primary btn-lg',
                    disabled: !eventIdSelected && !virtualEventIdSelected || !canCreateDivision,
                    onClick: onNewDivisionClick
                  },
                  'Create Division'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
            divisions.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DivisionList_jsx__["a" /* default */], {
              entries: divisions,
              onDivisionClick: onDivisionClick
            }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alert alert-info' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                'Heads up! '
              ),
              'No divisions found.'
            )
          ) : null
        )
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'alert alert-info' },
        'No information to display.'
      )
    )
  );
};

Divisions.propTypes = {
  eventIdSelected: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  virtualEventIdSelected: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  selectedEventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  events: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  virtualEvents: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  divisions: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  onEventClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onVirtualEventClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onDivisionClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onNewDivisionClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  canCreateDivision: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool
};

Divisions.defaultProps = {
  selectedEventName: '',
  events: [],
  virtualEvents: [],
  divisions: []
};

/* harmony default export */ __webpack_exports__["a"] = Divisions;

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Divisions_jsx__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(284);




var mapStateToProps = function mapStateToProps(state) {
  return {
    eventIdSelected: state.tournament.divisions.eventIdSelected,
    virtualEventIdSelected: state.tournament.divisions.virtualEventIdSelected,
    selectedEventName: state.tournament.divisions.selectedEventName,
    events: state.tournament.divisions.events,
    virtualEvents: state.tournament.divisions.virtualEvents,
    divisions: state.tournament.divisions.divisions,
    canCreateDivision: state.tournament.base.tournamentInfo.canCreateDivision
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onEventClick: function onEventClick(eventId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* handleEventClick */])(eventId));
    },
    onVirtualEventClick: function onVirtualEventClick(virtualEventId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["d" /* handleVirtualEventClick */])(virtualEventId));
    },
    onDivisionClick: function onDivisionClick(divisionId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["e" /* handleDivisionClick */])(divisionId));
    },
    onNewDivisionClick: function onNewDivisionClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* handeNewDivisionClick */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__Divisions_jsx__["a" /* default */]);

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);



var EventQuickList = function EventQuickList(_ref) {
  var entries = _ref.entries,
      onSelect = _ref.onSelect;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group' },
    entries.map(function (item, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          key: index,
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("list-group-item hover-highlight", { "highlight animated flipInX": item.highlight }),
          onClick: function onClick() {
            return onSelect(item.id);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'list-group-item-inner-wrapper cursor-pointer' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'list-group-item-heading' },
            item.name,
            ' '
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-right' })
        )
      );
    })
  );
};

EventQuickList.propTypes = {
  entries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  onSelect: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = EventQuickList;

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);



var VirtualEventQuickList = function VirtualEventQuickList(_ref) {
  var entries = _ref.entries,
      onSelect = _ref.onSelect;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group' },
    entries.map(function (item, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          key: index,
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("list-group-item hover-highlight", { "highlight animated flipInX": item.highlight }),
          onClick: function onClick() {
            return onSelect(item.id);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'list-group-item-inner-wrapper cursor-pointer' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'list-group-item-heading' },
            item.name,
            ' '
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-right' })
        )
      );
    })
  );
};

VirtualEventQuickList.propTypes = {
  entries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  onSelect: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = VirtualEventQuickList;

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(465);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return displayDivisionInForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setEventSelectedInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setVirtualEventSelectedInState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return displayNewDivision; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cancelDivisionItemForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return hightlightSelectedEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return highlightSelectedVirtualEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return displayEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return displayVirtualEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return displayDivisions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDivisionDisplayDefault; });


var displayDivisionInForm = function displayDivisionInForm(divisionId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_DIVISION_IN_FORM_FOR_TOURNAMENT */],
    payload: divisionId
  };
};

var setEventSelectedInState = function setEventSelectedInState(eventId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_EVENT_SELECTED_FOR_TOURNAMENT */],
    payload: eventId
  };
};

var setVirtualEventSelectedInState = function setVirtualEventSelectedInState(virtualEventId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_VIRTUAL_EVENT_SELECTED_FOR_TOURNAMENT */],
    payload: virtualEventId
  };
};

var displayNewDivision = function displayNewDivision() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* DISPLAY_NEW_DIVISION_FOR_TOURNAMENT */]
  };
};

var cancelDivisionItemForm = function cancelDivisionItemForm() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* CANCEL_DIVISION_FORM_FOR_TOURNAMENT */]
  };
};

var hightlightSelectedEvent = function hightlightSelectedEvent(eventId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* HIGHTLIGHT_SELECTED_EVENT_FOR_TOURNAMENT_DIVISIONS */],
    payload: eventId
  };
};

var highlightSelectedVirtualEvent = function highlightSelectedVirtualEvent(virtualEventId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* HIGHLIGHT_SELECTED_VIRTUAL_EVENT_FOR_TOURNAMENT_DIVISIONS */],
    payload: virtualEventId
  };
};

var displayEvents = function displayEvents(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* DISPLAY_EVENTS_FOR_TOURNAMENT_DIVISIONS */],
    payload: data
  };
};

var displayVirtualEvents = function displayVirtualEvents(virtualEvents) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* DISPLAY_VIRTUAL_EVENTS_FOR_TOURNAMENT_DIVISIONS */],
    payload: virtualEvents
  };
};

var displayDivisions = function displayDivisions(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* DISPLAY_DIVISION_FOR_TOURNAMENT_EVENT */],
    payload: data
  };
};

var setDivisionDisplayDefault = function setDivisionDisplayDefault(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* SET_DIVISION_DISPLAY_DEFAULT */],
    payload: data
  };
};

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(465);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var initialState = {
  eventIdSelected: null,
  virtualEventIdSelected: null,
  selectedEventName: '',
  events: [],
  virtualEvents: [],
  divisions: []
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_DIVISION_IN_FORM_FOR_TOURNAMENT */]:
      {
        state.divisions.forEach(function (entry) {
          entry.editing = entry.id === payload;
        });
        return _extends({}, state, { divisions: [].concat(_toConsumableArray(state.divisions.filter(function (entry) {
            return entry.id;
          }))) // return only items with information (not empty ones)
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_EVENT_SELECTED_FOR_TOURNAMENT */]:
      {
        var event = state.events.find(function (item) {
          return item.id === payload;
        });
        var eventName = event ? event.name : '';
        var displayDefault = event ? event.displayDefault : false;
        var averageBased = event ? event.averageBased : false;
        var ageBased = event ? event.ageBased : false;
        var genderBased = event ? event.genderBased : false;

        return _extends({}, state, {
          eventIdSelected: payload,
          selectedEventName: eventName,
          displayDefault: displayDefault,
          selectedEventAverageBased: averageBased,
          selectedEventAgeBased: ageBased,
          selectedEventGenderBased: genderBased
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_VIRTUAL_EVENT_SELECTED_FOR_TOURNAMENT */]:
      {
        var _event = state.virtualEvents.find(function (item) {
          return item.id === payload;
        });
        var _eventName = _event ? _event.name : '';
        var _displayDefault = _event ? _event.displayDefault : false;
        var _averageBased = _event ? _event.averageBased : false;
        var _ageBased = _event ? _event.ageBased : false;
        var _genderBased = _event ? _event.genderBased : false;

        return _extends({}, state, {
          virtualEventIdSelected: payload,
          selectedEventName: _eventName,
          displayDefault: _displayDefault,
          selectedEventAverageBased: _averageBased,
          selectedEventAgeBased: _ageBased,
          selectedEventGenderBased: _genderBased
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* DISPLAY_NEW_DIVISION_FOR_TOURNAMENT */]:
      {
        return _extends({}, state, {
          displayDefault: true
        }, {
          divisions: [{ editing: true, name: '[Create Division]' }].concat(_toConsumableArray(state.divisions))
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* CANCEL_DIVISION_FORM_FOR_TOURNAMENT */]:
      {
        state.divisions.forEach(function (item) {
          item.editing = false;
        });
        return _extends({}, state, { divisions: [].concat(_toConsumableArray(state.divisions.filter(function (item) {
            return item.id;
          }))) // return only items with information (not empty ones)
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* HIGHTLIGHT_SELECTED_EVENT_FOR_TOURNAMENT_DIVISIONS */]:
      state.events.forEach(function (item) {
        item.highlight = item.id === payload;
      });
      return _extends({}, state, { events: [].concat(_toConsumableArray(state.events)) });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* HIGHLIGHT_SELECTED_VIRTUAL_EVENT_FOR_TOURNAMENT_DIVISIONS */]:
      state.virtualEvents.forEach(function (item) {
        item.highlight = item.id === payload;
      });
      return _extends({}, state, { virtualEvents: [].concat(_toConsumableArray(state.virtualEvents)) });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* DISPLAY_EVENTS_FOR_TOURNAMENT_DIVISIONS */]:
      return _extends({}, state, { events: payload });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* DISPLAY_VIRTUAL_EVENTS_FOR_TOURNAMENT_DIVISIONS */]:
      return _extends({}, state, { virtualEvents: payload });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* DISPLAY_DIVISION_FOR_TOURNAMENT_EVENT */]:
      return _extends({}, state, { divisions: payload });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* SET_DIVISION_DISPLAY_DEFAULT */]:
      state.displayDefault = !state.divisions.find(function (elem) {
        return elem.id == payload;
      }).isDefault;
      return _extends({}, state);
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_StandardCheckboxField_jsx__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_StandardSelectField_jsx__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(54);








var requiredValue = function requiredValue(value) {
  return value ? undefined : 'Required';
};

var BowlEventItemForm = function BowlEventItemForm(_ref) {
  var handleSubmit = _ref.handleSubmit,
      submitting = _ref.submitting,
      pristine = _ref.pristine,
      onCancel = _ref.onCancel,
      onSubmit = _ref.onSubmit,
      ageOptions = _ref.ageOptions,
      ageBased = _ref.ageBased,
      numberOfBowlers = _ref.numberOfBowlers,
      isHandicapped = _ref.isHandicapped,
      onIsHandicappedClick = _ref.onIsHandicappedClick,
      handicapAppliedOptions = _ref.handicapAppliedOptions,
      readOnly = _ref.readOnly,
      availableLocationOptions = _ref.availableLocationOptions,
      readOnlyEvent = _ref.readOnlyEvent,
      readOnlyDivisions = _ref.readOnlyDivisions,
      onDelete = _ref.onDelete;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'panel panel-primary animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-heading' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h4',
        { className: 'panel-title' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'small',
          null,
          'Specify event details:'
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-body' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        {
          onSubmit: handleSubmit(onSubmit),
          noValidate: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: {
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column'
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'fieldset',
            { className: 'event-fieldset' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'legend',
              { className: 'event-fieldset-legend' },
              'Basic Info'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              autoFocus: true,
              name: 'name',
              type: 'text',
              component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
              placeholder: 'Event Name',
              disabled: readOnly,
              tooltip: 'Use a descriptive name such as Team, Doubles, Singles',
              tooltipPosition: 'top'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'expenseFee',
              type: 'number',
              step: '0.25',
              min: '0',
              component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
              placeholder: 'Expense Fee',
              tooltip: 'Enter the Total Expense Fee for the event, i.e. the individual fee per bowler times the number of bowlers on the team',
              tooltipPosition: 'top',
              disabled: readOnly || readOnlyEvent
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'lineageFee',
              type: 'number',
              step: '0.25',
              min: '0',
              component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
              placeholder: 'Lineage Fee',
              tooltip: 'Enter the Total Linage Cost for the event, i.e. the individual fee per bowler times the number of bowlers on the team',
              tooltipPosition: 'top',
              disabled: readOnly || readOnlyEvent
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'prizeFee',
              type: 'number',
              step: '0.25',
              min: '0',
              component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
              placeholder: 'Prize Fee',
              tooltip: 'Enter the Total Prize Fee for the event, i.e. the individual fee per bowler times the number of bowlers on the team',
              tooltipPosition: 'top',
              disabled: readOnly || readOnlyEvent
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'isHandicapped',
              component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardCheckboxField_jsx__["a" /* default */],
              label: 'Handicap Event',
              onCustomChange: function onCustomChange(event) {
                return onIsHandicappedClick(event.target.checked);
              },
              disabled: readOnly
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'locationId',
              component: __WEBPACK_IMPORTED_MODULE_5_shared_StandardSelectField_jsx__["a" /* default */],
              options: availableLocationOptions,
              placeholder: 'Location',
              label: 'Location',
              simpleValue: true,
              searchable: false,
              disabled: readOnly,
              validate: [requiredValue]
            })
          ),
          isHandicapped ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'fieldset',
            { className: 'event-fieldset' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'legend',
              { className: 'event-fieldset-legend' },
              'Handicap Settings'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h5',
              null,
              'Enter percent and individual bowler average. Handicap is calculated as bowler or Team in the selected Tournament Management System.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-sm-4 col-xs-12' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                  name: 'handicapPercentage',
                  component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
                  label: 'Percentage',
                  type: 'number',
                  min: '1',
                  max: '100',
                  required: true,
                  disabled: readOnly
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-sm-4 col-xs-12' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                  name: 'handicapAverage',
                  component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
                  label: 'Average',
                  type: 'number',
                  min: '0',
                  max: '300',
                  required: true,
                  disabled: readOnly
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-sm-4 col-xs-12' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                  name: 'handicapApplied',
                  component: __WEBPACK_IMPORTED_MODULE_5_shared_StandardSelectField_jsx__["a" /* default */],
                  label: 'Applies As',
                  placeholder: 'Applies As',
                  options: handicapAppliedOptions,
                  disabled: readOnly
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'allowNegativeHandicap',
              component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardCheckboxField_jsx__["a" /* default */],
              label: 'Allow Negative Handicap',
              disabled: readOnly
            })
          ) : null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'fieldset',
            { className: 'event-fieldset' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'legend',
              { className: 'event-fieldset-legend' },
              'Roster Info'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'numberOfBowlers',
              type: 'number',
              step: '1',
              min: '0',
              component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
              placeholder: 'Bowlers Per Team',
              disabled: readOnly || readOnlyEvent
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'gamesPerSeries',
              type: 'number',
              step: '1',
              min: '0',
              component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
              placeholder: 'Games Per Series',
              disabled: readOnly
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'entriesPerLanePair',
              type: 'number',
              step: '1',
              min: '0',
              component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
              placeholder: 'Teams/Lane Pair',
              disabled: readOnly
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'fieldset',
            { className: 'event-fieldset' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'legend',
              { className: 'event-fieldset-legend' },
              'Entry Info'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'maxEntriesPerBowler',
              type: 'number',
              step: '1',
              min: '1',
              component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
              placeholder: 'Max Entries/Bowler',
              disabled: readOnly
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'numberOfBowlersThatMustBeDifferentPerTeam',
              type: 'number',
              step: '1',
              min: '0',
              component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
              placeholder: 'Number Of Bowlers That Must Be Different/Team',
              disabled: readOnly
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'fieldset',
            { className: 'event-fieldset' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'legend',
              { className: 'event-fieldset-legend' },
              'Division Settings'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h5',
              null,
              'Identify what will determine your divisions, if applicable.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'averageBased',
              component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardCheckboxField_jsx__["a" /* default */],
              label: 'Include Average divisions',
              disabled: readOnly || readOnlyDivisions
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'ageBased',
              component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardCheckboxField_jsx__["a" /* default */],
              label: 'Include Age divisions',
              disabled: readOnly || readOnlyDivisions
            }),
            ageBased ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'fieldset',
              { className: 'event-fieldset' },
              numberOfBowlers > 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                name: 'ageAppliesTo',
                placeholder: 'Age Option',
                component: __WEBPACK_IMPORTED_MODULE_5_shared_StandardSelectField_jsx__["a" /* default */],
                options: ageOptions,
                simpleValue: true,
                searchable: true,
                matchPos: 'start',
                disabled: readOnly || readOnlyDivisions,
                tooltip: 'Oldest Member typically used for Youth Events and Youngest Member for Senior events',
                tooltipPosition: 'top'
              }) : null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                name: 'ageVerificationDate',
                type: 'date',
                todayHighlight: true,
                component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
                placeholder: 'Date on which the bowler needs to be the specified age',
                label: 'Event Specific Age as of Date',
                disabled: readOnly || readOnlyDivisions,
                tooltip: 'Used to determine the starting date in an age specific event.  Adding date here applies the age to only this event. Leaving blank will inherit the Tournament wide age as of date',
                tooltipPosition: 'top'
              })
            ) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'genderBased',
              component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardCheckboxField_jsx__["a" /* default */],
              label: 'Include Gender divisions',
              disabled: readOnly || readOnlyDivisions
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-group text-right' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-link',
                disabled: submitting,
                onClick: onCancel
              },
              'Cancel'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              {
                type: 'submit',
                className: 'btn btn-primary btn-lg',
                disabled: pristine || submitting
              },
              submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
              ' ',
              'Save'
            )
          )
        )
      )
    )
  );
};

BowlEventItemForm.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired,
  pristine: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  ageOptions: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  ageBased: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  ageVerificationDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  numberOfBowlers: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  isHandicapped: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onIsHandicappedClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  handicapPercentage: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  handicapAverage: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  handicapAppliedOptions: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  readOnly: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  availableLocationOptions: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  readOnlyEvent: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  readOnlyDivisions: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onDelete: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'eventItemForm',
  onSubmitFail: function onSubmitFail(errors) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["o" /* default */])(errors);
  }
})(BowlEventItemForm);

/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BowlEventItemForm_jsx__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);





var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])('eventItemForm');

var mapStateToProps = function mapStateToProps(state) {
  return {
    validate: __WEBPACK_IMPORTED_MODULE_2__actions__["q" /* validateBowlEventForm */],
    ageOptions: state.tournament.events.ageOptions,
    ageBased: selector(state, 'ageBased'),
    numberOfBowlers: selector(state, 'numberOfBowlers'),
    isHandicapped: selector(state, 'isHandicapped'),
    handicapAppliedOptions: state.tournament.events.handicapAppliedOptions,
    readOnly: state.tournament.base.tournamentInfo.readOnly,
    availableLocationOptions: state.tournament.events.availableLocationOptions,
    readOnlyEvent: selector(state, 'readOnly'),
    readOnlyDivisions: selector(state, 'readOnlyDivisions')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["r" /* handleSaveBowlEventForm */])(data));
    },
    onCancel: function onCancel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["s" /* handleCancelBowlEventForm */])());
    },
    onIsHandicappedClick: function onIsHandicappedClick(checked) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["n" /* handleIsHandicappedClick */])(checked));
    },
    onDelete: function onDelete(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["o" /* handleDeleteBowlEventForm */])(data));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__BowlEventItemForm_jsx__["a" /* default */]);

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventItem_jsx__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BowlEventItemFormContainer_jsx__ = __webpack_require__(1036);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var BowlEventList = function BowlEventList(_ref) {
  var source = _ref.source,
      onEventItemClick = _ref.onEventItemClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group animated fadeIn' },
    source.map(function (item, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: index },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__EventItem_jsx__["a" /* default */], _extends({}, item, {
          onClick: function onClick() {
            return onEventItemClick(item.id);
          }
        })),
        item.editing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BowlEventItemFormContainer_jsx__["a" /* default */], null) : null
      );
    })
  );
};

BowlEventList.propTypes = {
  source: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  onEventItemClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = BowlEventList;

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BowlEventList_jsx__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(140);




var mapStateToProps = function mapStateToProps(state) {
  return {
    source: state.tournament.events.bowlEvents
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onEventItemClick: function onEventItemClick(eventId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["p" /* retrieveEvent */])(eventId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__BowlEventList_jsx__["a" /* default */]);

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);



var BowlEventItem = function BowlEventItem(_ref) {
  var id = _ref.id,
      name = _ref.name,
      editing = _ref.editing,
      _onClick = _ref.onClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("list-group-item hover-highlight", { "highlight animated flipInX": editing })
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'list-group-item-inner-wrapper cursor-pointer',
        onClick: function onClick() {
          return _onClick(id);
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h4',
        { className: 'list-group-item-heading' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-pencil' }),
        ' ',
        name
      )
    )
  );
};

BowlEventItem.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  name: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  editing: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = BowlEventItem;

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BowlEventListContainer_jsx__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VirtualEventListContainer_jsx__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_DisplayIf_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_StandardField_jsx__ = __webpack_require__(16);







var Events = function Events(_ref) {
  var eventsAreLinked = _ref.eventsAreLinked,
      canLinkEvents = _ref.canLinkEvents,
      bowlEventsQty = _ref.bowlEventsQty,
      virtualEventsQty = _ref.virtualEventsQty,
      ageVerificationDate = _ref.ageVerificationDate,
      readOnly = _ref.readOnly,
      onNewBowlEventClick = _ref.onNewBowlEventClick,
      onNewVirtualEventClick = _ref.onNewVirtualEventClick,
      onLinkedEventsToggleClick = _ref.onLinkedEventsToggleClick,
      onAgeVerificationDateChange = _ref.onAgeVerificationDateChange,
      canCreateEvent = _ref.canCreateEvent,
      canCreateVirtualEvent = _ref.canCreateVirtualEvent;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'flex center animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'col-xs-12 col-lg-8' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_shared_StandardField_jsx__["a" /* default */], {
        name: 'ageVerificationDate',
        type: 'date',
        label: 'Tournament Wide Age as of Date',
        placeholder: 'Date on which the bowler needs to be the specified age',
        input: { value: ageVerificationDate },
        meta: { error: null, touched: true },
        onCustomChange: function onCustomChange(value) {
          return onAgeVerificationDateChange(value);
        },
        disabled: readOnly,
        tooltip: 'Used to determine the starting date in an age specific tournament.  Adding the date here applies the age to ALL events in the tournament',
        tooltipPosition: 'top'
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex space-between vertical-center' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          null,
          'Bowled Events',
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            '(' + bowlEventsQty + ')'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_shared_DisplayIf_jsx__["a" /* default */],
          { condition: !readOnly && canLinkEvents },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-link flex right',
              disabled: !canCreateEvent,
              onClick: onLinkedEventsToggleClick
            },
            (eventsAreLinked ? 'Unlink' : 'Link') + ' Doubles/Singles'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_shared_DisplayIf_jsx__["a" /* default */],
          { condition: !readOnly },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'text-right' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-primary btn-lg',
                disabled: !canCreateEvent,
                onClick: onNewBowlEventClick
              },
              'Create Bowled Event'
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h5',
        null,
        'Events bowled by a participant – examples are team, doubles and singles'
      ),
      bowlEventsQty ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__BowlEventListContainer_jsx__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'alert alert-info' },
        'No information to display.'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex space-between vertical-center' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          null,
          'Virtual Events',
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            '(' + virtualEventsQty + ')'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_shared_DisplayIf_jsx__["a" /* default */],
          { condition: !readOnly },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'text-right' },
            bowlEventsQty ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-primary btn-lg',
                disabled: !canCreateVirtualEvent,
                onClick: onNewVirtualEventClick
              },
              'Create Virtual Event'
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-primary btn-lg disabled'
              },
              'Create Virtual Event'
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h5',
        null,
        'Virtual Events are not bowled, but are calculated using bowled scores. Examples: All events Scratch, 6 game combined, Senior All Events, etc.'
      ),
      virtualEventsQty ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__VirtualEventListContainer_jsx__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'alert alert-info' },
        'No information to display.'
      )
    )
  );
};

Events.propTypes = {
  eventsAreLinked: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  canLinkEvents: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  bowlEventsQty: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  virtualEventsQty: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  ageVerificationDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  readOnly: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onNewBowlEventClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onNewVirtualEventClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onLinkedEventsToggleClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onAgeVerificationDateChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  canCreateEvent: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  canCreateVirtualEvent: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool
};

Events.defaultProps = {
  bowlEventsQty: 0,
  virtualEventsQty: 0
};

/* harmony default export */ __webpack_exports__["a"] = Events;

/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Events_jsx__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(140);




var mapStateToProps = function mapStateToProps(state) {
  return {
    eventsAreLinked: state.tournament.base.tournamentInfo.linkEvents,
    canLinkEvents: state.tournament.base.tournamentInfo.canLinkEvents,
    bowlEventsQty: state.tournament.events.bowlEvents.length,
    virtualEventsQty: state.tournament.events.virtualEvents.length,
    ageVerificationDate: state.tournament.base.tournamentInfo.ageVerificationDate,
    readOnly: state.tournament.base.tournamentInfo.readOnly,
    canCreateEvent: state.tournament.base.tournamentInfo.canCreateEvent,
    canCreateVirtualEvent: state.tournament.base.tournamentInfo.canCreateVirtualEvent
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onNewBowlEventClick: function onNewBowlEventClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* handleNewBowlEventClick */])());
    },
    onNewVirtualEventClick: function onNewVirtualEventClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["d" /* handleNewVirtualEventClick */])());
    },
    onLinkedEventsToggleClick: function onLinkedEventsToggleClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["e" /* handleLinkedEventsToggleClick */])());
    },
    onAgeVerificationDateChange: function onAgeVerificationDateChange(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* handleAgeVerificationDateChanged */])(data));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__Events_jsx__["a" /* default */]);

/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);



var VirtualEventItem = function VirtualEventItem(_ref) {
  var id = _ref.id,
      name = _ref.name,
      editing = _ref.editing,
      _onClick = _ref.onClick,
      onHideFromCaptain = _ref.onHideFromCaptain,
      status = _ref.status,
      checked = _ref.checked;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("list-group-item hover-highlight", { "highlight animated flipInX": editing })
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'list-group-item-inner-wrapper cursor-pointer',
        onClick: function onClick() {
          return _onClick(id);
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h4',
        { className: 'list-group-item-heading' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-pencil' }),
        ' ',
        name
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'label',
        { onClick: function onClick(e) {
            return e.stopPropagation();
          } },
        'Hide From Captains\xA0',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
          type: 'checkbox',
          id: id,
          onChange: function onChange(event) {
            return onHideFromCaptain(event);
          },
          checked: checked,
          disabled: status === 'Archived' || status === 'All Registrations Closed'
        })
      )
    )
  );
};

VirtualEventItem.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  name: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  editing: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onHideFromCaptain: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = VirtualEventItem;

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_StandardCheckboxField_jsx__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_StandardSelectField_jsx__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(54);








var VirtualEventItemForm = function VirtualEventItemForm(_ref) {
  var handleSubmit = _ref.handleSubmit,
      submitting = _ref.submitting,
      pristine = _ref.pristine,
      onCancel = _ref.onCancel,
      onSubmit = _ref.onSubmit,
      ageOptions = _ref.ageOptions,
      showAgeOptions = _ref.showAgeOptions,
      ageBased = _ref.ageBased,
      linkableEvents = _ref.linkableEvents,
      onMappedEventsClick = _ref.onMappedEventsClick,
      onAgeBasedClick = _ref.onAgeBasedClick,
      showScoringMethods = _ref.showScoringMethods,
      showOwnedBy = _ref.showOwnedBy,
      scoringMethods = _ref.scoringMethods,
      ownedByOptions = _ref.ownedByOptions,
      isHandicapped = _ref.isHandicapped,
      onIsHandicappedClick = _ref.onIsHandicappedClick,
      handicapAppliedOptions = _ref.handicapAppliedOptions,
      readOnly = _ref.readOnly,
      readOnlyEvent = _ref.readOnlyEvent,
      readOnlyDivisions = _ref.readOnlyDivisions,
      onDelete = _ref.onDelete;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'panel panel-primary animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-heading' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h4',
        { className: 'panel-title' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'small',
          null,
          'Specify event details:'
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-body' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        {
          onSubmit: handleSubmit(onSubmit),
          noValidate: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: {
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column'
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'fieldset',
            { className: 'event-fieldset' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'legend',
              { className: 'event-fieldset-legend' },
              'Basic Info'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              autoFocus: true,
              name: 'name',
              type: 'text',
              component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
              placeholder: 'Virtual Event Name',
              disabled: readOnly,
              tooltip: 'Use a descriptive name such as All Events Handicap, Singles Scratch, etc.',
              tooltipPosition: 'top'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'expenseFee',
              type: 'number',
              step: '0.25',
              min: '0',
              component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
              placeholder: 'Expense Fee',
              tooltip: 'Enter the Total Expense Fee for the event, i.e. the individual fee per bowler times the number of bowlers on the team',
              tooltipPosition: 'top',
              disabled: readOnly || readOnlyEvent
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'lineageFee',
              type: 'number',
              step: '0.25',
              min: '0',
              component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
              placeholder: 'Lineage Fee',
              tooltip: 'Enter the Total Linage Cost for the event, i.e. the individual fee per bowler times the number of bowlers on the team',
              tooltipPosition: 'top',
              disabled: readOnly || readOnlyEvent
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'prizeFee',
              type: 'number',
              step: '0.25',
              min: '0',
              component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
              placeholder: 'Prize Fee',
              tooltip: 'Enter the Total Prize Fee for the event, i.e. the individual fee per bowler times the number of bowlers on the team',
              tooltipPosition: 'top',
              disabled: readOnly || readOnlyEvent
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'isHandicapped',
              component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardCheckboxField_jsx__["a" /* default */],
              label: 'Handicap Event',
              onCustomChange: function onCustomChange(event) {
                return onIsHandicappedClick(event.target.checked);
              },
              disabled: readOnly
            })
          ),
          isHandicapped ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'fieldset',
            { className: 'event-fieldset' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'legend',
              { className: 'event-fieldset-legend' },
              'Handicap Settings'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h5',
              null,
              'Enter percent and individual bowler average. Handicap is calculated as bowler or Team in the selected Tournament Management System.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-sm-4 col-xs-12' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                  name: 'handicapPercentage',
                  component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
                  label: 'Percentage',
                  type: 'number',
                  min: '1',
                  max: '100',
                  required: true,
                  disabled: readOnly
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-sm-4 col-xs-12' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                  name: 'handicapAverage',
                  component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
                  label: 'Average',
                  type: 'number',
                  min: '0',
                  max: '300',
                  required: true,
                  disabled: readOnly
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-sm-4 col-xs-12' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                  name: 'handicapApplied',
                  component: __WEBPACK_IMPORTED_MODULE_5_shared_StandardSelectField_jsx__["a" /* default */],
                  label: 'Applies As',
                  placeholder: 'Applies As',
                  options: handicapAppliedOptions,
                  disabled: readOnly
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'allowNegativeHandicap',
              component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardCheckboxField_jsx__["a" /* default */],
              label: 'Allow Negative Handicap',
              disabled: readOnly
            })
          ) : null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'fieldset',
            { className: 'event-fieldset' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'legend',
              { className: 'event-fieldset-legend' },
              'Division Settings'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h5',
              null,
              'Identify what will determine your divisions, if applicable.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'averageBased',
              component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardCheckboxField_jsx__["a" /* default */],
              label: 'Include Average divisions',
              disabled: readOnly || readOnlyDivisions
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'ageBased',
              component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardCheckboxField_jsx__["a" /* default */],
              label: 'Include Age divisions',
              onCustomChange: function onCustomChange(event) {
                return onAgeBasedClick(event.target.checked);
              },
              disabled: readOnly || readOnlyDivisions
            }),
            ageBased ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'fieldset',
              { className: 'event-fieldset' },
              showAgeOptions ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                name: 'ageAppliesTo',
                placeholder: 'Age Option',
                component: __WEBPACK_IMPORTED_MODULE_5_shared_StandardSelectField_jsx__["a" /* default */],
                options: ageOptions,
                simpleValue: true,
                searchable: true,
                matchPos: 'start',
                disabled: readOnly || readOnlyDivisions,
                tooltip: 'Oldest Member typically used for Youth Events and Youngest Member for Senior events',
                tooltipPosition: 'top'
              }) : null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                name: 'ageVerificationDate',
                type: 'date',
                todayHighlight: true,
                component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
                placeholder: 'Date on which the bowler needs to be the specified age.',
                label: 'Event Specific Age as of Date',
                disabled: readOnly || readOnlyDivisions,
                tooltip: 'Used to determine the starting date in an age specific event.  Adding date here applies the age to only this event. Leaving blank will inherit the Tournament wide age as of date',
                tooltipPosition: 'top'
              })
            ) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'genderBased',
              component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardCheckboxField_jsx__["a" /* default */],
              label: 'Include Gender divisions',
              disabled: readOnly || readOnlyDivisions
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'maps',
              options: linkableEvents,
              component: __WEBPACK_IMPORTED_MODULE_5_shared_StandardSelectField_jsx__["a" /* default */],
              onCustomChange: onMappedEventsClick,
              multi: true,
              placeholder: 'Linked Bowled Events',
              disabled: readOnly,
              tooltip: 'Select the Bowled Events that make up the virtual scores',
              tooltipPosition: 'top'
            }),
            showScoringMethods ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'scoringMethod',
              placeholder: 'Scoring Method',
              component: __WEBPACK_IMPORTED_MODULE_5_shared_StandardSelectField_jsx__["a" /* default */],
              options: scoringMethods,
              simpleValue: true,
              searchable: true,
              matchPos: 'start',
              disabled: readOnly
            }) : null,
            showOwnedBy ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'ownedBy',
              placeholder: 'Owned By',
              component: __WEBPACK_IMPORTED_MODULE_5_shared_StandardSelectField_jsx__["a" /* default */],
              options: ownedByOptions,
              simpleValue: true,
              searchable: true,
              matchPos: 'start',
              disabled: readOnly,
              tooltip: 'Team owned displays the Event under the bowled event while Bowler owned displays the event under a separate section in the Captains view',
              tooltipPosition: 'top'
            }) : null
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-group text-right' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-link',
                disabled: submitting,
                onClick: onCancel
              },
              'Cancel'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              {
                type: 'submit',
                className: 'btn btn-primary btn-lg',
                disabled: pristine || submitting
              },
              submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
              ' ',
              'Save'
            )
          )
        )
      )
    )
  );
};

VirtualEventItemForm.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired,
  pristine: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  ageOptions: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  showAgeOptions: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  ageBased: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  ageVerificationDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  linkableEvents: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  onMappedEventsClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onAgeBasedClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  showScoringMethods: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  showOwnedBy: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  scoringMethods: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  ownedByOptions: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  isHandicapped: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onIsHandicappedClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  handicapPercentage: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  handicapAverage: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  handicapAppliedOptions: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  readOnly: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  readOnlyEvent: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  readOnlyDivisions: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onDelete: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'virtualEventForm',
  onSubmitFail: function onSubmitFail(errors) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["o" /* default */])(errors);
  }
})(VirtualEventItemForm);

/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualEventItemForm_jsx__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);





var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])('virtualEventForm');

var mapStateToProps = function mapStateToProps(state) {
  return {
    validate: __WEBPACK_IMPORTED_MODULE_2__actions__["i" /* validateVirtualEventForm */],
    ageOptions: state.tournament.events.ageOptions,
    showAgeOptions: state.tournament.events.showAgeOptions,
    ageBased: selector(state, 'ageBased'),
    linkableEvents: state.tournament.events.linkableEvents,
    showScoringMethods: state.tournament.events.showScoringMethods,
    showOwnedBy: state.tournament.events.showOwnedBy,
    scoringMethods: state.tournament.events.scoringMethods,
    ownedByOptions: state.tournament.events.ownedByOptions,
    isHandicapped: selector(state, 'isHandicapped'),
    handicapAppliedOptions: state.tournament.events.handicapAppliedOptions,
    readOnly: state.tournament.base.tournamentInfo.readOnly,
    readOnlyEvent: selector(state, 'readOnly'),
    readOnlyDivisions: selector(state, 'readOnlyDivisions')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSubmit: function onSubmit(formData) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["j" /* handleSaveVirtualEventForm */])(formData));
    },
    onCancel: function onCancel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["k" /* handleCancelVirtualEventForm */])());
    },
    onMappedEventsClick: function onMappedEventsClick(fieldData) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["l" /* handleMappedEventsUpdate */])(fieldData));
    },
    onAgeBasedClick: function onAgeBasedClick(checked) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["m" /* handleAgeBasedClick */])(checked));
    },
    onIsHandicappedClick: function onIsHandicappedClick(checked) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["n" /* handleIsHandicappedClick */])(checked));
    },
    onDelete: function onDelete(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["o" /* handleDeleteBowlEventForm */])(data));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__VirtualEventItemForm_jsx__["a" /* default */]);

/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualEventItem_jsx__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VirtualEventItemFormContainer_jsx__ = __webpack_require__(1044);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var VirtualEventList = function VirtualEventList(_ref) {
  var source = _ref.source,
      onVirtualEventItemClick = _ref.onVirtualEventItemClick,
      onIsHideFromCaptainClick = _ref.onIsHideFromCaptainClick,
      tournamentId = _ref.tournamentId,
      status = _ref.status;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group animated fadeIn' },
    source.map(function (item, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: index },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__VirtualEventItem_jsx__["a" /* default */], _extends({}, item, {
          status: status,
          onClick: function onClick() {
            return onVirtualEventItemClick(item.id);
          },
          onHideFromCaptain: function onHideFromCaptain(event) {
            return onIsHideFromCaptainClick(tournamentId, item.id, event.target.checked);
          },
          checked: item.hideFromCaptains
        })),
        item.editing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__VirtualEventItemFormContainer_jsx__["a" /* default */], null) : null
      );
    })
  );
};

VirtualEventList.propTypes = {
  source: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  onVirtualEventItemClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onIsHideFromCaptainClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = VirtualEventList;

/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualEventList_jsx__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(140);




var mapStateToProps = function mapStateToProps(state) {
  return {
    source: state.tournament.events.virtualEvents,
    tournamentId: state.tournament.base.tournamentInfo.id,
    status: state.tournament.base.tournamentInfo.statusDisplayName
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onVirtualEventItemClick: function onVirtualEventItemClick(virtualEventId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["g" /* handleVirtualEventItemClick */])(virtualEventId));
    },
    onIsHideFromCaptainClick: function onIsHideFromCaptainClick(tournamentId, virtualEventId, event) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["h" /* handleIsHideFromCaptainClick */])(tournamentId, virtualEventId, event));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__VirtualEventList_jsx__["a" /* default */]);

/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(466);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return displayVirtualEventForm; });
/* unused harmony export setAgeVerificationDateForEvent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cancelVirtualEventForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return displayVirtualEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return displayNewVirtualEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return displayNewEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return displayEventForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return cancelEventItemForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return displayEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setAgeOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return displayVirtualEventAgeOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return displayVirtualEventScoringMethodOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return displayVirtualEventOwnedByOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getVirtualEventScoringMethods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getVirtualEventOwnedByOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getHandicapAppliedToOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getAvailableLocationOptions; });
/* unused harmony export deleteEventItemForm */


var displayVirtualEventForm = function displayVirtualEventForm(virtualEventId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_VIRTUAL_EVENT_FORM_FOR_TOURNAMENT_SETUP */],
    payload: virtualEventId
  };
};

var setAgeVerificationDateForEvent = function setAgeVerificationDateForEvent(ageVerificationDate) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_AGE_VERIFICATION_EVENT_FOR_EVENT */],
    payload: ageVerificationDate
  };
};

var cancelVirtualEventForm = function cancelVirtualEventForm() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* CANCEL_VIRTUAL_EVENT_FORM_FOR_TOURNAMENT_SETUP */]
  };
};

var displayVirtualEvents = function displayVirtualEvents(virtualEvents) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* DISPLAY_VIRTUAL_EVENTS_FOR_TOURNAMENT_SETUP */],
    payload: virtualEvents
  };
};

var displayNewVirtualEvent = function displayNewVirtualEvent() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* DISPLAY_NEW_VIRTUAL_EVENT_FOR_TOURNAMENT_SETUP */]
  };
};

var displayNewEvent = function displayNewEvent() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* DISPLAY_NEW_BOWL_EVENT_FOR_TOURNAMENT_SETUP */]
  };
};

var displayEventForm = function displayEventForm(id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* DISPLAY_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP */],
    payload: id
  };
};

var cancelEventItemForm = function cancelEventItemForm() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* CANCEL_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP */]
  };
};

var displayEvents = function displayEvents(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* DISPLAY_BOWL_EVENTS_FOR_TOURNAMENT_SETUP */],
    payload: data
  };
};

var setAgeOptions = function setAgeOptions(ageOptions) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* SET_AGE_OPTIONS_FOR_DIVISONS */],
    payload: ageOptions
  };
};

var displayVirtualEventAgeOptions = function displayVirtualEventAgeOptions(showAgeOptions) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* DISPLAY_VIRTUAL_EVENT_AGE_OPTIONS */],
    payload: showAgeOptions
  };
};

var displayVirtualEventScoringMethodOptions = function displayVirtualEventScoringMethodOptions(showMethodOptions) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* DISPLAY_VIRTUAL_EVENT_SCORING_METHOD_OPTIONS */],
    payload: showMethodOptions
  };
};

var displayVirtualEventOwnedByOptions = function displayVirtualEventOwnedByOptions(showOwnedBy) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* DISPLAY_VIRTUAL_EVENT_OWNED_BY_OPTIONS */],
    payload: showOwnedBy
  };
};

var getVirtualEventScoringMethods = function getVirtualEventScoringMethods(scoringMethods) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* GET_VIRTUAL_EVENT_SCORING_METHODS */],
    payload: scoringMethods
  };
};

var getVirtualEventOwnedByOptions = function getVirtualEventOwnedByOptions(ownedByOptions) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["o" /* GET_VIRTUAL_EVENT_OWNED_BY_OPTIONS */],
    payload: ownedByOptions
  };
};

var getHandicapAppliedToOptions = function getHandicapAppliedToOptions(handicapAppliedOptions) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["p" /* GET_HANDICAP_APPLIED_TO_OPTIONS_FOR_VIRTUAL_EVENT */],
    payload: handicapAppliedOptions
  };
};

var getAvailableLocationOptions = function getAvailableLocationOptions(availableLocationOptions) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["q" /* GET_AVAILABLE_LOCATION_OPTIONS_FOR_EVENT */],
    payload: availableLocationOptions
  };
};

var deleteEventItemForm = function deleteEventItemForm() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["r" /* DELETE_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP */]
  };
};

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(466);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var newBowlEventModel = {
  editing: true,
  name: '[New Event]'
};

var newVirtualEventModel = {
  editing: true,
  name: '[Create Virtual Event]'
};

var initialState = {
  bowlEvents: [],
  virtualEvents: [],
  ageOptions: [],
  linkableEvents: [],
  scoringMethods: [],
  ownedByOptions: [],
  showScoringMethods: false,
  showOwnedBy: false,
  showAgeOptions: false,
  handicapAppliedOptions: [],
  availableLocationOptions: []
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_VIRTUAL_EVENT_FORM_FOR_TOURNAMENT_SETUP */]:
      state.virtualEvents.forEach(function (entry) {
        entry.editing = entry.id === payload;
      });
      return _extends({}, state, {
        virtualEvents: [].concat(_toConsumableArray(state.virtualEvents.filter(function (entry) {
          return entry.id;
        }))), // return only items with information (not empty ones)
        linkableEvents: state.bowlEvents.map(function (event) {
          return {
            value: event.id,
            label: event.name
          };
        })
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* CANCEL_VIRTUAL_EVENT_FORM_FOR_TOURNAMENT_SETUP */]:
      state.virtualEvents.forEach(function (entry) {
        entry.editing = false;
      });
      return _extends({}, state, {
        virtualEvents: [].concat(_toConsumableArray(state.virtualEvents.filter(function (entry) {
          return entry.id;
        }))) // return only items with information (not empty ones)
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* DISPLAY_VIRTUAL_EVENTS_FOR_TOURNAMENT_SETUP */]:
      return payload ? _extends({}, state, {
        virtualEvents: [].concat(_toConsumableArray(payload))
      }) : state;
    case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* DISPLAY_NEW_VIRTUAL_EVENT_FOR_TOURNAMENT_SETUP */]:
      {
        return _extends({}, state, {
          virtualEvents: [_extends({}, newVirtualEventModel)].concat(_toConsumableArray(state.virtualEvents)),
          linkableEvents: state.bowlEvents.map(function (event) {
            return {
              value: event.id,
              label: event.name
            };
          })
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* DISPLAY_NEW_BOWL_EVENT_FOR_TOURNAMENT_SETUP */]:
      {
        return _extends({}, state, {
          bowlEvents: [_extends({}, newBowlEventModel)].concat(_toConsumableArray(state.bowlEvents))
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* DISPLAY_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP */]:
      {
        state.bowlEvents.forEach(function (entry) {
          entry.editing = entry.id === payload;
        });
        return _extends({}, state, {
          bowlEvents: [].concat(_toConsumableArray(state.bowlEvents.filter(function (entry) {
            return entry.id;
          }))) // return only items with information (not empty ones)
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* CANCEL_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP */]:
      {
        state.bowlEvents.forEach(function (entry) {
          entry.editing = false;
        });
        return _extends({}, state, {
          bowlEvents: [].concat(_toConsumableArray(state.bowlEvents.filter(function (entry) {
            return entry.id;
          }))) // return only items with information (not empty ones)
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* DISPLAY_BOWL_EVENTS_FOR_TOURNAMENT_SETUP */]:
      return _extends({}, state, {
        bowlEvents: [].concat(_toConsumableArray(payload))
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* SET_AGE_OPTIONS_FOR_DIVISONS */]:
      return _extends({}, state, {
        ageOptions: payload || initialState.ageOptions
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* DISPLAY_VIRTUAL_EVENT_AGE_OPTIONS */]:
      return _extends({}, state, {
        showAgeOptions: payload || initialState.showAgeOptions
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* GET_VIRTUAL_EVENT_SCORING_METHODS */]:
      return _extends({}, state, {
        scoringMethods: payload || initialState.scoringMethods
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["o" /* GET_VIRTUAL_EVENT_OWNED_BY_OPTIONS */]:
      return _extends({}, state, {
        ownedByOptions: payload || initialState.ownedByOptions
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* DISPLAY_VIRTUAL_EVENT_SCORING_METHOD_OPTIONS */]:
      return _extends({}, state, {
        showScoringMethods: payload || initialState.showScoringMethods
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* DISPLAY_VIRTUAL_EVENT_OWNED_BY_OPTIONS */]:
      return _extends({}, state, {
        showOwnedBy: payload || initialState.showOwnedBy
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["p" /* GET_HANDICAP_APPLIED_TO_OPTIONS_FOR_VIRTUAL_EVENT */]:
      return _extends({}, state, {
        handicapAppliedOptions: payload || initialState.handicapAppliedOptions
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_AGE_VERIFICATION_EVENT_FOR_EVENT */]:
      {
        return _extends({}, state, {
          ageVerificationDate: payload || initialState.ageVerificationDate
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["q" /* GET_AVAILABLE_LOCATION_OPTIONS_FOR_EVENT */]:
      return _extends({}, state, {
        availableLocationOptions: payload || initialState.availableLocationOptions
      });
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_StandardModal_jsx__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_util_formatCurrency__ = __webpack_require__(27);





Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_4_shared_util_formatCurrency__["a" /* formatCurrency */];

var DeactivateModal = function DeactivateModal(_ref) {
  var id = _ref.id,
      fee = _ref.fee,
      description = _ref.description,
      eventName = _ref.eventName,
      visible = _ref.visible,
      submitting = _ref.submitting,
      onCancelClick = _ref.onCancelClick,
      onDeactivateClick = _ref.onDeactivateClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_shared_StandardModal_jsx__["a" /* default */],
    {
      visible: visible,
      title: 'Add On Fee',
      onCloseClick: onCancelClick
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'alert alert-warning text-center' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        'The following fee will no longer be charged.'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'strong',
        { className: 'flex space-around' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          eventName
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          '$' + fee.formatCurrency(2)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          description
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'text-right' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          type: 'button',
          className: 'btn btn-link',
          disabled: submitting,
          onClick: onCancelClick
        },
        'Cancel'
      ),
      ' ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          type: 'button',
          className: 'btn btn-primary btn-lg',
          disabled: submitting,
          onClick: function onClick() {
            return onDeactivateClick(id);
          }
        },
        submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__["a" /* default */], null) : null,
        ' ',
        'Deactivate'
      )
    )
  );
};

DeactivateModal.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  fee: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  description: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  eventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  submitting: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onDeactivateClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

DeactivateModal.defaultProps = {
  id: '',
  fee: 0,
  description: '',
  eventName: '',
  visible: false,
  submitting: false
};

/* harmony default export */ __webpack_exports__["a"] = DeactivateModal;

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DeactivateModal_jsx__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(204);





var mapStateToProps = function mapStateToProps(state) {
  return state.tournament.fees.deactivateModal;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["c" /* cancelDeactivateModal */])());
    },
    onDeactivateClick: function onDeactivateClick(feeId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["e" /* deactivateFee */])(feeId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__DeactivateModal_jsx__["a" /* default */]);

/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_util_formatCurrency__ = __webpack_require__(27);




Number.prototype.formatCurrency = __WEBPACK_IMPORTED_MODULE_3_shared_util_formatCurrency__["a" /* formatCurrency */];

var FeeItem = function FeeItem(_ref) {
  var id = _ref.id,
      fee = _ref.fee,
      description = _ref.description,
      eventName = _ref.eventName,
      creationDate = _ref.creationDate,
      inactiveDate = _ref.inactiveDate,
      editing = _ref.editing,
      onSwitchClick = _ref.onSwitchClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('list-group-item-labeled hover-highlight', { 'highlight animated flipInX': editing })
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'list-group-item-labeled-child',
        style: { width: 150 }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Event'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        eventName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'list-group-item-labeled-child',
        style: { width: 75 }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Fee'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        '$' + fee.formatCurrency(2)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'list-group-item-labeled-child',
        style: { width: 200 }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Description'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        description
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'list-group-item-labeled-child',
        style: { width: 150 }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Creation Date'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        creationDate ? __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(creationDate).format('MMM Do, YYYY') : '-'
      )
    ),
    inactiveDate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'list-group-item-labeled-child',
        style: { width: 150 }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Inactive Date'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(inactiveDate).format('MMM Do, YYYY')
      )
    ) : null,
    id && !inactiveDate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'list-group-item-labeled-child',
        style: { width: 80 }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          className: 'btn btn-link',
          style: { padding: 0 },
          type: 'button',
          onClick: function onClick() {
            return onSwitchClick({
              id: id,
              fee: fee,
              description: description,
              eventName: eventName
            });
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', {
          className: 'fa fa-toggle-on',
          style: { fontSize: 36 }
        })
      )
    ) : null
  );
};

FeeItem.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  fee: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  description: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  eventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  creationDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  inactiveDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  editing: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onSwitchClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

FeeItem.defaultProps = {
  fee: 0
};

/* harmony default export */ __webpack_exports__["a"] = FeeItem;

/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);







var FeeItemForm = function FeeItemForm(_ref) {
  var eventTypes = _ref.eventTypes,
      handleSubmit = _ref.handleSubmit,
      submitting = _ref.submitting,
      onCancel = _ref.onCancel,
      onSubmit = _ref.onSubmit;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'form',
    {
      className: 'animated fadeIn',
      onSubmit: handleSubmit(onSubmit),
      noValidate: true
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-body' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'flex justify-content direction-column' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'panel-body-sub-heading' },
            'General (Required)'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            autofocus: true,
            component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__["a" /* default */],
            name: 'eventId',
            options: eventTypes,
            placeholder: 'Event',
            simpleValue: true,
            searchable: false
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'fee',
            type: 'number',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            step: '0.25',
            min: '0',
            placeholder: 'Add-On Fee ($)'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'description',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            placeholder: 'Fee Description - captain will see this on the fee line item',
            label: 'Description'
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-link',
              disabled: submitting,
              onClick: onCancel
            },
            'Cancel'
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'submit',
              className: 'btn btn-primary btn-lg',
              disabled: submitting
            },
            submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
            ' ',
            'Save'
          )
        )
      )
    )
  );
};

FeeItemForm.propTypes = {
  eventTypes: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired,
  onCancel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'feeItemForm'
})(FeeItemForm);

/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FeeItemForm_jsx__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(204);




var mapStateToProps = function mapStateToProps(state) {
  return {
    validate: __WEBPACK_IMPORTED_MODULE_2__actions__["f" /* validate */],
    eventTypes: state.tournament.fees.eventTypes
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["g" /* handleSave */])(data));
    },
    onCancel: function onCancel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["h" /* handleCancel */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__FeeItemForm_jsx__["a" /* default */]);

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FeeList_jsx__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(285);




var mapStateToProps = function mapStateToProps(state) {
  return {
    source: state.tournament.fees.activeFees
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onFeeItemSwitchClick: function onFeeItemSwitchClick(feeItem) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["i" /* displayDeactivateModal */])(feeItem));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__FeeList_jsx__["a" /* default */]);

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FeeList_jsx__ = __webpack_require__(467);



var mapStateToProps = function mapStateToProps(state) {
  return {
    source: state.tournament.fees.inactiveFees
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__FeeList_jsx__["a" /* default */]);

/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FeeListActiveContainer_jsx__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FeeListInactiveContainer_jsx__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DeactivateModalContainer_jsx__ = __webpack_require__(1050);





var Fees = function Fees(_ref) {
  var inactiveFeesQty = _ref.inactiveFeesQty,
      activeFeesQty = _ref.activeFeesQty,
      onNewFeeClick = _ref.onNewFeeClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'flex center animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'col-xs-12 col-lg-10' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex space-between vertical-center' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          null,
          'Active Fees',
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            '(' + activeFeesQty + ')'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-primary btn-lg',
              onClick: onNewFeeClick
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-plus' }),
            ' ',
            'New Fee'
          )
        )
      ),
      activeFeesQty ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__FeeListActiveContainer_jsx__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'alert alert-info' },
        'No information to display.'
      ),
      inactiveFeesQty ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          null,
          'Inactive Fees',
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            '(' + inactiveFeesQty + ')'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FeeListInactiveContainer_jsx__["a" /* default */], null)
      ) : null
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DeactivateModalContainer_jsx__["a" /* default */], null)
  );
};

Fees.propTypes = {
  inactiveFeesQty: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  activeFeesQty: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  onNewFeeClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = Fees;

/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Fees_jsx__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(204);




var mapStateToProps = function mapStateToProps(state) {
  return {
    inactiveFeesQty: state.tournament.fees.inactiveFees.length,
    activeFeesQty: state.tournament.fees.activeFees.length
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onNewFeeClick: function onNewFeeClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["d" /* handleNewFeeClick */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__Fees_jsx__["a" /* default */]);

/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(468);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var initialState = {
  activeFees: [],
  inactiveFees: [],
  eventTypes: [],
  deactivateModal: {}
};

var initialFeeState = {
  inactiveDate: null,
  creationDate: null,
  description: 'New Fee',
  eventName: 'Not Specified',
  fee: 0,
  id: '',
  statusDisplayName: 'New'
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DEACTIVATE_PROCESS_END_FOR_SETUP_FEES */]:
      return _extends({}, state, { deactivateModal: _extends({}, state.deactivateModal, {
          submitting: false
        }) });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEACTIVATE_PROCESS_START_FOR_SETUP_FEES */]:
      return _extends({}, state, { deactivateModal: _extends({}, state.deactivateModal, {
          submitting: true
        }) });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* CANCEL_DEACTIVATE_MODAL_FOR_SETUP_FEES */]:
      return _extends({}, state, { deactivateModal: {} });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* DISPLAY_DEACTIVATE_MODAL_FOR_SETUP_FEES */]:
      return payload ? _extends({}, state, { deactivateModal: _extends({}, payload, {
          visible: true
        }) }) : state;
    case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* SET_EVENT_TYPES_IN_STATE_FOR_SETUP_FEES */]:
      return payload ? _extends({}, state, { eventTypes: payload }) : state;
    case __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* DISPLAY_NEW_FEE_FOR_SETUP */]:
      return _extends({}, state, {
        activeFees: [_extends({}, initialFeeState, { editing: true })].concat(_toConsumableArray(state.activeFees))
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* CANCEL_FEE_FORM_FOR_SETUP */]:
      return _extends({}, state, {
        activeFees: state.activeFees.map(function (activeFee) {
          return feeReducer(activeFee, { type: type });
        }).filter(function (activeFee) {
          return activeFee.id;
        }) // return only items with information (not empty ones)
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* DISPLAY_INACTIVE_FEES_FOR_SETUP */]:
      return payload ? _extends({}, state, { inactiveFees: payload }) : state;
    case __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* DISPLAY_ACTIVE_FEES_FOR_SETUP */]:
      return payload ? _extends({}, state, { activeFees: payload }) : state;
    default:
      return state;
  }
};

var feeReducer = function feeReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref2 = arguments[1];
  var type = _ref2.type;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* CANCEL_FEE_FORM_FOR_SETUP */]:
      return _extends({}, state, { editing: false });
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GeneralForm_jsx__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_topBanner_actions__ = __webpack_require__(138);





var mapStateToProps = function mapStateToProps(state) {
  return {
    validate: __WEBPACK_IMPORTED_MODULE_2__actions__["m" /* validate */],
    submitLabel: 'Create',
    timeZones: state.tournament.general.timeZones,
    themes: state.tournament.general.themes,
    cards: state.tournament.general.cards,
    exportOptions: state.tournament.general.exportOptions,
    stripeAccountOptions: state.tournament.general.stripeAccounts,
    groupName: state.shared.auth.groupName,
    isAllowed: state.shared.auth.isAllowed,
    permissions: state.shared.auth.permissions,
    canEditTournamentName: true
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["n" /* handleSave */])(data));
    },
    onCancel: function onCancel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["o" /* handleCancel */])());
    },
    onPartnerLoginClick: function onPartnerLoginClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_topBanner_actions__["a" /* handlePartnerLoginClick */])());
    },
    onExitPartnerClick: function onExitPartnerClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_topBanner_actions__["b" /* handleExitPartnerClick */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__GeneralForm_jsx__["a" /* default */]);

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardSelectField_jsx__ = __webpack_require__(37);





var LocationItem = function LocationItem(_ref) {
  var id = _ref.id,
      name = _ref.name,
      address = _ref.address,
      city = _ref.city,
      state = _ref.state,
      zipCode = _ref.zipCode,
      phone = _ref.phone,
      certificationNumber = _ref.certificationNumber,
      locationName = _ref.locationName,
      locationSearchResults = _ref.locationSearchResults,
      editing = _ref.editing,
      saveable = _ref.saveable,
      selectable = _ref.selectable,
      onCancelClick = _ref.onCancelClick,
      onCenterChange = _ref.onCenterChange,
      onLocationNameChange = _ref.onLocationNameChange,
      onRemoveClick = _ref.onRemoveClick,
      onSaveClick = _ref.onSaveClick,
      onSearchClick = _ref.onSearchClick;
  return editing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'small',
      { className: 'form-group flex' },
      'Search by name, zip or certification #.  Name Requires minimum 3 characters.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
        classString: 'form-group flex',
        name: 'tournamentLocationName',
        type: 'input',
        component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */],
        placeholder: 'Location Name',
        value: locationName,
        onCustomChange: function onCustomChange(event) {
          return onLocationNameChange(event.target.value);
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
        classString: 'form-group flex',
        name: 'tournamentLocationZipCode',
        type: 'text',
        component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */],
        placeholder: 'Zip Code'
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
        classString: 'form-group flex',
        name: 'tournamentLocationCertificationNumber',
        type: 'text',
        component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */],
        placeholder: 'Certification #'
      }),
      selectable ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
        name: 'tournamentLocationSearchResults',
        component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardSelectField_jsx__["a" /* default */],
        options: locationSearchResults,
        placeholder: 'Center',
        label: 'Centers',
        simpleValue: true,
        searchable: true,
        onCustomChange: onCenterChange
      }) : null
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'form-group text-right' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          type: 'button',
          className: 'btn btn-link',
          onClick: function onClick() {
            return onCancelClick(id);
          } },
        ' ',
        'Cancel'
      ),
      ' ',
      saveable ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          type: 'button',
          className: 'btn btn-primary btn-lg',
          onClick: function onClick() {
            return onSaveClick(id);
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-search' }),
        ' ',
        'Add Location'
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          type: 'button',
          className: 'btn btn-primary btn-lg',
          onClick: function onClick() {
            return onSearchClick(id);
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-search' }),
        ' ',
        'Search'
      )
    )
  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group-item-labeled' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'b',
        null,
        '' + name
      ),
      certificationNumber.toString().includes("-") ? null : 'Certified #' + certificationNumber,
      certificationNumber.toString().includes("-") ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      address ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { style: { fontWeight: 300 } },
        address,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
      ) : null,
      city,
      ', ',
      state,
      ' ',
      zipCode,
      phone ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { style: { fontWeight: 300 } },
        phone
      ) : null
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { flexDirection: 'row' } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        { className: 'btn btn-link',
          type: 'button',
          onClick: function onClick() {
            return onRemoveClick(certificationNumber);
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-times' }),
        ' ',
        'Remove'
      )
    )
  );
};

LocationItem.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  name: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  address: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  city: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  state: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  zipCode: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  certificationNumber: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  phone: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  locationName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  locationSearchResults: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  editing: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  saveable: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  selectable: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onCenterChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onLocationNameChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onRemoveClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSaveClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSearchClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

LocationItem.defaultProps = {
  locationName: '',
  editing: false,
  saveable: false,
  selectable: false
};

/* harmony default export */ __webpack_exports__["a"] = LocationItem;

/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LocationItem_jsx__ = __webpack_require__(1060);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var LocationsPanel = function LocationsPanel(_ref) {
  var locationName = _ref.locationName,
      locations = _ref.locations,
      locationSearchResults = _ref.locationSearchResults,
      saveable = _ref.saveable,
      selectable = _ref.selectable,
      onAddLocationClick = _ref.onAddLocationClick,
      onCancelClick = _ref.onCancelClick,
      onCenterChange = _ref.onCenterChange,
      onLocationNameChange = _ref.onLocationNameChange,
      onRemoveClick = _ref.onRemoveClick,
      onSaveClick = _ref.onSaveClick,
      onSearchClick = _ref.onSearchClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'panel panel-default' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-heading' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h4',
        { className: 'panel-title' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Locations',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button',
              className: 'btn btn-link pull-right',
              onClick: onAddLocationClick },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-plus' }),
            ' ',
            'Add Location'
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-body' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group' },
        locations.map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__LocationItem_jsx__["a" /* default */], _extends({ key: index
          }, item, {
            locationName: locationName,
            locationSearchResults: locationSearchResults,
            saveable: saveable,
            selectable: selectable,
            onCancelClick: onCancelClick,
            onCenterChange: onCenterChange,
            onLocationNameChange: onLocationNameChange,
            onRemoveClick: onRemoveClick,
            onSaveClick: onSaveClick,
            onSearchClick: onSearchClick
          }));
        })
      )
    )
  );
};

LocationsPanel.propTypes = {
  locationName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  locations: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  locationSearchResults: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  saveable: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  selectable: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onAddLocationClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onCenterChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onLocationNameChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onRemoveClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSaveClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSearchClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

LocationsPanel.defaultProps = {
  locations: []
};

/* harmony default export */ __webpack_exports__["a"] = LocationsPanel;

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LocationsPanel_jsx__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(286);





var mapStateToProps = function mapStateToProps(state) {
  return {
    locationName: state.tournament.general.locationName,
    locationSearchResults: state.tournament.general.locationSearchResults,
    locations: state.tournament.general.locations,
    saveable: state.tournament.general.saveable,
    selectable: state.tournament.general.selectable
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onAddLocationClick: function onAddLocationClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["p" /* handleLocationAddClick */])());
    },
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["q" /* handleLocationCancelClick */])());
    },
    onCenterChange: function onCenterChange(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["r" /* handleCenterChange */])(data));
    },
    onLocationNameChange: function onLocationNameChange(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["w" /* handleLocationNameChange */])(data));
    },
    onRemoveClick: function onRemoveClick(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["s" /* handleLocationRemoveClick */])(data));
    },
    onSaveClick: function onSaveClick(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["t" /* handleLocationSaveClick */])(id));
    },
    onSearchClick: function onSearchClick(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["u" /* handleLocationSearchClick */])(id));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__LocationsPanel_jsx__["a" /* default */]);

/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var TagItem = function TagItem(_ref) {
  var label = _ref.label,
      value = _ref.value,
      onRemoveTagClick = _ref.onRemoveTagClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "list-group-item-labeled" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "list-group-item-labeled-child" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "b",
        null,
        "" + label
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "list-group-item-labeled-child",
        style: { flexDirection: 'row' } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        { className: "btn btn-link",
          type: "button",
          onClick: function onClick() {
            return onRemoveTagClick(value);
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-times" }),
        " ",
        'Remove'
      )
    )
  );
};

TagItem.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  value: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onRemoveTagClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

TagItem.defaultProps = {};

/* harmony default export */ __webpack_exports__["a"] = TagItem;

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_DisplayIf_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_MinimalField_jsx__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TagItem_jsx__ = __webpack_require__(1063);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var TagPanel = function TagPanel(_ref) {
  var isAddingTag = _ref.isAddingTag,
      onAddTagClick = _ref.onAddTagClick,
      onCancelClick = _ref.onCancelClick,
      onRemoveTagClick = _ref.onRemoveTagClick,
      onSaveClick = _ref.onSaveClick,
      onTagChange = _ref.onTagChange,
      onTagNameChange = _ref.onTagNameChange,
      tags = _ref.tags,
      tournamentTags = _ref.tournamentTags,
      value = _ref.value;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'panel panel-default' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-heading' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h4',
        { className: 'panel-title' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Tags'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'float-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button',
              className: 'btn btn-link pull-right',
              onClick: onAddTagClick },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-plus' }),
            ' ',
            'Create New Tag'
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-body' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
        name: 'tagId',
        component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__["a" /* default */],
        options: tags,
        placeholder: 'Available Tags',
        label: 'Choose your Tag:',
        simpleValue: true,
        searchable: false,
        onCustomChange: onTagChange
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_shared_DisplayIf_jsx__["a" /* default */],
        { condition: isAddingTag },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"],
          {
            classString: 'form-group flex',
            name: 'tournamentTagName',
            type: 'text',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_MinimalField_jsx__["a" /* default */],
            placeholder: 'Tag'
            //onCustomChange={e => onTagNameChange(e.target.value)}
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-primary-brand',
              onClick: function onClick() {
                return onCancelClick();
              }
            },
            'Cancel'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-primary',
              onClick: function onClick() {
                return onSaveClick(value);
              }
            },
            'Save'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group' },
        tournamentTags && tournamentTags.map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TagItem_jsx__["a" /* default */], _extends({ key: index
          }, item, {
            onRemoveTagClick: onRemoveTagClick
          }));
        })
      )
    )
  );
};

TagPanel.propTypes = {
  isAddingTag: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onAddTagClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onRemoveTagClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSaveClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onTagChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onTagNameChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  tags: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  tournamentTags: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  value: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

TagPanel.defaultProps = {
  isAddingTag: false,
  tags: [],
  tournamentTags: []
};

/* harmony default export */ __webpack_exports__["a"] = TagPanel;

/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TagPanel_jsx__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(168);




var mapStateToProps = function mapStateToProps(state) {
  return {
    canAssignTag: state.tournament.general.canAssignTag,
    canDeleteTag: state.tournament.general.canDeleteTag,
    isAddingTag: state.tournament.general.isAddingTag,
    tags: state.tournament.general.tags,
    tournamentTags: state.tournament.general.tournamentTags
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onAddTagClick: function onAddTagClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["v" /* handleTagAddClick */])());
    },
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["w" /* handleTagCancelClick */])());
    },
    onRemoveTagClick: function onRemoveTagClick(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["x" /* handleTagRemoveClick */])(data));
    },
    onSaveClick: function onSaveClick(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["y" /* handleTagSaveClick */])(id));
    },
    onTagChange: function onTagChange(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["z" /* handleTagChange */])(data));
    },
    onTagNameChange: function onTagNameChange(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["A" /* handleTagNameChange */])(data));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__TagPanel_jsx__["a" /* default */]);

/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GeneralForm_jsx__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_topBanner_actions__ = __webpack_require__(138);





var mapStateToProps = function mapStateToProps(state) {
  return {
    validate: __WEBPACK_IMPORTED_MODULE_2__actions__["m" /* validate */],
    submitLabel: 'Update',
    timeZones: state.tournament.general.timeZones,
    cards: state.tournament.general.cards,
    themes: state.tournament.general.themes,
    readOnly: state.tournament.base.tournamentInfo.readOnly,
    exportOptions: state.tournament.general.exportOptions,
    stripeAccountOptions: state.tournament.general.stripeAccounts,
    groupName: state.shared.auth.groupName,
    isAllowed: state.shared.auth.isAllowed,
    permissions: state.shared.auth.permissions,
    canEditTournamentName: state.tournament.base.tournamentInfo.canEditTournamentName,
    statusDisplayName: state.tournament.base.tournamentInfo.statusDisplayName
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["n" /* handleSave */])(data));
    },
    onCancel: function onCancel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["o" /* handleCancel */])());
    },
    onPartnerLoginClick: function onPartnerLoginClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_topBanner_actions__["a" /* handlePartnerLoginClick */])());
    },
    onExitPartnerClick: function onExitPartnerClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_topBanner_actions__["b" /* handleExitPartnerClick */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__GeneralForm_jsx__["a" /* default */]);

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(470);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  timeZones: [],
  managers: [],
  restrictions: [],
  tags: [],
  tagIndex: null,
  cards: [],
  themes: [],
  locations: [],
  exportOptions: [],
  exportSelection: null,
  stripeAccounts: [],
  cardSelection: null,
  stripeAccountSelection: null,
  locationSearchResults: []
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_CENTER_SAVE_BUTTON */]:
      {
        return _extends({}, state, {
          saveable: payload || initialState.saveable
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DISPLAY_CENTERS_DROPDOWN_LIST */]:
      {
        return _extends({}, state, {
          selectable: payload || initialState.selectable
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* DISPLAY_THEMES */]:
      return _extends({}, state, {
        themes: payload
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* DISPLAY_TIME_ZONES */]:
      return _extends({}, state, {
        timeZones: payload
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SET_CAN_ASSIGN_TAG */]:
      {
        return _extends({}, state, {
          canAssignTag: payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* SET_CAN_DELETE_TAG */]:
      {
        return _extends({}, state, {
          canDeleteTag: payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* SET_CARDS */]:
      {
        return _extends({}, state, {
          cards: payload || initialState.cards
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* SET_CARD_SELECTION */]:
      {
        return _extends({}, state, {
          cardSelection: payload || initialState.cardSelection
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* SET_IS_ADDING_TAG */]:
      {
        return _extends({}, state, {
          isAddingTag: payload || initialState.isAddingTag
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* SET_IS_NEW_TOURNAMENT */]:
      {
        return _extends({}, state, {
          isNewTournament: payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* SET_LOCATION_CERTIFICATION_NUMBER */]:
      {
        return _extends({}, state, {
          certificationNumber: payload || initialState.certificationNumber
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["p" /* SET_STRIPE_ACCOUNT_SELECTION */]:
      {
        return _extends({}, state, {
          stripeAccountSelection: payload || initialState.stripeAccountSelection
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["o" /* SET_STRIPE_ACCOUNTS */]:
      return _extends({}, state, {
        stripeAccounts: payload || initialState.stripeAccounts
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["r" /* SET_AVAILABLE_TAGS */]:
      {
        var tags = payload || initialState.tags;

        // Add editing flag
        tags.forEach(function (x) {
          return x.editing = false;
        });

        return _extends({}, state, {
          tags: tags
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["q" /* SET_TAG_INDEX */]:
      {
        return _extends({}, state, {
          tagIndex: payload || initialState.tagIndex
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* SET_TOURNAMENT_EXPORT_OPTIONS_IN_STATE */]:
      {
        return _extends({}, state, {
          exportOptions: payload || initialState.exportOptions
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* SET_TOURNAMENT_EXPORT_SELECTION_IN_STATE */]:
      {
        return _extends({}, state, {
          exportSelection: payload || initialState.exportSelection
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["v" /* SET_TOURNAMENT_LOCATION_EDITING */]:
      {
        return _extends({}, state, {
          locations: state.locations.map(function (m) {
            return m.id == payload ? _extends({}, m, { editing: !m.editing }) : _extends({}, m, { editing: false });
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* SET_TOURNAMENT_LOCATION_NAME_VALUE */]:
      return _extends({}, state, {
        locationName: payload
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["t" /* SET_TOURNAMENT_LOCATION_SEARCH_RESULTS */]:
      {
        return _extends({}, state, {
          locationSearchResults: payload || initialState.locationSearchResults
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["s" /* SET_TOURNAMENT_LOCATIONS_IN_STATE */]:
      {
        var locations = payload || initialState.managers;

        // Add editing flag
        locations.forEach(function (m) {
          return m.editing = false;
        });

        return _extends({}, state, {
          locations: locations
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["u" /* SET_TOURNAMENT_TAGS */]:
      {
        return _extends({}, state, {
          tournamentTags: payload
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["w" /* SET_IS_SUPER_USER */]:
      {
        return _extends({}, state, {
          isSuperUser: payload
        });
      }

    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_Link_jsx__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tournamentList_TournamentListContainer_jsx__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tournamentList_TournamentSearchContainer_jsx__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShowAllTournamentsCheckboxContainer_jsx__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_DisplayIf_jsx__ = __webpack_require__(12);







var SetupHome = function SetupHome(_ref) {
  var activeTournamentCount = _ref.activeTournamentCount,
      loadingTournaments = _ref.loadingTournaments,
      entries = _ref.entries,
      groupName = _ref.groupName,
      onPartnerLoginClick = _ref.onPartnerLoginClick,
      onExitPartnerClick = _ref.onExitPartnerClick,
      isAllowed = _ref.isAllowed,
      permissions = _ref.permissions;

  var canMigratePartnersFromV2 = permissions.find(function (permission) {
    return permission === "CanMigratePartnersFromV2";
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'flex center animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'col-xs-12 col-lg-8' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_shared_DisplayIf_jsx__["a" /* default */],
        { condition: isAllowed && canMigratePartnersFromV2 && groupName != undefined && groupName !== '' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-xs-12' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'alert alert-danger text-center' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3 text-left cursor-pointer', style: { fontSize: '10px', fontWeight: 'bold' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { onClick: onPartnerLoginClick },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-user' }),
                  ' Manage another Partner Hub'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-6 text-center' },
                'You are managing tournaments for ',
                groupName
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3 text-right cursor-pointer', style: { fontSize: '10px', fontWeight: 'bold' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { onClick: onExitPartnerClick },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-sign-out' }),
                  ' Exit Partner Hub Mode'
                )
              )
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'text-right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_shared_Link_jsx__["a" /* default */],
          {
            to: 'tournament/create',
            className: 'btn btn-primary btn-lg'
          },
          'Create New Tournament'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ShowAllTournamentsCheckboxContainer_jsx__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      activeTournamentCount > 6 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__tournamentList_TournamentSearchContainer_jsx__["a" /* default */], null) : null,
      loadingTournaments ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'alert alert-info' },
        'Loading tournament data.'
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        !entries || entries.length === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'alert alert-info' },
          'No tournaments found.'
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__tournamentList_TournamentListContainer_jsx__["a" /* default */], null)
      )
    )
  );
};

SetupHome.propTypes = {
  activeTournamentCount: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  loadingTournaments: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  entries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  groupName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onPartnerLoginClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onExitPartnerClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  isAllowed: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool
};

SetupHome.defaultProps = {
  entries: [],
  activeTournamentCount: 0
};

/* harmony default export */ __webpack_exports__["a"] = SetupHome;

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SetupHome_jsx__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_topBanner_actions__ = __webpack_require__(138);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var mapStateToProps = function mapStateToProps(state) {
  return _extends({}, state.tournament.tournamentList, {
    isAllowed: state.shared.auth.isAllowed,
    permissions: state.shared.auth.permissions,
    groupName: state.shared.auth.groupName
  });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onPartnerLoginClick: function onPartnerLoginClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_topBanner_actions__["a" /* handlePartnerLoginClick */])());
    },
    onExitPartnerClick: function onExitPartnerClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_topBanner_actions__["b" /* handleExitPartnerClick */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__SetupHome_jsx__["a" /* default */]);

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var ShowAllTournamentsCheckbox = function ShowAllTournamentsCheckbox(_ref) {
  var showAllTournaments = _ref.showAllTournaments,
      onShowAllTournamentChange = _ref.onShowAllTournamentChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'custom-checkbox-container',
      style: { margin: '0 15px' } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'checkbox',
      id: 'showAllTournaments',
      checked: showAllTournaments,
      onChange: function onChange(event) {
        return onShowAllTournamentChange(event.target.checked);
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'label',
      { htmlFor: 'showAllTournaments' },
      'Show All Tournaments'
    )
  );
};

ShowAllTournamentsCheckbox.propTypes = {
  showAllTournaments: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onShowAllTournamentChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

ShowAllTournamentsCheckbox.defaultProps = {
  showAllTournaments: false
};

/* harmony default export */ __webpack_exports__["a"] = ShowAllTournamentsCheckbox;

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShowAllTournamentsCheckbox_jsx__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tournamentList_actions__ = __webpack_require__(170);




var mapStateToProps = function mapStateToProps(state) {
  return {
    showAllTournaments: state.tournament.tournamentList.showAllTournaments
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onShowAllTournamentChange: function onShowAllTournamentChange(checked) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tournamentList_actions__["h" /* handleShowAllTournamentsChange */])(checked));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ShowAllTournamentsCheckbox_jsx__["a" /* default */]);

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_MinimalField_jsx__ = __webpack_require__(277);




var AdministratorItem = function AdministratorItem(_ref) {
  var id = _ref.id,
      email = _ref.email,
      isPrimary = _ref.isPrimary,
      editing = _ref.editing,
      onSaveClick = _ref.onSaveClick,
      onCancelClick = _ref.onCancelClick,
      onRemoveClick = _ref.onRemoveClick;
  return editing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group-item-labeled',
      style: { display: 'inherit' } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { paddingBottom: '8px' } }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"],
        {
          classString: 'form-group flex',
          name: 'tournamentAdministratorEmail',
          type: 'text',
          component: __WEBPACK_IMPORTED_MODULE_2_shared_MinimalField_jsx__["a" /* default */],
          placeholder: 'Administrator Email'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-primary-brand',
            onClick: function onClick() {
              return onCancelClick(id, email);
            }
          },
          'Cancel'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-primary',
            onClick: function onClick() {
              return onSaveClick(id, email);
            }
          },
          'Save'
        )
      )
    )
  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group-item-labeled' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { paddingBottom: '8px' } }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        '' + (email != null ? email.toLowerCase() : '{email unknown}')
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { flexDirection: 'row' } },
      !isPrimary ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        { className: 'btn btn-link',
          type: 'button',
          onClick: function onClick() {
            return onRemoveClick(id);
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-times' }),
        ' ',
        'Remove'
      ) : null
    )
  );
};

AdministratorItem.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  isPrimary: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  email: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  editing: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onSaveClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onRemoveClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

AdministratorItem.defaultProps = {
  isPrimary: false
};

/* harmony default export */ __webpack_exports__["a"] = AdministratorItem;

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AdministratorItem_jsx__ = __webpack_require__(1072);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var AdministratorsPanel = function AdministratorsPanel(_ref) {
  var administrators = _ref.administrators,
      onAddAdministratorClick = _ref.onAddAdministratorClick,
      onSaveClick = _ref.onSaveClick,
      onCancelClick = _ref.onCancelClick,
      onRemoveClick = _ref.onRemoveClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'panel panel-default' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-heading' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h4',
        { className: 'panel-title' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button',
              className: 'btn btn-link pull-right',
              onClick: onAddAdministratorClick },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-plus' }),
            ' ',
            'Add Administrator'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'administrators',
            type: 'hidden',
            component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */],
            style: { "float": "left" },
            label: 'Administrators',
            tooltip: 'A person who can process reservations/registrations, take payments, cancel entries, search entries, assist with squad moves, and other administrative duties',
            tooltipPosition: 'top'
          })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-body' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group' },
        administrators.map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AdministratorItem_jsx__["a" /* default */], _extends({ key: index
          }, item, {
            onSaveClick: onSaveClick,
            onCancelClick: onCancelClick,
            onRemoveClick: onRemoveClick }));
        })
      )
    )
  );
};

AdministratorsPanel.propTypes = {
  administrators: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  onAddAdministratorClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSaveClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onRemoveClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

AdministratorsPanel.defaultProps = {
  administrators: []
};

/* harmony default export */ __webpack_exports__["a"] = AdministratorsPanel;

/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdministratorsPanel_jsx__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(287);




var mapStateToProps = function mapStateToProps(state) {
  return {
    administrators: state.tournament.permissions.administrators
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onAddAdministratorClick: function onAddAdministratorClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["d" /* handleAdministratorAddClick */])());
    },
    onSaveClick: function onSaveClick(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["e" /* handleAdministratorSaveClick */])(id));
    },
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* handleAdministratorCancelClick */])());
    },
    onRemoveClick: function onRemoveClick(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["g" /* handleAdministratorRemoveClick */])(id));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AdministratorsPanel_jsx__["a" /* default */]);

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_MinimalField_jsx__ = __webpack_require__(277);




var ManagerItem = function ManagerItem(_ref) {
  var id = _ref.id,
      email = _ref.email,
      inheritedAccess = _ref.inheritedAccess,
      canEditPrimary = _ref.canEditPrimary,
      editing = _ref.editing,
      onSaveClick = _ref.onSaveClick,
      onEditClick = _ref.onEditClick,
      onCancelClick = _ref.onCancelClick,
      onRemoveClick = _ref.onRemoveClick;
  return editing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group-item-labeled',
      style: { display: 'inherit' } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"],
        {
          classString: 'form-group flex',
          name: 'tournamentManagerEmail',
          type: 'text',
          component: __WEBPACK_IMPORTED_MODULE_2_shared_MinimalField_jsx__["a" /* default */],
          placeholder: 'Manager Email'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-primary-brand',
            onClick: function onClick() {
              return onCancelClick(id, email);
            }
          },
          'Cancel'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-primary',
            onClick: function onClick() {
              return onSaveClick(id, email);
            }
          },
          'Save'
        )
      )
    )
  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group-item-labeled' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        '' + (email != null ? email.toLowerCase() : '{email unknown}')
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { flexDirection: 'row' } },
      canEditPrimary ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        { className: 'btn btn-link',
          type: 'button',
          onClick: function onClick() {
            return onEditClick(id, email);
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-pencil' }),
        ' ',
        'Edit'
      ) : null,
      !inheritedAccess ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        { className: 'btn btn-link',
          type: 'button',
          onClick: function onClick() {
            return onRemoveClick(id);
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-times' }),
        ' ',
        'Remove'
      ) : null
    )
  );
};

ManagerItem.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  email: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  inheritedAccess: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  canEditPrimary: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  editing: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onSaveClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onEditClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onRemoveClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

ManagerItem.defaultProps = {
  canEditPrimary: false,
  editing: false
};

/* harmony default export */ __webpack_exports__["a"] = ManagerItem;

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ManagerItem_jsx__ = __webpack_require__(1075);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var ManagersPanel = function ManagersPanel(_ref) {
  var managers = _ref.managers,
      userEmail = _ref.userEmail,
      onAddManagerClick = _ref.onAddManagerClick,
      onSaveClick = _ref.onSaveClick,
      onEditClick = _ref.onEditClick,
      onCancelClick = _ref.onCancelClick,
      onRemoveClick = _ref.onRemoveClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'panel panel-default' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-heading' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h4',
        { className: 'panel-title' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button',
              className: 'btn btn-link pull-right',
              onClick: onAddManagerClick },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-plus' }),
            ' ',
            'Add Manager'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'managers',
            type: 'hidden',
            component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */],
            style: { "float": "left" },
            label: 'Managers',
            tooltip: 'A person who can create tournament, update tournament set up, and update capacity levels',
            tooltipPosition: 'top'
          })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel-body' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group' },
        managers.map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ManagerItem_jsx__["a" /* default */], _extends({ key: index
          }, item, {
            canEditPrimary: item.email != null && item.email.toLowerCase() == userEmail.toLowerCase(),
            onSaveClick: onSaveClick,
            onEditClick: onEditClick,
            onCancelClick: onCancelClick,
            onRemoveClick: onRemoveClick }));
        })
      )
    )
  );
};

ManagersPanel.propTypes = {
  managers: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  userEmail: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onAddManagerClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSaveClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onEditClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onRemoveClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

ManagersPanel.defaultProps = {
  managers: []
};

/* harmony default export */ __webpack_exports__["a"] = ManagersPanel;

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ManagersPanel_jsx__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(287);




var mapStateToProps = function mapStateToProps(state) {
  return {
    managers: state.tournament.permissions.managers,
    userEmail: state.shared.auth.email
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onAddManagerClick: function onAddManagerClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["h" /* handleManagerAddClick */])());
    },
    onSaveClick: function onSaveClick(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["i" /* handleManagerSaveClick */])(id));
    },
    onEditClick: function onEditClick(id, email) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["j" /* handleManagerEditClick */])(id, email));
    },
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["k" /* handleManagerCancelClick */])());
    },
    onRemoveClick: function onRemoveClick(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["l" /* handleManagerRemoveClick */])(id));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ManagersPanel_jsx__["a" /* default */]);

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ManagersPanelContainer_jsx__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AdministratorsPanelContainer_jsx__ = __webpack_require__(1074);








var PermissionsForm = function PermissionsForm() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'flex center animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'form',
      {
        className: 'col-xs-12 col-md-10 col-lg-8' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-primary' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ManagersPanelContainer_jsx__["a" /* default */], null)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-primary' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AdministratorsPanelContainer_jsx__["a" /* default */], null)
      )
    )
  );
};

PermissionsForm.propTypes = {
  error: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  pristine: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired,
  readOnly: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* permissionsFormName */],
  onSubmitFail: function onSubmitFail(errors) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["o" /* default */])(errors);
  }
})(PermissionsForm);

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PermissionsForm_jsx__ = __webpack_require__(1078);



var mapStateToProps = function mapStateToProps(state) {
  return {
    readOnly: state.tournament.base.tournamentInfo.readOnly
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__PermissionsForm_jsx__["a" /* default */]);

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(205);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toggleTournamentManagerEditing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setTournamentManagers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return toggleTournamentAdministratorEditing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setTournamentAdministrators; });


var toggleTournamentManagerEditing = function toggleTournamentManagerEditing(id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_TOURNAMENT_MANAGER_EDITING */],
    payload: id
  };
};

var setTournamentManagers = function setTournamentManagers(managers) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_TOURNAMENT_MANAGERS_IN_STATE */],
    payload: managers
  };
};

var toggleTournamentAdministratorEditing = function toggleTournamentAdministratorEditing(id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_TOURNAMENT_ADMINISTRATOR_EDITING */],
    payload: id
  };
};

var setTournamentAdministrators = function setTournamentAdministrators(administrators) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* SET_TOURNAMENT_ADMINISTRATORS_IN_STATE */],
    payload: administrators
  };
};

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(205);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  managers: [],
  administrators: []
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_TOURNAMENT_MANAGERS_IN_STATE */]:
      {
        var managers = payload || initialState.managers;

        // Add editing flag
        managers.forEach(function (m) {
          return m.editing = false;
        });

        return _extends({}, state, {
          managers: managers
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_TOURNAMENT_MANAGER_EDITING */]:
      {
        return _extends({}, state, {
          managers: state.managers.map(function (m) {
            return m.id == payload ? _extends({}, m, { editing: !m.editing }) : _extends({}, m, { editing: false });
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* SET_TOURNAMENT_ADMINISTRATORS_IN_STATE */]:
      {
        var administrators = payload || initialState.administrators;

        // Add editing flag
        administrators.forEach(function (m) {
          return m.editing = false;
        });

        return _extends({}, state, {
          administrators: administrators
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_TOURNAMENT_ADMINISTRATOR_EDITING */]:
      {
        return _extends({}, state, {
          administrators: state.administrators.map(function (m) {
            return m.id == payload ? _extends({}, m, { editing: !m.editing }) : _extends({}, m, { editing: false });
          })
        });
      }

    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_reducer__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__general_reducer__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__permissions_reducer__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tournamentList_reducer__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__squads_reducer__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__divisions_reducer__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__capacity_reducer__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__status_reducer__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fees_reducer__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__restrictions_bundles_reducer__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__restrictions_reducer__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(464);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };















var initialState = {
  tournamentInfo: {}
};

var base = function base() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_12__constants__["a" /* SET_TOURNAMENT_FOR_SETUP */]:
      return _extends({}, state, {
        tournamentInfo: payload || initialState.tournamentInfo
      });
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  base: base,
  events: __WEBPACK_IMPORTED_MODULE_1__events_reducer__["a" /* default */],
  general: __WEBPACK_IMPORTED_MODULE_2__general_reducer__["a" /* default */],
  permissions: __WEBPACK_IMPORTED_MODULE_3__permissions_reducer__["a" /* default */],
  tournamentList: __WEBPACK_IMPORTED_MODULE_4__tournamentList_reducer__["a" /* default */],
  squads: __WEBPACK_IMPORTED_MODULE_5__squads_reducer__["a" /* default */],
  divisions: __WEBPACK_IMPORTED_MODULE_6__divisions_reducer__["a" /* default */],
  capacity: __WEBPACK_IMPORTED_MODULE_7__capacity_reducer__["a" /* default */],
  status: __WEBPACK_IMPORTED_MODULE_8__status_reducer__["a" /* default */],
  fees: __WEBPACK_IMPORTED_MODULE_9__fees_reducer__["a" /* default */],
  bundling: __WEBPACK_IMPORTED_MODULE_10__restrictions_bundles_reducer__["a" /* default */],
  restrictions: __WEBPACK_IMPORTED_MODULE_11__restrictions_reducer__["a" /* default */]
});

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardCheckboxField_jsx__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_Submitting_jsx__ = __webpack_require__(35);






var Restrictions = function Restrictions(_ref) {
  var pristine = _ref.pristine,
      submitting = _ref.submitting,
      handleSubmit = _ref.handleSubmit,
      onCancel = _ref.onCancel,
      onSubmit = _ref.onSubmit,
      requireRosterBeforeCheckout = _ref.requireRosterBeforeCheckout,
      enforceMinimumCaptainAge = _ref.enforceMinimumCaptainAge,
      readOnly = _ref.readOnly;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'form',
      {
        className: 'animated fadeIn',
        onSubmit: handleSubmit(onSubmit),
        noValidate: true
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex center animated fadeIn' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'col-xs-12 col-lg-10' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'panel panel-primary' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'panel-heading' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                { className: 'panel-title' },
                'Tournament Restrictions'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'panel-body row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                    name: 'enforceMinimumCaptainAge',
                    component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardCheckboxField_jsx__["a" /* default */],
                    label: 'Enforce a minimum captain age',
                    disabled: readOnly
                  }),
                  enforceMinimumCaptainAge ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                      name: 'minimumCaptainAge',
                      type: 'number',
                      component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */],
                      step: '1',
                      min: '0',
                      placeholder: 'Minimum Captain Age',
                      disabled: readOnly
                    })
                  ) : null
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                    name: 'showCalculatedDivisionToCaptain',
                    component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardCheckboxField_jsx__["a" /* default */],
                    label: 'Show Calculated Division to Captain',
                    disabled: readOnly
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                    name: 'requireRosterBeforeCheckout',
                    component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardCheckboxField_jsx__["a" /* default */],
                    label: 'Require roster to be filled out before checkout',
                    disabled: readOnly
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                  name: 'restrictBowlersToActiveMembership',
                  component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardCheckboxField_jsx__["a" /* default */],
                  label: 'Restrict bowlers to active membership',
                  disabled: readOnly
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                  name: 'restrictBowlersToYouthMembership',
                  component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardCheckboxField_jsx__["a" /* default */],
                  label: 'Restrict bowlers to youth membership',
                  disabled: readOnly
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                  name: 'blockFailedDivisionCalculation',
                  component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardCheckboxField_jsx__["a" /* default */],
                  label: 'Enforce Divisions when setting rosters',
                  disabled: readOnly || !requireRosterBeforeCheckout
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                  name: 'allowChangeBetweenFreeEvents',
                  component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardCheckboxField_jsx__["a" /* default */],
                  label: 'Allow transfers between free events',
                  disabled: readOnly
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                  name: 'enforceMaxEntries',
                  component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardCheckboxField_jsx__["a" /* default */],
                  label: 'Enforce Max Entries',
                  disabled: readOnly
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-12' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                  name: 'termsUrl',
                  type: 'text',
                  component: __WEBPACK_IMPORTED_MODULE_2_shared_StandardField_jsx__["a" /* default */],
                  placeholder: 'A link to terms & conditions that will be shown to captains prior to checkout (optional)',
                  label: 'Terms & Conditions/Rules Link',
                  maxLength: '255',
                  disabled: readOnly
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-12' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { style: { marginTop: '10px', borderTopWidth: '3px' } })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group text-right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-xs-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    {
                      type: 'button',
                      className: 'btn btn-link',
                      disabled: submitting,
                      onClick: onCancel
                    },
                    'Cancel'
                  ),
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    {
                      type: 'submit',
                      className: 'btn btn-primary btn-lg',
                      disabled: pristine || submitting
                    },
                    submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_Submitting_jsx__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
                    ' ',
                    'Save'
                  )
                )
              )
            )
          )
        )
      )
    )
  );
};

Restrictions.propTypes = {
  pristine: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  onCancel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  enforceMinimumCaptainAge: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  readOnly: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  requireRosterBeforeCheckout: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  restrictBowlersToYouthMembership: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  restrictBowlersToActiveMembership: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  termsUrl: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  blockFailedDivisionCalculation: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'tournamentRestrictions'
})(Restrictions);

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Restrictions_jsx__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(471);





var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["formValueSelector"])('tournamentRestrictions');

var mapStateToProps = function mapStateToProps(state) {
  return {
    enforceMinimumCaptainAge: selector(state, 'enforceMinimumCaptainAge'),
    requireRosterBeforeCheckout: selector(state, 'requireRosterBeforeCheckout'),
    restrictBowlersToActiveMembership: selector(state, 'restrictBowlersToActiveMembership'),
    restrictBowlersToYouthMembership: selector(state, 'restrictBowlersToYouthMembership'),
    blockFailedDivisionCalculation: selector(state, 'blockFailedDivisionCalculation'),
    validate: __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* validate */],
    readOnly: state.tournament.base.tournamentInfo.readOnly,
    termsUrl: selector(state, 'termsUrl')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["c" /* handleSave */])(data));
    },
    onCancel: function onCancel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* handleCancel */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__Restrictions_jsx__["a" /* default */]);

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RestrictionsContainer_jsx__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bundles_BundlesContainer_jsx__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bundles_DeactivateModalContainer_jsx__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);






var RestrictionsTab = function RestrictionsTab() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'flex center animated fadeIn' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-xs-12 col-lg-10' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_error_ErrorListContainer_jsx__["a" /* default */], null)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bundles_BundlesContainer_jsx__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bundles_DeactivateModalContainer_jsx__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RestrictionsContainer_jsx__["a" /* default */], null)
  );
};

/* harmony default export */ __webpack_exports__["a"] = RestrictionsTab;

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RestrictionsTab_jsx__ = __webpack_require__(1085);



/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])()(__WEBPACK_IMPORTED_MODULE_1__RestrictionsTab_jsx__["a" /* default */]);

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BundlingRuleListActiveContainer_jsx__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_DisplayIf_jsx__ = __webpack_require__(12);




var Bundles = function Bundles(_ref) {
  var activeBundlingRuleQty = _ref.activeBundlingRuleQty,
      onNewBundlingRuleClick = _ref.onNewBundlingRuleClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'flex center animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'col-xs-12 col-lg-10' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel panel-primary' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'panel-heading row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-sm-6' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'panel-title' },
              'Bundling Rules'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-sm-6' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'text-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_shared_DisplayIf_jsx__["a" /* default */],
                { condition: !activeBundlingRuleQty },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-primary btn-lg',
                    type: 'button',
                    onClick: onNewBundlingRuleClick },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-plus' }),
                  ' ',
                  'New Bundling Rule'
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'panel-body' },
          activeBundlingRuleQty ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__BundlingRuleListActiveContainer_jsx__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'alert alert-info' },
            'No active rule to display.'
          )
        )
      )
    )
  );
};

Bundles.propTypes = {
  activeBundlingRuleQty: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  onNewBundlingRuleClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = Bundles;

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Bundles_jsx__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(206);




var mapStateToProps = function mapStateToProps(state) {
  return {
    activeBundlingRuleQty: state.tournament.bundling.activeRules.length
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onNewBundlingRuleClick: function onNewBundlingRuleClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["d" /* handleNewBundlingRuleClick */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__Bundles_jsx__["a" /* default */]);

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__ = __webpack_require__(12);





var BundlingRuleItem = function BundlingRuleItem(_ref) {
  var id = _ref.id,
      quantity = _ref.quantity,
      parentEventName = _ref.parentEventName,
      childEventName = _ref.childEventName,
      creationDate = _ref.creationDate,
      inactiveDate = _ref.inactiveDate,
      editing = _ref.editing,
      onSwitchClick = _ref.onSwitchClick,
      description = _ref.description;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('list-group-item-labeled hover-highlight', { 'highlight animated flipInX': editing })
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'list-group-item-labeled-child'
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Rule ',
        creationDate ? '(Created: ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(creationDate).format('MMM Do, YYYY') + ')' : ''
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        'Buying 1 ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          parentEventName,
          ' Entry'
        ),
        ' allows purchase of ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          quantity
        ),
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          childEventName,
          ' ',
          quantity === 1 ? 'Entry' : 'Entries'
        ),
        ' on the next day.'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
        { condition: description === 'Split squad bundling is active.' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          description
        )
      )
    ),
    id && !inactiveDate && description !== 'Split squad bundling is active.' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'list-group-item-labeled-child',
        style: { width: 80 }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          className: 'btn btn-link',
          style: { padding: 0 },
          type: 'button',
          onClick: function onClick() {
            return onSwitchClick({
              id: id,
              quantity: quantity,
              parentEventName: parentEventName,
              childEventName: childEventName,
              description: description
            });
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', {
          className: 'fa fa-toggle-on',
          style: { fontSize: 36 }
        })
      )
    ) : null
  );
};

BundlingRuleItem.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  quantity: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  parentEventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  childEventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  creationDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  inactiveDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  editing: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onSwitchClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  description: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

/* harmony default export */ __webpack_exports__["a"] = BundlingRuleItem;

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);







var BundlingRuleItemForm = function BundlingRuleItemForm(_ref) {
  var eventTypes = _ref.eventTypes,
      handleSubmit = _ref.handleSubmit,
      submitting = _ref.submitting,
      onCancel = _ref.onCancel,
      onSubmit = _ref.onSubmit;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'form',
    {
      className: 'animated fadeIn',
      onSubmit: handleSubmit(onSubmit),
      noValidate: true
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-primary' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-body' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'flex justify-content direction-column' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'panel-body-sub-heading' },
            'General (Required)'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            autofocus: true,
            component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__["a" /* default */],
            name: 'parentEventId',
            options: eventTypes,
            placeholder: 'Parent Event',
            simpleValue: true,
            searchable: false
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: 'quantity',
            type: 'number',
            component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
            step: '1',
            min: '0',
            placeholder: 'Quantity'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__["a" /* default */],
            name: 'childEventId',
            options: eventTypes,
            placeholder: 'Child Event',
            simpleValue: true,
            searchable: false
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group text-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-link',
              disabled: submitting,
              onClick: onCancel
            },
            'Cancel'
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'submit',
              className: 'btn btn-primary btn-lg',
              disabled: submitting
            },
            submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
            ' ',
            'Save'
          )
        )
      )
    )
  );
};

BundlingRuleItemForm.propTypes = {
  eventTypes: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired,
  onCancel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'bundlingRuleItemForm'
})(BundlingRuleItemForm);

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BundlingRuleItemForm_jsx__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(206);




var mapStateToProps = function mapStateToProps(state) {
  return {
    validate: __WEBPACK_IMPORTED_MODULE_2__actions__["e" /* validate */],
    eventTypes: state.tournament.bundling.eventTypes
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* handleSave */])(data));
    },
    onCancel: function onCancel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["g" /* handleCancel */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__BundlingRuleItemForm_jsx__["a" /* default */]);

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BundlingRuleItem_jsx__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BundlingRuleItemFormContainer_jsx__ = __webpack_require__(1091);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var BundlingRuleList = function BundlingRuleList(_ref) {
  var source = _ref.source,
      onBundlingRuleItemSwitchClick = _ref.onBundlingRuleItemSwitchClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group animated fadeIn' },
    source.map(function (item, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: index },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__BundlingRuleItem_jsx__["a" /* default */], _extends({}, item, {
          onSwitchClick: onBundlingRuleItemSwitchClick
        })),
        item.editing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BundlingRuleItemFormContainer_jsx__["a" /* default */], null) : null
      );
    })
  );
};

BundlingRuleList.propTypes = {
  source: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  onBundlingRuleItemSwitchClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = BundlingRuleList;

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BundlingRuleList_jsx__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(288);




var mapStateToProps = function mapStateToProps(state) {
  return {
    source: state.tournament.bundling.activeRules
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onBundlingRuleItemSwitchClick: function onBundlingRuleItemSwitchClick(ruleItem) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["h" /* displayDeactivateModal */])(ruleItem));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__BundlingRuleList_jsx__["a" /* default */]);

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_StandardModal_jsx__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);





var DeactivateModal = function DeactivateModal(_ref) {
  var id = _ref.id,
      quantity = _ref.quantity,
      parentEventName = _ref.parentEventName,
      childEventName = _ref.childEventName,
      visible = _ref.visible,
      submitting = _ref.submitting,
      onCancelClick = _ref.onCancelClick,
      onDeactivateClick = _ref.onDeactivateClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_shared_StandardModal_jsx__["a" /* default */],
    {
      visible: visible,
      title: 'Bundling Rule',
      onCloseClick: onCancelClick
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'alert alert-warning text-center' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        'The following bundling rule will no longer apply.'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'strong',
        { className: 'flex space-around' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Buying 1 ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            null,
            parentEventName,
            ' Entry'
          ),
          ' allows purchase of ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            null,
            quantity
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            null,
            childEventName,
            ' ',
            quantity === 1 ? 'Entry' : 'Entries'
          ),
          ' on the next day.'
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'text-right' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          type: 'button',
          className: 'btn btn-link',
          disabled: submitting,
          onClick: onCancelClick
        },
        'Cancel'
      ),
      ' ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          type: 'button',
          className: 'btn btn-primary btn-lg',
          disabled: submitting,
          onClick: function onClick() {
            return onDeactivateClick(id);
          }
        },
        submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__["a" /* default */], null) : null,
        ' ',
        'Deactivate'
      )
    )
  );
};

DeactivateModal.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  quantity: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  parentEventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  childEventName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  submitting: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onDeactivateClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = DeactivateModal;

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DeactivateModal_jsx__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(206);





var mapStateToProps = function mapStateToProps(state) {
  return state.tournament.bundling.deactivateModal;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["c" /* cancelDeactivateModal */])());
    },
    onDeactivateClick: function onDeactivateClick(ruleId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["c" /* deactivateBundlingRule */])(ruleId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__DeactivateModal_jsx__["a" /* default */]);

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(472);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var initialState = {
  activeRules: [],
  eventTypes: [],
  deactivateModal: {}
};

var initialRuleState = {
  id: '',
  parentEventName: 'Not Specified',
  childEventName: 'Not Specified',
  quantity: 0,
  inactiveDate: null,
  creationDate: null,
  description: ''
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DEACTIVATE_PROCESS_END_FOR_BUNDLING_RULES */]:
      return _extends({}, state, { deactivateModal: _extends({}, state.deactivateModal, {
          submitting: false
        }) });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEACTIVATE_PROCESS_START_FOR_BUNDLING_RULES */]:
      return _extends({}, state, { deactivateModal: _extends({}, state.deactivateModal, {
          submitting: true
        }) });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* CANCEL_DEACTIVATE_MODAL_FOR_BUNDLING_RULES */]:
      return _extends({}, state, { deactivateModal: {} });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* DISPLAY_DEACTIVATE_MODAL_FOR_BUNDLING_RULES */]:
      return payload ? _extends({}, state, { deactivateModal: _extends({}, payload, {
          visible: true
        }) }) : state;
    case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* SET_EVENT_TYPES_IN_STATE_FOR_BUNDLING_RULES */]:
      return payload ? _extends({}, state, { eventTypes: payload }) : state;
    case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* DISPLAY_NEW_BUNDLING_RULE_FOR_BUNDLING_RULES */]:
      return _extends({}, state, {
        activeRules: [_extends({}, initialRuleState, { editing: true })].concat(_toConsumableArray(state.activeRules))
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* CANCEL_BUNDLING_RULE_FORM_FOR_BUNDLING_RULES */]:
      return _extends({}, state, {
        activeRules: state.activeRules.map(function (activeRule) {
          return ruleReducer(activeRule, { type: type });
        }).filter(function (activeRule) {
          return activeRule.id;
        }) // return only items with information (not empty ones)
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* DISPLAY_ACTIVE_RULES_FOR_BUNDLING_RULES */]:
      return payload ? _extends({}, state, { activeRules: payload }) : state;
    default:
      return state;
  }
};

var ruleReducer = function ruleReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref2 = arguments[1];
  var type = _ref2.type;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* CANCEL_BUNDLING_RULE_FORM_FOR_BUNDLING_RULES */]:
      return _extends({}, state, { editing: false });
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_TOURNAMENT_RESTRICTION; });
var SET_TOURNAMENT_RESTRICTION = 'SET_TOURNAMENT_RESTRICTION';

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(1097);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  enforceMinimumCaptainAge: false,
  minimumCaptainAge: null,
  showCalculatedDivisionToCaptain: false,
  requireRosterBeforeCheckout: false,
  restrictBowlersToActiveMembership: false,
  restrictBowlersToYouthMembership: false,
  blockFailedDivisionCalculation: false,
  termsUrl: ''
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_TOURNAMENT_RESTRICTION */]:
      {
        var enforceMinimumCaptainAge = payload.enforceMinimumCaptainAge || initialState.enforceMinimumCaptainAge;
        var minimumCaptainAge = payload.minimumCaptainAge || initialState.minimumCaptainAge;
        var showCalculatedDivisionToCaptain = payload.showCalculatedDivisionToCaptain || initialState.showCalculatedDivisionToCaptain;
        var requireRosterBeforeCheckout = payload.requireRosterBeforeCheckout || initialState.requireRosterBeforeCheckout;
        var restrictBowlersToActiveMembership = payload.restrictBowlersToActiveMembership || initialState.restrictBowlersToActiveMembership;
        var restrictBowlersToYouthMembership = payload.restrictBowlersToYouthMembership || initialState.restrictBowlersToYouthMembership;
        var blockFailedDivisionCalculation = payload.blockFailedDivisionCalculation || initialState.blockFailedDivisionCalculation;

        return _extends({}, state, {
          enforceMinimumCaptainAge: enforceMinimumCaptainAge,
          minimumCaptainAge: minimumCaptainAge,
          showCalculatedDivisionToCaptain: showCalculatedDivisionToCaptain,
          requireRosterBeforeCheckout: requireRosterBeforeCheckout,
          restrictBowlersToActiveMembership: restrictBowlersToActiveMembership,
          restrictBowlersToYouthMembership: restrictBowlersToYouthMembership,
          blockFailedDivisionCalculation: blockFailedDivisionCalculation
        });
      }
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home_SetupHomeContainer_jsx__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__general_AddGeneralContainer_jsx__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__general_UpdateGeneralContainer_jsx__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__communications_CommunicationFormContainer_jsx__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__permissions_PermissionsFormContainer_jsx__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__events_EventsContainer_jsx__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__squads_SquadsContainer_jsx__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__status_StatusContainer_jsx__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__divisions_DivisionsContainer_jsx__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__capacity_CapacityContainer_jsx__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fees_FeesContainer_jsx__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__restrictions_RestrictionsTabContainer_jsx__ = __webpack_require__(1086);
// libraries




// actions


// components













var managerRole = "superuser,manager";

var routes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'tournament',
    component: __WEBPACK_IMPORTED_MODULE_4__home_SetupHomeContainer_jsx__["a" /* default */],
    role: managerRole,
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* handleSetupHomeRouteEnter */])(nextState, replace, callback));
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'tournament/create',
    component: __WEBPACK_IMPORTED_MODULE_5__general_AddGeneralContainer_jsx__["a" /* default */],
    role: managerRole,
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* handleSetupCreateRouteEnter */])(nextState, replace, callback));
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'tournament/update/:tournamentId',
    component: __WEBPACK_IMPORTED_MODULE_6__general_UpdateGeneralContainer_jsx__["a" /* default */],
    role: managerRole,
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["c" /* handleSetupUpdateRouteEnter */])(nextState, replace, callback));
    },
    onLeave: function onLeave() {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* handleRouteLeave */])());
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'tournament/update/:tournamentId/communication',
    component: __WEBPACK_IMPORTED_MODULE_7__communications_CommunicationFormContainer_jsx__["a" /* default */],
    role: managerRole,
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["e" /* handleUpdateCommunicationRouteEnter */])(nextState, replace, callback));
    },
    onLeave: function onLeave() {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* handleRouteLeave */])());
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'tournament/update/:tournamentId/permissions',
    component: __WEBPACK_IMPORTED_MODULE_8__permissions_PermissionsFormContainer_jsx__["a" /* default */],
    role: managerRole,
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["f" /* handleSetupPermissionsRouteEnter */])(nextState, replace, callback));
    },
    onLeave: function onLeave() {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* handleRouteLeave */])());
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'tournament/update/:tournamentId/events',
    component: __WEBPACK_IMPORTED_MODULE_9__events_EventsContainer_jsx__["a" /* default */],
    role: managerRole,
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["g" /* handleSetupEventsRouteEnter */])(nextState, replace, callback));
    },
    onLeave: function onLeave() {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* handleRouteLeave */])());
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'tournament/update/:tournamentId/squads',
    component: __WEBPACK_IMPORTED_MODULE_10__squads_SquadsContainer_jsx__["a" /* default */],
    role: managerRole,
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["h" /* handleSetupSquadsRouteEnter */])(nextState, replace, callback));
    },
    onLeave: function onLeave() {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* handleRouteLeave */])());
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'tournament/update/:tournamentId/divisions',
    component: __WEBPACK_IMPORTED_MODULE_12__divisions_DivisionsContainer_jsx__["a" /* default */],
    role: managerRole,
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["i" /* handleSetupDivisionsRouteEnter */])(nextState, replace, callback));
    },
    onLeave: function onLeave() {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* handleRouteLeave */])());
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'tournament/update/:tournamentId/capacity',
    component: __WEBPACK_IMPORTED_MODULE_13__capacity_CapacityContainer_jsx__["a" /* default */],
    role: managerRole,
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["j" /* handleSetupCapacityRouteEnter */])(nextState, replace, callback));
    },
    onLeave: function onLeave() {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* handleRouteLeave */])());
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'tournament/update/:tournamentId/fees',
    component: __WEBPACK_IMPORTED_MODULE_14__fees_FeesContainer_jsx__["a" /* default */],
    role: managerRole,
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["k" /* handleSetupFeesRouteEnter */])(nextState, replace, callback));
    },
    onLeave: function onLeave() {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* handleRouteLeave */])());
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'tournament/update/:tournamentId/restrictions',
    component: __WEBPACK_IMPORTED_MODULE_15__restrictions_RestrictionsTabContainer_jsx__["a" /* default */],
    role: managerRole,
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["l" /* handleSetupRestrictionsRouteEnter */])(nextState, replace, callback));
    },
    onLeave: function onLeave() {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* handleRouteLeave */])());
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'tournament/update/:tournamentId/status',
    component: __WEBPACK_IMPORTED_MODULE_11__status_StatusContainer_jsx__["a" /* default */],
    role: managerRole,
    onEnter: function onEnter(nextState, replace, callback) {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["m" /* handleSetupStatusRouteEnter */])(nextState, replace, callback));
    },
    onLeave: function onLeave() {
      return __WEBPACK_IMPORTED_MODULE_2_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* handleRouteLeave */])());
    }
  })
);

/* harmony default export */ __webpack_exports__["a"] = routes;

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_StandardModal_jsx__ = __webpack_require__(23);



var SquadDeleteConfirmModal = function SquadDeleteConfirmModal(_ref) {
  var visible = _ref.visible,
      onCancelClick = _ref.onCancelClick,
      onConfirmDeleteClick = _ref.onConfirmDeleteClick,
      warningMessage = _ref.warningMessage,
      error = _ref.error,
      choices = _ref.choices,
      confirmation = _ref.confirmation;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_shared_StandardModal_jsx__["a" /* default */],
    {
      title: 'Confirm Squad Delete',
      visible: visible,
      onCloseClick: onCancelClick },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'alert alert-danger' },
        error
      ),
      warningMessage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'alert alert-warning' },
        warningMessage
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { display: 'flex', justifyContent: 'flex-end', gap: '10px' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-link',
            onClick: onCancelClick
          },
          'Cancel'
        ),
        choices && choices.length > 0 && choices.map(function (choice, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              key: index,
              type: 'button',
              className: 'btn btn-danger btn-lg',
              onClick: function onClick() {
                return onConfirmDeleteClick(choice, confirmation);
              },
              disabled: error
            },
            choice
          );
        })
      )
    )
  );
};

SquadDeleteConfirmModal.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onConfirmDeleteClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  warningMessage: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  error: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  choices: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array
};

/* harmony default export */ __webpack_exports__["a"] = SquadDeleteConfirmModal;

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SquadDeleteConfirmModal_jsx__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(169);




var mapStateToProps = function mapStateToProps(state) {
  return state.tournament.squads.squadDeleteConfirmModal;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions_js__["i" /* handleCloseDeleteModal */])());
    },
    onConfirmDeleteClick: function onConfirmDeleteClick(option, confirmation) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions_js__["j" /* handleConfirmSquadDelete */])(option, confirmation));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__SquadDeleteConfirmModal_jsx__["a" /* default */]);

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_StandardModal_jsx__ = __webpack_require__(23);



var SquadDeleteModal = function SquadDeleteModal(_ref) {
  var visible = _ref.visible,
      onCancelClick = _ref.onCancelClick,
      onDeleteClick = _ref.onDeleteClick,
      error = _ref.error;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_shared_StandardModal_jsx__["a" /* default */],
    {
      title: 'Delete Squad',
      visible: visible,
      onCloseClick: onCancelClick },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'alert alert-danger' },
        error
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        'Are you sure you want to delete?'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { display: 'flex', justifyContent: 'flex-end', gap: '10px' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-link',
            onClick: function onClick() {
              return onCancelClick();
            }
          },
          'No'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-danger btn-lg',
            onClick: function onClick() {
              return onDeleteClick();
            },
            disabled: error
          },
          'Yes'
        )
      )
    )
  );
};

SquadDeleteModal.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onDeleteClickClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  error: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

/* harmony default export */ __webpack_exports__["a"] = SquadDeleteModal;

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SquadDeleteModal_jsx__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(169);




var mapStateToProps = function mapStateToProps(state) {
  return state.tournament.squads.squadDeleteModal;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["i" /* handleCloseDeleteModal */])());
    },
    onDeleteClick: function onDeleteClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["k" /* handleSquadDelete */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__SquadDeleteModal_jsx__["a" /* default */]);

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_StandardCheckboxField_jsx__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_TimeField_jsx__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_DisplayIf_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SquadDeleteModalContainer_jsx__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SquadDeleteConfirmModalContainer_jsx__ = __webpack_require__(1101);











var daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

var SquadForm = function SquadForm(_ref) {
  var timeZoneDisplay = _ref.timeZoneDisplay,
      eventTypes = _ref.eventTypes,
      handleSubmit = _ref.handleSubmit,
      minDateUntil = _ref.minDateUntil,
      pristine = _ref.pristine,
      submitting = _ref.submitting,
      canRepeat = _ref.canRepeat,
      onCancel = _ref.onCancel,
      onSubmit = _ref.onSubmit,
      confirmDelete = _ref.confirmDelete,
      canDelete = _ref.canDelete,
      tmsEndpoint = _ref.tmsEndpoint,
      status = _ref.status;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'form',
    {
      onSubmit: handleSubmit(onSubmit)
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
      name: 'eventId',
      component: __WEBPACK_IMPORTED_MODULE_4_shared_StandardSelectField_jsx__["a" /* default */],
      options: eventTypes,
      placeholder: 'Event Type',
      simpleValue: true,
      searchable: false
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
      name: 'time',
      component: __WEBPACK_IMPORTED_MODULE_6_shared_TimeField_jsx__["a" /* default */],
      placeholder: 'Time (' + timeZoneDisplay + ')'
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
      name: 'startLane',
      type: 'number',
      step: '1',
      min: '0',
      component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
      placeholder: 'Start Lane',
      tooltip: 'Must be an odd number.',
      tooltipPosition: 'top'
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
      name: 'endLane',
      type: 'number',
      step: '1',
      min: '0',
      component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
      placeholder: 'End Lane',
      tooltip: 'Must be an even number. Managers can only increase the number of lanes.',
      tooltipPosition: 'top'
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_shared_DisplayIf_jsx__["a" /* default */],
      { condition: canRepeat },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'fieldset',
        { className: 'repeaton' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
          name: 'repeaton',
          type: 'hidden',
          component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
          label: 'Repeat On',
          tooltip: 'Select a day or days to repeat the event at the exact same day/time of the week until the end date selected. Example: Repeat the Singles event every Saturday and Sunday at 09:00am',
          tooltipPosition: 'top'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'horizontal-checkbox-group' },
          daysOfWeek.map(function (day, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: 'repeatOn.' + index,
              key: index,
              component: __WEBPACK_IMPORTED_MODULE_5_shared_StandardCheckboxField_jsx__["a" /* default */],
              label: day
            });
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
          name: 'until',
          type: 'date',
          minDate: minDateUntil,
          component: __WEBPACK_IMPORTED_MODULE_3_shared_StandardField_jsx__["a" /* default */],
          placeholder: 'Until'
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'form-group text-right' },
      canDelete && tmsEndpoint === null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { style: { paddingRight: 270 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-danger btn-lg',
            disabled: status !== 'Setup' || submitting,
            onClick: confirmDelete
          },
          'Delete'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          type: 'button',
          className: 'btn btn-link',
          disabled: submitting,
          onClick: onCancel
        },
        'Cancel'
      ),
      ' ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          type: 'submit',
          className: 'btn btn-primary btn-lg',
          disabled: pristine || submitting
        },
        submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-floppy-o' }),
        ' ',
        'Save'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SquadDeleteModalContainer_jsx__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SquadDeleteConfirmModalContainer_jsx__["a" /* default */], null)
  );
};

SquadForm.propTypes = {
  timeZoneDisplay: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  minDateUntil: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  eventTypes: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  status: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  pristine: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired,
  canRepeat: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancel: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSubmit: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onDelete: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: 'tournamentSquadForm'
})(SquadForm);

/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SquadForm_jsx__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actionTypes__ = __webpack_require__(289);








var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["formValueSelector"])('tournamentSquadForm');

var mapStateToProps = function mapStateToProps(state) {
  return {
    validate: __WEBPACK_IMPORTED_MODULE_3__actions__["f" /* validate */],
    canRepeat: selector(state, 'canRepeat'),
    canDelete: selector(state, 'canDelete'),
    tmsEndpoint: selector(state, 'tmsEndpoint'),
    status: selector(state, 'status'),
    minDateUntil: selector(state, 'minDateUntil'),
    eventTypes: state.tournament.squads.eventTypes,
    timeZoneDisplay: selector(state, 'timeZoneDisplayName')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["g" /* handleSave */])(data));
    },
    confirmDelete: function confirmDelete() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["h" /* confirmSquadDelete */])());
    },
    onCancel: function onCancel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actionTypes__["d" /* hideSquadDialog */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__SquadForm_jsx__["a" /* default */]);

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SquadFormContainer_jsx__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);







var SquadModal = function SquadModal(_ref) {
  var title = _ref.title,
      visible = _ref.visible,
      onCloseClick = _ref.onCloseClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("modal", { "display block animated fadeIn": visible })
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'modal-dialog' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'modal-content' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'modal-header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              type: 'button',
              className: 'close',
              'aria-hidden': 'true',
              onClick: onCloseClick
            },
            '\xD7'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'modal-title' },
            title
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'modal-body' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SquadFormContainer_jsx__["a" /* default */], null)
        )
      )
    )
  );
};

SquadModal.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCloseClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = SquadModal;

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_event_calendar__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_event_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_event_calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SquadModal_jsx__ = __webpack_require__(1106);





var Squads = function Squads(_ref) {
  var modalTitle = _ref.modalTitle,
      entries = _ref.entries,
      month = _ref.month,
      year = _ref.year,
      modalVisible = _ref.modalVisible,
      onPreviousClick = _ref.onPreviousClick,
      onNextClick = _ref.onNextClick,
      onDayClick = _ref.onDayClick,
      onModalCloseClick = _ref.onModalCloseClick,
      onEventClick = _ref.onEventClick;

  var monthForCalendar = month - 1,
      // EventCalendar plugin expects months starting from zero
  monthName = __WEBPACK_IMPORTED_MODULE_2_moment___default()(new Date(year + '/' + month + '/1')).format('MMMM'); // Use moment to get the name of the month

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'panel panel-default' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel-heading flex space-between' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          { className: 'panel-title' },
          monthName + ', ' + year
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              className: 'btn btn-link',
              onClick: onPreviousClick
            },
            'Previous'
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              className: 'btn btn-link',
              onClick: onNextClick
            },
            'Next'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_event_calendar___default.a, {
        month: monthForCalendar,
        year: year,
        events: entries,
        maxEventSlots: 30,
        onDayClick: onDayClick,
        onEventClick: onEventClick
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SquadModal_jsx__["a" /* default */], {
      title: modalTitle,
      visible: modalVisible,
      onCloseClick: onModalCloseClick
    })
  );
};

Squads.propTypes = {
  modalTitle: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  entries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object).isRequired,
  month: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number.isRequired,
  year: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number.isRequired,
  modalVisible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onPreviousClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onNextClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onDayClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onModalCloseClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onEventClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ __webpack_exports__["a"] = Squads;

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Squads_jsx__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(169);







var mapStateToProps = function mapStateToProps(state) {
  return state.tournament.squads;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onEventClick: function onEventClick(target, eventData, day) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* handleEventClick */])(target, eventData, day));
    },
    onModalCloseClick: function onModalCloseClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["d" /* hideSquadDialog */])());
    },
    onDayClick: function onDayClick(target, day) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["c" /* handleDayClick */])(target, day));
    },
    onPreviousClick: function onPreviousClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* moveToPreviousMonth */])());
    },
    onNextClick: function onNextClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["e" /* moveToNextMonth */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__Squads_jsx__["a" /* default */]);

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var currentDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date());

var itemListInitialState = {
  entries: [],
  month: Number(currentDate.format('M')),
  year: Number(currentDate.format('YYYY')),
  modalVisible: false,
  eventTypes: [],
  modalTitle: '',
  squadDeleteModal: {},
  squadDeleteConfirmModal: {},
  warningMessage: '',
  error: '',
  choices: [],
  confirmation: ''
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : itemListInitialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* DISPLAY_EVENTS_IN_DDL */]:
      return _extends({}, state, { eventTypes: payload });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* HIDE_SQUAD_DIALOG */]:
      return _extends({}, state, { modalVisible: false });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* HIDE_SQUAD_DELETE_DIALOG */]:
      return _extends({}, state, {
        modalVisible: true,
        squadDeleteModal: {
          visible: false
        },
        squadDeleteConfirmModal: {
          visible: false
        }
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_SQUAD_DELETE_MODAL */]:
      return _extends({}, state, {
        modalVisible: true,
        squadDeleteModal: {
          error: payload.error,
          visible: true
        },
        squadDeleteConfirmModal: {
          visible: false
        } });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DISPLAY_SQUAD_DELETE_CONFIRM_MODAL */]:
      return _extends({}, state, {
        modalVisible: true,
        squadDeleteModal: {
          visible: false
        },
        squadDeleteConfirmModal: {
          warningMessage: payload.warningMessage,
          error: payload.error,
          choices: payload.choices,
          confirmation: payload.confirmation,
          visible: true
        }
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* DISPLAY_SQUAD_DIALOG */]:
      return _extends({}, state, {
        modalVisible: true,
        modalTitle: payload,
        squadDeleteConfirmModal: {
          visible: false
        },
        squadDeleteModal: {
          visible: false
        }
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* DISPLAY_NEXT_MONTH */]:
      {
        var nextMonth = state.month + 1,
            year = nextMonth > 12 ? state.year + 1 : state.year,
            month = nextMonth > 12 ? 1 : nextMonth;

        return _extends({}, state, {
          month: month,
          year: year
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* DISPLAY_PREVIOUS_MONTH */]:
      {
        var prevMonth = state.month - 1,
            _year = prevMonth < 1 ? state.year - 1 : state.year,
            _month = prevMonth < 1 ? 12 : prevMonth;

        return _extends({}, state, {
          month: _month,
          year: _year
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* DISPLAY_SPECIFIC_MONTH */]:
      {
        return _extends({}, state, {
          month: payload.month,
          year: payload.year
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* DISPLAY_TOURNAMENT_SQUADS */]:
      return _extends({}, state, { entries: payload });

    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_validators__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(290);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getRepeatingDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAllDaysOfWeek; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return validateRepeatUntil; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validateSquad; });




var getRepeatingDays = function getRepeatingDays(startDate) {
  var repeatOn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var until = arguments[2];

  var untilEnd = __WEBPACK_IMPORTED_MODULE_0_moment___default()(until).endOf('day');
  var start = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate);
  var latestWeekDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()();
  var next = start.clone();
  var addDays = 0;
  var dates = [];

  dates.push(start.format());

  while (until && next.isBefore(untilEnd)) {
    dates = dates.concat(getDaysOfWeek(next, repeatOn, untilEnd, start));
    latestWeekDate = getLatestWeekDate(dates);
    addDays = getAddDays(next, latestWeekDate);
    next.add(addDays, 'days');
  }

  return dates.filter(function (value, index, self) {
    return self.indexOf(value) === index;
  });
};

var getLatestWeekDate = function getLatestWeekDate(dates) {
  var latestWeekDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(dates[dates.length - 1]);

  return latestWeekDate;
};

var getAddDays = function getAddDays(next, latestWeekDate) {
  var addDays = next.diff(latestWeekDate, 'days');

  return Math.abs(addDays) + 1;
};

var getAllDaysOfWeek = function getAllDaysOfWeek(startDate, repeatOn) {
  var days = [];
  var start = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate);

  if (!repeatOn) return days;

  repeatOn.forEach(function (shouldRepeat, dayOfWeek) {
    if (shouldRepeat) {
      var nextDay = getNextWeekday(start, dayOfWeek);

      days.push(nextDay.format());
    }
  });
  return days;
};

var getDaysOfWeek = function getDaysOfWeek(start, repeatOn, until, startDate) {
  var days = [];

  repeatOn.forEach(function (shouldRepeat, dayOfWeek) {
    if (shouldRepeat) {
      var nextDay = getNextWeekday(start, dayOfWeek);

      if (nextDay.isBefore(until) && nextDay.isAfter(startDate)) days.push(nextDay.format());
    }
  });
  return days;
};

var getNextWeekday = function getNextWeekday(start, day) {
  var startDay = __WEBPACK_IMPORTED_MODULE_0_moment___default()(start);
  var nextWeekday = startDay.day(day);

  return nextWeekday;
};

var validateRepeatUntil = function validateRepeatUntil(data) {
  if (data.repeatOn && data.repeatOn.some(function (x) {
    return !!x;
  })) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_validators__["b" /* validateDate */])(data.until)) {
      return __WEBPACK_IMPORTED_MODULE_2__constants__["k" /* ERROR_UNTIL_REQUIRED */];
    }
    if (data.until && __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.until).isBefore(data.startDateTime)) {
      return __WEBPACK_IMPORTED_MODULE_2__constants__["l" /* ERROR_UNTIL_BEFORE_START_DATE */];
    }
    if (data.until && data.until > data.tournamentEndDate) {
      return __WEBPACK_IMPORTED_MODULE_2__constants__["m" /* ERROR_UNTIL_AFTER_END_DATE */];
    }
  }
};

var validateSquad = function validateSquad(data) {
  var errors = {};

  if (!data.eventId) {
    errors.eventId = 'An event type must be specified';
  }if (!data.time) {
    errors.time = 'Time is required';
  }if (!data.startLane) {
    errors.startLane = 'Start lane is required';
  }if (!data.endLane) {
    errors.endLane = 'End lane is required';
  }

  if (data.startLane % 2 === 0) {
    errors.startLane = 'Start lane must be an odd number.';
  } else if (data.origStartLane && data.startLane > data.origStartLane) {
    errors.startLane = 'Start lane must be less than or equal to its original value.';
  }

  if (data.endLane && data.endLane % 2 !== 0) {
    errors.endLane = 'End lane must be an even number.';
  } else if (data.endLane && data.origEndLane && data.endLane < data.origEndLane) {
    errors.endLane = 'End lane must be greater than or equal to its original value.';
  }

  if (+data.endLane < +data.startLane) {
    errors.endLane = 'End lane must be greater or equal to start lane.';
  }

  return errors;
};

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_StandardModal_jsx__ = __webpack_require__(23);



var ConfirmStatusChangeModal = function ConfirmStatusChangeModal(_ref) {
  var newStatus = _ref.newStatus,
      currentStatus = _ref.currentStatus,
      visible = _ref.visible,
      onCancelClick = _ref.onCancelClick,
      onConfirmClick = _ref.onConfirmClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_shared_StandardModal_jsx__["a" /* default */],
    {
      visible: visible,
      title: 'Tournament - ' + currentStatus,
      onCloseClick: onCancelClick
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'text-center' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'You are about to change the Tournament Status to ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            null,
            newStatus
          ),
          '.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'This change cannot be undone.'
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'text-right' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          type: 'button',
          className: 'btn btn-link',
          onClick: onCancelClick
        },
        'Cancel'
      ),
      ' ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          type: 'button',
          className: 'btn btn-primary btn-lg',
          onClick: function onClick() {
            return onConfirmClick(newStatus);
          }
        },
        'Yes. Change Tournament Status.'
      )
    )
  );
};

ConfirmStatusChangeModal.propTypes = {
  newStatus: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  currentStatus: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  visible: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onCancelClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onConfirmClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

ConfirmStatusChangeModal.defaultProps = {
  newStatus: '',
  currentStatus: '',
  visible: false
};

/* harmony default export */ __webpack_exports__["a"] = ConfirmStatusChangeModal;

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConfirmStatusChangeModal_jsx__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(291);





var mapStateToProps = function mapStateToProps(state) {
  return state.tournament.status.confirmStatusChangeModal;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCancelClick: function onCancelClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["c" /* cancelConfirmStatusChangeModal */])());
    },
    onConfirmClick: function onConfirmClick(status) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["g" /* handleSetStatusClick */])(status));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ConfirmStatusChangeModal_jsx__["a" /* default */]);

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StatusItem_jsx__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConfirmStatusChangeModalContainer_jsx__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_error_ErrorListContainer_jsx__ = __webpack_require__(19);







var Status = function Status(_ref) {
  var currentStatus = _ref.currentStatus,
      statuses = _ref.statuses,
      publishing = _ref.publishing,
      hasPendingChanges = _ref.hasPendingChanges,
      onPublishClick = _ref.onPublishClick,
      onSetStatusClick = _ref.onSetStatusClick,
      exportSystemName = _ref.exportSystemName,
      systemShouldExport = _ref.systemShouldExport,
      onExportClick = _ref.onExportClick,
      loading = _ref.loading,
      exportStatus = _ref.exportStatus,
      onDownloadExportClick = _ref.onDownloadExportClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'flex center animated fadeIn' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'col-xs-12 col-lg-10' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_shared_error_ErrorListContainer_jsx__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
        { condition: !loading && hasPendingChanges && !systemShouldExport },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'alert alert-warning flex space-between' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'flex-2' },
            'We have detected pending changes in this tournament\'s configuration. Please check with the tournament manager before proceeding.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button',
              className: 'btn btn-warning flex-1',
              disabled: publishing,
              onClick: onPublishClick },
            publishing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__["a" /* default */], null),
              ' ',
              'Publishing'
            ) : 'I understand. Push to TMS'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
        { condition: !loading && systemShouldExport },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
          { condition: exportStatus == null || exportStatus == 0 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'alert alert-warning flex space-between' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'flex-3' },
              currentStatus !== statuses[3] && currentStatus !== statuses[4] ? 'Exporting is disabled unless tournament status is set to "Public Registration Closed" or "All Registrations Closed."' : 'Please check with the tournament manager before proceeding.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'flex-1' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { type: 'button',
                className: 'btn btn-success flex-1',
                disabled: publishing || currentStatus !== statuses[3] && currentStatus !== statuses[4],
                onClick: onExportClick },
              publishing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__["a" /* default */], null),
                ' ',
                'Exporting'
              ) : 'Export File for ' + exportSystemName
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
          { condition: exportStatus == 1 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'alert alert-warning flex space-between' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'flex-3' },
              'We are in the process of exporting this tournament. Feel free to leave this page and come back, or refresh this page, to check the status of your export.'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
          { condition: exportStatus == 2 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'alert alert-warning flex space-between' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'flex-3' },
              'We have completed exporting this tournament. Please click the button to download the import file.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'flex-1' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { type: 'button',
                className: 'btn btn-success flex-1',
                onClick: onDownloadExportClick },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Download Import File'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_shared_DisplayIf_jsx__["a" /* default */],
          { condition: exportStatus == 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'alert alert-danger flex space-between' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'flex-3' },
              'We encountered an error exporting this tournament. Please contact your Registration support.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'flex-1' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { type: 'button',
                className: 'btn btn-success flex-1',
                disabled: publishing || currentStatus !== statuses[3] && currentStatus !== statuses[4],
                onClick: onExportClick },
              publishing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_Submitting_jsx__["a" /* default */], null),
                ' ',
                'Exporting'
              ) : 'Export File for ' + exportSystemName
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-group' },
        statuses.map(function (status, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__StatusItem_jsx__["a" /* default */], { key: index,
            status: status,
            active: currentStatus === status,
            onSetStatusClick: onSetStatusClick,
            hasPendingChanges: systemShouldExport ? false : hasPendingChanges
          });
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ConfirmStatusChangeModalContainer_jsx__["a" /* default */], null)
  );
};

Status.propTypes = {
  currentStatus: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  statuses: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string),
  publishing: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  hasPendingChanges: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onPublishClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSetStatusClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  exportSystemName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  systemShouldExport: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  onExportClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  loading: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  exportStatus: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,
  onDownloadExportClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

Status.defaultProps = {
  currentStatus: '',
  statuses: [],
  publishing: false,
  hasPendingChanges: false,
  exportSystemName: '',
  systemShouldExport: false,
  loading: false
};

/* harmony default export */ __webpack_exports__["a"] = Status;

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Status_jsx__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(207);





var mapStateToProps = function mapStateToProps(state) {
  return state.tournament.status;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onPublishClick: function onPublishClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["d" /* handlePublish */])());
    },
    onSetStatusClick: function onSetStatusClick(status) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["k" /* displayConfirmStatusChangeModal */])(status));
    },
    onExportClick: function onExportClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["e" /* handleBeginExport */])());
    },
    onDownloadExportClick: function onDownloadExportClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* handleDownloadExport */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__Status_jsx__["a" /* default */]);

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);



var StatusItem = function StatusItem(_ref) {
  var active = _ref.active,
      status = _ref.status,
      onSetStatusClick = _ref.onSetStatusClick,
      hasPendingChanges = _ref.hasPendingChanges;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('list-group-item-labeled', { 'highlight': active }) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 300 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Status' + (active ? ' (Current)' : '')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        status
      )
    ),
    active ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'list-group-item-labeled-child',
        style: { width: 150 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        { className: 'btn btn-link',
          type: 'button',
          onClick: function onClick() {
            return onSetStatusClick(status);
          },
          disabled: hasPendingChanges },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-wrench' }),
        ' ',
        'Update Status'
      )
    )
  );
};

StatusItem.propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  status: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  onSetStatusClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  hasPendingChanges: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool
};

/* harmony default export */ __webpack_exports__["a"] = StatusItem;

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(473);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  publishing: false,
  statuses: [],
  currentStatus: '',
  hasPendingChanges: false,
  confirmStatusChangeModal: {
    newStatus: '',
    currentStatus: '',
    visible: false
  },
  exportSystemName: '',
  systemShouldExport: false,
  exportStatus: null,
  exportFileLocation: null,
  exportFileName: ""
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_TOURNAMENT_STATUS_FOR_TOURNAMENT_STATUS */]:
      return _extends({}, state, {
        currentStatus: payload || ''
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_TOURNAMENT_HAS_PENDING_CHANGES_FOR_TOURNAMENT_STATUS */]:
      return _extends({}, state, {
        hasPendingChanges: payload || false
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_AVAILABLE_STATUSES_FOR_TOURNAMENT_STATUS */]:
      return _extends({}, state, {
        statuses: payload || []
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* PUBLISH_STARTS_FOR_TOURNAMENT */]:
      return _extends({}, state, {
        publishing: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* PUBLISH_ENDS_FOR_TOURNAMENT */]:
      return _extends({}, state, {
        publishing: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* DISPLAY_CONFIRM_MODAL_FOR_STATUS_CHANGE */]:
      return _extends({}, state, {
        confirmStatusChangeModal: _extends({}, state.confirmStatusChangeModal, {
          newStatus: payload || '',
          currentStatus: state.currentStatus,
          visible: true
        })
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* CANCEL_CONFIRM_MODAL_FOR_STATUS_CHANGE */]:
      return _extends({}, state, {
        confirmStatusChangeModal: initialState.confirmStatusChangeModal
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* SET_EXPORT_SYSTEM_INFO */]:
      return _extends({}, state, {
        exportSystemName: payload.exportSystemName,
        systemShouldExport: payload.systemShouldExport
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* LOADING_STARTS_FOR_TOURNAMENT */]:
      return _extends({}, state, {
        loading: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* LOADING_ENDS_FOR_TOURNAMENT */]:
      return _extends({}, state, {
        loading: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* SET_EXPORT_STATUS */]:
      return _extends({}, state, {
        exportStatus: payload.exportStatus,
        exportFileLocation: payload.exportFileLocation,
        exportFileName: payload.exportFileName
      });
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_DisplayIf_jsx__ = __webpack_require__(12);




var mdyyyyDateFormat = 'M/D/YYYY';

var TournamentList = function TournamentList(_ref) {
  var entries = _ref.entries,
      onManageClick = _ref.onManageClick,
      onCopyClick = _ref.onCopyClick,
      groupName = _ref.groupName,
      isAllowed = _ref.isAllowed;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'list-group' },
    entries.map(function (item, index) {
      return item.userCanManage && window.GROUP_ENABLED === "true" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: index, className: 'list-group-item hover-highlight' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'list-group-item-inner-wrapper cursor-pointer', onClick: function onClick() {
              return onManageClick(item.id);
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'list-group-item-heading' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-pencil' }),
            ' ',
            item.name,
            item.readOnly ? ' (read-only)' : null
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'list-group-item-text' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'bg-light clearfix' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'pull-left' },
              'Starts: ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(item.startDate).format(mdyyyyDateFormat) + ', Ends: ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(item.endDate).format(mdyyyyDateFormat) + ', Reg. Close Date: ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(item.registrationCloseDate).format(mdyyyyDateFormat)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_shared_DisplayIf_jsx__["a" /* default */],
              { condition: isAllowed && groupName && window.GROUP_ENABLED === "true" ? true : false },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'pull-right cursor-pointer' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { onClick: function onClick() {
                      return onCopyClick(item.id);
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-copy' }),
                  ' Copy'
                )
              )
            )
          )
        )
      ) : item.userCanManage ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: index, className: 'list-group-item hover-highlight' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'list-group-item-inner-wrapper cursor-pointer', onClick: function onClick() {
              return onManageClick(item.id);
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'list-group-item-heading' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-pencil' }),
            ' ',
            item.name,
            item.readOnly ? ' (read-only)' : null
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'list-group-item-text' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'bg-light clearfix' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'pull-left' },
              'Starts: ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(item.startDate).format(mdyyyyDateFormat) + ', Ends: ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(item.endDate).format(mdyyyyDateFormat) + ', Reg. Close Date: ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(item.registrationCloseDate).format(mdyyyyDateFormat)
            )
          )
        )
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: index, className: 'list-group-item highlight-disabled' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'list-group-item-inner-wrapper' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'list-group-item-heading' },
            item.name,
            item.readOnly ? ' (read-only)' : null
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'list-group-item-text' },
          'Starts: ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(item.startDate).format(mdyyyyDateFormat) + ', Ends: ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(item.endDate).format(mdyyyyDateFormat) + ', Reg. Close Date: ' + __WEBPACK_IMPORTED_MODULE_1_moment___default.a.parseZone(item.registrationCloseDate).format(mdyyyyDateFormat)
        )
      );
    })
  );
};

TournamentList.propTypes = {
  entries: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object),
  onManageClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onCopyClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

TournamentList.defaultProps = {
  entries: []
};

/* harmony default export */ __webpack_exports__["a"] = TournamentList;

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TournamentList_jsx__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(170);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var mapStateToProps = function mapStateToProps(state) {
  return _extends({}, state.tournament.tournamentList, {
    groupName: state.shared.auth.groupName,
    isAllowed: state.shared.auth.isAllowed
  });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onManageClick: function onManageClick(tournamentId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["d" /* handleManageClick */])(tournamentId));
    },
    onCopyClick: function onCopyClick(tournamentId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["e" /* handleCopyClick */])(tournamentId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__TournamentList_jsx__["a" /* default */]);

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);



var TournamentSearch = function TournamentSearch(_ref) {
  var searchValue = _ref.searchValue,
      onSearchEnterKeyPress = _ref.onSearchEnterKeyPress,
      onSearchClick = _ref.onSearchClick,
      onSearchValueChange = _ref.onSearchValueChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'animated fadeIn flex wrap' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('input-group input-group-lg'), style: { "paddingBottom": "16px" } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text',
        autoFocus: true,
        placeholder: 'Type your search here...',
        className: 'form-control',
        value: searchValue,
        onChange: function onChange(event) {
          return onSearchValueChange(event.target.value);
        },
        onKeyDown: onSearchEnterKeyPress
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'input-group-btn' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-primary',
            type: 'button',
            onClick: onSearchClick },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-search' })
        )
      )
    )
  );
};

TournamentSearch.propTypes = {
  onSearchClick: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSearchEnterKeyPress: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onSearchValueChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  searchValue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

TournamentSearch.defaultProps = {
  searchValue: ''
};

/* harmony default export */ __webpack_exports__["a"] = TournamentSearch;

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TournamentSearch_jsx__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(474);





var mapStateToProps = function mapStateToProps(state) {
  return {
    searchValue: state.tournament.tournamentList.searchValue
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSearchEnterKeyPress: function onSearchEnterKeyPress(event) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* handleTournamentSearchEnterKeyPress */])(event));
    },
    onSearchClick: function onSearchClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["g" /* handleTournamentSearch */])());
    },
    onSearchValueChange: function onSearchValueChange(searchValue) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actionTypes__["f" /* setSearchTournamentValue */])(searchValue));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__TournamentSearch_jsx__["a" /* default */]);

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(475);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  entries: [],
  searchValue: '',
  activeTournamentCount: undefined,
  loadingTournaments: false,
  showAllTournaments: false
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISPLAY_TOURNAMENTS */]:
      {
        var activeTournamentCount = state.activeTournamentCount;

        if (payload.entries && !activeTournamentCount) activeTournamentCount = payload.entries.length;
        return _extends({}, state, payload, {
          activeTournamentCount: activeTournamentCount,
          loadingTournaments: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* START_LOADING_TOURNAMENTS */]:
      return _extends({}, state, {
        loadingTournaments: true,
        entries: []
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_SEARCH_TOURNAMENT_VALUE_FOR_TOURNAMENTS */]:
      return _extends({}, state, {
        searchValue: payload.searchValue || initialState.searchValue
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* UPDATE_SHOW_ALL_TOURNAMENTS */]:
      return _extends({}, state, {
        showAllTournaments: payload
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* DISPLAY_GROUP_NAME */]:
      return _extends({}, state, {
        groupName: payload
      });

    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_spinner__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_reducer__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__features_registration_reducer__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__features_tournament_reducer__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__features_admin_rootReducer__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__features_finance_rootReducer__ = __webpack_require__(880);






// features reducers






var rootReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  routing: __WEBPACK_IMPORTED_MODULE_4_react_router_redux__["routerReducer"],
  pendingTasks: __WEBPACK_IMPORTED_MODULE_3_react_redux_spinner__["pendingTasksReducer"],
  toastr: __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__["reducer"],
  form: __WEBPACK_IMPORTED_MODULE_1_redux_form__["reducer"],
  shared: __WEBPACK_IMPORTED_MODULE_5_shared_reducer__["a" /* default */],
  registration: __WEBPACK_IMPORTED_MODULE_6__features_registration_reducer__["a" /* default */],
  tournament: __WEBPACK_IMPORTED_MODULE_7__features_tournament_reducer__["a" /* default */],
  admin: __WEBPACK_IMPORTED_MODULE_8__features_admin_rootReducer__["a" /* default */],
  finance: __WEBPACK_IMPORTED_MODULE_9__features_finance_rootReducer__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = rootReducer;

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_App_jsx__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_variables__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__features_shared_auth_routes__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__features_admin_routes__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__features_finance_routes__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__features_tournament_routes__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__features_registration_routes__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__features_shared_routes__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__features_about_routes__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_store__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_auth_actions_js__ = __webpack_require__(62);





// feature routes











/* harmony default export */ __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"], {
    path: __WEBPACK_IMPORTED_MODULE_3_shared_variables__["c" /* BASE_PATH */] + '/signin/callback',
    onEnter: function onEnter() {
      return __WEBPACK_IMPORTED_MODULE_11_store___default.a.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_auth_actions_js__["d" /* signinRedirectCallback */])());
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"], {
    path: __WEBPACK_IMPORTED_MODULE_3_shared_variables__["c" /* BASE_PATH */] + '/signin/silentrenew',
    onEnter: function onEnter() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_auth_actions_js__["e" /* signinSilentCallback */])();
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],
    {
      path: '/' + __WEBPACK_IMPORTED_MODULE_3_shared_variables__["c" /* BASE_PATH */],
      component: __WEBPACK_IMPORTED_MODULE_2_shared_App_jsx__["a" /* default */]
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Redirect"], {
      from: '/',
      to: '/' + __WEBPACK_IMPORTED_MODULE_3_shared_variables__["c" /* BASE_PATH */] }),
    __WEBPACK_IMPORTED_MODULE_4__features_shared_auth_routes__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_8__features_registration_routes__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_7__features_tournament_routes__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_5__features_admin_routes__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_6__features_finance_routes__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_10__features_about_routes__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_9__features_shared_routes__["a" /* default */]
  )
);

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_thunk__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rootReducer__ = __webpack_require__(1122);






var reactRouterReduxMiddleware = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["routerMiddleware"])(__WEBPACK_IMPORTED_MODULE_0_react_router__["browserHistory"]);

var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux__["createStore"])(__WEBPACK_IMPORTED_MODULE_4__rootReducer__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux__["applyMiddleware"])(__WEBPACK_IMPORTED_MODULE_2_redux_thunk___default.a, reactRouterReduxMiddleware));

/* harmony default export */ __webpack_exports__["default"] = store;

/***/ }),
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "favicon.ico";

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "350x200_Pinstar_Thmnl.jpg";

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bowler.png";

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "usbc-banner.png";

/***/ }),
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _values = __webpack_require__(112);

var _values2 = _interopRequireDefault(_values);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends3 = __webpack_require__(7);

var _extends4 = _interopRequireDefault(_extends3);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _elementType = __webpack_require__(18);

var _elementType2 = _interopRequireDefault(_elementType);

var _bootstrapUtils = __webpack_require__(91);

var _StyleConfig = __webpack_require__(244);

var _SafeAnchor = __webpack_require__(1641);

var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = {
  active: _react2['default'].PropTypes.bool,
  disabled: _react2['default'].PropTypes.bool,
  block: _react2['default'].PropTypes.bool,
  onClick: _react2['default'].PropTypes.func,
  componentClass: _elementType2['default'],
  href: _react2['default'].PropTypes.string,
  /**
   * Defines HTML button type attribute
   * @defaultValue 'button'
   */
  type: _react2['default'].PropTypes.oneOf(['button', 'reset', 'submit'])
};

var defaultProps = {
  active: false,
  block: false,
  disabled: false
};

var Button = function (_React$Component) {
  (0, _inherits3['default'])(Button, _React$Component);

  function Button() {
    (0, _classCallCheck3['default'])(this, Button);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  Button.prototype.renderAnchor = function renderAnchor(elementProps, className) {
    return _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends4['default'])({}, elementProps, {
      className: (0, _classnames2['default'])(className, elementProps.disabled && 'disabled')
    }));
  };

  Button.prototype.renderButton = function renderButton(_ref, className) {
    var componentClass = _ref.componentClass,
        elementProps = (0, _objectWithoutProperties3['default'])(_ref, ['componentClass']);

    var Component = componentClass || 'button';

    return _react2['default'].createElement(Component, (0, _extends4['default'])({}, elementProps, {
      type: elementProps.type || 'button',
      className: className
    }));
  };

  Button.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        active = _props.active,
        block = _props.block,
        className = _props.className,
        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'block', 'className']);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
      active: active
    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'block')] = block, _extends2));
    var fullClassName = (0, _classnames2['default'])(className, classes);

    if (elementProps.href) {
      return this.renderAnchor(elementProps, fullClassName);
    }

    return this.renderButton(elementProps, fullClassName);
  };

  return Button;
}(_react2['default'].Component);

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

exports['default'] = (0, _bootstrapUtils.bsClass)('btn', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL, _StyleConfig.Size.XSMALL], (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY, _StyleConfig.Style.LINK]), _StyleConfig.Style.DEFAULT, Button)));
module.exports = exports['default'];

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Transition = __webpack_require__(384);

var _Transition2 = _interopRequireDefault(_Transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = {
  /**
   * Show the component; triggers the fade in or fade out animation
   */
  'in': _react2['default'].PropTypes.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: _react2['default'].PropTypes.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is faded out
   */
  unmountOnExit: _react2['default'].PropTypes.bool,

  /**
   * Run the fade in animation when the component mounts, if it is initially
   * shown
   */
  transitionAppear: _react2['default'].PropTypes.bool,

  /**
   * Duration of the fade animation in milliseconds, to ensure that finishing
   * callbacks are fired even if the original browser transition end events are
   * canceled
   */
  timeout: _react2['default'].PropTypes.number,

  /**
   * Callback fired before the component fades in
   */
  onEnter: _react2['default'].PropTypes.func,
  /**
   * Callback fired after the component starts to fade in
   */
  onEntering: _react2['default'].PropTypes.func,
  /**
   * Callback fired after the has component faded in
   */
  onEntered: _react2['default'].PropTypes.func,
  /**
   * Callback fired before the component fades out
   */
  onExit: _react2['default'].PropTypes.func,
  /**
   * Callback fired after the component starts to fade out
   */
  onExiting: _react2['default'].PropTypes.func,
  /**
   * Callback fired after the component has faded out
   */
  onExited: _react2['default'].PropTypes.func
};

var defaultProps = {
  'in': false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  transitionAppear: false
};

var Fade = function (_React$Component) {
  (0, _inherits3['default'])(Fade, _React$Component);

  function Fade() {
    (0, _classCallCheck3['default'])(this, Fade);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  Fade.prototype.render = function render() {
    return _react2['default'].createElement(_Transition2['default'], (0, _extends3['default'])({}, this.props, {
      className: (0, _classnames2['default'])(this.props.className, 'fade'),
      enteredClassName: 'in',
      enteringClassName: 'in'
    }));
  };

  return Fade;
}(_react2['default'].Component);

Fade.propTypes = propTypes;
Fade.defaultProps = defaultProps;

exports['default'] = Fade;
module.exports = exports['default'];

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _elementType = __webpack_require__(18);

var _elementType2 = _interopRequireDefault(_elementType);

var _warning = __webpack_require__(36);

var _warning2 = _interopRequireDefault(_warning);

var _FormControlFeedback = __webpack_require__(1633);

var _FormControlFeedback2 = _interopRequireDefault(_FormControlFeedback);

var _FormControlStatic = __webpack_require__(1634);

var _FormControlStatic2 = _interopRequireDefault(_FormControlStatic);

var _bootstrapUtils = __webpack_require__(91);

var _StyleConfig = __webpack_require__(244);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = {
  componentClass: _elementType2['default'],
  /**
   * Only relevant if `componentClass` is `'input'`.
   */
  type: _react2['default'].PropTypes.string,
  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  id: _react2['default'].PropTypes.string,
  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <FormControl inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: _react2['default'].PropTypes.func
};

var defaultProps = {
  componentClass: 'input'
};

var contextTypes = {
  $bs_formGroup: _react2['default'].PropTypes.object
};

var FormControl = function (_React$Component) {
  (0, _inherits3['default'])(FormControl, _React$Component);

  function FormControl() {
    (0, _classCallCheck3['default'])(this, FormControl);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  FormControl.prototype.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;

    var _props = this.props,
        Component = _props.componentClass,
        type = _props.type,
        _props$id = _props.id,
        id = _props$id === undefined ? controlId : _props$id,
        inputRef = _props.inputRef,
        className = _props.className,
        bsSize = _props.bsSize,
        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'type', 'id', 'inputRef', 'className', 'bsSize']);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? (0, _warning2['default'])(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;

    // input[type="file"] should not have .form-control.
    var classes = void 0;
    if (type !== 'file') {
      classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    }

    // If user provides a size, make sure to append it to classes as input-
    // e.g. if bsSize is small, it will append input-sm
    if (bsSize) {
      var size = _StyleConfig.SIZE_MAP[bsSize] || bsSize;
      classes[(0, _bootstrapUtils.prefix)({ bsClass: 'input' }, size)] = true;
    }

    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
      type: type,
      id: id,
      ref: inputRef,
      className: (0, _classnames2['default'])(className, classes)
    }));
  };

  return FormControl;
}(_react2['default'].Component);

FormControl.propTypes = propTypes;
FormControl.defaultProps = defaultProps;
FormControl.contextTypes = contextTypes;

FormControl.Feedback = _FormControlFeedback2['default'];
FormControl.Static = _FormControlStatic2['default'];

exports['default'] = (0, _bootstrapUtils.bsClass)('form-control', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.SMALL, _StyleConfig.Size.LARGE], FormControl));
module.exports = exports['default'];

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Glyphicon = __webpack_require__(1635);

var _Glyphicon2 = _interopRequireDefault(_Glyphicon);

var _bootstrapUtils = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var defaultProps = {
  bsRole: 'feedback'
};

var contextTypes = {
  $bs_formGroup: _react2['default'].PropTypes.object
};

var FormControlFeedback = function (_React$Component) {
  (0, _inherits3['default'])(FormControlFeedback, _React$Component);

  function FormControlFeedback() {
    (0, _classCallCheck3['default'])(this, FormControlFeedback);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  FormControlFeedback.prototype.getGlyph = function getGlyph(validationState) {
    switch (validationState) {
      case 'success':
        return 'ok';
      case 'warning':
        return 'warning-sign';
      case 'error':
        return 'remove';
      default:
        return null;
    }
  };

  FormControlFeedback.prototype.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
    var glyph = this.getGlyph(formGroup && formGroup.validationState);
    if (!glyph) {
      return null;
    }

    return _react2['default'].createElement(_Glyphicon2['default'], (0, _extends3['default'])({}, elementProps, {
      glyph: glyph,
      className: (0, _classnames2['default'])(className, classes)
    }));
  };

  FormControlFeedback.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);

    if (!children) {
      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
    }

    var child = _react2['default'].Children.only(children);
    return _react2['default'].cloneElement(child, (0, _extends3['default'])({}, elementProps, {
      className: (0, _classnames2['default'])(child.props.className, className, classes)
    }));
  };

  return FormControlFeedback;
}(_react2['default'].Component);

FormControlFeedback.defaultProps = defaultProps;
FormControlFeedback.contextTypes = contextTypes;

exports['default'] = (0, _bootstrapUtils.bsClass)('form-control-feedback', FormControlFeedback);
module.exports = exports['default'];

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _elementType = __webpack_require__(18);

var _elementType2 = _interopRequireDefault(_elementType);

var _bootstrapUtils = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = {
  componentClass: _elementType2['default']
};

var defaultProps = {
  componentClass: 'p'
};

var FormControlStatic = function (_React$Component) {
  (0, _inherits3['default'])(FormControlStatic, _React$Component);

  function FormControlStatic() {
    (0, _classCallCheck3['default'])(this, FormControlStatic);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  FormControlStatic.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);

    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
      className: (0, _classnames2['default'])(className, classes)
    }));
  };

  return FormControlStatic;
}(_react2['default'].Component);

FormControlStatic.propTypes = propTypes;
FormControlStatic.defaultProps = defaultProps;

exports['default'] = (0, _bootstrapUtils.bsClass)('form-control-static', FormControlStatic);
module.exports = exports['default'];

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends3 = __webpack_require__(7);

var _extends4 = _interopRequireDefault(_extends3);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _bootstrapUtils = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = {
  /**
   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
   */
  glyph: _react2['default'].PropTypes.string.isRequired
};

var Glyphicon = function (_React$Component) {
  (0, _inherits3['default'])(Glyphicon, _React$Component);

  function Glyphicon() {
    (0, _classCallCheck3['default'])(this, Glyphicon);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  Glyphicon.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        glyph = _props.glyph,
        className = _props.className,
        props = (0, _objectWithoutProperties3['default'])(_props, ['glyph', 'className']);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, glyph)] = true, _extends2));

    return _react2['default'].createElement('span', (0, _extends4['default'])({}, elementProps, {
      className: (0, _classnames2['default'])(className, classes)
    }));
  };

  return Glyphicon;
}(_react2['default'].Component);

Glyphicon.propTypes = propTypes;

exports['default'] = (0, _bootstrapUtils.bsClass)('glyphicon', Glyphicon);
module.exports = exports['default'];

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _InputGroupAddon = __webpack_require__(1637);

var _InputGroupAddon2 = _interopRequireDefault(_InputGroupAddon);

var _InputGroupButton = __webpack_require__(1638);

var _InputGroupButton2 = _interopRequireDefault(_InputGroupButton);

var _bootstrapUtils = __webpack_require__(91);

var _StyleConfig = __webpack_require__(244);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var InputGroup = function (_React$Component) {
  (0, _inherits3['default'])(InputGroup, _React$Component);

  function InputGroup() {
    (0, _classCallCheck3['default'])(this, InputGroup);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  InputGroup.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);

    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
      className: (0, _classnames2['default'])(className, classes)
    }));
  };

  return InputGroup;
}(_react2['default'].Component);

InputGroup.Addon = _InputGroupAddon2['default'];
InputGroup.Button = _InputGroupButton2['default'];

exports['default'] = (0, _bootstrapUtils.bsClass)('input-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], InputGroup));
module.exports = exports['default'];

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _bootstrapUtils = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var InputGroupAddon = function (_React$Component) {
  (0, _inherits3['default'])(InputGroupAddon, _React$Component);

  function InputGroupAddon() {
    (0, _classCallCheck3['default'])(this, InputGroupAddon);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  InputGroupAddon.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);

    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
      className: (0, _classnames2['default'])(className, classes)
    }));
  };

  return InputGroupAddon;
}(_react2['default'].Component);

exports['default'] = (0, _bootstrapUtils.bsClass)('input-group-addon', InputGroupAddon);
module.exports = exports['default'];

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _bootstrapUtils = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var InputGroupButton = function (_React$Component) {
  (0, _inherits3['default'])(InputGroupButton, _React$Component);

  function InputGroupButton() {
    (0, _classCallCheck3['default'])(this, InputGroupButton);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  InputGroupButton.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);

    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
      className: (0, _classnames2['default'])(className, classes)
    }));
  };

  return InputGroupButton;
}(_react2['default'].Component);

exports['default'] = (0, _bootstrapUtils.bsClass)('input-group-btn', InputGroupButton);
module.exports = exports['default'];

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Overlay = __webpack_require__(610);

var _Overlay2 = _interopRequireDefault(_Overlay);

var _elementType = __webpack_require__(18);

var _elementType2 = _interopRequireDefault(_elementType);

var _Fade = __webpack_require__(1631);

var _Fade2 = _interopRequireDefault(_Fade);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: _react2['default'].PropTypes.bool,
  /**
   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
   */
  rootClose: _react2['default'].PropTypes.bool,
  /**
   * A callback invoked by the overlay when it wishes to be hidden. Required if
   * `rootClose` is specified.
   */
  onHide: _react2['default'].PropTypes.func,

  /**
   * Use animation
   */
  animation: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _elementType2['default']]),

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: _react2['default'].PropTypes.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: _react2['default'].PropTypes.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: _react2['default'].PropTypes.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: _react2['default'].PropTypes.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: _react2['default'].PropTypes.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: _react2['default'].PropTypes.func,

  /**
   * Sets the direction of the Overlay.
   */
  placement: _react2['default'].PropTypes.oneOf(['top', 'right', 'bottom', 'left'])
});

var defaultProps = {
  animation: _Fade2['default'],
  rootClose: false,
  show: false,
  placement: 'right'
};

var Overlay = function (_React$Component) {
  (0, _inherits3['default'])(Overlay, _React$Component);

  function Overlay() {
    (0, _classCallCheck3['default'])(this, Overlay);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  Overlay.prototype.render = function render() {
    var _props = this.props,
        animation = _props.animation,
        children = _props.children,
        props = (0, _objectWithoutProperties3['default'])(_props, ['animation', 'children']);


    var transition = animation === true ? _Fade2['default'] : animation || null;

    var child = void 0;

    if (!transition) {
      child = (0, _react.cloneElement)(children, {
        className: (0, _classnames2['default'])(children.props.className, 'in')
      });
    } else {
      child = children;
    }

    return _react2['default'].createElement(
      _Overlay2['default'],
      (0, _extends3['default'])({}, props, {
        transition: transition
      }),
      child
    );
  };

  return Overlay;
}(_react2['default'].Component);

Overlay.propTypes = propTypes;
Overlay.defaultProps = defaultProps;

exports['default'] = Overlay;
module.exports = exports['default'];

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends3 = __webpack_require__(7);

var _extends4 = _interopRequireDefault(_extends3);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _isRequiredForA11y = __webpack_require__(188);

var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

var _bootstrapUtils = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string}
   * @required
   */
  id: (0, _isRequiredForA11y2['default'])(_react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])),

  /**
   * Sets the direction the Popover is positioned towards.
   */
  placement: _react2['default'].PropTypes.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Popover.
   */
  positionTop: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
  /**
   * The "left" position value for the Popover.
   */
  positionLeft: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),

  /**
   * The "top" position value for the Popover arrow.
   */
  arrowOffsetTop: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
  /**
   * The "left" position value for the Popover arrow.
   */
  arrowOffsetLeft: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),

  /**
   * Title content
   */
  title: _react2['default'].PropTypes.node
};

var defaultProps = {
  placement: 'right'
};

var Popover = function (_React$Component) {
  (0, _inherits3['default'])(Popover, _React$Component);

  function Popover() {
    (0, _classCallCheck3['default'])(this, Popover);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  Popover.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        placement = _props.placement,
        positionTop = _props.positionTop,
        positionLeft = _props.positionLeft,
        arrowOffsetTop = _props.arrowOffsetTop,
        arrowOffsetLeft = _props.arrowOffsetLeft,
        title = _props.title,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = (0, _objectWithoutProperties3['default'])(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'title', 'className', 'style', 'children']);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = (0, _extends4['default'])({
      display: 'block',
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };

    return _react2['default'].createElement(
      'div',
      (0, _extends4['default'])({}, elementProps, {
        role: 'tooltip',
        className: (0, _classnames2['default'])(className, classes),
        style: outerStyle
      }),
      _react2['default'].createElement('div', { className: 'arrow', style: arrowStyle }),
      title && _react2['default'].createElement(
        'h3',
        { className: (0, _bootstrapUtils.prefix)(bsProps, 'title') },
        title
      ),
      _react2['default'].createElement(
        'div',
        { className: (0, _bootstrapUtils.prefix)(bsProps, 'content') },
        children
      )
    );
  };

  return Popover;
}(_react2['default'].Component);

Popover.propTypes = propTypes;
Popover.defaultProps = defaultProps;

exports['default'] = (0, _bootstrapUtils.bsClass)('popover', Popover);
module.exports = exports['default'];

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(8);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _elementType = __webpack_require__(18);

var _elementType2 = _interopRequireDefault(_elementType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = {
  href: _react2['default'].PropTypes.string,
  onClick: _react2['default'].PropTypes.func,
  disabled: _react2['default'].PropTypes.bool,
  role: _react2['default'].PropTypes.string,
  tabIndex: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
  /**
   * this is sort of silly but needed for Button
   */
  componentClass: _elementType2['default']
};

var defaultProps = {
  componentClass: 'a'
};

function isTrivialHref(href) {
  return !href || href.trim() === '#';
}

/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
 */

var SafeAnchor = function (_React$Component) {
  (0, _inherits3['default'])(SafeAnchor, _React$Component);

  function SafeAnchor(props, context) {
    (0, _classCallCheck3['default'])(this, SafeAnchor);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  SafeAnchor.prototype.handleClick = function handleClick(event) {
    var _props = this.props,
        disabled = _props.disabled,
        href = _props.href,
        onClick = _props.onClick;


    if (disabled || isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  SafeAnchor.prototype.render = function render() {
    var _props2 = this.props,
        Component = _props2.componentClass,
        disabled = _props2.disabled,
        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'disabled']);


    if (isTrivialHref(props.href)) {
      props.role = props.role || 'button';
      // we want to make sure there is a href attribute on the node
      // otherwise, the cursor incorrectly styled (except with role='button')
      props.href = props.href || '#';
    }

    if (disabled) {
      props.tabIndex = -1;
      props.style = (0, _extends3['default'])({ pointerEvents: 'none' }, props.style);
    }

    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
      onClick: this.handleClick
    }));
  };

  return SafeAnchor;
}(_react2['default'].Component);

SafeAnchor.propTypes = propTypes;
SafeAnchor.defaultProps = defaultProps;

exports['default'] = SafeAnchor;
module.exports = exports['default'];

/***/ }),
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(681);


/***/ })
],[1866]);


// WEBPACK FOOTER //
// app.bundle.36a1400c22561db60b36.js